import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A country code as defined by ISO 3166-1 alpha-2 */
  CountryCode: { input: string; output: string; }
  CronExpression: { input: any; output: any; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: string; output: string; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: Date | string; output: Date | string; }
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** A field whose value exists in the standard IANA Time Zone Database: https://www.iana.org/time-zones */
  TimeZone: { input: string; output: string; }
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: { input: string; output: string; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: File; output: File; }
};

/** Information about this GraphQL API */
export type AboutModel = {
  __typename: 'AboutModel';
  author: Scalars['String']['output'];
  contact: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export enum AccessDirection {
  /** Entering the gym */
  Entry = 'ENTRY',
  /** Leaving the gym */
  Exit = 'EXIT'
}

export enum AccessEventFailureReason {
  /** Provider API or publish call failed */
  ProviderApiError = 'PROVIDER_API_ERROR',
  /** Unknown or unexpected error */
  Unknown = 'UNKNOWN'
}

export enum AccessEventStatus {
  /** Access was confirmed by the customer without dispatching a device command. Counts as a successful access. */
  Confirmed = 'CONFIRMED',
  /** Dispatch was successfully accepted by the provider */
  Dispatched = 'DISPATCHED',
  /** Dispatch failed */
  Failed = 'FAILED',
  /** Dispatch attempt started, provider call in progress */
  InFlight = 'IN_FLIGHT'
}

/** Available door opening event triggers */
export enum AccessEventTrigger {
  /** Requires to enter a code */
  AccessCode = 'ACCESS_CODE',
  /** Automatically after the request. No further user interaction is required. */
  Automatic = 'AUTOMATIC',
  /** No device involved. The customer confirmed being inside the gym already (e.g. let in by staff because the entry device was offline). */
  CustomerConfirmation = 'CUSTOMER_CONFIRMATION',
  /** Requires to scan a QR Code */
  QrCode = 'QR_CODE'
}

export enum AccessProvider {
  /** Be-in access provider */
  BeIn = 'BE_IN',
  /** Evo access provider */
  Evo = 'EVO',
  /** GymApp based access devices */
  GymApp = 'GYM_APP'
}

export enum AcsMigrationStatus {
  /** Migration zu ACS angestoßen (ROTATE_CERTS dispatched); Öffnen liefert DEVICE_UNDER_MIGRATION */
  Initiated = 'INITIATED',
  /** Gerät ist auf ACS migriert — Öffnen und Lesen laufen über ACS */
  Migrated = 'MIGRATED',
  /** Gerät wird (noch) über TrainToGo bedient — Default */
  None = 'NONE'
}

export type Activity = {
  __typename: 'Activity';
  actorProfile?: Maybe<Profile>;
  circle?: Maybe<Circle>;
  communityEventInstance?: Maybe<CommunityEventInstance>;
  communityPostComment?: Maybe<CommunityPostComment>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  isCircleMention: Scalars['Boolean']['output'];
  message?: Maybe<Message>;
  /**
   * Read/unread for the recipient. NULL means unread; always NULL for EVENT_BOOKED (no
   * recipient, so no read state).
   */
  readAt?: Maybe<Scalars['DateTime']['output']>;
  recipientProfile?: Maybe<Profile>;
  type: ActivityType;
  userPost?: Maybe<UserPost>;
  workout?: Maybe<Workout>;
};

export type ActivityCountAggregate = {
  __typename: 'ActivityCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  readAt: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
};

export type ActivityCreateNestedManyWithoutUserPostInput = {
  connect?: InputMaybe<Array<ActivityWhereUniqueInput>>;
};

export type ActivityCreateNestedManyWithoutWorkoutInput = {
  connect?: InputMaybe<Array<ActivityWhereUniqueInput>>;
};

export type ActivityEdge = {
  __typename: 'ActivityEdge';
  cursor: PaginatedActivityCursor;
  node: Activity;
};

export type ActivityListRelationFilter = {
  every?: InputMaybe<ActivityWhereInput>;
  none?: InputMaybe<ActivityWhereInput>;
  some?: InputMaybe<ActivityWhereInput>;
};

export type ActivityMaxAggregate = {
  __typename: 'ActivityMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  readAt?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<ActivityType>;
};

export type ActivityMinAggregate = {
  __typename: 'ActivityMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  readAt?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<ActivityType>;
};

export type ActivityOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ActivityOrderByWithRelationInput = {
  actorProfile?: InputMaybe<ProfileOrderByWithRelationInput>;
  actorProfileId?: InputMaybe<SortOrderInput>;
  circle?: InputMaybe<CircleOrderByWithRelationInput>;
  circleId?: InputMaybe<SortOrderInput>;
  communityEventInstance?: InputMaybe<CommunityEventInstanceOrderByWithRelationInput>;
  communityEventInstanceId?: InputMaybe<SortOrderInput>;
  communityPostComment?: InputMaybe<CommunityPostCommentOrderByWithRelationInput>;
  communityPostCommentId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<MessageOrderByWithRelationInput>;
  messageId?: InputMaybe<SortOrderInput>;
  readAt?: InputMaybe<SortOrderInput>;
  recipientProfile?: InputMaybe<ProfileOrderByWithRelationInput>;
  recipientProfileId?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
  userPost?: InputMaybe<UserPostOrderByWithRelationInput>;
  userPostId?: InputMaybe<SortOrderInput>;
  workout?: InputMaybe<WorkoutOrderByWithRelationInput>;
  workoutId?: InputMaybe<SortOrderInput>;
};

export enum ActivityScalarFieldEnum {
  ActorProfileId = 'actorProfileId',
  CircleId = 'circleId',
  CommunityEventInstanceId = 'communityEventInstanceId',
  CommunityPostCommentId = 'communityPostCommentId',
  CreatedAt = 'createdAt',
  Id = 'id',
  MessageId = 'messageId',
  ReadAt = 'readAt',
  RecipientProfileId = 'recipientProfileId',
  Type = 'type',
  UserPostId = 'userPostId',
  WorkoutId = 'workoutId'
}

/** README_COMMUNITY_CLUB_V2.md, Phase 7 ("Aktivitäten & zentrale Push-Steuerung"). */
export enum ActivityType {
  Commented = 'COMMENTED',
  /** Written by CommunityPostCommentLikeService.toggleCommentLike (Phase 8), Profile-path only. */
  CommentLiked = 'COMMENT_LIKED',
  /**
   * Feed-type activity (visible to the actor's followers via the persönlicher Feed's follow-
   * join), the only type with no recipientProfileId. Not wired to a write path yet.
   */
  EventBooked = 'EVENT_BOOKED',
  Followed = 'FOLLOWED',
  FollowRequested = 'FOLLOW_REQUESTED',
  FollowRequestAccepted = 'FOLLOW_REQUEST_ACCEPTED',
  /**
   * Written when a UserPost/CommunityPostComment/Circle mentions another Profile (structured
   * mentionedProfileIds input, no free-text parsing). If a comment mentions the post's own
   * author, no MENTIONED activity is recorded for them -- the COMMENTED activity already covers
   * that recipient, avoiding a duplicate notification for one action.
   */
  Mentioned = 'MENTIONED',
  MessageReceived = 'MESSAGE_RECEIVED',
  PostLiked = 'POST_LIKED',
  /**
   * Written by WorkoutService.tagParticipant when a Workout's author tags another Profile as
   * having participated together.
   */
  WorkoutTagged = 'WORKOUT_TAGGED'
}

export type ActivityUpdateManyWithoutCommunityEventInstanceNestedInput = {
  connect?: InputMaybe<Array<ActivityWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<ActivityWhereUniqueInput>>;
};

export type ActivityUpdateManyWithoutUserPostNestedInput = {
  connect?: InputMaybe<Array<ActivityWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<ActivityWhereUniqueInput>>;
};

export type ActivityUpdateManyWithoutWorkoutNestedInput = {
  connect?: InputMaybe<Array<ActivityWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<ActivityWhereUniqueInput>>;
};

export type ActivityWhereInput = {
  AND?: InputMaybe<Array<ActivityWhereInput>>;
  NOT?: InputMaybe<Array<ActivityWhereInput>>;
  OR?: InputMaybe<Array<ActivityWhereInput>>;
  actorProfile?: InputMaybe<ProfileNullableScalarRelationFilter>;
  actorProfileId?: InputMaybe<UuidNullableFilter>;
  circle?: InputMaybe<CircleNullableScalarRelationFilter>;
  circleId?: InputMaybe<UuidNullableFilter>;
  communityEventInstance?: InputMaybe<CommunityEventInstanceNullableScalarRelationFilter>;
  communityEventInstanceId?: InputMaybe<UuidNullableFilter>;
  communityPostComment?: InputMaybe<CommunityPostCommentNullableScalarRelationFilter>;
  communityPostCommentId?: InputMaybe<UuidNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  message?: InputMaybe<MessageNullableScalarRelationFilter>;
  messageId?: InputMaybe<UuidNullableFilter>;
  readAt?: InputMaybe<DateTimeNullableFilter>;
  recipientProfile?: InputMaybe<ProfileNullableScalarRelationFilter>;
  recipientProfileId?: InputMaybe<UuidNullableFilter>;
  type?: InputMaybe<EnumActivityTypeFilter>;
  userPost?: InputMaybe<UserPostNullableScalarRelationFilter>;
  userPostId?: InputMaybe<UuidNullableFilter>;
  workout?: InputMaybe<WorkoutNullableScalarRelationFilter>;
  workoutId?: InputMaybe<UuidNullableFilter>;
};

export type ActivityWhereUniqueInput = {
  AND?: InputMaybe<Array<ActivityWhereInput>>;
  NOT?: InputMaybe<Array<ActivityWhereInput>>;
  OR?: InputMaybe<Array<ActivityWhereInput>>;
  actorProfile?: InputMaybe<ProfileNullableScalarRelationFilter>;
  actorProfileId?: InputMaybe<UuidNullableFilter>;
  circle?: InputMaybe<CircleNullableScalarRelationFilter>;
  circleId?: InputMaybe<UuidNullableFilter>;
  communityEventInstance?: InputMaybe<CommunityEventInstanceNullableScalarRelationFilter>;
  communityEventInstanceId?: InputMaybe<UuidNullableFilter>;
  communityPostComment?: InputMaybe<CommunityPostCommentNullableScalarRelationFilter>;
  communityPostCommentId?: InputMaybe<UuidNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  message?: InputMaybe<MessageNullableScalarRelationFilter>;
  messageId?: InputMaybe<UuidNullableFilter>;
  readAt?: InputMaybe<DateTimeNullableFilter>;
  recipientProfile?: InputMaybe<ProfileNullableScalarRelationFilter>;
  recipientProfileId?: InputMaybe<UuidNullableFilter>;
  type?: InputMaybe<EnumActivityTypeFilter>;
  userPost?: InputMaybe<UserPostNullableScalarRelationFilter>;
  userPostId?: InputMaybe<UuidNullableFilter>;
  workout?: InputMaybe<WorkoutNullableScalarRelationFilter>;
  workoutId?: InputMaybe<UuidNullableFilter>;
};

export type AggregateCustomerBilling = {
  __typename: 'AggregateCustomerBilling';
  _avg?: Maybe<CustomerBillingAvgAggregate>;
  _count?: Maybe<CustomerBillingCountAggregate>;
  _max?: Maybe<CustomerBillingMaxAggregate>;
  _min?: Maybe<CustomerBillingMinAggregate>;
  _sum?: Maybe<CustomerBillingSumAggregate>;
};

export type AggregateTrainingSession = {
  __typename: 'AggregateTrainingSession';
  _avg?: Maybe<TrainingSessionAvgAggregate>;
  _count?: Maybe<TrainingSessionCountAggregate>;
  _max?: Maybe<TrainingSessionMaxAggregate>;
  _min?: Maybe<TrainingSessionMinAggregate>;
  _sum?: Maybe<TrainingSessionSumAggregate>;
};

/** A customer answer to one registration question */
export type AnswerRegistrationQuestionInput = {
  /** The selected option id(s). Exactly one for SINGLE_SELECT questions, one or more for MULTI_SELECT questions. */
  optionIds: Array<Scalars['UUID']['input']>;
  /** The registration question being answered */
  questionId: Scalars['UUID']['input'];
};

export type ArchivedCustomerBilling = {
  __typename: 'ArchivedCustomerBilling';
  /** The date and time when the billing record was archived. */
  archivedAt: Scalars['DateTime']['output'];
  /** The training session associated with the billing. */
  archivedTrainingSession: ArchivedTrainingSession;
  /** The date and time when the billing record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The date of the invoice. */
  dateOfInvoice: Scalars['DateTime']['output'];
  /** Any error message related to the billing process. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the billing record. */
  id: Scalars['Int']['output'];
  /** The invoice number for this billing. */
  invoiceNumber: Scalars['String']['output'];
  /** Indicates whether the bill has been paid. */
  isPaid: Scalars['Boolean']['output'];
  /** The key for accessing the PDF version of the invoice. */
  pdfKey?: Maybe<Scalars['String']['output']>;
  /** The status of the billing (e.g., OPEN, SENT, etc.). */
  status: BillingStatus;
  /** The price of the training session included in the invoice. */
  trainingPrice: Scalars['Float']['output'];
  /** The date and time when the billing record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type ArchivedCustomerBillingAvgAggregate = {
  __typename: 'ArchivedCustomerBillingAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  trainingPrice?: Maybe<Scalars['Float']['output']>;
};

export type ArchivedCustomerBillingCountAggregate = {
  __typename: 'ArchivedCustomerBillingCountAggregate';
  _all: Scalars['Int']['output'];
  archivedAt: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  dateOfInvoice: Scalars['Int']['output'];
  errorMessage: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  invoiceNumber: Scalars['Int']['output'];
  isPaid: Scalars['Int']['output'];
  pdfKey: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  trainingPrice: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ArchivedCustomerBillingMaxAggregate = {
  __typename: 'ArchivedCustomerBillingMaxAggregate';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateOfInvoice?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  isPaid?: Maybe<Scalars['Boolean']['output']>;
  pdfKey?: Maybe<Scalars['String']['output']>;
  status?: Maybe<BillingStatus>;
  trainingPrice?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ArchivedCustomerBillingMinAggregate = {
  __typename: 'ArchivedCustomerBillingMinAggregate';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateOfInvoice?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  isPaid?: Maybe<Scalars['Boolean']['output']>;
  pdfKey?: Maybe<Scalars['String']['output']>;
  status?: Maybe<BillingStatus>;
  trainingPrice?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ArchivedCustomerBillingSumAggregate = {
  __typename: 'ArchivedCustomerBillingSumAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  trainingPrice?: Maybe<Scalars['Float']['output']>;
};

export type ArchivedTrainingSession = {
  __typename: 'ArchivedTrainingSession';
  /** The date and time when the training session record was archived. */
  archivedAt: Scalars['DateTime']['output'];
  archivedCustomerBilling?: Maybe<ArchivedCustomerBilling>;
  /** Indicates whether a checkout reminder has been sent. */
  checkoutReminderSend: Scalars['Boolean']['output'];
  /** The date and time when the training session record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The end time of the training session. */
  endTime: Scalars['DateTime']['output'];
  /** An optional field to describe why the training was finished manually */
  finishReason?: Maybe<TrainingFinishReason>;
  /** The way the training was finished */
  finishType: TrainingFinishType;
  /** The unique identifier for the training session. */
  id: Scalars['UUID']['output'];
  /** The ID of the price at which the training was completed */
  priceId: Scalars['String']['output'];
  /** The start time of the training session. */
  startTime: Scalars['DateTime']['output'];
  /** The date and time when the training session record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type ArchivedTrainingSessionCountAggregate = {
  __typename: 'ArchivedTrainingSessionCountAggregate';
  _all: Scalars['Int']['output'];
  archivedAt: Scalars['Int']['output'];
  checkoutReminderSend: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  endTime: Scalars['Int']['output'];
  finishReason: Scalars['Int']['output'];
  finishType: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  priceId: Scalars['Int']['output'];
  startTime: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ArchivedTrainingSessionMaxAggregate = {
  __typename: 'ArchivedTrainingSessionMaxAggregate';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  checkoutReminderSend?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  finishReason?: Maybe<TrainingFinishReason>;
  finishType?: Maybe<TrainingFinishType>;
  id?: Maybe<Scalars['UUID']['output']>;
  priceId?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ArchivedTrainingSessionMinAggregate = {
  __typename: 'ArchivedTrainingSessionMinAggregate';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  checkoutReminderSend?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  finishReason?: Maybe<TrainingFinishReason>;
  finishType?: Maybe<TrainingFinishType>;
  id?: Maybe<Scalars['UUID']['output']>;
  priceId?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum BillingStatus {
  /** The billing is cancelled */
  Canceled = 'CANCELED',
  /** The invoice went to the debt collection agency */
  DebtCollection = 'DEBT_COLLECTION',
  /** A payment dispute has been created */
  Dispute = 'DISPUTE',
  /** There was an error processing the billing. */
  Error = 'ERROR',
  /** The billing is open and pending. */
  Open = 'OPEN',
  /** The billing is in retry status due to an issue. */
  Retry = 'RETRY',
  /** The billing is under review. */
  Review = 'REVIEW',
  /** The first reminder has been sent. */
  SendFirstReminder = 'SEND_FIRST_REMINDER',
  /** A payment reminder has been sent. */
  SendPaymentReminder = 'SEND_PAYMENT_REMINDER',
  /** The second reminder has been sent. */
  SendSecondReminder = 'SEND_SECOND_REMINDER',
  /** The billing has been sent to the customer. */
  Sent = 'SENT'
}

/** Input for contract proposal object */
export type BirdContractProposalInput = {
  /** The url params */
  parameter: Scalars['String']['input'];
};

/** Possible event types for message bird */
export enum BirdEventTypes {
  EventBooking = 'EVENT_BOOKING',
  FirstReminder = 'FIRST_REMINDER',
  OngoingTraining = 'ONGOING_TRAINING',
  PaymentReminder = 'PAYMENT_REMINDER',
  Register = 'REGISTER',
  SecondReminder = 'SECOND_REMINDER',
  SendSurvey = 'SEND_SURVEY',
  TrainingAutomaticallyClosed = 'TRAINING_AUTOMATICALLY_CLOSED',
  TrainingFinished = 'TRAINING_FINISHED',
  TrainingStart = 'TRAINING_START',
  U18 = 'U18'
}

export type BirdInputModel = {
  /** The contract proposal parameters */
  contractProposal?: InputMaybe<BirdContractProposalInput>;
  email: Scalars['String']['input'];
  eventName: BirdEventTypes;
  firstName: Scalars['String']['input'];
  /** The invoice parameters */
  invoice?: InputMaybe<BirdInvoiceInput>;
  language: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  mobileNumber: Scalars['String']['input'];
  /** The survey parameters */
  survey?: InputMaybe<BirdSurveyInput>;
};

/** Input for invoice object */
export type BirdInvoiceInput = {
  /** The url params */
  parameter: Scalars['String']['input'];
  /** The URL of the invoice */
  url: Scalars['String']['input'];
};

/** Represents the model of Bird Messager Status */
export type BirdStatusModel = {
  __typename: 'BirdStatusModel';
  status: Scalars['String']['output'];
};

/** Input for survey object */
export type BirdSurveyInput = {
  /** The url params */
  parameter: Scalars['String']['input'];
};

export type Block = {
  __typename: 'Block';
  blockedProfile: Profile;
  blockerProfile: Profile;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
};

export type BlockBlockerProfileIdBlockedProfileIdCompoundUniqueInput = {
  blockedProfileId: Scalars['String']['input'];
  blockerProfileId: Scalars['String']['input'];
};

export type BlockCountAggregate = {
  __typename: 'BlockCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export type BlockListRelationFilter = {
  every?: InputMaybe<BlockWhereInput>;
  none?: InputMaybe<BlockWhereInput>;
  some?: InputMaybe<BlockWhereInput>;
};

export type BlockMaxAggregate = {
  __typename: 'BlockMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
};

export type BlockMinAggregate = {
  __typename: 'BlockMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
};

export type BlockOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BlockOrderByWithRelationInput = {
  blockedProfile?: InputMaybe<ProfileOrderByWithRelationInput>;
  blockedProfileId?: InputMaybe<SortOrder>;
  blockerProfile?: InputMaybe<ProfileOrderByWithRelationInput>;
  blockerProfileId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export enum BlockScalarFieldEnum {
  BlockedProfileId = 'blockedProfileId',
  BlockerProfileId = 'blockerProfileId',
  CreatedAt = 'createdAt',
  Id = 'id'
}

export type BlockWhereInput = {
  AND?: InputMaybe<Array<BlockWhereInput>>;
  NOT?: InputMaybe<Array<BlockWhereInput>>;
  OR?: InputMaybe<Array<BlockWhereInput>>;
  blockedProfile?: InputMaybe<ProfileScalarRelationFilter>;
  blockedProfileId?: InputMaybe<UuidFilter>;
  blockerProfile?: InputMaybe<ProfileScalarRelationFilter>;
  blockerProfileId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
};

export type BlockWhereUniqueInput = {
  AND?: InputMaybe<Array<BlockWhereInput>>;
  NOT?: InputMaybe<Array<BlockWhereInput>>;
  OR?: InputMaybe<Array<BlockWhereInput>>;
  blockedProfile?: InputMaybe<ProfileScalarRelationFilter>;
  blockedProfileId?: InputMaybe<UuidFilter>;
  blockerProfile?: InputMaybe<ProfileScalarRelationFilter>;
  blockerProfileId?: InputMaybe<UuidFilter>;
  blockerProfileId_blockedProfileId?: InputMaybe<BlockBlockerProfileIdBlockedProfileIdCompoundUniqueInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input for a customer's ticket booking attempt; the buyer is always the acting customer. */
export type BookCommunityEventTicketInput = {
  /** The tier the app displayed; only drives the priceTierChanged hint. */
  expectedPriceTierId?: InputMaybe<Scalars['UUID']['input']>;
  /** The paid instance to book. */
  instanceId: Scalars['UUID']['input'];
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

/** Input for the acting customer cancelling their ticket after its event was rescheduled. */
export type CancelCommunityEventTicketAfterRescheduleInput = {
  /** The acting customer's ticket, obtained before the reschedule. */
  ticketId: Scalars['UUID']['input'];
};

/** Input for giving up the acting customer's queue entry or held reservation of an instance. */
export type CancelCommunityEventTicketBookingInput = {
  /** The paid instance. */
  instanceId: Scalars['UUID']['input'];
};

export enum CancelationStrategy {
  ReceiptDate = 'RECEIPT_DATE',
  Term = 'TERM'
}

/** Input for changing deleted state of a customer */
export type ChangeCustomerStateInput = {
  /** The new state for the customer */
  state: CustomerStateEnum;
};

export type CheckInUtilizationModel = {
  __typename: 'CheckInUtilizationModel';
  data: Array<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
};

export type Circle = {
  __typename: 'Circle';
  _count: CircleCount;
  authorProfile: Profile;
  /**
   * Letterbox/pillarbox fill color (hex, e.g. "#FF00AA") shown behind the media when it doesn't
   * fill the full circle canvas.
   */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Only set for mediaType=VIDEO. */
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  key: Scalars['String']['output'];
  /** Whether the current actor likes this circle. */
  likedByMe: Scalars['Boolean']['output'];
  /**
   * Employee/Business-Owner authors only -- CircleService.createCircle rejects this for a
   * Customer author (Decision, 2026-08-28).
   */
  link?: Maybe<Scalars['String']['output']>;
  mediaType: MediaType;
  /** Profiles mentioned in this Circle's caption text. */
  mentionedProfiles: Array<Profile>;
  seenByMe?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  /** Paginated list of Profiles that viewed this circle, each carrying whether they also liked it. Author-only -- see a foreign circle's own like status via likedByMe instead. */
  viewedBy: PaginatedCircleViewer;
};


export type CircleViewedByArgs = {
  cursor?: InputMaybe<CircleViewWhereUniqueInput>;
  distinct?: InputMaybe<Array<CircleViewScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CircleViewOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CircleViewWhereInput>;
};

export type CircleAvgAggregate = {
  __typename: 'CircleAvgAggregate';
  durationSeconds?: Maybe<Scalars['Float']['output']>;
};

export type CircleCount = {
  __typename: 'CircleCount';
  circleLikes: Scalars['Int']['output'];
  circleViews: Scalars['Int']['output'];
};

export type CircleCountAggregate = {
  __typename: 'CircleCountAggregate';
  _all: Scalars['Int']['output'];
  backgroundColor: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  durationSeconds: Scalars['Int']['output'];
  expiresAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  key: Scalars['Int']['output'];
  link: Scalars['Int']['output'];
  mediaType: Scalars['Int']['output'];
  text: Scalars['Int']['output'];
  thumbnailUrl: Scalars['Int']['output'];
  url: Scalars['Int']['output'];
};

/** Input for creating a Circle. Author/authorIsPrivate/key/url/thumbnailUrl/expiresAt are derived server-side, never from client input. */
export type CircleCreateInput = {
  /** Whether to post as the company/brand profile instead of the personal one. Only a business owner may set this (see Decision #5, UserPost). */
  asBrand?: InputMaybe<Scalars['Boolean']['input']>;
  /** Letterbox/pillarbox fill color (hex, e.g. "#FF00AA") shown behind the media when it doesn't fill the full circle canvas. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Only relevant for mediaType=VIDEO. */
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** The image/video file itself. */
  image: ImageInput;
  /** A link shown on the circle. Only an Employee (Host) or Business Owner author may set this -- rejected for a Customer author. */
  link?: InputMaybe<Scalars['String']['input']>;
  mediaType: MediaType;
  /** Profiles mentioned in this Circle's caption text. Notified via a MENTIONED activity/push, up to 3 ids. */
  mentionedProfileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Caption text. */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Only relevant for mediaType=VIDEO. */
  thumbnailImage?: InputMaybe<ImageInput>;
};

export type CircleListRelationFilter = {
  every?: InputMaybe<CircleWhereInput>;
  none?: InputMaybe<CircleWhereInput>;
  some?: InputMaybe<CircleWhereInput>;
};

export type CircleMaxAggregate = {
  __typename: 'CircleMaxAggregate';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<MediaType>;
  text?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CircleMinAggregate = {
  __typename: 'CircleMinAggregate';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<MediaType>;
  text?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CircleNullableScalarRelationFilter = {
  is?: InputMaybe<CircleWhereInput>;
  isNot?: InputMaybe<CircleWhereInput>;
};

export type CircleOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CircleOrderByWithRelationInput = {
  activities?: InputMaybe<ActivityOrderByRelationAggregateInput>;
  authorProfile?: InputMaybe<ProfileOrderByWithRelationInput>;
  authorProfileId?: InputMaybe<SortOrder>;
  backgroundColor?: InputMaybe<SortOrderInput>;
  circleViews?: InputMaybe<CircleViewOrderByRelationAggregateInput>;
  durationSeconds?: InputMaybe<SortOrderInput>;
  expiresAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  link?: InputMaybe<SortOrderInput>;
  mediaType?: InputMaybe<SortOrder>;
  sharedInMessages?: InputMaybe<MessageOrderByRelationAggregateInput>;
  text?: InputMaybe<SortOrderInput>;
  thumbnailUrl?: InputMaybe<SortOrderInput>;
  url?: InputMaybe<SortOrder>;
};

export enum CircleScalarFieldEnum {
  AuthorIsPrivate = 'authorIsPrivate',
  AuthorProfileId = 'authorProfileId',
  BackgroundColor = 'backgroundColor',
  CreatedAt = 'createdAt',
  DurationSeconds = 'durationSeconds',
  ExpiresAt = 'expiresAt',
  Id = 'id',
  Key = 'key',
  Link = 'link',
  MediaType = 'mediaType',
  Text = 'text',
  ThumbnailUrl = 'thumbnailUrl',
  Url = 'url'
}

export type CircleScalarRelationFilter = {
  is?: InputMaybe<CircleWhereInput>;
  isNot?: InputMaybe<CircleWhereInput>;
};

export type CircleSumAggregate = {
  __typename: 'CircleSumAggregate';
  durationSeconds?: Maybe<Scalars['Int']['output']>;
};

/** One author's active circles for the current actor's tray, oldest circle first. */
export type CircleTrayItem = {
  __typename: 'CircleTrayItem';
  circles: Array<Circle>;
  profile: Profile;
};

export type CircleViewCircleIdViewerProfileIdCompoundUniqueInput = {
  circleId: Scalars['String']['input'];
  viewerProfileId: Scalars['String']['input'];
};

export type CircleViewCountAggregate = {
  __typename: 'CircleViewCountAggregate';
  _all: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  likedAt: Scalars['Int']['output'];
  viewedAt: Scalars['Int']['output'];
};

export type CircleViewListRelationFilter = {
  every?: InputMaybe<CircleViewWhereInput>;
  none?: InputMaybe<CircleViewWhereInput>;
  some?: InputMaybe<CircleViewWhereInput>;
};

export type CircleViewMaxAggregate = {
  __typename: 'CircleViewMaxAggregate';
  id?: Maybe<Scalars['UUID']['output']>;
  likedAt?: Maybe<Scalars['DateTime']['output']>;
  viewedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CircleViewMinAggregate = {
  __typename: 'CircleViewMinAggregate';
  id?: Maybe<Scalars['UUID']['output']>;
  likedAt?: Maybe<Scalars['DateTime']['output']>;
  viewedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CircleViewOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CircleViewOrderByWithRelationInput = {
  circle?: InputMaybe<CircleOrderByWithRelationInput>;
  circleId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  viewerProfile?: InputMaybe<ProfileOrderByWithRelationInput>;
  viewerProfileId?: InputMaybe<SortOrder>;
};

export enum CircleViewScalarFieldEnum {
  CircleId = 'circleId',
  Id = 'id',
  LikedAt = 'likedAt',
  ViewedAt = 'viewedAt',
  ViewerProfileId = 'viewerProfileId'
}

export type CircleViewWhereInput = {
  AND?: InputMaybe<Array<CircleViewWhereInput>>;
  NOT?: InputMaybe<Array<CircleViewWhereInput>>;
  OR?: InputMaybe<Array<CircleViewWhereInput>>;
  circle?: InputMaybe<CircleScalarRelationFilter>;
  circleId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  viewerProfile?: InputMaybe<ProfileScalarRelationFilter>;
  viewerProfileId?: InputMaybe<UuidFilter>;
};

export type CircleViewWhereUniqueInput = {
  AND?: InputMaybe<Array<CircleViewWhereInput>>;
  NOT?: InputMaybe<Array<CircleViewWhereInput>>;
  OR?: InputMaybe<Array<CircleViewWhereInput>>;
  circle?: InputMaybe<CircleScalarRelationFilter>;
  circleId?: InputMaybe<UuidFilter>;
  circleId_viewerProfileId?: InputMaybe<CircleViewCircleIdViewerProfileIdCompoundUniqueInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  viewerProfile?: InputMaybe<ProfileScalarRelationFilter>;
  viewerProfileId?: InputMaybe<UuidFilter>;
};

export type CircleViewer = {
  __typename: 'CircleViewer';
  liked: Scalars['Boolean']['output'];
  profile: Profile;
};

export type CircleViewerEdge = {
  __typename: 'CircleViewerEdge';
  cursor: PaginatedCircleViewerCursor;
  node: CircleViewer;
};

export type CircleWhereInput = {
  AND?: InputMaybe<Array<CircleWhereInput>>;
  NOT?: InputMaybe<Array<CircleWhereInput>>;
  OR?: InputMaybe<Array<CircleWhereInput>>;
  activities?: InputMaybe<ActivityListRelationFilter>;
  authorProfile?: InputMaybe<ProfileScalarRelationFilter>;
  authorProfileId?: InputMaybe<UuidFilter>;
  backgroundColor?: InputMaybe<StringNullableFilter>;
  circleViews?: InputMaybe<CircleViewListRelationFilter>;
  durationSeconds?: InputMaybe<IntNullableFilter>;
  expiresAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  key?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringNullableFilter>;
  mediaType?: InputMaybe<EnumMediaTypeFilter>;
  sharedInMessages?: InputMaybe<MessageListRelationFilter>;
  text?: InputMaybe<StringNullableFilter>;
  thumbnailUrl?: InputMaybe<StringNullableFilter>;
  url?: InputMaybe<StringFilter>;
};

export type CircleWhereUniqueInput = {
  AND?: InputMaybe<Array<CircleWhereInput>>;
  NOT?: InputMaybe<Array<CircleWhereInput>>;
  OR?: InputMaybe<Array<CircleWhereInput>>;
  activities?: InputMaybe<ActivityListRelationFilter>;
  authorProfile?: InputMaybe<ProfileScalarRelationFilter>;
  authorProfileId?: InputMaybe<UuidFilter>;
  backgroundColor?: InputMaybe<StringNullableFilter>;
  circleViews?: InputMaybe<CircleViewListRelationFilter>;
  durationSeconds?: InputMaybe<IntNullableFilter>;
  expiresAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  key?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringNullableFilter>;
  mediaType?: InputMaybe<EnumMediaTypeFilter>;
  sharedInMessages?: InputMaybe<MessageListRelationFilter>;
  text?: InputMaybe<StringNullableFilter>;
  thumbnailUrl?: InputMaybe<StringNullableFilter>;
  url?: InputMaybe<StringFilter>;
};

/** A single media item (image or video) to attach to a comment. */
export type CommentMediaInput = {
  /** Only relevant for mediaType=VIDEO. */
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** The image/video file itself. */
  image: ImageInput;
  mediaType: MediaType;
  /** Only relevant for mediaType=VIDEO. */
  thumbnailImage?: InputMaybe<ImageInput>;
};

export type CommunityClub = {
  __typename: 'CommunityClub';
  communityEventBookings?: Maybe<Array<CommunityEventBooking>>;
  communityEventImages?: Maybe<Array<CommunityEventImage>>;
  communityEventInstances?: Maybe<Array<CommunityEventInstance>>;
  communityEvents?: Maybe<Array<CommunityEvent>>;
  communityHost: Array<Profile>;
  communityLocations?: Maybe<Array<CommunityEventLocation>>;
  communityMember: Array<Profile>;
  communityMemberRelations?: Maybe<Array<CommunityMemberRelation>>;
  communityPostCommentLikes?: Maybe<Array<CommunityPostCommentLike>>;
  communityPostComments?: Maybe<Array<CommunityPostComment>>;
  communityPostLikes?: Maybe<Array<CommunityPostLike>>;
  communityPosts?: Maybe<Array<CommunityPost>>;
  company: Company;
  createdAt: Scalars['DateTime']['output'];
  customerCommunityClubs?: Maybe<Array<CustomerCommunityClub>>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** A detailed description of the community club. */
  description?: Maybe<Scalars['String']['output']>;
  employees?: Maybe<Array<CompanyEmployee>>;
  /** The house number of the community club's location. */
  houseNumber: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  /** The latitude coordinate of the community club's location. */
  latitude: Scalars['String']['output'];
  /** The longitude coordinate of the community club's location. */
  longitude: Scalars['String']['output'];
  memberCount: Scalars['Int']['output'];
  /**
   * Whether members (Customers) may create a SUB_COMMUNITY-scoped UserPost for this club.
   * Hosts/Employees assigned to the club can always post regardless of this flag.
   */
  membersCanPost: Scalars['Boolean']['output'];
  /** The name of the community club. */
  name: Scalars['String']['output'];
  /** The city or town where the community club is located. */
  place: Scalars['String']['output'];
  plannedEventsCount: Scalars['Int']['output'];
  profile?: Maybe<Profile>;
  s3CoverImageKey?: Maybe<Scalars['String']['output']>;
  s3CoverImageUrl?: Maybe<Scalars['String']['output']>;
  /** Optional branding image keys and urls */
  s3LogoKey?: Maybe<Scalars['String']['output']>;
  s3LogoUrl?: Maybe<Scalars['String']['output']>;
  /** The street name of the community club's location. */
  street: Scalars['String']['output'];
  /** The ticket fees that apply to the club's paid events, with the defaults where the club has none. */
  ticketFees: CommunityClubTicketFees;
  /** Whether the club can sell tickets (it is connected to Stripe). Only then can paid events be created. */
  ticketingEnabled: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** The postal code of the community club's location. */
  zipcode: Scalars['String']['output'];
};


export type CommunityClubCommunityEventBookingsArgs = {
  cursor?: InputMaybe<CommunityEventBookingWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityEventBookingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityEventBookingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityEventBookingWhereInput>;
};


export type CommunityClubCommunityEventImagesArgs = {
  cursor?: InputMaybe<CommunityEventImageWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityEventImageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityEventImageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityEventImageWhereInput>;
};


export type CommunityClubCommunityEventInstancesArgs = {
  cursor?: InputMaybe<CommunityEventInstanceWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityEventInstanceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityEventInstanceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityEventInstanceWhereInput>;
};


export type CommunityClubCommunityEventsArgs = {
  cursor?: InputMaybe<CommunityEventWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityEventScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityEventOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityEventWhereInput>;
};


export type CommunityClubCommunityLocationsArgs = {
  cursor?: InputMaybe<CommunityEventLocationWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityEventLocationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityEventLocationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityEventLocationWhereInput>;
};


export type CommunityClubCommunityMemberRelationsArgs = {
  cursor?: InputMaybe<CommunityMemberRelationWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityMemberRelationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityMemberRelationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityMemberRelationWhereInput>;
};


export type CommunityClubCommunityPostCommentsArgs = {
  cursor?: InputMaybe<CommunityPostCommentWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityPostCommentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityPostCommentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityPostCommentWhereInput>;
};


export type CommunityClubCommunityPostLikesArgs = {
  cursor?: InputMaybe<CommunityPostLikeWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityPostLikeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityPostLikeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityPostLikeWhereInput>;
};


export type CommunityClubCommunityPostsArgs = {
  cursor?: InputMaybe<CommunityPostWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityPostScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityPostOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityPostWhereInput>;
};


export type CommunityClubCustomerCommunityClubsArgs = {
  cursor?: InputMaybe<CustomerCommunityClubWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomerCommunityClubScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomerCommunityClubOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerCommunityClubWhereInput>;
};


export type CommunityClubEmployeesArgs = {
  cursor?: InputMaybe<CompanyEmployeeWhereUniqueInput>;
  distinct?: InputMaybe<Array<CompanyEmployeeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CompanyEmployeeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CompanyEmployeeWhereInput>;
};

export type CommunityClubAvgAggregate = {
  __typename: 'CommunityClubAvgAggregate';
  ticketCommissionPercent?: Maybe<Scalars['Float']['output']>;
  ticketFlatFeeInCents?: Maybe<Scalars['Float']['output']>;
};

export type CommunityClubCountAggregate = {
  __typename: 'CommunityClubCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  houseNumber: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  latitude: Scalars['Int']['output'];
  longitude: Scalars['Int']['output'];
  membersCanPost: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  place: Scalars['Int']['output'];
  s3CoverImageKey: Scalars['Int']['output'];
  s3CoverImageUrl: Scalars['Int']['output'];
  s3LogoKey: Scalars['Int']['output'];
  s3LogoUrl: Scalars['Int']['output'];
  street: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  zipcode: Scalars['Int']['output'];
};

export type CommunityClubCreateInput = {
  communityEventBookings?: InputMaybe<CommunityEventBookingCreateNestedManyWithoutCommunityClubInput>;
  communityEventImages?: InputMaybe<CommunityEventImageCreateNestedManyWithoutCommunityClubInput>;
  communityEventInstances?: InputMaybe<CommunityEventInstanceCreateNestedManyWithoutCommunityClubInput>;
  communityEvents?: InputMaybe<CommunityEventCreateNestedManyWithoutCommunityClubInput>;
  communityLocations?: InputMaybe<CommunityEventLocationCreateNestedManyWithoutCommunityClubInput>;
  communityMemberRelations?: InputMaybe<CommunityMemberRelationCreateNestedManyWithoutCommunityClubInput>;
  communityPostCommentLikes?: InputMaybe<CommunityPostCommentLikeCreateNestedManyWithoutCommunityClubInput>;
  communityPostComments?: InputMaybe<CommunityPostCommentCreateNestedManyWithoutCommunityClubInput>;
  communityPostLikes?: InputMaybe<CommunityPostLikeCreateNestedManyWithoutCommunityClubInput>;
  communityPosts?: InputMaybe<CommunityPostCreateNestedManyWithoutCommunityClubInput>;
  company?: InputMaybe<CompanyCreateNestedOneWithoutCommunityClubsInput>;
  coverImage: ImageInput;
  customerCommunityClubs?: InputMaybe<CustomerCommunityClubCreateNestedManyWithoutCommunityClubInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  employees?: InputMaybe<CompanyEmployeeCreateNestedManyWithoutCommunityClubsInput>;
  houseNumber: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  latitude: Scalars['String']['input'];
  logoImage: ImageInput;
  longitude: Scalars['String']['input'];
  membersCanPost?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  place: Scalars['String']['input'];
  profile?: InputMaybe<ProfileCreateNestedOneWithoutCommunityClubInput>;
  /** Handle for the club's own Profile (auto-created alongside the club). */
  profileHandle: Scalars['String']['input'];
  reports?: InputMaybe<ReportCreateNestedManyWithoutCommunityClubInput>;
  s3CoverImageKey?: InputMaybe<Scalars['String']['input']>;
  s3LogoKey?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  userPosts?: InputMaybe<UserPostCreateNestedManyWithoutCommunityClubInput>;
  workouts?: InputMaybe<WorkoutCreateNestedManyWithoutCommunityClubInput>;
  zipcode: Scalars['String']['input'];
};

export type CommunityClubCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<CommunityClubWhereUniqueInput>>;
};

export type CommunityClubCreateNestedManyWithoutEmployeesInput = {
  connect?: InputMaybe<Array<CommunityClubWhereUniqueInput>>;
};

export type CommunityClubCreateNestedOneWithoutCommunityEventsInput = {
  connect?: InputMaybe<CommunityClubWhereUniqueInput>;
};

export type CommunityClubCreateNestedOneWithoutCommunityLocationsInput = {
  connect?: InputMaybe<CommunityClubWhereUniqueInput>;
};

export type CommunityClubCreateNestedOneWithoutCommunityPostsInput = {
  connect?: InputMaybe<CommunityClubWhereUniqueInput>;
};

export type CommunityClubListRelationFilter = {
  every?: InputMaybe<CommunityClubWhereInput>;
  none?: InputMaybe<CommunityClubWhereInput>;
  some?: InputMaybe<CommunityClubWhereInput>;
};

export type CommunityClubMaxAggregate = {
  __typename: 'CommunityClubMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  membersCanPost?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  place?: Maybe<Scalars['String']['output']>;
  s3CoverImageKey?: Maybe<Scalars['String']['output']>;
  s3CoverImageUrl?: Maybe<Scalars['String']['output']>;
  s3LogoKey?: Maybe<Scalars['String']['output']>;
  s3LogoUrl?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type CommunityClubMinAggregate = {
  __typename: 'CommunityClubMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  membersCanPost?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  place?: Maybe<Scalars['String']['output']>;
  s3CoverImageKey?: Maybe<Scalars['String']['output']>;
  s3CoverImageUrl?: Maybe<Scalars['String']['output']>;
  s3LogoKey?: Maybe<Scalars['String']['output']>;
  s3LogoUrl?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type CommunityClubNullableScalarRelationFilter = {
  is?: InputMaybe<CommunityClubWhereInput>;
  isNot?: InputMaybe<CommunityClubWhereInput>;
};

/**
 * A self-service application submitted through the public onboarding wizard, pending internal review
 * before a real Company/CommunityClub (and the corresponding Auth0/AWS setup) is provisioned.
 */
export type CommunityClubOnboarding = {
  __typename: 'CommunityClubOnboarding';
  /** Step 1 (Account) — email of the person submitting the application. */
  accountEmail: Scalars['String']['output'];
  /** Step 3 (Community Club) — optional description of the club. */
  clubDescription?: Maybe<Scalars['String']['output']>;
  /** Step 3 (Community Club) — house number of the club's address. */
  clubHouseNumber: Scalars['String']['output'];
  /** Step 3 (Community Club) — latitude of the club's location. */
  clubLatitude: Scalars['String']['output'];
  /** Step 3 (Community Club) — longitude of the club's location. */
  clubLongitude: Scalars['String']['output'];
  /** Step 3 (Community Club) — name of the club. */
  clubName: Scalars['String']['output'];
  /** Step 3 (Community Club) — city/town of the club's address. */
  clubPlace: Scalars['String']['output'];
  /** Step 3 (Community Club) — street of the club's address. */
  clubStreet: Scalars['String']['output'];
  /** Step 3 (Community Club) — postal code of the club's address. */
  clubZipcode: Scalars['String']['output'];
  /** Step 2 (Company) — company contact email. */
  companyEmail: Scalars['String']['output'];
  /** Step 2 (Company) — house number of the company's address. */
  companyHouseNumber: Scalars['String']['output'];
  /** Step 2 (Company) — brand/company name. */
  companyName: Scalars['String']['output'];
  /** Step 2 (Company) — city/town of the company's address. */
  companyPlace: Scalars['String']['output'];
  /** Step 2 (Company) — street of the company's address. */
  companyStreet: Scalars['String']['output'];
  /** Step 2 (Company) — postal code of the company's address. */
  companyZipcode: Scalars['String']['output'];
  /** Step 2 (Company) — ISO country code (DE, AT, CH). */
  countryCode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Step 1 (Account) — first name of the person submitting the application. */
  firstName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  /** Step 1 (Account) — last name of the person submitting the application. */
  lastName: Scalars['String']['output'];
  /** Reason given when the application is rejected. */
  rejectionReason?: Maybe<Scalars['String']['output']>;
  /** When the application was last reviewed (approved or rejected). */
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Auth0 subject (`sub`) of the internal reviewer who last set the status. */
  reviewedBy?: Maybe<Scalars['String']['output']>;
  /** Step 3 (Community Club) — uploaded cover image keys/urls. */
  s3CoverImageKey?: Maybe<Scalars['String']['output']>;
  s3CoverImageUrl?: Maybe<Scalars['String']['output']>;
  /** Step 3 (Community Club) — uploaded logo image keys/urls. */
  s3LogoKey?: Maybe<Scalars['String']['output']>;
  s3LogoUrl?: Maybe<Scalars['String']['output']>;
  /** The review lifecycle of the application. */
  status: CommunityClubOnboardingStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type CommunityClubOnboardingCountAggregate = {
  __typename: 'CommunityClubOnboardingCountAggregate';
  _all: Scalars['Int']['output'];
  accountEmail: Scalars['Int']['output'];
  clubDescription: Scalars['Int']['output'];
  clubHouseNumber: Scalars['Int']['output'];
  clubLatitude: Scalars['Int']['output'];
  clubLongitude: Scalars['Int']['output'];
  clubName: Scalars['Int']['output'];
  clubPlace: Scalars['Int']['output'];
  clubStreet: Scalars['Int']['output'];
  clubZipcode: Scalars['Int']['output'];
  companyEmail: Scalars['Int']['output'];
  companyHouseNumber: Scalars['Int']['output'];
  companyName: Scalars['Int']['output'];
  companyPlace: Scalars['Int']['output'];
  companyStreet: Scalars['Int']['output'];
  companyZipcode: Scalars['Int']['output'];
  countryCode: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  firstName: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['Int']['output'];
  rejectionReason: Scalars['Int']['output'];
  reviewedAt: Scalars['Int']['output'];
  reviewedBy: Scalars['Int']['output'];
  s3CoverImageKey: Scalars['Int']['output'];
  s3CoverImageUrl: Scalars['Int']['output'];
  s3LogoKey: Scalars['Int']['output'];
  s3LogoUrl: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CommunityClubOnboardingMaxAggregate = {
  __typename: 'CommunityClubOnboardingMaxAggregate';
  accountEmail?: Maybe<Scalars['String']['output']>;
  clubDescription?: Maybe<Scalars['String']['output']>;
  clubHouseNumber?: Maybe<Scalars['String']['output']>;
  clubLatitude?: Maybe<Scalars['String']['output']>;
  clubLongitude?: Maybe<Scalars['String']['output']>;
  clubName?: Maybe<Scalars['String']['output']>;
  clubPlace?: Maybe<Scalars['String']['output']>;
  clubStreet?: Maybe<Scalars['String']['output']>;
  clubZipcode?: Maybe<Scalars['String']['output']>;
  companyEmail?: Maybe<Scalars['String']['output']>;
  companyHouseNumber?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyPlace?: Maybe<Scalars['String']['output']>;
  companyStreet?: Maybe<Scalars['String']['output']>;
  companyZipcode?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  s3CoverImageKey?: Maybe<Scalars['String']['output']>;
  s3CoverImageUrl?: Maybe<Scalars['String']['output']>;
  s3LogoKey?: Maybe<Scalars['String']['output']>;
  s3LogoUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CommunityClubOnboardingStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityClubOnboardingMinAggregate = {
  __typename: 'CommunityClubOnboardingMinAggregate';
  accountEmail?: Maybe<Scalars['String']['output']>;
  clubDescription?: Maybe<Scalars['String']['output']>;
  clubHouseNumber?: Maybe<Scalars['String']['output']>;
  clubLatitude?: Maybe<Scalars['String']['output']>;
  clubLongitude?: Maybe<Scalars['String']['output']>;
  clubName?: Maybe<Scalars['String']['output']>;
  clubPlace?: Maybe<Scalars['String']['output']>;
  clubStreet?: Maybe<Scalars['String']['output']>;
  clubZipcode?: Maybe<Scalars['String']['output']>;
  companyEmail?: Maybe<Scalars['String']['output']>;
  companyHouseNumber?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyPlace?: Maybe<Scalars['String']['output']>;
  companyStreet?: Maybe<Scalars['String']['output']>;
  companyZipcode?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  s3CoverImageKey?: Maybe<Scalars['String']['output']>;
  s3CoverImageUrl?: Maybe<Scalars['String']['output']>;
  s3LogoKey?: Maybe<Scalars['String']['output']>;
  s3LogoUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CommunityClubOnboardingStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityClubOnboardingOrderByWithRelationInput = {
  accountEmail?: InputMaybe<SortOrder>;
  clubDescription?: InputMaybe<SortOrderInput>;
  clubHouseNumber?: InputMaybe<SortOrder>;
  clubLatitude?: InputMaybe<SortOrder>;
  clubLongitude?: InputMaybe<SortOrder>;
  clubName?: InputMaybe<SortOrder>;
  clubPlace?: InputMaybe<SortOrder>;
  clubStreet?: InputMaybe<SortOrder>;
  clubZipcode?: InputMaybe<SortOrder>;
  companyEmail?: InputMaybe<SortOrder>;
  companyHouseNumber?: InputMaybe<SortOrder>;
  companyName?: InputMaybe<SortOrder>;
  companyPlace?: InputMaybe<SortOrder>;
  companyStreet?: InputMaybe<SortOrder>;
  companyZipcode?: InputMaybe<SortOrder>;
  countryCode?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  rejectionReason?: InputMaybe<SortOrderInput>;
  reviewedAt?: InputMaybe<SortOrderInput>;
  reviewedBy?: InputMaybe<SortOrderInput>;
  s3CoverImageKey?: InputMaybe<SortOrderInput>;
  s3CoverImageUrl?: InputMaybe<SortOrderInput>;
  s3LogoKey?: InputMaybe<SortOrderInput>;
  s3LogoUrl?: InputMaybe<SortOrderInput>;
};

/** Input for an internal reviewer to approve or reject a community club onboarding application. Approving triggers Auth0/AWS provisioning and Company/CommunityClub creation automatically - the reviewer no longer supplies those identifiers. */
export type CommunityClubOnboardingReviewInput = {
  /** Required when rejecting; explains the decision to the applicant. */
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  /** Must be APPROVED or REJECTED. */
  status: CommunityClubOnboardingStatus;
};

export enum CommunityClubOnboardingScalarFieldEnum {
  AccountEmail = 'accountEmail',
  ClubDescription = 'clubDescription',
  ClubHouseNumber = 'clubHouseNumber',
  ClubLatitude = 'clubLatitude',
  ClubLongitude = 'clubLongitude',
  ClubName = 'clubName',
  ClubPlace = 'clubPlace',
  ClubStreet = 'clubStreet',
  ClubZipcode = 'clubZipcode',
  CompanyEmail = 'companyEmail',
  CompanyHouseNumber = 'companyHouseNumber',
  CompanyName = 'companyName',
  CompanyPlace = 'companyPlace',
  CompanyStreet = 'companyStreet',
  CompanyZipcode = 'companyZipcode',
  CountryCode = 'countryCode',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  FirstName = 'firstName',
  Id = 'id',
  LastName = 'lastName',
  Password = 'password',
  RejectionReason = 'rejectionReason',
  ReviewedAt = 'reviewedAt',
  ReviewedBy = 'reviewedBy',
  S3CoverImageKey = 's3CoverImageKey',
  S3CoverImageUrl = 's3CoverImageUrl',
  S3LogoKey = 's3LogoKey',
  S3LogoUrl = 's3LogoUrl',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

/** The review lifecycle of a self-service community club onboarding application. */
export enum CommunityClubOnboardingStatus {
  /** Reviewed and accepted; provisioning (Auth0/AWS/DB) is triggered separately. */
  Approved = 'APPROVED',
  /** Submitted by the applicant, awaiting internal review. */
  PendingReview = 'PENDING_REVIEW',
  /** Reviewed and declined. */
  Rejected = 'REJECTED'
}

/** Input for the public onboarding wizard to submit a new community club application. */
export type CommunityClubOnboardingSubmitInput = {
  accountEmail: Scalars['String']['input'];
  clubDescription?: InputMaybe<Scalars['String']['input']>;
  clubHouseNumber: Scalars['String']['input'];
  clubLatitude: Scalars['String']['input'];
  clubLongitude: Scalars['String']['input'];
  clubName: Scalars['String']['input'];
  clubPlace: Scalars['String']['input'];
  clubStreet: Scalars['String']['input'];
  clubZipcode: Scalars['String']['input'];
  companyEmail: Scalars['String']['input'];
  companyHouseNumber: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  companyPlace: Scalars['String']['input'];
  companyStreet: Scalars['String']['input'];
  companyZipcode: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  coverImage: ImageInput;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  logoImage: ImageInput;
  /** The applicant's chosen password; stored as plain text, never returned by any query. */
  password: Scalars['String']['input'];
};

export type CommunityClubOnboardingUpdateInput = {
  accountEmail?: InputMaybe<Scalars['String']['input']>;
  clubDescription?: InputMaybe<Scalars['String']['input']>;
  clubHouseNumber?: InputMaybe<Scalars['String']['input']>;
  clubLatitude?: InputMaybe<Scalars['String']['input']>;
  clubLongitude?: InputMaybe<Scalars['String']['input']>;
  clubName?: InputMaybe<Scalars['String']['input']>;
  clubPlace?: InputMaybe<Scalars['String']['input']>;
  clubStreet?: InputMaybe<Scalars['String']['input']>;
  clubZipcode?: InputMaybe<Scalars['String']['input']>;
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  companyHouseNumber?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyPlace?: InputMaybe<Scalars['String']['input']>;
  companyStreet?: InputMaybe<Scalars['String']['input']>;
  companyZipcode?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  reviewedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reviewedBy?: InputMaybe<Scalars['String']['input']>;
  s3CoverImageKey?: InputMaybe<Scalars['String']['input']>;
  s3CoverImageUrl?: InputMaybe<Scalars['String']['input']>;
  s3LogoKey?: InputMaybe<Scalars['String']['input']>;
  s3LogoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CommunityClubOnboardingWhereInput = {
  AND?: InputMaybe<Array<CommunityClubOnboardingWhereInput>>;
  NOT?: InputMaybe<Array<CommunityClubOnboardingWhereInput>>;
  OR?: InputMaybe<Array<CommunityClubOnboardingWhereInput>>;
  accountEmail?: InputMaybe<StringFilter>;
  clubDescription?: InputMaybe<StringNullableFilter>;
  clubHouseNumber?: InputMaybe<StringFilter>;
  clubLatitude?: InputMaybe<StringFilter>;
  clubLongitude?: InputMaybe<StringFilter>;
  clubName?: InputMaybe<StringFilter>;
  clubPlace?: InputMaybe<StringFilter>;
  clubStreet?: InputMaybe<StringFilter>;
  clubZipcode?: InputMaybe<StringFilter>;
  companyEmail?: InputMaybe<StringFilter>;
  companyHouseNumber?: InputMaybe<StringFilter>;
  companyName?: InputMaybe<StringFilter>;
  companyPlace?: InputMaybe<StringFilter>;
  companyStreet?: InputMaybe<StringFilter>;
  companyZipcode?: InputMaybe<StringFilter>;
  countryCode?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  lastName?: InputMaybe<StringFilter>;
  rejectionReason?: InputMaybe<StringNullableFilter>;
  reviewedAt?: InputMaybe<DateTimeNullableFilter>;
  reviewedBy?: InputMaybe<StringNullableFilter>;
  s3CoverImageKey?: InputMaybe<StringNullableFilter>;
  s3CoverImageUrl?: InputMaybe<StringNullableFilter>;
  s3LogoKey?: InputMaybe<StringNullableFilter>;
  s3LogoUrl?: InputMaybe<StringNullableFilter>;
};

export type CommunityClubOnboardingWhereUniqueInput = {
  AND?: InputMaybe<Array<CommunityClubOnboardingWhereInput>>;
  NOT?: InputMaybe<Array<CommunityClubOnboardingWhereInput>>;
  OR?: InputMaybe<Array<CommunityClubOnboardingWhereInput>>;
  accountEmail?: InputMaybe<StringFilter>;
  clubDescription?: InputMaybe<StringNullableFilter>;
  clubHouseNumber?: InputMaybe<StringFilter>;
  clubLatitude?: InputMaybe<StringFilter>;
  clubLongitude?: InputMaybe<StringFilter>;
  clubName?: InputMaybe<StringFilter>;
  clubPlace?: InputMaybe<StringFilter>;
  clubStreet?: InputMaybe<StringFilter>;
  clubZipcode?: InputMaybe<StringFilter>;
  companyEmail?: InputMaybe<StringFilter>;
  companyHouseNumber?: InputMaybe<StringFilter>;
  companyName?: InputMaybe<StringFilter>;
  companyPlace?: InputMaybe<StringFilter>;
  companyStreet?: InputMaybe<StringFilter>;
  companyZipcode?: InputMaybe<StringFilter>;
  countryCode?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  lastName?: InputMaybe<StringFilter>;
  rejectionReason?: InputMaybe<StringNullableFilter>;
  reviewedAt?: InputMaybe<DateTimeNullableFilter>;
  reviewedBy?: InputMaybe<StringNullableFilter>;
  s3CoverImageKey?: InputMaybe<StringNullableFilter>;
  s3CoverImageUrl?: InputMaybe<StringNullableFilter>;
  s3LogoKey?: InputMaybe<StringNullableFilter>;
  s3LogoUrl?: InputMaybe<StringNullableFilter>;
};

export type CommunityClubOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CommunityClubOrderByWithRelationInput = {
  communityEventBookings?: InputMaybe<CommunityEventBookingOrderByRelationAggregateInput>;
  communityEventImages?: InputMaybe<CommunityEventImageOrderByRelationAggregateInput>;
  communityEventInstances?: InputMaybe<CommunityEventInstanceOrderByRelationAggregateInput>;
  communityEvents?: InputMaybe<CommunityEventOrderByRelationAggregateInput>;
  communityLocations?: InputMaybe<CommunityEventLocationOrderByRelationAggregateInput>;
  communityMemberRelations?: InputMaybe<CommunityMemberRelationOrderByRelationAggregateInput>;
  communityPostCommentLikes?: InputMaybe<CommunityPostCommentLikeOrderByRelationAggregateInput>;
  communityPostComments?: InputMaybe<CommunityPostCommentOrderByRelationAggregateInput>;
  communityPostLikes?: InputMaybe<CommunityPostLikeOrderByRelationAggregateInput>;
  communityPosts?: InputMaybe<CommunityPostOrderByRelationAggregateInput>;
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  companyId?: InputMaybe<SortOrder>;
  customerCommunityClubs?: InputMaybe<CustomerCommunityClubOrderByRelationAggregateInput>;
  deletedAt?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrderInput>;
  employees?: InputMaybe<CompanyEmployeeOrderByRelationAggregateInput>;
  houseNumber?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  latitude?: InputMaybe<SortOrder>;
  longitude?: InputMaybe<SortOrder>;
  membersCanPost?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  place?: InputMaybe<SortOrder>;
  profile?: InputMaybe<ProfileOrderByWithRelationInput>;
  reports?: InputMaybe<ReportOrderByRelationAggregateInput>;
  s3CoverImageKey?: InputMaybe<SortOrderInput>;
  s3CoverImageUrl?: InputMaybe<SortOrderInput>;
  s3LogoKey?: InputMaybe<SortOrderInput>;
  s3LogoUrl?: InputMaybe<SortOrderInput>;
  street?: InputMaybe<SortOrder>;
  userPosts?: InputMaybe<UserPostOrderByRelationAggregateInput>;
  workouts?: InputMaybe<WorkoutOrderByRelationAggregateInput>;
  zipcode?: InputMaybe<SortOrder>;
};

export enum CommunityClubScalarFieldEnum {
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Description = 'description',
  HouseNumber = 'houseNumber',
  Id = 'id',
  Latitude = 'latitude',
  Longitude = 'longitude',
  MembersCanPost = 'membersCanPost',
  Name = 'name',
  Place = 'place',
  S3CoverImageKey = 's3CoverImageKey',
  S3CoverImageUrl = 's3CoverImageUrl',
  S3LogoKey = 's3LogoKey',
  S3LogoUrl = 's3LogoUrl',
  Street = 'street',
  StripeConnectId = 'stripeConnectId',
  TicketCommissionPercent = 'ticketCommissionPercent',
  TicketFlatFeeInCents = 'ticketFlatFeeInCents',
  UpdatedAt = 'updatedAt',
  Zipcode = 'zipcode'
}

export type CommunityClubScalarRelationFilter = {
  is?: InputMaybe<CommunityClubWhereInput>;
  isNot?: InputMaybe<CommunityClubWhereInput>;
};

export type CommunityClubSumAggregate = {
  __typename: 'CommunityClubSumAggregate';
  ticketCommissionPercent?: Maybe<Scalars['Float']['output']>;
  ticketFlatFeeInCents?: Maybe<Scalars['Int']['output']>;
};

/** The ticket fees that apply to the club's paid events: its own values, or the defaults where it has none. */
export type CommunityClubTicketFees = {
  __typename: 'CommunityClubTicketFees';
  /** Commission in percent of the ticket price. */
  commissionPercent: Scalars['Float']['output'];
  /** Flat fee per ticket in cents. */
  flatFeeInCents: Scalars['Int']['output'];
};

/** Input for updating a community club */
export type CommunityClubUpdateInput = {
  communityEventBookings?: InputMaybe<CommunityEventBookingUpdateManyWithoutCommunityClubNestedInput>;
  communityEventImages?: InputMaybe<CommunityEventImageUpdateManyWithoutCommunityClubNestedInput>;
  communityEventInstances?: InputMaybe<CommunityEventInstanceUpdateManyWithoutCommunityClubNestedInput>;
  communityEvents?: InputMaybe<CommunityEventUpdateManyWithoutCommunityClubNestedInput>;
  communityLocations?: InputMaybe<CommunityEventLocationUpdateManyWithoutCommunityClubNestedInput>;
  communityMemberRelations?: InputMaybe<CommunityMemberRelationUpdateManyWithoutCommunityClubNestedInput>;
  communityPostCommentLikes?: InputMaybe<CommunityPostCommentLikeUpdateManyWithoutCommunityClubNestedInput>;
  communityPostComments?: InputMaybe<CommunityPostCommentUpdateManyWithoutCommunityClubNestedInput>;
  communityPostLikes?: InputMaybe<CommunityPostLikeUpdateManyWithoutCommunityClubNestedInput>;
  communityPosts?: InputMaybe<CommunityPostUpdateManyWithoutCommunityClubNestedInput>;
  coverImage?: InputMaybe<ImageInput>;
  customerCommunityClubs?: InputMaybe<CustomerCommunityClubUpdateManyWithoutCommunityClubNestedInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  employees?: InputMaybe<CompanyEmployeeUpdateManyWithoutCommunityClubsNestedInput>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  logoImage?: InputMaybe<ImageInput>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  membersCanPost?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<ProfileUpdateOneWithoutCommunityClubNestedInput>;
  /** Handle for the club's own Profile. */
  profileHandle?: InputMaybe<Scalars['String']['input']>;
  reports?: InputMaybe<ReportUpdateManyWithoutCommunityClubNestedInput>;
  s3CoverImageKey?: InputMaybe<Scalars['String']['input']>;
  s3LogoKey?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  userPosts?: InputMaybe<UserPostUpdateManyWithoutCommunityClubNestedInput>;
  workouts?: InputMaybe<WorkoutUpdateManyWithoutCommunityClubNestedInput>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type CommunityClubUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<CommunityClubWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CommunityClubWhereUniqueInput>>;
};

export type CommunityClubUpdateOneRequiredWithoutCommunityEventBookingsNestedInput = {
  connect?: InputMaybe<CommunityClubWhereUniqueInput>;
};

export type CommunityClubUpdateOneRequiredWithoutCommunityEventInstancesNestedInput = {
  connect?: InputMaybe<CommunityClubWhereUniqueInput>;
};

export type CommunityClubUpdateOneRequiredWithoutCommunityLocationsNestedInput = {
  connect?: InputMaybe<CommunityClubWhereUniqueInput>;
};

export type CommunityClubWhereInput = {
  AND?: InputMaybe<Array<CommunityClubWhereInput>>;
  NOT?: InputMaybe<Array<CommunityClubWhereInput>>;
  OR?: InputMaybe<Array<CommunityClubWhereInput>>;
  communityEventBookings?: InputMaybe<CommunityEventBookingListRelationFilter>;
  communityEventImages?: InputMaybe<CommunityEventImageListRelationFilter>;
  communityEventInstances?: InputMaybe<CommunityEventInstanceListRelationFilter>;
  communityEvents?: InputMaybe<CommunityEventListRelationFilter>;
  communityLocations?: InputMaybe<CommunityEventLocationListRelationFilter>;
  communityMemberRelations?: InputMaybe<CommunityMemberRelationListRelationFilter>;
  communityPostCommentLikes?: InputMaybe<CommunityPostCommentLikeListRelationFilter>;
  communityPostComments?: InputMaybe<CommunityPostCommentListRelationFilter>;
  communityPostLikes?: InputMaybe<CommunityPostLikeListRelationFilter>;
  communityPosts?: InputMaybe<CommunityPostListRelationFilter>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  customerCommunityClubs?: InputMaybe<CustomerCommunityClubListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  employees?: InputMaybe<CompanyEmployeeListRelationFilter>;
  houseNumber?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  latitude?: InputMaybe<StringFilter>;
  longitude?: InputMaybe<StringFilter>;
  membersCanPost?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  place?: InputMaybe<StringFilter>;
  profile?: InputMaybe<ProfileNullableScalarRelationFilter>;
  reports?: InputMaybe<ReportListRelationFilter>;
  s3CoverImageKey?: InputMaybe<StringNullableFilter>;
  s3CoverImageUrl?: InputMaybe<StringNullableFilter>;
  s3LogoKey?: InputMaybe<StringNullableFilter>;
  s3LogoUrl?: InputMaybe<StringNullableFilter>;
  street?: InputMaybe<StringFilter>;
  userPosts?: InputMaybe<UserPostListRelationFilter>;
  workouts?: InputMaybe<WorkoutListRelationFilter>;
  zipcode?: InputMaybe<StringFilter>;
};

export type CommunityClubWhereUniqueInput = {
  AND?: InputMaybe<Array<CommunityClubWhereInput>>;
  NOT?: InputMaybe<Array<CommunityClubWhereInput>>;
  OR?: InputMaybe<Array<CommunityClubWhereInput>>;
  communityEventBookings?: InputMaybe<CommunityEventBookingListRelationFilter>;
  communityEventImages?: InputMaybe<CommunityEventImageListRelationFilter>;
  communityEventInstances?: InputMaybe<CommunityEventInstanceListRelationFilter>;
  communityEvents?: InputMaybe<CommunityEventListRelationFilter>;
  communityLocations?: InputMaybe<CommunityEventLocationListRelationFilter>;
  communityMemberRelations?: InputMaybe<CommunityMemberRelationListRelationFilter>;
  communityPostCommentLikes?: InputMaybe<CommunityPostCommentLikeListRelationFilter>;
  communityPostComments?: InputMaybe<CommunityPostCommentListRelationFilter>;
  communityPostLikes?: InputMaybe<CommunityPostLikeListRelationFilter>;
  communityPosts?: InputMaybe<CommunityPostListRelationFilter>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  customerCommunityClubs?: InputMaybe<CustomerCommunityClubListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  employees?: InputMaybe<CompanyEmployeeListRelationFilter>;
  houseNumber?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  latitude?: InputMaybe<StringFilter>;
  longitude?: InputMaybe<StringFilter>;
  membersCanPost?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  place?: InputMaybe<StringFilter>;
  profile?: InputMaybe<ProfileNullableScalarRelationFilter>;
  reports?: InputMaybe<ReportListRelationFilter>;
  s3CoverImageKey?: InputMaybe<StringNullableFilter>;
  s3CoverImageUrl?: InputMaybe<StringNullableFilter>;
  s3LogoKey?: InputMaybe<StringNullableFilter>;
  s3LogoUrl?: InputMaybe<StringNullableFilter>;
  street?: InputMaybe<StringFilter>;
  userPosts?: InputMaybe<UserPostListRelationFilter>;
  workouts?: InputMaybe<WorkoutListRelationFilter>;
  zipcode?: InputMaybe<StringFilter>;
};

export type CommunityEvent = {
  __typename: 'CommunityEvent';
  advanceGenerationDays: Scalars['Int']['output'];
  communityClub: CommunityClub;
  communityEventCategory?: Maybe<CommunityEventCategory>;
  communityEventCategoryId?: Maybe<Scalars['String']['output']>;
  communityEventImages?: Maybe<Array<CommunityEventImage>>;
  communityEventInstances?: Maybe<Array<CommunityEventInstance>>;
  communityEventLocation: CommunityEventLocation;
  communityEventPartner?: Maybe<CommunityEventPartner>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  durationMin?: Maybe<Scalars['Int']['output']>;
  host?: Maybe<Profile>;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDraft: Scalars['Boolean']['output'];
  isLimited: Scalars['Boolean']['output'];
  /**
   * Paid (ticketed) or free. Set only on create and never changed afterwards, so it is hidden from
   * every update input.
   */
  isPaid: Scalars['Boolean']['output'];
  maxParticipants?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /** The days of the week the event occurs on (e.g., [1, 2]). */
  recurrenceByweekday?: Maybe<Array<Scalars['Int']['output']>>;
  /** The number of occurrences if recurrenceEndType is 'count'. */
  recurrenceCount?: Maybe<Scalars['Int']['output']>;
  /** The end condition for the recurrence (e.g., never, until, count). */
  recurrenceEndType?: Maybe<RecurrenceEndType>;
  /** The frequency of the recurrence (e.g., DAILY, WEEKLY, MONTHLY). */
  recurrenceFreq?: Maybe<RecurrenceFrequency>;
  /** The interval of the recurrence (e.g., 1, 2, 3). */
  recurrenceInterval?: Maybe<Scalars['Int']['output']>;
  /** The month option for the recurrence (e.g., day, weekday, last-weekday). */
  recurrenceMonthOption?: Maybe<RecurrenceMonthOption>;
  /** The start date and time of the first event in the recurring series. */
  recurrenceStartDate?: Maybe<Scalars['DateTime']['output']>;
  /** The end date of the recurrence if recurrenceEndType is 'until'. */
  recurrenceUntil?: Maybe<Scalars['DateTime']['output']>;
  s3HeaderImageKey?: Maybe<Scalars['String']['output']>;
  s3HeaderImageUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type CommunityEventCommunityEventImagesArgs = {
  cursor?: InputMaybe<CommunityEventImageWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityEventImageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityEventImageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityEventImageWhereInput>;
};


export type CommunityEventCommunityEventInstancesArgs = {
  cursor?: InputMaybe<CommunityEventInstanceWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityEventInstanceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityEventInstanceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityEventInstanceWhereInput>;
};

export type CommunityEventAvgAggregate = {
  __typename: 'CommunityEventAvgAggregate';
  advanceGenerationDays?: Maybe<Scalars['Float']['output']>;
  durationMin?: Maybe<Scalars['Float']['output']>;
  maxParticipants?: Maybe<Scalars['Float']['output']>;
  recurrenceByweekday?: Maybe<Scalars['Float']['output']>;
  recurrenceCount?: Maybe<Scalars['Float']['output']>;
  recurrenceInterval?: Maybe<Scalars['Float']['output']>;
};

export type CommunityEventBooking = {
  __typename: 'CommunityEventBooking';
  communityClub: CommunityClub;
  communityEventInstance: CommunityEventInstance;
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  id: Scalars['UUID']['output'];
  status: CommunityEventBookingStatus;
  updatedAt: Scalars['DateTime']['output'];
};

/** Input for activating multiple waitlisted bookings of a single event instance */
export type CommunityEventBookingActivateWaitlistInput = {
  /** The IDs of the waitlisted bookings to activate */
  ids: Array<Scalars['String']['input']>;
  /** The event instance all bookings belong to */
  instanceId: Scalars['String']['input'];
};

export type CommunityEventBookingCountAggregate = {
  __typename: 'CommunityEventBookingCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CommunityEventBookingCreateInput = {
  instanceId: Scalars['String']['input'];
};

export type CommunityEventBookingCreateNestedManyWithoutCommunityClubInput = {
  connect?: InputMaybe<Array<CommunityEventBookingWhereUniqueInput>>;
};

export type CommunityEventBookingInstanceIdCustomerIdCompoundUniqueInput = {
  customerId: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
};

export type CommunityEventBookingListRelationFilter = {
  every?: InputMaybe<CommunityEventBookingWhereInput>;
  none?: InputMaybe<CommunityEventBookingWhereInput>;
  some?: InputMaybe<CommunityEventBookingWhereInput>;
};

export type CommunityEventBookingMaxAggregate = {
  __typename: 'CommunityEventBookingMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  status?: Maybe<CommunityEventBookingStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityEventBookingMinAggregate = {
  __typename: 'CommunityEventBookingMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  status?: Maybe<CommunityEventBookingStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityEventBookingNullableScalarRelationFilter = {
  is?: InputMaybe<CommunityEventBookingWhereInput>;
  isNot?: InputMaybe<CommunityEventBookingWhereInput>;
};

export type CommunityEventBookingOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CommunityEventBookingOrderByWithRelationInput = {
  communityClub?: InputMaybe<CommunityClubOrderByWithRelationInput>;
  communityClubId?: InputMaybe<SortOrder>;
  communityEventInstance?: InputMaybe<CommunityEventInstanceOrderByWithRelationInput>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  instanceId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export enum CommunityEventBookingScalarFieldEnum {
  CommunityClubId = 'communityClubId',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  Id = 'id',
  InstanceId = 'instanceId',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export enum CommunityEventBookingStatus {
  Active = 'ACTIVE',
  Attended = 'ATTENDED',
  Canceled = 'CANCELED',
  NoShow = 'NO_SHOW',
  Waitlisted = 'WAITLISTED'
}

export type CommunityEventBookingUpdateInput = {
  communityClub?: InputMaybe<CommunityClubUpdateOneRequiredWithoutCommunityEventBookingsNestedInput>;
  communityEventInstance?: InputMaybe<CommunityEventInstanceUpdateOneRequiredWithoutCommunityEventBookingsNestedInput>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutCommunityEventBookingsNestedInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<CommunityEventBookingStatus>;
};

export type CommunityEventBookingUpdateManyWithoutCommunityClubNestedInput = {
  connect?: InputMaybe<Array<CommunityEventBookingWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CommunityEventBookingWhereUniqueInput>>;
};

export type CommunityEventBookingUpdateManyWithoutCommunityEventInstanceNestedInput = {
  connect?: InputMaybe<Array<CommunityEventBookingWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CommunityEventBookingWhereUniqueInput>>;
};

export type CommunityEventBookingUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<CommunityEventBookingWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CommunityEventBookingWhereUniqueInput>>;
};

export type CommunityEventBookingWhereInput = {
  AND?: InputMaybe<Array<CommunityEventBookingWhereInput>>;
  NOT?: InputMaybe<Array<CommunityEventBookingWhereInput>>;
  OR?: InputMaybe<Array<CommunityEventBookingWhereInput>>;
  communityClub?: InputMaybe<CommunityClubScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidFilter>;
  communityEventInstance?: InputMaybe<CommunityEventInstanceScalarRelationFilter>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  instanceId?: InputMaybe<UuidFilter>;
  status?: InputMaybe<EnumCommunityEventBookingStatusFilter>;
};

export type CommunityEventBookingWhereUniqueInput = {
  AND?: InputMaybe<Array<CommunityEventBookingWhereInput>>;
  NOT?: InputMaybe<Array<CommunityEventBookingWhereInput>>;
  OR?: InputMaybe<Array<CommunityEventBookingWhereInput>>;
  communityClub?: InputMaybe<CommunityClubScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidFilter>;
  communityEventInstance?: InputMaybe<CommunityEventInstanceScalarRelationFilter>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  instanceId?: InputMaybe<UuidFilter>;
  instanceId_customerId?: InputMaybe<CommunityEventBookingInstanceIdCustomerIdCompoundUniqueInput>;
  status?: InputMaybe<EnumCommunityEventBookingStatusFilter>;
};

export type CommunityEventCategory = {
  __typename: 'CommunityEventCategory';
  communityEvents?: Maybe<Array<CommunityEvent>>;
  description?: Maybe<Scalars['String']['output']>;
  iconName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};


export type CommunityEventCategoryCommunityEventsArgs = {
  cursor?: InputMaybe<CommunityEventWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityEventScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityEventOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityEventWhereInput>;
};

export type CommunityEventCategoryCountAggregate = {
  __typename: 'CommunityEventCategoryCountAggregate';
  _all: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  iconName: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
};

export type CommunityEventCategoryCreateNestedOneWithoutCommunityEventsInput = {
  connect?: InputMaybe<CommunityEventCategoryWhereUniqueInput>;
};

export type CommunityEventCategoryMaxAggregate = {
  __typename: 'CommunityEventCategoryMaxAggregate';
  description?: Maybe<Scalars['String']['output']>;
  iconName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CommunityEventCategoryMinAggregate = {
  __typename: 'CommunityEventCategoryMinAggregate';
  description?: Maybe<Scalars['String']['output']>;
  iconName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CommunityEventCategoryNullableScalarRelationFilter = {
  is?: InputMaybe<CommunityEventCategoryWhereInput>;
  isNot?: InputMaybe<CommunityEventCategoryWhereInput>;
};

export type CommunityEventCategoryOrderByWithRelationInput = {
  communityEvents?: InputMaybe<CommunityEventOrderByRelationAggregateInput>;
  description?: InputMaybe<SortOrderInput>;
  iconName?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export enum CommunityEventCategoryScalarFieldEnum {
  Description = 'description',
  IconName = 'iconName',
  Id = 'id',
  Name = 'name'
}

export type CommunityEventCategoryUpdateOneWithoutCommunityEventsNestedInput = {
  connect?: InputMaybe<CommunityEventCategoryWhereUniqueInput>;
  disconnect?: InputMaybe<CommunityEventCategoryWhereInput>;
};

export type CommunityEventCategoryWhereInput = {
  AND?: InputMaybe<Array<CommunityEventCategoryWhereInput>>;
  NOT?: InputMaybe<Array<CommunityEventCategoryWhereInput>>;
  OR?: InputMaybe<Array<CommunityEventCategoryWhereInput>>;
  communityEvents?: InputMaybe<CommunityEventListRelationFilter>;
  description?: InputMaybe<StringNullableFilter>;
  iconName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
};

export type CommunityEventCategoryWhereUniqueInput = {
  AND?: InputMaybe<Array<CommunityEventCategoryWhereInput>>;
  NOT?: InputMaybe<Array<CommunityEventCategoryWhereInput>>;
  OR?: InputMaybe<Array<CommunityEventCategoryWhereInput>>;
  communityEvents?: InputMaybe<CommunityEventListRelationFilter>;
  description?: InputMaybe<StringNullableFilter>;
  iconName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CommunityEventCountAggregate = {
  __typename: 'CommunityEventCountAggregate';
  _all: Scalars['Int']['output'];
  advanceGenerationDays: Scalars['Int']['output'];
  communityEventCategoryId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  durationMin: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Int']['output'];
  isDraft: Scalars['Int']['output'];
  isLimited: Scalars['Int']['output'];
  isPaid: Scalars['Int']['output'];
  maxParticipants: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  recurrenceByweekday: Scalars['Int']['output'];
  recurrenceCount: Scalars['Int']['output'];
  recurrenceEndType: Scalars['Int']['output'];
  recurrenceFreq: Scalars['Int']['output'];
  recurrenceInterval: Scalars['Int']['output'];
  recurrenceMonthOption: Scalars['Int']['output'];
  recurrenceStartDate: Scalars['Int']['output'];
  recurrenceUntil: Scalars['Int']['output'];
  s3HeaderImageKey: Scalars['Int']['output'];
  s3HeaderImageUrl: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CommunityEventCreateInput = {
  advanceGenerationDays?: InputMaybe<Scalars['Int']['input']>;
  communityClub: CommunityClubCreateNestedOneWithoutCommunityEventsInput;
  communityEventCategory?: InputMaybe<CommunityEventCategoryCreateNestedOneWithoutCommunityEventsInput>;
  communityEventImages?: InputMaybe<CommunityEventImageCreateNestedManyWithoutCommunityEventInput>;
  communityEventInstances?: InputMaybe<CommunityEventInstanceCreateNestedManyWithoutCommunityEventInput>;
  communityEventLocation: CommunityEventLocationCreateNestedOneWithoutCommunityEventsInput;
  communityEventPartner?: InputMaybe<CommunityEventPartnerCreateNestedOneWithoutCommunityEventsInput>;
  /** Paid events only: quota of free tickets, separate from the tier quotas (default 0). */
  complimentaryQuota?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  durationMin?: InputMaybe<Scalars['Int']['input']>;
  headerImage?: InputMaybe<ImageInput>;
  hostProfile?: InputMaybe<ProfileCreateNestedOneWithoutHostedCommunityEventsInput>;
  /** The Profile to display as the event host — must belong to an employee assigned to this community club. Omit for no host. */
  hostProfileId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isLimited?: InputMaybe<Scalars['Boolean']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  maxParticipants?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  /** Paid events only: the first price tiers in their order. Publishing needs at least one tier. */
  priceTiers?: InputMaybe<Array<CommunityEventPriceTierInput>>;
  recurrenceByweekday?: InputMaybe<Array<Scalars['Int']['input']>>;
  recurrenceCount?: InputMaybe<Scalars['Int']['input']>;
  recurrenceEndType?: InputMaybe<RecurrenceEndType>;
  recurrenceFreq?: InputMaybe<RecurrenceFrequency>;
  recurrenceInterval?: InputMaybe<Scalars['Int']['input']>;
  recurrenceMonthOption?: InputMaybe<RecurrenceMonthOption>;
  recurrenceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  recurrenceUntil?: InputMaybe<Scalars['DateTime']['input']>;
  /** Paid events only (required): start of advance sales, before the event ends. */
  salesStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  sharedInMessages?: InputMaybe<MessageCreateNestedManyWithoutSharedCommunityEventInput>;
};

export type CommunityEventCreateNestedManyWithoutCommunityClubInput = {
  connect?: InputMaybe<Array<CommunityEventWhereUniqueInput>>;
};

export type CommunityEventCreateNestedManyWithoutCommunityEventLocationInput = {
  connect?: InputMaybe<Array<CommunityEventWhereUniqueInput>>;
};

export type CommunityEventCreateNestedManyWithoutCommunityEventPartnerInput = {
  connect?: InputMaybe<Array<CommunityEventWhereUniqueInput>>;
};

export type CommunityEventCreateNestedOneWithoutCommunityEventImagesInput = {
  connect?: InputMaybe<CommunityEventWhereUniqueInput>;
};

export type CommunityEventImage = {
  __typename: 'CommunityEventImage';
  communityClub: CommunityClub;
  communityEvent: CommunityEvent;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  s3ImageKey: Scalars['String']['output'];
  s3ImageUrl: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CommunityEventImageCountAggregate = {
  __typename: 'CommunityEventImageCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  s3ImageKey: Scalars['Int']['output'];
  s3ImageUrl: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

/** Input for creating event image */
export type CommunityEventImageCreateInput = {
  communityEvent: CommunityEventCreateNestedOneWithoutCommunityEventImagesInput;
  image: ImageInput;
};

export type CommunityEventImageCreateNestedManyWithoutCommunityClubInput = {
  connect?: InputMaybe<Array<CommunityEventImageWhereUniqueInput>>;
};

export type CommunityEventImageCreateNestedManyWithoutCommunityEventInput = {
  connect?: InputMaybe<Array<CommunityEventImageWhereUniqueInput>>;
};

export type CommunityEventImageListRelationFilter = {
  every?: InputMaybe<CommunityEventImageWhereInput>;
  none?: InputMaybe<CommunityEventImageWhereInput>;
  some?: InputMaybe<CommunityEventImageWhereInput>;
};

export type CommunityEventImageMaxAggregate = {
  __typename: 'CommunityEventImageMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  s3ImageKey?: Maybe<Scalars['String']['output']>;
  s3ImageUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityEventImageMinAggregate = {
  __typename: 'CommunityEventImageMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  s3ImageKey?: Maybe<Scalars['String']['output']>;
  s3ImageUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityEventImageOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CommunityEventImageOrderByWithRelationInput = {
  communityClub?: InputMaybe<CommunityClubOrderByWithRelationInput>;
  communityClubId?: InputMaybe<SortOrder>;
  communityEvent?: InputMaybe<CommunityEventOrderByWithRelationInput>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  s3ImageKey?: InputMaybe<SortOrder>;
  s3ImageUrl?: InputMaybe<SortOrder>;
};

export enum CommunityEventImageScalarFieldEnum {
  CommunityClubId = 'communityClubId',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  EventId = 'eventId',
  Id = 'id',
  S3ImageKey = 's3ImageKey',
  S3ImageUrl = 's3ImageUrl',
  UpdatedAt = 'updatedAt'
}

export type CommunityEventImageUpdateManyWithoutCommunityClubNestedInput = {
  connect?: InputMaybe<Array<CommunityEventImageWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CommunityEventImageWhereUniqueInput>>;
};

export type CommunityEventImageUpdateManyWithoutCommunityEventNestedInput = {
  connect?: InputMaybe<Array<CommunityEventImageWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CommunityEventImageWhereUniqueInput>>;
};

export type CommunityEventImageWhereInput = {
  AND?: InputMaybe<Array<CommunityEventImageWhereInput>>;
  NOT?: InputMaybe<Array<CommunityEventImageWhereInput>>;
  OR?: InputMaybe<Array<CommunityEventImageWhereInput>>;
  communityClub?: InputMaybe<CommunityClubScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidFilter>;
  communityEvent?: InputMaybe<CommunityEventScalarRelationFilter>;
  eventId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  s3ImageKey?: InputMaybe<StringFilter>;
  s3ImageUrl?: InputMaybe<StringFilter>;
};

export type CommunityEventImageWhereUniqueInput = {
  AND?: InputMaybe<Array<CommunityEventImageWhereInput>>;
  NOT?: InputMaybe<Array<CommunityEventImageWhereInput>>;
  OR?: InputMaybe<Array<CommunityEventImageWhereInput>>;
  communityClub?: InputMaybe<CommunityClubScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidFilter>;
  communityEvent?: InputMaybe<CommunityEventScalarRelationFilter>;
  eventId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  s3ImageKey?: InputMaybe<StringFilter>;
  s3ImageUrl?: InputMaybe<StringFilter>;
};

/** Input for creating multiple event images for one community event at once. */
export type CommunityEventImagesCreateInput = {
  communityEvent: CommunityEventCreateNestedOneWithoutCommunityEventImagesInput;
  /** 1 to 6 images. */
  images: Array<ImageInput>;
};

export type CommunityEventInstance = {
  __typename: 'CommunityEventInstance';
  _count: CommunityEventInstanceCount;
  attendance: CommunityEventInstanceAttendance;
  communityClub: CommunityClub;
  communityEvent: CommunityEvent;
  communityEventBookings?: Maybe<Array<CommunityEventBooking>>;
  communityMember: Array<Profile>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  startAt: Scalars['DateTime']['output'];
  /**
   * The ticket sale of a paid event's instance; null for free events. Visible in the output (read
   * via a scoped resolveField), but hidden from every input: no nested writes through instance
   * updates, and no filtering on sale columns hidden from the output (e.g. complimentaryQuota).
   */
  ticketSale?: Maybe<CommunityEventTicketSale>;
  updatedAt: Scalars['DateTime']['output'];
};


export type CommunityEventInstanceCommunityEventBookingsArgs = {
  cursor?: InputMaybe<CommunityEventBookingWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityEventBookingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityEventBookingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityEventBookingWhereInput>;
};

export type CommunityEventInstanceAttendance = {
  __typename: 'CommunityEventInstanceAttendance';
  checkedInCount: Scalars['Int']['output'];
  noShowCount: Scalars['Int']['output'];
  registeredCount: Scalars['Int']['output'];
};

export type CommunityEventInstanceCount = {
  __typename: 'CommunityEventInstanceCount';
  activities: Scalars['Int']['output'];
  communityEventBookings: Scalars['Int']['output'];
  lastMetInCommunityMemberRelations: Scalars['Int']['output'];
  sharedInMessages: Scalars['Int']['output'];
  workouts: Scalars['Int']['output'];
};

export type CommunityEventInstanceCountAggregate = {
  __typename: 'CommunityEventInstanceCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  endAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  startAt: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CommunityEventInstanceCreateInput = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  eventId: Scalars['String']['input'];
  startAt: Scalars['DateTime']['input'];
};

export type CommunityEventInstanceCreateNestedManyWithoutCommunityClubInput = {
  connect?: InputMaybe<Array<CommunityEventInstanceWhereUniqueInput>>;
};

export type CommunityEventInstanceCreateNestedManyWithoutCommunityEventInput = {
  connect?: InputMaybe<Array<CommunityEventInstanceWhereUniqueInput>>;
};

export type CommunityEventInstanceListRelationFilter = {
  every?: InputMaybe<CommunityEventInstanceWhereInput>;
  none?: InputMaybe<CommunityEventInstanceWhereInput>;
  some?: InputMaybe<CommunityEventInstanceWhereInput>;
};

export type CommunityEventInstanceMaxAggregate = {
  __typename: 'CommunityEventInstanceMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityEventInstanceMinAggregate = {
  __typename: 'CommunityEventInstanceMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityEventInstanceNullableScalarRelationFilter = {
  is?: InputMaybe<CommunityEventInstanceWhereInput>;
  isNot?: InputMaybe<CommunityEventInstanceWhereInput>;
};

export type CommunityEventInstanceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CommunityEventInstanceOrderByWithRelationInput = {
  activities?: InputMaybe<ActivityOrderByRelationAggregateInput>;
  communityClub?: InputMaybe<CommunityClubOrderByWithRelationInput>;
  communityClubId?: InputMaybe<SortOrder>;
  communityEvent?: InputMaybe<CommunityEventOrderByWithRelationInput>;
  communityEventBookings?: InputMaybe<CommunityEventBookingOrderByRelationAggregateInput>;
  deletedAt?: InputMaybe<SortOrderInput>;
  endAt?: InputMaybe<SortOrderInput>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastMetInCommunityMemberRelations?: InputMaybe<CommunityMemberRelationOrderByRelationAggregateInput>;
  relationsProcessedAt?: InputMaybe<SortOrderInput>;
  sharedInMessages?: InputMaybe<MessageOrderByRelationAggregateInput>;
  startAt?: InputMaybe<SortOrder>;
  workouts?: InputMaybe<WorkoutOrderByRelationAggregateInput>;
};

export enum CommunityEventInstanceScalarFieldEnum {
  CommunityClubId = 'communityClubId',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  EndAt = 'endAt',
  EventId = 'eventId',
  Id = 'id',
  RelationsProcessedAt = 'relationsProcessedAt',
  StartAt = 'startAt',
  UpdatedAt = 'updatedAt'
}

export type CommunityEventInstanceScalarRelationFilter = {
  is?: InputMaybe<CommunityEventInstanceWhereInput>;
  isNot?: InputMaybe<CommunityEventInstanceWhereInput>;
};

export type CommunityEventInstanceUpdateInput = {
  activities?: InputMaybe<ActivityUpdateManyWithoutCommunityEventInstanceNestedInput>;
  communityClub?: InputMaybe<CommunityClubUpdateOneRequiredWithoutCommunityEventInstancesNestedInput>;
  communityEvent?: InputMaybe<CommunityEventUpdateOneRequiredWithoutCommunityEventInstancesNestedInput>;
  communityEventBookings?: InputMaybe<CommunityEventBookingUpdateManyWithoutCommunityEventInstanceNestedInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  lastMetInCommunityMemberRelations?: InputMaybe<CommunityMemberRelationUpdateManyWithoutLastMetInstanceNestedInput>;
  relationsProcessedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sharedInMessages?: InputMaybe<MessageUpdateManyWithoutSharedCommunityEventInstanceNestedInput>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  workouts?: InputMaybe<WorkoutUpdateManyWithoutCommunityEventInstanceNestedInput>;
};

export type CommunityEventInstanceUpdateManyWithoutCommunityClubNestedInput = {
  connect?: InputMaybe<Array<CommunityEventInstanceWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CommunityEventInstanceWhereUniqueInput>>;
};

export type CommunityEventInstanceUpdateManyWithoutCommunityEventNestedInput = {
  connect?: InputMaybe<Array<CommunityEventInstanceWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CommunityEventInstanceWhereUniqueInput>>;
};

export type CommunityEventInstanceUpdateOneRequiredWithoutCommunityEventBookingsNestedInput = {
  connect?: InputMaybe<CommunityEventInstanceWhereUniqueInput>;
};

export type CommunityEventInstanceWhereInput = {
  AND?: InputMaybe<Array<CommunityEventInstanceWhereInput>>;
  NOT?: InputMaybe<Array<CommunityEventInstanceWhereInput>>;
  OR?: InputMaybe<Array<CommunityEventInstanceWhereInput>>;
  activities?: InputMaybe<ActivityListRelationFilter>;
  communityClub?: InputMaybe<CommunityClubScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidFilter>;
  communityEvent?: InputMaybe<CommunityEventScalarRelationFilter>;
  communityEventBookings?: InputMaybe<CommunityEventBookingListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  endAt?: InputMaybe<DateTimeNullableFilter>;
  eventId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  lastMetInCommunityMemberRelations?: InputMaybe<CommunityMemberRelationListRelationFilter>;
  relationsProcessedAt?: InputMaybe<DateTimeNullableFilter>;
  sharedInMessages?: InputMaybe<MessageListRelationFilter>;
  startAt?: InputMaybe<DateTimeFilter>;
  workouts?: InputMaybe<WorkoutListRelationFilter>;
};

export type CommunityEventInstanceWhereUniqueInput = {
  AND?: InputMaybe<Array<CommunityEventInstanceWhereInput>>;
  NOT?: InputMaybe<Array<CommunityEventInstanceWhereInput>>;
  OR?: InputMaybe<Array<CommunityEventInstanceWhereInput>>;
  activities?: InputMaybe<ActivityListRelationFilter>;
  communityClub?: InputMaybe<CommunityClubScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidFilter>;
  communityEvent?: InputMaybe<CommunityEventScalarRelationFilter>;
  communityEventBookings?: InputMaybe<CommunityEventBookingListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  endAt?: InputMaybe<DateTimeNullableFilter>;
  eventId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  lastMetInCommunityMemberRelations?: InputMaybe<CommunityMemberRelationListRelationFilter>;
  relationsProcessedAt?: InputMaybe<DateTimeNullableFilter>;
  sharedInMessages?: InputMaybe<MessageListRelationFilter>;
  startAt?: InputMaybe<DateTimeFilter>;
  workouts?: InputMaybe<WorkoutListRelationFilter>;
};

export type CommunityEventListRelationFilter = {
  every?: InputMaybe<CommunityEventWhereInput>;
  none?: InputMaybe<CommunityEventWhereInput>;
  some?: InputMaybe<CommunityEventWhereInput>;
};

export type CommunityEventLocation = {
  __typename: 'CommunityEventLocation';
  communityClub: CommunityClub;
  communityEvents?: Maybe<Array<CommunityEvent>>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The house number of the event location. */
  houseNumber: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  /** The latitude coordinate of the event location. */
  latitude: Scalars['String']['output'];
  /** The longitude coordinate of the event location. */
  longitude: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** The city or town where the event is located. */
  place: Scalars['String']['output'];
  /** The street name of the event location. */
  street: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** The postal code of the event location. */
  zipcode: Scalars['String']['output'];
};


export type CommunityEventLocationCommunityEventsArgs = {
  cursor?: InputMaybe<CommunityEventWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityEventScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityEventOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityEventWhereInput>;
};

export type CommunityEventLocationCountAggregate = {
  __typename: 'CommunityEventLocationCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  houseNumber: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  latitude: Scalars['Int']['output'];
  longitude: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  place: Scalars['Int']['output'];
  street: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  zipcode: Scalars['Int']['output'];
};

export type CommunityEventLocationCreateInput = {
  communityClub: CommunityClubCreateNestedOneWithoutCommunityLocationsInput;
  communityEvents?: InputMaybe<CommunityEventCreateNestedManyWithoutCommunityEventLocationInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  houseNumber: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  latitude: Scalars['String']['input'];
  longitude: Scalars['String']['input'];
  name: Scalars['String']['input'];
  place: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type CommunityEventLocationCreateNestedManyWithoutCommunityClubInput = {
  connect?: InputMaybe<Array<CommunityEventLocationWhereUniqueInput>>;
};

export type CommunityEventLocationCreateNestedOneWithoutCommunityEventsInput = {
  connect?: InputMaybe<CommunityEventLocationWhereUniqueInput>;
};

export type CommunityEventLocationListRelationFilter = {
  every?: InputMaybe<CommunityEventLocationWhereInput>;
  none?: InputMaybe<CommunityEventLocationWhereInput>;
  some?: InputMaybe<CommunityEventLocationWhereInput>;
};

export type CommunityEventLocationMaxAggregate = {
  __typename: 'CommunityEventLocationMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  place?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type CommunityEventLocationMinAggregate = {
  __typename: 'CommunityEventLocationMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  place?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type CommunityEventLocationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CommunityEventLocationOrderByWithRelationInput = {
  communityClub?: InputMaybe<CommunityClubOrderByWithRelationInput>;
  communityClubId?: InputMaybe<SortOrder>;
  communityEvents?: InputMaybe<CommunityEventOrderByRelationAggregateInput>;
  deletedAt?: InputMaybe<SortOrderInput>;
  houseNumber?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  latitude?: InputMaybe<SortOrder>;
  longitude?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  place?: InputMaybe<SortOrder>;
  street?: InputMaybe<SortOrder>;
  zipcode?: InputMaybe<SortOrder>;
};

export enum CommunityEventLocationScalarFieldEnum {
  CommunityClubId = 'communityClubId',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  HouseNumber = 'houseNumber',
  Id = 'id',
  Latitude = 'latitude',
  Longitude = 'longitude',
  Name = 'name',
  Place = 'place',
  Street = 'street',
  UpdatedAt = 'updatedAt',
  Zipcode = 'zipcode'
}

export type CommunityEventLocationScalarRelationFilter = {
  is?: InputMaybe<CommunityEventLocationWhereInput>;
  isNot?: InputMaybe<CommunityEventLocationWhereInput>;
};

export type CommunityEventLocationUpdateInput = {
  communityClub?: InputMaybe<CommunityClubUpdateOneRequiredWithoutCommunityLocationsNestedInput>;
  communityEvents?: InputMaybe<CommunityEventUpdateManyWithoutCommunityEventLocationNestedInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type CommunityEventLocationUpdateManyWithoutCommunityClubNestedInput = {
  connect?: InputMaybe<Array<CommunityEventLocationWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CommunityEventLocationWhereUniqueInput>>;
};

export type CommunityEventLocationUpdateOneRequiredWithoutCommunityEventsNestedInput = {
  connect?: InputMaybe<CommunityEventLocationWhereUniqueInput>;
};

export type CommunityEventLocationWhereInput = {
  AND?: InputMaybe<Array<CommunityEventLocationWhereInput>>;
  NOT?: InputMaybe<Array<CommunityEventLocationWhereInput>>;
  OR?: InputMaybe<Array<CommunityEventLocationWhereInput>>;
  communityClub?: InputMaybe<CommunityClubScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidFilter>;
  communityEvents?: InputMaybe<CommunityEventListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  houseNumber?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  latitude?: InputMaybe<StringFilter>;
  longitude?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  place?: InputMaybe<StringFilter>;
  street?: InputMaybe<StringFilter>;
  zipcode?: InputMaybe<StringFilter>;
};

export type CommunityEventLocationWhereUniqueInput = {
  AND?: InputMaybe<Array<CommunityEventLocationWhereInput>>;
  NOT?: InputMaybe<Array<CommunityEventLocationWhereInput>>;
  OR?: InputMaybe<Array<CommunityEventLocationWhereInput>>;
  communityClub?: InputMaybe<CommunityClubScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidFilter>;
  communityEvents?: InputMaybe<CommunityEventListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  houseNumber?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  latitude?: InputMaybe<StringFilter>;
  longitude?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  place?: InputMaybe<StringFilter>;
  street?: InputMaybe<StringFilter>;
  zipcode?: InputMaybe<StringFilter>;
};

export type CommunityEventMaxAggregate = {
  __typename: 'CommunityEventMaxAggregate';
  advanceGenerationDays?: Maybe<Scalars['Int']['output']>;
  communityEventCategoryId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  durationMin?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  isLimited?: Maybe<Scalars['Boolean']['output']>;
  isPaid?: Maybe<Scalars['Boolean']['output']>;
  maxParticipants?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  recurrenceCount?: Maybe<Scalars['Int']['output']>;
  recurrenceEndType?: Maybe<RecurrenceEndType>;
  recurrenceFreq?: Maybe<RecurrenceFrequency>;
  recurrenceInterval?: Maybe<Scalars['Int']['output']>;
  recurrenceMonthOption?: Maybe<RecurrenceMonthOption>;
  recurrenceStartDate?: Maybe<Scalars['DateTime']['output']>;
  recurrenceUntil?: Maybe<Scalars['DateTime']['output']>;
  s3HeaderImageKey?: Maybe<Scalars['String']['output']>;
  s3HeaderImageUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityEventMinAggregate = {
  __typename: 'CommunityEventMinAggregate';
  advanceGenerationDays?: Maybe<Scalars['Int']['output']>;
  communityEventCategoryId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  durationMin?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  isLimited?: Maybe<Scalars['Boolean']['output']>;
  isPaid?: Maybe<Scalars['Boolean']['output']>;
  maxParticipants?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  recurrenceCount?: Maybe<Scalars['Int']['output']>;
  recurrenceEndType?: Maybe<RecurrenceEndType>;
  recurrenceFreq?: Maybe<RecurrenceFrequency>;
  recurrenceInterval?: Maybe<Scalars['Int']['output']>;
  recurrenceMonthOption?: Maybe<RecurrenceMonthOption>;
  recurrenceStartDate?: Maybe<Scalars['DateTime']['output']>;
  recurrenceUntil?: Maybe<Scalars['DateTime']['output']>;
  s3HeaderImageKey?: Maybe<Scalars['String']['output']>;
  s3HeaderImageUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityEventNullableScalarRelationFilter = {
  is?: InputMaybe<CommunityEventWhereInput>;
  isNot?: InputMaybe<CommunityEventWhereInput>;
};

export type CommunityEventOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CommunityEventOrderByWithRelationInput = {
  advanceGenerationDays?: InputMaybe<SortOrder>;
  communityClub?: InputMaybe<CommunityClubOrderByWithRelationInput>;
  communityClubId?: InputMaybe<SortOrder>;
  communityEventCategory?: InputMaybe<CommunityEventCategoryOrderByWithRelationInput>;
  communityEventCategoryId?: InputMaybe<SortOrderInput>;
  communityEventImages?: InputMaybe<CommunityEventImageOrderByRelationAggregateInput>;
  communityEventInstances?: InputMaybe<CommunityEventInstanceOrderByRelationAggregateInput>;
  communityEventLocation?: InputMaybe<CommunityEventLocationOrderByWithRelationInput>;
  communityEventPartner?: InputMaybe<CommunityEventPartnerOrderByWithRelationInput>;
  deletedAt?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrderInput>;
  durationMin?: InputMaybe<SortOrderInput>;
  hostProfile?: InputMaybe<ProfileOrderByWithRelationInput>;
  hostProfileId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  isDraft?: InputMaybe<SortOrder>;
  isLimited?: InputMaybe<SortOrder>;
  isPaid?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  maxParticipants?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  partnerId?: InputMaybe<SortOrderInput>;
  recurrenceByweekday?: InputMaybe<SortOrder>;
  recurrenceCount?: InputMaybe<SortOrderInput>;
  recurrenceEndType?: InputMaybe<SortOrderInput>;
  recurrenceFreq?: InputMaybe<SortOrderInput>;
  recurrenceInterval?: InputMaybe<SortOrderInput>;
  recurrenceMonthOption?: InputMaybe<SortOrderInput>;
  recurrenceStartDate?: InputMaybe<SortOrderInput>;
  recurrenceUntil?: InputMaybe<SortOrderInput>;
  s3HeaderImageKey?: InputMaybe<SortOrderInput>;
  s3HeaderImageUrl?: InputMaybe<SortOrderInput>;
  sharedInMessages?: InputMaybe<MessageOrderByRelationAggregateInput>;
};

export type CommunityEventPartner = {
  __typename: 'CommunityEventPartner';
  communityEvents?: Maybe<Array<CommunityEvent>>;
  company: Company;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The house number of the event partner location. */
  houseNumber: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  /** The latitude coordinate of the event partner location. */
  latitude: Scalars['String']['output'];
  /** The longitude coordinate of the event partner location. */
  longitude: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** The city or town where the event partner is located. */
  place: Scalars['String']['output'];
  s3LogoKey?: Maybe<Scalars['String']['output']>;
  s3LogoUrl?: Maybe<Scalars['String']['output']>;
  /** The street name of the event partner location. */
  street: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** The postal code of the community club's event partner. */
  zipcode: Scalars['String']['output'];
};


export type CommunityEventPartnerCommunityEventsArgs = {
  cursor?: InputMaybe<CommunityEventWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityEventScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityEventOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityEventWhereInput>;
};

export type CommunityEventPartnerCountAggregate = {
  __typename: 'CommunityEventPartnerCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  houseNumber: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  latitude: Scalars['Int']['output'];
  longitude: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  place: Scalars['Int']['output'];
  s3LogoKey: Scalars['Int']['output'];
  s3LogoUrl: Scalars['Int']['output'];
  street: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  zipcode: Scalars['Int']['output'];
};

export type CommunityEventPartnerCreateInput = {
  communityEvents?: InputMaybe<CommunityEventCreateNestedManyWithoutCommunityEventPartnerInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  houseNumber: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  latitude: Scalars['String']['input'];
  logoImage?: InputMaybe<ImageInput>;
  longitude: Scalars['String']['input'];
  name: Scalars['String']['input'];
  place: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type CommunityEventPartnerCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<CommunityEventPartnerWhereUniqueInput>>;
};

export type CommunityEventPartnerCreateNestedOneWithoutCommunityEventsInput = {
  connect?: InputMaybe<CommunityEventPartnerWhereUniqueInput>;
};

export type CommunityEventPartnerListRelationFilter = {
  every?: InputMaybe<CommunityEventPartnerWhereInput>;
  none?: InputMaybe<CommunityEventPartnerWhereInput>;
  some?: InputMaybe<CommunityEventPartnerWhereInput>;
};

export type CommunityEventPartnerMaxAggregate = {
  __typename: 'CommunityEventPartnerMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  place?: Maybe<Scalars['String']['output']>;
  s3LogoKey?: Maybe<Scalars['String']['output']>;
  s3LogoUrl?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type CommunityEventPartnerMinAggregate = {
  __typename: 'CommunityEventPartnerMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  place?: Maybe<Scalars['String']['output']>;
  s3LogoKey?: Maybe<Scalars['String']['output']>;
  s3LogoUrl?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type CommunityEventPartnerNullableScalarRelationFilter = {
  is?: InputMaybe<CommunityEventPartnerWhereInput>;
  isNot?: InputMaybe<CommunityEventPartnerWhereInput>;
};

export type CommunityEventPartnerOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CommunityEventPartnerOrderByWithRelationInput = {
  communityEvents?: InputMaybe<CommunityEventOrderByRelationAggregateInput>;
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  companyId?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrderInput>;
  houseNumber?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  latitude?: InputMaybe<SortOrder>;
  longitude?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  place?: InputMaybe<SortOrder>;
  s3LogoKey?: InputMaybe<SortOrderInput>;
  s3LogoUrl?: InputMaybe<SortOrderInput>;
  street?: InputMaybe<SortOrder>;
  zipcode?: InputMaybe<SortOrder>;
};

export enum CommunityEventPartnerScalarFieldEnum {
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Description = 'description',
  HouseNumber = 'houseNumber',
  Id = 'id',
  Latitude = 'latitude',
  Longitude = 'longitude',
  Name = 'name',
  Place = 'place',
  S3LogoKey = 's3LogoKey',
  S3LogoUrl = 's3LogoUrl',
  Street = 'street',
  UpdatedAt = 'updatedAt',
  Zipcode = 'zipcode'
}

export type CommunityEventPartnerUpdateInput = {
  communityEvents?: InputMaybe<CommunityEventUpdateManyWithoutCommunityEventPartnerNestedInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  logoImage?: InputMaybe<ImageInput>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type CommunityEventPartnerUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<CommunityEventPartnerWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CommunityEventPartnerWhereUniqueInput>>;
};

export type CommunityEventPartnerUpdateOneWithoutCommunityEventsNestedInput = {
  connect?: InputMaybe<CommunityEventPartnerWhereUniqueInput>;
  disconnect?: InputMaybe<CommunityEventPartnerWhereInput>;
};

export type CommunityEventPartnerWhereInput = {
  AND?: InputMaybe<Array<CommunityEventPartnerWhereInput>>;
  NOT?: InputMaybe<Array<CommunityEventPartnerWhereInput>>;
  OR?: InputMaybe<Array<CommunityEventPartnerWhereInput>>;
  communityEvents?: InputMaybe<CommunityEventListRelationFilter>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  houseNumber?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  latitude?: InputMaybe<StringFilter>;
  longitude?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  place?: InputMaybe<StringFilter>;
  s3LogoKey?: InputMaybe<StringNullableFilter>;
  s3LogoUrl?: InputMaybe<StringNullableFilter>;
  street?: InputMaybe<StringFilter>;
  zipcode?: InputMaybe<StringFilter>;
};

export type CommunityEventPartnerWhereUniqueInput = {
  AND?: InputMaybe<Array<CommunityEventPartnerWhereInput>>;
  NOT?: InputMaybe<Array<CommunityEventPartnerWhereInput>>;
  OR?: InputMaybe<Array<CommunityEventPartnerWhereInput>>;
  communityEvents?: InputMaybe<CommunityEventListRelationFilter>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  houseNumber?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  latitude?: InputMaybe<StringFilter>;
  longitude?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  place?: InputMaybe<StringFilter>;
  s3LogoKey?: InputMaybe<StringNullableFilter>;
  s3LogoUrl?: InputMaybe<StringNullableFilter>;
  street?: InputMaybe<StringFilter>;
  zipcode?: InputMaybe<StringFilter>;
};

/**
 * A price tier of a ticket sale. Tiers form one sequential pool: tier k can sell up to the sum of
 * the quotas of tiers 1..k, so unsold tickets of a tier that ended by time carry over to the next.
 */
export type CommunityEventPriceTier = {
  __typename: 'CommunityEventPriceTier';
  /**
   * Set when a tier other than the last sells out, and never cleared, so neither a refund nor a
   * quota increase reopens a cheaper tier. The last tier is never closed; sold out is computed.
   */
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** Display label, e.g. "Early Bird", "Regular". */
  name: Scalars['String']['output'];
  priceInCents: Scalars['Int']['output'];
  /** Number of tickets in this tier. */
  quota: Scalars['Int']['output'];
  /** Ascending evaluation order; the first tier that is neither closed nor past validUntil is active. */
  sortOrder: Scalars['Int']['output'];
  ticketSale: CommunityEventTicketSale;
  updatedAt: Scalars['DateTime']['output'];
  /** Optional end of this tier. Never set on the last tier: it ends with the sale (instance endAt). */
  validUntil?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityEventPriceTierAvgAggregate = {
  __typename: 'CommunityEventPriceTierAvgAggregate';
  priceInCents?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Float']['output']>;
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

export type CommunityEventPriceTierCountAggregate = {
  __typename: 'CommunityEventPriceTierCountAggregate';
  _all: Scalars['Int']['output'];
  closedAt: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  priceInCents: Scalars['Int']['output'];
  quota: Scalars['Int']['output'];
  sortOrder: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  validUntil: Scalars['Int']['output'];
};

/** A price tier of a community event ticket sale. */
export type CommunityEventPriceTierInput = {
  /** Display name of the tier, e.g. "Early Bird"; at most 255 characters. */
  name: Scalars['String']['input'];
  /** Gross ticket price in cents, at least 50. */
  priceInCents: Scalars['Int']['input'];
  /** Number of tickets of this tier, at least 1. */
  quota: Scalars['Int']['input'];
  /** End of the tier's sales. Must be omitted for the last tier; ascending across tiers. */
  validUntil?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommunityEventPriceTierListRelationFilter = {
  every?: InputMaybe<CommunityEventPriceTierWhereInput>;
  none?: InputMaybe<CommunityEventPriceTierWhereInput>;
  some?: InputMaybe<CommunityEventPriceTierWhereInput>;
};

export type CommunityEventPriceTierMaxAggregate = {
  __typename: 'CommunityEventPriceTierMaxAggregate';
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priceInCents?: Maybe<Scalars['Int']['output']>;
  quota?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  validUntil?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityEventPriceTierMinAggregate = {
  __typename: 'CommunityEventPriceTierMinAggregate';
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priceInCents?: Maybe<Scalars['Int']['output']>;
  quota?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  validUntil?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityEventPriceTierNullableScalarRelationFilter = {
  is?: InputMaybe<CommunityEventPriceTierWhereInput>;
  isNot?: InputMaybe<CommunityEventPriceTierWhereInput>;
};

export type CommunityEventPriceTierOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CommunityEventPriceTierOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  priceInCents?: InputMaybe<SortOrder>;
  purchaseGrants?: InputMaybe<CommunityEventTicketPurchaseGrantOrderByRelationAggregateInput>;
  quota?: InputMaybe<SortOrder>;
  reservations?: InputMaybe<CommunityEventTicketReservationOrderByRelationAggregateInput>;
  sortOrder?: InputMaybe<SortOrder>;
  ticketSale?: InputMaybe<CommunityEventTicketSaleOrderByWithRelationInput>;
  ticketSaleId?: InputMaybe<SortOrder>;
  tickets?: InputMaybe<CommunityEventTicketOrderByRelationAggregateInput>;
  validUntil?: InputMaybe<SortOrderInput>;
};

export type CommunityEventPriceTierScalarRelationFilter = {
  is?: InputMaybe<CommunityEventPriceTierWhereInput>;
  isNot?: InputMaybe<CommunityEventPriceTierWhereInput>;
};

export type CommunityEventPriceTierSumAggregate = {
  __typename: 'CommunityEventPriceTierSumAggregate';
  priceInCents?: Maybe<Scalars['Int']['output']>;
  quota?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

export type CommunityEventPriceTierWhereInput = {
  AND?: InputMaybe<Array<CommunityEventPriceTierWhereInput>>;
  NOT?: InputMaybe<Array<CommunityEventPriceTierWhereInput>>;
  OR?: InputMaybe<Array<CommunityEventPriceTierWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  priceInCents?: InputMaybe<IntFilter>;
  purchaseGrants?: InputMaybe<CommunityEventTicketPurchaseGrantListRelationFilter>;
  quota?: InputMaybe<IntFilter>;
  reservations?: InputMaybe<CommunityEventTicketReservationListRelationFilter>;
  sortOrder?: InputMaybe<IntFilter>;
  ticketSale?: InputMaybe<CommunityEventTicketSaleScalarRelationFilter>;
  ticketSaleId?: InputMaybe<UuidFilter>;
  tickets?: InputMaybe<CommunityEventTicketListRelationFilter>;
  validUntil?: InputMaybe<DateTimeNullableFilter>;
};

export enum CommunityEventScalarFieldEnum {
  AdvanceGenerationDays = 'advanceGenerationDays',
  CommunityClubId = 'communityClubId',
  CommunityEventCategoryId = 'communityEventCategoryId',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Description = 'description',
  DurationMin = 'durationMin',
  HostProfileId = 'hostProfileId',
  Id = 'id',
  IsActive = 'isActive',
  IsDraft = 'isDraft',
  IsLimited = 'isLimited',
  IsPaid = 'isPaid',
  LocationId = 'locationId',
  MaxParticipants = 'maxParticipants',
  Name = 'name',
  PartnerId = 'partnerId',
  RecurrenceByweekday = 'recurrenceByweekday',
  RecurrenceCount = 'recurrenceCount',
  RecurrenceEndType = 'recurrenceEndType',
  RecurrenceFreq = 'recurrenceFreq',
  RecurrenceInterval = 'recurrenceInterval',
  RecurrenceMonthOption = 'recurrenceMonthOption',
  RecurrenceStartDate = 'recurrenceStartDate',
  RecurrenceUntil = 'recurrenceUntil',
  S3HeaderImageKey = 's3HeaderImageKey',
  S3HeaderImageUrl = 's3HeaderImageUrl',
  UpdatedAt = 'updatedAt'
}

export type CommunityEventScalarRelationFilter = {
  is?: InputMaybe<CommunityEventWhereInput>;
  isNot?: InputMaybe<CommunityEventWhereInput>;
};

export type CommunityEventSumAggregate = {
  __typename: 'CommunityEventSumAggregate';
  advanceGenerationDays?: Maybe<Scalars['Int']['output']>;
  durationMin?: Maybe<Scalars['Int']['output']>;
  maxParticipants?: Maybe<Scalars['Int']['output']>;
  recurrenceByweekday?: Maybe<Array<Scalars['Int']['output']>>;
  recurrenceCount?: Maybe<Scalars['Int']['output']>;
  recurrenceInterval?: Maybe<Scalars['Int']['output']>;
};

/** A ticket: bought (created from a reservation when the payment completes) or issued free by a host. */
export type CommunityEventTicket = {
  __typename: 'CommunityEventTicket';
  /** Until when the holder may cancel this ticket after its event was moved (the new start); null if it can't be cancelled. The app shows the cancel button exactly while this is set. */
  cancellableUntil?: Maybe<Scalars['DateTime']['output']>;
  /** The ticket's invoice for its holder: number, link to the invoice and, after a refund, when it was cancelled. Null for a free ticket, before the invoice is issued, or for anyone but the holder. */
  consumerBilling?: Maybe<ConsumerBilling>;
  createdAt: Scalars['DateTime']['output'];
  /** The buyer, for the hosts' sales overview. Null once the customer was deleted, or if the host cannot see them anymore (e.g. after they left the club). */
  customer?: Maybe<Customer>;
  /** What the ticket shows: event, date, club, location and tier. Readable for the holder even after leaving the company. */
  details: CommunityEventTicketDetails;
  id: Scalars['UUID']['output'];
  /** When the ticket came into existence (for a purchase: the payment completion). */
  issuedAt: Scalars['DateTime']['output'];
  /** Copied from the reservation's price snapshot; 0 for a free ticket. */
  priceInCents: Scalars['Int']['output'];
  priceTier?: Maybe<CommunityEventPriceTier>;
  /** The QR code's text for the entrance, for the holder only: set while the ticket is ACTIVE or USED and not being refunded, null otherwise. Static, so it also works printed or as a screenshot; the first scan wins. */
  qrCode?: Maybe<Scalars['String']['output']>;
  /** Set first, atomically, when a refund is requested; the ticket is invalid for scanning from then. */
  refundRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  refundedAt?: Maybe<Scalars['DateTime']['output']>;
  source: CommunityEventTicketSource;
  status: CommunityEventTicketStatus;
  ticketSale?: Maybe<CommunityEventTicketSale>;
  updatedAt: Scalars['DateTime']['output'];
  usedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityEventTicketAvgAggregate = {
  __typename: 'CommunityEventTicketAvgAggregate';
  priceInCents?: Maybe<Scalars['Float']['output']>;
};

/** Result of a community event ticket booking attempt */
export enum CommunityEventTicketBookingOutcome {
  Canceled = 'CANCELED',
  NotOnSaleYet = 'NOT_ON_SALE_YET',
  Queued = 'QUEUED',
  Reserved = 'RESERVED',
  SalesEnded = 'SALES_ENDED',
  SoldOut = 'SOLD_OUT'
}

/** Result of a ticket booking attempt: a reservation, a queue entry, or why neither. Never a ticket; a ticket only exists after payment. */
export type CommunityEventTicketBookingResult = {
  __typename: 'CommunityEventTicketBookingResult';
  /** The checkout URL to pay the reservation; set with RESERVED. The same on a repeated booking. */
  checkoutUrl?: Maybe<Scalars['String']['output']>;
  outcome: CommunityEventTicketBookingOutcome;
  /** True if the reserved tier differs from the tier the app displayed (expectedPriceTierId). */
  priceTierChanged: Scalars['Boolean']['output'];
  /** The queue entry; set with QUEUED. */
  queueEntry?: Maybe<CommunityEventTicketQueueEntry>;
  /** 1-based queue position at booking time; set with QUEUED. */
  queuePosition?: Maybe<Scalars['Int']['output']>;
  /** The held reservation; set with RESERVED. */
  reservation?: Maybe<CommunityEventTicketReservation>;
  /** Start of advance sales; set with NOT_ON_SALE_YET. */
  salesStartAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityEventTicketCountAggregate = {
  __typename: 'CommunityEventTicketCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  issuedAt: Scalars['Int']['output'];
  priceInCents: Scalars['Int']['output'];
  refundRequestedAt: Scalars['Int']['output'];
  refundedAt: Scalars['Int']['output'];
  source: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  usedAt: Scalars['Int']['output'];
};

/** What a ticket shows: event, date, club, location and tier. Readable for the holder even after leaving the company. */
export type CommunityEventTicketDetails = {
  __typename: 'CommunityEventTicketDetails';
  communityClubName: Scalars['String']['output'];
  endAt?: Maybe<Scalars['DateTime']['output']>;
  /** URL of the event's header image. */
  eventHeaderImageUrl?: Maybe<Scalars['String']['output']>;
  eventName: Scalars['String']['output'];
  locationHouseNumber: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  locationPlace: Scalars['String']['output'];
  locationStreet: Scalars['String']['output'];
  locationZipcode: Scalars['String']['output'];
  /** Name of the price tier; null for free tickets. */
  priceTierName?: Maybe<Scalars['String']['output']>;
  /** Start of the instance the ticket is for. */
  startAt: Scalars['DateTime']['output'];
};

export type CommunityEventTicketEdge = {
  __typename: 'CommunityEventTicketEdge';
  cursor: PaginatedCommunityEventTicketCursor;
  node: CommunityEventTicket;
};

export type CommunityEventTicketListRelationFilter = {
  every?: InputMaybe<CommunityEventTicketWhereInput>;
  none?: InputMaybe<CommunityEventTicketWhereInput>;
  some?: InputMaybe<CommunityEventTicketWhereInput>;
};

export type CommunityEventTicketMaxAggregate = {
  __typename: 'CommunityEventTicketMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  priceInCents?: Maybe<Scalars['Int']['output']>;
  refundRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  refundedAt?: Maybe<Scalars['DateTime']['output']>;
  source?: Maybe<CommunityEventTicketSource>;
  status?: Maybe<CommunityEventTicketStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  usedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityEventTicketMinAggregate = {
  __typename: 'CommunityEventTicketMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  priceInCents?: Maybe<Scalars['Int']['output']>;
  refundRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  refundedAt?: Maybe<Scalars['DateTime']['output']>;
  source?: Maybe<CommunityEventTicketSource>;
  status?: Maybe<CommunityEventTicketStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  usedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityEventTicketNullableScalarRelationFilter = {
  is?: InputMaybe<CommunityEventTicketWhereInput>;
  isNot?: InputMaybe<CommunityEventTicketWhereInput>;
};

export type CommunityEventTicketOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CommunityEventTicketOrderByWithRelationInput = {
  booking?: InputMaybe<CommunityEventBookingOrderByWithRelationInput>;
  bookingId?: InputMaybe<SortOrderInput>;
  consumerBilling?: InputMaybe<ConsumerBillingOrderByWithRelationInput>;
  consumerBillingId?: InputMaybe<SortOrderInput>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrderInput>;
  disputeClosedAt?: InputMaybe<SortOrderInput>;
  disputeFeeInCents?: InputMaybe<SortOrderInput>;
  disputedAt?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  issuedAt?: InputMaybe<SortOrder>;
  priceInCents?: InputMaybe<SortOrder>;
  priceTier?: InputMaybe<CommunityEventPriceTierOrderByWithRelationInput>;
  priceTierId?: InputMaybe<SortOrderInput>;
  refundFeeBilling?: InputMaybe<CompanyBillingOrderByWithRelationInput>;
  refundFeeBillingId?: InputMaybe<SortOrderInput>;
  refundRequestedAt?: InputMaybe<SortOrderInput>;
  refundRequestedByEmployeeId?: InputMaybe<SortOrderInput>;
  refundedAt?: InputMaybe<SortOrderInput>;
  reservation?: InputMaybe<CommunityEventTicketReservationOrderByWithRelationInput>;
  reservationId?: InputMaybe<SortOrderInput>;
  scannedByEmployeeId?: InputMaybe<SortOrderInput>;
  source?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  statusBeforeDispute?: InputMaybe<SortOrderInput>;
  stripeDisputeId?: InputMaybe<SortOrderInput>;
  stripeFeeInCents?: InputMaybe<SortOrderInput>;
  stripePaymentIntentId?: InputMaybe<SortOrderInput>;
  stripeRefundId?: InputMaybe<SortOrderInput>;
  stripeTransferReversalId?: InputMaybe<SortOrderInput>;
  ticketEmailSentAt?: InputMaybe<SortOrderInput>;
  ticketSale?: InputMaybe<CommunityEventTicketSaleOrderByWithRelationInput>;
  ticketSaleId?: InputMaybe<SortOrder>;
  ticketVersion?: InputMaybe<SortOrder>;
  usedAt?: InputMaybe<SortOrderInput>;
};

/**
 * The right of one club member, granted by a host, to buy one ticket despite sold out or a queue.
 * Not a ticket itself.
 */
export type CommunityEventTicketPurchaseGrant = {
  __typename: 'CommunityEventTicketPurchaseGrant';
  createdAt: Scalars['DateTime']['output'];
  /** The member who may buy. Null once the customer was deleted, or if the host cannot see them anymore (e.g. after they left the club). */
  customer?: Maybe<Customer>;
  id: Scalars['UUID']['output'];
  /** The tier whose price the member pays. */
  priceTier: CommunityEventPriceTier;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** Set when the ticket bought through this grant was created; the grant is spent. */
  usedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Optional end of the grant; otherwise it is valid until sales end. */
  validUntil?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityEventTicketPurchaseGrantCountAggregate = {
  __typename: 'CommunityEventTicketPurchaseGrantCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  revokedAt: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  usedAt: Scalars['Int']['output'];
  validUntil: Scalars['Int']['output'];
};

export type CommunityEventTicketPurchaseGrantListRelationFilter = {
  every?: InputMaybe<CommunityEventTicketPurchaseGrantWhereInput>;
  none?: InputMaybe<CommunityEventTicketPurchaseGrantWhereInput>;
  some?: InputMaybe<CommunityEventTicketPurchaseGrantWhereInput>;
};

export type CommunityEventTicketPurchaseGrantMaxAggregate = {
  __typename: 'CommunityEventTicketPurchaseGrantMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  usedAt?: Maybe<Scalars['DateTime']['output']>;
  validUntil?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityEventTicketPurchaseGrantMinAggregate = {
  __typename: 'CommunityEventTicketPurchaseGrantMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  usedAt?: Maybe<Scalars['DateTime']['output']>;
  validUntil?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityEventTicketPurchaseGrantNullableScalarRelationFilter = {
  is?: InputMaybe<CommunityEventTicketPurchaseGrantWhereInput>;
  isNot?: InputMaybe<CommunityEventTicketPurchaseGrantWhereInput>;
};

export type CommunityEventTicketPurchaseGrantOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CommunityEventTicketPurchaseGrantOrderByWithRelationInput = {
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrderInput>;
  grantedByEmployeeId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  priceTier?: InputMaybe<CommunityEventPriceTierOrderByWithRelationInput>;
  priceTierId?: InputMaybe<SortOrder>;
  reservations?: InputMaybe<CommunityEventTicketReservationOrderByRelationAggregateInput>;
  revokedAt?: InputMaybe<SortOrderInput>;
  ticketSale?: InputMaybe<CommunityEventTicketSaleOrderByWithRelationInput>;
  ticketSaleId?: InputMaybe<SortOrder>;
  usedAt?: InputMaybe<SortOrderInput>;
  validUntil?: InputMaybe<SortOrderInput>;
};

export type CommunityEventTicketPurchaseGrantWhereInput = {
  AND?: InputMaybe<Array<CommunityEventTicketPurchaseGrantWhereInput>>;
  NOT?: InputMaybe<Array<CommunityEventTicketPurchaseGrantWhereInput>>;
  OR?: InputMaybe<Array<CommunityEventTicketPurchaseGrantWhereInput>>;
  customer?: InputMaybe<CustomerNullableScalarRelationFilter>;
  customerId?: InputMaybe<StringNullableFilter>;
  grantedByEmployeeId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  priceTier?: InputMaybe<CommunityEventPriceTierScalarRelationFilter>;
  priceTierId?: InputMaybe<UuidFilter>;
  reservations?: InputMaybe<CommunityEventTicketReservationListRelationFilter>;
  revokedAt?: InputMaybe<DateTimeNullableFilter>;
  ticketSale?: InputMaybe<CommunityEventTicketSaleScalarRelationFilter>;
  ticketSaleId?: InputMaybe<UuidFilter>;
  usedAt?: InputMaybe<DateTimeNullableFilter>;
  validUntil?: InputMaybe<DateTimeNullableFilter>;
};

/**
 * A waiting position in a ticket sale. Ephemeral: deleted on promotion, on leaving, or when sales
 * end. It holds no money and no Stripe data, so deleting it loses nothing.
 */
export type CommunityEventTicketQueueEntry = {
  __typename: 'CommunityEventTicketQueueEntry';
  id: Scalars['UUID']['output'];
  /** Queue order. */
  queuedAt: Scalars['DateTime']['output'];
};

export type CommunityEventTicketQueueEntryCountAggregate = {
  __typename: 'CommunityEventTicketQueueEntryCountAggregate';
  _all: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  queuedAt: Scalars['Int']['output'];
};

export type CommunityEventTicketQueueEntryListRelationFilter = {
  every?: InputMaybe<CommunityEventTicketQueueEntryWhereInput>;
  none?: InputMaybe<CommunityEventTicketQueueEntryWhereInput>;
  some?: InputMaybe<CommunityEventTicketQueueEntryWhereInput>;
};

export type CommunityEventTicketQueueEntryMaxAggregate = {
  __typename: 'CommunityEventTicketQueueEntryMaxAggregate';
  id?: Maybe<Scalars['UUID']['output']>;
  queuedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityEventTicketQueueEntryMinAggregate = {
  __typename: 'CommunityEventTicketQueueEntryMinAggregate';
  id?: Maybe<Scalars['UUID']['output']>;
  queuedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityEventTicketQueueEntryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CommunityEventTicketQueueEntryWhereInput = {
  AND?: InputMaybe<Array<CommunityEventTicketQueueEntryWhereInput>>;
  NOT?: InputMaybe<Array<CommunityEventTicketQueueEntryWhereInput>>;
  OR?: InputMaybe<Array<CommunityEventTicketQueueEntryWhereInput>>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  queuedAt?: InputMaybe<DateTimeFilter>;
  ticketSale?: InputMaybe<CommunityEventTicketSaleScalarRelationFilter>;
  ticketSaleId?: InputMaybe<UuidFilter>;
};

/**
 * The hold of one ticket slot until payment. Kept after it ends: it carries the Checkout Session,
 * the evidence for support cases and disputes.
 */
export type CommunityEventTicketReservation = {
  __typename: 'CommunityEventTicketReservation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** Snapshot of the tier price at reservation time; never re-derived. */
  priceInCents: Scalars['Int']['output'];
  priceTier: CommunityEventPriceTier;
  /**
   * End of the hold: 15 minutes for a direct booking, 5 after moving up from the queue, capped at
   * the instance's endAt.
   */
  reservedUntil: Scalars['DateTime']['output'];
  status: CommunityEventTicketReservationStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type CommunityEventTicketReservationAvgAggregate = {
  __typename: 'CommunityEventTicketReservationAvgAggregate';
  priceInCents?: Maybe<Scalars['Float']['output']>;
};

export type CommunityEventTicketReservationCountAggregate = {
  __typename: 'CommunityEventTicketReservationCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  priceInCents: Scalars['Int']['output'];
  reservedUntil: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CommunityEventTicketReservationListRelationFilter = {
  every?: InputMaybe<CommunityEventTicketReservationWhereInput>;
  none?: InputMaybe<CommunityEventTicketReservationWhereInput>;
  some?: InputMaybe<CommunityEventTicketReservationWhereInput>;
};

export type CommunityEventTicketReservationMaxAggregate = {
  __typename: 'CommunityEventTicketReservationMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  priceInCents?: Maybe<Scalars['Int']['output']>;
  reservedUntil?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<CommunityEventTicketReservationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityEventTicketReservationMinAggregate = {
  __typename: 'CommunityEventTicketReservationMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  priceInCents?: Maybe<Scalars['Int']['output']>;
  reservedUntil?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<CommunityEventTicketReservationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityEventTicketReservationNullableScalarRelationFilter = {
  is?: InputMaybe<CommunityEventTicketReservationWhereInput>;
  isNot?: InputMaybe<CommunityEventTicketReservationWhereInput>;
};

export type CommunityEventTicketReservationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CommunityEventTicketReservationOrderByWithRelationInput = {
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  priceInCents?: InputMaybe<SortOrder>;
  priceTier?: InputMaybe<CommunityEventPriceTierOrderByWithRelationInput>;
  priceTierId?: InputMaybe<SortOrder>;
  purchaseGrant?: InputMaybe<CommunityEventTicketPurchaseGrantOrderByWithRelationInput>;
  purchaseGrantId?: InputMaybe<SortOrderInput>;
  reservedUntil?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  stripeCheckoutParams?: InputMaybe<SortOrderInput>;
  stripeCheckoutSessionId?: InputMaybe<SortOrderInput>;
  ticket?: InputMaybe<CommunityEventTicketOrderByWithRelationInput>;
  ticketSale?: InputMaybe<CommunityEventTicketSaleOrderByWithRelationInput>;
  ticketSaleId?: InputMaybe<SortOrder>;
  transferAmountInCents?: InputMaybe<SortOrder>;
};

/** The state of a ticket reservation (the hold of a slot until payment). */
export enum CommunityEventTicketReservationStatus {
  /** Given up by the customer, or ended by a cancellation, an event deletion or a club departure. */
  Canceled = 'CANCELED',
  /** Paid; the ticket was created from it. */
  Converted = 'CONVERTED',
  /** Timed out unpaid, after Stripe confirmed the session can no longer be paid. */
  Expired = 'EXPIRED',
  /** Held until reservedUntil, payment pending. */
  Held = 'HELD'
}

export type CommunityEventTicketReservationSumAggregate = {
  __typename: 'CommunityEventTicketReservationSumAggregate';
  priceInCents?: Maybe<Scalars['Int']['output']>;
};

export type CommunityEventTicketReservationWhereInput = {
  AND?: InputMaybe<Array<CommunityEventTicketReservationWhereInput>>;
  NOT?: InputMaybe<Array<CommunityEventTicketReservationWhereInput>>;
  OR?: InputMaybe<Array<CommunityEventTicketReservationWhereInput>>;
  customer?: InputMaybe<CustomerNullableScalarRelationFilter>;
  customerId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  priceInCents?: InputMaybe<IntFilter>;
  priceTier?: InputMaybe<CommunityEventPriceTierScalarRelationFilter>;
  priceTierId?: InputMaybe<UuidFilter>;
  purchaseGrant?: InputMaybe<CommunityEventTicketPurchaseGrantNullableScalarRelationFilter>;
  purchaseGrantId?: InputMaybe<UuidNullableFilter>;
  reservedUntil?: InputMaybe<DateTimeFilter>;
  status?: InputMaybe<EnumCommunityEventTicketReservationStatusFilter>;
  stripeCheckoutParams?: InputMaybe<JsonNullableFilter>;
  stripeCheckoutSessionId?: InputMaybe<StringNullableFilter>;
  ticket?: InputMaybe<CommunityEventTicketNullableScalarRelationFilter>;
  ticketSale?: InputMaybe<CommunityEventTicketSaleScalarRelationFilter>;
  ticketSaleId?: InputMaybe<UuidFilter>;
  transferAmountInCents?: InputMaybe<IntFilter>;
};

/**
 * Ticket sales of one instance of a paid community event. Created together with the instance, since
 * paid is decided when the event is created. Its row is also the lock that serializes every ticket
 * allocation of the sale (SELECT ... FOR UPDATE, no write), so ticket traffic never locks the
 * CommunityEventInstance row itself.
 */
export type CommunityEventTicketSale = {
  __typename: 'CommunityEventTicketSale';
  /** The tier a booking would currently be priced at; null while the sale is not open. Cached for a few seconds. */
  activePriceTier?: Maybe<CommunityEventPriceTier>;
  /** Free tickets at the active tier; null while the sale is not open, 0 when all are taken or reserved. Cached for a few seconds. */
  availableTicketCount?: Maybe<Scalars['Int']['output']>;
  /** Cancellation of the instance by the host: closes sales and triggers refunds. */
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  communityClub: CommunityClub;
  /** Quota of free tickets, separate from the tier quotas. Hosts only. */
  complimentaryQuota: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  instance: CommunityEventInstance;
  /** The acting customer's queue entry, held reservation, live ticket and usable purchase grant in this sale. */
  myState: CommunityEventTicketSaleState;
  priceTiers?: Maybe<Array<CommunityEventPriceTier>>;
  purchaseGrants?: Maybe<Array<CommunityEventTicketPurchaseGrant>>;
  queueEntries?: Maybe<Array<CommunityEventTicketQueueEntry>>;
  /**
   * Last reschedule of the instance after sales had started. Holders of tickets obtained before
   * it may cancel them until the new start.
   */
  rescheduledAt?: Maybe<Scalars['DateTime']['output']>;
  reservations?: Maybe<Array<CommunityEventTicketReservation>>;
  /** What a booking would currently lead to (on sale, queue, sold out, not yet, ended, canceled), without a purchase grant. Cached for a few seconds; the booking result decides. */
  saleStatus: CommunityEventTicketSaleStatus;
  /** Start of advance sales. Booking before it is refused; sales end at the instance's endAt. */
  salesStartAt: Scalars['DateTime']['output'];
  tickets?: Maybe<Array<CommunityEventTicket>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CommunityEventTicketSaleAvgAggregate = {
  __typename: 'CommunityEventTicketSaleAvgAggregate';
  complimentaryQuota?: Maybe<Scalars['Float']['output']>;
};

export type CommunityEventTicketSaleCountAggregate = {
  __typename: 'CommunityEventTicketSaleCountAggregate';
  _all: Scalars['Int']['output'];
  canceledAt: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  rescheduledAt: Scalars['Int']['output'];
  salesStartAt: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CommunityEventTicketSaleMaxAggregate = {
  __typename: 'CommunityEventTicketSaleMaxAggregate';
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  rescheduledAt?: Maybe<Scalars['DateTime']['output']>;
  salesStartAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityEventTicketSaleMinAggregate = {
  __typename: 'CommunityEventTicketSaleMinAggregate';
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  rescheduledAt?: Maybe<Scalars['DateTime']['output']>;
  salesStartAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityEventTicketSaleOrderByWithRelationInput = {
  communityClub?: InputMaybe<CommunityClubOrderByWithRelationInput>;
  communityClubId?: InputMaybe<SortOrder>;
  complimentaryQuota?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  instance?: InputMaybe<CommunityEventInstanceOrderByWithRelationInput>;
  instanceId?: InputMaybe<SortOrder>;
  priceTiers?: InputMaybe<CommunityEventPriceTierOrderByRelationAggregateInput>;
  purchaseGrants?: InputMaybe<CommunityEventTicketPurchaseGrantOrderByRelationAggregateInput>;
  queueEntries?: InputMaybe<CommunityEventTicketQueueEntryOrderByRelationAggregateInput>;
  reservations?: InputMaybe<CommunityEventTicketReservationOrderByRelationAggregateInput>;
  salesStartAt?: InputMaybe<SortOrder>;
  tickets?: InputMaybe<CommunityEventTicketOrderByRelationAggregateInput>;
};

export type CommunityEventTicketSaleScalarRelationFilter = {
  is?: InputMaybe<CommunityEventTicketSaleWhereInput>;
  isNot?: InputMaybe<CommunityEventTicketSaleWhereInput>;
};

/** The acting customer's current position in a ticket sale: queue entry, held reservation, live ticket and usable purchase grant. */
export type CommunityEventTicketSaleState = {
  __typename: 'CommunityEventTicketSaleState';
  /** A purchase grant the customer can still use (not used, not revoked, still valid). */
  purchaseGrant?: Maybe<CommunityEventTicketPurchaseGrant>;
  /** The customer's queue entry, if waiting. */
  queueEntry?: Maybe<CommunityEventTicketQueueEntry>;
  /** 1-based queue position; set with a queue entry. */
  queuePosition?: Maybe<Scalars['Int']['output']>;
  /** The customer's held reservation, if it can still be paid. */
  reservation?: Maybe<CommunityEventTicketReservation>;
  /** The customer's live ticket (ACTIVE, USED or DISPUTED). */
  ticket?: Maybe<CommunityEventTicket>;
};

/** What a booking attempt would currently lead to. Display only, cached for a few seconds; the booking result decides. */
export enum CommunityEventTicketSaleStatus {
  Canceled = 'CANCELED',
  NotOnSaleYet = 'NOT_ON_SALE_YET',
  OnSale = 'ON_SALE',
  QueueOnly = 'QUEUE_ONLY',
  SalesEnded = 'SALES_ENDED',
  SoldOut = 'SOLD_OUT'
}

export type CommunityEventTicketSaleSumAggregate = {
  __typename: 'CommunityEventTicketSaleSumAggregate';
  complimentaryQuota?: Maybe<Scalars['Int']['output']>;
};

export type CommunityEventTicketSaleWhereInput = {
  AND?: InputMaybe<Array<CommunityEventTicketSaleWhereInput>>;
  NOT?: InputMaybe<Array<CommunityEventTicketSaleWhereInput>>;
  OR?: InputMaybe<Array<CommunityEventTicketSaleWhereInput>>;
  communityClub?: InputMaybe<CommunityClubScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidFilter>;
  complimentaryQuota?: InputMaybe<IntFilter>;
  id?: InputMaybe<UuidFilter>;
  instance?: InputMaybe<CommunityEventInstanceScalarRelationFilter>;
  instanceId?: InputMaybe<UuidFilter>;
  priceTiers?: InputMaybe<CommunityEventPriceTierListRelationFilter>;
  purchaseGrants?: InputMaybe<CommunityEventTicketPurchaseGrantListRelationFilter>;
  queueEntries?: InputMaybe<CommunityEventTicketQueueEntryListRelationFilter>;
  reservations?: InputMaybe<CommunityEventTicketReservationListRelationFilter>;
  salesStartAt?: InputMaybe<DateTimeFilter>;
  tickets?: InputMaybe<CommunityEventTicketListRelationFilter>;
};

export type CommunityEventTicketSaleWhereUniqueInput = {
  AND?: InputMaybe<Array<CommunityEventTicketSaleWhereInput>>;
  NOT?: InputMaybe<Array<CommunityEventTicketSaleWhereInput>>;
  OR?: InputMaybe<Array<CommunityEventTicketSaleWhereInput>>;
  communityClub?: InputMaybe<CommunityClubScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidFilter>;
  complimentaryQuota?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  instance?: InputMaybe<CommunityEventInstanceScalarRelationFilter>;
  instanceId?: InputMaybe<Scalars['String']['input']>;
  priceTiers?: InputMaybe<CommunityEventPriceTierListRelationFilter>;
  purchaseGrants?: InputMaybe<CommunityEventTicketPurchaseGrantListRelationFilter>;
  queueEntries?: InputMaybe<CommunityEventTicketQueueEntryListRelationFilter>;
  reservations?: InputMaybe<CommunityEventTicketReservationListRelationFilter>;
  salesStartAt?: InputMaybe<DateTimeFilter>;
  tickets?: InputMaybe<CommunityEventTicketListRelationFilter>;
};

export enum CommunityEventTicketScalarFieldEnum {
  BookingId = 'bookingId',
  CommunityClubId = 'communityClubId',
  CompanyId = 'companyId',
  ConsumerBillingId = 'consumerBillingId',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  DisputeClosedAt = 'disputeClosedAt',
  DisputeFeeInCents = 'disputeFeeInCents',
  DisputedAt = 'disputedAt',
  Id = 'id',
  IssuedAt = 'issuedAt',
  PriceInCents = 'priceInCents',
  PriceTierId = 'priceTierId',
  RefundFeeBillingId = 'refundFeeBillingId',
  RefundRequestedAt = 'refundRequestedAt',
  RefundRequestedByEmployeeId = 'refundRequestedByEmployeeId',
  RefundedAt = 'refundedAt',
  ReservationId = 'reservationId',
  ScannedByEmployeeId = 'scannedByEmployeeId',
  Source = 'source',
  Status = 'status',
  StatusBeforeDispute = 'statusBeforeDispute',
  StripeDisputeId = 'stripeDisputeId',
  StripeFeeInCents = 'stripeFeeInCents',
  StripePaymentIntentId = 'stripePaymentIntentId',
  StripeRefundId = 'stripeRefundId',
  StripeTransferReversalId = 'stripeTransferReversalId',
  TicketEmailSentAt = 'ticketEmailSentAt',
  TicketSaleId = 'ticketSaleId',
  TicketVersion = 'ticketVersion',
  UpdatedAt = 'updatedAt',
  UsedAt = 'usedAt'
}

/** Result of a community event ticket scan. Rejections are results, not errors; only VALID lets the holder in. */
export type CommunityEventTicketScanResult = {
  __typename: 'CommunityEventTicketScanResult';
  eventName?: Maybe<Scalars['String']['output']>;
  /** The buyer's name, informational only: tickets are transferable. Null for INVALID or a deleted buyer. */
  holderName?: Maybe<Scalars['String']['output']>;
  /** Name of the price tier; null for INVALID and free tickets. */
  priceTierName?: Maybe<Scalars['String']['output']>;
  /** Who scanned the ticket; set for VALID and ALREADY_USED while the host still exists. */
  scannedByName?: Maybe<Scalars['String']['output']>;
  /** Start of the instance the ticket is for. */
  startAt?: Maybe<Scalars['DateTime']['output']>;
  status: CommunityEventTicketScanStatus;
  /** When the ticket was scanned; set for VALID and ALREADY_USED. */
  usedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** What a community event ticket scan found; only VALID lets the holder in. */
export enum CommunityEventTicketScanStatus {
  /** Scanned before; the result says when and by whom. */
  AlreadyUsed = 'ALREADY_USED',
  /** The event was called off, deleted or deactivated. */
  Canceled = 'CANCELED',
  /** The payment is disputed with the bank; no entry until it is resolved. */
  Disputed = 'DISPUTED',
  /** The payment dispute was lost; the ticket is void. */
  DisputeLost = 'DISPUTE_LOST',
  /** Not a ticket of this club: forged, unknown, outdated or of another club. */
  Invalid = 'INVALID',
  /** Before 00:00 (Europe/Berlin) on the start day, or after the end. */
  OutsideEntryWindow = 'OUTSIDE_ENTRY_WINDOW',
  /** Refunded, or its refund is running. */
  Refunded = 'REFUNDED',
  /** A free ticket that was withdrawn. */
  Revoked = 'REVOKED',
  /** Let in: the ticket was valid and is now used. */
  Valid = 'VALID',
  /** A ticket of this club, but for another date than the one being admitted; it stays valid. */
  WrongEvent = 'WRONG_EVENT'
}

/** How a community event ticket came about. */
export enum CommunityEventTicketSource {
  /** Issued free by a host, in the sale's own complimentary quota. */
  Complimentary = 'COMPLIMENTARY',
  /** Bought through a purchase grant: paid like a purchase, but outside the sale quota. */
  GrantedPurchase = 'GRANTED_PURCHASE',
  /** Bought through a reservation and Stripe, inside the sale quota. */
  Purchase = 'PURCHASE'
}

/** The state of a community event ticket. */
export enum CommunityEventTicketStatus {
  /** Paid (or issued free) and valid. */
  Active = 'ACTIVE',
  /** The customer disputed the payment with their bank; entry is blocked until it is resolved. */
  Disputed = 'DISPUTED',
  /** The dispute was lost: the money is gone, the ticket is void, and its slot is back on sale. */
  DisputeLost = 'DISPUTE_LOST',
  /**
   * Refunded: single refund by the host, cancellation of the instance, or the holder's cancellation
   * after a reschedule.
   */
  Refunded = 'REFUNDED',
  /** A free ticket withdrawn by the host, or ended by a cancellation or a club departure. */
  Revoked = 'REVOKED',
  /** Scanned at the entrance. */
  Used = 'USED'
}

export type CommunityEventTicketSumAggregate = {
  __typename: 'CommunityEventTicketSumAggregate';
  priceInCents?: Maybe<Scalars['Int']['output']>;
};

/** What one run of the community event ticket sweep did. Called by the maintenance service (M2M). */
export type CommunityEventTicketSweepResult = {
  __typename: 'CommunityEventTicketSweepResult';
  /** Reservations whose session turned out to be paid and that were completed into a ticket (D42). */
  completed: Scalars['Int']['output'];
  /** Items that failed and are retried on the next run (e.g. Stripe unreachable). */
  failed: Scalars['Int']['output'];
  /** Sales whose queue was promoted. */
  promotedSales: Scalars['Int']['output'];
  /** Reservations released (overdue, or of a cancelled sale), after their session was expired. */
  released: Scalars['Int']['output'];
  /** True if the run did nothing: another run was still active, or nothing was due. */
  skipped: Scalars['Boolean']['output'];
  /** Follow-up tasks that ran successfully. */
  tasksDone: Scalars['Int']['output'];
  /** Follow-up tasks that failed: retried after their backoff, or FAILED after the last attempt. */
  tasksFailed: Scalars['Int']['output'];
};

export type CommunityEventTicketTaskAvgAggregate = {
  __typename: 'CommunityEventTicketTaskAvgAggregate';
  attempts?: Maybe<Scalars['Float']['output']>;
};

export type CommunityEventTicketTaskCountAggregate = {
  __typename: 'CommunityEventTicketTaskCountAggregate';
  _all: Scalars['Int']['output'];
  attempts: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  dedupeKey: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastError: Scalars['Int']['output'];
  nextAttemptAt: Scalars['Int']['output'];
  payload: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  subjectId: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CommunityEventTicketTaskMaxAggregate = {
  __typename: 'CommunityEventTicketTaskMaxAggregate';
  attempts?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dedupeKey?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  nextAttemptAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<CommunityEventTicketTaskStatus>;
  subjectId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CommunityEventTicketTaskType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityEventTicketTaskMinAggregate = {
  __typename: 'CommunityEventTicketTaskMinAggregate';
  attempts?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dedupeKey?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  nextAttemptAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<CommunityEventTicketTaskStatus>;
  subjectId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CommunityEventTicketTaskType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** The state of a ticket follow-up task. */
export enum CommunityEventTicketTaskStatus {
  /** No longer needed, e.g. a refund after a lost dispute (the bank already returned the money). */
  Canceled = 'CANCELED',
  Done = 'DONE',
  /** Gave up after the maximum number of attempts; the operator was emailed, support resolves it. */
  Failed = 'FAILED',
  /** Due at nextAttemptAt (or leased until then by a running worker). */
  Pending = 'PENDING',
  /** Paused by a dispute, since a disputed charge can't be refunded; resumed if the dispute is won. */
  Suspended = 'SUSPENDED'
}

export type CommunityEventTicketTaskSumAggregate = {
  __typename: 'CommunityEventTicketTaskSumAggregate';
  attempts?: Maybe<Scalars['Int']['output']>;
};

/** The kind of a ticket follow-up task. */
export enum CommunityEventTicketTaskType {
  CreditNote = 'CREDIT_NOTE',
  FeeInvoice = 'FEE_INVOICE',
  IssueTicketInvoice = 'ISSUE_TICKET_INVOICE',
  OperatorEmail = 'OPERATOR_EMAIL',
  ReadStripeFee = 'READ_STRIPE_FEE',
  Refund = 'REFUND',
  ReverseTransfer = 'REVERSE_TRANSFER',
  SendRescheduleEmail = 'SEND_RESCHEDULE_EMAIL',
  SendTicketEmail = 'SEND_TICKET_EMAIL',
  UpdateWallet = 'UPDATE_WALLET',
  UpdateWalletClass = 'UPDATE_WALLET_CLASS'
}

export type CommunityEventTicketWhereInput = {
  AND?: InputMaybe<Array<CommunityEventTicketWhereInput>>;
  NOT?: InputMaybe<Array<CommunityEventTicketWhereInput>>;
  OR?: InputMaybe<Array<CommunityEventTicketWhereInput>>;
  booking?: InputMaybe<CommunityEventBookingNullableScalarRelationFilter>;
  bookingId?: InputMaybe<UuidNullableFilter>;
  consumerBilling?: InputMaybe<ConsumerBillingNullableScalarRelationFilter>;
  consumerBillingId?: InputMaybe<UuidNullableFilter>;
  customer?: InputMaybe<CustomerNullableScalarRelationFilter>;
  customerId?: InputMaybe<StringNullableFilter>;
  disputeClosedAt?: InputMaybe<DateTimeNullableFilter>;
  disputeFeeInCents?: InputMaybe<IntNullableFilter>;
  disputedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  issuedAt?: InputMaybe<DateTimeFilter>;
  priceInCents?: InputMaybe<IntFilter>;
  priceTier?: InputMaybe<CommunityEventPriceTierNullableScalarRelationFilter>;
  priceTierId?: InputMaybe<UuidNullableFilter>;
  refundFeeBilling?: InputMaybe<CompanyBillingNullableScalarRelationFilter>;
  refundFeeBillingId?: InputMaybe<UuidNullableFilter>;
  refundRequestedAt?: InputMaybe<DateTimeNullableFilter>;
  refundRequestedByEmployeeId?: InputMaybe<StringNullableFilter>;
  refundedAt?: InputMaybe<DateTimeNullableFilter>;
  reservation?: InputMaybe<CommunityEventTicketReservationNullableScalarRelationFilter>;
  reservationId?: InputMaybe<UuidNullableFilter>;
  scannedByEmployeeId?: InputMaybe<StringNullableFilter>;
  source?: InputMaybe<EnumCommunityEventTicketSourceFilter>;
  status?: InputMaybe<EnumCommunityEventTicketStatusFilter>;
  statusBeforeDispute?: InputMaybe<EnumCommunityEventTicketStatusNullableFilter>;
  stripeDisputeId?: InputMaybe<StringNullableFilter>;
  stripeFeeInCents?: InputMaybe<IntNullableFilter>;
  stripePaymentIntentId?: InputMaybe<StringNullableFilter>;
  stripeRefundId?: InputMaybe<StringNullableFilter>;
  stripeTransferReversalId?: InputMaybe<StringNullableFilter>;
  ticketEmailSentAt?: InputMaybe<DateTimeNullableFilter>;
  ticketSale?: InputMaybe<CommunityEventTicketSaleScalarRelationFilter>;
  ticketSaleId?: InputMaybe<UuidFilter>;
  ticketVersion?: InputMaybe<IntFilter>;
  usedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type CommunityEventTicketWhereUniqueInput = {
  AND?: InputMaybe<Array<CommunityEventTicketWhereInput>>;
  NOT?: InputMaybe<Array<CommunityEventTicketWhereInput>>;
  OR?: InputMaybe<Array<CommunityEventTicketWhereInput>>;
  booking?: InputMaybe<CommunityEventBookingNullableScalarRelationFilter>;
  bookingId?: InputMaybe<UuidNullableFilter>;
  consumerBilling?: InputMaybe<ConsumerBillingNullableScalarRelationFilter>;
  consumerBillingId?: InputMaybe<Scalars['String']['input']>;
  customer?: InputMaybe<CustomerNullableScalarRelationFilter>;
  customerId?: InputMaybe<StringNullableFilter>;
  disputeClosedAt?: InputMaybe<DateTimeNullableFilter>;
  disputeFeeInCents?: InputMaybe<IntNullableFilter>;
  disputedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  issuedAt?: InputMaybe<DateTimeFilter>;
  priceInCents?: InputMaybe<IntFilter>;
  priceTier?: InputMaybe<CommunityEventPriceTierNullableScalarRelationFilter>;
  priceTierId?: InputMaybe<UuidNullableFilter>;
  refundFeeBilling?: InputMaybe<CompanyBillingNullableScalarRelationFilter>;
  refundFeeBillingId?: InputMaybe<UuidNullableFilter>;
  refundRequestedAt?: InputMaybe<DateTimeNullableFilter>;
  refundRequestedByEmployeeId?: InputMaybe<StringNullableFilter>;
  refundedAt?: InputMaybe<DateTimeNullableFilter>;
  reservation?: InputMaybe<CommunityEventTicketReservationNullableScalarRelationFilter>;
  reservationId?: InputMaybe<Scalars['String']['input']>;
  scannedByEmployeeId?: InputMaybe<StringNullableFilter>;
  source?: InputMaybe<EnumCommunityEventTicketSourceFilter>;
  status?: InputMaybe<EnumCommunityEventTicketStatusFilter>;
  statusBeforeDispute?: InputMaybe<EnumCommunityEventTicketStatusNullableFilter>;
  stripeDisputeId?: InputMaybe<Scalars['String']['input']>;
  stripeFeeInCents?: InputMaybe<IntNullableFilter>;
  stripePaymentIntentId?: InputMaybe<Scalars['String']['input']>;
  stripeRefundId?: InputMaybe<Scalars['String']['input']>;
  stripeTransferReversalId?: InputMaybe<Scalars['String']['input']>;
  ticketEmailSentAt?: InputMaybe<DateTimeNullableFilter>;
  ticketSale?: InputMaybe<CommunityEventTicketSaleScalarRelationFilter>;
  ticketSaleId?: InputMaybe<UuidFilter>;
  ticketVersion?: InputMaybe<IntFilter>;
  usedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type CommunityEventUpdateInput = {
  advanceGenerationDays?: InputMaybe<Scalars['Int']['input']>;
  communityEventCategory?: InputMaybe<CommunityEventCategoryUpdateOneWithoutCommunityEventsNestedInput>;
  communityEventImages?: InputMaybe<CommunityEventImageUpdateManyWithoutCommunityEventNestedInput>;
  communityEventInstances?: InputMaybe<CommunityEventInstanceUpdateManyWithoutCommunityEventNestedInput>;
  communityEventLocation?: InputMaybe<CommunityEventLocationUpdateOneRequiredWithoutCommunityEventsNestedInput>;
  communityEventPartner?: InputMaybe<CommunityEventPartnerUpdateOneWithoutCommunityEventsNestedInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  durationMin?: InputMaybe<Scalars['Int']['input']>;
  headerImage?: InputMaybe<ImageInput>;
  hostProfile?: InputMaybe<ProfileUpdateOneWithoutHostedCommunityEventsNestedInput>;
  /** The Profile to display as the event host. Pass null to remove the host, omit to leave unchanged. */
  hostProfileId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isLimited?: InputMaybe<Scalars['Boolean']['input']>;
  maxParticipants?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recurrenceByweekday?: InputMaybe<Array<Scalars['Int']['input']>>;
  recurrenceCount?: InputMaybe<Scalars['Int']['input']>;
  recurrenceEndType?: InputMaybe<RecurrenceEndType>;
  recurrenceFreq?: InputMaybe<RecurrenceFrequency>;
  recurrenceInterval?: InputMaybe<Scalars['Int']['input']>;
  recurrenceMonthOption?: InputMaybe<RecurrenceMonthOption>;
  recurrenceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  recurrenceUntil?: InputMaybe<Scalars['DateTime']['input']>;
  sharedInMessages?: InputMaybe<MessageUpdateManyWithoutSharedCommunityEventNestedInput>;
};

export type CommunityEventUpdateManyWithoutCommunityClubNestedInput = {
  connect?: InputMaybe<Array<CommunityEventWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CommunityEventWhereUniqueInput>>;
};

export type CommunityEventUpdateManyWithoutCommunityEventLocationNestedInput = {
  connect?: InputMaybe<Array<CommunityEventWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CommunityEventWhereUniqueInput>>;
};

export type CommunityEventUpdateManyWithoutCommunityEventPartnerNestedInput = {
  connect?: InputMaybe<Array<CommunityEventWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CommunityEventWhereUniqueInput>>;
};

export type CommunityEventUpdateOneRequiredWithoutCommunityEventInstancesNestedInput = {
  connect?: InputMaybe<CommunityEventWhereUniqueInput>;
};

export type CommunityEventWhereInput = {
  AND?: InputMaybe<Array<CommunityEventWhereInput>>;
  NOT?: InputMaybe<Array<CommunityEventWhereInput>>;
  OR?: InputMaybe<Array<CommunityEventWhereInput>>;
  advanceGenerationDays?: InputMaybe<IntFilter>;
  communityClub?: InputMaybe<CommunityClubScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidFilter>;
  communityEventCategory?: InputMaybe<CommunityEventCategoryNullableScalarRelationFilter>;
  communityEventCategoryId?: InputMaybe<UuidNullableFilter>;
  communityEventImages?: InputMaybe<CommunityEventImageListRelationFilter>;
  communityEventInstances?: InputMaybe<CommunityEventInstanceListRelationFilter>;
  communityEventLocation?: InputMaybe<CommunityEventLocationScalarRelationFilter>;
  communityEventPartner?: InputMaybe<CommunityEventPartnerNullableScalarRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  durationMin?: InputMaybe<IntNullableFilter>;
  hostProfile?: InputMaybe<ProfileNullableScalarRelationFilter>;
  hostProfileId?: InputMaybe<UuidNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  isActive?: InputMaybe<BoolFilter>;
  isDraft?: InputMaybe<BoolFilter>;
  isLimited?: InputMaybe<BoolFilter>;
  isPaid?: InputMaybe<BoolFilter>;
  locationId?: InputMaybe<UuidFilter>;
  maxParticipants?: InputMaybe<IntNullableFilter>;
  name?: InputMaybe<StringFilter>;
  partnerId?: InputMaybe<UuidNullableFilter>;
  recurrenceByweekday?: InputMaybe<IntNullableListFilter>;
  recurrenceCount?: InputMaybe<IntNullableFilter>;
  recurrenceEndType?: InputMaybe<EnumRecurrenceEndTypeNullableFilter>;
  recurrenceFreq?: InputMaybe<EnumRecurrenceFrequencyNullableFilter>;
  recurrenceInterval?: InputMaybe<IntNullableFilter>;
  recurrenceMonthOption?: InputMaybe<EnumRecurrenceMonthOptionNullableFilter>;
  recurrenceStartDate?: InputMaybe<DateTimeNullableFilter>;
  recurrenceUntil?: InputMaybe<DateTimeNullableFilter>;
  s3HeaderImageKey?: InputMaybe<StringNullableFilter>;
  s3HeaderImageUrl?: InputMaybe<StringNullableFilter>;
  sharedInMessages?: InputMaybe<MessageListRelationFilter>;
};

export type CommunityEventWhereUniqueInput = {
  AND?: InputMaybe<Array<CommunityEventWhereInput>>;
  NOT?: InputMaybe<Array<CommunityEventWhereInput>>;
  OR?: InputMaybe<Array<CommunityEventWhereInput>>;
  advanceGenerationDays?: InputMaybe<IntFilter>;
  communityClub?: InputMaybe<CommunityClubScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidFilter>;
  communityEventCategory?: InputMaybe<CommunityEventCategoryNullableScalarRelationFilter>;
  communityEventCategoryId?: InputMaybe<UuidNullableFilter>;
  communityEventImages?: InputMaybe<CommunityEventImageListRelationFilter>;
  communityEventInstances?: InputMaybe<CommunityEventInstanceListRelationFilter>;
  communityEventLocation?: InputMaybe<CommunityEventLocationScalarRelationFilter>;
  communityEventPartner?: InputMaybe<CommunityEventPartnerNullableScalarRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  durationMin?: InputMaybe<IntNullableFilter>;
  hostProfile?: InputMaybe<ProfileNullableScalarRelationFilter>;
  hostProfileId?: InputMaybe<UuidNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<BoolFilter>;
  isDraft?: InputMaybe<BoolFilter>;
  isLimited?: InputMaybe<BoolFilter>;
  isPaid?: InputMaybe<BoolFilter>;
  locationId?: InputMaybe<UuidFilter>;
  maxParticipants?: InputMaybe<IntNullableFilter>;
  name?: InputMaybe<StringFilter>;
  partnerId?: InputMaybe<UuidNullableFilter>;
  recurrenceByweekday?: InputMaybe<IntNullableListFilter>;
  recurrenceCount?: InputMaybe<IntNullableFilter>;
  recurrenceEndType?: InputMaybe<EnumRecurrenceEndTypeNullableFilter>;
  recurrenceFreq?: InputMaybe<EnumRecurrenceFrequencyNullableFilter>;
  recurrenceInterval?: InputMaybe<IntNullableFilter>;
  recurrenceMonthOption?: InputMaybe<EnumRecurrenceMonthOptionNullableFilter>;
  recurrenceStartDate?: InputMaybe<DateTimeNullableFilter>;
  recurrenceUntil?: InputMaybe<DateTimeNullableFilter>;
  s3HeaderImageKey?: InputMaybe<StringNullableFilter>;
  s3HeaderImageUrl?: InputMaybe<StringNullableFilter>;
  sharedInMessages?: InputMaybe<MessageListRelationFilter>;
};

/**
 * Aggregated count of how often two community club members attended the same event instance
 * together. customerAId is always the lexicographically smaller of the two customer IDs, so a
 * pair is stored exactly once regardless of lookup direction.
 */
export type CommunityMemberRelation = {
  __typename: 'CommunityMemberRelation';
  communityClub: CommunityClub;
  /** The number of event instances the two members attended together. */
  count: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  customerA: Customer;
  customerB: Customer;
  id: Scalars['UUID']['output'];
  lastMetAt?: Maybe<Scalars['DateTime']['output']>;
  lastMetInstance?: Maybe<CommunityEventInstance>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CommunityMemberRelationAvgAggregate = {
  __typename: 'CommunityMemberRelationAvgAggregate';
  count?: Maybe<Scalars['Float']['output']>;
};

export type CommunityMemberRelationCommunityClubIdCustomerAIdCustomerBIdCompoundUniqueInput = {
  communityClubId: Scalars['String']['input'];
  customerAId: Scalars['String']['input'];
  customerBId: Scalars['String']['input'];
};

export type CommunityMemberRelationCountAggregate = {
  __typename: 'CommunityMemberRelationCountAggregate';
  _all: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastMetAt: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CommunityMemberRelationCreateNestedManyWithoutCommunityClubInput = {
  connect?: InputMaybe<Array<CommunityMemberRelationWhereUniqueInput>>;
};

export type CommunityMemberRelationListRelationFilter = {
  every?: InputMaybe<CommunityMemberRelationWhereInput>;
  none?: InputMaybe<CommunityMemberRelationWhereInput>;
  some?: InputMaybe<CommunityMemberRelationWhereInput>;
};

export type CommunityMemberRelationMaxAggregate = {
  __typename: 'CommunityMemberRelationMaxAggregate';
  count?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  lastMetAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityMemberRelationMinAggregate = {
  __typename: 'CommunityMemberRelationMinAggregate';
  count?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  lastMetAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityMemberRelationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CommunityMemberRelationOrderByWithRelationInput = {
  communityClub?: InputMaybe<CommunityClubOrderByWithRelationInput>;
  communityClubId?: InputMaybe<SortOrder>;
  count?: InputMaybe<SortOrder>;
  customerA?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerAId?: InputMaybe<SortOrder>;
  customerB?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerBId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastMetAt?: InputMaybe<SortOrderInput>;
  lastMetInstance?: InputMaybe<CommunityEventInstanceOrderByWithRelationInput>;
  lastMetInstanceId?: InputMaybe<SortOrderInput>;
};

export enum CommunityMemberRelationScalarFieldEnum {
  CommunityClubId = 'communityClubId',
  CompanyId = 'companyId',
  Count = 'count',
  CreatedAt = 'createdAt',
  CustomerAId = 'customerAId',
  CustomerBId = 'customerBId',
  Id = 'id',
  LastMetAt = 'lastMetAt',
  LastMetInstanceId = 'lastMetInstanceId',
  UpdatedAt = 'updatedAt'
}

export type CommunityMemberRelationSumAggregate = {
  __typename: 'CommunityMemberRelationSumAggregate';
  count?: Maybe<Scalars['Int']['output']>;
};

export type CommunityMemberRelationUpdateManyWithoutCommunityClubNestedInput = {
  connect?: InputMaybe<Array<CommunityMemberRelationWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CommunityMemberRelationWhereUniqueInput>>;
};

export type CommunityMemberRelationUpdateManyWithoutCustomerANestedInput = {
  connect?: InputMaybe<Array<CommunityMemberRelationWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CommunityMemberRelationWhereUniqueInput>>;
};

export type CommunityMemberRelationUpdateManyWithoutCustomerBNestedInput = {
  connect?: InputMaybe<Array<CommunityMemberRelationWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CommunityMemberRelationWhereUniqueInput>>;
};

export type CommunityMemberRelationUpdateManyWithoutLastMetInstanceNestedInput = {
  connect?: InputMaybe<Array<CommunityMemberRelationWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CommunityMemberRelationWhereUniqueInput>>;
};

export type CommunityMemberRelationWhereInput = {
  AND?: InputMaybe<Array<CommunityMemberRelationWhereInput>>;
  NOT?: InputMaybe<Array<CommunityMemberRelationWhereInput>>;
  OR?: InputMaybe<Array<CommunityMemberRelationWhereInput>>;
  communityClub?: InputMaybe<CommunityClubScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidFilter>;
  count?: InputMaybe<IntFilter>;
  customerA?: InputMaybe<CustomerScalarRelationFilter>;
  customerAId?: InputMaybe<StringFilter>;
  customerB?: InputMaybe<CustomerScalarRelationFilter>;
  customerBId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  lastMetAt?: InputMaybe<DateTimeNullableFilter>;
  lastMetInstance?: InputMaybe<CommunityEventInstanceNullableScalarRelationFilter>;
  lastMetInstanceId?: InputMaybe<UuidNullableFilter>;
};

export type CommunityMemberRelationWhereUniqueInput = {
  AND?: InputMaybe<Array<CommunityMemberRelationWhereInput>>;
  NOT?: InputMaybe<Array<CommunityMemberRelationWhereInput>>;
  OR?: InputMaybe<Array<CommunityMemberRelationWhereInput>>;
  communityClub?: InputMaybe<CommunityClubScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidFilter>;
  communityClubId_customerAId_customerBId?: InputMaybe<CommunityMemberRelationCommunityClubIdCustomerAIdCustomerBIdCompoundUniqueInput>;
  count?: InputMaybe<IntFilter>;
  customerA?: InputMaybe<CustomerScalarRelationFilter>;
  customerAId?: InputMaybe<StringFilter>;
  customerB?: InputMaybe<CustomerScalarRelationFilter>;
  customerBId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  lastMetAt?: InputMaybe<DateTimeNullableFilter>;
  lastMetInstance?: InputMaybe<CommunityEventInstanceNullableScalarRelationFilter>;
  lastMetInstanceId?: InputMaybe<UuidNullableFilter>;
};

export type CommunityPost = {
  __typename: 'CommunityPost';
  _count: CommunityPostCount;
  author?: Maybe<Profile>;
  communityClub: CommunityClub;
  communityPostComments?: Maybe<Array<CommunityPostComment>>;
  communityPostCommentsWithoutCustomer: Array<CommunityPostCommentModel>;
  communityPostLikes?: Maybe<Array<CommunityPostLike>>;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Set once `content` is changed via `updateCommunityPost` -- distinct from `updatedAt`, which
   * also bumps on unrelated writes (e.g. soft-delete). NULL means never edited.
   */
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Paginated list of Profiles that liked this post. */
  likedBy: PaginatedLiker;
  /** The date and time when the post is considered published. */
  postedAt: Scalars['DateTime']['output'];
  s3ImageUrl?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type CommunityPostCommunityPostCommentsArgs = {
  cursor?: InputMaybe<CommunityPostCommentWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityPostCommentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityPostCommentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityPostCommentWhereInput>;
};


export type CommunityPostCommunityPostLikesArgs = {
  cursor?: InputMaybe<CommunityPostLikeWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityPostLikeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityPostLikeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityPostLikeWhereInput>;
};


export type CommunityPostLikedByArgs = {
  cursor?: InputMaybe<CommunityPostLikeWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityPostLikeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityPostLikeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityPostLikeWhereInput>;
};

export type CommunityPostComment = {
  __typename: 'CommunityPostComment';
  _count: CommunityPostCommentCount;
  communityClub?: Maybe<CommunityClub>;
  communityPost?: Maybe<CommunityPost>;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<Customer>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Set once `content` is changed via `updateCommunityPostComment`/`updateUserPostComment` --
   * distinct from `updatedAt`, which also bumps on unrelated writes (e.g. `hiddenAt` toggle).
   * NULL means never edited.
   */
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  hiddenAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  /** Only set for mediaType=VIDEO. */
  mediaDurationSeconds?: Maybe<Scalars['Int']['output']>;
  mediaKey?: Maybe<Scalars['String']['output']>;
  /** Only set for mediaType=VIDEO. */
  mediaThumbnailUrl?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<MediaType>;
  mediaUrl?: Maybe<Scalars['String']['output']>;
  /** Profiles mentioned in this comment's content. */
  mentionedProfiles: Array<Profile>;
  parentComment?: Maybe<CommunityPostComment>;
  profile?: Maybe<Profile>;
  updatedAt: Scalars['DateTime']['output'];
  userPost?: Maybe<UserPost>;
};

export type CommunityPostCommentAvgAggregate = {
  __typename: 'CommunityPostCommentAvgAggregate';
  mediaDurationSeconds?: Maybe<Scalars['Float']['output']>;
};

export type CommunityPostCommentCount = {
  __typename: 'CommunityPostCommentCount';
  activities: Scalars['Int']['output'];
  communityPostCommentLikes: Scalars['Int']['output'];
  replies: Scalars['Int']['output'];
  reports: Scalars['Int']['output'];
};

export type CommunityPostCommentCountAggregate = {
  __typename: 'CommunityPostCommentCountAggregate';
  _all: Scalars['Int']['output'];
  content: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  editedAt: Scalars['Int']['output'];
  hiddenAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  mediaDurationSeconds: Scalars['Int']['output'];
  mediaKey: Scalars['Int']['output'];
  mediaThumbnailUrl: Scalars['Int']['output'];
  mediaType: Scalars['Int']['output'];
  mediaUrl: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CommunityPostCommentCreateInput = {
  communityPost: CommunityPostCreateNestedOneWithoutCommunityPostCommentsInput;
  content: Scalars['String']['input'];
  /** A single image or video to attach to the comment. */
  media?: InputMaybe<CommentMediaInput>;
  /** Profiles mentioned in this comment's content. Up to 3 ids. */
  mentionedProfileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  parentCommentId?: InputMaybe<Scalars['String']['input']>;
};

export type CommunityPostCommentCreateNestedManyWithoutCommunityClubInput = {
  connect?: InputMaybe<Array<CommunityPostCommentWhereUniqueInput>>;
};

export type CommunityPostCommentCreateNestedManyWithoutCommunityPostInput = {
  connect?: InputMaybe<Array<CommunityPostCommentWhereUniqueInput>>;
};

export type CommunityPostCommentLike = {
  __typename: 'CommunityPostCommentLike';
  communityClub?: Maybe<CommunityClub>;
  communityPostComment: CommunityPostComment;
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<Customer>;
  id: Scalars['UUID']['output'];
  profile?: Maybe<Profile>;
};

export type CommunityPostCommentLikeCommunityPostCommentIdCustomerIdCompoundUniqueInput = {
  communityPostCommentId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
};

export type CommunityPostCommentLikeCommunityPostCommentIdProfileIdCompoundUniqueInput = {
  communityPostCommentId: Scalars['String']['input'];
  profileId: Scalars['String']['input'];
};

export type CommunityPostCommentLikeCountAggregate = {
  __typename: 'CommunityPostCommentLikeCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export type CommunityPostCommentLikeCreateNestedManyWithoutCommunityClubInput = {
  connect?: InputMaybe<Array<CommunityPostCommentLikeWhereUniqueInput>>;
};

export type CommunityPostCommentLikeListRelationFilter = {
  every?: InputMaybe<CommunityPostCommentLikeWhereInput>;
  none?: InputMaybe<CommunityPostCommentLikeWhereInput>;
  some?: InputMaybe<CommunityPostCommentLikeWhereInput>;
};

export type CommunityPostCommentLikeMaxAggregate = {
  __typename: 'CommunityPostCommentLikeMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
};

export type CommunityPostCommentLikeMinAggregate = {
  __typename: 'CommunityPostCommentLikeMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
};

export type CommunityPostCommentLikeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CommunityPostCommentLikeOrderByWithRelationInput = {
  communityClub?: InputMaybe<CommunityClubOrderByWithRelationInput>;
  communityClubId?: InputMaybe<SortOrderInput>;
  communityPostComment?: InputMaybe<CommunityPostCommentOrderByWithRelationInput>;
  communityPostCommentId?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  profile?: InputMaybe<ProfileOrderByWithRelationInput>;
  profileId?: InputMaybe<SortOrderInput>;
};

export enum CommunityPostCommentLikeScalarFieldEnum {
  CommunityClubId = 'communityClubId',
  CommunityPostCommentId = 'communityPostCommentId',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  Id = 'id',
  ProfileId = 'profileId'
}

export type CommunityPostCommentLikeUpdateManyWithoutCommunityClubNestedInput = {
  connect?: InputMaybe<Array<CommunityPostCommentLikeWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CommunityPostCommentLikeWhereUniqueInput>>;
};

export type CommunityPostCommentLikeUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<CommunityPostCommentLikeWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CommunityPostCommentLikeWhereUniqueInput>>;
};

export type CommunityPostCommentLikeWhereInput = {
  AND?: InputMaybe<Array<CommunityPostCommentLikeWhereInput>>;
  NOT?: InputMaybe<Array<CommunityPostCommentLikeWhereInput>>;
  OR?: InputMaybe<Array<CommunityPostCommentLikeWhereInput>>;
  communityClub?: InputMaybe<CommunityClubNullableScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidNullableFilter>;
  communityPostComment?: InputMaybe<CommunityPostCommentScalarRelationFilter>;
  communityPostCommentId?: InputMaybe<UuidFilter>;
  customer?: InputMaybe<CustomerNullableScalarRelationFilter>;
  customerId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  profile?: InputMaybe<ProfileNullableScalarRelationFilter>;
  profileId?: InputMaybe<UuidNullableFilter>;
};

export type CommunityPostCommentLikeWhereUniqueInput = {
  AND?: InputMaybe<Array<CommunityPostCommentLikeWhereInput>>;
  NOT?: InputMaybe<Array<CommunityPostCommentLikeWhereInput>>;
  OR?: InputMaybe<Array<CommunityPostCommentLikeWhereInput>>;
  communityClub?: InputMaybe<CommunityClubNullableScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidNullableFilter>;
  communityPostComment?: InputMaybe<CommunityPostCommentScalarRelationFilter>;
  communityPostCommentId?: InputMaybe<UuidFilter>;
  communityPostCommentId_customerId?: InputMaybe<CommunityPostCommentLikeCommunityPostCommentIdCustomerIdCompoundUniqueInput>;
  communityPostCommentId_profileId?: InputMaybe<CommunityPostCommentLikeCommunityPostCommentIdProfileIdCompoundUniqueInput>;
  customer?: InputMaybe<CustomerNullableScalarRelationFilter>;
  customerId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  profile?: InputMaybe<ProfileNullableScalarRelationFilter>;
  profileId?: InputMaybe<UuidNullableFilter>;
};

export type CommunityPostCommentListRelationFilter = {
  every?: InputMaybe<CommunityPostCommentWhereInput>;
  none?: InputMaybe<CommunityPostCommentWhereInput>;
  some?: InputMaybe<CommunityPostCommentWhereInput>;
};

export type CommunityPostCommentMaxAggregate = {
  __typename: 'CommunityPostCommentMaxAggregate';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  hiddenAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  mediaDurationSeconds?: Maybe<Scalars['Int']['output']>;
  mediaKey?: Maybe<Scalars['String']['output']>;
  mediaThumbnailUrl?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<MediaType>;
  mediaUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityPostCommentMinAggregate = {
  __typename: 'CommunityPostCommentMinAggregate';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  hiddenAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  mediaDurationSeconds?: Maybe<Scalars['Int']['output']>;
  mediaKey?: Maybe<Scalars['String']['output']>;
  mediaThumbnailUrl?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<MediaType>;
  mediaUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Result of community post comment endpoint */
export type CommunityPostCommentModel = {
  __typename: 'CommunityPostCommentModel';
  /** The commenter's Profile, null if they haven't created one yet */
  authorProfile?: Maybe<Profile>;
  content: Scalars['String']['output'];
  /**
   * Set once `content` is changed via `updateCommunityPostComment`/`updateUserPostComment` --
   * distinct from `updatedAt`, which also bumps on unrelated writes (e.g. `hiddenAt` toggle).
   * NULL means never edited.
   */
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  /** Number of likes on this comment. */
  likesCount: Scalars['Int']['output'];
  /** Only set for mediaType=VIDEO. */
  mediaDurationSeconds?: Maybe<Scalars['Int']['output']>;
  mediaKey?: Maybe<Scalars['String']['output']>;
  /** Only set for mediaType=VIDEO. */
  mediaThumbnailUrl?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<MediaType>;
  mediaUrl?: Maybe<Scalars['String']['output']>;
  /** Profiles mentioned in this comment's content. */
  mentionedProfiles: Array<Profile>;
  /** The id of the comment this is a reply to, null for top-level comments. */
  parentCommentId?: Maybe<Scalars['String']['output']>;
  postedAt: Scalars['DateTime']['output'];
  /** Number of replies to this comment. */
  replyCount: Scalars['Int']['output'];
};

export type CommunityPostCommentNullableScalarRelationFilter = {
  is?: InputMaybe<CommunityPostCommentWhereInput>;
  isNot?: InputMaybe<CommunityPostCommentWhereInput>;
};

export type CommunityPostCommentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CommunityPostCommentOrderByWithRelationInput = {
  activities?: InputMaybe<ActivityOrderByRelationAggregateInput>;
  communityClub?: InputMaybe<CommunityClubOrderByWithRelationInput>;
  communityClubId?: InputMaybe<SortOrderInput>;
  communityPost?: InputMaybe<CommunityPostOrderByWithRelationInput>;
  communityPostCommentLikes?: InputMaybe<CommunityPostCommentLikeOrderByRelationAggregateInput>;
  content?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrderInput>;
  deletedAt?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  mediaDurationSeconds?: InputMaybe<SortOrderInput>;
  mediaKey?: InputMaybe<SortOrderInput>;
  mediaThumbnailUrl?: InputMaybe<SortOrderInput>;
  mediaType?: InputMaybe<SortOrderInput>;
  mediaUrl?: InputMaybe<SortOrderInput>;
  parentComment?: InputMaybe<CommunityPostCommentOrderByWithRelationInput>;
  parentCommentId?: InputMaybe<SortOrderInput>;
  postId?: InputMaybe<SortOrderInput>;
  profile?: InputMaybe<ProfileOrderByWithRelationInput>;
  profileId?: InputMaybe<SortOrderInput>;
  replies?: InputMaybe<CommunityPostCommentOrderByRelationAggregateInput>;
  reports?: InputMaybe<ReportOrderByRelationAggregateInput>;
  userPost?: InputMaybe<UserPostOrderByWithRelationInput>;
  userPostId?: InputMaybe<SortOrderInput>;
};

export enum CommunityPostCommentScalarFieldEnum {
  CommunityClubId = 'communityClubId',
  CompanyId = 'companyId',
  Content = 'content',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  DeletedAt = 'deletedAt',
  EditedAt = 'editedAt',
  HiddenAt = 'hiddenAt',
  Id = 'id',
  MediaDurationSeconds = 'mediaDurationSeconds',
  MediaKey = 'mediaKey',
  MediaThumbnailUrl = 'mediaThumbnailUrl',
  MediaType = 'mediaType',
  MediaUrl = 'mediaUrl',
  ParentCommentId = 'parentCommentId',
  PostId = 'postId',
  ProfileId = 'profileId',
  UpdatedAt = 'updatedAt',
  UserPostId = 'userPostId'
}

export type CommunityPostCommentScalarRelationFilter = {
  is?: InputMaybe<CommunityPostCommentWhereInput>;
  isNot?: InputMaybe<CommunityPostCommentWhereInput>;
};

export type CommunityPostCommentSumAggregate = {
  __typename: 'CommunityPostCommentSumAggregate';
  mediaDurationSeconds?: Maybe<Scalars['Int']['output']>;
};

/** Input for updating a Community Post */
export type CommunityPostCommentUpdateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  /** If provided, replaces the existing media item; pass null to remove it. */
  media?: InputMaybe<CommentMediaInput>;
  /** Profiles mentioned in this comment's content. Up to 3 ids. */
  mentionedProfileIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CommunityPostCommentUpdateManyWithoutCommunityClubNestedInput = {
  connect?: InputMaybe<Array<CommunityPostCommentWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CommunityPostCommentWhereUniqueInput>>;
};

export type CommunityPostCommentUpdateManyWithoutCommunityPostNestedInput = {
  connect?: InputMaybe<Array<CommunityPostCommentWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CommunityPostCommentWhereUniqueInput>>;
};

export type CommunityPostCommentUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<CommunityPostCommentWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CommunityPostCommentWhereUniqueInput>>;
};

export type CommunityPostCommentWhereInput = {
  AND?: InputMaybe<Array<CommunityPostCommentWhereInput>>;
  NOT?: InputMaybe<Array<CommunityPostCommentWhereInput>>;
  OR?: InputMaybe<Array<CommunityPostCommentWhereInput>>;
  activities?: InputMaybe<ActivityListRelationFilter>;
  communityClub?: InputMaybe<CommunityClubNullableScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidNullableFilter>;
  communityPost?: InputMaybe<CommunityPostNullableScalarRelationFilter>;
  communityPostCommentLikes?: InputMaybe<CommunityPostCommentLikeListRelationFilter>;
  content?: InputMaybe<StringFilter>;
  customer?: InputMaybe<CustomerNullableScalarRelationFilter>;
  customerId?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  mediaDurationSeconds?: InputMaybe<IntNullableFilter>;
  mediaKey?: InputMaybe<StringNullableFilter>;
  mediaThumbnailUrl?: InputMaybe<StringNullableFilter>;
  mediaType?: InputMaybe<EnumMediaTypeNullableFilter>;
  mediaUrl?: InputMaybe<StringNullableFilter>;
  parentComment?: InputMaybe<CommunityPostCommentNullableScalarRelationFilter>;
  parentCommentId?: InputMaybe<UuidNullableFilter>;
  postId?: InputMaybe<UuidNullableFilter>;
  profile?: InputMaybe<ProfileNullableScalarRelationFilter>;
  profileId?: InputMaybe<UuidNullableFilter>;
  replies?: InputMaybe<CommunityPostCommentListRelationFilter>;
  reports?: InputMaybe<ReportListRelationFilter>;
  userPost?: InputMaybe<UserPostNullableScalarRelationFilter>;
  userPostId?: InputMaybe<UuidNullableFilter>;
};

export type CommunityPostCommentWhereUniqueInput = {
  AND?: InputMaybe<Array<CommunityPostCommentWhereInput>>;
  NOT?: InputMaybe<Array<CommunityPostCommentWhereInput>>;
  OR?: InputMaybe<Array<CommunityPostCommentWhereInput>>;
  activities?: InputMaybe<ActivityListRelationFilter>;
  communityClub?: InputMaybe<CommunityClubNullableScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidNullableFilter>;
  communityPost?: InputMaybe<CommunityPostNullableScalarRelationFilter>;
  communityPostCommentLikes?: InputMaybe<CommunityPostCommentLikeListRelationFilter>;
  content?: InputMaybe<StringFilter>;
  customer?: InputMaybe<CustomerNullableScalarRelationFilter>;
  customerId?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  mediaDurationSeconds?: InputMaybe<IntNullableFilter>;
  mediaKey?: InputMaybe<StringNullableFilter>;
  mediaThumbnailUrl?: InputMaybe<StringNullableFilter>;
  mediaType?: InputMaybe<EnumMediaTypeNullableFilter>;
  mediaUrl?: InputMaybe<StringNullableFilter>;
  parentComment?: InputMaybe<CommunityPostCommentNullableScalarRelationFilter>;
  parentCommentId?: InputMaybe<UuidNullableFilter>;
  postId?: InputMaybe<UuidNullableFilter>;
  profile?: InputMaybe<ProfileNullableScalarRelationFilter>;
  profileId?: InputMaybe<UuidNullableFilter>;
  replies?: InputMaybe<CommunityPostCommentListRelationFilter>;
  reports?: InputMaybe<ReportListRelationFilter>;
  userPost?: InputMaybe<UserPostNullableScalarRelationFilter>;
  userPostId?: InputMaybe<UuidNullableFilter>;
};

export type CommunityPostCount = {
  __typename: 'CommunityPostCount';
  communityPostComments: Scalars['Int']['output'];
  communityPostLikes: Scalars['Int']['output'];
};

export type CommunityPostCountAggregate = {
  __typename: 'CommunityPostCountAggregate';
  _all: Scalars['Int']['output'];
  content: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  editedAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  postedAt: Scalars['Int']['output'];
  s3ImageUrl: Scalars['Int']['output'];
  s3Key: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CommunityPostCreateInput = {
  bookingStatuses?: InputMaybe<Array<CommunityEventBookingStatus>>;
  communityClub: CommunityClubCreateNestedOneWithoutCommunityPostsInput;
  communityPostComments?: InputMaybe<CommunityPostCommentCreateNestedManyWithoutCommunityPostInput>;
  communityPostLikes?: InputMaybe<CommunityPostLikeCreateNestedManyWithoutCommunityPostInput>;
  content: Scalars['String']['input'];
  eventId?: InputMaybe<Scalars['String']['input']>;
  headerImage?: InputMaybe<ImageInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  postedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sendPush?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CommunityPostCreateNestedManyWithoutAuthorInput = {
  connect?: InputMaybe<Array<CommunityPostWhereUniqueInput>>;
};

export type CommunityPostCreateNestedManyWithoutCommunityClubInput = {
  connect?: InputMaybe<Array<CommunityPostWhereUniqueInput>>;
};

export type CommunityPostCreateNestedOneWithoutCommunityPostCommentsInput = {
  connect: CommunityPostWhereUniqueInput;
};

export type CommunityPostLike = {
  __typename: 'CommunityPostLike';
  communityClub?: Maybe<CommunityClub>;
  communityPost?: Maybe<CommunityPost>;
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<Customer>;
  id: Scalars['UUID']['output'];
  profile?: Maybe<Profile>;
  userPost?: Maybe<UserPost>;
};

export type CommunityPostLikeCountAggregate = {
  __typename: 'CommunityPostLikeCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export type CommunityPostLikeCreateNestedManyWithoutCommunityClubInput = {
  connect?: InputMaybe<Array<CommunityPostLikeWhereUniqueInput>>;
};

export type CommunityPostLikeCreateNestedManyWithoutCommunityPostInput = {
  connect?: InputMaybe<Array<CommunityPostLikeWhereUniqueInput>>;
};

export type CommunityPostLikeListRelationFilter = {
  every?: InputMaybe<CommunityPostLikeWhereInput>;
  none?: InputMaybe<CommunityPostLikeWhereInput>;
  some?: InputMaybe<CommunityPostLikeWhereInput>;
};

export type CommunityPostLikeMaxAggregate = {
  __typename: 'CommunityPostLikeMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
};

export type CommunityPostLikeMinAggregate = {
  __typename: 'CommunityPostLikeMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
};

export type CommunityPostLikeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CommunityPostLikeOrderByWithRelationInput = {
  communityClub?: InputMaybe<CommunityClubOrderByWithRelationInput>;
  communityClubId?: InputMaybe<SortOrderInput>;
  communityPost?: InputMaybe<CommunityPostOrderByWithRelationInput>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  postId?: InputMaybe<SortOrderInput>;
  profile?: InputMaybe<ProfileOrderByWithRelationInput>;
  profileId?: InputMaybe<SortOrderInput>;
  userPost?: InputMaybe<UserPostOrderByWithRelationInput>;
  userPostId?: InputMaybe<SortOrderInput>;
};

export type CommunityPostLikePostIdCustomerIdCompoundUniqueInput = {
  customerId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};

export enum CommunityPostLikeScalarFieldEnum {
  CommunityClubId = 'communityClubId',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  Id = 'id',
  PostId = 'postId',
  ProfileId = 'profileId',
  UserPostId = 'userPostId'
}

export type CommunityPostLikeUpdateManyWithoutCommunityClubNestedInput = {
  connect?: InputMaybe<Array<CommunityPostLikeWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CommunityPostLikeWhereUniqueInput>>;
};

export type CommunityPostLikeUpdateManyWithoutCommunityPostNestedInput = {
  connect?: InputMaybe<Array<CommunityPostLikeWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CommunityPostLikeWhereUniqueInput>>;
};

export type CommunityPostLikeUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<CommunityPostLikeWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CommunityPostLikeWhereUniqueInput>>;
};

export type CommunityPostLikeUserPostIdProfileIdCompoundUniqueInput = {
  profileId: Scalars['String']['input'];
  userPostId: Scalars['String']['input'];
};

export type CommunityPostLikeWhereInput = {
  AND?: InputMaybe<Array<CommunityPostLikeWhereInput>>;
  NOT?: InputMaybe<Array<CommunityPostLikeWhereInput>>;
  OR?: InputMaybe<Array<CommunityPostLikeWhereInput>>;
  communityClub?: InputMaybe<CommunityClubNullableScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidNullableFilter>;
  communityPost?: InputMaybe<CommunityPostNullableScalarRelationFilter>;
  customer?: InputMaybe<CustomerNullableScalarRelationFilter>;
  customerId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  postId?: InputMaybe<UuidNullableFilter>;
  profile?: InputMaybe<ProfileNullableScalarRelationFilter>;
  profileId?: InputMaybe<UuidNullableFilter>;
  userPost?: InputMaybe<UserPostNullableScalarRelationFilter>;
  userPostId?: InputMaybe<UuidNullableFilter>;
};

export type CommunityPostLikeWhereUniqueInput = {
  AND?: InputMaybe<Array<CommunityPostLikeWhereInput>>;
  NOT?: InputMaybe<Array<CommunityPostLikeWhereInput>>;
  OR?: InputMaybe<Array<CommunityPostLikeWhereInput>>;
  communityClub?: InputMaybe<CommunityClubNullableScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidNullableFilter>;
  communityPost?: InputMaybe<CommunityPostNullableScalarRelationFilter>;
  customer?: InputMaybe<CustomerNullableScalarRelationFilter>;
  customerId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  postId?: InputMaybe<UuidNullableFilter>;
  postId_customerId?: InputMaybe<CommunityPostLikePostIdCustomerIdCompoundUniqueInput>;
  profile?: InputMaybe<ProfileNullableScalarRelationFilter>;
  profileId?: InputMaybe<UuidNullableFilter>;
  userPost?: InputMaybe<UserPostNullableScalarRelationFilter>;
  userPostId?: InputMaybe<UuidNullableFilter>;
  userPostId_profileId?: InputMaybe<CommunityPostLikeUserPostIdProfileIdCompoundUniqueInput>;
};

export type CommunityPostListRelationFilter = {
  every?: InputMaybe<CommunityPostWhereInput>;
  none?: InputMaybe<CommunityPostWhereInput>;
  some?: InputMaybe<CommunityPostWhereInput>;
};

export type CommunityPostMaxAggregate = {
  __typename: 'CommunityPostMaxAggregate';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  postedAt?: Maybe<Scalars['DateTime']['output']>;
  s3ImageUrl?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityPostMinAggregate = {
  __typename: 'CommunityPostMinAggregate';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  postedAt?: Maybe<Scalars['DateTime']['output']>;
  s3ImageUrl?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityPostNullableScalarRelationFilter = {
  is?: InputMaybe<CommunityPostWhereInput>;
  isNot?: InputMaybe<CommunityPostWhereInput>;
};

export type CommunityPostOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CommunityPostOrderByWithRelationInput = {
  author?: InputMaybe<CompanyEmployeeOrderByWithRelationInput>;
  authorId?: InputMaybe<SortOrderInput>;
  communityClub?: InputMaybe<CommunityClubOrderByWithRelationInput>;
  communityClubId?: InputMaybe<SortOrder>;
  communityPostComments?: InputMaybe<CommunityPostCommentOrderByRelationAggregateInput>;
  communityPostLikes?: InputMaybe<CommunityPostLikeOrderByRelationAggregateInput>;
  content?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  postedAt?: InputMaybe<SortOrder>;
  s3ImageUrl?: InputMaybe<SortOrderInput>;
  s3Key?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrderInput>;
};

export enum CommunityPostScalarFieldEnum {
  AuthorId = 'authorId',
  CommunityClubId = 'communityClubId',
  CompanyId = 'companyId',
  Content = 'content',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  EditedAt = 'editedAt',
  Id = 'id',
  PostedAt = 'postedAt',
  S3ImageUrl = 's3ImageUrl',
  S3Key = 's3Key',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

export type CommunityPostUpdateInput = {
  author?: InputMaybe<CompanyEmployeeUpdateOneWithoutCommunityPostsNestedInput>;
  communityPostComments?: InputMaybe<CommunityPostCommentUpdateManyWithoutCommunityPostNestedInput>;
  communityPostLikes?: InputMaybe<CommunityPostLikeUpdateManyWithoutCommunityPostNestedInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  headerImage?: InputMaybe<ImageInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  postedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CommunityPostUpdateManyWithoutCommunityClubNestedInput = {
  connect?: InputMaybe<Array<CommunityPostWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CommunityPostWhereUniqueInput>>;
};

export type CommunityPostWhereInput = {
  AND?: InputMaybe<Array<CommunityPostWhereInput>>;
  NOT?: InputMaybe<Array<CommunityPostWhereInput>>;
  OR?: InputMaybe<Array<CommunityPostWhereInput>>;
  author?: InputMaybe<CompanyEmployeeNullableScalarRelationFilter>;
  authorId?: InputMaybe<StringNullableFilter>;
  communityClub?: InputMaybe<CommunityClubScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidFilter>;
  communityPostComments?: InputMaybe<CommunityPostCommentListRelationFilter>;
  communityPostLikes?: InputMaybe<CommunityPostLikeListRelationFilter>;
  content?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  postedAt?: InputMaybe<DateTimeFilter>;
  s3ImageUrl?: InputMaybe<StringNullableFilter>;
  s3Key?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
};

export type CommunityPostWhereUniqueInput = {
  AND?: InputMaybe<Array<CommunityPostWhereInput>>;
  NOT?: InputMaybe<Array<CommunityPostWhereInput>>;
  OR?: InputMaybe<Array<CommunityPostWhereInput>>;
  author?: InputMaybe<CompanyEmployeeNullableScalarRelationFilter>;
  authorId?: InputMaybe<StringNullableFilter>;
  communityClub?: InputMaybe<CommunityClubScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidFilter>;
  communityPostComments?: InputMaybe<CommunityPostCommentListRelationFilter>;
  communityPostLikes?: InputMaybe<CommunityPostLikeListRelationFilter>;
  content?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  postedAt?: InputMaybe<DateTimeFilter>;
  s3ImageUrl?: InputMaybe<StringNullableFilter>;
  s3Key?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
};

export type Company = {
  __typename: 'Company';
  /** The commission rate for the company. */
  comission: Scalars['Float']['output'];
  /** The list of community clubs owned by the company. */
  communityClubs?: Maybe<Array<CommunityClub>>;
  /** The list of community event partners. */
  communityEventPartners?: Maybe<Array<CommunityEventPartner>>;
  /** The company billings (invoices) issued to this company. */
  companyBillings?: Maybe<Array<CompanyBilling>>;
  companyCustomers?: Maybe<Array<CustomerCompany>>;
  contract?: Maybe<Array<Contract>>;
  countryCode: Scalars['CountryCode']['output'];
  /** The list of coupons from the company. */
  coupon?: Maybe<Array<Coupon>>;
  /** The date and time when the company record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The CRM tenant name */
  crmTenant?: Maybe<Scalars['String']['output']>;
  customerCommunityClubs?: Maybe<Array<CustomerCommunityClub>>;
  customerGyms?: Maybe<Array<CustomerGym>>;
  /** The email address of the company. */
  email: Scalars['EmailAddress']['output'];
  /** The list of employees working for the company. */
  employees?: Maybe<Array<CompanyEmployee>>;
  /** The URL to the generel terms */
  generalTerms?: Maybe<Scalars['String']['output']>;
  /** The list of gyms owned by the company. */
  gyms?: Maybe<Array<Gym>>;
  /** The gym highlight orders placed by this company. */
  highlightOrders?: Maybe<Array<GymHighlightOrder>>;
  /** The house number of the company's location. */
  houseNumber: Scalars['String']['output'];
  /** The unique identifier for the company. */
  id: Scalars['ID']['output'];
  /** The URL to the imprint */
  imprint?: Maybe<Scalars['String']['output']>;
  /** The url to the logo of the company */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** The name of the company. */
  name: Scalars['String']['output'];
  /** The connection of the organization */
  organizationConnection?: Maybe<Scalars['String']['output']>;
  /** The unique organization name of the company. */
  organizationName: Scalars['String']['output'];
  /** The city or town where the company is located. */
  place: Scalars['String']['output'];
  /** The hexcode for primaray color */
  primaryColor?: Maybe<Scalars['String']['output']>;
  /** The URL to the privacy policy */
  privacyPolicy?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<Profile>;
  /** all promotion codes that are only available at this company */
  promotionCodes?: Maybe<Array<PromotionCode>>;
  promotions?: Maybe<Array<Promotion>>;
  pushNotifications?: Maybe<Array<PushNotification>>;
  ratingQuestions?: Maybe<Array<RatingQuestion>>;
  /** The hexcode for primaray color */
  secondaryColor?: Maybe<Scalars['String']['output']>;
  /** The street name of the company's location. */
  street: Scalars['String']['output'];
  /**
   * The Stripe customer id used as the invoice recipient for gym highlight purchases.
   * Created lazily on the company's first highlight checkout and reused afterwards.
   */
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  /** The date and time when the company record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The postal code of the company's location. */
  zipcode: Scalars['String']['output'];
};


export type CompanyPromotionCodesArgs = {
  cursor?: InputMaybe<PromotionCodeWhereUniqueInput>;
  distinct?: InputMaybe<Array<PromotionCodeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PromotionCodeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PromotionCodeWhereInput>;
};

export type CompanyAvgAggregate = {
  __typename: 'CompanyAvgAggregate';
  comission?: Maybe<Scalars['Float']['output']>;
};

/**
 * Supertype for all company-facing (B2B) invoices across features - the company counterpart to
 * CustomerBilling. Owns the shared, yearly-reset number circle and everything common to a company
 * invoice. Each feature entity is a subtype that holds a 1:1 foreign key to this table (the FK lives
 * on the subtype), so this table never grows a column when a new feature is added - only a new
 * `sourceType` value. The running number is assigned by the database from a standalone sequence.
 * Exception: a COMMUNITY_EVENT_REFUND_FEES invoice bills many refunded tickets at once, so there the
 * relation is n:1 (CommunityEventTicket.refundFeeBillingId, many tickets per billing).
 */
export type CompanyBilling = {
  __typename: 'CompanyBilling';
  /** The company the invoice was issued to. */
  company: Company;
  /** The date and time when the record was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * The invoice date (legal "Rechnungsdatum"). Explicit business field mirroring CustomerBilling.dateOfInvoice
   * (kept distinct from createdAt on purpose: for pay-later flows it differs from the paid date/creation).
   */
  dateOfInvoice: Scalars['DateTime']['output'];
  /** Subtype back-relation for the gym-highlight feature (1:1). Virtual - no column on this table. */
  gymHighlightOrder?: Maybe<GymHighlightOrder>;
  /** The unique identifier for the invoice record. */
  id: Scalars['UUID']['output'];
  /**
   * The composed, human-readable invoice number. Derived from year +
   * sequenceNumber and set at issuance (right after insert, once the db-assigned number is known).
   */
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  /** The date and time the payment was received. Null while unpaid (relevant for pay-later flows). */
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  /** The Stripe invoice PDF link (invoice.invoice_pdf), stored after finalization. */
  pdfKey?: Maybe<Scalars['String']['output']>;
  /**
   * The running number within the year. Assigned by the database from the Prisma-managed
   * auto-increment sequence `company_billing_sequence_number_seq` - fires automatically on insert,
   * no app code. A pg_cron job resets that sequence to 1 every year (see migration).
   */
  sequenceNumber: Scalars['Int']['output'];
  /** Which feature this invoice originates from (discriminator; tells you which subtype to join). */
  sourceType: CompanyBillingSource;
  /** The id of the Stripe invoice this record corresponds to. */
  stripeInvoiceId?: Maybe<Scalars['String']['output']>;
  /** The invoiced total in cents (snapshot). */
  totalAmountInCents: Scalars['Int']['output'];
  /** The date and time when the record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The year of the number circle this invoice belongs to (part of the number's uniqueness). */
  year: Scalars['Int']['output'];
};

export type CompanyBillingAvgAggregate = {
  __typename: 'CompanyBillingAvgAggregate';
  sequenceNumber?: Maybe<Scalars['Float']['output']>;
  totalAmountInCents?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

export type CompanyBillingCountAggregate = {
  __typename: 'CompanyBillingCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  dateOfInvoice: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  invoiceNumber: Scalars['Int']['output'];
  paidAt: Scalars['Int']['output'];
  pdfKey: Scalars['Int']['output'];
  sequenceNumber: Scalars['Int']['output'];
  sourceType: Scalars['Int']['output'];
  stripeInvoiceId: Scalars['Int']['output'];
  totalAmountInCents: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type CompanyBillingCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<CompanyBillingWhereUniqueInput>>;
};

export type CompanyBillingListRelationFilter = {
  every?: InputMaybe<CompanyBillingWhereInput>;
  none?: InputMaybe<CompanyBillingWhereInput>;
  some?: InputMaybe<CompanyBillingWhereInput>;
};

export type CompanyBillingMaxAggregate = {
  __typename: 'CompanyBillingMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateOfInvoice?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  pdfKey?: Maybe<Scalars['String']['output']>;
  sequenceNumber?: Maybe<Scalars['Int']['output']>;
  sourceType?: Maybe<CompanyBillingSource>;
  stripeInvoiceId?: Maybe<Scalars['String']['output']>;
  totalAmountInCents?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type CompanyBillingMinAggregate = {
  __typename: 'CompanyBillingMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateOfInvoice?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  pdfKey?: Maybe<Scalars['String']['output']>;
  sequenceNumber?: Maybe<Scalars['Int']['output']>;
  sourceType?: Maybe<CompanyBillingSource>;
  stripeInvoiceId?: Maybe<Scalars['String']['output']>;
  totalAmountInCents?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type CompanyBillingNullableScalarRelationFilter = {
  is?: InputMaybe<CompanyBillingWhereInput>;
  isNot?: InputMaybe<CompanyBillingWhereInput>;
};

export type CompanyBillingOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CompanyBillingOrderByWithRelationInput = {
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  companyId?: InputMaybe<SortOrder>;
  gymHighlightOrder?: InputMaybe<GymHighlightOrderOrderByWithRelationInput>;
  id?: InputMaybe<SortOrder>;
  sourceType?: InputMaybe<SortOrder>;
  year?: InputMaybe<SortOrder>;
};

export enum CompanyBillingScalarFieldEnum {
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  DateOfInvoice = 'dateOfInvoice',
  Id = 'id',
  InvoiceNumber = 'invoiceNumber',
  PaidAt = 'paidAt',
  PdfKey = 'pdfKey',
  SequenceNumber = 'sequenceNumber',
  SourceType = 'sourceType',
  StripeInvoiceId = 'stripeInvoiceId',
  TotalAmountInCents = 'totalAmountInCents',
  UpdatedAt = 'updatedAt',
  Year = 'year'
}

/** Discriminator for the feature a company billing originates from. A new B2B feature = one new value. */
export enum CompanyBillingSource {
  /**
   * The invoice bills the Stripe fees of refunded or dispute-lost community event tickets to the
   * club's company.
   */
  CommunityEventRefundFees = 'COMMUNITY_EVENT_REFUND_FEES',
  /** The invoice was issued for a gym highlight order. */
  GymHighlight = 'GYM_HIGHLIGHT'
}

export type CompanyBillingSumAggregate = {
  __typename: 'CompanyBillingSumAggregate';
  sequenceNumber?: Maybe<Scalars['Int']['output']>;
  totalAmountInCents?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type CompanyBillingUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<CompanyBillingWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CompanyBillingWhereUniqueInput>>;
};

export type CompanyBillingWhereInput = {
  AND?: InputMaybe<Array<CompanyBillingWhereInput>>;
  NOT?: InputMaybe<Array<CompanyBillingWhereInput>>;
  OR?: InputMaybe<Array<CompanyBillingWhereInput>>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  gymHighlightOrder?: InputMaybe<GymHighlightOrderNullableScalarRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  sourceType?: InputMaybe<EnumCompanyBillingSourceFilter>;
  year?: InputMaybe<IntFilter>;
};

export type CompanyBillingWhereUniqueInput = {
  AND?: InputMaybe<Array<CompanyBillingWhereInput>>;
  NOT?: InputMaybe<Array<CompanyBillingWhereInput>>;
  OR?: InputMaybe<Array<CompanyBillingWhereInput>>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  gymHighlightOrder?: InputMaybe<GymHighlightOrderNullableScalarRelationFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  sourceType?: InputMaybe<EnumCompanyBillingSourceFilter>;
  year?: InputMaybe<IntFilter>;
  year_sequenceNumber?: InputMaybe<CompanyBillingYearSequenceNumberCompoundUniqueInput>;
};

export type CompanyBillingYearSequenceNumberCompoundUniqueInput = {
  year: Scalars['Int']['input'];
};

export type CompanyCountAggregate = {
  __typename: 'CompanyCountAggregate';
  _all: Scalars['Int']['output'];
  comission: Scalars['Int']['output'];
  countryCode: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  crmTenant: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  generalTerms: Scalars['Int']['output'];
  houseNumber: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  imprint: Scalars['Int']['output'];
  logoUrl: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  organizationConnection: Scalars['Int']['output'];
  organizationName: Scalars['Int']['output'];
  place: Scalars['Int']['output'];
  primaryColor: Scalars['Int']['output'];
  privacyPolicy: Scalars['Int']['output'];
  secondaryColor: Scalars['Int']['output'];
  street: Scalars['Int']['output'];
  stripeCustomerId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  zipcode: Scalars['Int']['output'];
};

export type CompanyCreateNestedOneWithoutCommunityClubsInput = {
  connect: CompanyWhereUniqueInput;
};

export type CompanyCreateNestedOneWithoutCouponInput = {
  connect: CompanyWhereUniqueInput;
};

export type CompanyCreateNestedOneWithoutGymsInput = {
  connect: CompanyWhereUniqueInput;
};

/** Non nullable company connect input */
export type CompanyCreateNestedOneWithoutPromotionsInput = {
  connect: CompanyWhereUniqueInput;
};

/** Non nullable company connect input */
export type CompanyCreateNestedOneWithoutPushNotificationsInput = {
  connect: CompanyWhereUniqueInput;
};

export type CompanyEmployee = {
  __typename: 'CompanyEmployee';
  communityClubs?: Maybe<Array<CommunityClub>>;
  communityPosts?: Maybe<Array<CommunityPost>>;
  company: Company;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['EmailAddress']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  gyms?: Maybe<Array<Gym>>;
  id: Scalars['ID']['output'];
  invitationAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** The employee's own Profile, null if they haven't created one yet. */
  profile?: Maybe<Profile>;
  status: EmployeeStatus;
  updatedAt: Scalars['DateTime']['output'];
  userType: EmployeeUserType;
};

export type CompanyEmployeeCountAggregate = {
  __typename: 'CompanyEmployeeCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  firstName: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  invitationAcceptedAt: Scalars['Int']['output'];
  lastName: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userType: Scalars['Int']['output'];
};

export type CompanyEmployeeCreateNestedManyWithoutCommunityClubsInput = {
  connect?: InputMaybe<Array<CompanyEmployeeWhereUniqueInput>>;
};

export type CompanyEmployeeCreateNestedManyWithoutGymsInput = {
  connect?: InputMaybe<Array<CompanyEmployeeWhereUniqueInput>>;
};

export type CompanyEmployeeEmployeeIdentifierCompoundUniqueInput = {
  companyId: Scalars['String']['input'];
  email: Scalars['EmailAddress']['input'];
};

export type CompanyEmployeeListRelationFilter = {
  every?: InputMaybe<CompanyEmployeeWhereInput>;
  none?: InputMaybe<CompanyEmployeeWhereInput>;
  some?: InputMaybe<CompanyEmployeeWhereInput>;
};

export type CompanyEmployeeMaxAggregate = {
  __typename: 'CompanyEmployeeMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invitationAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EmployeeStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userType?: Maybe<EmployeeUserType>;
};

export type CompanyEmployeeMinAggregate = {
  __typename: 'CompanyEmployeeMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invitationAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EmployeeStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userType?: Maybe<EmployeeUserType>;
};

export type CompanyEmployeeNullableScalarRelationFilter = {
  is?: InputMaybe<CompanyEmployeeWhereInput>;
  isNot?: InputMaybe<CompanyEmployeeWhereInput>;
};

export type CompanyEmployeeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CompanyEmployeeOrderByWithRelationInput = {
  communityClubs?: InputMaybe<CommunityClubOrderByRelationAggregateInput>;
  communityPosts?: InputMaybe<CommunityPostOrderByRelationAggregateInput>;
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  companyId?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrderInput>;
  gyms?: InputMaybe<GymOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrderInput>;
  profile?: InputMaybe<ProfileOrderByWithRelationInput>;
  status?: InputMaybe<SortOrder>;
  userType?: InputMaybe<SortOrder>;
};

export enum CompanyEmployeeScalarFieldEnum {
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  Email = 'email',
  FirstName = 'firstName',
  Id = 'id',
  InvitationAcceptedAt = 'invitationAcceptedAt',
  LastName = 'lastName',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  UserType = 'userType'
}

export type CompanyEmployeeUniqueInput = {
  AND?: InputMaybe<CompanyEmployeeWhereInput>;
  NOT?: InputMaybe<CompanyEmployeeWhereInput>;
  OR?: InputMaybe<CompanyEmployeeWhereInput>;
  communityClubs?: InputMaybe<CommunityClubListRelationFilter>;
  communityPosts?: InputMaybe<CommunityPostListRelationFilter>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  employeeIdentifier: CompanyEmployeeEmployeeIdentifierCompoundUniqueInput;
  firstName?: InputMaybe<StringNullableFilter>;
  gyms?: InputMaybe<GymListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<StringNullableFilter>;
  profile?: InputMaybe<ProfileNullableScalarRelationFilter>;
  status?: InputMaybe<EnumEmployeeStatusFilter>;
  userType?: InputMaybe<EnumEmployeeUserTypeFilter>;
};

/** Input for updating a company employee */
export type CompanyEmployeeUpdateInput = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyEmployeeUpdateManyWithoutCommunityClubsNestedInput = {
  connect?: InputMaybe<Array<CompanyEmployeeWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CompanyEmployeeWhereUniqueInput>>;
};

export type CompanyEmployeeUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<CompanyEmployeeWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CompanyEmployeeWhereUniqueInput>>;
};

export type CompanyEmployeeUpdateManyWithoutGymsNestedInput = {
  connect?: InputMaybe<Array<CompanyEmployeeWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CompanyEmployeeWhereUniqueInput>>;
};

export type CompanyEmployeeUpdateOneWithoutCommunityPostsNestedInput = {
  connect?: InputMaybe<CompanyEmployeeWhereUniqueInput>;
  disconnect?: InputMaybe<CompanyEmployeeWhereInput>;
};

export type CompanyEmployeeWhereInput = {
  AND?: InputMaybe<Array<CompanyEmployeeWhereInput>>;
  NOT?: InputMaybe<Array<CompanyEmployeeWhereInput>>;
  OR?: InputMaybe<Array<CompanyEmployeeWhereInput>>;
  communityClubs?: InputMaybe<CommunityClubListRelationFilter>;
  communityPosts?: InputMaybe<CommunityPostListRelationFilter>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  gyms?: InputMaybe<GymListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  profile?: InputMaybe<ProfileNullableScalarRelationFilter>;
  status?: InputMaybe<EnumEmployeeStatusFilter>;
  userType?: InputMaybe<EnumEmployeeUserTypeFilter>;
};

export type CompanyEmployeeWhereUniqueInput = {
  AND?: InputMaybe<Array<CompanyEmployeeWhereInput>>;
  NOT?: InputMaybe<Array<CompanyEmployeeWhereInput>>;
  OR?: InputMaybe<Array<CompanyEmployeeWhereInput>>;
  communityClubs?: InputMaybe<CommunityClubListRelationFilter>;
  communityPosts?: InputMaybe<CommunityPostListRelationFilter>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  employeeIdentifier?: InputMaybe<CompanyEmployeeEmployeeIdentifierCompoundUniqueInput>;
  firstName?: InputMaybe<StringNullableFilter>;
  gyms?: InputMaybe<GymListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<StringNullableFilter>;
  profile?: InputMaybe<ProfileNullableScalarRelationFilter>;
  status?: InputMaybe<EnumEmployeeStatusFilter>;
  userType?: InputMaybe<EnumEmployeeUserTypeFilter>;
};

export type CompanyMaxAggregate = {
  __typename: 'CompanyMaxAggregate';
  comission?: Maybe<Scalars['Float']['output']>;
  countryCode?: Maybe<Scalars['CountryCode']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  crmTenant?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  generalTerms?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imprint?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationConnection?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  place?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  privacyPolicy?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type CompanyMinAggregate = {
  __typename: 'CompanyMinAggregate';
  comission?: Maybe<Scalars['Float']['output']>;
  countryCode?: Maybe<Scalars['CountryCode']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  crmTenant?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  generalTerms?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imprint?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationConnection?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  place?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  privacyPolicy?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type CompanyNullableScalarRelationFilter = {
  is?: InputMaybe<CompanyWhereInput>;
  isNot?: InputMaybe<CompanyWhereInput>;
};

export type CompanyOrderByWithRelationInput = {
  comission?: InputMaybe<SortOrder>;
  communityClubs?: InputMaybe<CommunityClubOrderByRelationAggregateInput>;
  communityEventPartners?: InputMaybe<CommunityEventPartnerOrderByRelationAggregateInput>;
  companyBillings?: InputMaybe<CompanyBillingOrderByRelationAggregateInput>;
  companyCustomers?: InputMaybe<CustomerCompanyOrderByRelationAggregateInput>;
  contract?: InputMaybe<ContractOrderByRelationAggregateInput>;
  countryCode?: InputMaybe<SortOrder>;
  coupon?: InputMaybe<CouponOrderByRelationAggregateInput>;
  crmTenant?: InputMaybe<SortOrderInput>;
  customerCommunityClubs?: InputMaybe<CustomerCommunityClubOrderByRelationAggregateInput>;
  customerGyms?: InputMaybe<CustomerGymOrderByRelationAggregateInput>;
  email?: InputMaybe<SortOrder>;
  employees?: InputMaybe<CompanyEmployeeOrderByRelationAggregateInput>;
  generalTerms?: InputMaybe<SortOrderInput>;
  gyms?: InputMaybe<GymOrderByRelationAggregateInput>;
  highlightOrders?: InputMaybe<GymHighlightOrderOrderByRelationAggregateInput>;
  houseNumber?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imprint?: InputMaybe<SortOrderInput>;
  logoUrl?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  organizationConnection?: InputMaybe<SortOrderInput>;
  organizationName?: InputMaybe<SortOrder>;
  place?: InputMaybe<SortOrder>;
  primaryColor?: InputMaybe<SortOrderInput>;
  privacyPolicy?: InputMaybe<SortOrderInput>;
  profile?: InputMaybe<ProfileOrderByWithRelationInput>;
  promotionCodes?: InputMaybe<PromotionCodeOrderByRelationAggregateInput>;
  promotions?: InputMaybe<PromotionOrderByRelationAggregateInput>;
  pushNotifications?: InputMaybe<PushNotificationOrderByRelationAggregateInput>;
  ratingQuestions?: InputMaybe<RatingQuestionOrderByRelationAggregateInput>;
  secondaryColor?: InputMaybe<SortOrderInput>;
  street?: InputMaybe<SortOrder>;
  zipcode?: InputMaybe<SortOrder>;
};

/** Input for creating the company/brand Profile. Unlike the personal Profile, isPrivate is not supported -- brands are always publicly discoverable/followable. */
export type CompanyProfileCreateInput = {
  /** The avatar image */
  avatarImage?: InputMaybe<ImageInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  /** The actor's full name shown on the Profile. Defaults to the value derived from Customer/CompanyEmployee if omitted. */
  fullName?: InputMaybe<Scalars['String']['input']>;
  handle: Scalars['String']['input'];
  place?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating the company/brand Profile. Unlike the personal Profile, isPrivate is not supported -- brands are always publicly discoverable/followable. */
export type CompanyProfileUpdateInput = {
  /** The avatar image */
  avatarImage?: InputMaybe<ImageInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  /** The actor's full name shown on the Profile. Pass null to clear it. */
  fullName?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
};

export enum CompanyScalarFieldEnum {
  Comission = 'comission',
  CountryCode = 'countryCode',
  CreatedAt = 'createdAt',
  CrmTenant = 'crmTenant',
  Email = 'email',
  GeneralTerms = 'generalTerms',
  HouseNumber = 'houseNumber',
  Id = 'id',
  Imprint = 'imprint',
  LogoUrl = 'logoUrl',
  Name = 'name',
  OrganizationConnection = 'organizationConnection',
  OrganizationName = 'organizationName',
  Place = 'place',
  PrimaryColor = 'primaryColor',
  PrivacyPolicy = 'privacyPolicy',
  SecondaryColor = 'secondaryColor',
  Street = 'street',
  StripeCustomerId = 'stripeCustomerId',
  UpdatedAt = 'updatedAt',
  Zipcode = 'zipcode'
}

export type CompanyScalarRelationFilter = {
  is?: InputMaybe<CompanyWhereInput>;
  isNot?: InputMaybe<CompanyWhereInput>;
};

export type CompanySumAggregate = {
  __typename: 'CompanySumAggregate';
  comission?: Maybe<Scalars['Float']['output']>;
};

export type CompanyUpdateInput = {
  comission?: InputMaybe<Scalars['Float']['input']>;
  communityClubs?: InputMaybe<CommunityClubUpdateManyWithoutCompanyNestedInput>;
  communityEventPartners?: InputMaybe<CommunityEventPartnerUpdateManyWithoutCompanyNestedInput>;
  companyBillings?: InputMaybe<CompanyBillingUpdateManyWithoutCompanyNestedInput>;
  companyCustomers?: InputMaybe<CustomerCompanyUpdateManyWithoutCompanyNestedInput>;
  contract?: InputMaybe<ContractUpdateManyWithoutCompanyNestedInput>;
  countryCode?: InputMaybe<Scalars['CountryCode']['input']>;
  coupon?: InputMaybe<CouponUpdateManyWithoutCompanyNestedInput>;
  crmTenant?: InputMaybe<Scalars['String']['input']>;
  customerCommunityClubs?: InputMaybe<CustomerCommunityClubUpdateManyWithoutCompanyNestedInput>;
  customerGyms?: InputMaybe<CustomerGymUpdateManyWithoutCompanyNestedInput>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  employees?: InputMaybe<CompanyEmployeeUpdateManyWithoutCompanyNestedInput>;
  generalTerms?: InputMaybe<Scalars['String']['input']>;
  gyms?: InputMaybe<GymUpdateManyWithoutCompanyNestedInput>;
  highlightOrders?: InputMaybe<GymHighlightOrderUpdateManyWithoutCompanyNestedInput>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imprint?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationConnection?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  privacyPolicy?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<ProfileUpdateOneWithoutCompanyNestedInput>;
  promotionCodes?: InputMaybe<PromotionCodeUpdateManyWithoutCompanyNestedInput>;
  promotions?: InputMaybe<PromotionUpdateManyWithoutCompanyNestedInput>;
  pushNotifications?: InputMaybe<PushNotificationUpdateManyWithoutCompanyNestedInput>;
  ratingQuestions?: InputMaybe<RatingQuestionUpdateManyWithoutCompanyNestedInput>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyUpdateOneRequiredWithoutCouponNestedInput = {
  connect?: InputMaybe<CompanyWhereUniqueInput>;
};

export type CompanyWhereInput = {
  AND?: InputMaybe<Array<CompanyWhereInput>>;
  NOT?: InputMaybe<Array<CompanyWhereInput>>;
  OR?: InputMaybe<Array<CompanyWhereInput>>;
  comission?: InputMaybe<FloatFilter>;
  communityClubs?: InputMaybe<CommunityClubListRelationFilter>;
  communityEventPartners?: InputMaybe<CommunityEventPartnerListRelationFilter>;
  companyBillings?: InputMaybe<CompanyBillingListRelationFilter>;
  companyCustomers?: InputMaybe<CustomerCompanyListRelationFilter>;
  contract?: InputMaybe<ContractListRelationFilter>;
  countryCode?: InputMaybe<StringFilter>;
  coupon?: InputMaybe<CouponListRelationFilter>;
  crmTenant?: InputMaybe<StringNullableFilter>;
  customerCommunityClubs?: InputMaybe<CustomerCommunityClubListRelationFilter>;
  customerGyms?: InputMaybe<CustomerGymListRelationFilter>;
  email?: InputMaybe<StringFilter>;
  employees?: InputMaybe<CompanyEmployeeListRelationFilter>;
  generalTerms?: InputMaybe<StringNullableFilter>;
  gyms?: InputMaybe<GymListRelationFilter>;
  highlightOrders?: InputMaybe<GymHighlightOrderListRelationFilter>;
  houseNumber?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  imprint?: InputMaybe<StringNullableFilter>;
  logoUrl?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  organizationConnection?: InputMaybe<StringNullableFilter>;
  organizationName?: InputMaybe<StringFilter>;
  place?: InputMaybe<StringFilter>;
  primaryColor?: InputMaybe<StringNullableFilter>;
  privacyPolicy?: InputMaybe<StringNullableFilter>;
  profile?: InputMaybe<ProfileNullableScalarRelationFilter>;
  promotionCodes?: InputMaybe<PromotionCodeListRelationFilter>;
  promotions?: InputMaybe<PromotionListRelationFilter>;
  pushNotifications?: InputMaybe<PushNotificationListRelationFilter>;
  ratingQuestions?: InputMaybe<RatingQuestionListRelationFilter>;
  secondaryColor?: InputMaybe<StringNullableFilter>;
  street?: InputMaybe<StringFilter>;
  zipcode?: InputMaybe<StringFilter>;
};

export type CompanyWhereUniqueInput = {
  AND?: InputMaybe<Array<CompanyWhereInput>>;
  NOT?: InputMaybe<Array<CompanyWhereInput>>;
  OR?: InputMaybe<Array<CompanyWhereInput>>;
  comission?: InputMaybe<FloatFilter>;
  communityClubs?: InputMaybe<CommunityClubListRelationFilter>;
  communityEventPartners?: InputMaybe<CommunityEventPartnerListRelationFilter>;
  companyBillings?: InputMaybe<CompanyBillingListRelationFilter>;
  companyCustomers?: InputMaybe<CustomerCompanyListRelationFilter>;
  contract?: InputMaybe<ContractListRelationFilter>;
  countryCode?: InputMaybe<StringFilter>;
  coupon?: InputMaybe<CouponListRelationFilter>;
  crmTenant?: InputMaybe<StringNullableFilter>;
  customerCommunityClubs?: InputMaybe<CustomerCommunityClubListRelationFilter>;
  customerGyms?: InputMaybe<CustomerGymListRelationFilter>;
  email?: InputMaybe<StringFilter>;
  employees?: InputMaybe<CompanyEmployeeListRelationFilter>;
  generalTerms?: InputMaybe<StringNullableFilter>;
  gyms?: InputMaybe<GymListRelationFilter>;
  highlightOrders?: InputMaybe<GymHighlightOrderListRelationFilter>;
  houseNumber?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  imprint?: InputMaybe<StringNullableFilter>;
  logoUrl?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  organizationConnection?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<StringFilter>;
  primaryColor?: InputMaybe<StringNullableFilter>;
  privacyPolicy?: InputMaybe<StringNullableFilter>;
  profile?: InputMaybe<ProfileNullableScalarRelationFilter>;
  promotionCodes?: InputMaybe<PromotionCodeListRelationFilter>;
  promotions?: InputMaybe<PromotionListRelationFilter>;
  pushNotifications?: InputMaybe<PushNotificationListRelationFilter>;
  ratingQuestions?: InputMaybe<RatingQuestionListRelationFilter>;
  secondaryColor?: InputMaybe<StringNullableFilter>;
  street?: InputMaybe<StringFilter>;
  zipcode?: InputMaybe<StringFilter>;
};

/** Input for completing a ticket reservation's payment (payment webhook). */
export type CompleteCommunityEventTicketPaymentInput = {
  /** The paid reservation, from the session's metadata communityEventReservationId. */
  reservationId: Scalars['UUID']['input'];
  /** The Stripe customer of the checkout session. */
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  /** The payment intent of the checkout session; stored on the ticket for refunds and disputes. */
  stripePaymentIntentId: Scalars['String']['input'];
};

/** Input for marking a company invoice paid. */
export type CompleteCompanyBillingPaymentInput = {
  /** The company billing from the invoice's metadata. */
  companyBillingId: Scalars['UUID']['input'];
};

/** Input for completing a highlight order's payment (payment webhook). */
export type CompleteGymHighlightOrderPaymentInput = {
  /** The highlight order that was paid. */
  orderId: Scalars['UUID']['input'];
  /** The Stripe customer id created/used by the checkout session. */
  stripeCustomerId: Scalars['String']['input'];
  /** The payment intent of the checkout session that collected the payment. When provided, it is attached to the issued invoice so it is paid by that charge instead of out-of-band. */
  stripePaymentIntentId?: InputMaybe<Scalars['String']['input']>;
};

export type ComputedRating = {
  __typename: 'ComputedRating';
  type?: Maybe<ComputedRatingType>;
  value: Scalars['Float']['output'];
};

/** Possible rating types */
export enum ComputedRatingType {
  Average = 'AVERAGE',
  Percentage = 'PERCENTAGE'
}

/** Result of a customer confirming the entry of their active training session without a device */
export type ConfirmEntryForActiveTraining = {
  __typename: 'ConfirmEntryForActiveTraining';
  /** The request identifier of the persisted access event */
  requestId: Scalars['UUID']['output'];
  /** The training session the entry was confirmed for */
  trainingSessionId: Scalars['UUID']['output'];
};

/** Input to confirm the entry of the customer's active training session without a device */
export type ConfirmEntryForActiveTrainingInput = {
  /** The gym in which the customer has an active training session */
  gymId: Scalars['UUID']['input'];
};

export type ConnectApiContractDataDto = {
  contractSignature?: InputMaybe<PublicApiSignatureDto>;
  notes?: InputMaybe<Scalars['String']['input']>;
  optionalRateBundleTermModules?: InputMaybe<Array<PublicApiSelectedOptionalRateBundleModuleDto>>;
  preuseDate?: InputMaybe<Scalars['String']['input']>;
  rateBundleTermId: Scalars['Float']['input'];
  selectedRateBundleModules?: InputMaybe<Array<PublicApiSelectedSelectableRateBundleModuleDto>>;
  sepaSignature?: InputMaybe<PublicApiSignatureDto>;
  startDate: Scalars['String']['input'];
  textBlockSignatures?: InputMaybe<Array<PublicApiSignatureDto>>;
};

export type ConnectApiCreatePublicCustomerDto = {
  additionalAddressInformation?: InputMaybe<Scalars['String']['input']>;
  bankAccount?: InputMaybe<PublicApiBankAccountDto>;
  city: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  creditCard?: InputMaybe<PublicApiCreditCardDto>;
  dateOfBirth: Scalars['String']['input'];
  documentIdentification?: InputMaybe<PublicApiDocumentIdentificationDto>;
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  gender?: InputMaybe<Gender>;
  houseNumber: Scalars['String']['input'];
  identityToken?: InputMaybe<Scalars['String']['input']>;
  lastname: Scalars['String']['input'];
  paymentChoice: PaymentChoice;
  street: Scalars['String']['input'];
  telephone_mobile?: InputMaybe<Scalars['String']['input']>;
  telephone_private?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['Float']['input'];
};

export type ConnectApiFollowUpActionTokenDto = {
  __typename: 'ConnectApiFollowUpActionTokenDto';
  token: Scalars['String']['output'];
  tokenValidUntil: Scalars['String']['output'];
};

export type ConnectApiRateBundle = {
  __typename: 'ConnectApiRateBundle';
  allowedPaymentChoices: Array<PaymentChoiceContract>;
  contractSignaturesRequired: Scalars['Boolean']['output'];
  contractTextBlocks: Array<ConnectApiSignableTextBlock>;
  description: Scalars['String']['output'];
  footnote?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  initialPaymentRequired: Scalars['Boolean']['output'];
  maximumNumberOfSelectableModules: Scalars['Float']['output'];
  modules: Array<ConnectApiRateBundleModule>;
  name: Scalars['String']['output'];
  onlinePaymentType: OnlinePaymentType;
  preuseType: PreuseType;
  selectableModules: Array<ConnectApiRateBundleModule>;
  subDescription?: Maybe<Scalars['String']['output']>;
  terms: Array<ConnectApiRateBundleTerm>;
};

export type ConnectApiRateBundleModule = {
  __typename: 'ConnectApiRateBundleModule';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  paymentFrequencyDto: PaymentFrequencyDto;
  paymentFrequencyId: Scalars['Float']['output'];
};

export type ConnectApiRateBundleTerm = {
  __typename: 'ConnectApiRateBundleTerm';
  cancelationStrategy: CancelationStrategy;
  cancellationPeriod: Scalars['Float']['output'];
  cancellationPeriodUnit: TermUnit;
  contractStartDateOfUse?: Maybe<Scalars['String']['output']>;
  defaultContractStartDate?: Maybe<Scalars['String']['output']>;
  extensionType: ExtensionType;
  id: Scalars['Float']['output'];
  optionalModules: Array<ConnectApiRateBundleModule>;
  paymentFrequencyDto: PaymentFrequencyDto;
  term: TermDto;
  termUnit: TermUnit;
  termValue: Scalars['Float']['output'];
  termValueWithoutBonusPeriod: Scalars['Float']['output'];
};

export type ConnectApiSignableTextBlock = {
  __typename: 'ConnectApiSignableTextBlock';
  id: Scalars['Float']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/**
 * A B2C invoice to a customer, independent of what it bills: the B2C counterpart of CompanyBilling.
 * sourceType says which feature it comes from; the source entity points here, not the other way
 * around. One yearly number circle for all sources. CustomerBilling (training sessions) can't be
 * reused: its id restarts every year and its primary key requires a training session.
 */
export type ConsumerBilling = {
  __typename: 'ConsumerBilling';
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  /** Source back-relation for community event tickets (1:1). Virtual - no column on this table. */
  communityEventTicket?: Maybe<CommunityEventTicket>;
  company: Company;
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<Customer>;
  dateOfInvoice: Scalars['DateTime']['output'];
  /**
   * Stripe's hosted invoice URL. CustomerBilling and CompanyBilling store the same value in a legacy
   * field named pdfKey.
   */
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  /**
   * "CE-<year>-<week>-<sequence>" (e.g. "CE-2026-39-17"), one prefix for all sources; set at issuance, once the
   * database-assigned sequence number is known.
   */
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  /**
   * When the billed item was paid (for a ticket: the payment completion, issuedAt). Set once the
   * invoice is issued, so a set paidAt also means "issued".
   */
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Running number within the year. Assigned by the database; a pg_cron job resets the sequence at
   * 00:00 Europe/Berlin on January 1st (see migration).
   */
  sequenceNumber: Scalars['Int']['output'];
  /** Which feature this invoice comes from (discriminator; tells you which source relation is set). */
  sourceType: ConsumerBillingSource;
  totalAmountInCents: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /**
   * Year of the number circle (part of the invoice number's uniqueness), in Europe/Berlin time. Assigned by
   * the database in the same INSERT as sequenceNumber, so year and sequence come from the same clock and
   * can't straddle the yearly sequence reset. Never set it from the application; read it back from the row.
   * clock_timestamp() instead of now(): now() is the transaction start and would reopen the window for
   * long-running transactions.
   */
  year: Scalars['Int']['output'];
};

export type ConsumerBillingAvgAggregate = {
  __typename: 'ConsumerBillingAvgAggregate';
  sequenceNumber?: Maybe<Scalars['Float']['output']>;
  totalAmountInCents?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

export type ConsumerBillingCountAggregate = {
  __typename: 'ConsumerBillingCountAggregate';
  _all: Scalars['Int']['output'];
  canceledAt: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  dateOfInvoice: Scalars['Int']['output'];
  hostedInvoiceUrl: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  invoiceNumber: Scalars['Int']['output'];
  paidAt: Scalars['Int']['output'];
  sequenceNumber: Scalars['Int']['output'];
  sourceType: Scalars['Int']['output'];
  totalAmountInCents: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type ConsumerBillingMaxAggregate = {
  __typename: 'ConsumerBillingMaxAggregate';
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateOfInvoice?: Maybe<Scalars['DateTime']['output']>;
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  sequenceNumber?: Maybe<Scalars['Int']['output']>;
  sourceType?: Maybe<ConsumerBillingSource>;
  totalAmountInCents?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type ConsumerBillingMinAggregate = {
  __typename: 'ConsumerBillingMinAggregate';
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateOfInvoice?: Maybe<Scalars['DateTime']['output']>;
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  sequenceNumber?: Maybe<Scalars['Int']['output']>;
  sourceType?: Maybe<ConsumerBillingSource>;
  totalAmountInCents?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type ConsumerBillingNullableScalarRelationFilter = {
  is?: InputMaybe<ConsumerBillingWhereInput>;
  isNot?: InputMaybe<ConsumerBillingWhereInput>;
};

export type ConsumerBillingOrderByWithRelationInput = {
  communityEventTicket?: InputMaybe<CommunityEventTicketOrderByWithRelationInput>;
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  sourceType?: InputMaybe<SortOrder>;
};

/** Which feature a ConsumerBilling invoice comes from. */
export enum ConsumerBillingSource {
  /** The invoice bills a paid community event ticket. */
  CommunityEventTicket = 'COMMUNITY_EVENT_TICKET'
}

export type ConsumerBillingSumAggregate = {
  __typename: 'ConsumerBillingSumAggregate';
  sequenceNumber?: Maybe<Scalars['Int']['output']>;
  totalAmountInCents?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type ConsumerBillingWhereInput = {
  AND?: InputMaybe<Array<ConsumerBillingWhereInput>>;
  NOT?: InputMaybe<Array<ConsumerBillingWhereInput>>;
  OR?: InputMaybe<Array<ConsumerBillingWhereInput>>;
  communityEventTicket?: InputMaybe<CommunityEventTicketNullableScalarRelationFilter>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  customer?: InputMaybe<CustomerNullableScalarRelationFilter>;
  customerId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  sourceType?: InputMaybe<EnumConsumerBillingSourceFilter>;
};

export type Contract = {
  __typename: 'Contract';
  company: Company;
  companyId: Scalars['String']['output'];
  /** The date and time when the sended contract proposal record was created. */
  createdAt: Scalars['DateTime']['output'];
  crmContractId: Scalars['String']['output'];
  crmCustomerNumber: Scalars['String']['output'];
  customer: Customer;
  customerId: Scalars['String']['output'];
  dateOfBirth: Scalars['DateTime']['output'];
  /** The date and time when the sended contract proposal record was last updated. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  firstName: Scalars['String']['output'];
  gym: Gym;
  gymId: Scalars['String']['output'];
  /** The unique identifier for the sended contract proposal. */
  id: Scalars['UUID']['output'];
  lastName: Scalars['String']['output'];
  /** The company associated with the gym. */
  updatedAt: Scalars['DateTime']['output'];
};

export type ContractCountAggregate = {
  __typename: 'ContractCountAggregate';
  _all: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  crmContractId: Scalars['Int']['output'];
  crmCustomerNumber: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  dateOfBirth: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  firstName: Scalars['Int']['output'];
  gymId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ContractCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<ContractWhereUniqueInput>>;
};

export type ContractCreateNestedManyWithoutGymInput = {
  connect?: InputMaybe<Array<ContractWhereUniqueInput>>;
};

export type ContractDetails = {
  __typename: 'ContractDetails';
  companyName?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<ConnectApiRateBundle>;
  crmStudioId: Scalars['String']['output'];
  generalTerms: Scalars['String']['output'];
  gymName: Scalars['String']['output'];
  imprint: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  normalPrice?: Maybe<Scalars['Float']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  privacyPolicy: Scalars['String']['output'];
  savings?: Maybe<Scalars['Float']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  tenant: Scalars['String']['output'];
  totalOverTerm?: Maybe<Scalars['Float']['output']>;
};

export type ContractListRelationFilter = {
  every?: InputMaybe<ContractWhereInput>;
  none?: InputMaybe<ContractWhereInput>;
  some?: InputMaybe<ContractWhereInput>;
};

export type ContractMaxAggregate = {
  __typename: 'ContractMaxAggregate';
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  crmContractId?: Maybe<Scalars['String']['output']>;
  crmCustomerNumber?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gymId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ContractMinAggregate = {
  __typename: 'ContractMinAggregate';
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  crmContractId?: Maybe<Scalars['String']['output']>;
  crmCustomerNumber?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gymId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ContractOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ContractOrderByWithRelationInput = {
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  crmContractId?: InputMaybe<SortOrder>;
  crmCustomerNumber?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  dateOfBirth?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrderInput>;
  firstName?: InputMaybe<SortOrder>;
  gym?: InputMaybe<GymOrderByWithRelationInput>;
  gymId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
};

export enum ContractScalarFieldEnum {
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  CrmContractId = 'crmContractId',
  CrmCustomerNumber = 'crmCustomerNumber',
  CustomerId = 'customerId',
  DateOfBirth = 'dateOfBirth',
  DeletedAt = 'deletedAt',
  FirstName = 'firstName',
  GymId = 'gymId',
  Id = 'id',
  LastName = 'lastName',
  UpdatedAt = 'updatedAt'
}

export type ContractUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<ContractWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<ContractWhereUniqueInput>>;
};

export type ContractUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<ContractWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<ContractWhereUniqueInput>>;
};

export type ContractUpdateManyWithoutGymNestedInput = {
  connect?: InputMaybe<Array<ContractWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<ContractWhereUniqueInput>>;
};

export type ContractWhereInput = {
  AND?: InputMaybe<Array<ContractWhereInput>>;
  NOT?: InputMaybe<Array<ContractWhereInput>>;
  OR?: InputMaybe<Array<ContractWhereInput>>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  crmContractId?: InputMaybe<StringFilter>;
  crmCustomerNumber?: InputMaybe<StringFilter>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  dateOfBirth?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  firstName?: InputMaybe<StringFilter>;
  gym?: InputMaybe<GymScalarRelationFilter>;
  gymId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  lastName?: InputMaybe<StringFilter>;
};

export type ContractWhereUniqueInput = {
  AND?: InputMaybe<Array<ContractWhereInput>>;
  NOT?: InputMaybe<Array<ContractWhereInput>>;
  OR?: InputMaybe<Array<ContractWhereInput>>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  crmContractId?: InputMaybe<StringFilter>;
  crmCustomerNumber?: InputMaybe<StringFilter>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  dateOfBirth?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  firstName?: InputMaybe<StringFilter>;
  gym?: InputMaybe<GymScalarRelationFilter>;
  gymId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  lastName?: InputMaybe<StringFilter>;
};

export type Conversation = {
  __typename: 'Conversation';
  createdAt: Scalars['DateTime']['output'];
  hasUnreadMessages: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  /** The most recent Message in this Conversation, for inbox previews. */
  lastMessage?: Maybe<Message>;
  lastMessageAt?: Maybe<Scalars['DateTime']['output']>;
  /** The other participant, or a synthetic "anonymous" Profile if they deleted their account. */
  otherProfile: Profile;
};

export type ConversationCountAggregate = {
  __typename: 'ConversationCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastMessageAt: Scalars['Int']['output'];
};

export type ConversationEdge = {
  __typename: 'ConversationEdge';
  cursor: PaginatedConversationCursor;
  node: Conversation;
};

export type ConversationListRelationFilter = {
  every?: InputMaybe<ConversationWhereInput>;
  none?: InputMaybe<ConversationWhereInput>;
  some?: InputMaybe<ConversationWhereInput>;
};

export type ConversationMaxAggregate = {
  __typename: 'ConversationMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  lastMessageAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ConversationMinAggregate = {
  __typename: 'ConversationMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  lastMessageAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ConversationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ConversationOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastMessageAt?: InputMaybe<SortOrderInput>;
  messages?: InputMaybe<MessageOrderByRelationAggregateInput>;
  profileA?: InputMaybe<ProfileOrderByWithRelationInput>;
  profileAId?: InputMaybe<SortOrderInput>;
  profileB?: InputMaybe<ProfileOrderByWithRelationInput>;
  profileBId?: InputMaybe<SortOrderInput>;
};

export type ConversationProfileAIdProfileBIdCompoundUniqueInput = {
  profileAId: Scalars['String']['input'];
  profileBId: Scalars['String']['input'];
};

export enum ConversationScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  LastMessageAt = 'lastMessageAt',
  ProfileADeletedAt = 'profileADeletedAt',
  ProfileAId = 'profileAId',
  ProfileALastReadAt = 'profileALastReadAt',
  ProfileBDeletedAt = 'profileBDeletedAt',
  ProfileBId = 'profileBId',
  ProfileBLastReadAt = 'profileBLastReadAt'
}

export type ConversationScalarRelationFilter = {
  is?: InputMaybe<ConversationWhereInput>;
  isNot?: InputMaybe<ConversationWhereInput>;
};

export type ConversationWhereInput = {
  AND?: InputMaybe<Array<ConversationWhereInput>>;
  NOT?: InputMaybe<Array<ConversationWhereInput>>;
  OR?: InputMaybe<Array<ConversationWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  lastMessageAt?: InputMaybe<DateTimeNullableFilter>;
  messages?: InputMaybe<MessageListRelationFilter>;
  profileA?: InputMaybe<ProfileNullableScalarRelationFilter>;
  profileAId?: InputMaybe<UuidNullableFilter>;
  profileB?: InputMaybe<ProfileNullableScalarRelationFilter>;
  profileBId?: InputMaybe<UuidNullableFilter>;
};

export type ConversationWhereUniqueInput = {
  AND?: InputMaybe<Array<ConversationWhereInput>>;
  NOT?: InputMaybe<Array<ConversationWhereInput>>;
  OR?: InputMaybe<Array<ConversationWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  lastMessageAt?: InputMaybe<DateTimeNullableFilter>;
  messages?: InputMaybe<MessageListRelationFilter>;
  profileA?: InputMaybe<ProfileNullableScalarRelationFilter>;
  profileAId?: InputMaybe<UuidNullableFilter>;
  profileAId_profileBId?: InputMaybe<ConversationProfileAIdProfileBIdCompoundUniqueInput>;
  profileB?: InputMaybe<ProfileNullableScalarRelationFilter>;
  profileBId?: InputMaybe<UuidNullableFilter>;
};

export type Coupon = {
  __typename: 'Coupon';
  /** The state if this coupon is currently active. */
  active: Scalars['Boolean']['output'];
  /** The company associated with the coupon. */
  company: Company;
  /** The date an time when the coupon was created. */
  createAt: Scalars['DateTime']['output'];
  /** The description of the coupon. */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the coupon. */
  id: Scalars['UUID']['output'];
  /** The name of the coupon. */
  name: Scalars['String']['output'];
  receivedCoupon?: Maybe<Array<ReceivedCoupon>>;
  redeemedCoupons: Array<ReceivedCoupon>;
  /** The date and time when the coupon was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type CouponCountAggregate = {
  __typename: 'CouponCountAggregate';
  _all: Scalars['Int']['output'];
  active: Scalars['Int']['output'];
  createAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CouponCreateInput = {
  company?: InputMaybe<CompanyCreateNestedOneWithoutCouponInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
};

export type CouponListRelationFilter = {
  every?: InputMaybe<CouponWhereInput>;
  none?: InputMaybe<CouponWhereInput>;
  some?: InputMaybe<CouponWhereInput>;
};

export type CouponMaxAggregate = {
  __typename: 'CouponMaxAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  createAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CouponMinAggregate = {
  __typename: 'CouponMinAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  createAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CouponOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CouponOrderByWithRelationInput = {
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  companyId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  receivedCoupon?: InputMaybe<ReceivedCouponOrderByRelationAggregateInput>;
};

export enum CouponScalarFieldEnum {
  Active = 'active',
  CompanyId = 'companyId',
  CreateAt = 'createAt',
  Description = 'description',
  Id = 'id',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type CouponScalarRelationFilter = {
  is?: InputMaybe<CouponWhereInput>;
  isNot?: InputMaybe<CouponWhereInput>;
};

export type CouponUpdateInput = {
  company?: InputMaybe<CompanyUpdateOneRequiredWithoutCouponNestedInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  receivedCoupon?: InputMaybe<ReceivedCouponUpdateManyWithoutCouponNestedInput>;
};

export type CouponUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<CouponWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CouponWhereUniqueInput>>;
};

export type CouponWhereInput = {
  AND?: InputMaybe<Array<CouponWhereInput>>;
  NOT?: InputMaybe<Array<CouponWhereInput>>;
  OR?: InputMaybe<Array<CouponWhereInput>>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  receivedCoupon?: InputMaybe<ReceivedCouponListRelationFilter>;
};

export type CouponWhereUniqueInput = {
  AND?: InputMaybe<Array<CouponWhereInput>>;
  NOT?: InputMaybe<Array<CouponWhereInput>>;
  OR?: InputMaybe<Array<CouponWhereInput>>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<StringFilter>;
  receivedCoupon?: InputMaybe<ReceivedCouponListRelationFilter>;
};

/** Input for appending a price tier to a ticket sale. */
export type CreateCommunityEventPriceTierInput = {
  /** Display name of the tier, e.g. "Early Bird"; at most 255 characters. */
  name: Scalars['String']['input'];
  /** Gross ticket price in cents, at least 50. */
  priceInCents: Scalars['Int']['input'];
  /** Number of tickets of this tier, at least 1. */
  quota: Scalars['Int']['input'];
  /** The ticket sale the tier is appended to. */
  ticketSaleId: Scalars['UUID']['input'];
  /** End of the tier's sales. Must be omitted for the last tier; ascending across tiers. */
  validUntil?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Input for allowing a club member to buy one ticket although the sale is sold out, or ahead of the queue. */
export type CreateCommunityEventTicketPurchaseGrantInput = {
  /** The club member who may buy. */
  customerId: Scalars['String']['input'];
  /** The tier whose price the member pays; a closed or sold out tier is fine. */
  priceTierId: Scalars['UUID']['input'];
  /** The sale of the paid date. */
  ticketSaleId: Scalars['UUID']['input'];
  /** Until when the grant can be used, between now and the event's end; without it, until sales end. */
  validUntil?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Input for giving a club member a free ticket. */
export type CreateComplimentaryCommunityEventTicketInput = {
  /** The club member who gets the ticket. */
  customerId: Scalars['String']['input'];
  /** The sale of the paid date the ticket is for. */
  ticketSaleId: Scalars['UUID']['input'];
};

/** Input for creating the Stripe checkout session of a pending highlight order. */
export type CreateGymHighlightOrderCheckoutSessionInput = {
  /** The id of the highlight order to pay for. */
  orderId: Scalars['UUID']['input'];
};

/** Input for booking a gym highlight order (one period, one or more gyms). */
export type CreateGymHighlightOrderInput = {
  /** Last day (inclusive) on which the selected gyms are highlighted (date only, "YYYY-MM-DD"). */
  endDate: Scalars['Date']['input'];
  /** Identifiers of the gyms to highlight for the given period. */
  gymIds: Array<Scalars['UUID']['input']>;
  /** First day (inclusive) on which the selected gyms are highlighted (date only, "YYYY-MM-DD"). */
  startDate: Scalars['Date']['input'];
};

export enum CronInterval {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type Customer = {
  __typename: 'Customer';
  /** The list of billing records associated with the customer. */
  billings?: Maybe<Array<CustomerBilling>>;
  bookings: Array<EventBooking>;
  communityEventBookings?: Maybe<Array<CommunityEventBooking>>;
  /** Profiles of other community members this customer has attended community events together with. */
  communityEventPartners: Array<Profile>;
  communityPostCommentLikes?: Maybe<Array<CommunityPostCommentLike>>;
  communityPostComments?: Maybe<Array<CommunityPostComment>>;
  communityPostLikes?: Maybe<Array<CommunityPostLike>>;
  contract?: Maybe<Array<Contract>>;
  /** The date and time when the customer record was created. */
  createdAt: Scalars['DateTime']['output'];
  customerBillings: Array<CustomerBilling>;
  customerCommunityClubs?: Maybe<Array<CustomerCommunityClub>>;
  customerCompanies?: Maybe<Array<CustomerCompany>>;
  customerGyms?: Maybe<Array<CustomerGym>>;
  customerPromotionCodes?: Maybe<Array<CustomerPromotionCode>>;
  /** The date of birth of the customer. */
  dateOfBirth: Scalars['DateTime']['output'];
  /** The date the user has been marked as deleted */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The email address of the customer. */
  email: Scalars['EmailAddress']['output'];
  /** The list of event bookings made by the customer. */
  eventBookings?: Maybe<Array<EventBooking>>;
  /** The first name of the customer. */
  firstName: Scalars['String']['output'];
  freeMinuteUsage?: Maybe<Array<CustomerFreeMinuteUsage>>;
  freeMinutes?: Maybe<Array<CustomerFreeMinuteGrant>>;
  gymRatings?: Maybe<Array<GymRating>>;
  healthInsurance?: Maybe<HealthInsurance>;
  /** The balance for a health insurance */
  healthInsuranceBalances?: Maybe<Array<HealthInsuranceBalance>>;
  healthInsuranceId?: Maybe<Scalars['String']['output']>;
  healthInsuranceReceivedPoint: Array<HealthInsuranceReceivedPoint>;
  healthInsuranceReceivedPoints?: Maybe<Array<HealthInsuranceReceivedPoint>>;
  healthInsuranceRedeemedPoints?: Maybe<Array<HealthInsuranceRedeemedPoint>>;
  /** The house number of the customer's address. */
  houseNumber: Scalars['String']['output'];
  /** The unique identifier for the customer. */
  id: Scalars['ID']['output'];
  /** The customer number for the health insurance */
  insuranceCustomerNumber?: Maybe<Scalars['String']['output']>;
  /** The last name of the customer. */
  lastName: Scalars['String']['output'];
  /** The mobile phone number of the customer. */
  mobileNumber: Scalars['String']['output'];
  /** The city or town where the customer resides. */
  place: Scalars['String']['output'];
  /** The customer's own Profile, null if they haven't created one yet. */
  profile?: Maybe<Profile>;
  /** The push token of the customer */
  pushToken?: Maybe<Scalars['String']['output']>;
  /** The list of received coupons associated with the customer. */
  receivedCoupon?: Maybe<Array<ReceivedCoupon>>;
  /** The customers personal unique referral code */
  referralCode: Scalars['String']['output'];
  registrationAnswers?: Maybe<Array<CustomerRegistrationAnswer>>;
  /** The street name of the customer's address. */
  street: Scalars['String']['output'];
  /** The Stripe customer ID associated with the customer. */
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  /** The total amount of remaining available unexpired free minutes. */
  totalRemainingFreeMinutes: Scalars['Float']['output'];
  /** The list of training sessions attended by the customer. */
  trainingSessions?: Maybe<Array<TrainingSession>>;
  /** The type of the customer */
  type: CustomerType;
  /** The date and time when the customer record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Indicates whether the customer's account is verified. */
  verified: Scalars['Boolean']['output'];
  /** The postal code of the customer's address. */
  zipcode: Scalars['String']['output'];
};


export type CustomerFreeMinutesArgs = {
  cursor?: InputMaybe<CustomerFreeMinuteGrantWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomerFreeMinuteGrantScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomerFreeMinuteGrantOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerFreeMinuteGrantWhereInput>;
};

export type CustomerBilling = {
  __typename: 'CustomerBilling';
  /** The date and time when the billing record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The customer associated with the billing. */
  customer: Customer;
  /** The date of the invoice. */
  dateOfInvoice: Scalars['DateTime']['output'];
  /** Any error message related to the billing process. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Indicator whether a free minute grant was used for this billing or not */
  freeMinutesUsed?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for the billing record. */
  id: Scalars['Int']['output'];
  /** The unique identifier of the original stripe invoice */
  invoiceId?: Maybe<Scalars['String']['output']>;
  /** The invoice number for this billing. */
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the bill has been paid. */
  isPaid: Scalars['Boolean']['output'];
  /** The actual price paid. Differs from the training price if a promotion code has been applied. */
  paidPrice?: Maybe<Scalars['Float']['output']>;
  /** The key for accessing the PDF version of the invoice. */
  pdfKey?: Maybe<Scalars['String']['output']>;
  /** Indicator whether a promotion code was used for this billing or not */
  promotionCodeUsed: Scalars['Boolean']['output'];
  /** The status of the billing (e.g., OPEN, SENT, etc.). */
  status: BillingStatus;
  /** The price of the training session included in the invoice. */
  trainingPrice?: Maybe<Scalars['Float']['output']>;
  /** The training session associated with the billing. */
  trainingSession: TrainingSession;
  /** The date and time when the billing record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type CustomerBillingAvgAggregate = {
  __typename: 'CustomerBillingAvgAggregate';
  freeMinutesUsed?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  paidPrice?: Maybe<Scalars['Float']['output']>;
  trainingPrice?: Maybe<Scalars['Float']['output']>;
};

export type CustomerBillingAvgAggregateInput = {
  freeMinutesUsed?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  paidPrice?: InputMaybe<Scalars['Boolean']['input']>;
  trainingPrice?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for cancellation of a customer billing */
export type CustomerBillingCancellationInput = {
  /** The ID of the original stripe invoice to be canceled. Optional and only necessary if the ID of the original invoice is not present at the CustomerBilling entry */
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  /** The corrected training time in minutes for the new invoice */
  trainingTime: Scalars['Float']['input'];
};

export type CustomerBillingCompound_Billing_IdCompoundUniqueInput = {
  id: Scalars['Int']['input'];
  trainingSessionId: Scalars['UUID']['input'];
};

export type CustomerBillingCountAggregate = {
  __typename: 'CustomerBillingCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  dateOfInvoice: Scalars['Int']['output'];
  errorMessage: Scalars['Int']['output'];
  freeMinutesUsed: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  invoiceId: Scalars['Int']['output'];
  invoiceNumber: Scalars['Int']['output'];
  isPaid: Scalars['Int']['output'];
  paidPrice: Scalars['Int']['output'];
  pdfKey: Scalars['Int']['output'];
  promotionCodeUsed: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  trainingPrice: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CustomerBillingCountAggregateInput = {
  _all?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  customerId?: InputMaybe<Scalars['Boolean']['input']>;
  dateOfInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  errorMessage?: InputMaybe<Scalars['Boolean']['input']>;
  freeMinutesUsed?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceId?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceNumber?: InputMaybe<Scalars['Boolean']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  paidPrice?: InputMaybe<Scalars['Boolean']['input']>;
  pdfKey?: InputMaybe<Scalars['Boolean']['input']>;
  promotionCodeUsed?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  trainingPrice?: InputMaybe<Scalars['Boolean']['input']>;
  trainingSessionId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomerBillingCreateInput = {
  customer: CustomerCreateNestedOneWithoutBillingsInput;
  dateOfInvoice: Scalars['DateTime']['input'];
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  freeMinutesUsed?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  paidPrice?: InputMaybe<Scalars['Float']['input']>;
  pdfKey?: InputMaybe<Scalars['String']['input']>;
  promotionCodeUsed?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<BillingStatus>;
  trainingPrice?: InputMaybe<Scalars['Float']['input']>;
  trainingSession: TrainingSessionCreateNestedOneWithoutCustomerBillingInput;
};

export type CustomerBillingListRelationFilter = {
  every?: InputMaybe<CustomerBillingWhereInput>;
  none?: InputMaybe<CustomerBillingWhereInput>;
  some?: InputMaybe<CustomerBillingWhereInput>;
};

export type CustomerBillingMaxAggregate = {
  __typename: 'CustomerBillingMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateOfInvoice?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  freeMinutesUsed?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  isPaid?: Maybe<Scalars['Boolean']['output']>;
  paidPrice?: Maybe<Scalars['Float']['output']>;
  pdfKey?: Maybe<Scalars['String']['output']>;
  promotionCodeUsed?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<BillingStatus>;
  trainingPrice?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerBillingMaxAggregateInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  customerId?: InputMaybe<Scalars['Boolean']['input']>;
  dateOfInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  errorMessage?: InputMaybe<Scalars['Boolean']['input']>;
  freeMinutesUsed?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceId?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceNumber?: InputMaybe<Scalars['Boolean']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  paidPrice?: InputMaybe<Scalars['Boolean']['input']>;
  pdfKey?: InputMaybe<Scalars['Boolean']['input']>;
  promotionCodeUsed?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  trainingPrice?: InputMaybe<Scalars['Boolean']['input']>;
  trainingSessionId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomerBillingMinAggregate = {
  __typename: 'CustomerBillingMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateOfInvoice?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  freeMinutesUsed?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  isPaid?: Maybe<Scalars['Boolean']['output']>;
  paidPrice?: Maybe<Scalars['Float']['output']>;
  pdfKey?: Maybe<Scalars['String']['output']>;
  promotionCodeUsed?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<BillingStatus>;
  trainingPrice?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerBillingMinAggregateInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  customerId?: InputMaybe<Scalars['Boolean']['input']>;
  dateOfInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  errorMessage?: InputMaybe<Scalars['Boolean']['input']>;
  freeMinutesUsed?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceId?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceNumber?: InputMaybe<Scalars['Boolean']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  paidPrice?: InputMaybe<Scalars['Boolean']['input']>;
  pdfKey?: InputMaybe<Scalars['Boolean']['input']>;
  promotionCodeUsed?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  trainingPrice?: InputMaybe<Scalars['Boolean']['input']>;
  trainingSessionId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomerBillingNullableScalarRelationFilter = {
  is?: InputMaybe<CustomerBillingWhereInput>;
  isNot?: InputMaybe<CustomerBillingWhereInput>;
};

export type CustomerBillingOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CustomerBillingOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  dateOfInvoice?: InputMaybe<SortOrder>;
  errorMessage?: InputMaybe<SortOrderInput>;
  freeMinutesUsed?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  invoiceId?: InputMaybe<SortOrderInput>;
  invoiceNumber?: InputMaybe<SortOrderInput>;
  isPaid?: InputMaybe<SortOrder>;
  paidPrice?: InputMaybe<SortOrderInput>;
  pdfKey?: InputMaybe<SortOrderInput>;
  promotionCodeUsed?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  trainingPrice?: InputMaybe<SortOrderInput>;
  trainingSession?: InputMaybe<TrainingSessionOrderByWithRelationInput>;
  trainingSessionId?: InputMaybe<SortOrder>;
};

export enum CustomerBillingScalarFieldEnum {
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  DateOfInvoice = 'dateOfInvoice',
  ErrorMessage = 'errorMessage',
  FreeMinutesUsed = 'freeMinutesUsed',
  Id = 'id',
  InvoiceId = 'invoiceId',
  InvoiceNumber = 'invoiceNumber',
  IsPaid = 'isPaid',
  PaidPrice = 'paidPrice',
  PdfKey = 'pdfKey',
  PromotionCodeUsed = 'promotionCodeUsed',
  Status = 'status',
  TrainingPrice = 'trainingPrice',
  TrainingSessionId = 'trainingSessionId',
  UpdatedAt = 'updatedAt'
}

export type CustomerBillingSumAggregate = {
  __typename: 'CustomerBillingSumAggregate';
  freeMinutesUsed?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  paidPrice?: Maybe<Scalars['Float']['output']>;
  trainingPrice?: Maybe<Scalars['Float']['output']>;
};

export type CustomerBillingSumAggregateInput = {
  freeMinutesUsed?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  paidPrice?: InputMaybe<Scalars['Boolean']['input']>;
  trainingPrice?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for updating a customer billing */
export type CustomerBillingUpdateInput = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<BillingStatus>;
};

export type CustomerBillingUpdateOneWithoutTrainingSessionNestedInput = {
  connect?: InputMaybe<CustomerBillingWhereUniqueInput>;
  disconnect?: InputMaybe<CustomerBillingWhereInput>;
};

export type CustomerBillingWhereInput = {
  AND?: InputMaybe<Array<CustomerBillingWhereInput>>;
  NOT?: InputMaybe<Array<CustomerBillingWhereInput>>;
  OR?: InputMaybe<Array<CustomerBillingWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  dateOfInvoice?: InputMaybe<DateTimeFilter>;
  errorMessage?: InputMaybe<StringNullableFilter>;
  freeMinutesUsed?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  invoiceId?: InputMaybe<StringNullableFilter>;
  invoiceNumber?: InputMaybe<StringNullableFilter>;
  isPaid?: InputMaybe<BoolFilter>;
  paidPrice?: InputMaybe<FloatNullableFilter>;
  pdfKey?: InputMaybe<StringNullableFilter>;
  promotionCodeUsed?: InputMaybe<BoolFilter>;
  status?: InputMaybe<EnumBillingStatusFilter>;
  trainingPrice?: InputMaybe<FloatNullableFilter>;
  trainingSession?: InputMaybe<TrainingSessionScalarRelationFilter>;
  trainingSessionId?: InputMaybe<UuidFilter>;
};

export type CustomerBillingWhereUniqueInput = {
  AND?: InputMaybe<Array<CustomerBillingWhereInput>>;
  NOT?: InputMaybe<Array<CustomerBillingWhereInput>>;
  OR?: InputMaybe<Array<CustomerBillingWhereInput>>;
  compound_billing_id?: InputMaybe<CustomerBillingCompound_Billing_IdCompoundUniqueInput>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  dateOfInvoice?: InputMaybe<DateTimeFilter>;
  errorMessage?: InputMaybe<StringNullableFilter>;
  freeMinutesUsed?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  invoiceId?: InputMaybe<StringNullableFilter>;
  invoiceNumber?: InputMaybe<StringNullableFilter>;
  isPaid?: InputMaybe<BoolFilter>;
  paidPrice?: InputMaybe<FloatNullableFilter>;
  pdfKey?: InputMaybe<StringNullableFilter>;
  promotionCodeUsed?: InputMaybe<BoolFilter>;
  status?: InputMaybe<EnumBillingStatusFilter>;
  trainingPrice?: InputMaybe<FloatNullableFilter>;
  trainingSession?: InputMaybe<TrainingSessionScalarRelationFilter>;
  trainingSessionId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CustomerCommunityClub = {
  __typename: 'CustomerCommunityClub';
  communityClub: CommunityClub;
  communityClubId: Scalars['String']['output'];
  company: Company;
  companyId: Scalars['String']['output'];
  customer: Customer;
  customerCompany: CustomerCompany;
  customerId: Scalars['String']['output'];
  joinedAt: Scalars['DateTime']['output'];
};

export type CustomerCommunityClubCompanyIdCommunityClubIdCustomerIdCompoundUniqueInput = {
  communityClubId: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
};

export type CustomerCommunityClubCountAggregate = {
  __typename: 'CustomerCommunityClubCountAggregate';
  _all: Scalars['Int']['output'];
  communityClubId: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  joinedAt: Scalars['Int']['output'];
};

export type CustomerCommunityClubCreateNestedManyWithoutCommunityClubInput = {
  connect?: InputMaybe<Array<CustomerCommunityClubWhereUniqueInput>>;
};

export type CustomerCommunityClubCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<CustomerCommunityClubWhereUniqueInput>>;
};

export type CustomerCommunityClubListRelationFilter = {
  every?: InputMaybe<CustomerCommunityClubWhereInput>;
  none?: InputMaybe<CustomerCommunityClubWhereInput>;
  some?: InputMaybe<CustomerCommunityClubWhereInput>;
};

export type CustomerCommunityClubMaxAggregate = {
  __typename: 'CustomerCommunityClubMaxAggregate';
  communityClubId?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  joinedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerCommunityClubMinAggregate = {
  __typename: 'CustomerCommunityClubMinAggregate';
  communityClubId?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  joinedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerCommunityClubOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CustomerCommunityClubOrderByWithRelationInput = {
  communityClub?: InputMaybe<CommunityClubOrderByWithRelationInput>;
  communityClubId?: InputMaybe<SortOrder>;
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  companyId?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerCompany?: InputMaybe<CustomerCompanyOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  joinedAt?: InputMaybe<SortOrder>;
};

export enum CustomerCommunityClubScalarFieldEnum {
  CommunityClubId = 'communityClubId',
  CompanyId = 'companyId',
  CustomerId = 'customerId',
  JoinedAt = 'joinedAt'
}

export type CustomerCommunityClubUpdateManyWithoutCommunityClubNestedInput = {
  connect?: InputMaybe<Array<CustomerCommunityClubWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CustomerCommunityClubWhereUniqueInput>>;
};

export type CustomerCommunityClubUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<CustomerCommunityClubWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CustomerCommunityClubWhereUniqueInput>>;
};

export type CustomerCommunityClubUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<CustomerCommunityClubWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CustomerCommunityClubWhereUniqueInput>>;
};

export type CustomerCommunityClubWhereInput = {
  AND?: InputMaybe<Array<CustomerCommunityClubWhereInput>>;
  NOT?: InputMaybe<Array<CustomerCommunityClubWhereInput>>;
  OR?: InputMaybe<Array<CustomerCommunityClubWhereInput>>;
  communityClub?: InputMaybe<CommunityClubScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidFilter>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerCompany?: InputMaybe<CustomerCompanyScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  joinedAt?: InputMaybe<DateTimeFilter>;
};

export type CustomerCommunityClubWhereUniqueInput = {
  AND?: InputMaybe<Array<CustomerCommunityClubWhereInput>>;
  NOT?: InputMaybe<Array<CustomerCommunityClubWhereInput>>;
  OR?: InputMaybe<Array<CustomerCommunityClubWhereInput>>;
  communityClub?: InputMaybe<CommunityClubScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidFilter>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  companyId_communityClubId_customerId?: InputMaybe<CustomerCommunityClubCompanyIdCommunityClubIdCustomerIdCompoundUniqueInput>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerCompany?: InputMaybe<CustomerCompanyScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  joinedAt?: InputMaybe<DateTimeFilter>;
};

export type CustomerCompany = {
  __typename: 'CustomerCompany';
  company: Company;
  companyId: Scalars['String']['output'];
  customer: Customer;
  customerCommunityClubs?: Maybe<Array<CustomerCommunityClub>>;
  customerGyms?: Maybe<Array<CustomerGym>>;
  customerId: Scalars['String']['output'];
  joinedAt: Scalars['DateTime']['output'];
};

export type CustomerCompanyCompanyIdCustomerIdCompoundUniqueInput = {
  companyId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
};

export type CustomerCompanyCountAggregate = {
  __typename: 'CustomerCompanyCountAggregate';
  _all: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  joinedAt: Scalars['Int']['output'];
};

export type CustomerCompanyListRelationFilter = {
  every?: InputMaybe<CustomerCompanyWhereInput>;
  none?: InputMaybe<CustomerCompanyWhereInput>;
  some?: InputMaybe<CustomerCompanyWhereInput>;
};

export type CustomerCompanyMaxAggregate = {
  __typename: 'CustomerCompanyMaxAggregate';
  companyId?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  joinedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerCompanyMinAggregate = {
  __typename: 'CustomerCompanyMinAggregate';
  companyId?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  joinedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerCompanyOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CustomerCompanyOrderByWithRelationInput = {
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  companyId?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerCommunityClubs?: InputMaybe<CustomerCommunityClubOrderByRelationAggregateInput>;
  customerGyms?: InputMaybe<CustomerGymOrderByRelationAggregateInput>;
  customerId?: InputMaybe<SortOrder>;
  joinedAt?: InputMaybe<SortOrder>;
};

export type CustomerCompanyScalarRelationFilter = {
  is?: InputMaybe<CustomerCompanyWhereInput>;
  isNot?: InputMaybe<CustomerCompanyWhereInput>;
};

export type CustomerCompanyUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<CustomerCompanyWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CustomerCompanyWhereUniqueInput>>;
};

export type CustomerCompanyWhereInput = {
  AND?: InputMaybe<Array<CustomerCompanyWhereInput>>;
  NOT?: InputMaybe<Array<CustomerCompanyWhereInput>>;
  OR?: InputMaybe<Array<CustomerCompanyWhereInput>>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerCommunityClubs?: InputMaybe<CustomerCommunityClubListRelationFilter>;
  customerGyms?: InputMaybe<CustomerGymListRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  joinedAt?: InputMaybe<DateTimeFilter>;
};

export type CustomerCompanyWhereUniqueInput = {
  AND?: InputMaybe<Array<CustomerCompanyWhereInput>>;
  NOT?: InputMaybe<Array<CustomerCompanyWhereInput>>;
  OR?: InputMaybe<Array<CustomerCompanyWhereInput>>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  companyId_customerId?: InputMaybe<CustomerCompanyCompanyIdCustomerIdCompoundUniqueInput>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerCommunityClubs?: InputMaybe<CustomerCommunityClubListRelationFilter>;
  customerGyms?: InputMaybe<CustomerGymListRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  joinedAt?: InputMaybe<DateTimeFilter>;
};

export type CustomerCountAggregate = {
  __typename: 'CustomerCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  dateOfBirth: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  firstName: Scalars['Int']['output'];
  healthInsuranceId: Scalars['Int']['output'];
  houseNumber: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  insuranceCustomerNumber: Scalars['Int']['output'];
  lastName: Scalars['Int']['output'];
  mobileNumber: Scalars['Int']['output'];
  place: Scalars['Int']['output'];
  pushToken: Scalars['Int']['output'];
  referralCode: Scalars['Int']['output'];
  street: Scalars['Int']['output'];
  stripeCustomerId: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  verified: Scalars['Int']['output'];
  zipcode: Scalars['Int']['output'];
};

/** Custom input for creating a customer */
export type CustomerCreateInput = {
  /** Answers to registration questions given during sign-up */
  answers?: InputMaybe<Array<AnswerRegistrationQuestionInput>>;
  dateOfBirth: Scalars['DateTime']['input'];
  email: Scalars['EmailAddress']['input'];
  firstName: Scalars['String']['input'];
  houseNumber: Scalars['String']['input'];
  id: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  mobileNumber: Scalars['String']['input'];
  place: Scalars['String']['input'];
  street: Scalars['String']['input'];
  /** A referral code used for this registration */
  usedReferralCode?: InputMaybe<Scalars['String']['input']>;
  zipcode: Scalars['String']['input'];
};

export type CustomerCreateNestedOneWithoutBillingsInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
};

/** Custom not nullable connect type for the customer */
export type CustomerCreateNestedOneWithoutHealthInsuranceRedeemedPointsInput = {
  connect: CustomerWhereUniqueInput;
};

/** Input for deleting customers */
export type CustomerDeleteInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  /** The ID array of training sessions */
  trainingIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Strategy for rollback process of archived customer data */
export enum CustomerDeletionArchiveRollbackStrategy {
  DeleteAndRestore = 'DELETE_AND_RESTORE',
  DeleteOnly = 'DELETE_ONLY'
}

/** The processes the deletion could be failed at */
export enum CustomerDeletionFailedProcess {
  Auth0 = 'AUTH0',
  Database = 'DATABASE',
  Stripe = 'STRIPE'
}

export type CustomerEdge = {
  __typename: 'CustomerEdge';
  cursor: PaginatedCustomersCursor;
  node: Customer;
};

export type CustomerFreeMinuteGrant = {
  __typename: 'CustomerFreeMinuteGrant';
  /** Creation date of this grant */
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  /** The expiry date for this free minutes */
  expiresAt: Scalars['DateTime']['output'];
  freeMinuteUsages?: Maybe<Array<CustomerFreeMinuteUsage>>;
  /** Initially granted minutes for this entry */
  grantedMinutes: Scalars['Int']['output'];
  /** The unique identifier for the transaction. */
  id: Scalars['UUID']['output'];
  referralConfig?: Maybe<ReferralConfig>;
  /** Remaining unconsumed minutes */
  remainingMinutes: Scalars['Int']['output'];
  /** The type through which these minutes were received */
  type: FreeMinuteType;
  /** Last updated of this grant */
  updatedAt: Scalars['DateTime']['output'];
};

export type CustomerFreeMinuteGrantAvgAggregate = {
  __typename: 'CustomerFreeMinuteGrantAvgAggregate';
  grantedMinutes?: Maybe<Scalars['Float']['output']>;
  remainingMinutes?: Maybe<Scalars['Float']['output']>;
};

export type CustomerFreeMinuteGrantCountAggregate = {
  __typename: 'CustomerFreeMinuteGrantCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  expiresAt: Scalars['Int']['output'];
  grantedMinutes: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  remainingMinutes: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CustomerFreeMinuteGrantListRelationFilter = {
  every?: InputMaybe<CustomerFreeMinuteGrantWhereInput>;
  none?: InputMaybe<CustomerFreeMinuteGrantWhereInput>;
  some?: InputMaybe<CustomerFreeMinuteGrantWhereInput>;
};

export type CustomerFreeMinuteGrantMaxAggregate = {
  __typename: 'CustomerFreeMinuteGrantMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  grantedMinutes?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  remainingMinutes?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<FreeMinuteType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerFreeMinuteGrantMinAggregate = {
  __typename: 'CustomerFreeMinuteGrantMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  grantedMinutes?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  remainingMinutes?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<FreeMinuteType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerFreeMinuteGrantOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CustomerFreeMinuteGrantOrderByWithRelationInput = {
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  expiresAt?: InputMaybe<SortOrder>;
  freeMinuteUsages?: InputMaybe<CustomerFreeMinuteUsageOrderByRelationAggregateInput>;
  grantedMinutes?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  referralConfig?: InputMaybe<ReferralConfigOrderByWithRelationInput>;
  referralConfigId?: InputMaybe<SortOrderInput>;
  remainingMinutes?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export enum CustomerFreeMinuteGrantScalarFieldEnum {
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  ExpiresAt = 'expiresAt',
  GrantedMinutes = 'grantedMinutes',
  Id = 'id',
  ReferralConfigId = 'referralConfigId',
  RemainingMinutes = 'remainingMinutes',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type CustomerFreeMinuteGrantScalarRelationFilter = {
  is?: InputMaybe<CustomerFreeMinuteGrantWhereInput>;
  isNot?: InputMaybe<CustomerFreeMinuteGrantWhereInput>;
};

export type CustomerFreeMinuteGrantSumAggregate = {
  __typename: 'CustomerFreeMinuteGrantSumAggregate';
  grantedMinutes?: Maybe<Scalars['Int']['output']>;
  remainingMinutes?: Maybe<Scalars['Int']['output']>;
};

export type CustomerFreeMinuteGrantUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<CustomerFreeMinuteGrantWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CustomerFreeMinuteGrantWhereUniqueInput>>;
};

export type CustomerFreeMinuteGrantWhereInput = {
  AND?: InputMaybe<Array<CustomerFreeMinuteGrantWhereInput>>;
  NOT?: InputMaybe<Array<CustomerFreeMinuteGrantWhereInput>>;
  OR?: InputMaybe<Array<CustomerFreeMinuteGrantWhereInput>>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  expiresAt?: InputMaybe<DateTimeFilter>;
  freeMinuteUsages?: InputMaybe<CustomerFreeMinuteUsageListRelationFilter>;
  grantedMinutes?: InputMaybe<IntFilter>;
  id?: InputMaybe<UuidFilter>;
  referralConfig?: InputMaybe<ReferralConfigNullableScalarRelationFilter>;
  referralConfigId?: InputMaybe<UuidNullableFilter>;
  remainingMinutes?: InputMaybe<IntFilter>;
  type?: InputMaybe<EnumFreeMinuteTypeFilter>;
};

export type CustomerFreeMinuteGrantWhereUniqueInput = {
  AND?: InputMaybe<Array<CustomerFreeMinuteGrantWhereInput>>;
  NOT?: InputMaybe<Array<CustomerFreeMinuteGrantWhereInput>>;
  OR?: InputMaybe<Array<CustomerFreeMinuteGrantWhereInput>>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  expiresAt?: InputMaybe<DateTimeFilter>;
  freeMinuteUsages?: InputMaybe<CustomerFreeMinuteUsageListRelationFilter>;
  grantedMinutes?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  referralConfig?: InputMaybe<ReferralConfigNullableScalarRelationFilter>;
  referralConfigId?: InputMaybe<UuidNullableFilter>;
  remainingMinutes?: InputMaybe<IntFilter>;
  type?: InputMaybe<EnumFreeMinuteTypeFilter>;
};

export type CustomerFreeMinuteUsage = {
  __typename: 'CustomerFreeMinuteUsage';
  /** Creation date of this grant */
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  grant: CustomerFreeMinuteGrant;
  /** The unique identifier */
  id: Scalars['UUID']['output'];
  trainingSession: TrainingSession;
  /** Last updated of this grant */
  updatedAt: Scalars['DateTime']['output'];
  /** The used minutes */
  usedMinutes: Scalars['Int']['output'];
};

export type CustomerFreeMinuteUsageAvgAggregate = {
  __typename: 'CustomerFreeMinuteUsageAvgAggregate';
  usedMinutes?: Maybe<Scalars['Float']['output']>;
};

export type CustomerFreeMinuteUsageCountAggregate = {
  __typename: 'CustomerFreeMinuteUsageCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  usedMinutes: Scalars['Int']['output'];
};

export type CustomerFreeMinuteUsageListRelationFilter = {
  every?: InputMaybe<CustomerFreeMinuteUsageWhereInput>;
  none?: InputMaybe<CustomerFreeMinuteUsageWhereInput>;
  some?: InputMaybe<CustomerFreeMinuteUsageWhereInput>;
};

export type CustomerFreeMinuteUsageMaxAggregate = {
  __typename: 'CustomerFreeMinuteUsageMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  usedMinutes?: Maybe<Scalars['Int']['output']>;
};

export type CustomerFreeMinuteUsageMinAggregate = {
  __typename: 'CustomerFreeMinuteUsageMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  usedMinutes?: Maybe<Scalars['Int']['output']>;
};

export type CustomerFreeMinuteUsageOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CustomerFreeMinuteUsageOrderByWithRelationInput = {
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  grant?: InputMaybe<CustomerFreeMinuteGrantOrderByWithRelationInput>;
  grantId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  trainingSession?: InputMaybe<TrainingSessionOrderByWithRelationInput>;
  trainingSessionId?: InputMaybe<SortOrder>;
  usedMinutes?: InputMaybe<SortOrder>;
};

export enum CustomerFreeMinuteUsageScalarFieldEnum {
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  GrantId = 'grantId',
  Id = 'id',
  TrainingSessionId = 'trainingSessionId',
  UpdatedAt = 'updatedAt',
  UsedMinutes = 'usedMinutes'
}

export type CustomerFreeMinuteUsageSumAggregate = {
  __typename: 'CustomerFreeMinuteUsageSumAggregate';
  usedMinutes?: Maybe<Scalars['Int']['output']>;
};

export type CustomerFreeMinuteUsageUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<CustomerFreeMinuteUsageWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CustomerFreeMinuteUsageWhereUniqueInput>>;
};

export type CustomerFreeMinuteUsageUpdateManyWithoutTrainingSessionNestedInput = {
  connect?: InputMaybe<Array<CustomerFreeMinuteUsageWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CustomerFreeMinuteUsageWhereUniqueInput>>;
};

export type CustomerFreeMinuteUsageWhereInput = {
  AND?: InputMaybe<Array<CustomerFreeMinuteUsageWhereInput>>;
  NOT?: InputMaybe<Array<CustomerFreeMinuteUsageWhereInput>>;
  OR?: InputMaybe<Array<CustomerFreeMinuteUsageWhereInput>>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  grant?: InputMaybe<CustomerFreeMinuteGrantScalarRelationFilter>;
  grantId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  trainingSession?: InputMaybe<TrainingSessionScalarRelationFilter>;
  trainingSessionId?: InputMaybe<UuidFilter>;
  usedMinutes?: InputMaybe<IntFilter>;
};

export type CustomerFreeMinuteUsageWhereUniqueInput = {
  AND?: InputMaybe<Array<CustomerFreeMinuteUsageWhereInput>>;
  NOT?: InputMaybe<Array<CustomerFreeMinuteUsageWhereInput>>;
  OR?: InputMaybe<Array<CustomerFreeMinuteUsageWhereInput>>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  grant?: InputMaybe<CustomerFreeMinuteGrantScalarRelationFilter>;
  grantId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  trainingSession?: InputMaybe<TrainingSessionScalarRelationFilter>;
  trainingSessionId?: InputMaybe<UuidFilter>;
  usedMinutes?: InputMaybe<IntFilter>;
};

export type CustomerGym = {
  __typename: 'CustomerGym';
  company: Company;
  companyId: Scalars['String']['output'];
  customer: Customer;
  customerCompany: CustomerCompany;
  customerId: Scalars['String']['output'];
  firstSeenAt: Scalars['DateTime']['output'];
  gym: Gym;
  gymId: Scalars['String']['output'];
  lastSeenAt: Scalars['DateTime']['output'];
};

export type CustomerGymCompanyIdGymIdCustomerIdCompoundUniqueInput = {
  companyId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  gymId: Scalars['String']['input'];
};

export type CustomerGymCountAggregate = {
  __typename: 'CustomerGymCountAggregate';
  _all: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  firstSeenAt: Scalars['Int']['output'];
  gymId: Scalars['Int']['output'];
  lastSeenAt: Scalars['Int']['output'];
};

export type CustomerGymCreateNestedManyWithoutGymInput = {
  connect?: InputMaybe<Array<CustomerGymWhereUniqueInput>>;
};

export type CustomerGymListRelationFilter = {
  every?: InputMaybe<CustomerGymWhereInput>;
  none?: InputMaybe<CustomerGymWhereInput>;
  some?: InputMaybe<CustomerGymWhereInput>;
};

export type CustomerGymMaxAggregate = {
  __typename: 'CustomerGymMaxAggregate';
  companyId?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  firstSeenAt?: Maybe<Scalars['DateTime']['output']>;
  gymId?: Maybe<Scalars['String']['output']>;
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerGymMinAggregate = {
  __typename: 'CustomerGymMinAggregate';
  companyId?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  firstSeenAt?: Maybe<Scalars['DateTime']['output']>;
  gymId?: Maybe<Scalars['String']['output']>;
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerGymOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CustomerGymUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<CustomerGymWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CustomerGymWhereUniqueInput>>;
};

export type CustomerGymUpdateManyWithoutGymNestedInput = {
  connect?: InputMaybe<Array<CustomerGymWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CustomerGymWhereUniqueInput>>;
};

export type CustomerGymWhereInput = {
  AND?: InputMaybe<Array<CustomerGymWhereInput>>;
  NOT?: InputMaybe<Array<CustomerGymWhereInput>>;
  OR?: InputMaybe<Array<CustomerGymWhereInput>>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerCompany?: InputMaybe<CustomerCompanyScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  firstSeenAt?: InputMaybe<DateTimeFilter>;
  gym?: InputMaybe<GymScalarRelationFilter>;
  gymId?: InputMaybe<UuidFilter>;
  lastSeenAt?: InputMaybe<DateTimeFilter>;
};

export type CustomerGymWhereUniqueInput = {
  AND?: InputMaybe<Array<CustomerGymWhereInput>>;
  NOT?: InputMaybe<Array<CustomerGymWhereInput>>;
  OR?: InputMaybe<Array<CustomerGymWhereInput>>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  companyId_gymId_customerId?: InputMaybe<CustomerGymCompanyIdGymIdCustomerIdCompoundUniqueInput>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerCompany?: InputMaybe<CustomerCompanyScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  firstSeenAt?: InputMaybe<DateTimeFilter>;
  gym?: InputMaybe<GymScalarRelationFilter>;
  gymId?: InputMaybe<UuidFilter>;
  lastSeenAt?: InputMaybe<DateTimeFilter>;
};

export type CustomerListRelationFilter = {
  every?: InputMaybe<CustomerWhereInput>;
  none?: InputMaybe<CustomerWhereInput>;
  some?: InputMaybe<CustomerWhereInput>;
};

export type CustomerMaxAggregate = {
  __typename: 'CustomerMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  healthInsuranceId?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insuranceCustomerNumber?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mobileNumber?: Maybe<Scalars['String']['output']>;
  place?: Maybe<Scalars['String']['output']>;
  pushToken?: Maybe<Scalars['String']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CustomerType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type CustomerMinAggregate = {
  __typename: 'CustomerMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  healthInsuranceId?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insuranceCustomerNumber?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mobileNumber?: Maybe<Scalars['String']['output']>;
  place?: Maybe<Scalars['String']['output']>;
  pushToken?: Maybe<Scalars['String']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CustomerType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type CustomerNullableScalarRelationFilter = {
  is?: InputMaybe<CustomerWhereInput>;
  isNot?: InputMaybe<CustomerWhereInput>;
};

export type CustomerOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CustomerOrderByWithRelationInput = {
  billings?: InputMaybe<CustomerBillingOrderByRelationAggregateInput>;
  communityEventBookings?: InputMaybe<CommunityEventBookingOrderByRelationAggregateInput>;
  communityMemberRelationsAsA?: InputMaybe<CommunityMemberRelationOrderByRelationAggregateInput>;
  communityMemberRelationsAsB?: InputMaybe<CommunityMemberRelationOrderByRelationAggregateInput>;
  communityPostCommentLikes?: InputMaybe<CommunityPostCommentLikeOrderByRelationAggregateInput>;
  communityPostComments?: InputMaybe<CommunityPostCommentOrderByRelationAggregateInput>;
  communityPostLikes?: InputMaybe<CommunityPostLikeOrderByRelationAggregateInput>;
  contract?: InputMaybe<ContractOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  customerCommunityClubs?: InputMaybe<CustomerCommunityClubOrderByRelationAggregateInput>;
  customerCompanies?: InputMaybe<CustomerCompanyOrderByRelationAggregateInput>;
  customerGyms?: InputMaybe<CustomerGymOrderByRelationAggregateInput>;
  customerPromotionCodes?: InputMaybe<CustomerPromotionCodeOrderByRelationAggregateInput>;
  dateOfBirth?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrderInput>;
  email?: InputMaybe<SortOrder>;
  eventBookings?: InputMaybe<EventBookingOrderByRelationAggregateInput>;
  feedCheckpoint?: InputMaybe<FeedCheckpointOrderByWithRelationInput>;
  firstName?: InputMaybe<SortOrder>;
  freeMinuteUsage?: InputMaybe<CustomerFreeMinuteUsageOrderByRelationAggregateInput>;
  freeMinutes?: InputMaybe<CustomerFreeMinuteGrantOrderByRelationAggregateInput>;
  gymRatings?: InputMaybe<GymRatingOrderByRelationAggregateInput>;
  healthInsurance?: InputMaybe<HealthInsuranceOrderByWithRelationInput>;
  healthInsuranceBalances?: InputMaybe<HealthInsuranceBalanceOrderByRelationAggregateInput>;
  healthInsuranceId?: InputMaybe<SortOrderInput>;
  healthInsuranceReceivedPoints?: InputMaybe<HealthInsuranceReceivedPointOrderByRelationAggregateInput>;
  healthInsuranceRedeemedPoints?: InputMaybe<HealthInsuranceRedeemedPointOrderByRelationAggregateInput>;
  houseNumber?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  insuranceCustomerNumber?: InputMaybe<SortOrderInput>;
  lastName?: InputMaybe<SortOrder>;
  mobileNumber?: InputMaybe<SortOrder>;
  place?: InputMaybe<SortOrder>;
  profile?: InputMaybe<ProfileOrderByWithRelationInput>;
  pushToken?: InputMaybe<SortOrderInput>;
  receivedCoupon?: InputMaybe<ReceivedCouponOrderByRelationAggregateInput>;
  referralCode?: InputMaybe<SortOrder>;
  registrationAnswers?: InputMaybe<CustomerRegistrationAnswerOrderByRelationAggregateInput>;
  street?: InputMaybe<SortOrder>;
  stripeCustomerId?: InputMaybe<SortOrderInput>;
  trainingSessions?: InputMaybe<TrainingSessionOrderByRelationAggregateInput>;
  type?: InputMaybe<SortOrder>;
  verified?: InputMaybe<SortOrder>;
  zipcode?: InputMaybe<SortOrder>;
};

export type CustomerPromotionCode = {
  __typename: 'CustomerPromotionCode';
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  /** The ID of the customer associated with the promotion code */
  customerId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The promotion code */
  promoCode: Scalars['String']['output'];
  promotionCode: PromotionCode;
  updatedAt: Scalars['DateTime']['output'];
  /** The current usage count of the promotion code */
  usageCount: Scalars['Int']['output'];
};

export type CustomerPromotionCodeAvgAggregate = {
  __typename: 'CustomerPromotionCodeAvgAggregate';
  usageCount?: Maybe<Scalars['Float']['output']>;
};

export type CustomerPromotionCodeCountAggregate = {
  __typename: 'CustomerPromotionCodeCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  promoCode: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  usageCount: Scalars['Int']['output'];
};

export type CustomerPromotionCodeCustomerIdPromotionCodeIdCompoundUniqueInput = {
  customerId: Scalars['String']['input'];
  promotionCodeId: Scalars['String']['input'];
};

export type CustomerPromotionCodeListRelationFilter = {
  every?: InputMaybe<CustomerPromotionCodeWhereInput>;
  none?: InputMaybe<CustomerPromotionCodeWhereInput>;
  some?: InputMaybe<CustomerPromotionCodeWhereInput>;
};

export type CustomerPromotionCodeMaxAggregate = {
  __typename: 'CustomerPromotionCodeMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  usageCount?: Maybe<Scalars['Int']['output']>;
};

export type CustomerPromotionCodeMinAggregate = {
  __typename: 'CustomerPromotionCodeMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  usageCount?: Maybe<Scalars['Int']['output']>;
};

export type CustomerPromotionCodeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CustomerPromotionCodeOrderByWithRelationInput = {
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  promoCode?: InputMaybe<SortOrder>;
  promotionCode?: InputMaybe<PromotionCodeOrderByWithRelationInput>;
  promotionCodeId?: InputMaybe<SortOrder>;
  usageCount?: InputMaybe<SortOrder>;
};

export enum CustomerPromotionCodeScalarFieldEnum {
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  Id = 'id',
  PromoCode = 'promoCode',
  PromotionCodeId = 'promotionCodeId',
  UpdatedAt = 'updatedAt',
  UsageCount = 'usageCount'
}

export type CustomerPromotionCodeSumAggregate = {
  __typename: 'CustomerPromotionCodeSumAggregate';
  usageCount?: Maybe<Scalars['Int']['output']>;
};

export type CustomerPromotionCodeUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<CustomerPromotionCodeWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CustomerPromotionCodeWhereUniqueInput>>;
};

export type CustomerPromotionCodeWhereInput = {
  AND?: InputMaybe<Array<CustomerPromotionCodeWhereInput>>;
  NOT?: InputMaybe<Array<CustomerPromotionCodeWhereInput>>;
  OR?: InputMaybe<Array<CustomerPromotionCodeWhereInput>>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  promoCode?: InputMaybe<StringFilter>;
  promotionCode?: InputMaybe<PromotionCodeScalarRelationFilter>;
  promotionCodeId?: InputMaybe<UuidFilter>;
  usageCount?: InputMaybe<IntFilter>;
};

export type CustomerPromotionCodeWhereUniqueInput = {
  AND?: InputMaybe<Array<CustomerPromotionCodeWhereInput>>;
  NOT?: InputMaybe<Array<CustomerPromotionCodeWhereInput>>;
  OR?: InputMaybe<Array<CustomerPromotionCodeWhereInput>>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  customerId_promotionCodeId?: InputMaybe<CustomerPromotionCodeCustomerIdPromotionCodeIdCompoundUniqueInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  promoCode?: InputMaybe<StringFilter>;
  promotionCode?: InputMaybe<PromotionCodeScalarRelationFilter>;
  promotionCodeId?: InputMaybe<UuidFilter>;
  usageCount?: InputMaybe<IntFilter>;
};

export type CustomerRegistrationAnswer = {
  __typename: 'CustomerRegistrationAnswer';
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  /** The unique identifier */
  id: Scalars['UUID']['output'];
  option: RegistrationQuestionOption;
  question: RegistrationQuestion;
};

export type CustomerRegistrationAnswerCountAggregate = {
  __typename: 'CustomerRegistrationAnswerCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export type CustomerRegistrationAnswerCreateNestedManyWithoutOptionInput = {
  connect?: InputMaybe<Array<CustomerRegistrationAnswerWhereUniqueInput>>;
};

export type CustomerRegistrationAnswerCreateNestedManyWithoutQuestionInput = {
  connect?: InputMaybe<Array<CustomerRegistrationAnswerWhereUniqueInput>>;
};

export type CustomerRegistrationAnswerCustomerIdOptionIdCompoundUniqueInput = {
  customerId: Scalars['String']['input'];
  optionId: Scalars['UUID']['input'];
};

export type CustomerRegistrationAnswerListRelationFilter = {
  every?: InputMaybe<CustomerRegistrationAnswerWhereInput>;
  none?: InputMaybe<CustomerRegistrationAnswerWhereInput>;
  some?: InputMaybe<CustomerRegistrationAnswerWhereInput>;
};

export type CustomerRegistrationAnswerMaxAggregate = {
  __typename: 'CustomerRegistrationAnswerMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
};

export type CustomerRegistrationAnswerMinAggregate = {
  __typename: 'CustomerRegistrationAnswerMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
};

export type CustomerRegistrationAnswerOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CustomerRegistrationAnswerUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<CustomerRegistrationAnswerWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CustomerRegistrationAnswerWhereUniqueInput>>;
};

export type CustomerRegistrationAnswerUpdateManyWithoutOptionNestedInput = {
  connect?: InputMaybe<Array<CustomerRegistrationAnswerWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CustomerRegistrationAnswerWhereUniqueInput>>;
};

export type CustomerRegistrationAnswerUpdateManyWithoutQuestionNestedInput = {
  connect?: InputMaybe<Array<CustomerRegistrationAnswerWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CustomerRegistrationAnswerWhereUniqueInput>>;
};

export type CustomerRegistrationAnswerWhereInput = {
  AND?: InputMaybe<Array<CustomerRegistrationAnswerWhereInput>>;
  NOT?: InputMaybe<Array<CustomerRegistrationAnswerWhereInput>>;
  OR?: InputMaybe<Array<CustomerRegistrationAnswerWhereInput>>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  option?: InputMaybe<RegistrationQuestionOptionScalarRelationFilter>;
  optionId?: InputMaybe<UuidFilter>;
  question?: InputMaybe<RegistrationQuestionScalarRelationFilter>;
  questionId?: InputMaybe<UuidFilter>;
};

export type CustomerRegistrationAnswerWhereUniqueInput = {
  AND?: InputMaybe<Array<CustomerRegistrationAnswerWhereInput>>;
  NOT?: InputMaybe<Array<CustomerRegistrationAnswerWhereInput>>;
  OR?: InputMaybe<Array<CustomerRegistrationAnswerWhereInput>>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  customerId_optionId?: InputMaybe<CustomerRegistrationAnswerCustomerIdOptionIdCompoundUniqueInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  option?: InputMaybe<RegistrationQuestionOptionScalarRelationFilter>;
  optionId?: InputMaybe<UuidFilter>;
  question?: InputMaybe<RegistrationQuestionScalarRelationFilter>;
  questionId?: InputMaybe<UuidFilter>;
};

export enum CustomerScalarFieldEnum {
  CreatedAt = 'createdAt',
  DateOfBirth = 'dateOfBirth',
  DeletedAt = 'deletedAt',
  Email = 'email',
  FirstName = 'firstName',
  HealthInsuranceId = 'healthInsuranceId',
  HouseNumber = 'houseNumber',
  Id = 'id',
  InsuranceCustomerNumber = 'insuranceCustomerNumber',
  LastName = 'lastName',
  MobileNumber = 'mobileNumber',
  Place = 'place',
  PushToken = 'pushToken',
  ReferralCode = 'referralCode',
  Street = 'street',
  StripeCustomerId = 'stripeCustomerId',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  Verified = 'verified',
  Zipcode = 'zipcode'
}

export type CustomerScalarRelationFilter = {
  is?: InputMaybe<CustomerWhereInput>;
  isNot?: InputMaybe<CustomerWhereInput>;
};

/** Possible states of customer */
export enum CustomerStateEnum {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export type CustomerTopRanking = {
  __typename: 'CustomerTopRanking';
  /** The email address of the customer. */
  email: Scalars['EmailAddress']['output'];
  /** The first name of the customer. */
  firstName: Scalars['String']['output'];
  /** The last name of the customer. */
  lastName: Scalars['String']['output'];
  salesTotal: Scalars['Float']['output'];
  trainingsTotal: Scalars['Float']['output'];
};

export enum CustomerType {
  /** Default customer */
  Customer = 'CUSTOMER',
  /** Influencer or olympian */
  Influencer = 'INFLUENCER'
}

/** Input for updating a customer */
export type CustomerUpdateInput = {
  communityEventBookings?: InputMaybe<CommunityEventBookingUpdateManyWithoutCustomerNestedInput>;
  communityMemberRelationsAsA?: InputMaybe<CommunityMemberRelationUpdateManyWithoutCustomerANestedInput>;
  communityMemberRelationsAsB?: InputMaybe<CommunityMemberRelationUpdateManyWithoutCustomerBNestedInput>;
  communityPostCommentLikes?: InputMaybe<CommunityPostCommentLikeUpdateManyWithoutCustomerNestedInput>;
  communityPostComments?: InputMaybe<CommunityPostCommentUpdateManyWithoutCustomerNestedInput>;
  communityPostLikes?: InputMaybe<CommunityPostLikeUpdateManyWithoutCustomerNestedInput>;
  contract?: InputMaybe<ContractUpdateManyWithoutCustomerNestedInput>;
  customerCommunityClubs?: InputMaybe<CustomerCommunityClubUpdateManyWithoutCustomerNestedInput>;
  customerPromotionCodes?: InputMaybe<CustomerPromotionCodeUpdateManyWithoutCustomerNestedInput>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  eventBookings?: InputMaybe<EventBookingUpdateManyWithoutCustomerNestedInput>;
  feedCheckpoint?: InputMaybe<FeedCheckpointUpdateOneWithoutCustomerNestedInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeMinuteUsage?: InputMaybe<CustomerFreeMinuteUsageUpdateManyWithoutCustomerNestedInput>;
  freeMinutes?: InputMaybe<CustomerFreeMinuteGrantUpdateManyWithoutCustomerNestedInput>;
  gymRatings?: InputMaybe<GymRatingUpdateManyWithoutCustomerNestedInput>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  insuranceCustomerNumber?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<ProfileUpdateOneWithoutCustomerNestedInput>;
  pushToken?: InputMaybe<Scalars['String']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  registrationAnswers?: InputMaybe<CustomerRegistrationAnswerUpdateManyWithoutCustomerNestedInput>;
  street?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerUpdateOneRequiredWithoutCommunityEventBookingsNestedInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
};

export type CustomerWhereInput = {
  AND?: InputMaybe<Array<CustomerWhereInput>>;
  NOT?: InputMaybe<Array<CustomerWhereInput>>;
  OR?: InputMaybe<Array<CustomerWhereInput>>;
  billings?: InputMaybe<CustomerBillingListRelationFilter>;
  communityEventBookings?: InputMaybe<CommunityEventBookingListRelationFilter>;
  communityMemberRelationsAsA?: InputMaybe<CommunityMemberRelationListRelationFilter>;
  communityMemberRelationsAsB?: InputMaybe<CommunityMemberRelationListRelationFilter>;
  communityPostCommentLikes?: InputMaybe<CommunityPostCommentLikeListRelationFilter>;
  communityPostComments?: InputMaybe<CommunityPostCommentListRelationFilter>;
  communityPostLikes?: InputMaybe<CommunityPostLikeListRelationFilter>;
  contract?: InputMaybe<ContractListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerCommunityClubs?: InputMaybe<CustomerCommunityClubListRelationFilter>;
  customerCompanies?: InputMaybe<CustomerCompanyListRelationFilter>;
  customerGyms?: InputMaybe<CustomerGymListRelationFilter>;
  customerPromotionCodes?: InputMaybe<CustomerPromotionCodeListRelationFilter>;
  dateOfBirth?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<StringFilter>;
  eventBookings?: InputMaybe<EventBookingListRelationFilter>;
  feedCheckpoint?: InputMaybe<FeedCheckpointNullableScalarRelationFilter>;
  firstName?: InputMaybe<StringFilter>;
  freeMinuteUsage?: InputMaybe<CustomerFreeMinuteUsageListRelationFilter>;
  freeMinutes?: InputMaybe<CustomerFreeMinuteGrantListRelationFilter>;
  gymRatings?: InputMaybe<GymRatingListRelationFilter>;
  healthInsurance?: InputMaybe<HealthInsuranceNullableScalarRelationFilter>;
  healthInsuranceBalances?: InputMaybe<HealthInsuranceBalanceListRelationFilter>;
  healthInsuranceId?: InputMaybe<StringNullableFilter>;
  healthInsuranceReceivedPoints?: InputMaybe<HealthInsuranceReceivedPointListRelationFilter>;
  healthInsuranceRedeemedPoints?: InputMaybe<HealthInsuranceRedeemedPointListRelationFilter>;
  houseNumber?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  insuranceCustomerNumber?: InputMaybe<StringNullableFilter>;
  lastName?: InputMaybe<StringFilter>;
  mobileNumber?: InputMaybe<StringFilter>;
  place?: InputMaybe<StringFilter>;
  profile?: InputMaybe<ProfileNullableScalarRelationFilter>;
  pushToken?: InputMaybe<StringNullableFilter>;
  receivedCoupon?: InputMaybe<ReceivedCouponListRelationFilter>;
  referralCode?: InputMaybe<StringFilter>;
  registrationAnswers?: InputMaybe<CustomerRegistrationAnswerListRelationFilter>;
  street?: InputMaybe<StringFilter>;
  stripeCustomerId?: InputMaybe<StringNullableFilter>;
  trainingSessions?: InputMaybe<TrainingSessionListRelationFilter>;
  type?: InputMaybe<EnumCustomerTypeFilter>;
  verified?: InputMaybe<BoolFilter>;
  zipcode?: InputMaybe<StringFilter>;
};

export type CustomerWhereUniqueInput = {
  AND?: InputMaybe<Array<CustomerWhereInput>>;
  NOT?: InputMaybe<Array<CustomerWhereInput>>;
  OR?: InputMaybe<Array<CustomerWhereInput>>;
  billings?: InputMaybe<CustomerBillingListRelationFilter>;
  communityEventBookings?: InputMaybe<CommunityEventBookingListRelationFilter>;
  communityMemberRelationsAsA?: InputMaybe<CommunityMemberRelationListRelationFilter>;
  communityMemberRelationsAsB?: InputMaybe<CommunityMemberRelationListRelationFilter>;
  communityPostCommentLikes?: InputMaybe<CommunityPostCommentLikeListRelationFilter>;
  communityPostComments?: InputMaybe<CommunityPostCommentListRelationFilter>;
  communityPostLikes?: InputMaybe<CommunityPostLikeListRelationFilter>;
  contract?: InputMaybe<ContractListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerCommunityClubs?: InputMaybe<CustomerCommunityClubListRelationFilter>;
  customerCompanies?: InputMaybe<CustomerCompanyListRelationFilter>;
  customerGyms?: InputMaybe<CustomerGymListRelationFilter>;
  customerPromotionCodes?: InputMaybe<CustomerPromotionCodeListRelationFilter>;
  dateOfBirth?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  eventBookings?: InputMaybe<EventBookingListRelationFilter>;
  feedCheckpoint?: InputMaybe<FeedCheckpointNullableScalarRelationFilter>;
  firstName?: InputMaybe<StringFilter>;
  freeMinuteUsage?: InputMaybe<CustomerFreeMinuteUsageListRelationFilter>;
  freeMinutes?: InputMaybe<CustomerFreeMinuteGrantListRelationFilter>;
  gymRatings?: InputMaybe<GymRatingListRelationFilter>;
  healthInsurance?: InputMaybe<HealthInsuranceNullableScalarRelationFilter>;
  healthInsuranceBalances?: InputMaybe<HealthInsuranceBalanceListRelationFilter>;
  healthInsuranceId?: InputMaybe<StringNullableFilter>;
  healthInsuranceReceivedPoints?: InputMaybe<HealthInsuranceReceivedPointListRelationFilter>;
  healthInsuranceRedeemedPoints?: InputMaybe<HealthInsuranceRedeemedPointListRelationFilter>;
  houseNumber?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  insuranceCustomerNumber?: InputMaybe<StringNullableFilter>;
  lastName?: InputMaybe<StringFilter>;
  mobileNumber?: InputMaybe<StringFilter>;
  place?: InputMaybe<StringFilter>;
  profile?: InputMaybe<ProfileNullableScalarRelationFilter>;
  pushToken?: InputMaybe<StringNullableFilter>;
  receivedCoupon?: InputMaybe<ReceivedCouponListRelationFilter>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  registrationAnswers?: InputMaybe<CustomerRegistrationAnswerListRelationFilter>;
  street?: InputMaybe<StringFilter>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  trainingSessions?: InputMaybe<TrainingSessionListRelationFilter>;
  type?: InputMaybe<EnumCustomerTypeFilter>;
  verified?: InputMaybe<BoolFilter>;
  zipcode?: InputMaybe<StringFilter>;
};

export type DateGroupedCount = {
  __typename: 'DateGroupedCount';
  count: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** Input for deleting a price tier. */
export type DeleteCommunityEventPriceTierInput = {
  /** The tier to delete. */
  id: Scalars['UUID']['input'];
};

/** The result of customer deletion process */
export type DeleteCustomerResult = {
  __typename: 'DeleteCustomerResult';
  /** The array of ID's from customers that could not be deleted */
  failedCustomerInfo?: Maybe<Array<FailedCustomerDeletionInfo>>;
  /** The count of successfully deleted customers */
  success: Scalars['Float']['output'];
};

/** Input for disabling a highlight order's gyms (schedule handler). */
export type DisableGymHighlightOrderInput = {
  /** The highlight order whose gyms to un-highlight. */
  orderId: Scalars['UUID']['input'];
};

export enum DocumentType {
  DriversLicence = 'DRIVERS_LICENCE',
  IdCard = 'ID_CARD',
  NationalIdNumber = 'NATIONAL_ID_NUMBER',
  Others = 'OTHERS',
  Passport = 'PASSPORT',
  ResidencePermit = 'RESIDENCE_PERMIT'
}

export enum EmployeeStatus {
  Invited = 'INVITED',
  Registered = 'REGISTERED'
}

export enum EmployeeUserType {
  /** The user is the business owner. */
  BusinessOwner = 'BUSINESS_OWNER',
  /** The user is an employee. */
  Employee = 'EMPLOYEE'
}

/** Input for enabling a highlight order's gyms (schedule handler). */
export type EnableGymHighlightOrderInput = {
  /** The highlight order whose gyms to highlight. */
  orderId: Scalars['UUID']['input'];
};

export type EnumAccessProviderFilter = {
  equals?: InputMaybe<AccessProvider>;
  in?: InputMaybe<Array<AccessProvider>>;
  not?: InputMaybe<NestedEnumAccessProviderFilter>;
  notIn?: InputMaybe<Array<AccessProvider>>;
};

export type EnumActivityTypeFilter = {
  equals?: InputMaybe<ActivityType>;
  in?: InputMaybe<Array<ActivityType>>;
  not?: InputMaybe<NestedEnumActivityTypeFilter>;
  notIn?: InputMaybe<Array<ActivityType>>;
};

export type EnumBillingStatusFilter = {
  equals?: InputMaybe<BillingStatus>;
  in?: InputMaybe<Array<BillingStatus>>;
  not?: InputMaybe<NestedEnumBillingStatusFilter>;
  notIn?: InputMaybe<Array<BillingStatus>>;
};

export type EnumCommunityEventBookingStatusFilter = {
  equals?: InputMaybe<CommunityEventBookingStatus>;
  in?: InputMaybe<Array<CommunityEventBookingStatus>>;
  not?: InputMaybe<NestedEnumCommunityEventBookingStatusFilter>;
  notIn?: InputMaybe<Array<CommunityEventBookingStatus>>;
};

export type EnumCommunityEventTicketReservationStatusFilter = {
  equals?: InputMaybe<CommunityEventTicketReservationStatus>;
  in?: InputMaybe<Array<CommunityEventTicketReservationStatus>>;
  not?: InputMaybe<NestedEnumCommunityEventTicketReservationStatusFilter>;
  notIn?: InputMaybe<Array<CommunityEventTicketReservationStatus>>;
};

export type EnumCommunityEventTicketSourceFilter = {
  equals?: InputMaybe<CommunityEventTicketSource>;
  in?: InputMaybe<Array<CommunityEventTicketSource>>;
  not?: InputMaybe<NestedEnumCommunityEventTicketSourceFilter>;
  notIn?: InputMaybe<Array<CommunityEventTicketSource>>;
};

export type EnumCommunityEventTicketStatusFilter = {
  equals?: InputMaybe<CommunityEventTicketStatus>;
  in?: InputMaybe<Array<CommunityEventTicketStatus>>;
  not?: InputMaybe<NestedEnumCommunityEventTicketStatusFilter>;
  notIn?: InputMaybe<Array<CommunityEventTicketStatus>>;
};

export type EnumCommunityEventTicketStatusNullableFilter = {
  equals?: InputMaybe<CommunityEventTicketStatus>;
  in?: InputMaybe<Array<CommunityEventTicketStatus>>;
  not?: InputMaybe<NestedEnumCommunityEventTicketStatusNullableFilter>;
  notIn?: InputMaybe<Array<CommunityEventTicketStatus>>;
};

export type EnumCompanyBillingSourceFilter = {
  equals?: InputMaybe<CompanyBillingSource>;
  in?: InputMaybe<Array<CompanyBillingSource>>;
  not?: InputMaybe<NestedEnumCompanyBillingSourceFilter>;
  notIn?: InputMaybe<Array<CompanyBillingSource>>;
};

export type EnumConsumerBillingSourceFilter = {
  equals?: InputMaybe<ConsumerBillingSource>;
  in?: InputMaybe<Array<ConsumerBillingSource>>;
  not?: InputMaybe<NestedEnumConsumerBillingSourceFilter>;
  notIn?: InputMaybe<Array<ConsumerBillingSource>>;
};

export type EnumCronIntervalNullableFilter = {
  equals?: InputMaybe<CronInterval>;
  in?: InputMaybe<Array<CronInterval>>;
  not?: InputMaybe<NestedEnumCronIntervalNullableFilter>;
  notIn?: InputMaybe<Array<CronInterval>>;
};

export type EnumCustomerTypeFilter = {
  equals?: InputMaybe<CustomerType>;
  in?: InputMaybe<Array<CustomerType>>;
  not?: InputMaybe<NestedEnumCustomerTypeFilter>;
  notIn?: InputMaybe<Array<CustomerType>>;
};

export type EnumEmployeeStatusFilter = {
  equals?: InputMaybe<EmployeeStatus>;
  in?: InputMaybe<Array<EmployeeStatus>>;
  not?: InputMaybe<NestedEnumEmployeeStatusFilter>;
  notIn?: InputMaybe<Array<EmployeeStatus>>;
};

export type EnumEmployeeUserTypeFilter = {
  equals?: InputMaybe<EmployeeUserType>;
  in?: InputMaybe<Array<EmployeeUserType>>;
  not?: InputMaybe<NestedEnumEmployeeUserTypeFilter>;
  notIn?: InputMaybe<Array<EmployeeUserType>>;
};

export type EnumEventBookingStatusFilter = {
  equals?: InputMaybe<EventBookingStatus>;
  in?: InputMaybe<Array<EventBookingStatus>>;
  not?: InputMaybe<NestedEnumEventBookingStatusFilter>;
  notIn?: InputMaybe<Array<EventBookingStatus>>;
};

export type EnumFollowRequestStatusFilter = {
  equals?: InputMaybe<FollowRequestStatus>;
  in?: InputMaybe<Array<FollowRequestStatus>>;
  not?: InputMaybe<NestedEnumFollowRequestStatusFilter>;
  notIn?: InputMaybe<Array<FollowRequestStatus>>;
};

export type EnumFreeMinuteTypeFilter = {
  equals?: InputMaybe<FreeMinuteType>;
  in?: InputMaybe<Array<FreeMinuteType>>;
  not?: InputMaybe<NestedEnumFreeMinuteTypeFilter>;
  notIn?: InputMaybe<Array<FreeMinuteType>>;
};

export type EnumGymTypeFilter = {
  equals?: InputMaybe<GymType>;
  in?: InputMaybe<Array<GymType>>;
  not?: InputMaybe<NestedEnumGymTypeFilter>;
  notIn?: InputMaybe<Array<GymType>>;
};

export type EnumMediaTypeFilter = {
  equals?: InputMaybe<MediaType>;
  in?: InputMaybe<Array<MediaType>>;
  not?: InputMaybe<NestedEnumMediaTypeFilter>;
  notIn?: InputMaybe<Array<MediaType>>;
};

export type EnumMediaTypeNullableFilter = {
  equals?: InputMaybe<MediaType>;
  in?: InputMaybe<Array<MediaType>>;
  not?: InputMaybe<NestedEnumMediaTypeNullableFilter>;
  notIn?: InputMaybe<Array<MediaType>>;
};

export type EnumPointCollectionMethodFilter = {
  equals?: InputMaybe<PointCollectionMethod>;
  in?: InputMaybe<Array<PointCollectionMethod>>;
  not?: InputMaybe<NestedEnumPointCollectionMethodFilter>;
  notIn?: InputMaybe<Array<PointCollectionMethod>>;
};

export type EnumPopupTypeFilter = {
  equals?: InputMaybe<PopupType>;
  in?: InputMaybe<Array<PopupType>>;
  not?: InputMaybe<NestedEnumPopupTypeFilter>;
  notIn?: InputMaybe<Array<PopupType>>;
};

export type EnumPostScopeFilter = {
  equals?: InputMaybe<PostScope>;
  in?: InputMaybe<Array<PostScope>>;
  not?: InputMaybe<NestedEnumPostScopeFilter>;
  notIn?: InputMaybe<Array<PostScope>>;
};

export type EnumProfileOwnerTypeFilter = {
  equals?: InputMaybe<ProfileOwnerType>;
  in?: InputMaybe<Array<ProfileOwnerType>>;
  not?: InputMaybe<NestedEnumProfileOwnerTypeFilter>;
  notIn?: InputMaybe<Array<ProfileOwnerType>>;
};

export type EnumPushNotificationSendTypeFilter = {
  equals?: InputMaybe<PushNotificationSendType>;
  in?: InputMaybe<Array<PushNotificationSendType>>;
  not?: InputMaybe<NestedEnumPushNotificationSendTypeFilter>;
  notIn?: InputMaybe<Array<PushNotificationSendType>>;
};

export type EnumPushNotificationStatusFilter = {
  equals?: InputMaybe<PushNotificationStatus>;
  in?: InputMaybe<Array<PushNotificationStatus>>;
  not?: InputMaybe<NestedEnumPushNotificationStatusFilter>;
  notIn?: InputMaybe<Array<PushNotificationStatus>>;
};

export type EnumRatingQuestionTypeFilter = {
  equals?: InputMaybe<RatingQuestionType>;
  in?: InputMaybe<Array<RatingQuestionType>>;
  not?: InputMaybe<NestedEnumRatingQuestionTypeFilter>;
  notIn?: InputMaybe<Array<RatingQuestionType>>;
};

export type EnumRecurrenceEndTypeNullableFilter = {
  equals?: InputMaybe<RecurrenceEndType>;
  in?: InputMaybe<Array<RecurrenceEndType>>;
  not?: InputMaybe<NestedEnumRecurrenceEndTypeNullableFilter>;
  notIn?: InputMaybe<Array<RecurrenceEndType>>;
};

export type EnumRecurrenceFrequencyNullableFilter = {
  equals?: InputMaybe<RecurrenceFrequency>;
  in?: InputMaybe<Array<RecurrenceFrequency>>;
  not?: InputMaybe<NestedEnumRecurrenceFrequencyNullableFilter>;
  notIn?: InputMaybe<Array<RecurrenceFrequency>>;
};

export type EnumRecurrenceMonthOptionNullableFilter = {
  equals?: InputMaybe<RecurrenceMonthOption>;
  in?: InputMaybe<Array<RecurrenceMonthOption>>;
  not?: InputMaybe<NestedEnumRecurrenceMonthOptionNullableFilter>;
  notIn?: InputMaybe<Array<RecurrenceMonthOption>>;
};

export type EnumRegistrationQuestionTypeFilter = {
  equals?: InputMaybe<RegistrationQuestionType>;
  in?: InputMaybe<Array<RegistrationQuestionType>>;
  not?: InputMaybe<NestedEnumRegistrationQuestionTypeFilter>;
  notIn?: InputMaybe<Array<RegistrationQuestionType>>;
};

export type EnumTrainingFinishReasonNullableFilter = {
  equals?: InputMaybe<TrainingFinishReason>;
  in?: InputMaybe<Array<TrainingFinishReason>>;
  not?: InputMaybe<NestedEnumTrainingFinishReasonNullableFilter>;
  notIn?: InputMaybe<Array<TrainingFinishReason>>;
};

export type EnumTrainingFinishTypeFilter = {
  equals?: InputMaybe<TrainingFinishType>;
  in?: InputMaybe<Array<TrainingFinishType>>;
  not?: InputMaybe<NestedEnumTrainingFinishTypeFilter>;
  notIn?: InputMaybe<Array<TrainingFinishType>>;
};

export type EnumUserPostTypeFilter = {
  equals?: InputMaybe<UserPostType>;
  in?: InputMaybe<Array<UserPostType>>;
  not?: InputMaybe<NestedEnumUserPostTypeFilter>;
  notIn?: InputMaybe<Array<UserPostType>>;
};

export type EnumWorkoutProviderFilter = {
  equals?: InputMaybe<WorkoutProvider>;
  in?: InputMaybe<Array<WorkoutProvider>>;
  not?: InputMaybe<NestedEnumWorkoutProviderFilter>;
  notIn?: InputMaybe<Array<WorkoutProvider>>;
};

export type EnumWorkoutTypeFilter = {
  equals?: InputMaybe<WorkoutType>;
  in?: InputMaybe<Array<WorkoutType>>;
  not?: InputMaybe<NestedEnumWorkoutTypeFilter>;
  notIn?: InputMaybe<Array<WorkoutType>>;
};

export type EnumWorkoutVisibilityFilter = {
  equals?: InputMaybe<WorkoutVisibility>;
  in?: InputMaybe<Array<WorkoutVisibility>>;
  not?: InputMaybe<NestedEnumWorkoutVisibilityFilter>;
  notIn?: InputMaybe<Array<WorkoutVisibility>>;
};

export type EnumWorkoutVisibleMetricNullableListFilter = {
  equals?: InputMaybe<Array<WorkoutVisibleMetric>>;
  has?: InputMaybe<WorkoutVisibleMetric>;
  hasEvery?: InputMaybe<Array<WorkoutVisibleMetric>>;
  hasSome?: InputMaybe<Array<WorkoutVisibleMetric>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input to calculate estimated training price for training sessions */
export type EstimatedPriceInput = {
  /** The end time of the training session */
  endTime: Scalars['String']['input'];
  /** The minimum training duration of the gym in which this session was completed */
  minTrainingDuration: Scalars['Float']['input'];
  /** The training price per minute of the gym in which this session was completed */
  pricePerMinute: Scalars['Float']['input'];
  /** The start time of the training session */
  startTime: Scalars['String']['input'];
};

/** Represents the result of estimated training price endpoint */
export type EstimatedPriceModel = {
  __typename: 'EstimatedPriceModel';
  totalDuration: Scalars['Float']['output'];
  totalNet: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
  totalVat: Scalars['Float']['output'];
};

/** Represents a event hosted by a special interest gym. */
export type Event = {
  __typename: 'Event';
  _count: EventCount;
  bookings?: Maybe<Array<EventBooking>>;
  /** The date and time when the event was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The date and time at which the event was deleted */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** A detailed description of the event. */
  description?: Maybe<Scalars['String']['output']>;
  duration: Scalars['Int']['output'];
  /** The end date and time of the event. */
  endAt: Scalars['DateTime']['output'];
  /** The gym where the event takes place. */
  gym: Gym;
  /** The unique identifier for the event. */
  id: Scalars['UUID']['output'];
  /** The maximum number of participants for the event. */
  maxParticipants: Scalars['Int']['output'];
  /** The name of the event. */
  name: Scalars['String']['output'];
  price?: Maybe<Price>;
  /** The list of sessions for this event. */
  sessions?: Maybe<Array<TrainingSession>>;
  /** The start date and time of the event. */
  startAt: Scalars['DateTime']['output'];
  /** The date and time when the event was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/** Represents a event hosted by a special interest gym. */
export type EventBookingsArgs = {
  cursor?: InputMaybe<EventBookingWhereUniqueInput>;
  distinct?: InputMaybe<Array<EventBookingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<EventBookingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventBookingWhereInput>;
};

export type EventAvgAggregate = {
  __typename: 'EventAvgAggregate';
  maxParticipants?: Maybe<Scalars['Float']['output']>;
};

/** Represents a customer's booking / reservation for a specific event. */
export type EventBooking = {
  __typename: 'EventBooking';
  /** The date and time when the booking was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The customer who booked the event. */
  customer: Customer;
  /** The date and time at which the booking was deleted */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The booked event. */
  event: Event;
  gym: Gym;
  /** The identifier of the gym where the event takes place. */
  gymId: Scalars['String']['output'];
  /** The unique identifier for the event booking. */
  id: Scalars['UUID']['output'];
  /** The status of the booking */
  status: EventBookingStatus;
};

export type EventBookingCountAggregate = {
  __typename: 'EventBookingCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  gymId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
};

export type EventBookingCreateInput = {
  eventId: Scalars['String']['input'];
  gymId: Scalars['String']['input'];
};

export type EventBookingCreateNestedManyWithoutGymInput = {
  connect?: InputMaybe<Array<EventBookingWhereUniqueInput>>;
};

export type EventBookingEdge = {
  __typename: 'EventBookingEdge';
  cursor: PaginatedEventbookingsCursor;
  node: EventBooking;
};

export type EventBookingEventIdCustomerIdCompoundUniqueInput = {
  customerId: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
};

export type EventBookingListRelationFilter = {
  every?: InputMaybe<EventBookingWhereInput>;
  none?: InputMaybe<EventBookingWhereInput>;
  some?: InputMaybe<EventBookingWhereInput>;
};

export type EventBookingMaxAggregate = {
  __typename: 'EventBookingMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  gymId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  status?: Maybe<EventBookingStatus>;
};

export type EventBookingMinAggregate = {
  __typename: 'EventBookingMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  gymId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  status?: Maybe<EventBookingStatus>;
};

export type EventBookingOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type EventBookingOrderByWithRelationInput = {
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrderInput>;
  event?: InputMaybe<EventOrderByWithRelationInput>;
  eventId?: InputMaybe<SortOrder>;
  gym?: InputMaybe<GymOrderByWithRelationInput>;
  gymId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export enum EventBookingScalarFieldEnum {
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  DeletedAt = 'deletedAt',
  EventId = 'eventId',
  GymId = 'gymId',
  Id = 'id',
  Status = 'status'
}

export enum EventBookingStatus {
  Active = 'ACTIVE',
  CanceledCustomer = 'CANCELED_CUSTOMER',
  CanceledOrganizer = 'CANCELED_ORGANIZER',
  Done = 'DONE',
  NotParticipated = 'NOT_PARTICIPATED'
}

export type EventBookingUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<EventBookingWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<EventBookingWhereUniqueInput>>;
};

export type EventBookingUpdateManyWithoutEventNestedInput = {
  connect?: InputMaybe<Array<EventBookingWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<EventBookingWhereUniqueInput>>;
};

export type EventBookingUpdateManyWithoutGymNestedInput = {
  connect?: InputMaybe<Array<EventBookingWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<EventBookingWhereUniqueInput>>;
};

export type EventBookingWhereInput = {
  AND?: InputMaybe<Array<EventBookingWhereInput>>;
  NOT?: InputMaybe<Array<EventBookingWhereInput>>;
  OR?: InputMaybe<Array<EventBookingWhereInput>>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  event?: InputMaybe<EventScalarRelationFilter>;
  eventId?: InputMaybe<UuidFilter>;
  gym?: InputMaybe<GymScalarRelationFilter>;
  gymId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  status?: InputMaybe<EnumEventBookingStatusFilter>;
};

export type EventBookingWhereUniqueInput = {
  AND?: InputMaybe<Array<EventBookingWhereInput>>;
  NOT?: InputMaybe<Array<EventBookingWhereInput>>;
  OR?: InputMaybe<Array<EventBookingWhereInput>>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  event?: InputMaybe<EventScalarRelationFilter>;
  eventId?: InputMaybe<UuidFilter>;
  eventId_customerId?: InputMaybe<EventBookingEventIdCustomerIdCompoundUniqueInput>;
  gym?: InputMaybe<GymScalarRelationFilter>;
  gymId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<EnumEventBookingStatusFilter>;
};

export type EventCount = {
  __typename: 'EventCount';
  bookings: Scalars['Int']['output'];
  sessions: Scalars['Int']['output'];
};

export type EventCountAggregate = {
  __typename: 'EventCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  endAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  maxParticipants: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  startAt: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type EventCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endAt: Scalars['DateTime']['input'];
  gym: GymCreateNestedOneWithoutEventsInput;
  maxParticipants: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  /** The price of the Event */
  price: Scalars['Float']['input'];
  startAt: Scalars['DateTime']['input'];
};

export type EventCreateNestedManyWithoutGymInput = {
  connect?: InputMaybe<Array<EventWhereUniqueInput>>;
};

export type EventCreateNestedOneWithoutSessionsInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
};

export type EventListRelationFilter = {
  every?: InputMaybe<EventWhereInput>;
  none?: InputMaybe<EventWhereInput>;
  some?: InputMaybe<EventWhereInput>;
};

export type EventMaxAggregate = {
  __typename: 'EventMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  maxParticipants?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EventMinAggregate = {
  __typename: 'EventMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  maxParticipants?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EventNullableScalarRelationFilter = {
  is?: InputMaybe<EventWhereInput>;
  isNot?: InputMaybe<EventWhereInput>;
};

export type EventOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type EventOrderByWithRelationInput = {
  bookings?: InputMaybe<EventBookingOrderByRelationAggregateInput>;
  deletedAt?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrderInput>;
  endAt?: InputMaybe<SortOrder>;
  gym?: InputMaybe<GymOrderByWithRelationInput>;
  gymId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  maxParticipants?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  price?: InputMaybe<PriceOrderByWithRelationInput>;
  sessions?: InputMaybe<TrainingSessionOrderByRelationAggregateInput>;
  startAt?: InputMaybe<SortOrder>;
};

export enum EventScalarFieldEnum {
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Description = 'description',
  EndAt = 'endAt',
  GymId = 'gymId',
  Id = 'id',
  MaxParticipants = 'maxParticipants',
  Name = 'name',
  StartAt = 'startAt',
  UpdatedAt = 'updatedAt'
}

export type EventScalarRelationFilter = {
  is?: InputMaybe<EventWhereInput>;
  isNot?: InputMaybe<EventWhereInput>;
};

export type EventSumAggregate = {
  __typename: 'EventSumAggregate';
  maxParticipants?: Maybe<Scalars['Int']['output']>;
};

/** Input for updating a gym */
export type EventUpdateInput = {
  bookings?: InputMaybe<EventBookingUpdateManyWithoutEventNestedInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  maxParticipants?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The price to update */
  price?: InputMaybe<Scalars['Float']['input']>;
  sessions?: InputMaybe<TrainingSessionUpdateManyWithoutEventNestedInput>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EventUpdateManyWithoutGymNestedInput = {
  connect?: InputMaybe<Array<EventWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<EventWhereUniqueInput>>;
};

export type EventUpdateOneWithoutSessionsNestedInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  disconnect?: InputMaybe<EventWhereInput>;
};

export type EventWhereInput = {
  AND?: InputMaybe<Array<EventWhereInput>>;
  NOT?: InputMaybe<Array<EventWhereInput>>;
  OR?: InputMaybe<Array<EventWhereInput>>;
  bookings?: InputMaybe<EventBookingListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  endAt?: InputMaybe<DateTimeFilter>;
  gym?: InputMaybe<GymScalarRelationFilter>;
  gymId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  maxParticipants?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  price?: InputMaybe<PriceNullableScalarRelationFilter>;
  sessions?: InputMaybe<TrainingSessionListRelationFilter>;
  startAt?: InputMaybe<DateTimeFilter>;
};

export type EventWhereUniqueInput = {
  AND?: InputMaybe<Array<EventWhereInput>>;
  NOT?: InputMaybe<Array<EventWhereInput>>;
  OR?: InputMaybe<Array<EventWhereInput>>;
  bookings?: InputMaybe<EventBookingListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  endAt?: InputMaybe<DateTimeFilter>;
  gym?: InputMaybe<GymScalarRelationFilter>;
  gymId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  maxParticipants?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  price?: InputMaybe<PriceNullableScalarRelationFilter>;
  sessions?: InputMaybe<TrainingSessionListRelationFilter>;
  startAt?: InputMaybe<DateTimeFilter>;
};

export enum ExtensionType {
  None = 'NONE',
  SubsequentRateDetail = 'SUBSEQUENT_RATE_DETAIL',
  TermExtension = 'TERM_EXTENSION'
}

/** Information about failed customer deletion */
export type FailedCustomerDeletionInfo = {
  __typename: 'FailedCustomerDeletionInfo';
  /** Indicator of whether a rollback of the archive is necessary or not */
  archiveRollbackStrategy?: Maybe<CustomerDeletionArchiveRollbackStrategy>;
  /** The unique identifier of the customer that failed to delete */
  customerId: Scalars['String']['output'];
  /** The process the deletion has been failed at */
  failedProcess: CustomerDeletionFailedProcess;
  /** The reason why the deletion has failed */
  reason: Scalars['String']['output'];
};

export type FeedCheckpointCountAggregate = {
  __typename: 'FeedCheckpointCountAggregate';
  _all: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastSeenPostId: Scalars['Int']['output'];
  lastSeenPostedAt: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type FeedCheckpointMaxAggregate = {
  __typename: 'FeedCheckpointMaxAggregate';
  id?: Maybe<Scalars['UUID']['output']>;
  lastSeenPostId?: Maybe<Scalars['String']['output']>;
  lastSeenPostedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FeedCheckpointMinAggregate = {
  __typename: 'FeedCheckpointMinAggregate';
  id?: Maybe<Scalars['UUID']['output']>;
  lastSeenPostId?: Maybe<Scalars['String']['output']>;
  lastSeenPostedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FeedCheckpointNullableScalarRelationFilter = {
  is?: InputMaybe<FeedCheckpointWhereInput>;
  isNot?: InputMaybe<FeedCheckpointWhereInput>;
};

export type FeedCheckpointOrderByWithRelationInput = {
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastSeenPostId?: InputMaybe<SortOrder>;
  lastSeenPostedAt?: InputMaybe<SortOrder>;
};

export type FeedCheckpointUpdateOneWithoutCustomerNestedInput = {
  connect?: InputMaybe<FeedCheckpointWhereUniqueInput>;
  disconnect?: InputMaybe<FeedCheckpointWhereInput>;
};

export type FeedCheckpointWhereInput = {
  AND?: InputMaybe<Array<FeedCheckpointWhereInput>>;
  NOT?: InputMaybe<Array<FeedCheckpointWhereInput>>;
  OR?: InputMaybe<Array<FeedCheckpointWhereInput>>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  lastSeenPostId?: InputMaybe<UuidFilter>;
  lastSeenPostedAt?: InputMaybe<DateTimeFilter>;
};

export type FeedCheckpointWhereUniqueInput = {
  AND?: InputMaybe<Array<FeedCheckpointWhereInput>>;
  NOT?: InputMaybe<Array<FeedCheckpointWhereInput>>;
  OR?: InputMaybe<Array<FeedCheckpointWhereInput>>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  lastSeenPostId?: InputMaybe<UuidFilter>;
  lastSeenPostedAt?: InputMaybe<DateTimeFilter>;
};

export type FeedItem = CommunityPost | UserPost;

/** Input for finishing a training session */
export type FinishTrainingSessionInput = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  finishReason?: InputMaybe<TrainingFinishReason>;
  finishType?: InputMaybe<TrainingFinishType>;
};

export type FloatFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type Follow = {
  __typename: 'Follow';
  createdAt: Scalars['DateTime']['output'];
  followerProfile: Profile;
  followingProfile: Profile;
  id: Scalars['UUID']['output'];
};

export type FollowCountAggregate = {
  __typename: 'FollowCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export type FollowEdge = {
  __typename: 'FollowEdge';
  cursor: PaginatedFollowCursor;
  node: Follow;
};

export type FollowFollowerProfileIdFollowingProfileIdCompoundUniqueInput = {
  followerProfileId: Scalars['String']['input'];
  followingProfileId: Scalars['String']['input'];
};

export type FollowListRelationFilter = {
  every?: InputMaybe<FollowWhereInput>;
  none?: InputMaybe<FollowWhereInput>;
  some?: InputMaybe<FollowWhereInput>;
};

export type FollowMaxAggregate = {
  __typename: 'FollowMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
};

export type FollowMinAggregate = {
  __typename: 'FollowMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
};

export type FollowOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FollowOrderByWithRelationInput = {
  followerProfile?: InputMaybe<ProfileOrderByWithRelationInput>;
  followerProfileId?: InputMaybe<SortOrder>;
  followingProfile?: InputMaybe<ProfileOrderByWithRelationInput>;
  followingProfileId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type FollowRequest = {
  __typename: 'FollowRequest';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  requesterProfile: Profile;
  status: FollowRequestStatus;
  targetProfile: Profile;
  updatedAt: Scalars['DateTime']['output'];
};

export type FollowRequestCountAggregate = {
  __typename: 'FollowRequestCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type FollowRequestListRelationFilter = {
  every?: InputMaybe<FollowRequestWhereInput>;
  none?: InputMaybe<FollowRequestWhereInput>;
  some?: InputMaybe<FollowRequestWhereInput>;
};

export type FollowRequestMaxAggregate = {
  __typename: 'FollowRequestMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  status?: Maybe<FollowRequestStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FollowRequestMinAggregate = {
  __typename: 'FollowRequestMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  status?: Maybe<FollowRequestStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FollowRequestOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum FollowRequestStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export type FollowRequestWhereInput = {
  AND?: InputMaybe<Array<FollowRequestWhereInput>>;
  NOT?: InputMaybe<Array<FollowRequestWhereInput>>;
  OR?: InputMaybe<Array<FollowRequestWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  requesterProfile?: InputMaybe<ProfileScalarRelationFilter>;
  requesterProfileId?: InputMaybe<UuidFilter>;
  status?: InputMaybe<EnumFollowRequestStatusFilter>;
  targetProfile?: InputMaybe<ProfileScalarRelationFilter>;
  targetProfileId?: InputMaybe<UuidFilter>;
};

export enum FollowScalarFieldEnum {
  CreatedAt = 'createdAt',
  FollowerCompanyId = 'followerCompanyId',
  FollowerCustomerId = 'followerCustomerId',
  FollowerEmployeeId = 'followerEmployeeId',
  FollowerProfileId = 'followerProfileId',
  FollowingProfileId = 'followingProfileId',
  Id = 'id'
}

export type FollowWhereInput = {
  AND?: InputMaybe<Array<FollowWhereInput>>;
  NOT?: InputMaybe<Array<FollowWhereInput>>;
  OR?: InputMaybe<Array<FollowWhereInput>>;
  followerProfile?: InputMaybe<ProfileScalarRelationFilter>;
  followerProfileId?: InputMaybe<UuidFilter>;
  followingProfile?: InputMaybe<ProfileScalarRelationFilter>;
  followingProfileId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
};

export type FollowWhereUniqueInput = {
  AND?: InputMaybe<Array<FollowWhereInput>>;
  NOT?: InputMaybe<Array<FollowWhereInput>>;
  OR?: InputMaybe<Array<FollowWhereInput>>;
  followerProfile?: InputMaybe<ProfileScalarRelationFilter>;
  followerProfileId?: InputMaybe<UuidFilter>;
  followerProfileId_followingProfileId?: InputMaybe<FollowFollowerProfileIdFollowingProfileIdCompoundUniqueInput>;
  followingProfile?: InputMaybe<ProfileScalarRelationFilter>;
  followingProfileId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export enum FreeMinuteType {
  /** Minutes assigned manually by an admin */
  Manual = 'MANUAL',
  /** Obtained by successfully referring a friend */
  ReferralReward = 'REFERRAL_REWARD'
}

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  Unisex = 'UNISEX'
}

export type GenerateContractInput = {
  contract: ConnectApiContractDataDto;
  customer: ConnectApiCreatePublicCustomerDto;
  landingPageConfigurationId?: InputMaybe<Scalars['Float']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  studioId: Scalars['Float']['input'];
  voucherCode?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateContractResponse = {
  __typename: 'GenerateContractResponse';
  customerId: Scalars['Float']['output'];
  customerMemberName: Scalars['String']['output'];
  customerMemberNumber: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  optionalPaymentUrl?: Maybe<Scalars['String']['output']>;
  quickRegistrationUrl?: Maybe<Scalars['String']['output']>;
  tokenForAdditionalRequests: ConnectApiFollowUpActionTokenDto;
};

export type Gym = {
  __typename: 'Gym';
  _count: GymCount;
  accessCapabilities: GymAccessCapabilities;
  accessDevices?: Maybe<Array<GymAccessDevice>>;
  /** The advantages of the gym */
  advantages?: Maybe<Array<GymAdvantage>>;
  averageRating: Scalars['Float']['output'];
  category?: Maybe<GymCategory>;
  /** The category of the gym */
  categoryId?: Maybe<Scalars['String']['output']>;
  /** The company associated with the gym. */
  company: Company;
  /** The email address of the gym. */
  contactEmail?: Maybe<Scalars['EmailAddress']['output']>;
  /** The mobilephone number for customer support (WhatsApp) */
  contactPhone?: Maybe<Scalars['String']['output']>;
  contractProposals?: Maybe<Array<Contract>>;
  /** The date and time when the gym record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The contract id of the studio crm system */
  crmContractId?: Maybe<Scalars['String']['output']>;
  /** The studio id of the companies crm system */
  crmStudioId?: Maybe<Scalars['String']['output']>;
  customerGyms?: Maybe<Array<CustomerGym>>;
  /** The date and time at which the gym was deleted */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The description of the company (WhatsApp) */
  description?: Maybe<Scalars['String']['output']>;
  employees?: Maybe<Array<CompanyEmployee>>;
  eventBookings?: Maybe<Array<EventBooking>>;
  events?: Maybe<Array<Event>>;
  /** Whether the gym is currently highlighted. Denormalized flag maintained by the highlight scheduler. */
  highlighted: Scalars['Boolean']['output'];
  /** The house number of the gym's location. */
  houseNumber: Scalars['String']['output'];
  /** The unique identifier for the gym. */
  id: Scalars['UUID']['output'];
  /** The images of the gym */
  images?: Maybe<Array<GymImage>>;
  /** The latitude coordinate of the gym's location. */
  latitude: Scalars['String']['output'];
  /** The longitude coordinate of the gym's location. */
  longitude: Scalars['String']['output'];
  /** The minimum duration of a training session in minutes. */
  minTrainingDuration: Scalars['Int']['output'];
  /** The name of the gym. */
  name: Scalars['String']['output'];
  openingHours?: Maybe<Array<OpeningHour>>;
  payoutHistory?: Maybe<Array<PayoutHistory>>;
  /** The city or town where the gym is located. */
  place: Scalars['String']['output'];
  /** The price information associated with the gym. */
  price?: Maybe<Price>;
  promotion?: Maybe<Promotion>;
  /** The promotion id associated with this gym */
  promotionId?: Maybe<Scalars['UUID']['output']>;
  /** The QR code associated with the gym. */
  qrcode: Scalars['String']['output'];
  ratings?: Maybe<Array<GymRating>>;
  /** The street name of the gym's location. */
  street: Scalars['String']['output'];
  /** The Stripe Connect ID associated with this gym. */
  stripeConnectId: Scalars['String']['output'];
  /** The list of training sessions held at the gym. */
  trainingSessions?: Maybe<Array<TrainingSession>>;
  /** The type of the gym, e.g., a standard fitness studio or a special interest studio. */
  type: GymType;
  /** The date and time when the gym record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The maximum number of sessions a member can attend per week. */
  weeklySessionLimit?: Maybe<Scalars['Int']['output']>;
  /** The postal code of the gym's location. */
  zipcode: Scalars['String']['output'];
};


export type GymAverageRatingArgs = {
  onlyQuestionRelated?: Scalars['Boolean']['input'];
};


export type GymEventsArgs = {
  cursor?: InputMaybe<EventWhereUniqueInput>;
  distinct?: InputMaybe<Array<EventScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<EventOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventWhereInput>;
};

export type GymAccessCapabilities = {
  __typename: 'GymAccessCapabilities';
  enabled: Scalars['Boolean']['output'];
  entry: Scalars['Boolean']['output'];
  exit: Scalars['Boolean']['output'];
};

export type GymAccessDevice = {
  __typename: 'GymAccessDevice';
  /**
   * Defines whether this device can trigger an ENTRY (open for entering the gym)
   * Used for validation when opening access for training start
   */
  canOpenEntry: Scalars['Boolean']['output'];
  /**
   * Defines whether this device can trigger an EXIT (open for leaving the gym)
   * If false, exiting the gym is handled externally or there is no need to open a device
   */
  canOpenExit: Scalars['Boolean']['output'];
  /** Timestamp when the device record was created */
  createdAt: Scalars['DateTime']['output'];
  /** Optional description of the device (location, notes, etc.) */
  description?: Maybe<Scalars['String']['output']>;
  durationMs?: Maybe<Scalars['Float']['output']>;
  gym: Gym;
  /** Gym identifier where the device is physically installed */
  gymId: Scalars['UUID']['output'];
  /** Unique identifier of the access device wihting TrainToGo */
  id: Scalars['UUID']['output'];
  /**
   * Indicates whether the device is currently active and should be used by the system
   * Inactive devices are ignored for access and UI capability checks
   */
  isActive: Scalars['Boolean']['output'];
  /** Live online status from ACS (event-based). Only for GYM_APP devices; null for be-in / evo or when ACS has no match. */
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  /** Human readable name of the device (e.g.) "Main Entrance") */
  name: Scalars['String']['output'];
  /** The access provider used to control this device */
  provider: AccessProvider;
  /** Display order of the device within its gym (from ACS, ascending). Only for GYM_APP devices; null for be-in / evo or when ACS has no match. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** Timestamp of the last update */
  updatedAt: Scalars['DateTime']['output'];
};

export type GymAccessDeviceCountAggregate = {
  __typename: 'GymAccessDeviceCountAggregate';
  _all: Scalars['Int']['output'];
  canOpenEntry: Scalars['Int']['output'];
  canOpenExit: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  gymId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  provider: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type GymAccessDeviceCreateNestedManyWithoutGymInput = {
  connect?: InputMaybe<Array<GymAccessDeviceWhereUniqueInput>>;
};

export type GymAccessDeviceListRelationFilter = {
  every?: InputMaybe<GymAccessDeviceWhereInput>;
  none?: InputMaybe<GymAccessDeviceWhereInput>;
  some?: InputMaybe<GymAccessDeviceWhereInput>;
};

export type GymAccessDeviceMaxAggregate = {
  __typename: 'GymAccessDeviceMaxAggregate';
  canOpenEntry?: Maybe<Scalars['Boolean']['output']>;
  canOpenExit?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  gymId?: Maybe<Scalars['UUID']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<AccessProvider>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GymAccessDeviceMinAggregate = {
  __typename: 'GymAccessDeviceMinAggregate';
  canOpenEntry?: Maybe<Scalars['Boolean']['output']>;
  canOpenExit?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  gymId?: Maybe<Scalars['UUID']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<AccessProvider>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GymAccessDeviceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type GymAccessDeviceProviderProviderDeviceIdCompoundUniqueInput = {
  provider: AccessProvider;
};

export type GymAccessDeviceUpdateManyWithoutGymNestedInput = {
  connect?: InputMaybe<Array<GymAccessDeviceWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<GymAccessDeviceWhereUniqueInput>>;
};

export type GymAccessDeviceWhereInput = {
  AND?: InputMaybe<Array<GymAccessDeviceWhereInput>>;
  NOT?: InputMaybe<Array<GymAccessDeviceWhereInput>>;
  OR?: InputMaybe<Array<GymAccessDeviceWhereInput>>;
  canOpenEntry?: InputMaybe<BoolFilter>;
  canOpenExit?: InputMaybe<BoolFilter>;
  description?: InputMaybe<StringNullableFilter>;
  gym?: InputMaybe<GymScalarRelationFilter>;
  gymId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isActive?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  provider?: InputMaybe<EnumAccessProviderFilter>;
};

export type GymAccessDeviceWhereUniqueInput = {
  AND?: InputMaybe<Array<GymAccessDeviceWhereInput>>;
  NOT?: InputMaybe<Array<GymAccessDeviceWhereInput>>;
  OR?: InputMaybe<Array<GymAccessDeviceWhereInput>>;
  canOpenEntry?: InputMaybe<BoolFilter>;
  canOpenExit?: InputMaybe<BoolFilter>;
  description?: InputMaybe<StringNullableFilter>;
  gym?: InputMaybe<GymScalarRelationFilter>;
  gymId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  provider?: InputMaybe<EnumAccessProviderFilter>;
  provider_providerDeviceId?: InputMaybe<GymAccessDeviceProviderProviderDeviceIdCompoundUniqueInput>;
};

export type GymAccessDevicesInput = {
  /** The gym whose access devices are requested (also the ACS externalGymId). */
  gymId: Scalars['String']['input'];
  /** Optional provider filter. Omitted = all providers. A non-GYM_APP provider skips ACS entirely (ACS only holds GYM_APP devices). */
  provider?: InputMaybe<AccessProvider>;
};

export type GymAdvantage = {
  __typename: 'GymAdvantage';
  description?: Maybe<Scalars['String']['output']>;
  gyms?: Maybe<Array<Gym>>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

export type GymAdvantageCountAggregate = {
  __typename: 'GymAdvantageCountAggregate';
  _all: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
};

export type GymAdvantageCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  gyms?: InputMaybe<GymCreateNestedManyWithoutAdvantagesInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
};

export type GymAdvantageCreateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
};

export type GymAdvantageListRelationFilter = {
  every?: InputMaybe<GymAdvantageWhereInput>;
  none?: InputMaybe<GymAdvantageWhereInput>;
  some?: InputMaybe<GymAdvantageWhereInput>;
};

export type GymAdvantageMaxAggregate = {
  __typename: 'GymAdvantageMaxAggregate';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GymAdvantageMinAggregate = {
  __typename: 'GymAdvantageMinAggregate';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GymAdvantageOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type GymAdvantageOrderByWithRelationInput = {
  description?: InputMaybe<SortOrderInput>;
  gyms?: InputMaybe<GymOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export enum GymAdvantageScalarFieldEnum {
  Description = 'description',
  Id = 'id',
  Name = 'name'
}

export type GymAdvantageUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  gyms?: InputMaybe<GymUpdateManyWithoutAdvantagesNestedInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GymAdvantageUpdateManyWithoutGymsNestedInput = {
  connect?: InputMaybe<Array<GymAdvantageWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<GymAdvantageWhereUniqueInput>>;
};

export type GymAdvantageWhereInput = {
  AND?: InputMaybe<Array<GymAdvantageWhereInput>>;
  NOT?: InputMaybe<Array<GymAdvantageWhereInput>>;
  OR?: InputMaybe<Array<GymAdvantageWhereInput>>;
  description?: InputMaybe<StringNullableFilter>;
  gyms?: InputMaybe<GymListRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
};

export type GymAdvantageWhereUniqueInput = {
  AND?: InputMaybe<Array<GymAdvantageWhereInput>>;
  NOT?: InputMaybe<Array<GymAdvantageWhereInput>>;
  OR?: InputMaybe<Array<GymAdvantageWhereInput>>;
  description?: InputMaybe<StringNullableFilter>;
  gyms?: InputMaybe<GymListRelationFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GymAvgAggregate = {
  __typename: 'GymAvgAggregate';
  minTrainingDuration?: Maybe<Scalars['Float']['output']>;
  weeklySessionLimit?: Maybe<Scalars['Float']['output']>;
};

export type GymCategory = {
  __typename: 'GymCategory';
  description?: Maybe<Scalars['String']['output']>;
  gyms?: Maybe<Array<Gym>>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

export type GymCategoryCountAggregate = {
  __typename: 'GymCategoryCountAggregate';
  _all: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
};

export type GymCategoryCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  gyms?: InputMaybe<GymCreateNestedManyWithoutCategoryInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
};

export type GymCategoryCreateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
};

export type GymCategoryCreateNestedOneWithoutGymsInput = {
  connect?: InputMaybe<GymCategoryWhereUniqueInput>;
};

export type GymCategoryMaxAggregate = {
  __typename: 'GymCategoryMaxAggregate';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GymCategoryMinAggregate = {
  __typename: 'GymCategoryMinAggregate';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GymCategoryNullableScalarRelationFilter = {
  is?: InputMaybe<GymCategoryWhereInput>;
  isNot?: InputMaybe<GymCategoryWhereInput>;
};

export type GymCategoryOrderByWithRelationInput = {
  description?: InputMaybe<SortOrderInput>;
  gyms?: InputMaybe<GymOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export enum GymCategoryScalarFieldEnum {
  Description = 'description',
  Id = 'id',
  Name = 'name'
}

export type GymCategoryUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  gyms?: InputMaybe<GymUpdateManyWithoutCategoryNestedInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GymCategoryUpdateOneWithoutGymsNestedInput = {
  connect?: InputMaybe<GymCategoryWhereUniqueInput>;
  disconnect?: InputMaybe<GymCategoryWhereInput>;
};

export type GymCategoryWhereInput = {
  AND?: InputMaybe<Array<GymCategoryWhereInput>>;
  NOT?: InputMaybe<Array<GymCategoryWhereInput>>;
  OR?: InputMaybe<Array<GymCategoryWhereInput>>;
  description?: InputMaybe<StringNullableFilter>;
  gyms?: InputMaybe<GymListRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
};

export type GymCategoryWhereUniqueInput = {
  AND?: InputMaybe<Array<GymCategoryWhereInput>>;
  NOT?: InputMaybe<Array<GymCategoryWhereInput>>;
  OR?: InputMaybe<Array<GymCategoryWhereInput>>;
  description?: InputMaybe<StringNullableFilter>;
  gyms?: InputMaybe<GymListRelationFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GymCount = {
  __typename: 'GymCount';
  accessDevices: Scalars['Int']['output'];
  advantages: Scalars['Int']['output'];
  contractProposals: Scalars['Int']['output'];
  customerGyms: Scalars['Int']['output'];
  employees: Scalars['Int']['output'];
  eventBookings: Scalars['Int']['output'];
  events: Scalars['Int']['output'];
  highlightOrders: Scalars['Int']['output'];
  images: Scalars['Int']['output'];
  openingHours: Scalars['Int']['output'];
  payoutHistory: Scalars['Int']['output'];
  prices: Scalars['Int']['output'];
  ratings: Scalars['Int']['output'];
  trainingSessions: Scalars['Int']['output'];
};

export type GymCountAggregate = {
  __typename: 'GymCountAggregate';
  _all: Scalars['Int']['output'];
  categoryId: Scalars['Int']['output'];
  contactEmail: Scalars['Int']['output'];
  contactPhone: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  crmContractId: Scalars['Int']['output'];
  crmStudioId: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  highlighted: Scalars['Int']['output'];
  houseNumber: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  latitude: Scalars['Int']['output'];
  longitude: Scalars['Int']['output'];
  minTrainingDuration: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  place: Scalars['Int']['output'];
  promotionId: Scalars['Int']['output'];
  qrcode: Scalars['Int']['output'];
  street: Scalars['Int']['output'];
  stripeConnectId: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  weeklySessionLimit: Scalars['Int']['output'];
  zipcode: Scalars['Int']['output'];
};

export type GymCreateInput = {
  accessDevices?: InputMaybe<GymAccessDeviceCreateNestedManyWithoutGymInput>;
  category?: InputMaybe<GymCategoryCreateNestedOneWithoutGymsInput>;
  company?: InputMaybe<CompanyCreateNestedOneWithoutGymsInput>;
  contactEmail?: InputMaybe<Scalars['EmailAddress']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  contractProposals?: InputMaybe<ContractCreateNestedManyWithoutGymInput>;
  crmContractId?: InputMaybe<Scalars['String']['input']>;
  crmStudioId?: InputMaybe<Scalars['String']['input']>;
  customerGyms?: InputMaybe<CustomerGymCreateNestedManyWithoutGymInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employees?: InputMaybe<CompanyEmployeeCreateNestedManyWithoutGymsInput>;
  eventBookings?: InputMaybe<EventBookingCreateNestedManyWithoutGymInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutGymInput>;
  highlightOrders?: InputMaybe<GymHighlightOrderGymCreateNestedManyWithoutGymInput>;
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
  houseNumber: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  latitude: Scalars['String']['input'];
  longitude: Scalars['String']['input'];
  minTrainingDuration?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  openingHours?: InputMaybe<OpeningHourCreateNestedManyWithoutGymInput>;
  place: Scalars['String']['input'];
  /** The price per minute in cents of the gym */
  price: Scalars['Float']['input'];
  /** How the price is billed: PAY_PER_MINUTE (price in cents per minute, default) or DAILY_TICKET (price in cents per training). EVENT is not allowed for gyms. */
  pricingModel?: InputMaybe<PricingModel>;
  promotion?: InputMaybe<PromotionCreateNestedOneWithoutGymsInput>;
  qrcode: Scalars['String']['input'];
  ratings?: InputMaybe<GymRatingCreateNestedManyWithoutGymInput>;
  street: Scalars['String']['input'];
  stripeConnectId: Scalars['String']['input'];
  type?: InputMaybe<GymType>;
  weeklySessionLimit?: InputMaybe<Scalars['Int']['input']>;
  zipcode: Scalars['String']['input'];
};

export type GymCreateNestedManyWithoutAdvantagesInput = {
  connect?: InputMaybe<Array<GymWhereUniqueInput>>;
};

export type GymCreateNestedManyWithoutCategoryInput = {
  connect?: InputMaybe<Array<GymWhereUniqueInput>>;
};

export type GymCreateNestedManyWithoutEmployeesInput = {
  connect?: InputMaybe<Array<GymWhereUniqueInput>>;
};

export type GymCreateNestedManyWithoutPromotionInput = {
  /** List of gyms to connect to this promotion */
  connect: Array<GymWhereUniqueInput>;
};

export type GymCreateNestedOneWithoutEventsInput = {
  connect: GymWhereUniqueInput;
};

export type GymCreateNestedOneWithoutImagesInput = {
  connect?: InputMaybe<GymWhereUniqueInput>;
};

export type GymCreateNestedOneWithoutOpeningHoursInput = {
  connect: GymWhereUniqueInput;
};

export type GymCreateNestedOneWithoutPayoutHistoryInput = {
  connect: GymWhereUniqueInput;
};

export type GymCreateNestedOneWithoutTrainingSessionsInput = {
  connect?: InputMaybe<GymWhereUniqueInput>;
};

/**
 * A purchase that highlights one or more gyms for one shared period and carries the payment.
 * A gym is highlighted for [startDate, endDate] while a covering order is PAID.
 */
export type GymHighlightOrder = {
  __typename: 'GymHighlightOrder';
  /** Price per gym for the period in cents (snapshotted); order total = this * gym count. */
  amountPerGymInCents: Scalars['Int']['output'];
  /** The company that placed the order. */
  company: Company;
  companyBilling?: Maybe<CompanyBilling>;
  /** The date and time when the order was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Last day (inclusive) the gyms are highlighted; shared by all gyms of the order. */
  endDate: Scalars['Date']['output'];
  gyms: Array<Gym>;
  /** The unique identifier for the highlight order. */
  id: Scalars['UUID']['output'];
  /** The price config that was active when this order was placed. */
  priceConfig: GymHighlightPriceConfig;
  /** First day (inclusive) the gyms are highlighted; shared by all gyms of the order. */
  startDate: Scalars['Date']['output'];
  /** The current payment status of the order. */
  status: GymHighlightOrderStatus;
  /** The Stripe Checkout Session id used to collect the payment. */
  stripeCheckoutSessionId?: Maybe<Scalars['String']['output']>;
  /** The total amount of the whole order in cents, snapshotted at checkout time. */
  totalAmountInCents: Scalars['Int']['output'];
  /** The date and time when the order was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type GymHighlightOrderAvgAggregate = {
  __typename: 'GymHighlightOrderAvgAggregate';
  amountPerGymInCents?: Maybe<Scalars['Float']['output']>;
  totalAmountInCents?: Maybe<Scalars['Float']['output']>;
};

export type GymHighlightOrderCountAggregate = {
  __typename: 'GymHighlightOrderCountAggregate';
  _all: Scalars['Int']['output'];
  amountPerGymInCents: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  endDate: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  startDate: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  stripeCheckoutSessionId: Scalars['Int']['output'];
  totalAmountInCents: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type GymHighlightOrderCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<GymHighlightOrderWhereUniqueInput>>;
};

export type GymHighlightOrderGymCountAggregate = {
  __typename: 'GymHighlightOrderGymCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type GymHighlightOrderGymCreateNestedManyWithoutGymInput = {
  connect?: InputMaybe<Array<GymHighlightOrderGymWhereUniqueInput>>;
};

export type GymHighlightOrderGymListRelationFilter = {
  every?: InputMaybe<GymHighlightOrderGymWhereInput>;
  none?: InputMaybe<GymHighlightOrderGymWhereInput>;
  some?: InputMaybe<GymHighlightOrderGymWhereInput>;
};

export type GymHighlightOrderGymMaxAggregate = {
  __typename: 'GymHighlightOrderGymMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GymHighlightOrderGymMinAggregate = {
  __typename: 'GymHighlightOrderGymMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GymHighlightOrderGymOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type GymHighlightOrderGymOrderIdGymIdCompoundUniqueInput = {
  gymId: Scalars['UUID']['input'];
  orderId: Scalars['UUID']['input'];
};

export type GymHighlightOrderGymUpdateManyWithoutGymNestedInput = {
  connect?: InputMaybe<Array<GymHighlightOrderGymWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<GymHighlightOrderGymWhereUniqueInput>>;
};

export type GymHighlightOrderGymWhereInput = {
  AND?: InputMaybe<Array<GymHighlightOrderGymWhereInput>>;
  NOT?: InputMaybe<Array<GymHighlightOrderGymWhereInput>>;
  OR?: InputMaybe<Array<GymHighlightOrderGymWhereInput>>;
  gym?: InputMaybe<GymScalarRelationFilter>;
  gymId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  order?: InputMaybe<GymHighlightOrderScalarRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
};

export type GymHighlightOrderGymWhereUniqueInput = {
  AND?: InputMaybe<Array<GymHighlightOrderGymWhereInput>>;
  NOT?: InputMaybe<Array<GymHighlightOrderGymWhereInput>>;
  OR?: InputMaybe<Array<GymHighlightOrderGymWhereInput>>;
  gym?: InputMaybe<GymScalarRelationFilter>;
  gymId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  order?: InputMaybe<GymHighlightOrderScalarRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
  orderId_gymId?: InputMaybe<GymHighlightOrderGymOrderIdGymIdCompoundUniqueInput>;
};

export type GymHighlightOrderListRelationFilter = {
  every?: InputMaybe<GymHighlightOrderWhereInput>;
  none?: InputMaybe<GymHighlightOrderWhereInput>;
  some?: InputMaybe<GymHighlightOrderWhereInput>;
};

export type GymHighlightOrderMaxAggregate = {
  __typename: 'GymHighlightOrderMaxAggregate';
  amountPerGymInCents?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<GymHighlightOrderStatus>;
  stripeCheckoutSessionId?: Maybe<Scalars['String']['output']>;
  totalAmountInCents?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GymHighlightOrderMinAggregate = {
  __typename: 'GymHighlightOrderMinAggregate';
  amountPerGymInCents?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<GymHighlightOrderStatus>;
  stripeCheckoutSessionId?: Maybe<Scalars['String']['output']>;
  totalAmountInCents?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GymHighlightOrderNullableScalarRelationFilter = {
  is?: InputMaybe<GymHighlightOrderWhereInput>;
  isNot?: InputMaybe<GymHighlightOrderWhereInput>;
};

export type GymHighlightOrderOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type GymHighlightOrderOrderByWithRelationInput = {
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  companyBilling?: InputMaybe<CompanyBillingOrderByWithRelationInput>;
  companyBillingId?: InputMaybe<SortOrderInput>;
  companyId?: InputMaybe<SortOrder>;
  gyms?: InputMaybe<GymHighlightOrderGymOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  priceConfig?: InputMaybe<GymHighlightPriceConfigOrderByWithRelationInput>;
  priceConfigId?: InputMaybe<SortOrder>;
};

export enum GymHighlightOrderScalarFieldEnum {
  AmountPerGymInCents = 'amountPerGymInCents',
  CompanyBillingId = 'companyBillingId',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  EndDate = 'endDate',
  Id = 'id',
  PriceConfigId = 'priceConfigId',
  StartDate = 'startDate',
  Status = 'status',
  StripeCheckoutSessionId = 'stripeCheckoutSessionId',
  TotalAmountInCents = 'totalAmountInCents',
  UpdatedAt = 'updatedAt'
}

export type GymHighlightOrderScalarRelationFilter = {
  is?: InputMaybe<GymHighlightOrderWhereInput>;
  isNot?: InputMaybe<GymHighlightOrderWhereInput>;
};

/** The payment lifecycle of a gym highlight order. */
export enum GymHighlightOrderStatus {
  /** The order was created (a "cart") but the company has not yet started payment. */
  Draft = 'DRAFT',
  /** The payment was received; the invoice was issued and the highlights are scheduled/active. */
  Paid = 'PAID',
  /** The company clicked "pay now" and a Stripe checkout session was created; awaiting payment. */
  PendingPayment = 'PENDING_PAYMENT'
}

export type GymHighlightOrderSumAggregate = {
  __typename: 'GymHighlightOrderSumAggregate';
  amountPerGymInCents?: Maybe<Scalars['Int']['output']>;
  totalAmountInCents?: Maybe<Scalars['Int']['output']>;
};

export type GymHighlightOrderUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<GymHighlightOrderWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<GymHighlightOrderWhereUniqueInput>>;
};

export type GymHighlightOrderWhereInput = {
  AND?: InputMaybe<Array<GymHighlightOrderWhereInput>>;
  NOT?: InputMaybe<Array<GymHighlightOrderWhereInput>>;
  OR?: InputMaybe<Array<GymHighlightOrderWhereInput>>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  companyBilling?: InputMaybe<CompanyBillingNullableScalarRelationFilter>;
  companyBillingId?: InputMaybe<UuidNullableFilter>;
  companyId?: InputMaybe<StringFilter>;
  gyms?: InputMaybe<GymHighlightOrderGymListRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  priceConfig?: InputMaybe<GymHighlightPriceConfigScalarRelationFilter>;
  priceConfigId?: InputMaybe<UuidFilter>;
};

export type GymHighlightOrderWhereUniqueInput = {
  AND?: InputMaybe<Array<GymHighlightOrderWhereInput>>;
  NOT?: InputMaybe<Array<GymHighlightOrderWhereInput>>;
  OR?: InputMaybe<Array<GymHighlightOrderWhereInput>>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  companyBilling?: InputMaybe<CompanyBillingNullableScalarRelationFilter>;
  companyBillingId?: InputMaybe<Scalars['UUID']['input']>;
  companyId?: InputMaybe<StringFilter>;
  gyms?: InputMaybe<GymHighlightOrderGymListRelationFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  priceConfig?: InputMaybe<GymHighlightPriceConfigScalarRelationFilter>;
  priceConfigId?: InputMaybe<UuidFilter>;
};

/**
 * A versioned set of weekday prices for the gym highlight feature.
 * One row holds the full price set (one price per weekday). Prices are defined by the platform
 * (admin) only and are never editable by companies. A config is immutable once created - changing
 * prices means creating a new config and activating it. At most one config is active at a time
 * (enforced by a partial unique index on `active`). The total price of a highlight period is the
 * sum of the matching weekday prices across every calendar day in the selected range.
 */
export type GymHighlightPriceConfig = {
  __typename: 'GymHighlightPriceConfig';
  /** Whether this is the currently active config. At most one config may be active at a time. */
  active: Scalars['Boolean']['output'];
  /** The date and time when the record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Price for highlighting a gym on a Friday, in cents. */
  fridayCents: Scalars['Int']['output'];
  /** The unique identifier for the price config. */
  id: Scalars['UUID']['output'];
  /** Price for highlighting a gym on a Monday, in cents. */
  mondayCents: Scalars['Int']['output'];
  /** The orders that were priced using this config (provenance of the charged amounts). */
  orders?: Maybe<Array<GymHighlightOrder>>;
  /** Price for highlighting a gym on a Saturday, in cents. */
  saturdayCents: Scalars['Int']['output'];
  /** Price for highlighting a gym on a Sunday, in cents. */
  sundayCents: Scalars['Int']['output'];
  /** Price for highlighting a gym on a Thursday, in cents. */
  thursdayCents: Scalars['Int']['output'];
  /** Price for highlighting a gym on a Tuesday, in cents. */
  tuesdayCents: Scalars['Int']['output'];
  /** The date and time when the record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Price for highlighting a gym on a Wednesday, in cents. */
  wednesdayCents: Scalars['Int']['output'];
};

export type GymHighlightPriceConfigAvgAggregate = {
  __typename: 'GymHighlightPriceConfigAvgAggregate';
  fridayCents?: Maybe<Scalars['Float']['output']>;
  mondayCents?: Maybe<Scalars['Float']['output']>;
  saturdayCents?: Maybe<Scalars['Float']['output']>;
  sundayCents?: Maybe<Scalars['Float']['output']>;
  thursdayCents?: Maybe<Scalars['Float']['output']>;
  tuesdayCents?: Maybe<Scalars['Float']['output']>;
  wednesdayCents?: Maybe<Scalars['Float']['output']>;
};

export type GymHighlightPriceConfigCountAggregate = {
  __typename: 'GymHighlightPriceConfigCountAggregate';
  _all: Scalars['Int']['output'];
  active: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  fridayCents: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  mondayCents: Scalars['Int']['output'];
  saturdayCents: Scalars['Int']['output'];
  sundayCents: Scalars['Int']['output'];
  thursdayCents: Scalars['Int']['output'];
  tuesdayCents: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  wednesdayCents: Scalars['Int']['output'];
};

export type GymHighlightPriceConfigMaxAggregate = {
  __typename: 'GymHighlightPriceConfigMaxAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fridayCents?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  mondayCents?: Maybe<Scalars['Int']['output']>;
  saturdayCents?: Maybe<Scalars['Int']['output']>;
  sundayCents?: Maybe<Scalars['Int']['output']>;
  thursdayCents?: Maybe<Scalars['Int']['output']>;
  tuesdayCents?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  wednesdayCents?: Maybe<Scalars['Int']['output']>;
};

export type GymHighlightPriceConfigMinAggregate = {
  __typename: 'GymHighlightPriceConfigMinAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fridayCents?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  mondayCents?: Maybe<Scalars['Int']['output']>;
  saturdayCents?: Maybe<Scalars['Int']['output']>;
  sundayCents?: Maybe<Scalars['Int']['output']>;
  thursdayCents?: Maybe<Scalars['Int']['output']>;
  tuesdayCents?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  wednesdayCents?: Maybe<Scalars['Int']['output']>;
};

export type GymHighlightPriceConfigOrderByWithRelationInput = {
  active?: InputMaybe<SortOrder>;
  fridayCents?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  mondayCents?: InputMaybe<SortOrder>;
  orders?: InputMaybe<GymHighlightOrderOrderByRelationAggregateInput>;
  saturdayCents?: InputMaybe<SortOrder>;
  sundayCents?: InputMaybe<SortOrder>;
  thursdayCents?: InputMaybe<SortOrder>;
  tuesdayCents?: InputMaybe<SortOrder>;
  wednesdayCents?: InputMaybe<SortOrder>;
};

export enum GymHighlightPriceConfigScalarFieldEnum {
  Active = 'active',
  CreatedAt = 'createdAt',
  FridayCents = 'fridayCents',
  Id = 'id',
  MondayCents = 'mondayCents',
  SaturdayCents = 'saturdayCents',
  SundayCents = 'sundayCents',
  ThursdayCents = 'thursdayCents',
  TuesdayCents = 'tuesdayCents',
  UpdatedAt = 'updatedAt',
  WednesdayCents = 'wednesdayCents'
}

export type GymHighlightPriceConfigScalarRelationFilter = {
  is?: InputMaybe<GymHighlightPriceConfigWhereInput>;
  isNot?: InputMaybe<GymHighlightPriceConfigWhereInput>;
};

export type GymHighlightPriceConfigSumAggregate = {
  __typename: 'GymHighlightPriceConfigSumAggregate';
  fridayCents?: Maybe<Scalars['Int']['output']>;
  mondayCents?: Maybe<Scalars['Int']['output']>;
  saturdayCents?: Maybe<Scalars['Int']['output']>;
  sundayCents?: Maybe<Scalars['Int']['output']>;
  thursdayCents?: Maybe<Scalars['Int']['output']>;
  tuesdayCents?: Maybe<Scalars['Int']['output']>;
  wednesdayCents?: Maybe<Scalars['Int']['output']>;
};

export type GymHighlightPriceConfigWhereInput = {
  AND?: InputMaybe<Array<GymHighlightPriceConfigWhereInput>>;
  NOT?: InputMaybe<Array<GymHighlightPriceConfigWhereInput>>;
  OR?: InputMaybe<Array<GymHighlightPriceConfigWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  fridayCents?: InputMaybe<IntFilter>;
  id?: InputMaybe<UuidFilter>;
  mondayCents?: InputMaybe<IntFilter>;
  orders?: InputMaybe<GymHighlightOrderListRelationFilter>;
  saturdayCents?: InputMaybe<IntFilter>;
  sundayCents?: InputMaybe<IntFilter>;
  thursdayCents?: InputMaybe<IntFilter>;
  tuesdayCents?: InputMaybe<IntFilter>;
  wednesdayCents?: InputMaybe<IntFilter>;
};

export type GymHighlightPriceConfigWhereUniqueInput = {
  AND?: InputMaybe<Array<GymHighlightPriceConfigWhereInput>>;
  NOT?: InputMaybe<Array<GymHighlightPriceConfigWhereInput>>;
  OR?: InputMaybe<Array<GymHighlightPriceConfigWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  fridayCents?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  mondayCents?: InputMaybe<IntFilter>;
  orders?: InputMaybe<GymHighlightOrderListRelationFilter>;
  saturdayCents?: InputMaybe<IntFilter>;
  sundayCents?: InputMaybe<IntFilter>;
  thursdayCents?: InputMaybe<IntFilter>;
  tuesdayCents?: InputMaybe<IntFilter>;
  wednesdayCents?: InputMaybe<IntFilter>;
};

export type GymImage = {
  __typename: 'GymImage';
  createdAt: Scalars['DateTime']['output'];
  gym: Gym;
  gymId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  /** The url of the uploaded image */
  s3ImageUrl: Scalars['String']['output'];
  /** The file key in the s3 bucket */
  s3Key: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type GymImageCountAggregate = {
  __typename: 'GymImageCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  gymId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  s3ImageUrl: Scalars['Int']['output'];
  s3Key: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

/** Input for creating gym image */
export type GymImageCreateInput = {
  gym: GymCreateNestedOneWithoutImagesInput;
  image: ImageInput;
};

export type GymImageListRelationFilter = {
  every?: InputMaybe<GymImageWhereInput>;
  none?: InputMaybe<GymImageWhereInput>;
  some?: InputMaybe<GymImageWhereInput>;
};

export type GymImageMaxAggregate = {
  __typename: 'GymImageMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  gymId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  s3ImageUrl?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GymImageMinAggregate = {
  __typename: 'GymImageMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  gymId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  s3ImageUrl?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GymImageOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type GymImageOrderByWithRelationInput = {
  gym?: InputMaybe<GymOrderByWithRelationInput>;
  gymId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  s3ImageUrl?: InputMaybe<SortOrder>;
  s3Key?: InputMaybe<SortOrder>;
};

export enum GymImageScalarFieldEnum {
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  GymId = 'gymId',
  Id = 'id',
  S3ImageUrl = 's3ImageUrl',
  S3Key = 's3Key',
  UpdatedAt = 'updatedAt'
}

export type GymImageWhereInput = {
  AND?: InputMaybe<Array<GymImageWhereInput>>;
  NOT?: InputMaybe<Array<GymImageWhereInput>>;
  OR?: InputMaybe<Array<GymImageWhereInput>>;
  gym?: InputMaybe<GymScalarRelationFilter>;
  gymId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  s3ImageUrl?: InputMaybe<StringFilter>;
  s3Key?: InputMaybe<StringFilter>;
};

export type GymImageWhereUniqueInput = {
  AND?: InputMaybe<Array<GymImageWhereInput>>;
  NOT?: InputMaybe<Array<GymImageWhereInput>>;
  OR?: InputMaybe<Array<GymImageWhereInput>>;
  gym?: InputMaybe<GymScalarRelationFilter>;
  gymId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  s3ImageUrl?: InputMaybe<StringFilter>;
  s3Key?: InputMaybe<StringFilter>;
};

export type GymListRelationFilter = {
  every?: InputMaybe<GymWhereInput>;
  none?: InputMaybe<GymWhereInput>;
  some?: InputMaybe<GymWhereInput>;
};

export type GymMaxAggregate = {
  __typename: 'GymMaxAggregate';
  categoryId?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['EmailAddress']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  crmContractId?: Maybe<Scalars['String']['output']>;
  crmStudioId?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  highlighted?: Maybe<Scalars['Boolean']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  minTrainingDuration?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  place?: Maybe<Scalars['String']['output']>;
  promotionId?: Maybe<Scalars['UUID']['output']>;
  qrcode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  stripeConnectId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<GymType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  weeklySessionLimit?: Maybe<Scalars['Int']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type GymMinAggregate = {
  __typename: 'GymMinAggregate';
  categoryId?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['EmailAddress']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  crmContractId?: Maybe<Scalars['String']['output']>;
  crmStudioId?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  highlighted?: Maybe<Scalars['Boolean']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  minTrainingDuration?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  place?: Maybe<Scalars['String']['output']>;
  promotionId?: Maybe<Scalars['UUID']['output']>;
  qrcode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  stripeConnectId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<GymType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  weeklySessionLimit?: Maybe<Scalars['Int']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type GymNullableScalarRelationFilter = {
  is?: InputMaybe<GymWhereInput>;
  isNot?: InputMaybe<GymWhereInput>;
};

export type GymOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type GymOrderByWithRelationInput = {
  accessDevices?: InputMaybe<GymAccessDeviceOrderByRelationAggregateInput>;
  advantages?: InputMaybe<GymAdvantageOrderByRelationAggregateInput>;
  category?: InputMaybe<GymCategoryOrderByWithRelationInput>;
  categoryId?: InputMaybe<SortOrderInput>;
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  companyId?: InputMaybe<SortOrder>;
  contactEmail?: InputMaybe<SortOrderInput>;
  contactPhone?: InputMaybe<SortOrderInput>;
  contractProposals?: InputMaybe<ContractOrderByRelationAggregateInput>;
  crmContractId?: InputMaybe<SortOrderInput>;
  crmStudioId?: InputMaybe<SortOrderInput>;
  customerGyms?: InputMaybe<CustomerGymOrderByRelationAggregateInput>;
  deletedAt?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrderInput>;
  employees?: InputMaybe<CompanyEmployeeOrderByRelationAggregateInput>;
  eventBookings?: InputMaybe<EventBookingOrderByRelationAggregateInput>;
  events?: InputMaybe<EventOrderByRelationAggregateInput>;
  highlightOrders?: InputMaybe<GymHighlightOrderGymOrderByRelationAggregateInput>;
  highlighted?: InputMaybe<SortOrder>;
  houseNumber?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  images?: InputMaybe<GymImageOrderByRelationAggregateInput>;
  latitude?: InputMaybe<SortOrder>;
  longitude?: InputMaybe<SortOrder>;
  minTrainingDuration?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  openingHours?: InputMaybe<OpeningHourOrderByRelationAggregateInput>;
  payoutHistory?: InputMaybe<PayoutHistoryOrderByRelationAggregateInput>;
  place?: InputMaybe<SortOrder>;
  prices?: InputMaybe<PriceOrderByRelationAggregateInput>;
  promotion?: InputMaybe<PromotionOrderByWithRelationInput>;
  promotionId?: InputMaybe<SortOrderInput>;
  qrcode?: InputMaybe<SortOrder>;
  ratings?: InputMaybe<GymRatingOrderByRelationAggregateInput>;
  street?: InputMaybe<SortOrder>;
  stripeConnectId?: InputMaybe<SortOrder>;
  trainingSessions?: InputMaybe<TrainingSessionOrderByRelationAggregateInput>;
  type?: InputMaybe<SortOrder>;
  weeklySessionLimit?: InputMaybe<SortOrderInput>;
  zipcode?: InputMaybe<SortOrder>;
};

export type GymRating = {
  __typename: 'GymRating';
  /** Optional text comment provided by the customer */
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  /** The identifier of the customer who submitted the rating */
  customerId: Scalars['String']['output'];
  gym: Gym;
  /** The identifier of the branch office being rated */
  gymId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  /** The star rating given by the customer (1 - 10) */
  rating: Scalars['Int']['output'];
  ratingQuestion?: Maybe<RatingQuestion>;
  /** The identifier of the specific rating question (nullable for general ratings) */
  ratingQuestionId?: Maybe<Scalars['UUID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type GymRatingAvgAggregate = {
  __typename: 'GymRatingAvgAggregate';
  rating?: Maybe<Scalars['Float']['output']>;
};

export type GymRatingCountAggregate = {
  __typename: 'GymRatingCountAggregate';
  _all: Scalars['Int']['output'];
  comment: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  gymId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  rating: Scalars['Int']['output'];
  ratingQuestionId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

/** Input for creating one gym rating */
export type GymRatingCreateManyInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['Int']['input'];
  ratingQuestionId?: InputMaybe<Scalars['UUID']['input']>;
};

export type GymRatingCreateNestedManyWithoutGymInput = {
  connect?: InputMaybe<Array<GymRatingWhereUniqueInput>>;
};

export type GymRatingCreateNestedManyWithoutRatingQuestionInput = {
  connect?: InputMaybe<Array<GymRatingWhereUniqueInput>>;
};

export type GymRatingEdge = {
  __typename: 'GymRatingEdge';
  cursor: PaginatedGymRatingCursor;
  node: GymRating;
};

export type GymRatingListRelationFilter = {
  every?: InputMaybe<GymRatingWhereInput>;
  none?: InputMaybe<GymRatingWhereInput>;
  some?: InputMaybe<GymRatingWhereInput>;
};

export type GymRatingMaxAggregate = {
  __typename: 'GymRatingMaxAggregate';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  gymId?: Maybe<Scalars['UUID']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingQuestionId?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GymRatingMinAggregate = {
  __typename: 'GymRatingMinAggregate';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  gymId?: Maybe<Scalars['UUID']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingQuestionId?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GymRatingOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type GymRatingOrderByWithRelationInput = {
  comment?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  gym?: InputMaybe<GymOrderByWithRelationInput>;
  gymId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  rating?: InputMaybe<SortOrder>;
  ratingQuestion?: InputMaybe<RatingQuestionOrderByWithRelationInput>;
  ratingQuestionId?: InputMaybe<SortOrderInput>;
};

export enum GymRatingScalarFieldEnum {
  Comment = 'comment',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  GymId = 'gymId',
  Id = 'id',
  Rating = 'rating',
  RatingQuestionId = 'ratingQuestionId',
  UpdatedAt = 'updatedAt'
}

export type GymRatingSumAggregate = {
  __typename: 'GymRatingSumAggregate';
  rating?: Maybe<Scalars['Int']['output']>;
};

export type GymRatingUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<GymRatingWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<GymRatingWhereUniqueInput>>;
};

export type GymRatingUpdateManyWithoutGymNestedInput = {
  connect?: InputMaybe<Array<GymRatingWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<GymRatingWhereUniqueInput>>;
};

export type GymRatingWhereInput = {
  AND?: InputMaybe<Array<GymRatingWhereInput>>;
  NOT?: InputMaybe<Array<GymRatingWhereInput>>;
  OR?: InputMaybe<Array<GymRatingWhereInput>>;
  comment?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  gym?: InputMaybe<GymScalarRelationFilter>;
  gymId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  rating?: InputMaybe<IntFilter>;
  ratingQuestion?: InputMaybe<RatingQuestionNullableScalarRelationFilter>;
  ratingQuestionId?: InputMaybe<UuidNullableFilter>;
};

export type GymRatingWhereUniqueInput = {
  AND?: InputMaybe<Array<GymRatingWhereInput>>;
  NOT?: InputMaybe<Array<GymRatingWhereInput>>;
  OR?: InputMaybe<Array<GymRatingWhereInput>>;
  comment?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  gym?: InputMaybe<GymScalarRelationFilter>;
  gymId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  rating?: InputMaybe<IntFilter>;
  ratingQuestion?: InputMaybe<RatingQuestionNullableScalarRelationFilter>;
  ratingQuestionId?: InputMaybe<UuidNullableFilter>;
};

export enum GymScalarFieldEnum {
  CategoryId = 'categoryId',
  CompanyId = 'companyId',
  ContactEmail = 'contactEmail',
  ContactPhone = 'contactPhone',
  CreatedAt = 'createdAt',
  CrmContractId = 'crmContractId',
  CrmStudioId = 'crmStudioId',
  DeletedAt = 'deletedAt',
  Description = 'description',
  Highlighted = 'highlighted',
  HouseNumber = 'houseNumber',
  Id = 'id',
  Latitude = 'latitude',
  Longitude = 'longitude',
  MinTrainingDuration = 'minTrainingDuration',
  Name = 'name',
  Place = 'place',
  PromotionId = 'promotionId',
  Qrcode = 'qrcode',
  Street = 'street',
  StripeConnectId = 'stripeConnectId',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  WeeklySessionLimit = 'weeklySessionLimit',
  Zipcode = 'zipcode'
}

export type GymScalarRelationFilter = {
  is?: InputMaybe<GymWhereInput>;
  isNot?: InputMaybe<GymWhereInput>;
};

export type GymSumAggregate = {
  __typename: 'GymSumAggregate';
  minTrainingDuration?: Maybe<Scalars['Int']['output']>;
  weeklySessionLimit?: Maybe<Scalars['Int']['output']>;
};

export type GymTopRating = {
  __typename: 'GymTopRating';
  /** The unique identifier for the gym. */
  id: Scalars['UUID']['output'];
  /** The name of the gym. */
  name: Scalars['String']['output'];
  overallTotalRating: Scalars['Float']['output'];
};

/** The different types of gyms. */
export enum GymType {
  /** A standard fitness studio with regular pricing. */
  FitnessStudio = 'FITNESS_STUDIO',
  /** A studio for special interest courses or events with fixed prices. */
  SpecialInterestStudio = 'SPECIAL_INTEREST_STUDIO'
}

/** Input for updating a gym */
export type GymUpdateInput = {
  accessDevices?: InputMaybe<GymAccessDeviceUpdateManyWithoutGymNestedInput>;
  advantages?: InputMaybe<GymAdvantageUpdateManyWithoutGymsNestedInput>;
  category?: InputMaybe<GymCategoryUpdateOneWithoutGymsNestedInput>;
  contactEmail?: InputMaybe<Scalars['EmailAddress']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  contractProposals?: InputMaybe<ContractUpdateManyWithoutGymNestedInput>;
  crmContractId?: InputMaybe<Scalars['String']['input']>;
  crmStudioId?: InputMaybe<Scalars['String']['input']>;
  customerGyms?: InputMaybe<CustomerGymUpdateManyWithoutGymNestedInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employees?: InputMaybe<CompanyEmployeeUpdateManyWithoutGymsNestedInput>;
  eventBookings?: InputMaybe<EventBookingUpdateManyWithoutGymNestedInput>;
  events?: InputMaybe<EventUpdateManyWithoutGymNestedInput>;
  highlightOrders?: InputMaybe<GymHighlightOrderGymUpdateManyWithoutGymNestedInput>;
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  minTrainingDuration?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  openingHours?: InputMaybe<OpeningHourUpdateManyWithoutGymNestedInput>;
  payoutHistory?: InputMaybe<PayoutHistoryUpdateManyWithoutGymNestedInput>;
  place?: InputMaybe<Scalars['String']['input']>;
  /** The price to update */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** How the price is billed: PAY_PER_MINUTE (price in cents per minute) or DAILY_TICKET (price in cents per training). Can only be changed together with `price`; if omitted, the current pricing model is kept. EVENT is not allowed for gyms. */
  pricingModel?: InputMaybe<PricingModel>;
  promotion?: InputMaybe<PromotionUpdateOneWithoutGymsNestedInput>;
  qrcode?: InputMaybe<Scalars['String']['input']>;
  ratings?: InputMaybe<GymRatingUpdateManyWithoutGymNestedInput>;
  street?: InputMaybe<Scalars['String']['input']>;
  stripeConnectId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<GymType>;
  weeklySessionLimit?: InputMaybe<Scalars['Int']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type GymUpdateManyWithoutAdvantagesNestedInput = {
  connect?: InputMaybe<Array<GymWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<GymWhereUniqueInput>>;
};

export type GymUpdateManyWithoutCategoryNestedInput = {
  connect?: InputMaybe<Array<GymWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<GymWhereUniqueInput>>;
};

export type GymUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<GymWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<GymWhereUniqueInput>>;
};

export type GymUpdateManyWithoutPromotionNestedInput = {
  /** List of gyms to connect to this promotion */
  connect?: InputMaybe<Array<GymWhereUniqueInput>>;
  /** List of gyms to disconnect from this promotion */
  disconnect?: InputMaybe<Array<GymWhereUniqueInput>>;
};

export type GymUpdateOneRequiredWithoutTrainingSessionsNestedInput = {
  connect?: InputMaybe<GymWhereUniqueInput>;
};

export type GymWhereInput = {
  AND?: InputMaybe<Array<GymWhereInput>>;
  NOT?: InputMaybe<Array<GymWhereInput>>;
  OR?: InputMaybe<Array<GymWhereInput>>;
  accessDevices?: InputMaybe<GymAccessDeviceListRelationFilter>;
  advantages?: InputMaybe<GymAdvantageListRelationFilter>;
  category?: InputMaybe<GymCategoryNullableScalarRelationFilter>;
  categoryId?: InputMaybe<UuidNullableFilter>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  contactEmail?: InputMaybe<StringNullableFilter>;
  contactPhone?: InputMaybe<StringNullableFilter>;
  contractProposals?: InputMaybe<ContractListRelationFilter>;
  crmContractId?: InputMaybe<StringNullableFilter>;
  crmStudioId?: InputMaybe<StringNullableFilter>;
  customerGyms?: InputMaybe<CustomerGymListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  employees?: InputMaybe<CompanyEmployeeListRelationFilter>;
  eventBookings?: InputMaybe<EventBookingListRelationFilter>;
  events?: InputMaybe<EventListRelationFilter>;
  highlightOrders?: InputMaybe<GymHighlightOrderGymListRelationFilter>;
  highlighted?: InputMaybe<BoolFilter>;
  houseNumber?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  images?: InputMaybe<GymImageListRelationFilter>;
  latitude?: InputMaybe<StringFilter>;
  longitude?: InputMaybe<StringFilter>;
  minTrainingDuration?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  openingHours?: InputMaybe<OpeningHourListRelationFilter>;
  payoutHistory?: InputMaybe<PayoutHistoryListRelationFilter>;
  place?: InputMaybe<StringFilter>;
  prices?: InputMaybe<PriceListRelationFilter>;
  promotion?: InputMaybe<PromotionNullableScalarRelationFilter>;
  promotionId?: InputMaybe<UuidNullableFilter>;
  qrcode?: InputMaybe<StringFilter>;
  ratings?: InputMaybe<GymRatingListRelationFilter>;
  street?: InputMaybe<StringFilter>;
  stripeConnectId?: InputMaybe<StringFilter>;
  trainingSessions?: InputMaybe<TrainingSessionListRelationFilter>;
  type?: InputMaybe<EnumGymTypeFilter>;
  weeklySessionLimit?: InputMaybe<IntNullableFilter>;
  zipcode?: InputMaybe<StringFilter>;
};

export type GymWhereUniqueInput = {
  AND?: InputMaybe<Array<GymWhereInput>>;
  NOT?: InputMaybe<Array<GymWhereInput>>;
  OR?: InputMaybe<Array<GymWhereInput>>;
  accessDevices?: InputMaybe<GymAccessDeviceListRelationFilter>;
  advantages?: InputMaybe<GymAdvantageListRelationFilter>;
  category?: InputMaybe<GymCategoryNullableScalarRelationFilter>;
  categoryId?: InputMaybe<UuidNullableFilter>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  contactEmail?: InputMaybe<StringNullableFilter>;
  contactPhone?: InputMaybe<StringNullableFilter>;
  contractProposals?: InputMaybe<ContractListRelationFilter>;
  crmContractId?: InputMaybe<StringNullableFilter>;
  crmStudioId?: InputMaybe<StringNullableFilter>;
  customerGyms?: InputMaybe<CustomerGymListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  employees?: InputMaybe<CompanyEmployeeListRelationFilter>;
  eventBookings?: InputMaybe<EventBookingListRelationFilter>;
  events?: InputMaybe<EventListRelationFilter>;
  highlightOrders?: InputMaybe<GymHighlightOrderGymListRelationFilter>;
  highlighted?: InputMaybe<BoolFilter>;
  houseNumber?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  images?: InputMaybe<GymImageListRelationFilter>;
  latitude?: InputMaybe<StringFilter>;
  longitude?: InputMaybe<StringFilter>;
  minTrainingDuration?: InputMaybe<IntFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  openingHours?: InputMaybe<OpeningHourListRelationFilter>;
  payoutHistory?: InputMaybe<PayoutHistoryListRelationFilter>;
  place?: InputMaybe<StringFilter>;
  prices?: InputMaybe<PriceListRelationFilter>;
  promotion?: InputMaybe<PromotionNullableScalarRelationFilter>;
  promotionId?: InputMaybe<UuidNullableFilter>;
  qrcode?: InputMaybe<StringFilter>;
  ratings?: InputMaybe<GymRatingListRelationFilter>;
  street?: InputMaybe<StringFilter>;
  stripeConnectId?: InputMaybe<StringFilter>;
  trainingSessions?: InputMaybe<TrainingSessionListRelationFilter>;
  type?: InputMaybe<EnumGymTypeFilter>;
  weeklySessionLimit?: InputMaybe<IntNullableFilter>;
  zipcode?: InputMaybe<StringFilter>;
};

export type HandleBlacklistCountAggregate = {
  __typename: 'HandleBlacklistCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  handle: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  reason: Scalars['Int']['output'];
};

export type HandleBlacklistMaxAggregate = {
  __typename: 'HandleBlacklistMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  handle?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type HandleBlacklistMinAggregate = {
  __typename: 'HandleBlacklistMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  handle?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type HealthInsurance = {
  __typename: 'HealthInsurance';
  balances?: Maybe<Array<HealthInsuranceBalance>>;
  /** The date and time when the configuration was created. */
  createdAt: Scalars['DateTime']['output'];
  customers?: Maybe<Array<Customer>>;
  /** The description for the health insurance */
  description?: Maybe<Scalars['String']['output']>;
  /** The contact email of the health insurance */
  email: Scalars['EmailAddress']['output'];
  employees?: Maybe<Array<HealthInsuranceEmployee>>;
  houseNumber: Scalars['String']['output'];
  /** The unique identifier of the health insurance */
  id: Scalars['ID']['output'];
  /** The URL to the displayed logo */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** The name of the health insurance */
  name: Scalars['String']['output'];
  /** The connection name of the organization */
  organizationConnection?: Maybe<Scalars['String']['output']>;
  /** The name of the organization */
  organizationName: Scalars['String']['output'];
  place: Scalars['String']['output'];
  pointsConfig?: Maybe<HealthInsurancePointsConfig>;
  receivedPoints?: Maybe<Array<HealthInsuranceReceivedPoint>>;
  rewards?: Maybe<Array<HealthInsuranceReward>>;
  street: Scalars['String']['output'];
  /** The date and time when the configuration was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  zipcode: Scalars['String']['output'];
};

export type HealthInsuranceBalance = {
  __typename: 'HealthInsuranceBalance';
  /** The count of points for a health insurance */
  count: Scalars['Int']['output'];
  /** The date and time when the configuration was created. */
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  healthInsurance: HealthInsurance;
  /** The date and time when the configuration was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type HealthInsuranceBalanceAvgAggregate = {
  __typename: 'HealthInsuranceBalanceAvgAggregate';
  count?: Maybe<Scalars['Float']['output']>;
};

export type HealthInsuranceBalanceCountAggregate = {
  __typename: 'HealthInsuranceBalanceCountAggregate';
  _all: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type HealthInsuranceBalanceHealthInsuranceIdCustomerIdCompoundUniqueInput = {
  customerId: Scalars['String']['input'];
  healthInsuranceId: Scalars['String']['input'];
};

export type HealthInsuranceBalanceListRelationFilter = {
  every?: InputMaybe<HealthInsuranceBalanceWhereInput>;
  none?: InputMaybe<HealthInsuranceBalanceWhereInput>;
  some?: InputMaybe<HealthInsuranceBalanceWhereInput>;
};

export type HealthInsuranceBalanceMaxAggregate = {
  __typename: 'HealthInsuranceBalanceMaxAggregate';
  count?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HealthInsuranceBalanceMinAggregate = {
  __typename: 'HealthInsuranceBalanceMinAggregate';
  count?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HealthInsuranceBalanceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type HealthInsuranceBalanceOrderByWithRelationInput = {
  count?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  healthInsurance?: InputMaybe<HealthInsuranceOrderByWithRelationInput>;
  healthInsuranceId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum HealthInsuranceBalanceScalarFieldEnum {
  Count = 'count',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  HealthInsuranceId = 'healthInsuranceId',
  UpdatedAt = 'updatedAt'
}

export type HealthInsuranceBalanceSumAggregate = {
  __typename: 'HealthInsuranceBalanceSumAggregate';
  count?: Maybe<Scalars['Int']['output']>;
};

export type HealthInsuranceBalanceWhereInput = {
  AND?: InputMaybe<Array<HealthInsuranceBalanceWhereInput>>;
  NOT?: InputMaybe<Array<HealthInsuranceBalanceWhereInput>>;
  OR?: InputMaybe<Array<HealthInsuranceBalanceWhereInput>>;
  count?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  healthInsurance?: InputMaybe<HealthInsuranceScalarRelationFilter>;
  healthInsuranceId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type HealthInsuranceBalanceWhereUniqueInput = {
  AND?: InputMaybe<Array<HealthInsuranceBalanceWhereInput>>;
  NOT?: InputMaybe<Array<HealthInsuranceBalanceWhereInput>>;
  OR?: InputMaybe<Array<HealthInsuranceBalanceWhereInput>>;
  count?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  healthInsurance?: InputMaybe<HealthInsuranceScalarRelationFilter>;
  healthInsuranceId?: InputMaybe<StringFilter>;
  healthInsuranceId_customerId?: InputMaybe<HealthInsuranceBalanceHealthInsuranceIdCustomerIdCompoundUniqueInput>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type HealthInsuranceCountAggregate = {
  __typename: 'HealthInsuranceCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  houseNumber: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  logoUrl: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  organizationConnection: Scalars['Int']['output'];
  organizationName: Scalars['Int']['output'];
  place: Scalars['Int']['output'];
  street: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  zipcode: Scalars['Int']['output'];
};

export type HealthInsuranceCreateNestedOneWithoutPointsConfigInput = {
  connect: HealthInsuranceWhereUniqueInput;
};

export type HealthInsuranceCreateNestedOneWithoutRewardInput = {
  connect: HealthInsuranceWhereUniqueInput;
};

export type HealthInsuranceEmployee = {
  __typename: 'HealthInsuranceEmployee';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['EmailAddress']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  healthInsurance: HealthInsurance;
  id?: Maybe<Scalars['String']['output']>;
  invitationAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  status: EmployeeStatus;
  updatedAt: Scalars['DateTime']['output'];
  userType: EmployeeUserType;
};

export type HealthInsuranceEmployeeCountAggregate = {
  __typename: 'HealthInsuranceEmployeeCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  firstName: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  invitationAcceptedAt: Scalars['Int']['output'];
  lastName: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userType: Scalars['Int']['output'];
};

export type HealthInsuranceEmployeeEmployeeIdentifierCompoundUniqueInput = {
  email: Scalars['EmailAddress']['input'];
  healthInsuranceId: Scalars['String']['input'];
};

export type HealthInsuranceEmployeeListRelationFilter = {
  every?: InputMaybe<HealthInsuranceEmployeeWhereInput>;
  none?: InputMaybe<HealthInsuranceEmployeeWhereInput>;
  some?: InputMaybe<HealthInsuranceEmployeeWhereInput>;
};

export type HealthInsuranceEmployeeMaxAggregate = {
  __typename: 'HealthInsuranceEmployeeMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invitationAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EmployeeStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userType?: Maybe<EmployeeUserType>;
};

export type HealthInsuranceEmployeeMinAggregate = {
  __typename: 'HealthInsuranceEmployeeMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invitationAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EmployeeStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userType?: Maybe<EmployeeUserType>;
};

export type HealthInsuranceEmployeeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type HealthInsuranceEmployeeOrderByWithRelationInput = {
  email?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrderInput>;
  healthInsurance?: InputMaybe<HealthInsuranceOrderByWithRelationInput>;
  healthInsuranceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrderInput>;
  lastName?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  userType?: InputMaybe<SortOrder>;
};

export enum HealthInsuranceEmployeeScalarFieldEnum {
  CreatedAt = 'createdAt',
  Email = 'email',
  FirstName = 'firstName',
  HealthInsuranceId = 'healthInsuranceId',
  Id = 'id',
  InvitationAcceptedAt = 'invitationAcceptedAt',
  LastName = 'lastName',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  UserType = 'userType'
}

export type HealthInsuranceEmployeeUniqueInput = {
  AND?: InputMaybe<HealthInsuranceEmployeeWhereInput>;
  NOT?: InputMaybe<HealthInsuranceEmployeeWhereInput>;
  OR?: InputMaybe<HealthInsuranceEmployeeWhereInput>;
  email?: InputMaybe<StringFilter>;
  employeeIdentifier: HealthInsuranceEmployeeEmployeeIdentifierCompoundUniqueInput;
  firstName?: InputMaybe<StringNullableFilter>;
  healthInsurance?: InputMaybe<HealthInsuranceScalarRelationFilter>;
  healthInsuranceId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringNullableFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumEmployeeStatusFilter>;
  userType?: InputMaybe<EnumEmployeeUserTypeFilter>;
};

/** Input for updating a health insurance employee */
export type HealthInsuranceEmployeeUpdateInput = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type HealthInsuranceEmployeeWhereInput = {
  AND?: InputMaybe<Array<HealthInsuranceEmployeeWhereInput>>;
  NOT?: InputMaybe<Array<HealthInsuranceEmployeeWhereInput>>;
  OR?: InputMaybe<Array<HealthInsuranceEmployeeWhereInput>>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  healthInsurance?: InputMaybe<HealthInsuranceScalarRelationFilter>;
  healthInsuranceId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringNullableFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumEmployeeStatusFilter>;
  userType?: InputMaybe<EnumEmployeeUserTypeFilter>;
};

export type HealthInsuranceEmployeeWhereUniqueInput = {
  AND?: InputMaybe<Array<HealthInsuranceEmployeeWhereInput>>;
  NOT?: InputMaybe<Array<HealthInsuranceEmployeeWhereInput>>;
  OR?: InputMaybe<Array<HealthInsuranceEmployeeWhereInput>>;
  email?: InputMaybe<StringFilter>;
  employeeIdentifier?: InputMaybe<HealthInsuranceEmployeeEmployeeIdentifierCompoundUniqueInput>;
  firstName?: InputMaybe<StringNullableFilter>;
  healthInsurance?: InputMaybe<HealthInsuranceScalarRelationFilter>;
  healthInsuranceId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringNullableFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumEmployeeStatusFilter>;
  userType?: InputMaybe<EnumEmployeeUserTypeFilter>;
};

export type HealthInsuranceMaxAggregate = {
  __typename: 'HealthInsuranceMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationConnection?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  place?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type HealthInsuranceMinAggregate = {
  __typename: 'HealthInsuranceMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationConnection?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  place?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type HealthInsuranceNullableScalarRelationFilter = {
  is?: InputMaybe<HealthInsuranceWhereInput>;
  isNot?: InputMaybe<HealthInsuranceWhereInput>;
};

export type HealthInsuranceOrderByWithRelationInput = {
  balances?: InputMaybe<HealthInsuranceBalanceOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  customers?: InputMaybe<CustomerOrderByRelationAggregateInput>;
  description?: InputMaybe<SortOrderInput>;
  email?: InputMaybe<SortOrder>;
  employees?: InputMaybe<HealthInsuranceEmployeeOrderByRelationAggregateInput>;
  houseNumber?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  logoUrl?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  organizationConnection?: InputMaybe<SortOrderInput>;
  organizationName?: InputMaybe<SortOrder>;
  place?: InputMaybe<SortOrder>;
  pointsConfig?: InputMaybe<HealthInsurancePointsConfigOrderByWithRelationInput>;
  receivedPoints?: InputMaybe<HealthInsuranceReceivedPointOrderByRelationAggregateInput>;
  rewards?: InputMaybe<HealthInsuranceRewardOrderByRelationAggregateInput>;
  street?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  zipcode?: InputMaybe<SortOrder>;
};

export type HealthInsurancePointsConfig = {
  __typename: 'HealthInsurancePointsConfig';
  /** The multiplier to calculate point amount based on the method */
  collectionMethodMultiplier: Scalars['Int']['output'];
  /** The date and time when the configuration was created. */
  createdAt: Scalars['DateTime']['output'];
  healthInsurance?: Maybe<HealthInsurance>;
  id: Scalars['UUID']['output'];
  /** The method points can be collected with */
  pointCollectionMethod: PointCollectionMethod;
  /** The amount of points to receive per method */
  points: Scalars['Int']['output'];
  /** The date and time when the configuration was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type HealthInsurancePointsConfigAvgAggregate = {
  __typename: 'HealthInsurancePointsConfigAvgAggregate';
  collectionMethodMultiplier?: Maybe<Scalars['Float']['output']>;
  points?: Maybe<Scalars['Float']['output']>;
};

export type HealthInsurancePointsConfigCountAggregate = {
  __typename: 'HealthInsurancePointsConfigCountAggregate';
  _all: Scalars['Int']['output'];
  collectionMethodMultiplier: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  pointCollectionMethod: Scalars['Int']['output'];
  points: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

/** Input for creating points config for health insurance */
export type HealthInsurancePointsConfigCreateInput = {
  collectionMethodMultiplier?: InputMaybe<Scalars['Int']['input']>;
  /** Optionally specify the health insurance for which this config should created for */
  healthInsurance?: InputMaybe<HealthInsuranceCreateNestedOneWithoutPointsConfigInput>;
  pointCollectionMethod?: InputMaybe<PointCollectionMethod>;
  points?: InputMaybe<Scalars['Int']['input']>;
};

export type HealthInsurancePointsConfigMaxAggregate = {
  __typename: 'HealthInsurancePointsConfigMaxAggregate';
  collectionMethodMultiplier?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  pointCollectionMethod?: Maybe<PointCollectionMethod>;
  points?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HealthInsurancePointsConfigMinAggregate = {
  __typename: 'HealthInsurancePointsConfigMinAggregate';
  collectionMethodMultiplier?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  pointCollectionMethod?: Maybe<PointCollectionMethod>;
  points?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HealthInsurancePointsConfigNullableScalarRelationFilter = {
  is?: InputMaybe<HealthInsurancePointsConfigWhereInput>;
  isNot?: InputMaybe<HealthInsurancePointsConfigWhereInput>;
};

export type HealthInsurancePointsConfigOrderByWithRelationInput = {
  collectionMethodMultiplier?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  healthInsurance?: InputMaybe<HealthInsuranceOrderByWithRelationInput>;
  healthInsuranceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pointCollectionMethod?: InputMaybe<SortOrder>;
  points?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum HealthInsurancePointsConfigScalarFieldEnum {
  CollectionMethodMultiplier = 'collectionMethodMultiplier',
  CreatedAt = 'createdAt',
  HealthInsuranceId = 'healthInsuranceId',
  Id = 'id',
  PointCollectionMethod = 'pointCollectionMethod',
  Points = 'points',
  UpdatedAt = 'updatedAt'
}

export type HealthInsurancePointsConfigSumAggregate = {
  __typename: 'HealthInsurancePointsConfigSumAggregate';
  collectionMethodMultiplier?: Maybe<Scalars['Int']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
};

/** Input for updating a health insurance points config */
export type HealthInsurancePointsConfigUpdateInput = {
  collectionMethodMultiplier?: InputMaybe<Scalars['Int']['input']>;
  pointCollectionMethod?: InputMaybe<PointCollectionMethod>;
  points?: InputMaybe<Scalars['Int']['input']>;
};

export type HealthInsurancePointsConfigWhereInput = {
  AND?: InputMaybe<Array<HealthInsurancePointsConfigWhereInput>>;
  NOT?: InputMaybe<Array<HealthInsurancePointsConfigWhereInput>>;
  OR?: InputMaybe<Array<HealthInsurancePointsConfigWhereInput>>;
  collectionMethodMultiplier?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  healthInsurance?: InputMaybe<HealthInsuranceNullableScalarRelationFilter>;
  healthInsuranceId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  pointCollectionMethod?: InputMaybe<EnumPointCollectionMethodFilter>;
  points?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type HealthInsurancePointsConfigWhereUniqueInput = {
  AND?: InputMaybe<Array<HealthInsurancePointsConfigWhereInput>>;
  NOT?: InputMaybe<Array<HealthInsurancePointsConfigWhereInput>>;
  OR?: InputMaybe<Array<HealthInsurancePointsConfigWhereInput>>;
  collectionMethodMultiplier?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  healthInsurance?: InputMaybe<HealthInsuranceNullableScalarRelationFilter>;
  healthInsuranceId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  pointCollectionMethod?: InputMaybe<EnumPointCollectionMethodFilter>;
  points?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type HealthInsuranceReceivedPoint = {
  __typename: 'HealthInsuranceReceivedPoint';
  /** The count of received points */
  count: Scalars['Int']['output'];
  customer: Customer;
  healthInsurance: HealthInsurance;
  id: Scalars['UUID']['output'];
};

export type HealthInsuranceReceivedPointAvgAggregate = {
  __typename: 'HealthInsuranceReceivedPointAvgAggregate';
  count?: Maybe<Scalars['Float']['output']>;
};

export type HealthInsuranceReceivedPointCountAggregate = {
  __typename: 'HealthInsuranceReceivedPointCountAggregate';
  _all: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export type HealthInsuranceReceivedPointListRelationFilter = {
  every?: InputMaybe<HealthInsuranceReceivedPointWhereInput>;
  none?: InputMaybe<HealthInsuranceReceivedPointWhereInput>;
  some?: InputMaybe<HealthInsuranceReceivedPointWhereInput>;
};

export type HealthInsuranceReceivedPointMaxAggregate = {
  __typename: 'HealthInsuranceReceivedPointMaxAggregate';
  count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
};

export type HealthInsuranceReceivedPointMinAggregate = {
  __typename: 'HealthInsuranceReceivedPointMinAggregate';
  count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
};

export type HealthInsuranceReceivedPointOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type HealthInsuranceReceivedPointOrderByWithRelationInput = {
  count?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  healthInsurance?: InputMaybe<HealthInsuranceOrderByWithRelationInput>;
  healthInsuranceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export enum HealthInsuranceReceivedPointScalarFieldEnum {
  Count = 'count',
  CustomerId = 'customerId',
  HealthInsuranceId = 'healthInsuranceId',
  Id = 'id'
}

export type HealthInsuranceReceivedPointSumAggregate = {
  __typename: 'HealthInsuranceReceivedPointSumAggregate';
  count?: Maybe<Scalars['Int']['output']>;
};

export type HealthInsuranceReceivedPointWhereInput = {
  AND?: InputMaybe<Array<HealthInsuranceReceivedPointWhereInput>>;
  NOT?: InputMaybe<Array<HealthInsuranceReceivedPointWhereInput>>;
  OR?: InputMaybe<Array<HealthInsuranceReceivedPointWhereInput>>;
  count?: InputMaybe<IntFilter>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  healthInsurance?: InputMaybe<HealthInsuranceScalarRelationFilter>;
  healthInsuranceId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
};

export type HealthInsuranceReceivedPointWhereUniqueInput = {
  AND?: InputMaybe<Array<HealthInsuranceReceivedPointWhereInput>>;
  NOT?: InputMaybe<Array<HealthInsuranceReceivedPointWhereInput>>;
  OR?: InputMaybe<Array<HealthInsuranceReceivedPointWhereInput>>;
  count?: InputMaybe<IntFilter>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  healthInsurance?: InputMaybe<HealthInsuranceScalarRelationFilter>;
  healthInsuranceId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type HealthInsuranceRedeemedPoint = {
  __typename: 'HealthInsuranceRedeemedPoint';
  /** The date and time when the configuration was created. */
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  id: Scalars['UUID']['output'];
  reward: HealthInsuranceReward;
  /** The date and time when the configuration was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type HealthInsuranceRedeemedPointCountAggregate = {
  __typename: 'HealthInsuranceRedeemedPointCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

/** Input for creating a health insurance redeemed point */
export type HealthInsuranceRedeemedPointCreateInput = {
  /** Optionally specify the customer that redeemed the reward. */
  customer?: InputMaybe<CustomerCreateNestedOneWithoutHealthInsuranceRedeemedPointsInput>;
  /** The reward to redeem. */
  reward: HealthInsuranceRewardCreateNestedOneWithoutRedeemedPointsInput;
};

export type HealthInsuranceRedeemedPointListRelationFilter = {
  every?: InputMaybe<HealthInsuranceRedeemedPointWhereInput>;
  none?: InputMaybe<HealthInsuranceRedeemedPointWhereInput>;
  some?: InputMaybe<HealthInsuranceRedeemedPointWhereInput>;
};

export type HealthInsuranceRedeemedPointMaxAggregate = {
  __typename: 'HealthInsuranceRedeemedPointMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HealthInsuranceRedeemedPointMinAggregate = {
  __typename: 'HealthInsuranceRedeemedPointMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HealthInsuranceRedeemedPointOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type HealthInsuranceRedeemedPointOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  reward?: InputMaybe<HealthInsuranceRewardOrderByWithRelationInput>;
  rewardId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum HealthInsuranceRedeemedPointScalarFieldEnum {
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  HealthInsuranceId = 'healthInsuranceId',
  Id = 'id',
  RewardId = 'rewardId',
  UpdatedAt = 'updatedAt'
}

export type HealthInsuranceRedeemedPointWhereInput = {
  AND?: InputMaybe<Array<HealthInsuranceRedeemedPointWhereInput>>;
  NOT?: InputMaybe<Array<HealthInsuranceRedeemedPointWhereInput>>;
  OR?: InputMaybe<Array<HealthInsuranceRedeemedPointWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  reward?: InputMaybe<HealthInsuranceRewardScalarRelationFilter>;
  rewardId?: InputMaybe<UuidFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type HealthInsuranceRedeemedPointWhereUniqueInput = {
  AND?: InputMaybe<Array<HealthInsuranceRedeemedPointWhereInput>>;
  NOT?: InputMaybe<Array<HealthInsuranceRedeemedPointWhereInput>>;
  OR?: InputMaybe<Array<HealthInsuranceRedeemedPointWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  reward?: InputMaybe<HealthInsuranceRewardScalarRelationFilter>;
  rewardId?: InputMaybe<UuidFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type HealthInsuranceReward = {
  __typename: 'HealthInsuranceReward';
  /** The date and time when the configuration was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The date and time when the configuration was last updated. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The description of the reward */
  description?: Maybe<Scalars['String']['output']>;
  healthInsurance: HealthInsurance;
  id: Scalars['UUID']['output'];
  /** The name of the reward */
  name: Scalars['String']['output'];
  redeemedPoints?: Maybe<Array<HealthInsuranceRedeemedPoint>>;
  /** The required points to redeem this reward */
  requiredPoints: Scalars['Int']['output'];
  /** The price of the reward that would be saved */
  saving?: Maybe<Scalars['Float']['output']>;
  /** The date and time when the configuration was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type HealthInsuranceRewardAvgAggregate = {
  __typename: 'HealthInsuranceRewardAvgAggregate';
  requiredPoints?: Maybe<Scalars['Float']['output']>;
  saving?: Maybe<Scalars['Float']['output']>;
};

export type HealthInsuranceRewardCountAggregate = {
  __typename: 'HealthInsuranceRewardCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  requiredPoints: Scalars['Int']['output'];
  saving: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

/** Input for creating a reward for a health insurance */
export type HealthInsuranceRewardCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optionally specify the health insurance for which the reward should created for */
  healthInsurance?: InputMaybe<HealthInsuranceCreateNestedOneWithoutRewardInput>;
  name: Scalars['String']['input'];
  requiredPoints: Scalars['Int']['input'];
  saving?: InputMaybe<Scalars['Float']['input']>;
};

/** Custom not nullable connect type for the reward */
export type HealthInsuranceRewardCreateNestedOneWithoutRedeemedPointsInput = {
  connect: HealthInsuranceRewardWhereUniqueInput;
};

export type HealthInsuranceRewardListRelationFilter = {
  every?: InputMaybe<HealthInsuranceRewardWhereInput>;
  none?: InputMaybe<HealthInsuranceRewardWhereInput>;
  some?: InputMaybe<HealthInsuranceRewardWhereInput>;
};

export type HealthInsuranceRewardMaxAggregate = {
  __typename: 'HealthInsuranceRewardMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  requiredPoints?: Maybe<Scalars['Int']['output']>;
  saving?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HealthInsuranceRewardMinAggregate = {
  __typename: 'HealthInsuranceRewardMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  requiredPoints?: Maybe<Scalars['Int']['output']>;
  saving?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HealthInsuranceRewardOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type HealthInsuranceRewardOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrderInput>;
  healthInsurance?: InputMaybe<HealthInsuranceOrderByWithRelationInput>;
  healthInsuranceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  redeemedPoints?: InputMaybe<HealthInsuranceRedeemedPointOrderByRelationAggregateInput>;
  requiredPoints?: InputMaybe<SortOrder>;
  saving?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum HealthInsuranceRewardScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Description = 'description',
  HealthInsuranceId = 'healthInsuranceId',
  Id = 'id',
  Name = 'name',
  RequiredPoints = 'requiredPoints',
  Saving = 'saving',
  UpdatedAt = 'updatedAt'
}

export type HealthInsuranceRewardScalarRelationFilter = {
  is?: InputMaybe<HealthInsuranceRewardWhereInput>;
  isNot?: InputMaybe<HealthInsuranceRewardWhereInput>;
};

export type HealthInsuranceRewardSumAggregate = {
  __typename: 'HealthInsuranceRewardSumAggregate';
  requiredPoints?: Maybe<Scalars['Int']['output']>;
  saving?: Maybe<Scalars['Float']['output']>;
};

/** Input for updating an health insurance reward */
export type HealthInsuranceRewardUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requiredPoints?: InputMaybe<Scalars['Int']['input']>;
  saving?: InputMaybe<Scalars['Float']['input']>;
};

export type HealthInsuranceRewardWhereInput = {
  AND?: InputMaybe<Array<HealthInsuranceRewardWhereInput>>;
  NOT?: InputMaybe<Array<HealthInsuranceRewardWhereInput>>;
  OR?: InputMaybe<Array<HealthInsuranceRewardWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  healthInsurance?: InputMaybe<HealthInsuranceScalarRelationFilter>;
  healthInsuranceId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  redeemedPoints?: InputMaybe<HealthInsuranceRedeemedPointListRelationFilter>;
  requiredPoints?: InputMaybe<IntFilter>;
  saving?: InputMaybe<FloatNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type HealthInsuranceRewardWhereUniqueInput = {
  AND?: InputMaybe<Array<HealthInsuranceRewardWhereInput>>;
  NOT?: InputMaybe<Array<HealthInsuranceRewardWhereInput>>;
  OR?: InputMaybe<Array<HealthInsuranceRewardWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  healthInsurance?: InputMaybe<HealthInsuranceScalarRelationFilter>;
  healthInsuranceId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<StringFilter>;
  redeemedPoints?: InputMaybe<HealthInsuranceRedeemedPointListRelationFilter>;
  requiredPoints?: InputMaybe<IntFilter>;
  saving?: InputMaybe<FloatNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum HealthInsuranceScalarFieldEnum {
  CreatedAt = 'createdAt',
  Description = 'description',
  Email = 'email',
  HouseNumber = 'houseNumber',
  Id = 'id',
  LogoUrl = 'logoUrl',
  Name = 'name',
  OrganizationConnection = 'organizationConnection',
  OrganizationName = 'organizationName',
  Place = 'place',
  Street = 'street',
  UpdatedAt = 'updatedAt',
  Zipcode = 'zipcode'
}

export type HealthInsuranceScalarRelationFilter = {
  is?: InputMaybe<HealthInsuranceWhereInput>;
  isNot?: InputMaybe<HealthInsuranceWhereInput>;
};

/** Input for updating a health insurance */
export type HealthInsuranceUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type HealthInsuranceWhereInput = {
  AND?: InputMaybe<Array<HealthInsuranceWhereInput>>;
  NOT?: InputMaybe<Array<HealthInsuranceWhereInput>>;
  OR?: InputMaybe<Array<HealthInsuranceWhereInput>>;
  balances?: InputMaybe<HealthInsuranceBalanceListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customers?: InputMaybe<CustomerListRelationFilter>;
  description?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringFilter>;
  employees?: InputMaybe<HealthInsuranceEmployeeListRelationFilter>;
  houseNumber?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  logoUrl?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  organizationConnection?: InputMaybe<StringNullableFilter>;
  organizationName?: InputMaybe<StringFilter>;
  place?: InputMaybe<StringFilter>;
  pointsConfig?: InputMaybe<HealthInsurancePointsConfigNullableScalarRelationFilter>;
  receivedPoints?: InputMaybe<HealthInsuranceReceivedPointListRelationFilter>;
  rewards?: InputMaybe<HealthInsuranceRewardListRelationFilter>;
  street?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  zipcode?: InputMaybe<StringFilter>;
};

export type HealthInsuranceWhereUniqueInput = {
  AND?: InputMaybe<Array<HealthInsuranceWhereInput>>;
  NOT?: InputMaybe<Array<HealthInsuranceWhereInput>>;
  OR?: InputMaybe<Array<HealthInsuranceWhereInput>>;
  balances?: InputMaybe<HealthInsuranceBalanceListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customers?: InputMaybe<CustomerListRelationFilter>;
  description?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringFilter>;
  employees?: InputMaybe<HealthInsuranceEmployeeListRelationFilter>;
  houseNumber?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  organizationConnection?: InputMaybe<StringNullableFilter>;
  organizationName?: InputMaybe<StringFilter>;
  place?: InputMaybe<StringFilter>;
  pointsConfig?: InputMaybe<HealthInsurancePointsConfigNullableScalarRelationFilter>;
  receivedPoints?: InputMaybe<HealthInsuranceReceivedPointListRelationFilter>;
  rewards?: InputMaybe<HealthInsuranceRewardListRelationFilter>;
  street?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  zipcode?: InputMaybe<StringFilter>;
};

/** Input for setting an image */
export type ImageInput = {
  /** A new file upload */
  fileUpload?: InputMaybe<Scalars['Upload']['input']>;
  /** The URL of an image */
  imageUrl?: InputMaybe<Scalars['String']['input']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['Int']['input']>>;
  has?: InputMaybe<Scalars['Int']['input']>;
  hasEvery?: InputMaybe<Array<Scalars['Int']['input']>>;
  hasSome?: InputMaybe<Array<Scalars['Int']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents a stripe invoice */
export type Invoice = {
  __typename: 'Invoice';
  /** The creation date of the invoice */
  created: Scalars['Float']['output'];
  /** The link of the downloadable invoice pdf */
  invoicePdf?: Maybe<Scalars['String']['output']>;
  /** The number of the invoice */
  number: Scalars['String']['output'];
  /** Indicates whether the invoice has been paid or not */
  paid: Scalars['Boolean']['output'];
  /** The total amount of the invoice */
  total: Scalars['Float']['output'];
};

export type JobLeaseCountAggregate = {
  __typename: 'JobLeaseCountAggregate';
  _all: Scalars['Int']['output'];
  holder: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  leaseUntil: Scalars['Int']['output'];
};

export type JobLeaseMaxAggregate = {
  __typename: 'JobLeaseMaxAggregate';
  holder?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  leaseUntil?: Maybe<Scalars['DateTime']['output']>;
};

export type JobLeaseMinAggregate = {
  __typename: 'JobLeaseMinAggregate';
  holder?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  leaseUntil?: Maybe<Scalars['DateTime']['output']>;
};

export type JsonNullableFilter = {
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Send mail to support */
export type MailModel = {
  __typename: 'MailModel';
  successful: Scalars['Boolean']['output'];
};

/** Possible mail types */
export enum MailTypes {
  Contact = 'CONTACT',
  Information = 'INFORMATION'
}

/** Model for created Jobs of management client */
export type ManagementJobModel = {
  __typename: 'ManagementJobModel';
  created_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum MediaType {
  Gif = 'GIF',
  Image = 'IMAGE',
  Video = 'VIDEO'
}

export type Message = {
  __typename: 'Message';
  content?: Maybe<Scalars['String']['output']>;
  /**
   * "Delete for everyone" (WhatsApp-style, MessageService.deleteMessage): set once the sender
   * deletes their own Message. `content`/media/shared-event/location are cleared at the same
   * time -- the row itself, its position in the Conversation, and Conversation.lastMessage all
   * stay intact so the client can render a "message deleted" tombstone in place.
   */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isCircleReply: Scalars['Boolean']['output'];
  locationAddress?: Maybe<Scalars['String']['output']>;
  /**
   * Free-text display name of the shared location (e.g. "Treffpunkt Stadtpark"), if this
   * message shares a location. The client builds the "Route" deep link from lat/long.
   */
  locationLabel?: Maybe<Scalars['String']['output']>;
  locationLatitude?: Maybe<Scalars['Float']['output']>;
  locationLongitude?: Maybe<Scalars['Float']['output']>;
  media: Array<MessageMedia>;
  senderProfile?: Maybe<Profile>;
  sentAt: Scalars['DateTime']['output'];
  sharedCircle?: Maybe<Circle>;
  sharedCommunityEvent?: Maybe<CommunityEvent>;
  sharedCommunityEventInstance?: Maybe<CommunityEventInstance>;
};


export type MessageMediaArgs = {
  cursor?: InputMaybe<MessageMediaWhereUniqueInput>;
  distinct?: InputMaybe<Array<MessageMediaScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MessageMediaOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MessageMediaWhereInput>;
};

export type MessageAvgAggregate = {
  __typename: 'MessageAvgAggregate';
  locationLatitude?: Maybe<Scalars['Float']['output']>;
  locationLongitude?: Maybe<Scalars['Float']['output']>;
};

export type MessageCountAggregate = {
  __typename: 'MessageCountAggregate';
  _all: Scalars['Int']['output'];
  content: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  locationAddress: Scalars['Int']['output'];
  locationLabel: Scalars['Int']['output'];
  locationLatitude: Scalars['Int']['output'];
  locationLongitude: Scalars['Int']['output'];
  sentAt: Scalars['Int']['output'];
};

export type MessageCreateNestedManyWithoutSharedCommunityEventInput = {
  connect?: InputMaybe<Array<MessageWhereUniqueInput>>;
};

export type MessageEdge = {
  __typename: 'MessageEdge';
  cursor: PaginatedMessageCursor;
  node: Message;
};

export type MessageListRelationFilter = {
  every?: InputMaybe<MessageWhereInput>;
  none?: InputMaybe<MessageWhereInput>;
  some?: InputMaybe<MessageWhereInput>;
};

/** A location to share in a Message. The client builds the "Route" button from lat/long. */
export type MessageLocationInput = {
  /** Free-text address. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Free-text display name, e.g. "Treffpunkt Stadtpark". */
  label?: InputMaybe<Scalars['String']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type MessageMaxAggregate = {
  __typename: 'MessageMaxAggregate';
  content?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  locationAddress?: Maybe<Scalars['String']['output']>;
  locationLabel?: Maybe<Scalars['String']['output']>;
  locationLatitude?: Maybe<Scalars['Float']['output']>;
  locationLongitude?: Maybe<Scalars['Float']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MessageMedia = {
  __typename: 'MessageMedia';
  createdAt: Scalars['DateTime']['output'];
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  key: Scalars['String']['output'];
  mediaType: MediaType;
  position: Scalars['Int']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type MessageMediaAvgAggregate = {
  __typename: 'MessageMediaAvgAggregate';
  durationSeconds?: Maybe<Scalars['Float']['output']>;
  position?: Maybe<Scalars['Float']['output']>;
};

export type MessageMediaCountAggregate = {
  __typename: 'MessageMediaCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  durationSeconds: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  key: Scalars['Int']['output'];
  mediaType: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  thumbnailUrl: Scalars['Int']['output'];
  url: Scalars['Int']['output'];
};

/** A single media item to attach to a Message. */
export type MessageMediaInput = {
  /** Only relevant for mediaType=VIDEO. */
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** The image/video file itself. */
  image: ImageInput;
  mediaType: MediaType;
  /** Display order within the message, ascending. Defaults to 0. */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Only relevant for mediaType=VIDEO. */
  thumbnailImage?: InputMaybe<ImageInput>;
};

export type MessageMediaListRelationFilter = {
  every?: InputMaybe<MessageMediaWhereInput>;
  none?: InputMaybe<MessageMediaWhereInput>;
  some?: InputMaybe<MessageMediaWhereInput>;
};

export type MessageMediaMaxAggregate = {
  __typename: 'MessageMediaMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<MediaType>;
  position?: Maybe<Scalars['Int']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type MessageMediaMinAggregate = {
  __typename: 'MessageMediaMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<MediaType>;
  position?: Maybe<Scalars['Int']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type MessageMediaOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MessageMediaOrderByWithRelationInput = {
  durationSeconds?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  mediaType?: InputMaybe<SortOrder>;
  message?: InputMaybe<MessageOrderByWithRelationInput>;
  messageId?: InputMaybe<SortOrder>;
  position?: InputMaybe<SortOrder>;
  thumbnailUrl?: InputMaybe<SortOrderInput>;
  url?: InputMaybe<SortOrder>;
};

export enum MessageMediaScalarFieldEnum {
  CreatedAt = 'createdAt',
  DurationSeconds = 'durationSeconds',
  Id = 'id',
  Key = 'key',
  MediaType = 'mediaType',
  MessageId = 'messageId',
  Position = 'position',
  ThumbnailUrl = 'thumbnailUrl',
  Url = 'url'
}

export type MessageMediaSumAggregate = {
  __typename: 'MessageMediaSumAggregate';
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
};

export type MessageMediaWhereInput = {
  AND?: InputMaybe<Array<MessageMediaWhereInput>>;
  NOT?: InputMaybe<Array<MessageMediaWhereInput>>;
  OR?: InputMaybe<Array<MessageMediaWhereInput>>;
  durationSeconds?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  key?: InputMaybe<StringFilter>;
  mediaType?: InputMaybe<EnumMediaTypeFilter>;
  message?: InputMaybe<MessageScalarRelationFilter>;
  messageId?: InputMaybe<UuidFilter>;
  position?: InputMaybe<IntFilter>;
  thumbnailUrl?: InputMaybe<StringNullableFilter>;
  url?: InputMaybe<StringFilter>;
};

export type MessageMediaWhereUniqueInput = {
  AND?: InputMaybe<Array<MessageMediaWhereInput>>;
  NOT?: InputMaybe<Array<MessageMediaWhereInput>>;
  OR?: InputMaybe<Array<MessageMediaWhereInput>>;
  durationSeconds?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  key?: InputMaybe<StringFilter>;
  mediaType?: InputMaybe<EnumMediaTypeFilter>;
  message?: InputMaybe<MessageScalarRelationFilter>;
  messageId?: InputMaybe<UuidFilter>;
  position?: InputMaybe<IntFilter>;
  thumbnailUrl?: InputMaybe<StringNullableFilter>;
  url?: InputMaybe<StringFilter>;
};

export type MessageMinAggregate = {
  __typename: 'MessageMinAggregate';
  content?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  locationAddress?: Maybe<Scalars['String']['output']>;
  locationLabel?: Maybe<Scalars['String']['output']>;
  locationLatitude?: Maybe<Scalars['Float']['output']>;
  locationLongitude?: Maybe<Scalars['Float']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MessageNullableScalarRelationFilter = {
  is?: InputMaybe<MessageWhereInput>;
  isNot?: InputMaybe<MessageWhereInput>;
};

export type MessageOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MessageOrderByWithRelationInput = {
  activities?: InputMaybe<ActivityOrderByRelationAggregateInput>;
  content?: InputMaybe<SortOrderInput>;
  conversation?: InputMaybe<ConversationOrderByWithRelationInput>;
  conversationId?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  locationAddress?: InputMaybe<SortOrderInput>;
  locationLabel?: InputMaybe<SortOrderInput>;
  locationLatitude?: InputMaybe<SortOrderInput>;
  locationLongitude?: InputMaybe<SortOrderInput>;
  media?: InputMaybe<MessageMediaOrderByRelationAggregateInput>;
  senderProfile?: InputMaybe<ProfileOrderByWithRelationInput>;
  senderProfileId?: InputMaybe<SortOrderInput>;
  sentAt?: InputMaybe<SortOrder>;
  sharedCircle?: InputMaybe<CircleOrderByWithRelationInput>;
  sharedCircleId?: InputMaybe<SortOrderInput>;
  sharedCommunityEvent?: InputMaybe<CommunityEventOrderByWithRelationInput>;
  sharedCommunityEventId?: InputMaybe<SortOrderInput>;
  sharedCommunityEventInstance?: InputMaybe<CommunityEventInstanceOrderByWithRelationInput>;
  sharedCommunityEventInstanceId?: InputMaybe<SortOrderInput>;
};

export enum MessageScalarFieldEnum {
  Content = 'content',
  ConversationId = 'conversationId',
  DeletedAt = 'deletedAt',
  Id = 'id',
  LocationAddress = 'locationAddress',
  LocationLabel = 'locationLabel',
  LocationLatitude = 'locationLatitude',
  LocationLongitude = 'locationLongitude',
  ProfileAId = 'profileAId',
  ProfileBId = 'profileBId',
  SenderProfileId = 'senderProfileId',
  SentAt = 'sentAt',
  SharedCircleId = 'sharedCircleId',
  SharedCommunityEventId = 'sharedCommunityEventId',
  SharedCommunityEventInstanceId = 'sharedCommunityEventInstanceId'
}

export type MessageScalarRelationFilter = {
  is?: InputMaybe<MessageWhereInput>;
  isNot?: InputMaybe<MessageWhereInput>;
};

/** A suggested Profile to message, alongside the CommunityEventInstance the current actor most recently attended together with them. */
export type MessageSuggestion = {
  __typename: 'MessageSuggestion';
  profile: Profile;
  sharedCommunityEventInstance: CommunityEventInstance;
};

export type MessageSumAggregate = {
  __typename: 'MessageSumAggregate';
  locationLatitude?: Maybe<Scalars['Float']['output']>;
  locationLongitude?: Maybe<Scalars['Float']['output']>;
};

export type MessageUpdateManyWithoutSharedCommunityEventInstanceNestedInput = {
  connect?: InputMaybe<Array<MessageWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<MessageWhereUniqueInput>>;
};

export type MessageUpdateManyWithoutSharedCommunityEventNestedInput = {
  connect?: InputMaybe<Array<MessageWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<MessageWhereUniqueInput>>;
};

export type MessageWhereInput = {
  AND?: InputMaybe<Array<MessageWhereInput>>;
  NOT?: InputMaybe<Array<MessageWhereInput>>;
  OR?: InputMaybe<Array<MessageWhereInput>>;
  activities?: InputMaybe<ActivityListRelationFilter>;
  content?: InputMaybe<StringNullableFilter>;
  conversation?: InputMaybe<ConversationScalarRelationFilter>;
  conversationId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  locationAddress?: InputMaybe<StringNullableFilter>;
  locationLabel?: InputMaybe<StringNullableFilter>;
  locationLatitude?: InputMaybe<FloatNullableFilter>;
  locationLongitude?: InputMaybe<FloatNullableFilter>;
  media?: InputMaybe<MessageMediaListRelationFilter>;
  senderProfile?: InputMaybe<ProfileNullableScalarRelationFilter>;
  senderProfileId?: InputMaybe<UuidNullableFilter>;
  sentAt?: InputMaybe<DateTimeFilter>;
  sharedCircle?: InputMaybe<CircleNullableScalarRelationFilter>;
  sharedCircleId?: InputMaybe<UuidNullableFilter>;
  sharedCommunityEvent?: InputMaybe<CommunityEventNullableScalarRelationFilter>;
  sharedCommunityEventId?: InputMaybe<UuidNullableFilter>;
  sharedCommunityEventInstance?: InputMaybe<CommunityEventInstanceNullableScalarRelationFilter>;
  sharedCommunityEventInstanceId?: InputMaybe<UuidNullableFilter>;
};

export type MessageWhereUniqueInput = {
  AND?: InputMaybe<Array<MessageWhereInput>>;
  NOT?: InputMaybe<Array<MessageWhereInput>>;
  OR?: InputMaybe<Array<MessageWhereInput>>;
  activities?: InputMaybe<ActivityListRelationFilter>;
  content?: InputMaybe<StringNullableFilter>;
  conversation?: InputMaybe<ConversationScalarRelationFilter>;
  conversationId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationAddress?: InputMaybe<StringNullableFilter>;
  locationLabel?: InputMaybe<StringNullableFilter>;
  locationLatitude?: InputMaybe<FloatNullableFilter>;
  locationLongitude?: InputMaybe<FloatNullableFilter>;
  media?: InputMaybe<MessageMediaListRelationFilter>;
  senderProfile?: InputMaybe<ProfileNullableScalarRelationFilter>;
  senderProfileId?: InputMaybe<UuidNullableFilter>;
  sentAt?: InputMaybe<DateTimeFilter>;
  sharedCircle?: InputMaybe<CircleNullableScalarRelationFilter>;
  sharedCircleId?: InputMaybe<UuidNullableFilter>;
  sharedCommunityEvent?: InputMaybe<CommunityEventNullableScalarRelationFilter>;
  sharedCommunityEventId?: InputMaybe<UuidNullableFilter>;
  sharedCommunityEventInstance?: InputMaybe<CommunityEventInstanceNullableScalarRelationFilter>;
  sharedCommunityEventInstanceId?: InputMaybe<UuidNullableFilter>;
};

/** A GYM_APP access device as seen by the ACS migration tooling (exposes serialNumber / providerDeviceId / acsMigrationStatus). */
export type MigrationAccessDevice = {
  __typename: 'MigrationAccessDevice';
  /** Current migration state towards ACS (NONE | INITIATED | MIGRATED). */
  acsMigrationStatus: AcsMigrationStatus;
  /** Whether the device controls the entry turnstile. */
  canOpenEntry: Scalars['Boolean']['output'];
  /** Whether the device controls the exit turnstile. */
  canOpenExit: Scalars['Boolean']['output'];
  /** When the device was created in TrainToGo (ISO 8601); preserved as the ACS device createdAt during migration. */
  createdAt: Scalars['String']['output'];
  /** The gym id — becomes the ACS externalGymId in the mapping. */
  gymId: Scalars['String']['output'];
  /** The TrainToGo access-device row id. */
  id: Scalars['String']['output'];
  /** Whether the device is active. */
  isActive: Scalars['Boolean']['output'];
  /** Human-readable device name; carried onto the ACS device during migration. */
  name: Scalars['String']['output'];
  /** The provider device id (equals the ACS device UUID; fallback match key). */
  providerDeviceId: Scalars['String']['output'];
  /** Physical serial number of the controller (primary match key). */
  serialNumber?: Maybe<Scalars['String']['output']>;
};

export type MigrationAccessDevicesInput = {
  /** Limit to a single gym (studio-wise migration). */
  gymId?: InputMaybe<Scalars['String']['input']>;
  /** Limit to a single device by providerDeviceId (= ACS device UUID). */
  providerDeviceId?: InputMaybe<Scalars['String']['input']>;
  /** Limit to a single device by serial number. */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};

export type MoneyDto = {
  __typename: 'MoneyDto';
  amount: Scalars['Float']['output'];
  currencyCode: Scalars['String']['output'];
};

export type Mutation = {
  __typename: 'Mutation';
  /** Accepts an incoming follow request addressed to the current actor’s own profile. */
  acceptFollowRequest: FollowRequest;
  /** Activates a waitlisted booking for a community event as a management user */
  activateCommunityEventBookingFromWaitlist: CommunityEventBooking;
  /** Activates multiple waitlisted bookings of a single event instance as a management user */
  activateCommunityEventBookingsFromWaitlist: Array<CommunityEventBooking>;
  /** Blocks a profile from the current actor's own personal profile. Also unfollows both directions between the two profiles. */
  blockProfile: Block;
  /** Books a ticket of a paid instance for the acting customer: a reservation to pay, a queue entry, or why neither. */
  bookCommunityEventTicket: CommunityEventTicketBookingResult;
  /** Deletes a booking for an event as Organizer */
  cancelBookingCompany: EventBooking;
  /** Deletes a booking for an event as Customer */
  cancelBookingCustomer: EventBooking;
  /** Deletes a booking for a community event */
  cancelCommunityEventBookingCustomer: CommunityEventBooking;
  /** Cancels a booking for a community event as a management user */
  cancelCommunityEventBookingManagement: CommunityEventBooking;
  /** Cancels the acting customer's ticket after its event was moved: a paid ticket is refunded in full, a free one revoked. Only for a ticket obtained before the reschedule, until the new start. */
  cancelCommunityEventTicketAfterReschedule: CommunityEventTicket;
  /** Gives up the acting customer's queue entry or held reservation of a paid instance and returns the state afterwards. A paid ticket can't be cancelled. */
  cancelCommunityEventTicketBooking: CommunityEventTicketSaleState;
  cancelContract: ContractDetails;
  /** Cancel the `customer-billing` and the `invoice` in Stripe. The `credit note` (cancellation invoice) will also be sent to the customer. A new `training`, `customer-billing` and `invoice` will be created based on the given corrected training time and immediately sent to the customer. */
  cancelCustomerBilling: CustomerBilling;
  /** Cancel one event and the associated bookings */
  cancelEvent: Event;
  changeCustomerState: Customer;
  /** Completes a ticket reservation's payment (payment webhook). Null if the payment can't be attached to a reservation. */
  completeCommunityEventTicketPayment?: Maybe<CommunityEventTicket>;
  /** Marks a company invoice paid (payment webhook). A repeated call keeps the first payment time. */
  completeCompanyBillingPayment: CompanyBilling;
  completeGymHighlightOrderPayment: GymHighlightOrder;
  /** Confirms the entry of the active training session without a device (e.g. entry device offline and customer was let in by staff). Counts as a valid entry, so the exit can be opened afterwards. */
  confirmEntryForActiveTraining: ConfirmEntryForActiveTraining;
  /** Creates a booking for an event */
  createBooking: EventBooking;
  /** Creates one circle */
  createCircle: Circle;
  /** Creates a booking for a community event */
  createCommunityEventBooking: CommunityEventBooking;
  createCommunityEventImage: CommunityEventImage;
  createCommunityEventImages: Array<CommunityEventImage>;
  /** Creates one community event instances */
  createCommunityEventInstance: CommunityEventInstance;
  /** Appends a price tier to a ticket sale. */
  createCommunityEventPriceTier: CommunityEventPriceTier;
  /** Allows a club member to buy one ticket although the sale is sold out, or ahead of the queue, at the price of the chosen tier. The member gets a push and buys in the app as usual. */
  createCommunityEventTicketPurchaseGrant: CommunityEventTicketPurchaseGrant;
  /** Creates one community post */
  createCommunityPost: CommunityPost;
  /** Creates an Community Post Comment */
  createCommunityPostComment: CommunityPostComment;
  /** Creates the profile for the current company/brand (business owner only) */
  createCompanyProfile: Profile;
  /** Gives a club member a free ticket for a published paid date, within the sale's free ticket quota. The member gets a push; the ticket and its QR code are in the app. */
  createComplimentaryCommunityEventTicket: CommunityEventTicket;
  createCoupon: Coupon;
  /** Creates one customer */
  createCustomer: Customer;
  createCustomerBilling: CustomerBilling;
  /** Creates an event */
  createEvent: Event;
  /** Creates multiple events at once */
  createEvents: Array<Event>;
  createGymAdvantage: GymAdvantage;
  createGymCategory: GymCategory;
  createGymHighlightOrder: GymHighlightOrder;
  /** Creates a Stripe checkout session for a pending highlight order and returns the payment URL. */
  createGymHighlightOrderCheckoutSession: Scalars['String']['output'];
  createGymImage: GymImage;
  createHealthInsurancePointsConfig: HealthInsurancePointsConfig;
  createHealthInsuranceRedeemedPoint: HealthInsuranceRedeemedPoint;
  createHealthInsuranceReward: HealthInsuranceReward;
  /** Create one or more gym advantages */
  createManyGymAdvantages: Scalars['JSON']['output'];
  /** Create one or more gym categories */
  createManyGymCategories: Array<GymCategory>;
  createManyGymRatings: Array<GymRating>;
  /** Creates the current actor's own personal profile */
  createMyProfile: Profile;
  /** Creates one CommunityClub */
  createOneCommunityClub: CommunityClub;
  /** Creates one CommunityEvent */
  createOneCommunityEvent: CommunityEvent;
  /** Creates one CommunityEventLocation */
  createOneCommunityEventLocation: CommunityEventLocation;
  /** Creates one CommunityEventPartner */
  createOneCommunityEventPartner: CommunityEventPartner;
  /** Creates one gym */
  createOneGym: Gym;
  /** Creates one opening hour */
  createOneOpeningHour: OpeningHour;
  createPayoutHistory: PayoutHistory;
  createPopup: Popup;
  createPopupPeriod: PopupPeriod;
  createPromotion: Promotion;
  createPromotionCode: PromotionCode;
  /**
   * Push notifications of type IMMEDIATE will be sent out immediately after creation.
   *     For Push notifications of type RECURRING and SCHEDULED_ONCE, scheduler will be created to sent out the notification at expression date
   */
  createPushNotification: PushNotification;
  /** Creates a push notification restricted to the customers of the given community clubs. At least one communityClubId must be specified. The company is always derived from the user context. Push notifications to community clubs can only be of type IMMEDIATE and cannot be scheduled. */
  createPushNotificationCommunityClub: PushNotification;
  createRatingQuestion: RatingQuestion;
  createRatingQuestions: Array<RatingQuestion>;
  createRegistrationQuestion: RegistrationQuestion;
  createRegistrationQuestionOption: RegistrationQuestionOption;
  /** Creates one training session */
  createTrainingSession: TrainingSession;
  /** Creates one user post */
  createUserPost: UserPost;
  /** Creates a comment on a UserPost */
  createUserPostComment: CommunityPostComment;
  /** Creates one workout */
  createWorkout: Workout;
  /** Declines an incoming follow request addressed to the current actor’s own profile. */
  declineFollowRequest: FollowRequest;
  /** Deletes one circle */
  deleteCircle: Circle;
  deleteCommunityClub: CommunityClub;
  deleteCommunityClubOnboarding: CommunityClubOnboarding;
  /** Deletes one CommunityEvent */
  deleteCommunityEvent: CommunityEvent;
  deleteCommunityEventImage: CommunityEventImage;
  /** Deletes one CommunityEventInstance */
  deleteCommunityEventInstance: CommunityEventInstance;
  /** Deletes one CommunityEventLocation */
  deleteCommunityEventLocation: CommunityEventLocation;
  /** Deletes one CommunityEventPartner */
  deleteCommunityEventPartner: CommunityEventPartner;
  /** Deletes a price tier; only before the first ticket of the sale is reserved. */
  deleteCommunityEventPriceTier: CommunityEventPriceTier;
  /** Deletes one community post */
  deleteCommunityPost: CommunityPost;
  /** Deletes an Community Post Comment */
  deleteCommunityPostComment: CommunityPostComment;
  deleteCompany: Company;
  deleteCompanyEmployee: CompanyEmployee;
  /** "Delete chat" (WhatsApp-style): hides this Conversation from the current actor's own list. Reappears automatically once either side sends a new Message. */
  deleteConversation: Scalars['Boolean']['output'];
  deleteCoupon: Coupon;
  deleteCustomerBilling: CustomerBilling;
  deleteGym: Gym;
  deleteGymAdvantage: GymAdvantage;
  deleteGymCategory: GymCategory;
  deleteGymHighlightOrder: GymHighlightOrder;
  deleteGymImage: GymImage;
  deleteGymRating: GymRating;
  deleteHealthInsurance: HealthInsurance;
  deleteHealthInsuranceEmployee: HealthInsuranceEmployee;
  deleteHealthInsurancePointsConfig: HealthInsurancePointsConfig;
  deleteHealthInsuranceReward: HealthInsuranceReward;
  /** "Delete for everyone" (WhatsApp-style): only the sender may delete their own Message. Clears its content/media/shared event or location, leaving a tombstone visible to both participants. */
  deleteMessage: Message;
  deleteOpeningHour: OpeningHour;
  deletePopup: Popup;
  /** Delete the specified popup period. Note!: If you delete a popup period that was already active you will loose information about the views, clicks and closes of this period. */
  deletePopupPeriod: PopupPeriod;
  deletePromotion: Promotion;
  deletePushNotification: PushNotification;
  deleteRatingQuestion: RatingQuestion;
  deleteRegistrationQuestion: RegistrationQuestion;
  deleteRegistrationQuestionOption: RegistrationQuestionOption;
  deleteTrainingSession: TrainingSession;
  /** Deletes one user post */
  deleteUserPost: UserPost;
  /** Deletes one workout */
  deleteWorkout: Workout;
  disableGymHighlightOrder: GymHighlightOrder;
  disablePopup: Popup;
  disablePushNotification: PushNotification;
  /** Dismisses an unfounded report without touching the reported content */
  dismissReport: Scalars['Boolean']['output'];
  enableGymHighlightOrder: GymHighlightOrder;
  enablePopup: Popup;
  /** Finish a training session and generate the checkout session url to pay this session */
  finishTrainingSession: TrainingSession;
  /** Follows a profile from the current actor's own personal profile, or -- if the target is private -- sends a follow request instead. Returns ACCEPTED if now following, PENDING if a request was sent. */
  followProfile: FollowRequestStatus;
  generateContract: GenerateContractResponse;
  /** Generates upcoming instances for all active community events based on their recurrence rules. Intended to be called periodically by a maintenance service. Returns the number of events processed. */
  generateUpcomingCommunityEventInstances: Scalars['Int']['output'];
  /** Invite a employee into a organization */
  inviteCompanyEmployee: CompanyEmployee;
  inviteHealthInsuranceEmployee: HealthInsuranceEmployee;
  /** Join a community club as a customer */
  joinCommunityClub: Scalars['Boolean']['output'];
  /** Leave a community club as a customer */
  leaveCommunityClub: Scalars['Boolean']['output'];
  /** Marks a single Activity/notification as read */
  markActivityRead: Scalars['Boolean']['output'];
  /** Marks all of the current Profile's unread notifications as read */
  markAllActivitiesRead: Scalars['Boolean']['output'];
  /** Marks a circle as seen, incrementing its viewer count. */
  markCircleViewed: Circle;
  /** Advances the current actor's own read-position on a Conversation to now. */
  markConversationRead: Scalars['Boolean']['output'];
  /** Advances the current actor’s personal feed checkpoint. */
  markFeedSeen: Scalars['Boolean']['output'];
  openAccessDeviceAggregator: OpenAccessDeviceGymApp;
  openAccessDeviceForActiveTraining: OpenAccessDevice;
  openAccessDeviceManually: OpenAccessDeviceGymApp;
  /** Activate a booking for a community event */
  participateCommunityEventBookingCustomer: CommunityEventBooking;
  /** One run of the community event ticket sweep (maintenance service): releases overdue reservations, completes paid ones and promotes the queues. */
  processCommunityEventTicketReservations: CommunityEventTicketSweepResult;
  /** Processes bookings that were not checked in (No-Show) and creates invoices for them. */
  processNoShowBookings: Scalars['Float']['output'];
  /** Marks bookings of completed community event instances that are still ACTIVE as NO_SHOW, and bookings that are still WAITLISTED as CANCELED. Also syncs the CommunityMemberRelation attendance counts for those completed instances. Intended to be called periodically (e.g. hourly) by a maintenance service. Returns the number of bookings updated. */
  processNoShowCommunityEventBookings: Scalars['Int']['output'];
  /** Triggered every day by the customer-handler lambda function to delete all customers that marked as deleted for 30 days */
  processScheduledCustomerDeletion?: Maybe<DeleteCustomerResult>;
  /** Refunds one paid, not scanned ticket in full; the freed slot goes back on sale. */
  refundCommunityEventTicket: CommunityEventTicket;
  registerCompany: Company;
  registerHealthInsurance: HealthInsurance;
  registerInvitedCompanyEmployee: CompanyEmployee;
  registerInvitedHealthInsuranceEmployee: HealthInsuranceEmployee;
  /** Removes a profile from the current actor's own followers. */
  removeFollower: Scalars['Boolean']['output'];
  /** Reports a comment */
  reportComment: Scalars['Boolean']['output'];
  /** Reports a user post */
  reportUserPost: Scalars['Boolean']['output'];
  resendVerificationMail: ManagementJobModel;
  /** Approve or reject a pending community club onboarding application. Approving triggers Auth0/AWS provisioning (via traintogo-company-registration-flow) and Company/CommunityClub creation automatically. */
  reviewCommunityClubOnboarding: CommunityClubOnboarding;
  /** Revokes a purchase grant that wasn't used yet; refused while the member is paying through it. */
  revokeCommunityEventTicketPurchaseGrant: CommunityEventTicketPurchaseGrant;
  /** Scans a ticket's QR code at the entrance; a valid ticket is used. Rejections are results, not errors: only VALID lets the holder in. */
  scanCommunityEventTicket: CommunityEventTicketScanResult;
  /** Sends the check-in reminder push notification for an event instance to all customers with an active booking. */
  sendCommunityEventCheckinReminder: CommunityEventInstance;
  sendCompanyEmployeePasswordChangeEmail: CompanyEmployee;
  sendContractProposalAfterPayment: SendContractProposalResult;
  /** Finish a training session and generate the checkout session url to pay this session */
  sendEventMessage: Scalars['Boolean']['output'];
  /** Sends reminders for events starting tomorrow. */
  sendEventReminders: Scalars['Float']['output'];
  sendHealthInsuranceEmployeePasswordChangeEmail: HealthInsuranceEmployee;
  /** Send information to MessageBird */
  sendInformationToBird: BirdStatusModel;
  /** Sends a message from the current actor's own personal profile to another profile. */
  sendMessage: Message;
  sendPushNotification: PushNotification;
  sendSurveyToCustomer: Scalars['Boolean']['output'];
  /** Sets the ACS migration status of a single GYM_APP device (by providerDeviceId). */
  setAccessDeviceMigrationStatus: MigrationAccessDevice;
  /** Sets the tags on the company/brand profile (business owner only) */
  setCompanyProfileTags: Profile;
  /** Sets the tags on the current actor's own personal profile (employees only) */
  setMyProfileTags: Profile;
  /** Sets whether a Customer's Profile is permanently featured in the discovery feed (Employee/Business-Owner only, scoped to Customers who are members of a club the actor moderates) */
  setProfileFeaturedForDiscovery: Profile;
  /** Soft delete a promotion code by setting `deleted_at` date. */
  softDeletePromotionCode: PromotionCode;
  /** Public entry point for the community club onboarding wizard to submit a new application for internal review. */
  submitCommunityClubOnboarding: CommunityClubOnboarding;
  /** Syncs a ticket's dispute state from Stripe (payment webhook). */
  syncCommunityEventTicketDispute: Scalars['Boolean']['output'];
  /** Tags a profile as having participated in a workout together. */
  tagWorkoutParticipant: Workout;
  /** Toggle the like of a circle */
  toggleCircleLike: Scalars['Boolean']['output'];
  /** Toggles a comment on a UserPost hidden/visible -- only the parent post author may do this */
  toggleCommentHidden: Scalars['Boolean']['output'];
  /** Toggle the like of a comment */
  toggleCommentLike: Scalars['Boolean']['output'];
  /** Toggle the like of a post */
  toggleCommunityPostLike: Scalars['Boolean']['output'];
  /** Toggle the like of a user post */
  toggleUserPostLike: Scalars['Boolean']['output'];
  /** Unblocks a profile the current actor's own personal profile has blocked. */
  unblockProfile: Scalars['Boolean']['output'];
  /** Unfollows a profile the current actor's own personal profile is following. */
  unfollowProfile: Scalars['Boolean']['output'];
  /** Removes a tagged profile from a workout. */
  untagWorkoutParticipant: Workout;
  updateCommunityClub: CommunityClub;
  updateCommunityClubOnboarding: CommunityClubOnboarding;
  /** Updates one CommunityEventInstance */
  updateCommunityEventInstance: CommunityEventInstance;
  /** Changes a price tier. */
  updateCommunityEventPriceTier: CommunityEventPriceTier;
  /** Changes a ticket sale's settings (sales start, free-ticket quota). */
  updateCommunityEventTicketSale: CommunityEventTicketSale;
  /** Updates one community post */
  updateCommunityPost: CommunityPost;
  /** Updates an Community Post Comment */
  updateCommunityPostComment: CommunityPostComment;
  updateCompany: Company;
  updateCompanyEmployee: CompanyEmployee;
  /** Updates the profile for the current company/brand (business owner only) */
  updateCompanyProfile: Profile;
  updateCoupon: Coupon;
  updateCustomer: Customer;
  updateCustomerBilling: CustomerBilling;
  updateCustomerProfilePicture: Scalars['Boolean']['output'];
  updateEvent: Event;
  updateGym: Gym;
  updateGymAdvantage: GymAdvantage;
  updateGymCategory: GymCategory;
  updateHealthInsurance: HealthInsurance;
  updateHealthInsuranceEmployee: HealthInsuranceEmployee;
  updateHealthInsurancePointsConfig: HealthInsurancePointsConfig;
  updateHealthInsuranceReward: HealthInsuranceReward;
  /** Updates the current actor's own personal profile */
  updateMyProfile: Profile;
  /** Updates one CommunityEvent */
  updateOneCommunityEvent: CommunityEvent;
  /** Updates one CommunityEventLocation */
  updateOneCommunityEventLocation: CommunityEventLocation;
  /** Updates one CommunityEventPartner */
  updateOneCommunityEventPartner: CommunityEventPartner;
  /** Updates open training sessions */
  updateOpenTrainingSessions: UpdateOpenTrainingSessionModel;
  /** Updates one opening hour */
  updateOpeningHour: OpeningHour;
  updatePayoutHistory: PayoutHistory;
  /** Update the statistic of an specific popup period by incrementing views and either clicks or closes based on customers action for the associated popup. */
  updatePopupPeriodStatistic: PopupPeriod;
  updatePromotion: Promotion;
  updateRatingQuestionActiveStatus: RatingQuestion;
  updateRegistrationQuestion: RegistrationQuestion;
  updateRegistrationQuestionOption: RegistrationQuestionOption;
  /** Updates one training session by uniqueInput */
  updateTrainingSession: TrainingSession;
  /** Updates one user post */
  updateUserPost: UserPost;
  /** Updates a comment on a UserPost */
  updateUserPostComment: CommunityPostComment;
  /** Updates one workout */
  updateWorkout: Workout;
};


export type MutationAcceptFollowRequestArgs = {
  requestId: Scalars['String']['input'];
};


export type MutationActivateCommunityEventBookingFromWaitlistArgs = {
  data: CommunityEventBookingUpdateInput;
  where: CommunityEventBookingWhereUniqueInput;
};


export type MutationActivateCommunityEventBookingsFromWaitlistArgs = {
  data: CommunityEventBookingActivateWaitlistInput;
};


export type MutationBlockProfileArgs = {
  profileId: Scalars['String']['input'];
};


export type MutationBookCommunityEventTicketArgs = {
  data: BookCommunityEventTicketInput;
};


export type MutationCancelBookingCompanyArgs = {
  where: EventBookingWhereUniqueInput;
};


export type MutationCancelBookingCustomerArgs = {
  where: EventBookingWhereUniqueInput;
};


export type MutationCancelCommunityEventBookingCustomerArgs = {
  where: CommunityEventBookingWhereUniqueInput;
};


export type MutationCancelCommunityEventBookingManagementArgs = {
  where: CommunityEventBookingWhereUniqueInput;
};


export type MutationCancelCommunityEventTicketAfterRescheduleArgs = {
  data: CancelCommunityEventTicketAfterRescheduleInput;
};


export type MutationCancelCommunityEventTicketBookingArgs = {
  data: CancelCommunityEventTicketBookingInput;
};


export type MutationCancelContractArgs = {
  contractId: Scalars['String']['input'];
};


export type MutationCancelCustomerBillingArgs = {
  data: CustomerBillingCancellationInput;
  where: CustomerBillingWhereUniqueInput;
};


export type MutationCancelEventArgs = {
  where: EventWhereUniqueInput;
};


export type MutationChangeCustomerStateArgs = {
  data: ChangeCustomerStateInput;
  where: CustomerWhereUniqueInput;
};


export type MutationCompleteCommunityEventTicketPaymentArgs = {
  data: CompleteCommunityEventTicketPaymentInput;
};


export type MutationCompleteCompanyBillingPaymentArgs = {
  data: CompleteCompanyBillingPaymentInput;
};


export type MutationCompleteGymHighlightOrderPaymentArgs = {
  data: CompleteGymHighlightOrderPaymentInput;
};


export type MutationConfirmEntryForActiveTrainingArgs = {
  where: ConfirmEntryForActiveTrainingInput;
};


export type MutationCreateBookingArgs = {
  data: EventBookingCreateInput;
};


export type MutationCreateCircleArgs = {
  data: CircleCreateInput;
};


export type MutationCreateCommunityEventBookingArgs = {
  data: CommunityEventBookingCreateInput;
};


export type MutationCreateCommunityEventImageArgs = {
  data: CommunityEventImageCreateInput;
};


export type MutationCreateCommunityEventImagesArgs = {
  data: CommunityEventImagesCreateInput;
};


export type MutationCreateCommunityEventInstanceArgs = {
  data: CommunityEventInstanceCreateInput;
};


export type MutationCreateCommunityEventPriceTierArgs = {
  data: CreateCommunityEventPriceTierInput;
};


export type MutationCreateCommunityEventTicketPurchaseGrantArgs = {
  data: CreateCommunityEventTicketPurchaseGrantInput;
};


export type MutationCreateCommunityPostArgs = {
  data: CommunityPostCreateInput;
};


export type MutationCreateCommunityPostCommentArgs = {
  data: CommunityPostCommentCreateInput;
};


export type MutationCreateCompanyProfileArgs = {
  data: CompanyProfileCreateInput;
};


export type MutationCreateComplimentaryCommunityEventTicketArgs = {
  data: CreateComplimentaryCommunityEventTicketInput;
};


export type MutationCreateCouponArgs = {
  data: CouponCreateInput;
};


export type MutationCreateCustomerArgs = {
  data: CustomerCreateInput;
};


export type MutationCreateCustomerBillingArgs = {
  data: CustomerBillingCreateInput;
};


export type MutationCreateEventArgs = {
  data: EventCreateInput;
};


export type MutationCreateEventsArgs = {
  data: Array<EventCreateInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateGymAdvantageArgs = {
  data: GymAdvantageCreateInput;
};


export type MutationCreateGymCategoryArgs = {
  data: GymCategoryCreateInput;
};


export type MutationCreateGymHighlightOrderArgs = {
  data: CreateGymHighlightOrderInput;
};


export type MutationCreateGymHighlightOrderCheckoutSessionArgs = {
  data: CreateGymHighlightOrderCheckoutSessionInput;
};


export type MutationCreateGymImageArgs = {
  data: GymImageCreateInput;
};


export type MutationCreateHealthInsurancePointsConfigArgs = {
  data: HealthInsurancePointsConfigCreateInput;
};


export type MutationCreateHealthInsuranceRedeemedPointArgs = {
  data: HealthInsuranceRedeemedPointCreateInput;
};


export type MutationCreateHealthInsuranceRewardArgs = {
  data: HealthInsuranceRewardCreateInput;
};


export type MutationCreateManyGymAdvantagesArgs = {
  data: Array<GymAdvantageCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyGymCategoriesArgs = {
  data: Array<GymCategoryCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyGymRatingsArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  data: Array<GymRatingCreateManyInput>;
  gymId: Scalars['String']['input'];
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
  trainingSessionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateMyProfileArgs = {
  data: ProfileCreateInput;
};


export type MutationCreateOneCommunityClubArgs = {
  data: CommunityClubCreateInput;
};


export type MutationCreateOneCommunityEventArgs = {
  data: CommunityEventCreateInput;
};


export type MutationCreateOneCommunityEventLocationArgs = {
  data: CommunityEventLocationCreateInput;
};


export type MutationCreateOneCommunityEventPartnerArgs = {
  data: CommunityEventPartnerCreateInput;
};


export type MutationCreateOneGymArgs = {
  data: GymCreateInput;
};


export type MutationCreateOneOpeningHourArgs = {
  data: OpeningHourCreateInput;
};


export type MutationCreatePayoutHistoryArgs = {
  data: PayoutHistoryCreateInput;
};


export type MutationCreatePopupArgs = {
  data: PopupCreateInput;
};


export type MutationCreatePopupPeriodArgs = {
  data: PopupPeriodCreateNextInput;
};


export type MutationCreatePromotionArgs = {
  data: PromotionCreateInput;
};


export type MutationCreatePromotionCodeArgs = {
  data: PromotionCodeCreateInput;
};


export type MutationCreatePushNotificationArgs = {
  data: PushNotificationCreateInput;
};


export type MutationCreatePushNotificationCommunityClubArgs = {
  data: PushNotificationCreateCommunityClubInput;
};


export type MutationCreateRatingQuestionArgs = {
  data: RatingQuestionCreateInput;
};


export type MutationCreateRatingQuestionsArgs = {
  data: Array<RatingQuestionCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateRegistrationQuestionArgs = {
  data: RegistrationQuestionCreateInput;
};


export type MutationCreateRegistrationQuestionOptionArgs = {
  data: RegistrationQuestionOptionCreateInput;
};


export type MutationCreateTrainingSessionArgs = {
  data: TrainingSessionCreateInput;
};


export type MutationCreateUserPostArgs = {
  data: UserPostCreateInput;
};


export type MutationCreateUserPostCommentArgs = {
  data: UserPostCommentCreateInput;
};


export type MutationCreateWorkoutArgs = {
  data: WorkoutCreateInput;
};


export type MutationDeclineFollowRequestArgs = {
  requestId: Scalars['String']['input'];
};


export type MutationDeleteCircleArgs = {
  where: CircleWhereUniqueInput;
};


export type MutationDeleteCommunityClubArgs = {
  where: CommunityClubWhereUniqueInput;
};


export type MutationDeleteCommunityClubOnboardingArgs = {
  where: CommunityClubOnboardingWhereUniqueInput;
};


export type MutationDeleteCommunityEventArgs = {
  where: CommunityEventWhereUniqueInput;
};


export type MutationDeleteCommunityEventImageArgs = {
  where: CommunityEventImageWhereUniqueInput;
};


export type MutationDeleteCommunityEventInstanceArgs = {
  where: CommunityEventInstanceWhereUniqueInput;
};


export type MutationDeleteCommunityEventLocationArgs = {
  where: CommunityEventLocationWhereUniqueInput;
};


export type MutationDeleteCommunityEventPartnerArgs = {
  where: CommunityEventPartnerWhereUniqueInput;
};


export type MutationDeleteCommunityEventPriceTierArgs = {
  data: DeleteCommunityEventPriceTierInput;
};


export type MutationDeleteCommunityPostArgs = {
  where: CommunityPostWhereUniqueInput;
};


export type MutationDeleteCommunityPostCommentArgs = {
  where: CommunityPostCommentWhereUniqueInput;
};


export type MutationDeleteCompanyArgs = {
  where: CompanyWhereUniqueInput;
};


export type MutationDeleteCompanyEmployeeArgs = {
  email: Scalars['EmailAddress']['input'];
};


export type MutationDeleteConversationArgs = {
  conversationId: Scalars['String']['input'];
};


export type MutationDeleteCouponArgs = {
  where: CouponWhereUniqueInput;
};


export type MutationDeleteCustomerBillingArgs = {
  where: CustomerBillingWhereUniqueInput;
};


export type MutationDeleteGymArgs = {
  where: GymWhereUniqueInput;
};


export type MutationDeleteGymAdvantageArgs = {
  where: GymAdvantageWhereUniqueInput;
};


export type MutationDeleteGymCategoryArgs = {
  where: GymCategoryWhereUniqueInput;
};


export type MutationDeleteGymHighlightOrderArgs = {
  where: GymHighlightOrderWhereUniqueInput;
};


export type MutationDeleteGymImageArgs = {
  where: GymImageWhereUniqueInput;
};


export type MutationDeleteGymRatingArgs = {
  where: GymRatingWhereUniqueInput;
};


export type MutationDeleteHealthInsuranceArgs = {
  where: HealthInsuranceWhereUniqueInput;
};


export type MutationDeleteHealthInsuranceEmployeeArgs = {
  email: Scalars['EmailAddress']['input'];
};


export type MutationDeleteHealthInsurancePointsConfigArgs = {
  where: HealthInsurancePointsConfigWhereUniqueInput;
};


export type MutationDeleteHealthInsuranceRewardArgs = {
  where: HealthInsuranceRewardWhereUniqueInput;
};


export type MutationDeleteMessageArgs = {
  messageId: Scalars['String']['input'];
};


export type MutationDeleteOpeningHourArgs = {
  where: OpeningHourWhereUniqueInput;
};


export type MutationDeletePopupArgs = {
  where: PopupWhereUniqueInput;
};


export type MutationDeletePopupPeriodArgs = {
  where: PopupPeriodWhereUniqueInput;
};


export type MutationDeletePromotionArgs = {
  where: PromotionWhereUniqueInput;
};


export type MutationDeletePushNotificationArgs = {
  where: PushNotificationWhereUniqueInput;
};


export type MutationDeleteRatingQuestionArgs = {
  where: RatingQuestionWhereUniqueInput;
};


export type MutationDeleteRegistrationQuestionArgs = {
  where: RegistrationQuestionWhereUniqueInput;
};


export type MutationDeleteRegistrationQuestionOptionArgs = {
  where: RegistrationQuestionOptionWhereUniqueInput;
};


export type MutationDeleteTrainingSessionArgs = {
  where: TrainingSessionWhereUniqueInput;
};


export type MutationDeleteUserPostArgs = {
  where: UserPostWhereUniqueInput;
};


export type MutationDeleteWorkoutArgs = {
  where: WorkoutWhereUniqueInput;
};


export type MutationDisableGymHighlightOrderArgs = {
  data: DisableGymHighlightOrderInput;
};


export type MutationDisablePopupArgs = {
  where: PopupWhereUniqueInput;
};


export type MutationDisablePushNotificationArgs = {
  pushNotificationId: Scalars['String']['input'];
};


export type MutationDismissReportArgs = {
  reportId: Scalars['String']['input'];
};


export type MutationEnableGymHighlightOrderArgs = {
  data: EnableGymHighlightOrderInput;
};


export type MutationEnablePopupArgs = {
  where: PopupWhereUniqueInput;
};


export type MutationFinishTrainingSessionArgs = {
  data?: InputMaybe<FinishTrainingSessionInput>;
  where: TrainingSessionWhereUniqueInput;
};


export type MutationFollowProfileArgs = {
  profileId: Scalars['String']['input'];
};


export type MutationGenerateContractArgs = {
  customerId: Scalars['String']['input'];
  data: GenerateContractInput;
  gymId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};


export type MutationInviteCompanyEmployeeArgs = {
  communityClubs?: InputMaybe<CommunityClubCreateNestedManyWithoutEmployeesInput>;
  email: Scalars['EmailAddress']['input'];
  gyms?: InputMaybe<GymCreateNestedManyWithoutEmployeesInput>;
};


export type MutationInviteHealthInsuranceEmployeeArgs = {
  email: Scalars['EmailAddress']['input'];
};


export type MutationJoinCommunityClubArgs = {
  where: CommunityClubWhereUniqueInput;
};


export type MutationLeaveCommunityClubArgs = {
  where: CommunityClubWhereUniqueInput;
};


export type MutationMarkActivityReadArgs = {
  activityId: Scalars['String']['input'];
};


export type MutationMarkCircleViewedArgs = {
  id: Scalars['String']['input'];
};


export type MutationMarkConversationReadArgs = {
  conversationId: Scalars['String']['input'];
};


export type MutationMarkFeedSeenArgs = {
  upToPostId: Scalars['String']['input'];
  upToPostedAt: Scalars['DateTime']['input'];
};


export type MutationOpenAccessDeviceAggregatorArgs = {
  where: OpenAccessDeviceManuallyInput;
};


export type MutationOpenAccessDeviceForActiveTrainingArgs = {
  where: OpenAccessDeviceForActiveTrainingInput;
};


export type MutationOpenAccessDeviceManuallyArgs = {
  where: OpenAccessDeviceManuallyInput;
};


export type MutationParticipateCommunityEventBookingCustomerArgs = {
  data: CommunityEventBookingUpdateInput;
  where: CommunityEventBookingWhereUniqueInput;
};


export type MutationProcessScheduledCustomerDeletionArgs = {
  data: Array<CustomerDeleteInput>;
};


export type MutationRefundCommunityEventTicketArgs = {
  data: RefundCommunityEventTicketInput;
};


export type MutationRegisterCompanyArgs = {
  data: RegisterCompanyInput;
};


export type MutationRegisterHealthInsuranceArgs = {
  data: RegisterHealthInsuranceInput;
};


export type MutationRegisterInvitedCompanyEmployeeArgs = {
  data: RegisterCompanyEmployeeInput;
  where: CompanyEmployeeUniqueInput;
};


export type MutationRemoveFollowerArgs = {
  profileId: Scalars['String']['input'];
};


export type MutationReportCommentArgs = {
  communityPostCommentId: Scalars['String']['input'];
};


export type MutationReportUserPostArgs = {
  userPostId: Scalars['String']['input'];
};


export type MutationResendVerificationMailArgs = {
  userId: Scalars['String']['input'];
};


export type MutationReviewCommunityClubOnboardingArgs = {
  data: CommunityClubOnboardingReviewInput;
  where: CommunityClubOnboardingWhereUniqueInput;
};


export type MutationRevokeCommunityEventTicketPurchaseGrantArgs = {
  data: RevokeCommunityEventTicketPurchaseGrantInput;
};


export type MutationScanCommunityEventTicketArgs = {
  data: ScanCommunityEventTicketInput;
};


export type MutationSendCommunityEventCheckinReminderArgs = {
  instanceId: Scalars['String']['input'];
};


export type MutationSendContractProposalAfterPaymentArgs = {
  data: SendContractProposalInput;
};


export type MutationSendEventMessageArgs = {
  createInputMessageBird: BirdInputModel;
  pushToken?: InputMaybe<Scalars['String']['input']>;
  wellyouChannel: Scalars['Boolean']['input'];
};


export type MutationSendInformationToBirdArgs = {
  createInput: BirdInputModel;
};


export type MutationSendMessageArgs = {
  content?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<MessageLocationInput>;
  media?: InputMaybe<Array<MessageMediaInput>>;
  sharedCircleId?: InputMaybe<Scalars['String']['input']>;
  sharedCommunityEventId?: InputMaybe<Scalars['String']['input']>;
  sharedCommunityEventInstanceId?: InputMaybe<Scalars['String']['input']>;
  targetProfileId: Scalars['String']['input'];
};


export type MutationSendPushNotificationArgs = {
  pushNotificationId: Scalars['String']['input'];
};


export type MutationSendSurveyToCustomerArgs = {
  trainingSessionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetAccessDeviceMigrationStatusArgs = {
  data: SetAccessDeviceMigrationStatusInput;
};


export type MutationSetCompanyProfileTagsArgs = {
  tagIds: Array<Scalars['String']['input']>;
};


export type MutationSetMyProfileTagsArgs = {
  tagIds: Array<Scalars['String']['input']>;
};


export type MutationSetProfileFeaturedForDiscoveryArgs = {
  featured: Scalars['Boolean']['input'];
  profileId: Scalars['String']['input'];
};


export type MutationSoftDeletePromotionCodeArgs = {
  promotionCode: Scalars['String']['input'];
};


export type MutationSubmitCommunityClubOnboardingArgs = {
  data: CommunityClubOnboardingSubmitInput;
};


export type MutationSyncCommunityEventTicketDisputeArgs = {
  data: SyncCommunityEventTicketDisputeInput;
};


export type MutationTagWorkoutParticipantArgs = {
  taggedProfileId: Scalars['String']['input'];
  workoutId: Scalars['String']['input'];
};


export type MutationToggleCircleLikeArgs = {
  id: Scalars['String']['input'];
};


export type MutationToggleCommentHiddenArgs = {
  commentId: Scalars['String']['input'];
};


export type MutationToggleCommentLikeArgs = {
  commentId: Scalars['String']['input'];
};


export type MutationToggleCommunityPostLikeArgs = {
  postId: Scalars['String']['input'];
};


export type MutationToggleUserPostLikeArgs = {
  userPostId: Scalars['String']['input'];
};


export type MutationUnblockProfileArgs = {
  profileId: Scalars['String']['input'];
};


export type MutationUnfollowProfileArgs = {
  profileId: Scalars['String']['input'];
};


export type MutationUntagWorkoutParticipantArgs = {
  taggedProfileId: Scalars['String']['input'];
  workoutId: Scalars['String']['input'];
};


export type MutationUpdateCommunityClubArgs = {
  data: CommunityClubUpdateInput;
  where: CommunityClubWhereUniqueInput;
};


export type MutationUpdateCommunityClubOnboardingArgs = {
  data: CommunityClubOnboardingUpdateInput;
  where: CommunityClubOnboardingWhereUniqueInput;
};


export type MutationUpdateCommunityEventInstanceArgs = {
  data: CommunityEventInstanceUpdateInput;
  where: CommunityEventInstanceWhereUniqueInput;
};


export type MutationUpdateCommunityEventPriceTierArgs = {
  data: UpdateCommunityEventPriceTierInput;
};


export type MutationUpdateCommunityEventTicketSaleArgs = {
  data: UpdateCommunityEventTicketSaleInput;
};


export type MutationUpdateCommunityPostArgs = {
  data: CommunityPostUpdateInput;
  where: CommunityPostWhereUniqueInput;
};


export type MutationUpdateCommunityPostCommentArgs = {
  data: CommunityPostCommentUpdateInput;
  where: CommunityPostCommentWhereUniqueInput;
};


export type MutationUpdateCompanyArgs = {
  updateInput: CompanyUpdateInput;
};


export type MutationUpdateCompanyEmployeeArgs = {
  data: CompanyEmployeeUpdateInput;
  where?: InputMaybe<CompanyEmployeeUniqueInput>;
};


export type MutationUpdateCompanyProfileArgs = {
  data: CompanyProfileUpdateInput;
};


export type MutationUpdateCouponArgs = {
  data: CouponUpdateInput;
  where: CouponWhereUniqueInput;
};


export type MutationUpdateCustomerArgs = {
  data: CustomerUpdateInput;
  where?: InputMaybe<CustomerWhereUniqueInput>;
};


export type MutationUpdateCustomerBillingArgs = {
  data: CustomerBillingUpdateInput;
  where: CustomerBillingWhereUniqueInput;
};


export type MutationUpdateCustomerProfilePictureArgs = {
  file: ImageInput;
  userId: Scalars['String']['input'];
};


export type MutationUpdateEventArgs = {
  data: EventUpdateInput;
  where: EventWhereUniqueInput;
};


export type MutationUpdateGymArgs = {
  data: GymUpdateInput;
  where: GymWhereUniqueInput;
};


export type MutationUpdateGymAdvantageArgs = {
  data: GymAdvantageUpdateInput;
  where: GymAdvantageWhereUniqueInput;
};


export type MutationUpdateGymCategoryArgs = {
  data: GymCategoryUpdateInput;
  where: GymCategoryWhereUniqueInput;
};


export type MutationUpdateHealthInsuranceArgs = {
  data: HealthInsuranceUpdateInput;
  where?: InputMaybe<HealthInsuranceWhereUniqueInput>;
};


export type MutationUpdateHealthInsuranceEmployeeArgs = {
  data: HealthInsuranceEmployeeUpdateInput;
  where?: InputMaybe<HealthInsuranceEmployeeUniqueInput>;
};


export type MutationUpdateHealthInsurancePointsConfigArgs = {
  data: HealthInsurancePointsConfigUpdateInput;
  where: HealthInsurancePointsConfigWhereUniqueInput;
};


export type MutationUpdateHealthInsuranceRewardArgs = {
  data: HealthInsuranceRewardUpdateInput;
  where: HealthInsuranceRewardWhereUniqueInput;
};


export type MutationUpdateMyProfileArgs = {
  data: ProfileUpdateInput;
};


export type MutationUpdateOneCommunityEventArgs = {
  data: CommunityEventUpdateInput;
  where: CommunityEventWhereUniqueInput;
};


export type MutationUpdateOneCommunityEventLocationArgs = {
  data: CommunityEventLocationUpdateInput;
  where: CommunityEventLocationWhereUniqueInput;
};


export type MutationUpdateOneCommunityEventPartnerArgs = {
  data: CommunityEventPartnerUpdateInput;
  where: CommunityEventPartnerWhereUniqueInput;
};


export type MutationUpdateOpenTrainingSessionsArgs = {
  updateInput: Array<UpdateOpenTrainingSessionInput>;
};


export type MutationUpdateOpeningHourArgs = {
  data: OpeningHourUpdateInput;
  where: OpeningHourWhereUniqueInput;
};


export type MutationUpdatePayoutHistoryArgs = {
  data: PayoutHistoryUpdateInput;
  where: PayoutHistoryWhereUniqueInput;
};


export type MutationUpdatePopupPeriodStatisticArgs = {
  data: PopupPeriodStatisticUpdateInput;
  where: PopupPeriodWhereUniqueInput;
};


export type MutationUpdatePromotionArgs = {
  data: PromotionUpdateInput;
  where: PromotionWhereUniqueInput;
};


export type MutationUpdateRatingQuestionActiveStatusArgs = {
  data: RatingQuestionActiveStatusUpdateInput;
  where: RatingQuestionWhereUniqueInput;
};


export type MutationUpdateRegistrationQuestionArgs = {
  data: RegistrationQuestionUpdateInput;
  where: RegistrationQuestionWhereUniqueInput;
};


export type MutationUpdateRegistrationQuestionOptionArgs = {
  data: RegistrationQuestionOptionUpdateInput;
  where: RegistrationQuestionOptionWhereUniqueInput;
};


export type MutationUpdateTrainingSessionArgs = {
  data: TrainingSessionUpdateInput;
  where: TrainingSessionWhereUniqueInput;
};


export type MutationUpdateUserPostArgs = {
  data: UserPostUpdateInput;
  where: UserPostWhereUniqueInput;
};


export type MutationUpdateUserPostCommentArgs = {
  data: CommunityPostCommentUpdateInput;
  where: CommunityPostCommentWhereUniqueInput;
};


export type MutationUpdateWorkoutArgs = {
  data: WorkoutUpdateInput;
  where: WorkoutWhereUniqueInput;
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** Input for nested creation of employee by registering a company */
export type NestedEmployeeCreateWithoutCompanyInput = {
  communityClubs?: InputMaybe<CommunityClubCreateNestedManyWithoutEmployeesInput>;
  communityPosts?: InputMaybe<CommunityPostCreateNestedManyWithoutAuthorInput>;
  email: Scalars['EmailAddress']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  gyms?: InputMaybe<GymCreateNestedManyWithoutEmployeesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EmployeeStatus>;
  userType?: InputMaybe<EmployeeUserType>;
};

/** Input for nested creation of employee by registering a company */
export type NestedEmployeeCreateWithoutHealthInsuranceInput = {
  email: Scalars['EmailAddress']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EmployeeStatus>;
  userType?: InputMaybe<EmployeeUserType>;
};

export type NestedEnumAccessProviderFilter = {
  equals?: InputMaybe<AccessProvider>;
  in?: InputMaybe<Array<AccessProvider>>;
  not?: InputMaybe<NestedEnumAccessProviderFilter>;
  notIn?: InputMaybe<Array<AccessProvider>>;
};

export type NestedEnumActivityTypeFilter = {
  equals?: InputMaybe<ActivityType>;
  in?: InputMaybe<Array<ActivityType>>;
  not?: InputMaybe<NestedEnumActivityTypeFilter>;
  notIn?: InputMaybe<Array<ActivityType>>;
};

export type NestedEnumBillingStatusFilter = {
  equals?: InputMaybe<BillingStatus>;
  in?: InputMaybe<Array<BillingStatus>>;
  not?: InputMaybe<NestedEnumBillingStatusFilter>;
  notIn?: InputMaybe<Array<BillingStatus>>;
};

export type NestedEnumCommunityEventBookingStatusFilter = {
  equals?: InputMaybe<CommunityEventBookingStatus>;
  in?: InputMaybe<Array<CommunityEventBookingStatus>>;
  not?: InputMaybe<NestedEnumCommunityEventBookingStatusFilter>;
  notIn?: InputMaybe<Array<CommunityEventBookingStatus>>;
};

export type NestedEnumCommunityEventTicketReservationStatusFilter = {
  equals?: InputMaybe<CommunityEventTicketReservationStatus>;
  in?: InputMaybe<Array<CommunityEventTicketReservationStatus>>;
  not?: InputMaybe<NestedEnumCommunityEventTicketReservationStatusFilter>;
  notIn?: InputMaybe<Array<CommunityEventTicketReservationStatus>>;
};

export type NestedEnumCommunityEventTicketSourceFilter = {
  equals?: InputMaybe<CommunityEventTicketSource>;
  in?: InputMaybe<Array<CommunityEventTicketSource>>;
  not?: InputMaybe<NestedEnumCommunityEventTicketSourceFilter>;
  notIn?: InputMaybe<Array<CommunityEventTicketSource>>;
};

export type NestedEnumCommunityEventTicketStatusFilter = {
  equals?: InputMaybe<CommunityEventTicketStatus>;
  in?: InputMaybe<Array<CommunityEventTicketStatus>>;
  not?: InputMaybe<NestedEnumCommunityEventTicketStatusFilter>;
  notIn?: InputMaybe<Array<CommunityEventTicketStatus>>;
};

export type NestedEnumCommunityEventTicketStatusNullableFilter = {
  equals?: InputMaybe<CommunityEventTicketStatus>;
  in?: InputMaybe<Array<CommunityEventTicketStatus>>;
  not?: InputMaybe<NestedEnumCommunityEventTicketStatusNullableFilter>;
  notIn?: InputMaybe<Array<CommunityEventTicketStatus>>;
};

export type NestedEnumCompanyBillingSourceFilter = {
  equals?: InputMaybe<CompanyBillingSource>;
  in?: InputMaybe<Array<CompanyBillingSource>>;
  not?: InputMaybe<NestedEnumCompanyBillingSourceFilter>;
  notIn?: InputMaybe<Array<CompanyBillingSource>>;
};

export type NestedEnumConsumerBillingSourceFilter = {
  equals?: InputMaybe<ConsumerBillingSource>;
  in?: InputMaybe<Array<ConsumerBillingSource>>;
  not?: InputMaybe<NestedEnumConsumerBillingSourceFilter>;
  notIn?: InputMaybe<Array<ConsumerBillingSource>>;
};

export type NestedEnumCronIntervalNullableFilter = {
  equals?: InputMaybe<CronInterval>;
  in?: InputMaybe<Array<CronInterval>>;
  not?: InputMaybe<NestedEnumCronIntervalNullableFilter>;
  notIn?: InputMaybe<Array<CronInterval>>;
};

export type NestedEnumCustomerTypeFilter = {
  equals?: InputMaybe<CustomerType>;
  in?: InputMaybe<Array<CustomerType>>;
  not?: InputMaybe<NestedEnumCustomerTypeFilter>;
  notIn?: InputMaybe<Array<CustomerType>>;
};

export type NestedEnumEmployeeStatusFilter = {
  equals?: InputMaybe<EmployeeStatus>;
  in?: InputMaybe<Array<EmployeeStatus>>;
  not?: InputMaybe<NestedEnumEmployeeStatusFilter>;
  notIn?: InputMaybe<Array<EmployeeStatus>>;
};

export type NestedEnumEmployeeUserTypeFilter = {
  equals?: InputMaybe<EmployeeUserType>;
  in?: InputMaybe<Array<EmployeeUserType>>;
  not?: InputMaybe<NestedEnumEmployeeUserTypeFilter>;
  notIn?: InputMaybe<Array<EmployeeUserType>>;
};

export type NestedEnumEventBookingStatusFilter = {
  equals?: InputMaybe<EventBookingStatus>;
  in?: InputMaybe<Array<EventBookingStatus>>;
  not?: InputMaybe<NestedEnumEventBookingStatusFilter>;
  notIn?: InputMaybe<Array<EventBookingStatus>>;
};

export type NestedEnumFollowRequestStatusFilter = {
  equals?: InputMaybe<FollowRequestStatus>;
  in?: InputMaybe<Array<FollowRequestStatus>>;
  not?: InputMaybe<NestedEnumFollowRequestStatusFilter>;
  notIn?: InputMaybe<Array<FollowRequestStatus>>;
};

export type NestedEnumFreeMinuteTypeFilter = {
  equals?: InputMaybe<FreeMinuteType>;
  in?: InputMaybe<Array<FreeMinuteType>>;
  not?: InputMaybe<NestedEnumFreeMinuteTypeFilter>;
  notIn?: InputMaybe<Array<FreeMinuteType>>;
};

export type NestedEnumGymTypeFilter = {
  equals?: InputMaybe<GymType>;
  in?: InputMaybe<Array<GymType>>;
  not?: InputMaybe<NestedEnumGymTypeFilter>;
  notIn?: InputMaybe<Array<GymType>>;
};

export type NestedEnumMediaTypeFilter = {
  equals?: InputMaybe<MediaType>;
  in?: InputMaybe<Array<MediaType>>;
  not?: InputMaybe<NestedEnumMediaTypeFilter>;
  notIn?: InputMaybe<Array<MediaType>>;
};

export type NestedEnumMediaTypeNullableFilter = {
  equals?: InputMaybe<MediaType>;
  in?: InputMaybe<Array<MediaType>>;
  not?: InputMaybe<NestedEnumMediaTypeNullableFilter>;
  notIn?: InputMaybe<Array<MediaType>>;
};

export type NestedEnumPointCollectionMethodFilter = {
  equals?: InputMaybe<PointCollectionMethod>;
  in?: InputMaybe<Array<PointCollectionMethod>>;
  not?: InputMaybe<NestedEnumPointCollectionMethodFilter>;
  notIn?: InputMaybe<Array<PointCollectionMethod>>;
};

export type NestedEnumPopupTypeFilter = {
  equals?: InputMaybe<PopupType>;
  in?: InputMaybe<Array<PopupType>>;
  not?: InputMaybe<NestedEnumPopupTypeFilter>;
  notIn?: InputMaybe<Array<PopupType>>;
};

export type NestedEnumPostScopeFilter = {
  equals?: InputMaybe<PostScope>;
  in?: InputMaybe<Array<PostScope>>;
  not?: InputMaybe<NestedEnumPostScopeFilter>;
  notIn?: InputMaybe<Array<PostScope>>;
};

export type NestedEnumProfileOwnerTypeFilter = {
  equals?: InputMaybe<ProfileOwnerType>;
  in?: InputMaybe<Array<ProfileOwnerType>>;
  not?: InputMaybe<NestedEnumProfileOwnerTypeFilter>;
  notIn?: InputMaybe<Array<ProfileOwnerType>>;
};

export type NestedEnumPushNotificationSendTypeFilter = {
  equals?: InputMaybe<PushNotificationSendType>;
  in?: InputMaybe<Array<PushNotificationSendType>>;
  not?: InputMaybe<NestedEnumPushNotificationSendTypeFilter>;
  notIn?: InputMaybe<Array<PushNotificationSendType>>;
};

export type NestedEnumPushNotificationStatusFilter = {
  equals?: InputMaybe<PushNotificationStatus>;
  in?: InputMaybe<Array<PushNotificationStatus>>;
  not?: InputMaybe<NestedEnumPushNotificationStatusFilter>;
  notIn?: InputMaybe<Array<PushNotificationStatus>>;
};

export type NestedEnumRatingQuestionTypeFilter = {
  equals?: InputMaybe<RatingQuestionType>;
  in?: InputMaybe<Array<RatingQuestionType>>;
  not?: InputMaybe<NestedEnumRatingQuestionTypeFilter>;
  notIn?: InputMaybe<Array<RatingQuestionType>>;
};

export type NestedEnumRecurrenceEndTypeNullableFilter = {
  equals?: InputMaybe<RecurrenceEndType>;
  in?: InputMaybe<Array<RecurrenceEndType>>;
  not?: InputMaybe<NestedEnumRecurrenceEndTypeNullableFilter>;
  notIn?: InputMaybe<Array<RecurrenceEndType>>;
};

export type NestedEnumRecurrenceFrequencyNullableFilter = {
  equals?: InputMaybe<RecurrenceFrequency>;
  in?: InputMaybe<Array<RecurrenceFrequency>>;
  not?: InputMaybe<NestedEnumRecurrenceFrequencyNullableFilter>;
  notIn?: InputMaybe<Array<RecurrenceFrequency>>;
};

export type NestedEnumRecurrenceMonthOptionNullableFilter = {
  equals?: InputMaybe<RecurrenceMonthOption>;
  in?: InputMaybe<Array<RecurrenceMonthOption>>;
  not?: InputMaybe<NestedEnumRecurrenceMonthOptionNullableFilter>;
  notIn?: InputMaybe<Array<RecurrenceMonthOption>>;
};

export type NestedEnumRegistrationQuestionTypeFilter = {
  equals?: InputMaybe<RegistrationQuestionType>;
  in?: InputMaybe<Array<RegistrationQuestionType>>;
  not?: InputMaybe<NestedEnumRegistrationQuestionTypeFilter>;
  notIn?: InputMaybe<Array<RegistrationQuestionType>>;
};

export type NestedEnumTrainingFinishReasonNullableFilter = {
  equals?: InputMaybe<TrainingFinishReason>;
  in?: InputMaybe<Array<TrainingFinishReason>>;
  not?: InputMaybe<NestedEnumTrainingFinishReasonNullableFilter>;
  notIn?: InputMaybe<Array<TrainingFinishReason>>;
};

export type NestedEnumTrainingFinishTypeFilter = {
  equals?: InputMaybe<TrainingFinishType>;
  in?: InputMaybe<Array<TrainingFinishType>>;
  not?: InputMaybe<NestedEnumTrainingFinishTypeFilter>;
  notIn?: InputMaybe<Array<TrainingFinishType>>;
};

export type NestedEnumUserPostTypeFilter = {
  equals?: InputMaybe<UserPostType>;
  in?: InputMaybe<Array<UserPostType>>;
  not?: InputMaybe<NestedEnumUserPostTypeFilter>;
  notIn?: InputMaybe<Array<UserPostType>>;
};

export type NestedEnumWorkoutProviderFilter = {
  equals?: InputMaybe<WorkoutProvider>;
  in?: InputMaybe<Array<WorkoutProvider>>;
  not?: InputMaybe<NestedEnumWorkoutProviderFilter>;
  notIn?: InputMaybe<Array<WorkoutProvider>>;
};

export type NestedEnumWorkoutTypeFilter = {
  equals?: InputMaybe<WorkoutType>;
  in?: InputMaybe<Array<WorkoutType>>;
  not?: InputMaybe<NestedEnumWorkoutTypeFilter>;
  notIn?: InputMaybe<Array<WorkoutType>>;
};

export type NestedEnumWorkoutVisibilityFilter = {
  equals?: InputMaybe<WorkoutVisibility>;
  in?: InputMaybe<Array<WorkoutVisibility>>;
  not?: InputMaybe<NestedEnumWorkoutVisibilityFilter>;
  notIn?: InputMaybe<Array<WorkoutVisibility>>;
};

export type NestedFloatFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedFloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedUuidFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedUuidFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NestedUuidNullableFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedUuidNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum NullsOrder {
  First = 'first',
  Last = 'last'
}

export enum OnlinePaymentType {
  DirectPayment = 'DIRECT_PAYMENT',
  None = 'NONE'
}

export type OpenAccessDevice = OpenAccessDeviceBeIn | OpenAccessDeviceEvo | OpenAccessDeviceGymApp;

/** Open access device result for be-in devices */
export type OpenAccessDeviceBeIn = {
  __typename: 'OpenAccessDeviceBeIn';
  /** ISO 8601 timestamp when QR code expires */
  expiresAt: Scalars['String']['output'];
  /** External request ID */
  externalRequestId?: Maybe<Scalars['String']['output']>;
  /** Base64 encoded PNG image data */
  imagePng: Scalars['String']['output'];
  requestId: Scalars['UUID']['output'];
};

/** Open access device result for evo devices */
export type OpenAccessDeviceEvo = {
  __typename: 'OpenAccessDeviceEvo';
  /** The access code to open door */
  accessCode: Scalars['String']['output'];
  requestId: Scalars['UUID']['output'];
};

export type OpenAccessDeviceForActiveTrainingInput = {
  /** The specific access device to open, selected by the client (e.g. one of several doors ordered by sortOrder). When omitted, the first active device supporting the direction is used — kept for backward compatibility. */
  deviceId?: InputMaybe<Scalars['UUID']['input']>;
  direction: AccessDirection;
  gymId: Scalars['UUID']['input'];
};

/** Open access device result for GymApp devices */
export type OpenAccessDeviceGymApp = {
  __typename: 'OpenAccessDeviceGymApp';
  requestId: Scalars['UUID']['output'];
};

export type OpenAccessDeviceManuallyInput = {
  deviceId: Scalars['UUID']['input'];
  direction: AccessDirection;
  /** Gym the device belongs to (the ACS externalGymId). Required to open an ACS-backed device that has no TrainToGo row (post-migration cleanup); ignored when a TrainToGo row still exists. */
  gymId?: InputMaybe<Scalars['UUID']['input']>;
  /** The source that requested the access */
  source?: InputMaybe<Scalars['String']['input']>;
};

export type OpeningHour = {
  __typename: 'OpeningHour';
  /** Closing time of the gym */
  close: Scalars['DateTime']['output'];
  /** 1 = Monday, 2 = Thusday, ... 7 = Sunday */
  day: Scalars['Int']['output'];
  /** The gym associated with the opening hour. */
  gym: Gym;
  /** The unique identifier of the opening hour. A day can have several non-overlapping opening hours. */
  id: Scalars['UUID']['output'];
  /** Opening time of the gym */
  open: Scalars['DateTime']['output'];
};

export type OpeningHourAvgAggregate = {
  __typename: 'OpeningHourAvgAggregate';
  day?: Maybe<Scalars['Float']['output']>;
};

export type OpeningHourCountAggregate = {
  __typename: 'OpeningHourCountAggregate';
  _all: Scalars['Int']['output'];
  close: Scalars['Int']['output'];
  day: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  open: Scalars['Int']['output'];
};

export type OpeningHourCreateInput = {
  close: Scalars['DateTime']['input'];
  day?: InputMaybe<Scalars['Int']['input']>;
  gym: GymCreateNestedOneWithoutOpeningHoursInput;
  open: Scalars['DateTime']['input'];
};

export type OpeningHourCreateNestedManyWithoutGymInput = {
  connect?: InputMaybe<Array<OpeningHourWhereUniqueInput>>;
};

export type OpeningHourListRelationFilter = {
  every?: InputMaybe<OpeningHourWhereInput>;
  none?: InputMaybe<OpeningHourWhereInput>;
  some?: InputMaybe<OpeningHourWhereInput>;
};

export type OpeningHourMaxAggregate = {
  __typename: 'OpeningHourMaxAggregate';
  close?: Maybe<Scalars['DateTime']['output']>;
  day?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  open?: Maybe<Scalars['DateTime']['output']>;
};

export type OpeningHourMinAggregate = {
  __typename: 'OpeningHourMinAggregate';
  close?: Maybe<Scalars['DateTime']['output']>;
  day?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  open?: Maybe<Scalars['DateTime']['output']>;
};

export type OpeningHourOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OpeningHourOrderByWithRelationInput = {
  close?: InputMaybe<SortOrder>;
  day?: InputMaybe<SortOrder>;
  gym?: InputMaybe<GymOrderByWithRelationInput>;
  gymId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  open?: InputMaybe<SortOrder>;
};

export enum OpeningHourScalarFieldEnum {
  Close = 'close',
  CompanyId = 'companyId',
  Day = 'day',
  GymId = 'gymId',
  Id = 'id',
  Open = 'open'
}

export type OpeningHourSumAggregate = {
  __typename: 'OpeningHourSumAggregate';
  day?: Maybe<Scalars['Int']['output']>;
};

export type OpeningHourUpdateInput = {
  close?: InputMaybe<Scalars['DateTime']['input']>;
  day?: InputMaybe<Scalars['Int']['input']>;
  open?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OpeningHourUpdateManyWithoutGymNestedInput = {
  connect?: InputMaybe<Array<OpeningHourWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<OpeningHourWhereUniqueInput>>;
};

export type OpeningHourWhereInput = {
  AND?: InputMaybe<Array<OpeningHourWhereInput>>;
  NOT?: InputMaybe<Array<OpeningHourWhereInput>>;
  OR?: InputMaybe<Array<OpeningHourWhereInput>>;
  close?: InputMaybe<DateTimeFilter>;
  day?: InputMaybe<IntFilter>;
  gym?: InputMaybe<GymScalarRelationFilter>;
  gymId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  open?: InputMaybe<DateTimeFilter>;
};

export type OpeningHourWhereUniqueInput = {
  AND?: InputMaybe<Array<OpeningHourWhereInput>>;
  NOT?: InputMaybe<Array<OpeningHourWhereInput>>;
  OR?: InputMaybe<Array<OpeningHourWhereInput>>;
  close?: InputMaybe<DateTimeFilter>;
  day?: InputMaybe<IntFilter>;
  gym?: InputMaybe<GymScalarRelationFilter>;
  gymId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  open?: InputMaybe<DateTimeFilter>;
};

export type PaginatedActivity = {
  __typename: 'PaginatedActivity';
  edges?: Maybe<Array<ActivityEdge>>;
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<Activity>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedActivityCursor = {
  __typename: 'PaginatedActivityCursor';
  id?: Maybe<Scalars['UUID']['output']>;
};

export type PaginatedCircleViewer = {
  __typename: 'PaginatedCircleViewer';
  edges?: Maybe<Array<CircleViewerEdge>>;
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<CircleViewer>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedCircleViewerCursor = {
  __typename: 'PaginatedCircleViewerCursor';
  id?: Maybe<Scalars['UUID']['output']>;
};

export type PaginatedCommunityEventTicket = {
  __typename: 'PaginatedCommunityEventTicket';
  edges?: Maybe<Array<CommunityEventTicketEdge>>;
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<CommunityEventTicket>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedCommunityEventTicketCursor = {
  __typename: 'PaginatedCommunityEventTicketCursor';
  id?: Maybe<Scalars['UUID']['output']>;
};

export type PaginatedConversation = {
  __typename: 'PaginatedConversation';
  edges?: Maybe<Array<ConversationEdge>>;
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<Conversation>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedConversationCursor = {
  __typename: 'PaginatedConversationCursor';
  id?: Maybe<Scalars['UUID']['output']>;
};

export type PaginatedCustomers = {
  __typename: 'PaginatedCustomers';
  edges?: Maybe<Array<CustomerEdge>>;
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<Customer>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedCustomersCursor = {
  __typename: 'PaginatedCustomersCursor';
  email?: Maybe<Scalars['EmailAddress']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
};

export type PaginatedEventbookings = {
  __typename: 'PaginatedEventbookings';
  edges?: Maybe<Array<EventBookingEdge>>;
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<EventBooking>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedEventbookingsCursor = {
  __typename: 'PaginatedEventbookingsCursor';
  id?: Maybe<Scalars['UUID']['output']>;
};

export type PaginatedFollow = {
  __typename: 'PaginatedFollow';
  edges?: Maybe<Array<FollowEdge>>;
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<Follow>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedFollowCursor = {
  __typename: 'PaginatedFollowCursor';
  id?: Maybe<Scalars['UUID']['output']>;
};

export type PaginatedGymRating = {
  __typename: 'PaginatedGymRating';
  edges?: Maybe<Array<GymRatingEdge>>;
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<GymRating>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedGymRatingCursor = {
  __typename: 'PaginatedGymRatingCursor';
  id?: Maybe<Scalars['UUID']['output']>;
};

export type PaginatedLiker = {
  __typename: 'PaginatedLiker';
  edges?: Maybe<Array<ProfileEdge>>;
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<Profile>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedLikerCursor = {
  __typename: 'PaginatedLikerCursor';
  id?: Maybe<Scalars['UUID']['output']>;
};

export type PaginatedMessage = {
  __typename: 'PaginatedMessage';
  edges?: Maybe<Array<MessageEdge>>;
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<Message>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedMessageCursor = {
  __typename: 'PaginatedMessageCursor';
  id?: Maybe<Scalars['UUID']['output']>;
};

export type PaginatedTrainings = {
  __typename: 'PaginatedTrainings';
  edges?: Maybe<Array<TrainingSessionEdge>>;
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<TrainingSession>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedTrainingsCursor = {
  __typename: 'PaginatedTrainingsCursor';
  id?: Maybe<Scalars['UUID']['output']>;
};

export type PaginatedWorkout = {
  __typename: 'PaginatedWorkout';
  edges?: Maybe<Array<WorkoutEdge>>;
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<Workout>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedWorkoutCursor = {
  __typename: 'PaginatedWorkoutCursor';
  id?: Maybe<Scalars['UUID']['output']>;
};

export enum PaymentChoice {
  BankTransfer = 'BANK_TRANSFER',
  Cash = 'CASH',
  CreditCard = 'CREDIT_CARD',
  DirectDebit = 'DIRECT_DEBIT',
  Twint = 'TWINT'
}

export enum PaymentChoiceContract {
  BankTransfer = 'BANK_TRANSFER',
  Cash = 'CASH',
  CreditCard = 'CREDIT_CARD',
  DirectDebit = 'DIRECT_DEBIT',
  Twint = 'TWINT'
}

export type PaymentFrequencyDto = {
  __typename: 'PaymentFrequencyDto';
  money: MoneyDto;
  recurring: Scalars['Boolean']['output'];
  term?: Maybe<TermDto>;
  type: PaymentFrequencyType;
};

export enum PaymentFrequencyType {
  Free = 'FREE',
  MonthDay = 'MONTH_DAY',
  NonRecurring = 'NON_RECURRING',
  Recurring = 'RECURRING',
  TermBased = 'TERM_BASED'
}

export type PayoutHistory = {
  __typename: 'PayoutHistory';
  /** The date and time when the configuration was created. */
  createdAt: Scalars['DateTime']['output'];
  gym: Gym;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The total amount of the payout */
  payoutAmount: Scalars['Float']['output'];
  /** The S3 URL to the payout pdf file */
  payoutPdfUrl?: Maybe<Scalars['String']['output']>;
  /** The date and time when the configuration was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type PayoutHistoryAvgAggregate = {
  __typename: 'PayoutHistoryAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  payoutAmount?: Maybe<Scalars['Float']['output']>;
};

export type PayoutHistoryCountAggregate = {
  __typename: 'PayoutHistoryCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  payoutAmount: Scalars['Int']['output'];
  payoutPdfUrl: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

/** Input for creating one payout history entry */
export type PayoutHistoryCreateInput = {
  gym: GymCreateNestedOneWithoutPayoutHistoryInput;
  payoutAmount: Scalars['Float']['input'];
  payoutPdfUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PayoutHistoryListRelationFilter = {
  every?: InputMaybe<PayoutHistoryWhereInput>;
  none?: InputMaybe<PayoutHistoryWhereInput>;
  some?: InputMaybe<PayoutHistoryWhereInput>;
};

export type PayoutHistoryMaxAggregate = {
  __typename: 'PayoutHistoryMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  payoutAmount?: Maybe<Scalars['Float']['output']>;
  payoutPdfUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PayoutHistoryMinAggregate = {
  __typename: 'PayoutHistoryMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  payoutAmount?: Maybe<Scalars['Float']['output']>;
  payoutPdfUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PayoutHistoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PayoutHistoryOrderByWithRelationInput = {
  gym?: InputMaybe<GymOrderByWithRelationInput>;
  gymId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  payoutAmount?: InputMaybe<SortOrder>;
  payoutPdfUrl?: InputMaybe<SortOrderInput>;
};

export enum PayoutHistoryScalarFieldEnum {
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  GymId = 'gymId',
  Id = 'id',
  PayoutAmount = 'payoutAmount',
  PayoutPdfUrl = 'payoutPdfUrl',
  UpdatedAt = 'updatedAt'
}

export type PayoutHistorySumAggregate = {
  __typename: 'PayoutHistorySumAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  payoutAmount?: Maybe<Scalars['Float']['output']>;
};

/** Input for updating one payout history entry */
export type PayoutHistoryUpdateInput = {
  payoutPdfUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PayoutHistoryUpdateManyWithoutGymNestedInput = {
  connect?: InputMaybe<Array<PayoutHistoryWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<PayoutHistoryWhereUniqueInput>>;
};

export type PayoutHistoryWhereInput = {
  AND?: InputMaybe<Array<PayoutHistoryWhereInput>>;
  NOT?: InputMaybe<Array<PayoutHistoryWhereInput>>;
  OR?: InputMaybe<Array<PayoutHistoryWhereInput>>;
  gym?: InputMaybe<GymScalarRelationFilter>;
  gymId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<IntFilter>;
  payoutAmount?: InputMaybe<FloatFilter>;
  payoutPdfUrl?: InputMaybe<StringNullableFilter>;
};

export type PayoutHistoryWhereUniqueInput = {
  AND?: InputMaybe<Array<PayoutHistoryWhereInput>>;
  NOT?: InputMaybe<Array<PayoutHistoryWhereInput>>;
  OR?: InputMaybe<Array<PayoutHistoryWhereInput>>;
  gym?: InputMaybe<GymScalarRelationFilter>;
  gymId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  payoutAmount?: InputMaybe<FloatFilter>;
  payoutPdfUrl?: InputMaybe<StringNullableFilter>;
};

/** A page of the personal feed (Follow-Graph + Community Clubs). */
export type PersonalFeedResponse = {
  __typename: 'PersonalFeedResponse';
  /** Whether any item newer than the current FeedCheckpoint exists, independent of pagination. */
  hasNewPosts: Scalars['Boolean']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  items: Array<FeedItem>;
  /** Pass to PersonalFeedArgs.cursor to fetch the next page. */
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export enum PointCollectionMethod {
  PerMinute = 'PER_MINUTE',
  PerSession = 'PER_SESSION'
}

export type Popup = {
  __typename: 'Popup';
  /** Indicator whether this popup is currently active */
  active: Scalars['Boolean']['output'];
  /** The URL the user will be redirected to after clicking the popup */
  clickUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** An optional description for the popup */
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  /** Seconds the popup (type force) is locked before it becomes dismissible */
  lockTime: Scalars['Float']['output'];
  /** The type of the media element attached to the popup (e.g. image, gif, or video) */
  mediaType: MediaType;
  /** The URL pointing to the media file used in the popup */
  mediaUrl?: Maybe<Scalars['String']['output']>;
  /** An optional name for the popup */
  name?: Maybe<Scalars['String']['output']>;
  /** The periods of this popup */
  periods?: Maybe<Array<PopupPeriod>>;
  /** The type of the popup (simple, or force (close lock for x seconds) ) */
  type: PopupType;
  updatedAt: Scalars['DateTime']['output'];
};


export type PopupPeriodsArgs = {
  cursor?: InputMaybe<PopupPeriodWhereUniqueInput>;
  distinct?: InputMaybe<Array<PopupPeriodScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PopupPeriodOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PopupPeriodWhereInput>;
};

export type PopupAvgAggregate = {
  __typename: 'PopupAvgAggregate';
  lockTime?: Maybe<Scalars['Float']['output']>;
};

export type PopupCountAggregate = {
  __typename: 'PopupCountAggregate';
  _all: Scalars['Int']['output'];
  active: Scalars['Int']['output'];
  clickUrl: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lockTime: Scalars['Int']['output'];
  mediaType: Scalars['Int']['output'];
  mediaUrl: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

/** Input for creating a popup */
export type PopupCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  clickUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  lockTime?: InputMaybe<Scalars['Float']['input']>;
  /** Input for uploading or linking an image for this popup */
  media: ImageInput;
  mediaType?: InputMaybe<MediaType>;
  mediaUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Specify the period for the popup */
  period: PopupPeriodCreateInput;
  type?: InputMaybe<PopupType>;
};

export type PopupCreateNestedOneWithoutPeriodsInput = {
  connect: PopupWhereUniqueInput;
};

export type PopupMaxAggregate = {
  __typename: 'PopupMaxAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  clickUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  lockTime?: Maybe<Scalars['Float']['output']>;
  mediaType?: Maybe<MediaType>;
  mediaUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PopupType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PopupMinAggregate = {
  __typename: 'PopupMinAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  clickUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  lockTime?: Maybe<Scalars['Float']['output']>;
  mediaType?: Maybe<MediaType>;
  mediaUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PopupType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PopupOrderByWithRelationInput = {
  active?: InputMaybe<SortOrder>;
  clickUrl?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  lockTime?: InputMaybe<SortOrder>;
  mediaType?: InputMaybe<SortOrder>;
  mediaUrl?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrderInput>;
  periods?: InputMaybe<PopupPeriodOrderByRelationAggregateInput>;
  type?: InputMaybe<SortOrder>;
};

export type PopupPeriod = {
  __typename: 'PopupPeriod';
  /** The startdate at which this popup should be visible */
  activeFrom: Scalars['DateTime']['output'];
  /** The enddate of this popup to be visible */
  activeUntil: Scalars['DateTime']['output'];
  /** The current number of clicks for this popup */
  clicks: Scalars['Int']['output'];
  /** The current number of closes for this popup */
  closes: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  popup: Popup;
  popupId: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** The current number of total views for this popup */
  views: Scalars['Int']['output'];
};

export type PopupPeriodAvgAggregate = {
  __typename: 'PopupPeriodAvgAggregate';
  clicks?: Maybe<Scalars['Float']['output']>;
  closes?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

export type PopupPeriodCountAggregate = {
  __typename: 'PopupPeriodCountAggregate';
  _all: Scalars['Int']['output'];
  activeFrom: Scalars['Int']['output'];
  activeUntil: Scalars['Int']['output'];
  clicks: Scalars['Int']['output'];
  closes: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  popupId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  views: Scalars['Int']['output'];
};

/** Input for creating a popup period */
export type PopupPeriodCreateInput = {
  activeFrom: Scalars['DateTime']['input'];
  activeUntil: Scalars['DateTime']['input'];
};

/** Input for creating a popup period */
export type PopupPeriodCreateNextInput = {
  activeFrom: Scalars['DateTime']['input'];
  activeUntil: Scalars['DateTime']['input'];
  popup: PopupCreateNestedOneWithoutPeriodsInput;
};

export type PopupPeriodListRelationFilter = {
  every?: InputMaybe<PopupPeriodWhereInput>;
  none?: InputMaybe<PopupPeriodWhereInput>;
  some?: InputMaybe<PopupPeriodWhereInput>;
};

export type PopupPeriodMaxAggregate = {
  __typename: 'PopupPeriodMaxAggregate';
  activeFrom?: Maybe<Scalars['DateTime']['output']>;
  activeUntil?: Maybe<Scalars['DateTime']['output']>;
  clicks?: Maybe<Scalars['Int']['output']>;
  closes?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  popupId?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

export type PopupPeriodMinAggregate = {
  __typename: 'PopupPeriodMinAggregate';
  activeFrom?: Maybe<Scalars['DateTime']['output']>;
  activeUntil?: Maybe<Scalars['DateTime']['output']>;
  clicks?: Maybe<Scalars['Int']['output']>;
  closes?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  popupId?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

export type PopupPeriodOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PopupPeriodOrderByWithRelationInput = {
  activeFrom?: InputMaybe<SortOrder>;
  activeUntil?: InputMaybe<SortOrder>;
  clicks?: InputMaybe<SortOrder>;
  closes?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  popup?: InputMaybe<PopupOrderByWithRelationInput>;
  views?: InputMaybe<SortOrder>;
};

export enum PopupPeriodScalarFieldEnum {
  ActiveFrom = 'activeFrom',
  ActiveUntil = 'activeUntil',
  Clicks = 'clicks',
  Closes = 'closes',
  CreatedAt = 'createdAt',
  Id = 'id',
  PopupId = 'popupId',
  UpdatedAt = 'updatedAt',
  Views = 'views'
}

/** Possible statistic types for a popup period */
export enum PopupPeriodStatisticType {
  Click = 'CLICK',
  Close = 'CLOSE'
}

/** Input for updating statistics of popup period */
export type PopupPeriodStatisticUpdateInput = {
  /** The statistic type to be updated (CLICK or CLOSE). The VIEWS will always be updated. */
  statisticType: PopupPeriodStatisticType;
};

export type PopupPeriodSumAggregate = {
  __typename: 'PopupPeriodSumAggregate';
  clicks?: Maybe<Scalars['Int']['output']>;
  closes?: Maybe<Scalars['Int']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

export type PopupPeriodWhereInput = {
  AND?: InputMaybe<Array<PopupPeriodWhereInput>>;
  NOT?: InputMaybe<Array<PopupPeriodWhereInput>>;
  OR?: InputMaybe<Array<PopupPeriodWhereInput>>;
  activeFrom?: InputMaybe<DateTimeFilter>;
  activeUntil?: InputMaybe<DateTimeFilter>;
  clicks?: InputMaybe<IntFilter>;
  closes?: InputMaybe<IntFilter>;
  id?: InputMaybe<UuidFilter>;
  popup?: InputMaybe<PopupScalarRelationFilter>;
  views?: InputMaybe<IntFilter>;
};

export type PopupPeriodWhereUniqueInput = {
  AND?: InputMaybe<Array<PopupPeriodWhereInput>>;
  NOT?: InputMaybe<Array<PopupPeriodWhereInput>>;
  OR?: InputMaybe<Array<PopupPeriodWhereInput>>;
  activeFrom?: InputMaybe<DateTimeFilter>;
  activeUntil?: InputMaybe<DateTimeFilter>;
  clicks?: InputMaybe<IntFilter>;
  closes?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  popup?: InputMaybe<PopupScalarRelationFilter>;
  views?: InputMaybe<IntFilter>;
};

export enum PopupScalarFieldEnum {
  Active = 'active',
  ClickUrl = 'clickUrl',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Description = 'description',
  Id = 'id',
  LockTime = 'lockTime',
  MediaType = 'mediaType',
  MediaUrl = 'mediaUrl',
  Name = 'name',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type PopupScalarRelationFilter = {
  is?: InputMaybe<PopupWhereInput>;
  isNot?: InputMaybe<PopupWhereInput>;
};

export type PopupSumAggregate = {
  __typename: 'PopupSumAggregate';
  lockTime?: Maybe<Scalars['Float']['output']>;
};

/** The types for a popup */
export enum PopupType {
  /** A forced popup (close lock for x seconds) */
  Force = 'FORCE',
  /** A simple popup */
  Simple = 'SIMPLE'
}

export type PopupWhereInput = {
  AND?: InputMaybe<Array<PopupWhereInput>>;
  NOT?: InputMaybe<Array<PopupWhereInput>>;
  OR?: InputMaybe<Array<PopupWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  clickUrl?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  lockTime?: InputMaybe<FloatFilter>;
  mediaType?: InputMaybe<EnumMediaTypeFilter>;
  mediaUrl?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  periods?: InputMaybe<PopupPeriodListRelationFilter>;
  type?: InputMaybe<EnumPopupTypeFilter>;
};

export type PopupWhereUniqueInput = {
  AND?: InputMaybe<Array<PopupWhereInput>>;
  NOT?: InputMaybe<Array<PopupWhereInput>>;
  OR?: InputMaybe<Array<PopupWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  clickUrl?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  lockTime?: InputMaybe<FloatFilter>;
  mediaType?: InputMaybe<EnumMediaTypeFilter>;
  mediaUrl?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  periods?: InputMaybe<PopupPeriodListRelationFilter>;
  type?: InputMaybe<EnumPopupTypeFilter>;
};

export type PostMedia = {
  __typename: 'PostMedia';
  createdAt: Scalars['DateTime']['output'];
  /** Only set for mediaType=VIDEO. */
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  key: Scalars['String']['output'];
  mediaType: MediaType;
  position: Scalars['Int']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
  userPost: UserPost;
};

export type PostMediaAvgAggregate = {
  __typename: 'PostMediaAvgAggregate';
  durationSeconds?: Maybe<Scalars['Float']['output']>;
  position?: Maybe<Scalars['Float']['output']>;
};

export type PostMediaCountAggregate = {
  __typename: 'PostMediaCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  durationSeconds: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  key: Scalars['Int']['output'];
  mediaType: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  thumbnailUrl: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  url: Scalars['Int']['output'];
};

export type PostMediaListRelationFilter = {
  every?: InputMaybe<PostMediaWhereInput>;
  none?: InputMaybe<PostMediaWhereInput>;
  some?: InputMaybe<PostMediaWhereInput>;
};

export type PostMediaMaxAggregate = {
  __typename: 'PostMediaMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<MediaType>;
  position?: Maybe<Scalars['Int']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type PostMediaMinAggregate = {
  __typename: 'PostMediaMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<MediaType>;
  position?: Maybe<Scalars['Int']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type PostMediaOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PostMediaOrderByWithRelationInput = {
  durationSeconds?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  mediaType?: InputMaybe<SortOrder>;
  position?: InputMaybe<SortOrder>;
  thumbnailUrl?: InputMaybe<SortOrderInput>;
  url?: InputMaybe<SortOrder>;
  userPost?: InputMaybe<UserPostOrderByWithRelationInput>;
  userPostId?: InputMaybe<SortOrder>;
};

export enum PostMediaScalarFieldEnum {
  CreatedAt = 'createdAt',
  DurationSeconds = 'durationSeconds',
  Id = 'id',
  Key = 'key',
  MediaType = 'mediaType',
  Position = 'position',
  ThumbnailUrl = 'thumbnailUrl',
  UpdatedAt = 'updatedAt',
  Url = 'url',
  UserPostId = 'userPostId'
}

export type PostMediaSumAggregate = {
  __typename: 'PostMediaSumAggregate';
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
};

export type PostMediaWhereInput = {
  AND?: InputMaybe<Array<PostMediaWhereInput>>;
  NOT?: InputMaybe<Array<PostMediaWhereInput>>;
  OR?: InputMaybe<Array<PostMediaWhereInput>>;
  durationSeconds?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  key?: InputMaybe<StringFilter>;
  mediaType?: InputMaybe<EnumMediaTypeFilter>;
  position?: InputMaybe<IntFilter>;
  thumbnailUrl?: InputMaybe<StringNullableFilter>;
  url?: InputMaybe<StringFilter>;
  userPost?: InputMaybe<UserPostScalarRelationFilter>;
  userPostId?: InputMaybe<UuidFilter>;
};

export type PostMediaWhereUniqueInput = {
  AND?: InputMaybe<Array<PostMediaWhereInput>>;
  NOT?: InputMaybe<Array<PostMediaWhereInput>>;
  OR?: InputMaybe<Array<PostMediaWhereInput>>;
  durationSeconds?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  key?: InputMaybe<StringFilter>;
  mediaType?: InputMaybe<EnumMediaTypeFilter>;
  position?: InputMaybe<IntFilter>;
  thumbnailUrl?: InputMaybe<StringNullableFilter>;
  url?: InputMaybe<StringFilter>;
  userPost?: InputMaybe<UserPostScalarRelationFilter>;
  userPostId?: InputMaybe<UuidFilter>;
};

export enum PostScope {
  Brand = 'BRAND',
  Personal = 'PERSONAL',
  SubCommunity = 'SUB_COMMUNITY'
}

export enum PreuseType {
  Chargeable = 'CHARGEABLE',
  Free = 'FREE',
  None = 'NONE'
}

export type Price = {
  __typename: 'Price';
  /** Whether this is the current price of the gym. Deactivated versions stay for existing training sessions. */
  active: Scalars['Boolean']['output'];
  /** The date and time when the price record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The gym associated with the price. */
  event?: Maybe<Event>;
  /** The gym associated with the price. */
  gym?: Maybe<Gym>;
  /** The unique identifier for the price record. */
  id: Scalars['UUID']['output'];
  /** The price value. */
  price: Scalars['Float']['output'];
  /**
   * How the price is billed; versioned together with the amount. Gym prices are PAY_PER_MINUTE or
   * DAILY_TICKET, event prices are always EVENT (enforced by a check constraint, see migration).
   */
  pricingModel: PricingModel;
  /** The list of training sessions that use this price. */
  trainingSessions?: Maybe<Array<TrainingSession>>;
  /** The date and time when the price record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type PriceAvgAggregate = {
  __typename: 'PriceAvgAggregate';
  price?: Maybe<Scalars['Float']['output']>;
};

export type PriceCountAggregate = {
  __typename: 'PriceCountAggregate';
  _all: Scalars['Int']['output'];
  active: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  pricingModel: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type PriceListRelationFilter = {
  every?: InputMaybe<PriceWhereInput>;
  none?: InputMaybe<PriceWhereInput>;
  some?: InputMaybe<PriceWhereInput>;
};

export type PriceMaxAggregate = {
  __typename: 'PriceMaxAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  pricingModel?: Maybe<PricingModel>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PriceMinAggregate = {
  __typename: 'PriceMinAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  pricingModel?: Maybe<PricingModel>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PriceNullableScalarRelationFilter = {
  is?: InputMaybe<PriceWhereInput>;
  isNot?: InputMaybe<PriceWhereInput>;
};

export type PriceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PriceOrderByWithRelationInput = {
  event?: InputMaybe<EventOrderByWithRelationInput>;
  eventId?: InputMaybe<SortOrderInput>;
  gym?: InputMaybe<GymOrderByWithRelationInput>;
  gymId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  trainingSessions?: InputMaybe<TrainingSessionOrderByRelationAggregateInput>;
};

export enum PriceScalarFieldEnum {
  Active = 'active',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  EventId = 'eventId',
  GymId = 'gymId',
  Id = 'id',
  Price = 'price',
  PricingModel = 'pricingModel',
  UpdatedAt = 'updatedAt'
}

export type PriceSumAggregate = {
  __typename: 'PriceSumAggregate';
  price?: Maybe<Scalars['Float']['output']>;
};

export type PriceWhereInput = {
  AND?: InputMaybe<Array<PriceWhereInput>>;
  NOT?: InputMaybe<Array<PriceWhereInput>>;
  OR?: InputMaybe<Array<PriceWhereInput>>;
  event?: InputMaybe<EventNullableScalarRelationFilter>;
  eventId?: InputMaybe<UuidNullableFilter>;
  gym?: InputMaybe<GymNullableScalarRelationFilter>;
  gymId?: InputMaybe<UuidNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  price?: InputMaybe<FloatFilter>;
  trainingSessions?: InputMaybe<TrainingSessionListRelationFilter>;
};

export type PriceWhereUniqueInput = {
  AND?: InputMaybe<Array<PriceWhereInput>>;
  NOT?: InputMaybe<Array<PriceWhereInput>>;
  OR?: InputMaybe<Array<PriceWhereInput>>;
  event?: InputMaybe<EventNullableScalarRelationFilter>;
  eventId?: InputMaybe<Scalars['UUID']['input']>;
  gym?: InputMaybe<GymNullableScalarRelationFilter>;
  gymId?: InputMaybe<UuidNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  price?: InputMaybe<FloatFilter>;
  trainingSessions?: InputMaybe<TrainingSessionListRelationFilter>;
};

/** How a price is billed for a training session. */
export enum PricingModel {
  /** Gym price, charged once per training (price in cents per training). */
  DailyTicket = 'DAILY_TICKET',
  /** Event price, charged once per event participation. Set by the backend, never a gym pricing model. */
  Event = 'EVENT',
  /** Gym price, charged per trained minute (price in cents per minute). */
  PayPerMinute = 'PAY_PER_MINUTE'
}

export type Profile = {
  __typename: 'Profile';
  avatarKey?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  circles: Array<Circle>;
  createdAt: Scalars['DateTime']['output'];
  followerCount: Scalars['Int']['output'];
  followingCount: Scalars['Int']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  handle: Scalars['String']['output'];
  /**
   * Set once the handle is actually changed via `updateMyProfile` (Customer only, 14-day
   * cooldown enforced in ProfileService._updateProfile) -- distinct from `updatedAt`, which also
   * bumps on unrelated field changes (bio/avatar/place/...). NULL means never manually changed;
   * the auto-generated handle from registration does not count and never triggers a cooldown.
   */
  handleChangedAt?: Maybe<Scalars['DateTime']['output']>;
  hasUnseenCircles: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  isFeaturedForDiscovery: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  metCommunityEventInstance?: Maybe<CommunityEventInstance>;
  mutualFollowers: Array<Profile>;
  ownerType: ProfileOwnerType;
  place?: Maybe<Scalars['String']['output']>;
  sharedCommunityClubs: Array<CommunityClub>;
  tags?: Maybe<Array<ProfileTag>>;
  updatedAt: Scalars['DateTime']['output'];
  workouts: Array<Workout>;
  workoutsFeed: PaginatedWorkout;
};


export type ProfileWorkoutsFeedArgs = {
  cursor?: InputMaybe<WorkoutWhereUniqueInput>;
  distinct?: InputMaybe<Array<WorkoutScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<WorkoutOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WorkoutWhereInput>;
};

export type ProfileCountAggregate = {
  __typename: 'ProfileCountAggregate';
  _all: Scalars['Int']['output'];
  avatarKey: Scalars['Int']['output'];
  avatarUrl: Scalars['Int']['output'];
  bio: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  fullName: Scalars['Int']['output'];
  handle: Scalars['Int']['output'];
  handleChangedAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isFeaturedForDiscovery: Scalars['Int']['output'];
  isPrivate: Scalars['Int']['output'];
  ownerType: Scalars['Int']['output'];
  place: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

/** Input for creating a Profile. Owner identity (customer/employee/company) is derived server-side, never from client input. */
export type ProfileCreateInput = {
  /** The avatar image */
  avatarImage?: InputMaybe<ImageInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  /** The actor's full name shown on the Profile. Defaults to the value derived from Customer/CompanyEmployee if omitted. */
  fullName?: InputMaybe<Scalars['String']['input']>;
  handle: Scalars['String']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileCreateNestedOneWithoutCommunityClubInput = {
  connect?: InputMaybe<ProfileWhereUniqueInput>;
};

export type ProfileCreateNestedOneWithoutHostedCommunityEventsInput = {
  connect?: InputMaybe<ProfileWhereUniqueInput>;
};

export type ProfileEdge = {
  __typename: 'ProfileEdge';
  cursor: PaginatedLikerCursor;
  node: Profile;
};

export type ProfileListRelationFilter = {
  every?: InputMaybe<ProfileWhereInput>;
  none?: InputMaybe<ProfileWhereInput>;
  some?: InputMaybe<ProfileWhereInput>;
};

export type ProfileMaxAggregate = {
  __typename: 'ProfileMaxAggregate';
  avatarKey?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  handle?: Maybe<Scalars['String']['output']>;
  handleChangedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  isFeaturedForDiscovery?: Maybe<Scalars['Boolean']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  ownerType?: Maybe<ProfileOwnerType>;
  place?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProfileMinAggregate = {
  __typename: 'ProfileMinAggregate';
  avatarKey?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  handle?: Maybe<Scalars['String']['output']>;
  handleChangedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  isFeaturedForDiscovery?: Maybe<Scalars['Boolean']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  ownerType?: Maybe<ProfileOwnerType>;
  place?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProfileNullableScalarRelationFilter = {
  is?: InputMaybe<ProfileWhereInput>;
  isNot?: InputMaybe<ProfileWhereInput>;
};

export type ProfileOrderByWithRelationInput = {
  activitiesAsActor?: InputMaybe<ActivityOrderByRelationAggregateInput>;
  activitiesAsRecipient?: InputMaybe<ActivityOrderByRelationAggregateInput>;
  avatarKey?: InputMaybe<SortOrderInput>;
  avatarUrl?: InputMaybe<SortOrderInput>;
  bio?: InputMaybe<SortOrderInput>;
  blockedBy?: InputMaybe<BlockOrderByRelationAggregateInput>;
  blocking?: InputMaybe<BlockOrderByRelationAggregateInput>;
  circleViews?: InputMaybe<CircleViewOrderByRelationAggregateInput>;
  circles?: InputMaybe<CircleOrderByRelationAggregateInput>;
  communityClub?: InputMaybe<CommunityClubOrderByWithRelationInput>;
  communityClubId?: InputMaybe<SortOrderInput>;
  communityPostCommentLikes?: InputMaybe<CommunityPostCommentLikeOrderByRelationAggregateInput>;
  communityPostComments?: InputMaybe<CommunityPostCommentOrderByRelationAggregateInput>;
  communityPostLikes?: InputMaybe<CommunityPostLikeOrderByRelationAggregateInput>;
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  companyId?: InputMaybe<SortOrderInput>;
  conversationsAsA?: InputMaybe<ConversationOrderByRelationAggregateInput>;
  conversationsAsB?: InputMaybe<ConversationOrderByRelationAggregateInput>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrderInput>;
  employee?: InputMaybe<CompanyEmployeeOrderByWithRelationInput>;
  employeeId?: InputMaybe<SortOrderInput>;
  followers?: InputMaybe<FollowOrderByRelationAggregateInput>;
  following?: InputMaybe<FollowOrderByRelationAggregateInput>;
  fullName?: InputMaybe<SortOrderInput>;
  handle?: InputMaybe<SortOrder>;
  hostedCommunityEvents?: InputMaybe<CommunityEventOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  isFeaturedForDiscovery?: InputMaybe<SortOrder>;
  isPrivate?: InputMaybe<SortOrder>;
  ownerType?: InputMaybe<SortOrder>;
  place?: InputMaybe<SortOrderInput>;
  receivedFollowRequests?: InputMaybe<FollowRequestOrderByRelationAggregateInput>;
  reports?: InputMaybe<ReportOrderByRelationAggregateInput>;
  sentFollowRequests?: InputMaybe<FollowRequestOrderByRelationAggregateInput>;
  sentMessages?: InputMaybe<MessageOrderByRelationAggregateInput>;
  taggedInWorkouts?: InputMaybe<WorkoutParticipantOrderByRelationAggregateInput>;
  tags?: InputMaybe<ProfileTagOrderByRelationAggregateInput>;
  userPosts?: InputMaybe<UserPostOrderByRelationAggregateInput>;
  workouts?: InputMaybe<WorkoutOrderByRelationAggregateInput>;
};

export enum ProfileOwnerType {
  CommunityClub = 'COMMUNITY_CLUB',
  Company = 'COMPANY',
  Customer = 'CUSTOMER',
  Employee = 'EMPLOYEE'
}

export type ProfileScalarRelationFilter = {
  is?: InputMaybe<ProfileWhereInput>;
  isNot?: InputMaybe<ProfileWhereInput>;
};

export type ProfileTag = {
  __typename: 'ProfileTag';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  profiles?: Maybe<Array<Profile>>;
};

export type ProfileTagCountAggregate = {
  __typename: 'ProfileTagCountAggregate';
  _all: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
};

export type ProfileTagListRelationFilter = {
  every?: InputMaybe<ProfileTagWhereInput>;
  none?: InputMaybe<ProfileTagWhereInput>;
  some?: InputMaybe<ProfileTagWhereInput>;
};

export type ProfileTagMaxAggregate = {
  __typename: 'ProfileTagMaxAggregate';
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ProfileTagMinAggregate = {
  __typename: 'ProfileTagMinAggregate';
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ProfileTagOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProfileTagWhereInput = {
  AND?: InputMaybe<Array<ProfileTagWhereInput>>;
  NOT?: InputMaybe<Array<ProfileTagWhereInput>>;
  OR?: InputMaybe<Array<ProfileTagWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  profiles?: InputMaybe<ProfileListRelationFilter>;
};

/** Input for updating a Profile. Owner identity cannot be changed. */
export type ProfileUpdateInput = {
  /** The avatar image */
  avatarImage?: InputMaybe<ImageInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  /** The actor's full name shown on the Profile. Pass null to clear it. */
  fullName?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileUpdateOneWithoutCommunityClubNestedInput = {
  connect?: InputMaybe<ProfileWhereUniqueInput>;
  disconnect?: InputMaybe<ProfileWhereInput>;
};

export type ProfileUpdateOneWithoutCompanyNestedInput = {
  connect?: InputMaybe<ProfileWhereUniqueInput>;
  disconnect?: InputMaybe<ProfileWhereInput>;
};

export type ProfileUpdateOneWithoutCustomerNestedInput = {
  connect?: InputMaybe<ProfileWhereUniqueInput>;
  disconnect?: InputMaybe<ProfileWhereInput>;
};

export type ProfileUpdateOneWithoutHostedCommunityEventsNestedInput = {
  connect?: InputMaybe<ProfileWhereUniqueInput>;
  disconnect?: InputMaybe<ProfileWhereInput>;
};

export type ProfileWhereInput = {
  AND?: InputMaybe<Array<ProfileWhereInput>>;
  NOT?: InputMaybe<Array<ProfileWhereInput>>;
  OR?: InputMaybe<Array<ProfileWhereInput>>;
  activitiesAsActor?: InputMaybe<ActivityListRelationFilter>;
  activitiesAsRecipient?: InputMaybe<ActivityListRelationFilter>;
  avatarKey?: InputMaybe<StringNullableFilter>;
  avatarUrl?: InputMaybe<StringNullableFilter>;
  bio?: InputMaybe<StringNullableFilter>;
  blockedBy?: InputMaybe<BlockListRelationFilter>;
  blocking?: InputMaybe<BlockListRelationFilter>;
  circleViews?: InputMaybe<CircleViewListRelationFilter>;
  circles?: InputMaybe<CircleListRelationFilter>;
  communityClub?: InputMaybe<CommunityClubNullableScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidNullableFilter>;
  communityPostCommentLikes?: InputMaybe<CommunityPostCommentLikeListRelationFilter>;
  communityPostComments?: InputMaybe<CommunityPostCommentListRelationFilter>;
  communityPostLikes?: InputMaybe<CommunityPostLikeListRelationFilter>;
  company?: InputMaybe<CompanyNullableScalarRelationFilter>;
  companyId?: InputMaybe<StringNullableFilter>;
  conversationsAsA?: InputMaybe<ConversationListRelationFilter>;
  conversationsAsB?: InputMaybe<ConversationListRelationFilter>;
  customer?: InputMaybe<CustomerNullableScalarRelationFilter>;
  customerId?: InputMaybe<StringNullableFilter>;
  employee?: InputMaybe<CompanyEmployeeNullableScalarRelationFilter>;
  employeeId?: InputMaybe<StringNullableFilter>;
  followers?: InputMaybe<FollowListRelationFilter>;
  following?: InputMaybe<FollowListRelationFilter>;
  fullName?: InputMaybe<StringNullableFilter>;
  handle?: InputMaybe<StringFilter>;
  hostedCommunityEvents?: InputMaybe<CommunityEventListRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  isFeaturedForDiscovery?: InputMaybe<BoolFilter>;
  isPrivate?: InputMaybe<BoolFilter>;
  ownerType?: InputMaybe<EnumProfileOwnerTypeFilter>;
  place?: InputMaybe<StringNullableFilter>;
  receivedFollowRequests?: InputMaybe<FollowRequestListRelationFilter>;
  reports?: InputMaybe<ReportListRelationFilter>;
  sentFollowRequests?: InputMaybe<FollowRequestListRelationFilter>;
  sentMessages?: InputMaybe<MessageListRelationFilter>;
  taggedInWorkouts?: InputMaybe<WorkoutParticipantListRelationFilter>;
  tags?: InputMaybe<ProfileTagListRelationFilter>;
  userPosts?: InputMaybe<UserPostListRelationFilter>;
  workouts?: InputMaybe<WorkoutListRelationFilter>;
};

export type ProfileWhereUniqueInput = {
  AND?: InputMaybe<Array<ProfileWhereInput>>;
  NOT?: InputMaybe<Array<ProfileWhereInput>>;
  OR?: InputMaybe<Array<ProfileWhereInput>>;
  activitiesAsActor?: InputMaybe<ActivityListRelationFilter>;
  activitiesAsRecipient?: InputMaybe<ActivityListRelationFilter>;
  avatarKey?: InputMaybe<StringNullableFilter>;
  avatarUrl?: InputMaybe<StringNullableFilter>;
  bio?: InputMaybe<StringNullableFilter>;
  blockedBy?: InputMaybe<BlockListRelationFilter>;
  blocking?: InputMaybe<BlockListRelationFilter>;
  circleViews?: InputMaybe<CircleViewListRelationFilter>;
  circles?: InputMaybe<CircleListRelationFilter>;
  communityClub?: InputMaybe<CommunityClubNullableScalarRelationFilter>;
  communityClubId?: InputMaybe<Scalars['String']['input']>;
  communityPostCommentLikes?: InputMaybe<CommunityPostCommentLikeListRelationFilter>;
  communityPostComments?: InputMaybe<CommunityPostCommentListRelationFilter>;
  communityPostLikes?: InputMaybe<CommunityPostLikeListRelationFilter>;
  company?: InputMaybe<CompanyNullableScalarRelationFilter>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  conversationsAsA?: InputMaybe<ConversationListRelationFilter>;
  conversationsAsB?: InputMaybe<ConversationListRelationFilter>;
  customer?: InputMaybe<CustomerNullableScalarRelationFilter>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  employee?: InputMaybe<CompanyEmployeeNullableScalarRelationFilter>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<FollowListRelationFilter>;
  following?: InputMaybe<FollowListRelationFilter>;
  fullName?: InputMaybe<StringNullableFilter>;
  handle?: InputMaybe<Scalars['String']['input']>;
  hostedCommunityEvents?: InputMaybe<CommunityEventListRelationFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isFeaturedForDiscovery?: InputMaybe<BoolFilter>;
  isPrivate?: InputMaybe<BoolFilter>;
  ownerType?: InputMaybe<EnumProfileOwnerTypeFilter>;
  place?: InputMaybe<StringNullableFilter>;
  receivedFollowRequests?: InputMaybe<FollowRequestListRelationFilter>;
  reports?: InputMaybe<ReportListRelationFilter>;
  sentFollowRequests?: InputMaybe<FollowRequestListRelationFilter>;
  sentMessages?: InputMaybe<MessageListRelationFilter>;
  taggedInWorkouts?: InputMaybe<WorkoutParticipantListRelationFilter>;
  tags?: InputMaybe<ProfileTagListRelationFilter>;
  userPosts?: InputMaybe<UserPostListRelationFilter>;
  workouts?: InputMaybe<WorkoutListRelationFilter>;
};

export type Promotion = {
  __typename: 'Promotion';
  /** Indicator whether this promotion is currently active */
  active: Scalars['Boolean']['output'];
  /** The URL the user will be redirected to after clicking the promotion */
  clickUrl?: Maybe<Scalars['String']['output']>;
  company: Company;
  /** The companyId that owns this promotion */
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** An optional description for view in the management portal */
  description?: Maybe<Scalars['String']['output']>;
  gyms?: Maybe<Array<Gym>>;
  id: Scalars['UUID']['output'];
  /** The URL to the image for this promotion */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** An optional name for view in the management portal */
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PromotionCode = {
  __typename: 'PromotionCode';
  _count: PromotionCodeCount;
  company?: Maybe<Company>;
  createdAt: Scalars['DateTime']['output'];
  customerPromotionCode?: Maybe<Array<CustomerPromotionCode>>;
  /** Mark the promotion code as deleted (soft delete) */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** A optional description for this promotion code */
  description?: Maybe<Scalars['String']['output']>;
  /** Optional a end date for the promotion code */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** The percentage for this promotion code */
  percentage: Scalars['Int']['output'];
  /** The name of the promotion code in stripe */
  promotionCode: Scalars['String']['output'];
  /** Optional a start date for the promotion code */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  trainings?: Maybe<Array<TrainingSession>>;
  updatedAt: Scalars['DateTime']['output'];
  /** The maximum usage limit for example: 3. If not set, the usage is unlimited */
  usageLimit?: Maybe<Scalars['Int']['output']>;
};

export type PromotionCodeAvgAggregate = {
  __typename: 'PromotionCodeAvgAggregate';
  percentage?: Maybe<Scalars['Float']['output']>;
  usageLimit?: Maybe<Scalars['Float']['output']>;
};

export type PromotionCodeCount = {
  __typename: 'PromotionCodeCount';
  customerPromotionCode: Scalars['Int']['output'];
  trainings: Scalars['Int']['output'];
};

export type PromotionCodeCountAggregate = {
  __typename: 'PromotionCodeCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  endDate: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  percentage: Scalars['Int']['output'];
  promotionCode: Scalars['Int']['output'];
  startDate: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  usageLimit: Scalars['Int']['output'];
};

/** Custom input for promotion code creation */
export type PromotionCodeCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** The date until when the promotion code can be redeemed */
  endDate: Scalars['String']['input'];
  /** Set this if you only want the promotion code to be valid for first orders (new customers). Only works with a 'usageLimit' of 1 */
  onlyFirstTimeOrder?: InputMaybe<Scalars['Boolean']['input']>;
  percentage: Scalars['Int']['input'];
  promotionCode: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  usageLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type PromotionCodeCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<PromotionCodeWhereUniqueInput>>;
};

export type PromotionCodeListRelationFilter = {
  every?: InputMaybe<PromotionCodeWhereInput>;
  none?: InputMaybe<PromotionCodeWhereInput>;
  some?: InputMaybe<PromotionCodeWhereInput>;
};

export type PromotionCodeMaxAggregate = {
  __typename: 'PromotionCodeMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Int']['output']>;
  promotionCode?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  usageLimit?: Maybe<Scalars['Int']['output']>;
};

export type PromotionCodeMinAggregate = {
  __typename: 'PromotionCodeMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Int']['output']>;
  promotionCode?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  usageLimit?: Maybe<Scalars['Int']['output']>;
};

export type PromotionCodeNullableScalarRelationFilter = {
  is?: InputMaybe<PromotionCodeWhereInput>;
  isNot?: InputMaybe<PromotionCodeWhereInput>;
};

export type PromotionCodeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PromotionCodeOrderByWithRelationInput = {
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  customerPromotionCode?: InputMaybe<CustomerPromotionCodeOrderByRelationAggregateInput>;
  deletedAt?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrderInput>;
  endDate?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  percentage?: InputMaybe<SortOrder>;
  promotionCode?: InputMaybe<SortOrder>;
  restrictedToCompanyId?: InputMaybe<SortOrderInput>;
  startDate?: InputMaybe<SortOrderInput>;
  stripeCoupon?: InputMaybe<StripeCouponOrderByWithRelationInput>;
  stripeCouponId?: InputMaybe<SortOrder>;
  stripePromotionCodeId?: InputMaybe<SortOrder>;
  trainings?: InputMaybe<TrainingSessionOrderByRelationAggregateInput>;
  usageLimit?: InputMaybe<SortOrderInput>;
};

export enum PromotionCodeScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Description = 'description',
  EndDate = 'endDate',
  Id = 'id',
  Percentage = 'percentage',
  PromotionCode = 'promotionCode',
  RestrictedToCompanyId = 'restrictedToCompanyId',
  StartDate = 'startDate',
  StripeCouponId = 'stripeCouponId',
  StripePromotionCodeId = 'stripePromotionCodeId',
  UpdatedAt = 'updatedAt',
  UsageLimit = 'usageLimit'
}

export type PromotionCodeScalarRelationFilter = {
  is?: InputMaybe<PromotionCodeWhereInput>;
  isNot?: InputMaybe<PromotionCodeWhereInput>;
};

export type PromotionCodeSumAggregate = {
  __typename: 'PromotionCodeSumAggregate';
  percentage?: Maybe<Scalars['Int']['output']>;
  usageLimit?: Maybe<Scalars['Int']['output']>;
};

export type PromotionCodeUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<PromotionCodeWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<PromotionCodeWhereUniqueInput>>;
};

export type PromotionCodeUpdateOneWithoutTrainingsNestedInput = {
  connect?: InputMaybe<PromotionCodeWhereUniqueInput>;
  disconnect?: InputMaybe<PromotionCodeWhereInput>;
};

export type PromotionCodeWhereInput = {
  AND?: InputMaybe<Array<PromotionCodeWhereInput>>;
  NOT?: InputMaybe<Array<PromotionCodeWhereInput>>;
  OR?: InputMaybe<Array<PromotionCodeWhereInput>>;
  company?: InputMaybe<CompanyNullableScalarRelationFilter>;
  customerPromotionCode?: InputMaybe<CustomerPromotionCodeListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  endDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  percentage?: InputMaybe<IntFilter>;
  promotionCode?: InputMaybe<StringFilter>;
  restrictedToCompanyId?: InputMaybe<StringNullableFilter>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  stripeCoupon?: InputMaybe<StripeCouponScalarRelationFilter>;
  stripeCouponId?: InputMaybe<StringFilter>;
  stripePromotionCodeId?: InputMaybe<StringFilter>;
  trainings?: InputMaybe<TrainingSessionListRelationFilter>;
  usageLimit?: InputMaybe<IntNullableFilter>;
};

export type PromotionCodeWhereUniqueInput = {
  AND?: InputMaybe<Array<PromotionCodeWhereInput>>;
  NOT?: InputMaybe<Array<PromotionCodeWhereInput>>;
  OR?: InputMaybe<Array<PromotionCodeWhereInput>>;
  company?: InputMaybe<CompanyNullableScalarRelationFilter>;
  customerPromotionCode?: InputMaybe<CustomerPromotionCodeListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  endDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<IntFilter>;
  promotionCode?: InputMaybe<StringFilter>;
  restrictedToCompanyId?: InputMaybe<StringNullableFilter>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  stripeCoupon?: InputMaybe<StripeCouponScalarRelationFilter>;
  stripeCouponId?: InputMaybe<StringFilter>;
  stripePromotionCodeId?: InputMaybe<StringFilter>;
  trainings?: InputMaybe<TrainingSessionListRelationFilter>;
  usageLimit?: InputMaybe<IntNullableFilter>;
};

export type PromotionCountAggregate = {
  __typename: 'PromotionCountAggregate';
  _all: Scalars['Int']['output'];
  active: Scalars['Int']['output'];
  clickUrl: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  imageUrl: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

/** Input for creating a new promotion */
export type PromotionCreateInput = {
  clickUrl?: InputMaybe<Scalars['String']['input']>;
  /** Optionally connect this promotion to a specific company */
  company?: InputMaybe<CompanyCreateNestedOneWithoutPromotionsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optionally connect this promotion to multiple gyms */
  gyms?: InputMaybe<GymCreateNestedManyWithoutPromotionInput>;
  /** Set an image URL or upload an image for this promotion */
  image: ImageInput;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PromotionCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<PromotionWhereUniqueInput>>;
};

export type PromotionCreateNestedOneWithoutGymsInput = {
  connect?: InputMaybe<PromotionWhereUniqueInput>;
};

export type PromotionListRelationFilter = {
  every?: InputMaybe<PromotionWhereInput>;
  none?: InputMaybe<PromotionWhereInput>;
  some?: InputMaybe<PromotionWhereInput>;
};

export type PromotionMaxAggregate = {
  __typename: 'PromotionMaxAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  clickUrl?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PromotionMinAggregate = {
  __typename: 'PromotionMinAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  clickUrl?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PromotionNullableScalarRelationFilter = {
  is?: InputMaybe<PromotionWhereInput>;
  isNot?: InputMaybe<PromotionWhereInput>;
};

export type PromotionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PromotionOrderByWithRelationInput = {
  active?: InputMaybe<SortOrder>;
  clickUrl?: InputMaybe<SortOrderInput>;
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  companyId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  gyms?: InputMaybe<GymOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrderInput>;
};

export enum PromotionScalarFieldEnum {
  Active = 'active',
  ClickUrl = 'clickUrl',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Description = 'description',
  Id = 'id',
  ImageUrl = 'imageUrl',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

/** Input for updating a promotion */
export type PromotionUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  clickUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Update the gyms to be connected with this promotion */
  gyms?: InputMaybe<GymUpdateManyWithoutPromotionNestedInput>;
  /** Set a new image for this promotion */
  image?: InputMaybe<ImageInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PromotionUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<PromotionWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<PromotionWhereUniqueInput>>;
};

export type PromotionUpdateOneWithoutGymsNestedInput = {
  connect?: InputMaybe<PromotionWhereUniqueInput>;
  disconnect?: InputMaybe<PromotionWhereInput>;
};

export type PromotionWhereInput = {
  AND?: InputMaybe<Array<PromotionWhereInput>>;
  NOT?: InputMaybe<Array<PromotionWhereInput>>;
  OR?: InputMaybe<Array<PromotionWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  clickUrl?: InputMaybe<StringNullableFilter>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringNullableFilter>;
  gyms?: InputMaybe<GymListRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
};

export type PromotionWhereUniqueInput = {
  AND?: InputMaybe<Array<PromotionWhereInput>>;
  NOT?: InputMaybe<Array<PromotionWhereInput>>;
  OR?: InputMaybe<Array<PromotionWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  clickUrl?: InputMaybe<StringNullableFilter>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringNullableFilter>;
  gyms?: InputMaybe<GymListRelationFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
};

export type PublicApiBankAccountDto = {
  accountHolder: Scalars['String']['input'];
  bic?: InputMaybe<Scalars['String']['input']>;
  iban: Scalars['String']['input'];
};

export type PublicApiCreditCardDto = {
  accountPaymentInstrumentToken?: InputMaybe<Scalars['String']['input']>;
  tokenizationReference?: InputMaybe<Scalars['String']['input']>;
};

export type PublicApiDocumentIdentificationDto = {
  documentNumber: Scalars['String']['input'];
  documentType: DocumentType;
};

export type PublicApiSelectedOptionalRateBundleModuleDto = {
  id: Scalars['Float']['input'];
};

export type PublicApiSelectedSelectableRateBundleModuleDto = {
  id: Scalars['Float']['input'];
};

export type PublicApiSignatureDto = {
  base64Svg: Scalars['String']['input'];
  textBlockId?: InputMaybe<Scalars['Float']['input']>;
};

/** Result of public community club endpoint */
export type PublicCommunityClubModel = {
  __typename: 'PublicCommunityClubModel';
  communityEvents?: Maybe<Array<PublicCommunityEventModel>>;
  communityHost?: Maybe<Array<Profile>>;
  /** A detailed description of the community club. */
  description?: Maybe<Scalars['String']['output']>;
  /** The house number of the community club's location. */
  houseNumber: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  /** The latitude coordinate of the community club's location. */
  latitude: Scalars['String']['output'];
  /** The longitude coordinate of the community club's location. */
  longitude: Scalars['String']['output'];
  /** The name of the community club. */
  name: Scalars['String']['output'];
  /** The city or town where the community club is located. */
  place: Scalars['String']['output'];
  profile?: Maybe<Profile>;
  s3CoverImageUrl?: Maybe<Scalars['String']['output']>;
  s3LogoUrl?: Maybe<Scalars['String']['output']>;
  /** The street name of the community club's location. */
  street: Scalars['String']['output'];
  /** The postal code of the community club's location. */
  zipcode: Scalars['String']['output'];
};

/** Result of public Community Club endpoint */
export type PublicCommunityClubsModel = {
  __typename: 'PublicCommunityClubsModel';
  company: PublicCompanyModel;
  id: Scalars['UUID']['output'];
  /** The latitude coordinate of the community club's location. */
  latitude: Scalars['String']['output'];
  /** The longitude coordinate of the community club's location. */
  longitude: Scalars['String']['output'];
  /** The name of the community club. */
  name: Scalars['String']['output'];
  profile?: Maybe<Profile>;
  s3CoverImageUrl?: Maybe<Scalars['String']['output']>;
  s3LogoUrl?: Maybe<Scalars['String']['output']>;
};

/** Public Event category model */
export type PublicCommunityEventCategoryModel = {
  __typename: 'PublicCommunityEventCategoryModel';
  iconName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

/** Result of public community event instance endpoint */
export type PublicCommunityEventInstanceModel = {
  __typename: 'PublicCommunityEventInstanceModel';
  id: Scalars['UUID']['output'];
  startAt: Scalars['DateTime']['output'];
};

/** Result of public community event location endpoint */
export type PublicCommunityEventLocationModel = {
  __typename: 'PublicCommunityEventLocationModel';
  /** The house number of the event location. */
  houseNumber: Scalars['String']['output'];
  /** The latitude coordinate of the event location. */
  latitude: Scalars['String']['output'];
  /** The longitude coordinate of the event location. */
  longitude: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** The city or town where the event is located. */
  place: Scalars['String']['output'];
  /** The street name of the event location. */
  street: Scalars['String']['output'];
  /** The postal code of the event location. */
  zipcode: Scalars['String']['output'];
};

/** Result of public community event endpoint */
export type PublicCommunityEventModel = {
  __typename: 'PublicCommunityEventModel';
  communityClub: PublicCommunityClubModel;
  communityEventCategory?: Maybe<CommunityEventCategory>;
  communityEventInstances?: Maybe<Array<PublicCommunityEventInstanceModel>>;
  communityEventLocation: PublicCommunityEventLocationModel;
  communityEventPartner?: Maybe<PublicCommunityEventPartnerModel>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  maxParticipants?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  s3HeaderImageUrl?: Maybe<Scalars['String']['output']>;
};

/** Result of public community event partner endpoint */
export type PublicCommunityEventPartnerModel = {
  __typename: 'PublicCommunityEventPartnerModel';
  description?: Maybe<Scalars['String']['output']>;
  /** The house number of the event partner location. */
  houseNumber: Scalars['String']['output'];
  /** The latitude coordinate of the event partner location. */
  latitude: Scalars['String']['output'];
  /** The longitude coordinate of the event partner location. */
  longitude: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** The city or town where the event partner is located. */
  place: Scalars['String']['output'];
  s3LogoUrl?: Maybe<Scalars['String']['output']>;
  /** The street name of the event partner location. */
  street: Scalars['String']['output'];
  /** The postal code of the community club's event partner. */
  zipcode: Scalars['String']['output'];
};

/** Result of public community event endpoint */
export type PublicCommunityPostModel = {
  __typename: 'PublicCommunityPostModel';
  _count?: Maybe<CommunityPostCount>;
  author?: Maybe<Profile>;
  communityClub: PublicCommunityClubModel;
  content: Scalars['String']['output'];
  /**
   * Set once `content` is changed via `updateCommunityPost` -- distinct from `updatedAt`, which
   * also bumps on unrelated writes (e.g. soft-delete). NULL means never edited.
   */
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  /** The date and time when the post is considered published. */
  postedAt: Scalars['DateTime']['output'];
  s3ImageUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Public company model */
export type PublicCompanyModel = {
  __typename: 'PublicCompanyModel';
  id?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** The name of the company. */
  name: Scalars['String']['output'];
  profile?: Maybe<PublicCompanyProfileModel>;
};

/** Minimal public projection of a brand's Profile */
export type PublicCompanyProfileModel = {
  __typename: 'PublicCompanyProfileModel';
  id: Scalars['UUID']['output'];
};

/** Result of public event endpoint */
export type PublicEventModel = {
  __typename: 'PublicEventModel';
  /** A detailed description of the event. */
  description?: Maybe<Scalars['String']['output']>;
  /** The end date and time of the event. */
  endAt: Scalars['DateTime']['output'];
  gym: PublicGymModel;
  /** The maximum number of participants for the event. */
  maxParticipants: Scalars['Int']['output'];
  /** The name of the event. */
  name: Scalars['String']['output'];
  price: PublicPriceModel;
  /** The start date and time of the event. */
  startAt: Scalars['DateTime']['output'];
};

/** Public gym advantage model */
export type PublicGymAdvantageModel = {
  __typename: 'PublicGymAdvantageModel';
  name: Scalars['String']['output'];
};

/** Public gym Category model */
export type PublicGymCategoryModel = {
  __typename: 'PublicGymCategoryModel';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

/** Public gym image model */
export type PublicGymImageModel = {
  __typename: 'PublicGymImageModel';
  /** The url of the uploaded image */
  s3ImageUrl: Scalars['String']['output'];
};

/** Result of public gym endpoint */
export type PublicGymModel = {
  __typename: 'PublicGymModel';
  advantages: Array<PublicGymAdvantageModel>;
  category?: Maybe<PublicGymCategoryModel>;
  company?: Maybe<PublicCompanyModel>;
  /** The email address of the gym. */
  contactEmail?: Maybe<Scalars['EmailAddress']['output']>;
  /** The mobilephone number for customer support (WhatsApp) */
  contactPhone?: Maybe<Scalars['String']['output']>;
  /** The description of the company (WhatsApp) */
  description?: Maybe<Scalars['String']['output']>;
  events?: Maybe<Array<PublicEventModel>>;
  /** The house number of the gym's location. */
  houseNumber: Scalars['String']['output'];
  images: Array<PublicGymImageModel>;
  /** The latitude coordinate of the gym's location. */
  latitude: Scalars['String']['output'];
  /** The longitude coordinate of the gym's location. */
  longitude: Scalars['String']['output'];
  /** The name of the gym. */
  name: Scalars['String']['output'];
  openingHours: Array<PublicOpeningHourModel>;
  /** The city or town where the gym is located. */
  place: Scalars['String']['output'];
  price?: Maybe<PublicPriceModel>;
  /** The street name of the gym's location. */
  street: Scalars['String']['output'];
  /** The type of the gym, e.g., a standard fitness studio or a special interest studio. */
  type: GymType;
  /** The postal code of the gym's location. */
  zipcode: Scalars['String']['output'];
};

/** Result of public gym endpoint */
export type PublicGymsModel = {
  __typename: 'PublicGymsModel';
  category?: Maybe<PublicGymCategoryModel>;
  company: PublicCompanyModel;
  /** Whether the gym is currently highlighted. Denormalized flag maintained by the highlight scheduler. */
  highlighted: Scalars['Boolean']['output'];
  /** The unique identifier for the gym. */
  id: Scalars['UUID']['output'];
  /** The latitude coordinate of the gym's location. */
  latitude: Scalars['String']['output'];
  /** The longitude coordinate of the gym's location. */
  longitude: Scalars['String']['output'];
  /** The name of the gym. */
  name: Scalars['String']['output'];
  openingHours: Array<PublicOpeningHourModel>;
  price?: Maybe<PublicPriceModel>;
  /** The type of the gym, e.g., a standard fitness studio or a special interest studio. */
  type: GymType;
};

/** Public opening hour model */
export type PublicOpeningHourModel = {
  __typename: 'PublicOpeningHourModel';
  /** Closing time of the gym */
  close: Scalars['DateTime']['output'];
  /** 1 = Monday, 2 = Thusday, ... 7 = Sunday */
  day: Scalars['Int']['output'];
  /** Opening time of the gym */
  open: Scalars['DateTime']['output'];
};

/** Public price model */
export type PublicPriceModel = {
  __typename: 'PublicPriceModel';
  /** The price value. */
  price: Scalars['Float']['output'];
  /**
   * How the price is billed; versioned together with the amount. Gym prices are PAY_PER_MINUTE or
   * DAILY_TICKET, event prices are always EVENT (enforced by a check constraint, see migration).
   */
  pricingModel: PricingModel;
};

export type PublicRatingQuestion = {
  __typename: 'PublicRatingQuestion';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** The text of the rating question shown to customers */
  question: Scalars['String']['output'];
  /** State of different question */
  type: RatingQuestionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type PublicRatingQuestionWhereInput = {
  companyId?: InputMaybe<StringFilter>;
};

export type PushNotification = {
  __typename: 'PushNotification';
  company: Company;
  createdAt: Scalars['DateTime']['output'];
  /** The cron expression for the scheduler of notifications of type RECURRING */
  cronExpression?: Maybe<Scalars['String']['output']>;
  cronInterval?: Maybe<CronInterval>;
  /** The date at which the cron should be executed the first time */
  cronStartDate?: Maybe<Scalars['DateTime']['output']>;
  /** The history of sendings of an push notification */
  history?: Maybe<Array<PushNotificationHistory>>;
  id: Scalars['UUID']['output'];
  /** The message of the push notification */
  message: Scalars['String']['output'];
  /** The send date for notifications of type SCHEDULED_ONCE */
  sendAt?: Maybe<Scalars['DateTime']['output']>;
  /** The status of the push notification */
  status: PushNotificationStatus;
  /** The title of the push notification */
  title: Scalars['String']['output'];
  /** The send type for the push notification */
  type: PushNotificationSendType;
};

export type PushNotificationCountAggregate = {
  __typename: 'PushNotificationCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  cronExpression: Scalars['Int']['output'];
  cronInterval: Scalars['Int']['output'];
  cronStartDate: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  message: Scalars['Int']['output'];
  sendAt: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
};

/** Input for creating a push notification restricted to community clubs. The company is always derived from the user context and cannot be specified. */
export type PushNotificationCreateCommunityClubInput = {
  communityClubIds: Array<Scalars['String']['input']>;
  cronExpression?: InputMaybe<Scalars['CronExpression']['input']>;
  cronInterval?: InputMaybe<CronInterval>;
  cronStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  sendAt?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<PushNotificationSendType>;
};

/** Input for creating a push notification */
export type PushNotificationCreateInput = {
  /** Optionally restrict the notification to customers of the given community clubs. Currently only supported for IMMEDIATE notifications. */
  communityClubIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optionally specify the company this notification should be created for */
  company?: InputMaybe<CompanyCreateNestedOneWithoutPushNotificationsInput>;
  /** The expression for the scheduler. Needs to be in format: 'minutes hours day-of-month month day-of-week year'. Example for a cron that runs each month on the 15th: "0 0 15 * ? *". Only needs to be specified if the type of notification is SCHEDULED_ONCE or RECURRING */
  cronExpression?: InputMaybe<Scalars['CronExpression']['input']>;
  cronInterval?: InputMaybe<CronInterval>;
  cronStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  message: Scalars['String']['input'];
  sendAt?: InputMaybe<Scalars['DateTime']['input']>;
  type: PushNotificationSendType;
};

export type PushNotificationCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<PushNotificationWhereUniqueInput>>;
};

export type PushNotificationHistory = {
  __typename: 'PushNotificationHistory';
  affectedCustomers: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  pushNotification: PushNotification;
  pushNotificationId: Scalars['String']['output'];
  sendAt: Scalars['DateTime']['output'];
};

export type PushNotificationHistoryAvgAggregate = {
  __typename: 'PushNotificationHistoryAvgAggregate';
  affectedCustomers?: Maybe<Scalars['Float']['output']>;
};

export type PushNotificationHistoryCountAggregate = {
  __typename: 'PushNotificationHistoryCountAggregate';
  _all: Scalars['Int']['output'];
  affectedCustomers: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  pushNotificationId: Scalars['Int']['output'];
  sendAt: Scalars['Int']['output'];
};

export type PushNotificationHistoryListRelationFilter = {
  every?: InputMaybe<PushNotificationHistoryWhereInput>;
  none?: InputMaybe<PushNotificationHistoryWhereInput>;
  some?: InputMaybe<PushNotificationHistoryWhereInput>;
};

export type PushNotificationHistoryMaxAggregate = {
  __typename: 'PushNotificationHistoryMaxAggregate';
  affectedCustomers?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  pushNotificationId?: Maybe<Scalars['String']['output']>;
  sendAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PushNotificationHistoryMinAggregate = {
  __typename: 'PushNotificationHistoryMinAggregate';
  affectedCustomers?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  pushNotificationId?: Maybe<Scalars['String']['output']>;
  sendAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PushNotificationHistoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PushNotificationHistoryOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  pushNotification?: InputMaybe<PushNotificationOrderByWithRelationInput>;
  pushNotificationId?: InputMaybe<SortOrder>;
};

export enum PushNotificationHistoryScalarFieldEnum {
  AffectedCustomers = 'affectedCustomers',
  CompanyId = 'companyId',
  Id = 'id',
  PushNotificationId = 'pushNotificationId',
  SendAt = 'sendAt'
}

export type PushNotificationHistorySumAggregate = {
  __typename: 'PushNotificationHistorySumAggregate';
  affectedCustomers?: Maybe<Scalars['Int']['output']>;
};

export type PushNotificationHistoryWhereInput = {
  AND?: InputMaybe<Array<PushNotificationHistoryWhereInput>>;
  NOT?: InputMaybe<Array<PushNotificationHistoryWhereInput>>;
  OR?: InputMaybe<Array<PushNotificationHistoryWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  pushNotification?: InputMaybe<PushNotificationScalarRelationFilter>;
  pushNotificationId?: InputMaybe<UuidFilter>;
};

export type PushNotificationHistoryWhereUniqueInput = {
  AND?: InputMaybe<Array<PushNotificationHistoryWhereInput>>;
  NOT?: InputMaybe<Array<PushNotificationHistoryWhereInput>>;
  OR?: InputMaybe<Array<PushNotificationHistoryWhereInput>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  pushNotification?: InputMaybe<PushNotificationScalarRelationFilter>;
  pushNotificationId?: InputMaybe<UuidFilter>;
};

export type PushNotificationListRelationFilter = {
  every?: InputMaybe<PushNotificationWhereInput>;
  none?: InputMaybe<PushNotificationWhereInput>;
  some?: InputMaybe<PushNotificationWhereInput>;
};

export type PushNotificationMaxAggregate = {
  __typename: 'PushNotificationMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  cronExpression?: Maybe<Scalars['String']['output']>;
  cronInterval?: Maybe<CronInterval>;
  cronStartDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  sendAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<PushNotificationStatus>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PushNotificationSendType>;
};

export type PushNotificationMinAggregate = {
  __typename: 'PushNotificationMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  cronExpression?: Maybe<Scalars['String']['output']>;
  cronInterval?: Maybe<CronInterval>;
  cronStartDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  sendAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<PushNotificationStatus>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PushNotificationSendType>;
};

export type PushNotificationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PushNotificationOrderByWithRelationInput = {
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  companyId?: InputMaybe<SortOrder>;
  cronExpression?: InputMaybe<SortOrderInput>;
  cronInterval?: InputMaybe<SortOrderInput>;
  cronStartDate?: InputMaybe<SortOrderInput>;
  history?: InputMaybe<PushNotificationHistoryOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  sendAt?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export enum PushNotificationScalarFieldEnum {
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  CronExpression = 'cronExpression',
  CronInterval = 'cronInterval',
  CronStartDate = 'cronStartDate',
  Id = 'id',
  Message = 'message',
  SendAt = 'sendAt',
  Status = 'status',
  Title = 'title',
  Type = 'type'
}

export type PushNotificationScalarRelationFilter = {
  is?: InputMaybe<PushNotificationWhereInput>;
  isNot?: InputMaybe<PushNotificationWhereInput>;
};

/** The available types of push notifications. */
export enum PushNotificationSendType {
  /** Send the notification immediately */
  Immediate = 'IMMEDIATE',
  /** Scheduled to run in a specific interval */
  Recurring = 'RECURRING',
  /** Scheduled to run once on a specific date */
  ScheduledOnce = 'SCHEDULED_ONCE'
}

/** The different status of push notifications based on their types */
export enum PushNotificationStatus {
  /** The recurring schedule period of the notification is currently active */
  Active = 'ACTIVE',
  /** The notification is prepared and created but not processed */
  Pending = 'PENDING',
  /** The notification is created and scheduled and will be processed at the scheduled date */
  Scheduled = 'SCHEDULED',
  /** The final status for all notifications of all types. For recurring notifications that means that the recurring scheduler is deactivated or finished */
  Sent = 'SENT'
}

export type PushNotificationUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<PushNotificationWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<PushNotificationWhereUniqueInput>>;
};

export type PushNotificationWhereInput = {
  AND?: InputMaybe<Array<PushNotificationWhereInput>>;
  NOT?: InputMaybe<Array<PushNotificationWhereInput>>;
  OR?: InputMaybe<Array<PushNotificationWhereInput>>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  cronExpression?: InputMaybe<StringNullableFilter>;
  cronInterval?: InputMaybe<EnumCronIntervalNullableFilter>;
  cronStartDate?: InputMaybe<DateTimeNullableFilter>;
  history?: InputMaybe<PushNotificationHistoryListRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  message?: InputMaybe<StringFilter>;
  sendAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumPushNotificationStatusFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumPushNotificationSendTypeFilter>;
};

export type PushNotificationWhereUniqueInput = {
  AND?: InputMaybe<Array<PushNotificationWhereInput>>;
  NOT?: InputMaybe<Array<PushNotificationWhereInput>>;
  OR?: InputMaybe<Array<PushNotificationWhereInput>>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  cronExpression?: InputMaybe<StringNullableFilter>;
  cronInterval?: InputMaybe<EnumCronIntervalNullableFilter>;
  cronStartDate?: InputMaybe<DateTimeNullableFilter>;
  history?: InputMaybe<PushNotificationHistoryListRelationFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  message?: InputMaybe<StringFilter>;
  sendAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumPushNotificationStatusFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumPushNotificationSendTypeFilter>;
};

export type Query = {
  __typename: 'Query';
  about: AboutModel;
  /** Returns the currently active referral configuration if the referral feature is enabled */
  activeReferralConfig?: Maybe<ReferralConfig>;
  activeRegistrationQuestions: Array<RegistrationQuestion>;
  /** Returns active training session of customer */
  activeTrainingSession: Array<TrainingSession>;
  activity: Activity;
  aggregateCustomerBilling: AggregateCustomerBilling;
  aggregateTrainingSession: AggregateTrainingSession;
  /** Returns a list of available Stripe Coupon percentages. */
  availableStripeCoupons: Array<StripeCoupon>;
  averageTrainingSessionTime: Scalars['Float']['output'];
  block: Block;
  blocks: Array<Block>;
  /** Returns check-in utilization for the last 7-days */
  checkInUtilization: Array<CheckInUtilizationModel>;
  circle?: Maybe<Circle>;
  /** The current actor's circle tray: active circles from followed profiles plus their own, grouped by author. */
  circleFeed: Array<CircleTrayItem>;
  circles: Array<Circle>;
  communityClub: CommunityClub;
  communityClubOnboarding: CommunityClubOnboarding;
  /** Checks whether an active (pending or approved) application already exists for the given account email - called as soon as the wizard's account step email is entered. */
  communityClubOnboardingEmailExists: Scalars['Boolean']['output'];
  communityClubOnboardings: Array<CommunityClubOnboarding>;
  communityClubs: Array<CommunityClub>;
  communityEvent: CommunityEvent;
  communityEventBooking: CommunityEventBooking;
  communityEventBookings: Array<CommunityEventBooking>;
  communityEventCategories: Array<CommunityEventCategory>;
  communityEventCategory: CommunityEventCategory;
  communityEventImage: CommunityEventImage;
  communityEventImages: Array<CommunityEventImage>;
  communityEventInstance: CommunityEventInstance;
  communityEventInstances: Array<CommunityEventInstance>;
  communityEventLocation: CommunityEventLocation;
  communityEventLocations: Array<CommunityEventLocation>;
  communityEventPartner: CommunityEventPartner;
  communityEventPartners: Array<CommunityEventPartner>;
  communityEventTicketSale: CommunityEventTicketSale;
  communityEvents: Array<CommunityEvent>;
  communityMemberRelation: CommunityMemberRelation;
  communityMemberRelations: Array<CommunityMemberRelation>;
  communityPost: CommunityPost;
  communityPostComment: CommunityPostComment;
  communityPostCommentLike: CommunityPostCommentLike;
  communityPostCommentLikes: Array<CommunityPostCommentLike>;
  communityPostComments: Array<CommunityPostComment>;
  communityPostLike: CommunityPostLike;
  communityPostLikes: Array<CommunityPostLike>;
  communityPosts: Array<CommunityPost>;
  companies: Array<Company>;
  company: Company;
  companyBilling: CompanyBilling;
  companyBillings: Array<CompanyBilling>;
  companyEmployee: CompanyEmployee;
  companyEmployees: Array<CompanyEmployee>;
  companyName: Scalars['String']['output'];
  /** The current actor's own company/brand profile */
  companyProfile?: Maybe<Profile>;
  contract: Contract;
  contracts: Array<Contract>;
  conversation: Conversation;
  countBookings: Scalars['Float']['output'];
  countCustomer: Scalars['Float']['output'];
  countTrainingSessions: Scalars['Float']['output'];
  coupon: Coupon;
  coupons: Array<Coupon>;
  customer: Customer;
  customerBilling: CustomerBilling;
  customerBillingPerDay: Array<DateGroupedCount>;
  customerBillingTrend: TrendMetric;
  customerBillings: Array<CustomerBilling>;
  customerFreeMinuteGrant: CustomerFreeMinuteGrant;
  customerFreeMinuteGrants: Array<CustomerFreeMinuteGrant>;
  customerFreeMinuteUsage: CustomerFreeMinuteUsage;
  customerFreeMinuteUsages: Array<CustomerFreeMinuteUsage>;
  customerInvoices: Array<Invoice>;
  customerPromotionCode: CustomerPromotionCode;
  customerPromotionCodes: Array<CustomerPromotionCode>;
  customerTopRanking: Array<CustomerTopRanking>;
  customerTrend: TrendMetric;
  customers: Array<Customer>;
  /** Finds an event starting in the next hour at the gym where the user scanned the QR-Code and the user has a booking */
  eligibleCheckInEvent?: Maybe<Event>;
  emailExistsInAuth0: Scalars['Boolean']['output'];
  /**
   * Calculates estimated price for training session
   * @deprecated Not in use anymore. Will be removed soon
   */
  estimatedPrice: EstimatedPriceModel;
  event: Event;
  eventBooking: EventBooking;
  eventBookings: Array<EventBooking>;
  events: Array<Event>;
  follow: Follow;
  /** The current actor's own follow relationship towards a profile -- null if never followed/requested, or unfollowed since. */
  followStatus?: Maybe<FollowRequestStatus>;
  gym: Gym;
  gymAccessDevices: Array<GymAccessDevice>;
  gymAdvantage: GymAdvantage;
  gymAdvantages: Array<GymAdvantage>;
  gymCategories: Array<GymCategory>;
  gymCategory: GymCategory;
  gymHighlightOrder: GymHighlightOrder;
  gymHighlightOrders: Array<GymHighlightOrder>;
  gymHighlightPriceConfig: GymHighlightPriceConfig;
  gymHighlightPriceConfigs: Array<GymHighlightPriceConfig>;
  gymImage: GymImage;
  gymImages: Array<GymImage>;
  gymRating: GymRating;
  gymRatings: Array<GymRating>;
  gymTopRating: Array<GymTopRating>;
  gyms: Array<Gym>;
  healthInsurance: HealthInsurance;
  healthInsuranceBalance: HealthInsuranceBalance;
  healthInsuranceBalances: Array<HealthInsuranceBalance>;
  healthInsuranceEmployee: HealthInsuranceEmployee;
  healthInsuranceEmployees: Array<HealthInsuranceEmployee>;
  healthInsurancePointsConfig: HealthInsurancePointsConfig;
  healthInsurancePointsConfigs: Array<HealthInsurancePointsConfig>;
  healthInsuranceReceivedPoint: HealthInsuranceReceivedPoint;
  healthInsuranceReceivedPoints: Array<HealthInsuranceReceivedPoint>;
  healthInsuranceRedeemedPoint: HealthInsuranceRedeemedPoint;
  healthInsuranceRedeemedPoints: Array<HealthInsuranceRedeemedPoint>;
  healthInsuranceReward: HealthInsuranceReward;
  healthInsuranceRewards: Array<HealthInsuranceReward>;
  healthInsurances: Array<HealthInsurance>;
  /** Checks whether a handle is valid, not blacklisted, and not already taken -- for live validation while typing, before submitting createMyProfile/createCompanyProfile/updateMyProfile/updateCompanyProfile. */
  isHandleAvailable: Scalars['Boolean']['output'];
  isMember: Scalars['Boolean']['output'];
  /** Fetch latest customer billing and return the id */
  latestCustomerBilling: Scalars['Float']['output'];
  listContractsOfGym: Array<ConnectApiRateBundle>;
  message: Message;
  /** Up to 4 random Profile suggestions for the current actor to message, based on CommunityEvents they recently attended together. Excludes profiles already messaged or blocked in either direction. */
  messageSuggestions: Array<MessageSuggestion>;
  /** GYM_APP access devices for the ACS migration tooling. Optional filter by gymId (studio) or serialNumber / providerDeviceId (single device). */
  migrationAccessDevices: Array<MigrationAccessDevice>;
  /** The current actor's own list of blocked profiles. */
  myBlockedProfiles: Array<Profile>;
  /** Returns all finished training sessions for user */
  myFinishedTrainingSessions: Array<TrainingSession>;
  /** The current actor's own profile's pending incoming follow requests. */
  myFollowRequests: Array<FollowRequest>;
  /** The current actor's own personal profile */
  myProfile?: Maybe<Profile>;
  openingHour: OpeningHour;
  openingHours: Array<OpeningHour>;
  /** The current actor's own Conversations, most recent first. */
  paginatedConversation: PaginatedConversation;
  paginatedCustomers: PaginatedCustomers;
  paginatedEventBookings: PaginatedEventbookings;
  /** Paginated Follow edges, e.g. filter by where.followingProfileId for a profile's followers, or where.followerProfileId for who it follows. */
  paginatedFollow: PaginatedFollow;
  paginatedGymRating: PaginatedGymRating;
  /** Paginated Messages, e.g. filter by where.conversationId for a single conversation. */
  paginatedMessage: PaginatedMessage;
  /** The acting customer's own tickets of all sales, in every status, newest first by default. */
  paginatedMyCommunityEventTickets: PaginatedCommunityEventTicket;
  /** Paginated notifications addressed to the current actor's own Profile, newest first. */
  paginatedMyNotifications: PaginatedActivity;
  paginatedTrainingSessions: PaginatedTrainings;
  payoutHistories: Array<PayoutHistory>;
  payoutHistory: PayoutHistory;
  personalFeed: PersonalFeedResponse;
  popup: Popup;
  popupPeriod: PopupPeriod;
  popupPeriods: Array<PopupPeriod>;
  popups: Array<Popup>;
  price: Price;
  prices: Array<Price>;
  profile: Profile;
  promotion: Promotion;
  promotionCode: PromotionCode;
  promotionCodes: Array<PromotionCode>;
  promotions: Array<Promotion>;
  publicCommunityClub: PublicCommunityClubModel;
  publicCommunityClubs: Array<PublicCommunityClubsModel>;
  publicCommunityEvent: PublicCommunityEventModel;
  publicCommunityEventCategories: Array<PublicCommunityEventCategoryModel>;
  publicCommunityEvents: Array<PublicCommunityEventModel>;
  publicCommunityPost: PublicCommunityPostModel;
  publicCommunityPosts: Array<PublicCommunityPostModel>;
  publicContractDetails: ContractDetails;
  publicEvent: PublicEventModel;
  publicEvents: Array<PublicEventModel>;
  publicGym: PublicGymModel;
  publicGymCategories: Array<PublicGymCategoryModel>;
  publicGyms: Array<PublicGymsModel>;
  publicRatingQuestions: Array<PublicRatingQuestion>;
  pushNotification: PushNotification;
  pushNotificationHistories: Array<PushNotificationHistory>;
  pushNotificationHistory: PushNotificationHistory;
  pushNotifications: Array<PushNotification>;
  ratingQuestion: RatingQuestion;
  ratingQuestions: Array<RatingQuestion>;
  receivedCoupon: ReceivedCoupon;
  receivedCoupons: Array<ReceivedCoupon>;
  registrationQuestion: RegistrationQuestion;
  registrationQuestionOption: RegistrationQuestionOption;
  registrationQuestionOptions: Array<RegistrationQuestionOption>;
  registrationQuestions: Array<RegistrationQuestion>;
  report: Report;
  reports: Array<Report>;
  /** Searches Customer/Employee Profiles by handle or full name (contains, case-insensitive) for the message contact search -- e.g. typing a name instead of a known handle. A Customer actor only sees Profiles sharing a CommunityClub with them; an Employee/Business-Owner actor sees any Profile (Customer or coworker) under their own Company/Brand. The actor's own Profile and any Profile blocked in either direction are excluded. Capped at 20 results. */
  searchProfiles: Array<Profile>;
  sendMailToSupport: MailModel;
  subCommunityFeed: SubCommunityFeedResponse;
  trainingSession: TrainingSession;
  trainingSessionTrend: TrendMetric;
  trainingSessions: Array<TrainingSession>;
  /** Returns training sessions for which the billing has not been paid */
  unpaidTrainingSessions: Array<TrainingSession>;
  userPost?: Maybe<UserPost>;
  userPosts: Array<UserPost>;
  workout?: Maybe<Workout>;
  workouts: Array<Workout>;
};


export type QueryActivityArgs = {
  where: ActivityWhereUniqueInput;
};


export type QueryAggregateCustomerBillingArgs = {
  _avg?: InputMaybe<CustomerBillingAvgAggregateInput>;
  _count?: InputMaybe<CustomerBillingCountAggregateInput>;
  _max?: InputMaybe<CustomerBillingMaxAggregateInput>;
  _min?: InputMaybe<CustomerBillingMinAggregateInput>;
  _sum?: InputMaybe<CustomerBillingSumAggregateInput>;
  cursor?: InputMaybe<CustomerBillingWhereUniqueInput>;
  orderBy?: InputMaybe<Array<CustomerBillingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerBillingWhereInput>;
};


export type QueryAggregateTrainingSessionArgs = {
  _avg?: InputMaybe<TrainingSessionAvgAggregateInput>;
  _count?: InputMaybe<TrainingSessionCountAggregateInput>;
  _max?: InputMaybe<TrainingSessionMaxAggregateInput>;
  _min?: InputMaybe<TrainingSessionMinAggregateInput>;
  _sum?: InputMaybe<TrainingSessionSumAggregateInput>;
  cursor?: InputMaybe<TrainingSessionWhereUniqueInput>;
  orderBy?: InputMaybe<Array<TrainingSessionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TrainingSessionWhereInput>;
};


export type QueryAverageTrainingSessionTimeArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  gymId?: InputMaybe<Scalars['UUID']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  timezone?: Scalars['TimeZone']['input'];
};


export type QueryBlockArgs = {
  where: BlockWhereUniqueInput;
};


export type QueryBlocksArgs = {
  cursor?: InputMaybe<BlockWhereUniqueInput>;
  distinct?: InputMaybe<Array<BlockScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BlockOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BlockWhereInput>;
};


export type QueryCircleArgs = {
  where: CircleWhereUniqueInput;
};


export type QueryCirclesArgs = {
  cursor?: InputMaybe<CircleWhereUniqueInput>;
  distinct?: InputMaybe<Array<CircleScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CircleOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CircleWhereInput>;
};


export type QueryCommunityClubArgs = {
  where: CommunityClubWhereUniqueInput;
};


export type QueryCommunityClubOnboardingArgs = {
  where: CommunityClubOnboardingWhereUniqueInput;
};


export type QueryCommunityClubOnboardingEmailExistsArgs = {
  accountEmail: Scalars['String']['input'];
};


export type QueryCommunityClubOnboardingsArgs = {
  cursor?: InputMaybe<CommunityClubOnboardingWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityClubOnboardingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityClubOnboardingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityClubOnboardingWhereInput>;
};


export type QueryCommunityClubsArgs = {
  cursor?: InputMaybe<CommunityClubWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityClubScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityClubOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityClubWhereInput>;
};


export type QueryCommunityEventArgs = {
  where: CommunityEventWhereUniqueInput;
};


export type QueryCommunityEventBookingArgs = {
  where: CommunityEventBookingWhereUniqueInput;
};


export type QueryCommunityEventBookingsArgs = {
  cursor?: InputMaybe<CommunityEventBookingWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityEventBookingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityEventBookingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityEventBookingWhereInput>;
};


export type QueryCommunityEventCategoriesArgs = {
  cursor?: InputMaybe<CommunityEventCategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityEventCategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityEventCategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityEventCategoryWhereInput>;
};


export type QueryCommunityEventCategoryArgs = {
  where: CommunityEventCategoryWhereUniqueInput;
};


export type QueryCommunityEventImageArgs = {
  where: CommunityEventImageWhereUniqueInput;
};


export type QueryCommunityEventImagesArgs = {
  cursor?: InputMaybe<CommunityEventImageWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityEventImageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityEventImageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityEventImageWhereInput>;
};


export type QueryCommunityEventInstanceArgs = {
  where: CommunityEventInstanceWhereUniqueInput;
};


export type QueryCommunityEventInstancesArgs = {
  cursor?: InputMaybe<CommunityEventInstanceWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityEventInstanceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityEventInstanceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityEventInstanceWhereInput>;
};


export type QueryCommunityEventLocationArgs = {
  where: CommunityEventLocationWhereUniqueInput;
};


export type QueryCommunityEventLocationsArgs = {
  cursor?: InputMaybe<CommunityEventLocationWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityEventLocationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityEventLocationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityEventLocationWhereInput>;
};


export type QueryCommunityEventPartnerArgs = {
  where: CommunityEventPartnerWhereUniqueInput;
};


export type QueryCommunityEventPartnersArgs = {
  cursor?: InputMaybe<CommunityEventPartnerWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityEventPartnerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityEventPartnerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityEventPartnerWhereInput>;
};


export type QueryCommunityEventTicketSaleArgs = {
  where: CommunityEventTicketSaleWhereUniqueInput;
};


export type QueryCommunityEventsArgs = {
  cursor?: InputMaybe<CommunityEventWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityEventScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityEventOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityEventWhereInput>;
};


export type QueryCommunityMemberRelationArgs = {
  where: CommunityMemberRelationWhereUniqueInput;
};


export type QueryCommunityMemberRelationsArgs = {
  cursor?: InputMaybe<CommunityMemberRelationWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityMemberRelationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityMemberRelationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityMemberRelationWhereInput>;
};


export type QueryCommunityPostArgs = {
  where: CommunityPostWhereUniqueInput;
};


export type QueryCommunityPostCommentArgs = {
  where: CommunityPostCommentWhereUniqueInput;
};


export type QueryCommunityPostCommentLikeArgs = {
  where: CommunityPostCommentLikeWhereUniqueInput;
};


export type QueryCommunityPostCommentLikesArgs = {
  cursor?: InputMaybe<CommunityPostCommentLikeWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityPostCommentLikeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityPostCommentLikeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityPostCommentLikeWhereInput>;
};


export type QueryCommunityPostCommentsArgs = {
  cursor?: InputMaybe<CommunityPostCommentWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityPostCommentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityPostCommentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityPostCommentWhereInput>;
};


export type QueryCommunityPostLikeArgs = {
  where: CommunityPostLikeWhereUniqueInput;
};


export type QueryCommunityPostLikesArgs = {
  cursor?: InputMaybe<CommunityPostLikeWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityPostLikeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityPostLikeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityPostLikeWhereInput>;
};


export type QueryCommunityPostsArgs = {
  cursor?: InputMaybe<CommunityPostWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityPostScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityPostOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityPostWhereInput>;
};


export type QueryCompaniesArgs = {
  cursor?: InputMaybe<CompanyWhereUniqueInput>;
  distinct?: InputMaybe<Array<CompanyScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CompanyOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CompanyWhereInput>;
};


export type QueryCompanyBillingArgs = {
  where: CompanyBillingWhereUniqueInput;
};


export type QueryCompanyBillingsArgs = {
  cursor?: InputMaybe<CompanyBillingWhereUniqueInput>;
  distinct?: InputMaybe<Array<CompanyBillingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CompanyBillingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CompanyBillingWhereInput>;
};


export type QueryCompanyEmployeeArgs = {
  where: CompanyEmployeeWhereUniqueInput;
};


export type QueryCompanyEmployeesArgs = {
  cursor?: InputMaybe<CompanyEmployeeWhereUniqueInput>;
  distinct?: InputMaybe<Array<CompanyEmployeeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CompanyEmployeeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CompanyEmployeeWhereInput>;
};


export type QueryContractArgs = {
  where: ContractWhereUniqueInput;
};


export type QueryContractsArgs = {
  cursor?: InputMaybe<ContractWhereUniqueInput>;
  distinct?: InputMaybe<Array<ContractScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ContractOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContractWhereInput>;
};


export type QueryConversationArgs = {
  where: ConversationWhereUniqueInput;
};


export type QueryCountBookingsArgs = {
  cursor?: InputMaybe<EventBookingWhereUniqueInput>;
  orderBy?: InputMaybe<Array<EventBookingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventBookingWhereInput>;
};


export type QueryCountCustomerArgs = {
  cursor?: InputMaybe<CustomerWhereUniqueInput>;
  orderBy?: InputMaybe<Array<CustomerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerWhereInput>;
};


export type QueryCountTrainingSessionsArgs = {
  cursor?: InputMaybe<TrainingSessionWhereUniqueInput>;
  orderBy?: InputMaybe<Array<TrainingSessionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TrainingSessionWhereInput>;
};


export type QueryCouponArgs = {
  where: CouponWhereUniqueInput;
};


export type QueryCouponsArgs = {
  cursor?: InputMaybe<CouponWhereUniqueInput>;
  distinct?: InputMaybe<Array<CouponScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CouponOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CouponWhereInput>;
};


export type QueryCustomerArgs = {
  where: CustomerWhereUniqueInput;
};


export type QueryCustomerBillingArgs = {
  where: CustomerBillingWhereUniqueInput;
};


export type QueryCustomerBillingPerDayArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  gymId?: InputMaybe<Scalars['UUID']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  timezone?: Scalars['TimeZone']['input'];
};


export type QueryCustomerBillingTrendArgs = {
  endDate: Scalars['DateTime']['input'];
  gymId?: InputMaybe<Scalars['UUID']['input']>;
  startDate: Scalars['DateTime']['input'];
  timezone?: InputMaybe<Scalars['TimeZone']['input']>;
};


export type QueryCustomerBillingsArgs = {
  cursor?: InputMaybe<CustomerBillingWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomerBillingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomerBillingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerBillingWhereInput>;
};


export type QueryCustomerFreeMinuteGrantArgs = {
  where: CustomerFreeMinuteGrantWhereUniqueInput;
};


export type QueryCustomerFreeMinuteGrantsArgs = {
  cursor?: InputMaybe<CustomerFreeMinuteGrantWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomerFreeMinuteGrantScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomerFreeMinuteGrantOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerFreeMinuteGrantWhereInput>;
};


export type QueryCustomerFreeMinuteUsageArgs = {
  where: CustomerFreeMinuteUsageWhereUniqueInput;
};


export type QueryCustomerFreeMinuteUsagesArgs = {
  cursor?: InputMaybe<CustomerFreeMinuteUsageWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomerFreeMinuteUsageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomerFreeMinuteUsageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerFreeMinuteUsageWhereInput>;
};


export type QueryCustomerPromotionCodeArgs = {
  where: CustomerPromotionCodeWhereUniqueInput;
};


export type QueryCustomerPromotionCodesArgs = {
  cursor?: InputMaybe<CustomerPromotionCodeWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomerPromotionCodeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomerPromotionCodeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerPromotionCodeWhereInput>;
};


export type QueryCustomerTopRankingArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  gymId?: InputMaybe<Scalars['UUID']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  timezone?: Scalars['TimeZone']['input'];
};


export type QueryCustomerTrendArgs = {
  endDate: Scalars['DateTime']['input'];
  gymId?: InputMaybe<Scalars['UUID']['input']>;
  startDate: Scalars['DateTime']['input'];
  timezone?: InputMaybe<Scalars['TimeZone']['input']>;
};


export type QueryCustomersArgs = {
  cursor?: InputMaybe<CustomerWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerWhereInput>;
};


export type QueryEligibleCheckInEventArgs = {
  gymId: Scalars['String']['input'];
};


export type QueryEmailExistsInAuth0Args = {
  connectionName: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type QueryEstimatedPriceArgs = {
  estimatedPriceInput: EstimatedPriceInput;
};


export type QueryEventArgs = {
  where: EventWhereUniqueInput;
};


export type QueryEventBookingArgs = {
  where: EventBookingWhereUniqueInput;
};


export type QueryEventBookingsArgs = {
  cursor?: InputMaybe<EventBookingWhereUniqueInput>;
  distinct?: InputMaybe<Array<EventBookingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<EventBookingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventBookingWhereInput>;
};


export type QueryEventsArgs = {
  cursor?: InputMaybe<EventWhereUniqueInput>;
  distinct?: InputMaybe<Array<EventScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<EventOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventWhereInput>;
};


export type QueryFollowArgs = {
  where: FollowWhereUniqueInput;
};


export type QueryFollowStatusArgs = {
  profileId: Scalars['String']['input'];
};


export type QueryGymArgs = {
  where: GymWhereUniqueInput;
};


export type QueryGymAccessDevicesArgs = {
  where: GymAccessDevicesInput;
};


export type QueryGymAdvantageArgs = {
  where: GymAdvantageWhereUniqueInput;
};


export type QueryGymAdvantagesArgs = {
  cursor?: InputMaybe<GymAdvantageWhereUniqueInput>;
  distinct?: InputMaybe<Array<GymAdvantageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<GymAdvantageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GymAdvantageWhereInput>;
};


export type QueryGymCategoriesArgs = {
  cursor?: InputMaybe<GymCategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<GymCategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<GymCategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GymCategoryWhereInput>;
};


export type QueryGymCategoryArgs = {
  where: GymCategoryWhereUniqueInput;
};


export type QueryGymHighlightOrderArgs = {
  where: GymHighlightOrderWhereUniqueInput;
};


export type QueryGymHighlightOrdersArgs = {
  cursor?: InputMaybe<GymHighlightOrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<GymHighlightOrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<GymHighlightOrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GymHighlightOrderWhereInput>;
};


export type QueryGymHighlightPriceConfigArgs = {
  where: GymHighlightPriceConfigWhereUniqueInput;
};


export type QueryGymHighlightPriceConfigsArgs = {
  cursor?: InputMaybe<GymHighlightPriceConfigWhereUniqueInput>;
  distinct?: InputMaybe<Array<GymHighlightPriceConfigScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<GymHighlightPriceConfigOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GymHighlightPriceConfigWhereInput>;
};


export type QueryGymImageArgs = {
  where: GymImageWhereUniqueInput;
};


export type QueryGymImagesArgs = {
  cursor?: InputMaybe<GymImageWhereUniqueInput>;
  distinct?: InputMaybe<Array<GymImageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<GymImageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GymImageWhereInput>;
};


export type QueryGymRatingArgs = {
  where: GymRatingWhereUniqueInput;
};


export type QueryGymRatingsArgs = {
  cursor?: InputMaybe<GymRatingWhereUniqueInput>;
  distinct?: InputMaybe<Array<GymRatingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<GymRatingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GymRatingWhereInput>;
};


export type QueryGymTopRatingArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  timezone?: Scalars['TimeZone']['input'];
};


export type QueryGymsArgs = {
  cursor?: InputMaybe<GymWhereUniqueInput>;
  distinct?: InputMaybe<Array<GymScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<GymOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GymWhereInput>;
};


export type QueryHealthInsuranceArgs = {
  where: HealthInsuranceWhereUniqueInput;
};


export type QueryHealthInsuranceBalanceArgs = {
  where: HealthInsuranceBalanceWhereUniqueInput;
};


export type QueryHealthInsuranceBalancesArgs = {
  cursor?: InputMaybe<HealthInsuranceBalanceWhereUniqueInput>;
  distinct?: InputMaybe<Array<HealthInsuranceBalanceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<HealthInsuranceBalanceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HealthInsuranceBalanceWhereInput>;
};


export type QueryHealthInsuranceEmployeeArgs = {
  where: HealthInsuranceEmployeeWhereUniqueInput;
};


export type QueryHealthInsuranceEmployeesArgs = {
  cursor?: InputMaybe<HealthInsuranceEmployeeWhereUniqueInput>;
  distinct?: InputMaybe<Array<HealthInsuranceEmployeeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<HealthInsuranceEmployeeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HealthInsuranceEmployeeWhereInput>;
};


export type QueryHealthInsurancePointsConfigArgs = {
  where: HealthInsurancePointsConfigWhereUniqueInput;
};


export type QueryHealthInsurancePointsConfigsArgs = {
  cursor?: InputMaybe<HealthInsurancePointsConfigWhereUniqueInput>;
  distinct?: InputMaybe<Array<HealthInsurancePointsConfigScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<HealthInsurancePointsConfigOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HealthInsurancePointsConfigWhereInput>;
};


export type QueryHealthInsuranceReceivedPointArgs = {
  where: HealthInsuranceReceivedPointWhereUniqueInput;
};


export type QueryHealthInsuranceReceivedPointsArgs = {
  cursor?: InputMaybe<HealthInsuranceReceivedPointWhereUniqueInput>;
  distinct?: InputMaybe<Array<HealthInsuranceReceivedPointScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<HealthInsuranceReceivedPointOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HealthInsuranceReceivedPointWhereInput>;
};


export type QueryHealthInsuranceRedeemedPointArgs = {
  where: HealthInsuranceRedeemedPointWhereUniqueInput;
};


export type QueryHealthInsuranceRedeemedPointsArgs = {
  cursor?: InputMaybe<HealthInsuranceRedeemedPointWhereUniqueInput>;
  distinct?: InputMaybe<Array<HealthInsuranceRedeemedPointScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<HealthInsuranceRedeemedPointOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HealthInsuranceRedeemedPointWhereInput>;
};


export type QueryHealthInsuranceRewardArgs = {
  where: HealthInsuranceRewardWhereUniqueInput;
};


export type QueryHealthInsuranceRewardsArgs = {
  cursor?: InputMaybe<HealthInsuranceRewardWhereUniqueInput>;
  distinct?: InputMaybe<Array<HealthInsuranceRewardScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<HealthInsuranceRewardOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HealthInsuranceRewardWhereInput>;
};


export type QueryHealthInsurancesArgs = {
  cursor?: InputMaybe<HealthInsuranceWhereUniqueInput>;
  distinct?: InputMaybe<Array<HealthInsuranceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<HealthInsuranceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HealthInsuranceWhereInput>;
};


export type QueryIsHandleAvailableArgs = {
  handle: Scalars['String']['input'];
};


export type QueryIsMemberArgs = {
  where: CommunityClubWhereUniqueInput;
};


export type QueryListContractsOfGymArgs = {
  gymId: Scalars['String']['input'];
};


export type QueryMessageArgs = {
  where: MessageWhereUniqueInput;
};


export type QueryMigrationAccessDevicesArgs = {
  where?: InputMaybe<MigrationAccessDevicesInput>;
};


export type QueryOpeningHourArgs = {
  where: OpeningHourWhereUniqueInput;
};


export type QueryOpeningHoursArgs = {
  cursor?: InputMaybe<OpeningHourWhereUniqueInput>;
  distinct?: InputMaybe<Array<OpeningHourScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OpeningHourOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OpeningHourWhereInput>;
};


export type QueryPaginatedConversationArgs = {
  cursor?: InputMaybe<ConversationWhereUniqueInput>;
  distinct?: InputMaybe<Array<ConversationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ConversationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConversationWhereInput>;
};


export type QueryPaginatedCustomersArgs = {
  cursor?: InputMaybe<CustomerWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerWhereInput>;
};


export type QueryPaginatedEventBookingsArgs = {
  cursor?: InputMaybe<EventBookingWhereUniqueInput>;
  distinct?: InputMaybe<Array<EventBookingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<EventBookingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventBookingWhereInput>;
};


export type QueryPaginatedFollowArgs = {
  cursor?: InputMaybe<FollowWhereUniqueInput>;
  distinct?: InputMaybe<Array<FollowScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FollowOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FollowWhereInput>;
};


export type QueryPaginatedGymRatingArgs = {
  cursor?: InputMaybe<GymRatingWhereUniqueInput>;
  distinct?: InputMaybe<Array<GymRatingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<GymRatingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GymRatingWhereInput>;
};


export type QueryPaginatedMessageArgs = {
  cursor?: InputMaybe<MessageWhereUniqueInput>;
  distinct?: InputMaybe<Array<MessageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MessageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MessageWhereInput>;
};


export type QueryPaginatedMyCommunityEventTicketsArgs = {
  cursor?: InputMaybe<CommunityEventTicketWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityEventTicketScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityEventTicketOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityEventTicketWhereInput>;
};


export type QueryPaginatedMyNotificationsArgs = {
  cursor?: InputMaybe<ActivityWhereUniqueInput>;
  distinct?: InputMaybe<Array<ActivityScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ActivityOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActivityWhereInput>;
};


export type QueryPaginatedTrainingSessionsArgs = {
  cursor?: InputMaybe<TrainingSessionWhereUniqueInput>;
  distinct?: InputMaybe<Array<TrainingSessionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TrainingSessionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TrainingSessionWhereInput>;
};


export type QueryPayoutHistoriesArgs = {
  cursor?: InputMaybe<PayoutHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<PayoutHistoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PayoutHistoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PayoutHistoryWhereInput>;
};


export type QueryPayoutHistoryArgs = {
  where: PayoutHistoryWhereUniqueInput;
};


export type QueryPersonalFeedArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPopupArgs = {
  where: PopupWhereUniqueInput;
};


export type QueryPopupPeriodArgs = {
  where: PopupPeriodWhereUniqueInput;
};


export type QueryPopupPeriodsArgs = {
  cursor?: InputMaybe<PopupPeriodWhereUniqueInput>;
  distinct?: InputMaybe<Array<PopupPeriodScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PopupPeriodOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PopupPeriodWhereInput>;
};


export type QueryPopupsArgs = {
  cursor?: InputMaybe<PopupWhereUniqueInput>;
  distinct?: InputMaybe<Array<PopupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PopupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PopupWhereInput>;
};


export type QueryPriceArgs = {
  where: PriceWhereUniqueInput;
};


export type QueryPricesArgs = {
  cursor?: InputMaybe<PriceWhereUniqueInput>;
  distinct?: InputMaybe<Array<PriceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PriceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PriceWhereInput>;
};


export type QueryProfileArgs = {
  where: ProfileWhereUniqueInput;
};


export type QueryPromotionArgs = {
  where: PromotionWhereUniqueInput;
};


export type QueryPromotionCodeArgs = {
  where: PromotionCodeWhereUniqueInput;
};


export type QueryPromotionCodesArgs = {
  cursor?: InputMaybe<PromotionCodeWhereUniqueInput>;
  distinct?: InputMaybe<Array<PromotionCodeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PromotionCodeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PromotionCodeWhereInput>;
};


export type QueryPromotionsArgs = {
  cursor?: InputMaybe<PromotionWhereUniqueInput>;
  distinct?: InputMaybe<Array<PromotionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PromotionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PromotionWhereInput>;
};


export type QueryPublicCommunityClubArgs = {
  where: CommunityClubWhereUniqueInput;
};


export type QueryPublicCommunityClubsArgs = {
  cursor?: InputMaybe<CommunityClubWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityClubScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityClubOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityClubWhereInput>;
};


export type QueryPublicCommunityEventArgs = {
  where: CommunityEventWhereUniqueInput;
};


export type QueryPublicCommunityEventCategoriesArgs = {
  cursor?: InputMaybe<CommunityEventCategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityEventCategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityEventCategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityEventCategoryWhereInput>;
};


export type QueryPublicCommunityEventsArgs = {
  cursor?: InputMaybe<CommunityEventWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityEventScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityEventOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityEventWhereInput>;
};


export type QueryPublicCommunityPostArgs = {
  where: CommunityPostWhereUniqueInput;
};


export type QueryPublicCommunityPostsArgs = {
  cursor?: InputMaybe<CommunityPostWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityPostScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityPostOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityPostWhereInput>;
};


export type QueryPublicContractDetailsArgs = {
  contractId: Scalars['String']['input'];
  gymId: Scalars['String']['input'];
};


export type QueryPublicEventArgs = {
  where: EventWhereUniqueInput;
};


export type QueryPublicEventsArgs = {
  cursor?: InputMaybe<EventWhereUniqueInput>;
  distinct?: InputMaybe<Array<EventScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<EventOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventWhereInput>;
};


export type QueryPublicGymArgs = {
  where: GymWhereUniqueInput;
};


export type QueryPublicGymsArgs = {
  cursor?: InputMaybe<GymWhereUniqueInput>;
  distinct?: InputMaybe<Array<GymScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<GymOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GymWhereInput>;
};


export type QueryPublicRatingQuestionsArgs = {
  where: PublicRatingQuestionWhereInput;
};


export type QueryPushNotificationArgs = {
  where: PushNotificationWhereUniqueInput;
};


export type QueryPushNotificationHistoriesArgs = {
  cursor?: InputMaybe<PushNotificationHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<PushNotificationHistoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PushNotificationHistoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PushNotificationHistoryWhereInput>;
};


export type QueryPushNotificationHistoryArgs = {
  where: PushNotificationHistoryWhereUniqueInput;
};


export type QueryPushNotificationsArgs = {
  cursor?: InputMaybe<PushNotificationWhereUniqueInput>;
  distinct?: InputMaybe<Array<PushNotificationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PushNotificationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PushNotificationWhereInput>;
};


export type QueryRatingQuestionArgs = {
  where: RatingQuestionWhereUniqueInput;
};


export type QueryRatingQuestionsArgs = {
  cursor?: InputMaybe<RatingQuestionWhereUniqueInput>;
  distinct?: InputMaybe<Array<RatingQuestionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RatingQuestionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RatingQuestionWhereInput>;
};


export type QueryReceivedCouponArgs = {
  where: ReceivedCouponWhereUniqueInput;
};


export type QueryReceivedCouponsArgs = {
  cursor?: InputMaybe<ReceivedCouponWhereUniqueInput>;
  distinct?: InputMaybe<Array<ReceivedCouponScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ReceivedCouponOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReceivedCouponWhereInput>;
};


export type QueryRegistrationQuestionArgs = {
  where: RegistrationQuestionWhereUniqueInput;
};


export type QueryRegistrationQuestionOptionArgs = {
  where: RegistrationQuestionOptionWhereUniqueInput;
};


export type QueryRegistrationQuestionOptionsArgs = {
  cursor?: InputMaybe<RegistrationQuestionOptionWhereUniqueInput>;
  distinct?: InputMaybe<Array<RegistrationQuestionOptionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RegistrationQuestionOptionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RegistrationQuestionOptionWhereInput>;
};


export type QueryRegistrationQuestionsArgs = {
  cursor?: InputMaybe<RegistrationQuestionWhereUniqueInput>;
  distinct?: InputMaybe<Array<RegistrationQuestionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RegistrationQuestionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RegistrationQuestionWhereInput>;
};


export type QueryReportArgs = {
  where: ReportWhereUniqueInput;
};


export type QueryReportsArgs = {
  cursor?: InputMaybe<ReportWhereUniqueInput>;
  distinct?: InputMaybe<Array<ReportScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ReportOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReportWhereInput>;
};


export type QuerySearchProfilesArgs = {
  query: Scalars['String']['input'];
};


export type QuerySendMailToSupportArgs = {
  fromMail: Scalars['String']['input'];
  mailType: MailTypes;
  message?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySubCommunityFeedArgs = {
  communityClubId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTrainingSessionArgs = {
  where: TrainingSessionWhereUniqueInput;
};


export type QueryTrainingSessionTrendArgs = {
  endDate: Scalars['DateTime']['input'];
  gymId?: InputMaybe<Scalars['UUID']['input']>;
  startDate: Scalars['DateTime']['input'];
  timezone?: InputMaybe<Scalars['TimeZone']['input']>;
};


export type QueryTrainingSessionsArgs = {
  cursor?: InputMaybe<TrainingSessionWhereUniqueInput>;
  distinct?: InputMaybe<Array<TrainingSessionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TrainingSessionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TrainingSessionWhereInput>;
};


export type QueryUserPostArgs = {
  where: UserPostWhereUniqueInput;
};


export type QueryUserPostsArgs = {
  cursor?: InputMaybe<UserPostWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserPostScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserPostOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserPostWhereInput>;
};


export type QueryWorkoutArgs = {
  where: WorkoutWhereUniqueInput;
};


export type QueryWorkoutsArgs = {
  cursor?: InputMaybe<WorkoutWhereUniqueInput>;
  distinct?: InputMaybe<Array<WorkoutScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<WorkoutOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WorkoutWhereInput>;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type RatingQuestion = {
  __typename: 'RatingQuestion';
  company: Company;
  /** The identifier of the company who created the question */
  companyId: Scalars['String']['output'];
  computedRating: ComputedRating;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** Indicates whether the question is currently active and shown */
  isActive: Scalars['Boolean']['output'];
  /** The text of the rating question shown to customers */
  question: Scalars['String']['output'];
  ratings?: Maybe<Array<GymRating>>;
  /** State of different question */
  type: RatingQuestionType;
  updatedAt: Scalars['DateTime']['output'];
};


export type RatingQuestionComputedRatingArgs = {
  gymId?: InputMaybe<Scalars['UUID']['input']>;
};

export type RatingQuestionActiveStatusUpdateInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RatingQuestionCountAggregate = {
  __typename: 'RatingQuestionCountAggregate';
  _all: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Int']['output'];
  question: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type RatingQuestionCreateInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  question: Scalars['String']['input'];
  ratings?: InputMaybe<GymRatingCreateNestedManyWithoutRatingQuestionInput>;
  type?: InputMaybe<RatingQuestionType>;
};

export type RatingQuestionCreateManyInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  question: Scalars['String']['input'];
  type?: InputMaybe<RatingQuestionType>;
};

export type RatingQuestionCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<RatingQuestionWhereUniqueInput>>;
};

export type RatingQuestionListRelationFilter = {
  every?: InputMaybe<RatingQuestionWhereInput>;
  none?: InputMaybe<RatingQuestionWhereInput>;
  some?: InputMaybe<RatingQuestionWhereInput>;
};

export type RatingQuestionMaxAggregate = {
  __typename: 'RatingQuestionMaxAggregate';
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  type?: Maybe<RatingQuestionType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RatingQuestionMinAggregate = {
  __typename: 'RatingQuestionMinAggregate';
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  type?: Maybe<RatingQuestionType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RatingQuestionNullableScalarRelationFilter = {
  is?: InputMaybe<RatingQuestionWhereInput>;
  isNot?: InputMaybe<RatingQuestionWhereInput>;
};

export type RatingQuestionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type RatingQuestionOrderByWithRelationInput = {
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  companyId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  question?: InputMaybe<SortOrder>;
  ratings?: InputMaybe<GymRatingOrderByRelationAggregateInput>;
  type?: InputMaybe<SortOrder>;
};

export enum RatingQuestionScalarFieldEnum {
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsActive = 'isActive',
  Question = 'question',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export enum RatingQuestionType {
  Bool = 'BOOL',
  Rating = 'RATING'
}

export type RatingQuestionUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<RatingQuestionWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<RatingQuestionWhereUniqueInput>>;
};

export type RatingQuestionWhereInput = {
  AND?: InputMaybe<Array<RatingQuestionWhereInput>>;
  NOT?: InputMaybe<Array<RatingQuestionWhereInput>>;
  OR?: InputMaybe<Array<RatingQuestionWhereInput>>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  isActive?: InputMaybe<BoolFilter>;
  question?: InputMaybe<StringFilter>;
  ratings?: InputMaybe<GymRatingListRelationFilter>;
  type?: InputMaybe<EnumRatingQuestionTypeFilter>;
};

export type RatingQuestionWhereUniqueInput = {
  AND?: InputMaybe<Array<RatingQuestionWhereInput>>;
  NOT?: InputMaybe<Array<RatingQuestionWhereInput>>;
  OR?: InputMaybe<Array<RatingQuestionWhereInput>>;
  company?: InputMaybe<CompanyScalarRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<BoolFilter>;
  question?: InputMaybe<StringFilter>;
  ratings?: InputMaybe<GymRatingListRelationFilter>;
  type?: InputMaybe<EnumRatingQuestionTypeFilter>;
};

export type ReceivedCoupon = {
  __typename: 'ReceivedCoupon';
  /** The coupon associated with the received coupon. */
  coupon: Coupon;
  /** The date an time when a coupon was received. */
  createdAt: Scalars['DateTime']['output'];
  /** The customer associated with the received coupon. */
  customer: Customer;
  /** The unique identifier for the received coupon. */
  id: Scalars['UUID']['output'];
  redeemed: Scalars['Boolean']['output'];
  /** The date and time when the received coupon was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type ReceivedCouponCountAggregate = {
  __typename: 'ReceivedCouponCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  redeemed: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ReceivedCouponListRelationFilter = {
  every?: InputMaybe<ReceivedCouponWhereInput>;
  none?: InputMaybe<ReceivedCouponWhereInput>;
  some?: InputMaybe<ReceivedCouponWhereInput>;
};

export type ReceivedCouponMaxAggregate = {
  __typename: 'ReceivedCouponMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  redeemed?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ReceivedCouponMinAggregate = {
  __typename: 'ReceivedCouponMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  redeemed?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ReceivedCouponOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ReceivedCouponOrderByWithRelationInput = {
  coupon?: InputMaybe<CouponOrderByWithRelationInput>;
  couponId?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export enum ReceivedCouponScalarFieldEnum {
  CouponId = 'couponId',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  Id = 'id',
  Redeemed = 'redeemed',
  UpdatedAt = 'updatedAt'
}

export type ReceivedCouponUpdateManyWithoutCouponNestedInput = {
  connect?: InputMaybe<Array<ReceivedCouponWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<ReceivedCouponWhereUniqueInput>>;
};

export type ReceivedCouponWhereInput = {
  AND?: InputMaybe<Array<ReceivedCouponWhereInput>>;
  NOT?: InputMaybe<Array<ReceivedCouponWhereInput>>;
  OR?: InputMaybe<Array<ReceivedCouponWhereInput>>;
  coupon?: InputMaybe<CouponScalarRelationFilter>;
  couponId?: InputMaybe<UuidFilter>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
};

export type ReceivedCouponWhereUniqueInput = {
  AND?: InputMaybe<Array<ReceivedCouponWhereInput>>;
  NOT?: InputMaybe<Array<ReceivedCouponWhereInput>>;
  OR?: InputMaybe<Array<ReceivedCouponWhereInput>>;
  coupon?: InputMaybe<CouponScalarRelationFilter>;
  couponId?: InputMaybe<UuidFilter>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

/** The end condition of a recurring event. */
export enum RecurrenceEndType {
  Count = 'COUNT',
  Never = 'NEVER',
  Until = 'UNTIL'
}

/** The frequency of a recurring event. */
export enum RecurrenceFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

/** The monthly configuration option for a recurring event. */
export enum RecurrenceMonthOption {
  Day = 'DAY',
  LastWeekday = 'LAST_WEEKDAY',
  Weekday = 'WEEKDAY'
}

export type ReferralConfig = {
  __typename: 'ReferralConfig';
  /** Indicator whether this config is currently active or not */
  active: Scalars['Boolean']['output'];
  /** Creation date of this config */
  createdAt: Scalars['DateTime']['output'];
  customerFreeMinuteGrants?: Maybe<Array<CustomerFreeMinuteGrant>>;
  /** The minutes are credited when successfully refer a friend */
  freeMinutesGrant: Scalars['Int']['output'];
  /** The validity days for the reward minutes */
  freeMinutesValidityDays: Scalars['Int']['output'];
  /** The unique identifier for the referral config. */
  id: Scalars['UUID']['output'];
  /** Last updated of this config */
  updatedAt: Scalars['DateTime']['output'];
};

export type ReferralConfigAvgAggregate = {
  __typename: 'ReferralConfigAvgAggregate';
  freeMinutesGrant?: Maybe<Scalars['Float']['output']>;
  freeMinutesValidityDays?: Maybe<Scalars['Float']['output']>;
};

export type ReferralConfigCountAggregate = {
  __typename: 'ReferralConfigCountAggregate';
  _all: Scalars['Int']['output'];
  active: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  freeMinutesGrant: Scalars['Int']['output'];
  freeMinutesValidityDays: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ReferralConfigMaxAggregate = {
  __typename: 'ReferralConfigMaxAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  freeMinutesGrant?: Maybe<Scalars['Int']['output']>;
  freeMinutesValidityDays?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ReferralConfigMinAggregate = {
  __typename: 'ReferralConfigMinAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  freeMinutesGrant?: Maybe<Scalars['Int']['output']>;
  freeMinutesValidityDays?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ReferralConfigNullableScalarRelationFilter = {
  is?: InputMaybe<ReferralConfigWhereInput>;
  isNot?: InputMaybe<ReferralConfigWhereInput>;
};

export type ReferralConfigOrderByWithRelationInput = {
  active?: InputMaybe<SortOrder>;
  customerFreeMinuteGrants?: InputMaybe<CustomerFreeMinuteGrantOrderByRelationAggregateInput>;
  freeMinutesGrant?: InputMaybe<SortOrder>;
  freeMinutesValidityDays?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type ReferralConfigSumAggregate = {
  __typename: 'ReferralConfigSumAggregate';
  freeMinutesGrant?: Maybe<Scalars['Int']['output']>;
  freeMinutesValidityDays?: Maybe<Scalars['Int']['output']>;
};

export type ReferralConfigWhereInput = {
  AND?: InputMaybe<Array<ReferralConfigWhereInput>>;
  NOT?: InputMaybe<Array<ReferralConfigWhereInput>>;
  OR?: InputMaybe<Array<ReferralConfigWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  customerFreeMinuteGrants?: InputMaybe<CustomerFreeMinuteGrantListRelationFilter>;
  freeMinutesGrant?: InputMaybe<IntFilter>;
  freeMinutesValidityDays?: InputMaybe<IntFilter>;
  id?: InputMaybe<UuidFilter>;
};

/** Input for the host's refund of one paid ticket. */
export type RefundCommunityEventTicketInput = {
  /** The paid ticket to refund, ACTIVE and not scanned. */
  ticketId: Scalars['UUID']['input'];
};

/** Input for registering an invited employee */
export type RegisterCompanyEmployeeInput = {
  communityClubs?: InputMaybe<CommunityClubCreateNestedManyWithoutEmployeesInput>;
  communityPosts?: InputMaybe<CommunityPostCreateNestedManyWithoutAuthorInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gyms?: InputMaybe<GymCreateNestedManyWithoutEmployeesInput>;
  /** The ID of the employees auth0 account */
  id: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/** create input for a company */
export type RegisterCompanyInput = {
  comission?: InputMaybe<Scalars['Float']['input']>;
  communityClubs?: InputMaybe<CommunityClubCreateNestedManyWithoutCompanyInput>;
  communityEventPartners?: InputMaybe<CommunityEventPartnerCreateNestedManyWithoutCompanyInput>;
  companyBillings?: InputMaybe<CompanyBillingCreateNestedManyWithoutCompanyInput>;
  contract?: InputMaybe<ContractCreateNestedManyWithoutCompanyInput>;
  countryCode: Scalars['CountryCode']['input'];
  crmTenant?: InputMaybe<Scalars['String']['input']>;
  customerCommunityClubs?: InputMaybe<CustomerCommunityClubCreateNestedManyWithoutCompanyInput>;
  email: Scalars['EmailAddress']['input'];
  generalTerms?: InputMaybe<Scalars['String']['input']>;
  highlightOrders?: InputMaybe<GymHighlightOrderCreateNestedManyWithoutCompanyInput>;
  houseNumber: Scalars['String']['input'];
  id: Scalars['String']['input'];
  imprint?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationConnection?: InputMaybe<Scalars['String']['input']>;
  organizationName: Scalars['String']['input'];
  owner: NestedEmployeeCreateWithoutCompanyInput;
  place: Scalars['String']['input'];
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  privacyPolicy?: InputMaybe<Scalars['String']['input']>;
  promotionCodes?: InputMaybe<PromotionCodeCreateNestedManyWithoutCompanyInput>;
  promotions?: InputMaybe<PromotionCreateNestedManyWithoutCompanyInput>;
  pushNotifications?: InputMaybe<PushNotificationCreateNestedManyWithoutCompanyInput>;
  ratingQuestions?: InputMaybe<RatingQuestionCreateNestedManyWithoutCompanyInput>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

/** create input for a company */
export type RegisterHealthInsuranceInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['EmailAddress']['input'];
  houseNumber: Scalars['String']['input'];
  id: Scalars['String']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationConnection?: InputMaybe<Scalars['String']['input']>;
  organizationName: Scalars['String']['input'];
  owner: NestedEmployeeCreateWithoutHealthInsuranceInput;
  place: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type RegistrationQuestion = {
  __typename: 'RegistrationQuestion';
  answers?: Maybe<Array<CustomerRegistrationAnswer>>;
  createdAt: Scalars['DateTime']['output'];
  /** The unique identifier */
  id: Scalars['UUID']['output'];
  /** Indicates whether the question is currently active and shown */
  isActive: Scalars['Boolean']['output'];
  options?: Maybe<Array<RegistrationQuestionOption>>;
  /** The display order of the question */
  order: Scalars['Int']['output'];
  /** The German text of the question shown to customers */
  textDe: Scalars['String']['output'];
  /** The English text of the question shown to customers */
  textEn: Scalars['String']['output'];
  /** Whether the customer can select one or multiple options */
  type: RegistrationQuestionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type RegistrationQuestionAvgAggregate = {
  __typename: 'RegistrationQuestionAvgAggregate';
  order?: Maybe<Scalars['Float']['output']>;
};

export type RegistrationQuestionCountAggregate = {
  __typename: 'RegistrationQuestionCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  textDe: Scalars['Int']['output'];
  textEn: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type RegistrationQuestionCreateInput = {
  answers?: InputMaybe<CustomerRegistrationAnswerCreateNestedManyWithoutQuestionInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RegistrationQuestionOptionCreateNestedManyWithoutQuestionInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  textDe: Scalars['String']['input'];
  textEn: Scalars['String']['input'];
  type?: InputMaybe<RegistrationQuestionType>;
};

export type RegistrationQuestionCreateNestedOneWithoutOptionsInput = {
  connect?: InputMaybe<RegistrationQuestionWhereUniqueInput>;
};

export type RegistrationQuestionMaxAggregate = {
  __typename: 'RegistrationQuestionMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  textDe?: Maybe<Scalars['String']['output']>;
  textEn?: Maybe<Scalars['String']['output']>;
  type?: Maybe<RegistrationQuestionType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RegistrationQuestionMinAggregate = {
  __typename: 'RegistrationQuestionMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  textDe?: Maybe<Scalars['String']['output']>;
  textEn?: Maybe<Scalars['String']['output']>;
  type?: Maybe<RegistrationQuestionType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RegistrationQuestionOption = {
  __typename: 'RegistrationQuestionOption';
  answers?: Maybe<Array<CustomerRegistrationAnswer>>;
  createdAt: Scalars['DateTime']['output'];
  /** The unique identifier */
  id: Scalars['UUID']['output'];
  /** Indicates whether the option is currently active and selectable */
  isActive: Scalars['Boolean']['output'];
  /** The display order of the option */
  order: Scalars['Int']['output'];
  question: RegistrationQuestion;
  /** The German text of the option shown to customers */
  textDe: Scalars['String']['output'];
  /** The English text of the option shown to customers */
  textEn: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RegistrationQuestionOptionAvgAggregate = {
  __typename: 'RegistrationQuestionOptionAvgAggregate';
  order?: Maybe<Scalars['Float']['output']>;
};

export type RegistrationQuestionOptionCountAggregate = {
  __typename: 'RegistrationQuestionOptionCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  textDe: Scalars['Int']['output'];
  textEn: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type RegistrationQuestionOptionCreateInput = {
  answers?: InputMaybe<CustomerRegistrationAnswerCreateNestedManyWithoutOptionInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  question: RegistrationQuestionCreateNestedOneWithoutOptionsInput;
  textDe: Scalars['String']['input'];
  textEn: Scalars['String']['input'];
};

export type RegistrationQuestionOptionCreateNestedManyWithoutQuestionInput = {
  connect?: InputMaybe<Array<RegistrationQuestionOptionWhereUniqueInput>>;
};

export type RegistrationQuestionOptionListRelationFilter = {
  every?: InputMaybe<RegistrationQuestionOptionWhereInput>;
  none?: InputMaybe<RegistrationQuestionOptionWhereInput>;
  some?: InputMaybe<RegistrationQuestionOptionWhereInput>;
};

export type RegistrationQuestionOptionMaxAggregate = {
  __typename: 'RegistrationQuestionOptionMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  textDe?: Maybe<Scalars['String']['output']>;
  textEn?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RegistrationQuestionOptionMinAggregate = {
  __typename: 'RegistrationQuestionOptionMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  textDe?: Maybe<Scalars['String']['output']>;
  textEn?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RegistrationQuestionOptionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type RegistrationQuestionOptionOrderByWithRelationInput = {
  answers?: InputMaybe<CustomerRegistrationAnswerOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  question?: InputMaybe<RegistrationQuestionOrderByWithRelationInput>;
  questionId?: InputMaybe<SortOrder>;
  textDe?: InputMaybe<SortOrder>;
  textEn?: InputMaybe<SortOrder>;
};

export enum RegistrationQuestionOptionScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  IsActive = 'isActive',
  Order = 'order',
  QuestionId = 'questionId',
  TextDe = 'textDe',
  TextEn = 'textEn',
  UpdatedAt = 'updatedAt'
}

export type RegistrationQuestionOptionScalarRelationFilter = {
  is?: InputMaybe<RegistrationQuestionOptionWhereInput>;
  isNot?: InputMaybe<RegistrationQuestionOptionWhereInput>;
};

export type RegistrationQuestionOptionSumAggregate = {
  __typename: 'RegistrationQuestionOptionSumAggregate';
  order?: Maybe<Scalars['Int']['output']>;
};

export type RegistrationQuestionOptionUpdateInput = {
  answers?: InputMaybe<CustomerRegistrationAnswerUpdateManyWithoutOptionNestedInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  question?: InputMaybe<RegistrationQuestionUpdateOneRequiredWithoutOptionsNestedInput>;
  textDe?: InputMaybe<Scalars['String']['input']>;
  textEn?: InputMaybe<Scalars['String']['input']>;
};

export type RegistrationQuestionOptionUpdateManyWithoutQuestionNestedInput = {
  connect?: InputMaybe<Array<RegistrationQuestionOptionWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<RegistrationQuestionOptionWhereUniqueInput>>;
};

export type RegistrationQuestionOptionWhereInput = {
  AND?: InputMaybe<Array<RegistrationQuestionOptionWhereInput>>;
  NOT?: InputMaybe<Array<RegistrationQuestionOptionWhereInput>>;
  OR?: InputMaybe<Array<RegistrationQuestionOptionWhereInput>>;
  answers?: InputMaybe<CustomerRegistrationAnswerListRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  isActive?: InputMaybe<BoolFilter>;
  order?: InputMaybe<IntFilter>;
  question?: InputMaybe<RegistrationQuestionScalarRelationFilter>;
  questionId?: InputMaybe<UuidFilter>;
  textDe?: InputMaybe<StringFilter>;
  textEn?: InputMaybe<StringFilter>;
};

export type RegistrationQuestionOptionWhereUniqueInput = {
  AND?: InputMaybe<Array<RegistrationQuestionOptionWhereInput>>;
  NOT?: InputMaybe<Array<RegistrationQuestionOptionWhereInput>>;
  OR?: InputMaybe<Array<RegistrationQuestionOptionWhereInput>>;
  answers?: InputMaybe<CustomerRegistrationAnswerListRelationFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<BoolFilter>;
  order?: InputMaybe<IntFilter>;
  question?: InputMaybe<RegistrationQuestionScalarRelationFilter>;
  questionId?: InputMaybe<UuidFilter>;
  textDe?: InputMaybe<StringFilter>;
  textEn?: InputMaybe<StringFilter>;
};

export type RegistrationQuestionOrderByWithRelationInput = {
  answers?: InputMaybe<CustomerRegistrationAnswerOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  options?: InputMaybe<RegistrationQuestionOptionOrderByRelationAggregateInput>;
  order?: InputMaybe<SortOrder>;
  textDe?: InputMaybe<SortOrder>;
  textEn?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export enum RegistrationQuestionScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  IsActive = 'isActive',
  Order = 'order',
  TextDe = 'textDe',
  TextEn = 'textEn',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type RegistrationQuestionScalarRelationFilter = {
  is?: InputMaybe<RegistrationQuestionWhereInput>;
  isNot?: InputMaybe<RegistrationQuestionWhereInput>;
};

export type RegistrationQuestionSumAggregate = {
  __typename: 'RegistrationQuestionSumAggregate';
  order?: Maybe<Scalars['Int']['output']>;
};

export enum RegistrationQuestionType {
  /** The customer may pick one or more options */
  MultiSelect = 'MULTI_SELECT',
  /** The customer may pick exactly one option */
  SingleSelect = 'SINGLE_SELECT'
}

export type RegistrationQuestionUpdateInput = {
  answers?: InputMaybe<CustomerRegistrationAnswerUpdateManyWithoutQuestionNestedInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RegistrationQuestionOptionUpdateManyWithoutQuestionNestedInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  textDe?: InputMaybe<Scalars['String']['input']>;
  textEn?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<RegistrationQuestionType>;
};

export type RegistrationQuestionUpdateOneRequiredWithoutOptionsNestedInput = {
  connect?: InputMaybe<RegistrationQuestionWhereUniqueInput>;
};

export type RegistrationQuestionWhereInput = {
  AND?: InputMaybe<Array<RegistrationQuestionWhereInput>>;
  NOT?: InputMaybe<Array<RegistrationQuestionWhereInput>>;
  OR?: InputMaybe<Array<RegistrationQuestionWhereInput>>;
  answers?: InputMaybe<CustomerRegistrationAnswerListRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  isActive?: InputMaybe<BoolFilter>;
  options?: InputMaybe<RegistrationQuestionOptionListRelationFilter>;
  order?: InputMaybe<IntFilter>;
  textDe?: InputMaybe<StringFilter>;
  textEn?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumRegistrationQuestionTypeFilter>;
};

export type RegistrationQuestionWhereUniqueInput = {
  AND?: InputMaybe<Array<RegistrationQuestionWhereInput>>;
  NOT?: InputMaybe<Array<RegistrationQuestionWhereInput>>;
  OR?: InputMaybe<Array<RegistrationQuestionWhereInput>>;
  answers?: InputMaybe<CustomerRegistrationAnswerListRelationFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<BoolFilter>;
  options?: InputMaybe<RegistrationQuestionOptionListRelationFilter>;
  order?: InputMaybe<IntFilter>;
  textDe?: InputMaybe<StringFilter>;
  textEn?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumRegistrationQuestionTypeFilter>;
};

export type Report = {
  __typename: 'Report';
  communityClub?: Maybe<CommunityClub>;
  communityPostComment?: Maybe<CommunityPostComment>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dismissedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  reportedAt: Scalars['DateTime']['output'];
  reporterProfile: Profile;
  userPost?: Maybe<UserPost>;
};

export type ReportCommunityPostCommentIdReporterProfileIdCompoundUniqueInput = {
  communityPostCommentId: Scalars['String']['input'];
  reporterProfileId: Scalars['String']['input'];
};

export type ReportCountAggregate = {
  __typename: 'ReportCountAggregate';
  _all: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  dismissedAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  reportedAt: Scalars['Int']['output'];
};

export type ReportCreateNestedManyWithoutCommunityClubInput = {
  connect?: InputMaybe<Array<ReportWhereUniqueInput>>;
};

export type ReportCreateNestedManyWithoutUserPostInput = {
  connect?: InputMaybe<Array<ReportWhereUniqueInput>>;
};

export type ReportListRelationFilter = {
  every?: InputMaybe<ReportWhereInput>;
  none?: InputMaybe<ReportWhereInput>;
  some?: InputMaybe<ReportWhereInput>;
};

export type ReportMaxAggregate = {
  __typename: 'ReportMaxAggregate';
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dismissedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  reportedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ReportMinAggregate = {
  __typename: 'ReportMinAggregate';
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dismissedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  reportedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ReportOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ReportOrderByWithRelationInput = {
  communityClub?: InputMaybe<CommunityClubOrderByWithRelationInput>;
  communityClubId?: InputMaybe<SortOrderInput>;
  communityPostComment?: InputMaybe<CommunityPostCommentOrderByWithRelationInput>;
  communityPostCommentId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  reporterProfile?: InputMaybe<ProfileOrderByWithRelationInput>;
  reporterProfileId?: InputMaybe<SortOrder>;
  userPost?: InputMaybe<UserPostOrderByWithRelationInput>;
  userPostId?: InputMaybe<SortOrderInput>;
};

export enum ReportScalarFieldEnum {
  CommunityClubId = 'communityClubId',
  CommunityPostCommentId = 'communityPostCommentId',
  CompanyId = 'companyId',
  DeletedAt = 'deletedAt',
  DismissedAt = 'dismissedAt',
  Id = 'id',
  ReportedAt = 'reportedAt',
  ReporterProfileId = 'reporterProfileId',
  UserPostId = 'userPostId'
}

export type ReportUpdateManyWithoutCommunityClubNestedInput = {
  connect?: InputMaybe<Array<ReportWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<ReportWhereUniqueInput>>;
};

export type ReportUpdateManyWithoutUserPostNestedInput = {
  connect?: InputMaybe<Array<ReportWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<ReportWhereUniqueInput>>;
};

export type ReportUserPostIdReporterProfileIdCompoundUniqueInput = {
  reporterProfileId: Scalars['String']['input'];
  userPostId: Scalars['String']['input'];
};

export type ReportWhereInput = {
  AND?: InputMaybe<Array<ReportWhereInput>>;
  NOT?: InputMaybe<Array<ReportWhereInput>>;
  OR?: InputMaybe<Array<ReportWhereInput>>;
  communityClub?: InputMaybe<CommunityClubNullableScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidNullableFilter>;
  communityPostComment?: InputMaybe<CommunityPostCommentNullableScalarRelationFilter>;
  communityPostCommentId?: InputMaybe<UuidNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  reporterProfile?: InputMaybe<ProfileScalarRelationFilter>;
  reporterProfileId?: InputMaybe<UuidFilter>;
  userPost?: InputMaybe<UserPostNullableScalarRelationFilter>;
  userPostId?: InputMaybe<UuidNullableFilter>;
};

export type ReportWhereUniqueInput = {
  AND?: InputMaybe<Array<ReportWhereInput>>;
  NOT?: InputMaybe<Array<ReportWhereInput>>;
  OR?: InputMaybe<Array<ReportWhereInput>>;
  communityClub?: InputMaybe<CommunityClubNullableScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidNullableFilter>;
  communityPostComment?: InputMaybe<CommunityPostCommentNullableScalarRelationFilter>;
  communityPostCommentId?: InputMaybe<UuidNullableFilter>;
  communityPostCommentId_reporterProfileId?: InputMaybe<ReportCommunityPostCommentIdReporterProfileIdCompoundUniqueInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  reporterProfile?: InputMaybe<ProfileScalarRelationFilter>;
  reporterProfileId?: InputMaybe<UuidFilter>;
  userPost?: InputMaybe<UserPostNullableScalarRelationFilter>;
  userPostId?: InputMaybe<UuidNullableFilter>;
  userPostId_reporterProfileId?: InputMaybe<ReportUserPostIdReporterProfileIdCompoundUniqueInput>;
};

/** Input for revoking a purchase grant. */
export type RevokeCommunityEventTicketPurchaseGrantInput = {
  /** The grant to revoke, not used yet. */
  id: Scalars['UUID']['input'];
};

/** Input for scanning a community event ticket's QR code. */
export type ScanCommunityEventTicketInput = {
  /** The QR code's text, as scanned. */
  code: Scalars['String']['input'];
  /** The date (instance) being admitted. A ticket for another date answers WRONG_EVENT and stays valid. */
  communityEventInstanceId: Scalars['UUID']['input'];
};

export type SendContractProposalInput = {
  trainingSessionId: Scalars['String']['input'];
};

export type SendContractProposalResult = {
  __typename: 'SendContractProposalResult';
  sent: Scalars['Boolean']['output'];
};

export type SetAccessDeviceMigrationStatusInput = {
  /** The providerDeviceId (= ACS device UUID) of the GYM_APP device. */
  providerDeviceId: Scalars['String']['input'];
  /** The new migration status (NONE | INITIATED | MIGRATED). Transitions are validated. */
  status: AcsMigrationStatus;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortOrderInput = {
  nulls?: InputMaybe<NullsOrder>;
  sort: SortOrder;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StripeCoupon = {
  __typename: 'StripeCoupon';
  /** The percentage of this coupon. The percentage is unique and can only exist once */
  percentage: Scalars['Int']['output'];
};

export type StripeCouponAvgAggregate = {
  __typename: 'StripeCouponAvgAggregate';
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type StripeCouponCountAggregate = {
  __typename: 'StripeCouponCountAggregate';
  _all: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  percentage: Scalars['Int']['output'];
  stripeCouponId: Scalars['Int']['output'];
};

export type StripeCouponMaxAggregate = {
  __typename: 'StripeCouponMaxAggregate';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Int']['output']>;
  stripeCouponId?: Maybe<Scalars['String']['output']>;
};

export type StripeCouponMinAggregate = {
  __typename: 'StripeCouponMinAggregate';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Int']['output']>;
  stripeCouponId?: Maybe<Scalars['String']['output']>;
};

export type StripeCouponOrderByWithRelationInput = {
  description?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  percentage?: InputMaybe<SortOrder>;
  promotionCodes?: InputMaybe<PromotionCodeOrderByRelationAggregateInput>;
  stripeCouponId?: InputMaybe<SortOrder>;
};

export type StripeCouponScalarRelationFilter = {
  is?: InputMaybe<StripeCouponWhereInput>;
  isNot?: InputMaybe<StripeCouponWhereInput>;
};

export type StripeCouponSumAggregate = {
  __typename: 'StripeCouponSumAggregate';
  percentage?: Maybe<Scalars['Int']['output']>;
};

export type StripeCouponWhereInput = {
  AND?: InputMaybe<Array<StripeCouponWhereInput>>;
  NOT?: InputMaybe<Array<StripeCouponWhereInput>>;
  OR?: InputMaybe<Array<StripeCouponWhereInput>>;
  description?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  percentage?: InputMaybe<IntFilter>;
  promotionCodes?: InputMaybe<PromotionCodeListRelationFilter>;
  stripeCouponId?: InputMaybe<StringFilter>;
};

/** A page of a single Community Club's feed (CommunityPost + UserPost). Always shows the latest posts -- unlike the personal feed, there is no read-progress/checkpoint concept here. */
export type SubCommunityFeedResponse = {
  __typename: 'SubCommunityFeedResponse';
  hasNextPage: Scalars['Boolean']['output'];
  items: Array<FeedItem>;
  /** Pass to SubCommunityFeedArgs.cursor to fetch the next page. */
  nextCursor?: Maybe<Scalars['String']['output']>;
};

/** Input for syncing a ticket's dispute state (payment webhook). */
export type SyncCommunityEventTicketDisputeInput = {
  /** The Stripe dispute. */
  stripeDisputeId: Scalars['String']['input'];
};

export type TermDto = {
  __typename: 'TermDto';
  term: Scalars['Float']['output'];
  termUnit: TermUnit;
};

export enum TermUnit {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type TrainingAccessDeviceState = {
  __typename: 'TrainingAccessDeviceState';
  /** The opened device's provider device id (for GYM_APP = the ACS device id) — the key the app matches on. */
  deviceId: Scalars['String']['output'];
};

export type TrainingAccessEventCountAggregate = {
  __typename: 'TrainingAccessEventCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  direction: Scalars['Int']['output'];
  externalRequestId: Scalars['Int']['output'];
  failureMessage: Scalars['Int']['output'];
  failureReason: Scalars['Int']['output'];
  finishedAt: Scalars['Int']['output'];
  gymId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  internalRequestId: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  trainingSessionId: Scalars['Int']['output'];
  trigger: Scalars['Int']['output'];
};

export type TrainingAccessEventMaxAggregate = {
  __typename: 'TrainingAccessEventMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  direction?: Maybe<AccessDirection>;
  externalRequestId?: Maybe<Scalars['String']['output']>;
  failureMessage?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<AccessEventFailureReason>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  gymId?: Maybe<Scalars['UUID']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  internalRequestId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AccessEventStatus>;
  trainingSessionId?: Maybe<Scalars['UUID']['output']>;
  trigger?: Maybe<AccessEventTrigger>;
};

export type TrainingAccessEventMinAggregate = {
  __typename: 'TrainingAccessEventMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  direction?: Maybe<AccessDirection>;
  externalRequestId?: Maybe<Scalars['String']['output']>;
  failureMessage?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<AccessEventFailureReason>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  gymId?: Maybe<Scalars['UUID']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  internalRequestId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AccessEventStatus>;
  trainingSessionId?: Maybe<Scalars['UUID']['output']>;
  trigger?: Maybe<AccessEventTrigger>;
};

export enum TrainingFinishReason {
  ForgotCheckout = 'FORGOT_CHECKOUT',
  TechnicalIssue = 'TECHNICAL_ISSUE',
  TrainingComplained = 'TRAINING_COMPLAINED'
}

export enum TrainingFinishType {
  Automatically = 'AUTOMATICALLY',
  Cancellation = 'CANCELLATION',
  Manually = 'MANUALLY',
  Normal = 'NORMAL',
  NoShow = 'NO_SHOW'
}

export type TrainingPromotionCode = {
  __typename: 'TrainingPromotionCode';
  id: Scalars['ID']['output'];
  /** The percentage for this promotion code */
  percentage: Scalars['Int']['output'];
  /** The name of the promotion code in stripe */
  promotionCode: Scalars['String']['output'];
};

export type TrainingSession = {
  __typename: 'TrainingSession';
  accessState: TrainingSessionAccessState;
  /** Indicates whether a checkout reminder has been sent. */
  checkoutReminderSend: Scalars['Boolean']['output'];
  /** The date and time when the training session record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The customer attending the session. */
  customer: Customer;
  /** The billing record associated with the session. */
  customerBilling?: Maybe<CustomerBilling>;
  /** Training duration in minutes. */
  durationMin?: Maybe<Scalars['Float']['output']>;
  /** The end time of the training session. */
  endTime?: Maybe<Scalars['DateTime']['output']>;
  event?: Maybe<Event>;
  eventId?: Maybe<Scalars['String']['output']>;
  /** An optional field to describe why the training was finished manually */
  finishReason?: Maybe<TrainingFinishReason>;
  /** The way the training was finished */
  finishType: TrainingFinishType;
  freeMinuteUsage?: Maybe<Array<CustomerFreeMinuteUsage>>;
  /** The gym where the session is held. */
  gym: Gym;
  /** The unique identifier for the training session. */
  id: Scalars['UUID']['output'];
  /** The price record for the session. */
  price: Price;
  promotionCode?: Maybe<PromotionCode>;
  /** The start time of the training session. */
  startTime: Scalars['DateTime']['output'];
  /** The date and time when the training session record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The free minutes that should be used for this training. */
  useFreeMinutes?: Maybe<Scalars['Int']['output']>;
  usedPromotionCode?: Maybe<TrainingPromotionCode>;
};

export type TrainingSessionAccessState = {
  __typename: 'TrainingSessionAccessState';
  /** Whether any valid ENTRY exists for the session (incl. a device-less customer confirmation). */
  entryTriggered: Scalars['Boolean']['output'];
  /** Access devices already opened for ENTRY this session (device-less confirmations excluded). For multi-door gyms the app can tell which doors are still pending. */
  entryTriggeredDevices: Array<TrainingAccessDeviceState>;
  /** Whether any valid EXIT exists for the session. */
  exitTriggered: Scalars['Boolean']['output'];
  /** Access devices already opened for EXIT this session (device-less events excluded). */
  exitTriggeredDevices: Array<TrainingAccessDeviceState>;
};

export type TrainingSessionAvgAggregate = {
  __typename: 'TrainingSessionAvgAggregate';
  durationMin?: Maybe<Scalars['Float']['output']>;
  useFreeMinutes?: Maybe<Scalars['Float']['output']>;
};

export type TrainingSessionAvgAggregateInput = {
  durationMin?: InputMaybe<Scalars['Boolean']['input']>;
  useFreeMinutes?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TrainingSessionCountAggregate = {
  __typename: 'TrainingSessionCountAggregate';
  _all: Scalars['Int']['output'];
  checkoutReminderSend: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  durationMin: Scalars['Int']['output'];
  endTime: Scalars['Int']['output'];
  eventId: Scalars['Int']['output'];
  finishReason: Scalars['Int']['output'];
  finishType: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  startTime: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  useFreeMinutes: Scalars['Int']['output'];
};

export type TrainingSessionCountAggregateInput = {
  _all?: InputMaybe<Scalars['Boolean']['input']>;
  checkoutReminderSend?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  customerId?: InputMaybe<Scalars['Boolean']['input']>;
  durationMin?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['Boolean']['input']>;
  eventId?: InputMaybe<Scalars['Boolean']['input']>;
  finishReason?: InputMaybe<Scalars['Boolean']['input']>;
  finishType?: InputMaybe<Scalars['Boolean']['input']>;
  gymId?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  priceId?: InputMaybe<Scalars['Boolean']['input']>;
  promotionCodeId?: InputMaybe<Scalars['Boolean']['input']>;
  startTime?: InputMaybe<Scalars['Boolean']['input']>;
  useFreeMinutes?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Custom input for creating a training session with optional discount code */
export type TrainingSessionCreateInput = {
  event?: InputMaybe<EventCreateNestedOneWithoutSessionsInput>;
  gym: GymCreateNestedOneWithoutTrainingSessionsInput;
  /** Optional: A promotion code for this training session */
  promotionCode?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['DateTime']['input'];
  useFreeMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type TrainingSessionCreateNestedOneWithoutCustomerBillingInput = {
  connect?: InputMaybe<TrainingSessionWhereUniqueInput>;
};

export type TrainingSessionEdge = {
  __typename: 'TrainingSessionEdge';
  cursor: PaginatedTrainingsCursor;
  node: TrainingSession;
};

export type TrainingSessionListRelationFilter = {
  every?: InputMaybe<TrainingSessionWhereInput>;
  none?: InputMaybe<TrainingSessionWhereInput>;
  some?: InputMaybe<TrainingSessionWhereInput>;
};

export type TrainingSessionMaxAggregate = {
  __typename: 'TrainingSessionMaxAggregate';
  checkoutReminderSend?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  durationMin?: Maybe<Scalars['Float']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  eventId?: Maybe<Scalars['String']['output']>;
  finishReason?: Maybe<TrainingFinishReason>;
  finishType?: Maybe<TrainingFinishType>;
  id?: Maybe<Scalars['UUID']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  useFreeMinutes?: Maybe<Scalars['Int']['output']>;
};

export type TrainingSessionMaxAggregateInput = {
  checkoutReminderSend?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  customerId?: InputMaybe<Scalars['Boolean']['input']>;
  durationMin?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['Boolean']['input']>;
  eventId?: InputMaybe<Scalars['Boolean']['input']>;
  finishReason?: InputMaybe<Scalars['Boolean']['input']>;
  finishType?: InputMaybe<Scalars['Boolean']['input']>;
  gymId?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  priceId?: InputMaybe<Scalars['Boolean']['input']>;
  promotionCodeId?: InputMaybe<Scalars['Boolean']['input']>;
  startTime?: InputMaybe<Scalars['Boolean']['input']>;
  useFreeMinutes?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TrainingSessionMinAggregate = {
  __typename: 'TrainingSessionMinAggregate';
  checkoutReminderSend?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  durationMin?: Maybe<Scalars['Float']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  eventId?: Maybe<Scalars['String']['output']>;
  finishReason?: Maybe<TrainingFinishReason>;
  finishType?: Maybe<TrainingFinishType>;
  id?: Maybe<Scalars['UUID']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  useFreeMinutes?: Maybe<Scalars['Int']['output']>;
};

export type TrainingSessionMinAggregateInput = {
  checkoutReminderSend?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  customerId?: InputMaybe<Scalars['Boolean']['input']>;
  durationMin?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['Boolean']['input']>;
  eventId?: InputMaybe<Scalars['Boolean']['input']>;
  finishReason?: InputMaybe<Scalars['Boolean']['input']>;
  finishType?: InputMaybe<Scalars['Boolean']['input']>;
  gymId?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  priceId?: InputMaybe<Scalars['Boolean']['input']>;
  promotionCodeId?: InputMaybe<Scalars['Boolean']['input']>;
  startTime?: InputMaybe<Scalars['Boolean']['input']>;
  useFreeMinutes?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TrainingSessionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TrainingSessionOrderByWithRelationInput = {
  checkoutReminderSend?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerBilling?: InputMaybe<CustomerBillingOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  durationMin?: InputMaybe<SortOrderInput>;
  endTime?: InputMaybe<SortOrderInput>;
  event?: InputMaybe<EventOrderByWithRelationInput>;
  eventId?: InputMaybe<SortOrderInput>;
  finishReason?: InputMaybe<SortOrderInput>;
  finishType?: InputMaybe<SortOrder>;
  freeMinuteUsage?: InputMaybe<CustomerFreeMinuteUsageOrderByRelationAggregateInput>;
  gym?: InputMaybe<GymOrderByWithRelationInput>;
  gymId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  priceId?: InputMaybe<SortOrder>;
  promotionCode?: InputMaybe<PromotionCodeOrderByWithRelationInput>;
  promotionCodeId?: InputMaybe<SortOrderInput>;
  startTime?: InputMaybe<SortOrder>;
  useFreeMinutes?: InputMaybe<SortOrderInput>;
};

export enum TrainingSessionScalarFieldEnum {
  CheckoutReminderSend = 'checkoutReminderSend',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  DurationMin = 'durationMin',
  EndTime = 'endTime',
  EventId = 'eventId',
  FinishReason = 'finishReason',
  FinishType = 'finishType',
  GymId = 'gymId',
  Id = 'id',
  PriceId = 'priceId',
  PromotionCodeId = 'promotionCodeId',
  StartTime = 'startTime',
  UpdatedAt = 'updatedAt',
  UseFreeMinutes = 'useFreeMinutes'
}

export type TrainingSessionScalarRelationFilter = {
  is?: InputMaybe<TrainingSessionWhereInput>;
  isNot?: InputMaybe<TrainingSessionWhereInput>;
};

export type TrainingSessionSumAggregate = {
  __typename: 'TrainingSessionSumAggregate';
  durationMin?: Maybe<Scalars['Float']['output']>;
  useFreeMinutes?: Maybe<Scalars['Int']['output']>;
};

export type TrainingSessionSumAggregateInput = {
  durationMin?: InputMaybe<Scalars['Boolean']['input']>;
  useFreeMinutes?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TrainingSessionUpdateInput = {
  checkoutReminderSend?: InputMaybe<Scalars['Boolean']['input']>;
  customerBilling?: InputMaybe<CustomerBillingUpdateOneWithoutTrainingSessionNestedInput>;
  durationMin?: InputMaybe<Scalars['Float']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  event?: InputMaybe<EventUpdateOneWithoutSessionsNestedInput>;
  finishReason?: InputMaybe<TrainingFinishReason>;
  finishType?: InputMaybe<TrainingFinishType>;
  freeMinuteUsage?: InputMaybe<CustomerFreeMinuteUsageUpdateManyWithoutTrainingSessionNestedInput>;
  gym?: InputMaybe<GymUpdateOneRequiredWithoutTrainingSessionsNestedInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  promotionCode?: InputMaybe<PromotionCodeUpdateOneWithoutTrainingsNestedInput>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  useFreeMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type TrainingSessionUpdateManyWithoutEventNestedInput = {
  connect?: InputMaybe<Array<TrainingSessionWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<TrainingSessionWhereUniqueInput>>;
};

export type TrainingSessionWhereInput = {
  AND?: InputMaybe<Array<TrainingSessionWhereInput>>;
  NOT?: InputMaybe<Array<TrainingSessionWhereInput>>;
  OR?: InputMaybe<Array<TrainingSessionWhereInput>>;
  checkoutReminderSend?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerBilling?: InputMaybe<CustomerBillingNullableScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  durationMin?: InputMaybe<FloatNullableFilter>;
  endTime?: InputMaybe<DateTimeNullableFilter>;
  event?: InputMaybe<EventNullableScalarRelationFilter>;
  eventId?: InputMaybe<UuidNullableFilter>;
  finishReason?: InputMaybe<EnumTrainingFinishReasonNullableFilter>;
  finishType?: InputMaybe<EnumTrainingFinishTypeFilter>;
  freeMinuteUsage?: InputMaybe<CustomerFreeMinuteUsageListRelationFilter>;
  gym?: InputMaybe<GymScalarRelationFilter>;
  gymId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  priceId?: InputMaybe<UuidFilter>;
  promotionCode?: InputMaybe<PromotionCodeNullableScalarRelationFilter>;
  promotionCodeId?: InputMaybe<UuidNullableFilter>;
  startTime?: InputMaybe<DateTimeFilter>;
  useFreeMinutes?: InputMaybe<IntNullableFilter>;
};

export type TrainingSessionWhereUniqueInput = {
  AND?: InputMaybe<Array<TrainingSessionWhereInput>>;
  NOT?: InputMaybe<Array<TrainingSessionWhereInput>>;
  OR?: InputMaybe<Array<TrainingSessionWhereInput>>;
  checkoutReminderSend?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerBilling?: InputMaybe<CustomerBillingNullableScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  durationMin?: InputMaybe<FloatNullableFilter>;
  endTime?: InputMaybe<DateTimeNullableFilter>;
  event?: InputMaybe<EventNullableScalarRelationFilter>;
  eventId?: InputMaybe<UuidNullableFilter>;
  finishReason?: InputMaybe<EnumTrainingFinishReasonNullableFilter>;
  finishType?: InputMaybe<EnumTrainingFinishTypeFilter>;
  freeMinuteUsage?: InputMaybe<CustomerFreeMinuteUsageListRelationFilter>;
  gym?: InputMaybe<GymScalarRelationFilter>;
  gymId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  priceId?: InputMaybe<UuidFilter>;
  promotionCode?: InputMaybe<PromotionCodeNullableScalarRelationFilter>;
  promotionCodeId?: InputMaybe<UuidNullableFilter>;
  startTime?: InputMaybe<DateTimeFilter>;
  useFreeMinutes?: InputMaybe<IntNullableFilter>;
};

export type TrendMetric = {
  __typename: 'TrendMetric';
  dateGroupedCount: Array<DateGroupedCount>;
  periodCount: Scalars['Float']['output'];
  previousPeriodCount: Scalars['Float']['output'];
  trend: Scalars['Float']['output'];
};

/** Input for changing a price tier; omitted fields stay unchanged. */
export type UpdateCommunityEventPriceTierInput = {
  /** The tier to change. */
  id: Scalars['UUID']['input'];
  /** New display name; at most 255 characters. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** New gross price in cents, at least 50. Affects future reservations only. */
  priceInCents?: InputMaybe<Scalars['Int']['input']>;
  /** New number of tickets of this tier, at least 1. */
  quota?: InputMaybe<Scalars['Int']['input']>;
  /** New end of the tier's sales; null removes it. The last tier must not have one. */
  validUntil?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Input for changing a ticket sale's settings; omitted fields stay unchanged. */
export type UpdateCommunityEventTicketSaleInput = {
  /** New quota of free tickets; can be lowered only down to the free tickets already issued. */
  complimentaryQuota?: InputMaybe<Scalars['Int']['input']>;
  /** The ticket sale to change. */
  id: Scalars['UUID']['input'];
  /** New start of advance sales; only until sales have started, before the instance's end and every tier's end. */
  salesStartAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Model that represents errors during update of training sessions */
export type UpdateOpenTrainingSessionErrorModel = {
  __typename: 'UpdateOpenTrainingSessionErrorModel';
  reason: Scalars['String']['output'];
  trainingSessionId: Scalars['String']['output'];
};

/** Input type for update of open training sessions */
export type UpdateOpenTrainingSessionInput = {
  endTime: Scalars['String']['input'];
  id: Scalars['String']['input'];
  reason: TrainingFinishReason;
};

/** Represents the result of updating open training sessions */
export type UpdateOpenTrainingSessionModel = {
  __typename: 'UpdateOpenTrainingSessionModel';
  errors?: Maybe<Array<UpdateOpenTrainingSessionErrorModel>>;
  success: Scalars['Float']['output'];
};

export type UserPost = {
  __typename: 'UserPost';
  _count: UserPostCount;
  authorProfile: Profile;
  communityClub?: Maybe<CommunityClub>;
  communityPostComments?: Maybe<Array<CommunityPostComment>>;
  communityPostLikes?: Maybe<Array<CommunityPostLike>>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Set once `content` is changed via `updateUserPost` -- distinct from `updatedAt`, which also
   * bumps on unrelated writes (e.g. soft-delete). NULL means never edited. Media-only changes
   * (`replaceMedia`) deliberately do NOT set this (Nutzer-Entscheidung 2026-08-20).
   */
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Paginated list of Profiles that liked this post. */
  likedBy: PaginatedLiker;
  media?: Maybe<Array<PostMedia>>;
  /** Profiles mentioned in this post's content. */
  mentionedProfiles: Array<Profile>;
  postType: UserPostType;
  postedAt: Scalars['DateTime']['output'];
  scope: PostScope;
  updatedAt: Scalars['DateTime']['output'];
  workout?: Maybe<Workout>;
};


export type UserPostCommunityPostLikesArgs = {
  cursor?: InputMaybe<CommunityPostLikeWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityPostLikeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityPostLikeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityPostLikeWhereInput>;
};


export type UserPostLikedByArgs = {
  cursor?: InputMaybe<CommunityPostLikeWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommunityPostLikeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommunityPostLikeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityPostLikeWhereInput>;
};


export type UserPostMediaArgs = {
  cursor?: InputMaybe<PostMediaWhereUniqueInput>;
  distinct?: InputMaybe<Array<PostMediaScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PostMediaOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PostMediaWhereInput>;
};

export type UserPostCommentCreateInput = {
  content: Scalars['String']['input'];
  /** A single image or video to attach to the comment. */
  media?: InputMaybe<CommentMediaInput>;
  /** Profiles mentioned in this comment's content. Notified via a MENTIONED activity/push (suppressed for the post's own author, who already gets a COMMENTED activity), up to 3 ids. */
  mentionedProfileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  parentCommentId?: InputMaybe<Scalars['String']['input']>;
  userPost: UserPostCreateNestedOneWithoutCommunityPostCommentsInput;
};

export type UserPostCount = {
  __typename: 'UserPostCount';
  activities: Scalars['Int']['output'];
  communityPostComments: Scalars['Int']['output'];
  communityPostLikes: Scalars['Int']['output'];
  media: Scalars['Int']['output'];
  reports: Scalars['Int']['output'];
};

export type UserPostCountAggregate = {
  __typename: 'UserPostCountAggregate';
  _all: Scalars['Int']['output'];
  content: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  editedAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  postType: Scalars['Int']['output'];
  postedAt: Scalars['Int']['output'];
  scope: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

/** Input for creating a UserPost. Author/company/authorIsPrivate are derived server-side, never from client input. */
export type UserPostCreateInput = {
  activities?: InputMaybe<ActivityCreateNestedManyWithoutUserPostInput>;
  /** Required when scope is SUB_COMMUNITY, ignored otherwise. */
  communityClubId?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  /** Up to 6 media items. */
  media?: InputMaybe<Array<UserPostMediaInput>>;
  /** Profiles mentioned in this post's content. Notified via a MENTIONED activity/push, up to 3 ids. */
  mentionedProfileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  reports?: InputMaybe<ReportCreateNestedManyWithoutUserPostInput>;
  scope: PostScope;
  workout?: InputMaybe<WorkoutCreateNestedOneWithoutUserPostInput>;
};

export type UserPostCreateNestedManyWithoutCommunityClubInput = {
  connect?: InputMaybe<Array<UserPostWhereUniqueInput>>;
};

export type UserPostCreateNestedOneWithoutCommunityPostCommentsInput = {
  connect: UserPostWhereUniqueInput;
};

export type UserPostListRelationFilter = {
  every?: InputMaybe<UserPostWhereInput>;
  none?: InputMaybe<UserPostWhereInput>;
  some?: InputMaybe<UserPostWhereInput>;
};

export type UserPostMaxAggregate = {
  __typename: 'UserPostMaxAggregate';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  postType?: Maybe<UserPostType>;
  postedAt?: Maybe<Scalars['DateTime']['output']>;
  scope?: Maybe<PostScope>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** A single media item to attach to a UserPost. */
export type UserPostMediaInput = {
  /** Only relevant for mediaType=VIDEO. */
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** The image/video file itself. */
  image: ImageInput;
  mediaType: MediaType;
  /** Display order within the post, ascending. Defaults to 0. */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Only relevant for mediaType=VIDEO. */
  thumbnailImage?: InputMaybe<ImageInput>;
};

export type UserPostMinAggregate = {
  __typename: 'UserPostMinAggregate';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  postType?: Maybe<UserPostType>;
  postedAt?: Maybe<Scalars['DateTime']['output']>;
  scope?: Maybe<PostScope>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UserPostNullableScalarRelationFilter = {
  is?: InputMaybe<UserPostWhereInput>;
  isNot?: InputMaybe<UserPostWhereInput>;
};

export type UserPostOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserPostOrderByWithRelationInput = {
  activities?: InputMaybe<ActivityOrderByRelationAggregateInput>;
  authorProfile?: InputMaybe<ProfileOrderByWithRelationInput>;
  authorProfileId?: InputMaybe<SortOrder>;
  communityClub?: InputMaybe<CommunityClubOrderByWithRelationInput>;
  communityClubId?: InputMaybe<SortOrderInput>;
  communityPostComments?: InputMaybe<CommunityPostCommentOrderByRelationAggregateInput>;
  communityPostLikes?: InputMaybe<CommunityPostLikeOrderByRelationAggregateInput>;
  content?: InputMaybe<SortOrderInput>;
  deletedAt?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  media?: InputMaybe<PostMediaOrderByRelationAggregateInput>;
  postType?: InputMaybe<SortOrder>;
  postedAt?: InputMaybe<SortOrder>;
  reports?: InputMaybe<ReportOrderByRelationAggregateInput>;
  scope?: InputMaybe<SortOrder>;
  workout?: InputMaybe<WorkoutOrderByWithRelationInput>;
  workoutId?: InputMaybe<SortOrderInput>;
};

export enum UserPostScalarFieldEnum {
  AuthorIsPrivate = 'authorIsPrivate',
  AuthorProfileId = 'authorProfileId',
  CommunityClubId = 'communityClubId',
  CompanyId = 'companyId',
  Content = 'content',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  EditedAt = 'editedAt',
  Id = 'id',
  PostType = 'postType',
  PostedAt = 'postedAt',
  Scope = 'scope',
  UpdatedAt = 'updatedAt',
  WorkoutId = 'workoutId'
}

export type UserPostScalarRelationFilter = {
  is?: InputMaybe<UserPostWhereInput>;
  isNot?: InputMaybe<UserPostWhereInput>;
};

export enum UserPostType {
  Ad = 'AD',
  Event = 'EVENT',
  ProfileRecommendation = 'PROFILE_RECOMMENDATION',
  UserPost = 'USER_POST',
  Workout = 'WORKOUT'
}

/** Input for updating a UserPost. scope/communityClub are immutable after creation. Passing media replaces the full existing media list. */
export type UserPostUpdateInput = {
  activities?: InputMaybe<ActivityUpdateManyWithoutUserPostNestedInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  /** If provided, replaces the post's full media list. Up to 6 items. */
  media?: InputMaybe<Array<UserPostMediaInput>>;
  /** Profiles mentioned in this post's content. Additive: a Profile already mentioned in an earlier version of this post is not re-notified, only newly added ids trigger a MENTIONED activity/push. Up to 3 ids. */
  mentionedProfileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  reports?: InputMaybe<ReportUpdateManyWithoutUserPostNestedInput>;
  workout?: InputMaybe<WorkoutUpdateOneWithoutUserPostNestedInput>;
};

export type UserPostUpdateManyWithoutCommunityClubNestedInput = {
  connect?: InputMaybe<Array<UserPostWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<UserPostWhereUniqueInput>>;
};

export type UserPostWhereInput = {
  AND?: InputMaybe<Array<UserPostWhereInput>>;
  NOT?: InputMaybe<Array<UserPostWhereInput>>;
  OR?: InputMaybe<Array<UserPostWhereInput>>;
  activities?: InputMaybe<ActivityListRelationFilter>;
  authorProfile?: InputMaybe<ProfileScalarRelationFilter>;
  authorProfileId?: InputMaybe<UuidFilter>;
  communityClub?: InputMaybe<CommunityClubNullableScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidNullableFilter>;
  communityPostComments?: InputMaybe<CommunityPostCommentListRelationFilter>;
  communityPostLikes?: InputMaybe<CommunityPostLikeListRelationFilter>;
  content?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  media?: InputMaybe<PostMediaListRelationFilter>;
  postType?: InputMaybe<EnumUserPostTypeFilter>;
  postedAt?: InputMaybe<DateTimeFilter>;
  reports?: InputMaybe<ReportListRelationFilter>;
  scope?: InputMaybe<EnumPostScopeFilter>;
  workout?: InputMaybe<WorkoutNullableScalarRelationFilter>;
  workoutId?: InputMaybe<UuidNullableFilter>;
};

export type UserPostWhereUniqueInput = {
  AND?: InputMaybe<Array<UserPostWhereInput>>;
  NOT?: InputMaybe<Array<UserPostWhereInput>>;
  OR?: InputMaybe<Array<UserPostWhereInput>>;
  activities?: InputMaybe<ActivityListRelationFilter>;
  authorProfile?: InputMaybe<ProfileScalarRelationFilter>;
  authorProfileId?: InputMaybe<UuidFilter>;
  communityClub?: InputMaybe<CommunityClubNullableScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidNullableFilter>;
  communityPostComments?: InputMaybe<CommunityPostCommentListRelationFilter>;
  communityPostLikes?: InputMaybe<CommunityPostLikeListRelationFilter>;
  content?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  media?: InputMaybe<PostMediaListRelationFilter>;
  postType?: InputMaybe<EnumUserPostTypeFilter>;
  postedAt?: InputMaybe<DateTimeFilter>;
  reports?: InputMaybe<ReportListRelationFilter>;
  scope?: InputMaybe<EnumPostScopeFilter>;
  workout?: InputMaybe<WorkoutNullableScalarRelationFilter>;
  workoutId?: InputMaybe<Scalars['String']['input']>;
};

export type UuidFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedUuidFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UuidNullableFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedUuidNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Workout = {
  __typename: 'Workout';
  authorProfile: Profile;
  avgHeartRate?: Maybe<Scalars['Int']['output']>;
  avgPaceSecondsPerKm?: Maybe<Scalars['Int']['output']>;
  calories?: Maybe<Scalars['Int']['output']>;
  communityClub?: Maybe<CommunityClub>;
  communityEventInstance?: Maybe<CommunityEventInstance>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  distanceMeters?: Maybe<Scalars['Float']['output']>;
  durationSeconds: Scalars['Int']['output'];
  elevationGainMeters?: Maybe<Scalars['Float']['output']>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  /**
   * Free-text, client-populated via reverse geocoding from the route start -- not server-side
   * validated, same as `route`. Masked for non-authors under WorkoutVisibleMetric.LOCATION.
   */
  locationLabel?: Maybe<Scalars['String']['output']>;
  maxHeartRate?: Maybe<Scalars['Int']['output']>;
  provider: WorkoutProvider;
  providerWorkoutId?: Maybe<Scalars['String']['output']>;
  /**
   * Only time series on this model (pace/heart rate/... stay aggregates). Array of
   * `{lat, lng, timestampOffsetSec, altitude?}`.
   */
  route?: Maybe<Scalars['JSON']['output']>;
  /**
   * NULL means the stored route is the untrimmed original (or no route at all).
   * Masked for non-authors under WorkoutVisibleMetric.ROUTE, same as `route`.
   */
  routeTrimmedAt?: Maybe<Scalars['DateTime']['output']>;
  startAt: Scalars['DateTime']['output'];
  /** Profiles tagged as having participated in this workout together. */
  taggedProfiles: Array<Profile>;
  title?: Maybe<Scalars['String']['output']>;
  type: WorkoutType;
  updatedAt: Scalars['DateTime']['output'];
  /** The companion post, if this workout is publicly shared (visibility=PUBLIC). */
  userPost?: Maybe<UserPost>;
  visibility: WorkoutVisibility;
  /**
   * Which metric fields a non-author viewer may see (WorkoutService.maskMetric). Defaults to the
   * app's own toggle defaults when omitted at creation.
   */
  visibleMetrics?: Maybe<Array<WorkoutVisibleMetric>>;
};

export type WorkoutAvgAggregate = {
  __typename: 'WorkoutAvgAggregate';
  avgHeartRate?: Maybe<Scalars['Float']['output']>;
  avgPaceSecondsPerKm?: Maybe<Scalars['Float']['output']>;
  calories?: Maybe<Scalars['Float']['output']>;
  distanceMeters?: Maybe<Scalars['Float']['output']>;
  durationSeconds?: Maybe<Scalars['Float']['output']>;
  elevationGainMeters?: Maybe<Scalars['Float']['output']>;
  maxHeartRate?: Maybe<Scalars['Float']['output']>;
};

export type WorkoutCountAggregate = {
  __typename: 'WorkoutCountAggregate';
  _all: Scalars['Int']['output'];
  avgHeartRate: Scalars['Int']['output'];
  avgPaceSecondsPerKm: Scalars['Int']['output'];
  calories: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  distanceMeters: Scalars['Int']['output'];
  durationSeconds: Scalars['Int']['output'];
  elevationGainMeters: Scalars['Int']['output'];
  endAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  locationLabel: Scalars['Int']['output'];
  maxHeartRate: Scalars['Int']['output'];
  provider: Scalars['Int']['output'];
  providerWorkoutId: Scalars['Int']['output'];
  route: Scalars['Int']['output'];
  routeTrimmedAt: Scalars['Int']['output'];
  startAt: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  visibility: Scalars['Int']['output'];
  visibleMetrics: Scalars['Int']['output'];
};

/** Input for creating a Workout. Author/authorIsPrivate are derived server-side, never from client input. */
export type WorkoutCreateInput = {
  activities?: InputMaybe<ActivityCreateNestedManyWithoutWorkoutInput>;
  avgHeartRate?: InputMaybe<Scalars['Int']['input']>;
  avgPaceSecondsPerKm?: InputMaybe<Scalars['Int']['input']>;
  calories?: InputMaybe<Scalars['Int']['input']>;
  /** Posts the companion post (created when visibility is PUBLIC) into this CommunityClub instead of personally -- same membership rules as a normal SUB_COMMUNITY UserPost. Only allowed when visibility is PUBLIC. */
  communityClubId?: InputMaybe<Scalars['String']['input']>;
  /** Links this workout to a CommunityEventInstance the author attended (a CommunityEventBooking with status=ATTENDED is required, Customer profiles only). */
  communityEventInstanceId?: InputMaybe<Scalars['String']['input']>;
  /** Caption for the companion post created when visibility is PUBLIC. Ignored when visibility is PRIVATE. */
  content?: InputMaybe<Scalars['String']['input']>;
  distanceMeters?: InputMaybe<Scalars['Float']['input']>;
  durationSeconds: Scalars['Int']['input'];
  elevationGainMeters?: InputMaybe<Scalars['Float']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Set when this workout is part of an initial historical backfill (e.g. right after connecting Apple Health/Google Fit for the first time), not a single just-completed workout. Suppresses the "workout imported" push for this create -- without it, backfilling years of history would fire one push per workout. */
  isInitialSync?: InputMaybe<Scalars['Boolean']['input']>;
  locationLabel?: InputMaybe<Scalars['String']['input']>;
  maxHeartRate?: InputMaybe<Scalars['Int']['input']>;
  provider: WorkoutProvider;
  providerWorkoutId?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['JSON']['input']>;
  routeTrimmedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startAt: Scalars['DateTime']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  type: WorkoutType;
  visibility?: InputMaybe<WorkoutVisibility>;
  visibleMetrics?: InputMaybe<Array<WorkoutVisibleMetric>>;
};

export type WorkoutCreateNestedManyWithoutCommunityClubInput = {
  connect?: InputMaybe<Array<WorkoutWhereUniqueInput>>;
};

export type WorkoutCreateNestedOneWithoutUserPostInput = {
  connect?: InputMaybe<WorkoutWhereUniqueInput>;
};

export type WorkoutEdge = {
  __typename: 'WorkoutEdge';
  cursor: PaginatedWorkoutCursor;
  node: Workout;
};

export type WorkoutListRelationFilter = {
  every?: InputMaybe<WorkoutWhereInput>;
  none?: InputMaybe<WorkoutWhereInput>;
  some?: InputMaybe<WorkoutWhereInput>;
};

export type WorkoutMaxAggregate = {
  __typename: 'WorkoutMaxAggregate';
  avgHeartRate?: Maybe<Scalars['Int']['output']>;
  avgPaceSecondsPerKm?: Maybe<Scalars['Int']['output']>;
  calories?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  distanceMeters?: Maybe<Scalars['Float']['output']>;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  elevationGainMeters?: Maybe<Scalars['Float']['output']>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  locationLabel?: Maybe<Scalars['String']['output']>;
  maxHeartRate?: Maybe<Scalars['Int']['output']>;
  provider?: Maybe<WorkoutProvider>;
  providerWorkoutId?: Maybe<Scalars['String']['output']>;
  routeTrimmedAt?: Maybe<Scalars['DateTime']['output']>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<WorkoutType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  visibility?: Maybe<WorkoutVisibility>;
};

export type WorkoutMinAggregate = {
  __typename: 'WorkoutMinAggregate';
  avgHeartRate?: Maybe<Scalars['Int']['output']>;
  avgPaceSecondsPerKm?: Maybe<Scalars['Int']['output']>;
  calories?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  distanceMeters?: Maybe<Scalars['Float']['output']>;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  elevationGainMeters?: Maybe<Scalars['Float']['output']>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  locationLabel?: Maybe<Scalars['String']['output']>;
  maxHeartRate?: Maybe<Scalars['Int']['output']>;
  provider?: Maybe<WorkoutProvider>;
  providerWorkoutId?: Maybe<Scalars['String']['output']>;
  routeTrimmedAt?: Maybe<Scalars['DateTime']['output']>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<WorkoutType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  visibility?: Maybe<WorkoutVisibility>;
};

export type WorkoutNullableScalarRelationFilter = {
  is?: InputMaybe<WorkoutWhereInput>;
  isNot?: InputMaybe<WorkoutWhereInput>;
};

export type WorkoutOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type WorkoutOrderByWithRelationInput = {
  activities?: InputMaybe<ActivityOrderByRelationAggregateInput>;
  authorProfile?: InputMaybe<ProfileOrderByWithRelationInput>;
  authorProfileId?: InputMaybe<SortOrder>;
  avgHeartRate?: InputMaybe<SortOrderInput>;
  avgPaceSecondsPerKm?: InputMaybe<SortOrderInput>;
  calories?: InputMaybe<SortOrderInput>;
  communityClub?: InputMaybe<CommunityClubOrderByWithRelationInput>;
  communityClubId?: InputMaybe<SortOrderInput>;
  communityEventInstance?: InputMaybe<CommunityEventInstanceOrderByWithRelationInput>;
  communityEventInstanceId?: InputMaybe<SortOrderInput>;
  companyId?: InputMaybe<SortOrderInput>;
  deletedAt?: InputMaybe<SortOrderInput>;
  distanceMeters?: InputMaybe<SortOrderInput>;
  durationSeconds?: InputMaybe<SortOrder>;
  elevationGainMeters?: InputMaybe<SortOrderInput>;
  endAt?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  locationLabel?: InputMaybe<SortOrderInput>;
  maxHeartRate?: InputMaybe<SortOrderInput>;
  participants?: InputMaybe<WorkoutParticipantOrderByRelationAggregateInput>;
  provider?: InputMaybe<SortOrder>;
  providerWorkoutId?: InputMaybe<SortOrderInput>;
  route?: InputMaybe<SortOrderInput>;
  routeTrimmedAt?: InputMaybe<SortOrderInput>;
  startAt?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
  userPost?: InputMaybe<UserPostOrderByWithRelationInput>;
  visibility?: InputMaybe<SortOrder>;
  visibleMetrics?: InputMaybe<SortOrder>;
};

export type WorkoutParticipantCountAggregate = {
  __typename: 'WorkoutParticipantCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export type WorkoutParticipantListRelationFilter = {
  every?: InputMaybe<WorkoutParticipantWhereInput>;
  none?: InputMaybe<WorkoutParticipantWhereInput>;
  some?: InputMaybe<WorkoutParticipantWhereInput>;
};

export type WorkoutParticipantMaxAggregate = {
  __typename: 'WorkoutParticipantMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
};

export type WorkoutParticipantMinAggregate = {
  __typename: 'WorkoutParticipantMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
};

export type WorkoutParticipantOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type WorkoutParticipantWhereInput = {
  AND?: InputMaybe<Array<WorkoutParticipantWhereInput>>;
  NOT?: InputMaybe<Array<WorkoutParticipantWhereInput>>;
  OR?: InputMaybe<Array<WorkoutParticipantWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  taggedProfile?: InputMaybe<ProfileScalarRelationFilter>;
  taggedProfileId?: InputMaybe<UuidFilter>;
  workout?: InputMaybe<WorkoutScalarRelationFilter>;
  workoutId?: InputMaybe<UuidFilter>;
};

export enum WorkoutProvider {
  AppleHealth = 'APPLE_HEALTH',
  GoogleFit = 'GOOGLE_FIT',
  Manual = 'MANUAL'
}

export type WorkoutProviderProviderWorkoutIdCompoundUniqueInput = {
  provider: WorkoutProvider;
  providerWorkoutId: Scalars['String']['input'];
};

export enum WorkoutScalarFieldEnum {
  AuthorIsPrivate = 'authorIsPrivate',
  AuthorProfileId = 'authorProfileId',
  AvgHeartRate = 'avgHeartRate',
  AvgPaceSecondsPerKm = 'avgPaceSecondsPerKm',
  Calories = 'calories',
  CommunityClubId = 'communityClubId',
  CommunityEventInstanceId = 'communityEventInstanceId',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  DistanceMeters = 'distanceMeters',
  DurationSeconds = 'durationSeconds',
  ElevationGainMeters = 'elevationGainMeters',
  EndAt = 'endAt',
  Id = 'id',
  LocationLabel = 'locationLabel',
  MaxHeartRate = 'maxHeartRate',
  Provider = 'provider',
  ProviderWorkoutId = 'providerWorkoutId',
  Route = 'route',
  RouteTrimmedAt = 'routeTrimmedAt',
  StartAt = 'startAt',
  Title = 'title',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  Visibility = 'visibility',
  VisibleMetrics = 'visibleMetrics'
}

export type WorkoutScalarRelationFilter = {
  is?: InputMaybe<WorkoutWhereInput>;
  isNot?: InputMaybe<WorkoutWhereInput>;
};

export type WorkoutSumAggregate = {
  __typename: 'WorkoutSumAggregate';
  avgHeartRate?: Maybe<Scalars['Int']['output']>;
  avgPaceSecondsPerKm?: Maybe<Scalars['Int']['output']>;
  calories?: Maybe<Scalars['Int']['output']>;
  distanceMeters?: Maybe<Scalars['Float']['output']>;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  elevationGainMeters?: Maybe<Scalars['Float']['output']>;
  maxHeartRate?: Maybe<Scalars['Int']['output']>;
};

export enum WorkoutType {
  Cycling = 'CYCLING',
  GymWorkout = 'GYM_WORKOUT',
  Hiking = 'HIKING',
  Other = 'OTHER',
  Running = 'RUNNING',
  Swimming = 'SWIMMING',
  Walking = 'WALKING'
}

/** Input for updating a Workout. provider/providerWorkoutId are immutable after creation (re-sync identity). */
export type WorkoutUpdateInput = {
  activities?: InputMaybe<ActivityUpdateManyWithoutWorkoutNestedInput>;
  avgHeartRate?: InputMaybe<Scalars['Int']['input']>;
  avgPaceSecondsPerKm?: InputMaybe<Scalars['Int']['input']>;
  calories?: InputMaybe<Scalars['Int']['input']>;
  /** Posts the companion post into this CommunityClub instead of personally -- same membership rules as a normal SUB_COMMUNITY UserPost. Only allowed when the resulting visibility is PUBLIC. Omit to leave the current target untouched, pass null to detach back to personal. Not sending it while switching visibility away from PUBLIC always detaches it, regardless. */
  communityClubId?: InputMaybe<Scalars['String']['input']>;
  /** Links this workout to a CommunityEventInstance the author attended (a CommunityEventBooking with status=ATTENDED is required, Customer profiles only). Pass null to unlink. */
  communityEventInstanceId?: InputMaybe<Scalars['String']['input']>;
  /** Caption for the companion post, only used when this update creates or revives it (a PRIVATE->PUBLIC transition). Ignored for a pure communityClubId retarget or any other already-live-post update -- to edit an existing companion post's caption, use updateUserPost directly. */
  content?: InputMaybe<Scalars['String']['input']>;
  distanceMeters?: InputMaybe<Scalars['Float']['input']>;
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  elevationGainMeters?: InputMaybe<Scalars['Float']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  locationLabel?: InputMaybe<Scalars['String']['input']>;
  maxHeartRate?: InputMaybe<Scalars['Int']['input']>;
  route?: InputMaybe<Scalars['JSON']['input']>;
  routeTrimmedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<WorkoutType>;
  visibility?: InputMaybe<WorkoutVisibility>;
  visibleMetrics?: InputMaybe<Array<WorkoutVisibleMetric>>;
};

export type WorkoutUpdateManyWithoutCommunityClubNestedInput = {
  connect?: InputMaybe<Array<WorkoutWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<WorkoutWhereUniqueInput>>;
};

export type WorkoutUpdateManyWithoutCommunityEventInstanceNestedInput = {
  connect?: InputMaybe<Array<WorkoutWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<WorkoutWhereUniqueInput>>;
};

export type WorkoutUpdateOneWithoutUserPostNestedInput = {
  connect?: InputMaybe<WorkoutWhereUniqueInput>;
  disconnect?: InputMaybe<WorkoutWhereInput>;
};

export enum WorkoutVisibility {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export enum WorkoutVisibleMetric {
  Calories = 'CALORIES',
  Distance = 'DISTANCE',
  Duration = 'DURATION',
  Elevation = 'ELEVATION',
  HeartRate = 'HEART_RATE',
  Location = 'LOCATION',
  Pace = 'PACE',
  Route = 'ROUTE'
}

export type WorkoutWhereInput = {
  AND?: InputMaybe<Array<WorkoutWhereInput>>;
  NOT?: InputMaybe<Array<WorkoutWhereInput>>;
  OR?: InputMaybe<Array<WorkoutWhereInput>>;
  activities?: InputMaybe<ActivityListRelationFilter>;
  authorProfile?: InputMaybe<ProfileScalarRelationFilter>;
  authorProfileId?: InputMaybe<UuidFilter>;
  avgHeartRate?: InputMaybe<IntNullableFilter>;
  avgPaceSecondsPerKm?: InputMaybe<IntNullableFilter>;
  calories?: InputMaybe<IntNullableFilter>;
  communityClub?: InputMaybe<CommunityClubNullableScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidNullableFilter>;
  communityEventInstance?: InputMaybe<CommunityEventInstanceNullableScalarRelationFilter>;
  communityEventInstanceId?: InputMaybe<UuidNullableFilter>;
  companyId?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  distanceMeters?: InputMaybe<FloatNullableFilter>;
  durationSeconds?: InputMaybe<IntFilter>;
  elevationGainMeters?: InputMaybe<FloatNullableFilter>;
  endAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  locationLabel?: InputMaybe<StringNullableFilter>;
  maxHeartRate?: InputMaybe<IntNullableFilter>;
  participants?: InputMaybe<WorkoutParticipantListRelationFilter>;
  provider?: InputMaybe<EnumWorkoutProviderFilter>;
  providerWorkoutId?: InputMaybe<StringNullableFilter>;
  route?: InputMaybe<JsonNullableFilter>;
  routeTrimmedAt?: InputMaybe<DateTimeNullableFilter>;
  startAt?: InputMaybe<DateTimeFilter>;
  title?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumWorkoutTypeFilter>;
  userPost?: InputMaybe<UserPostNullableScalarRelationFilter>;
  visibility?: InputMaybe<EnumWorkoutVisibilityFilter>;
  visibleMetrics?: InputMaybe<EnumWorkoutVisibleMetricNullableListFilter>;
};

export type WorkoutWhereUniqueInput = {
  AND?: InputMaybe<Array<WorkoutWhereInput>>;
  NOT?: InputMaybe<Array<WorkoutWhereInput>>;
  OR?: InputMaybe<Array<WorkoutWhereInput>>;
  activities?: InputMaybe<ActivityListRelationFilter>;
  authorProfile?: InputMaybe<ProfileScalarRelationFilter>;
  authorProfileId?: InputMaybe<UuidFilter>;
  avgHeartRate?: InputMaybe<IntNullableFilter>;
  avgPaceSecondsPerKm?: InputMaybe<IntNullableFilter>;
  calories?: InputMaybe<IntNullableFilter>;
  communityClub?: InputMaybe<CommunityClubNullableScalarRelationFilter>;
  communityClubId?: InputMaybe<UuidNullableFilter>;
  communityEventInstance?: InputMaybe<CommunityEventInstanceNullableScalarRelationFilter>;
  communityEventInstanceId?: InputMaybe<UuidNullableFilter>;
  companyId?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  distanceMeters?: InputMaybe<FloatNullableFilter>;
  durationSeconds?: InputMaybe<IntFilter>;
  elevationGainMeters?: InputMaybe<FloatNullableFilter>;
  endAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationLabel?: InputMaybe<StringNullableFilter>;
  maxHeartRate?: InputMaybe<IntNullableFilter>;
  participants?: InputMaybe<WorkoutParticipantListRelationFilter>;
  provider?: InputMaybe<EnumWorkoutProviderFilter>;
  providerWorkoutId?: InputMaybe<StringNullableFilter>;
  provider_providerWorkoutId?: InputMaybe<WorkoutProviderProviderWorkoutIdCompoundUniqueInput>;
  route?: InputMaybe<JsonNullableFilter>;
  routeTrimmedAt?: InputMaybe<DateTimeNullableFilter>;
  startAt?: InputMaybe<DateTimeFilter>;
  title?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumWorkoutTypeFilter>;
  userPost?: InputMaybe<UserPostNullableScalarRelationFilter>;
  visibility?: InputMaybe<EnumWorkoutVisibilityFilter>;
  visibleMetrics?: InputMaybe<EnumWorkoutVisibleMetricNullableListFilter>;
};

export type CircleFieldsFragment = { __typename: 'Circle', id: string, mediaType: MediaType, key: string, url: string, thumbnailUrl?: string | null, durationSeconds?: number | null, text?: string | null, link?: string | null, expiresAt: Date | string, createdAt: Date | string, authorProfile: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null }, _count: { __typename: 'CircleCount', circleViews: number } };

export type CommunityClubPickerFieldsFragment = { __typename: 'CommunityClub', id: string, name: string };

export type CommunityClubFieldsFragment = { __typename: 'CommunityClub', id: string, name: string, description?: string | null, s3LogoKey?: string | null, s3LogoUrl?: string | null, s3CoverImageKey?: string | null, s3CoverImageUrl?: string | null, zipcode: string, place: string, street: string, houseNumber: string, latitude: string, longitude: string, createdAt: Date | string, updatedAt: Date | string, memberCount: number, plannedEventsCount: number, membersCanPost: boolean, ticketingEnabled: boolean, profile?: { __typename: 'Profile', id: string, handle: string } | null };

export type CommunityEventBookingInfoFragment = { __typename: 'CommunityEventBooking', id: string, status: CommunityEventBookingStatus, communityEventInstance: { __typename: 'CommunityEventInstance', id: string, startAt: Date | string, endAt?: Date | string | null, communityEvent: { __typename: 'CommunityEvent', id: string, name: string } } };

export type CommunityEventBookingParticipantFieldsFragment = { __typename: 'CommunityEventBooking', id: string, status: CommunityEventBookingStatus, customer: { __typename: 'Customer', id: string, firstName: string, lastName: string, email: string, profile?: { __typename: 'Profile', id: string, handle: string } | null } };

export type CommunityEventBookingFieldsFragment = { __typename: 'CommunityEventBooking', id: string, status: CommunityEventBookingStatus, communityEventInstance: { __typename: 'CommunityEventInstance', id: string, startAt: Date | string, endAt?: Date | string | null }, customer: { __typename: 'Customer', id: string, firstName: string, lastName: string } };

export type CommunityEventCategoryFieldsFragment = { __typename: 'CommunityEventCategory', id: string, name: string, description?: string | null, iconName?: string | null };

export type CommunityEventImageFieldsFragment = { __typename: 'CommunityEventImage', id: string, s3ImageUrl: string, communityEvent: { __typename: 'CommunityEvent', id: string } };

export type CommunityEventInstanceAttendanceFieldsFragment = { __typename: 'CommunityEventInstance', id: string, startAt: Date | string, endAt?: Date | string | null, attendance: { __typename: 'CommunityEventInstanceAttendance', registeredCount: number, checkedInCount: number, noShowCount: number } };

export type CommunityEventInstanceFieldsFragment = { __typename: 'CommunityEventInstance', id: string, startAt: Date | string, endAt?: Date | string | null };

export type CommunityEventLocationFieldsFragment = { __typename: 'CommunityEventLocation', id: string, name: string, zipcode: string, place: string, street: string, houseNumber: string, latitude: string, longitude: string, communityClub: { __typename: 'CommunityClub', id: string } };

export type CommunityEventPartnerFieldsFragment = { __typename: 'CommunityEventPartner', id: string, name: string, description?: string | null, s3LogoKey?: string | null, s3LogoUrl?: string | null, street: string, houseNumber: string, zipcode: string, place: string, latitude: string, longitude: string };

export type CommunityEventPriceTierFieldsFragment = { __typename: 'CommunityEventPriceTier', id: string, name: string, priceInCents: number, sortOrder: number, quota: number, validUntil?: Date | string | null, closedAt?: Date | string | null };

export type CommunityEventTicketFieldsFragment = { __typename: 'CommunityEventTicket', id: string, status: CommunityEventTicketStatus, source: CommunityEventTicketSource, priceInCents: number, issuedAt: Date | string, usedAt?: Date | string | null, refundRequestedAt?: Date | string | null, refundedAt?: Date | string | null, priceTier?: { __typename: 'CommunityEventPriceTier', id: string, name: string } | null, customer?: { __typename: 'Customer', id: string, firstName: string, lastName: string } | null };

export type CommunityEventTicketPurchaseGrantFieldsFragment = { __typename: 'CommunityEventTicketPurchaseGrant', id: string, validUntil?: Date | string | null, usedAt?: Date | string | null, revokedAt?: Date | string | null, createdAt: Date | string, priceTier: { __typename: 'CommunityEventPriceTier', id: string, name: string, priceInCents: number }, customer?: { __typename: 'Customer', id: string, firstName: string, lastName: string } | null };

export type CommunityEventTicketSaleFieldsFragment = { __typename: 'CommunityEventTicketSale', id: string, salesStartAt: Date | string, rescheduledAt?: Date | string | null, canceledAt?: Date | string | null, complimentaryQuota: number, availableTicketCount?: number | null, communityClub: { __typename: 'CommunityClub', id: string }, activePriceTier?: { __typename: 'CommunityEventPriceTier', id: string, name: string, priceInCents: number, sortOrder: number, quota: number, validUntil?: Date | string | null, closedAt?: Date | string | null } | null, priceTiers?: Array<{ __typename: 'CommunityEventPriceTier', id: string, name: string, priceInCents: number, sortOrder: number, quota: number, validUntil?: Date | string | null, closedAt?: Date | string | null }> | null, reservations?: Array<{ __typename: 'CommunityEventTicketReservation', id: string, status: CommunityEventTicketReservationStatus }> | null, queueEntries?: Array<{ __typename: 'CommunityEventTicketQueueEntry', id: string }> | null };

export type CommunityEventFieldsFragment = { __typename: 'CommunityEvent', id: string, name: string, description?: string | null, isActive: boolean, isLimited: boolean, isDraft: boolean, isPaid: boolean, durationMin?: number | null, s3HeaderImageKey?: string | null, s3HeaderImageUrl?: string | null, maxParticipants?: number | null, advanceGenerationDays: number, recurrenceFreq?: RecurrenceFrequency | null, recurrenceInterval?: number | null, recurrenceStartDate?: Date | string | null, recurrenceEndType?: RecurrenceEndType | null, recurrenceUntil?: Date | string | null, recurrenceCount?: number | null, recurrenceByweekday?: Array<number> | null, recurrenceMonthOption?: RecurrenceMonthOption | null, communityClub: { __typename: 'CommunityClub', id: string, name: string }, communityEventPartner?: { __typename: 'CommunityEventPartner', id: string, name: string } | null, communityEventLocation: { __typename: 'CommunityEventLocation', id: string, name: string }, communityEventCategory?: { __typename: 'CommunityEventCategory', id: string, name: string, iconName?: string | null } | null, host?: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } | null };

export type CommunityPostCommentFieldsFragment = { __typename: 'CommunityPostComment', id: string, content: string, customer?: { __typename: 'Customer', firstName: string, lastName: string } | null, profile?: { __typename: 'Profile', fullName?: string | null } | null };

export type CommunityPostFieldsFragment = { __typename: 'CommunityPost', id: string, title?: string | null, content: string, postedAt: Date | string, s3ImageUrl?: string | null, author?: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } | null, communityClub: { __typename: 'CommunityClub', id: string, name: string }, _count: { __typename: 'CommunityPostCount', communityPostLikes: number, communityPostComments: number } };

export type ReportFieldsFragment = { __typename: 'Report', id: string, reportedAt: Date | string, reporterProfile: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null }, communityClub?: { __typename: 'CommunityClub', id: string, name: string } | null, userPost?: { __typename: 'UserPost', id: string, content?: string | null, scope: PostScope, postedAt: Date | string, authorProfile: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null }, media?: Array<{ __typename: 'PostMedia', id: string, mediaType: MediaType, url: string, thumbnailUrl?: string | null, position: number }> | null } | null, communityPostComment?: { __typename: 'CommunityPostComment', id: string, content: string, userPost?: { __typename: 'UserPost', id: string } | null, profile?: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } | null, customer?: { __typename: 'Customer', firstName: string, lastName: string } | null } | null };

export type UserPostFieldsFragment = { __typename: 'UserPost', id: string, scope: PostScope, postType: UserPostType, content?: string | null, postedAt: Date | string, authorProfile: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null }, communityClub?: { __typename: 'CommunityClub', id: string, name: string } | null, media?: Array<{ __typename: 'PostMedia', id: string, mediaType: MediaType, url: string, thumbnailUrl?: string | null, durationSeconds?: number | null, position: number }> | null, _count: { __typename: 'UserPostCount', communityPostLikes: number, communityPostComments: number } };

export type CompanyAddressFieldsFragment = { __typename: 'Company', street: string, houseNumber: string, place: string, zipcode: string };

export type CompanyInformationFieldsFragment = { __typename: 'Company', name: string, email: string, comission: number, primaryColor?: string | null, secondaryColor?: string | null, id: string, logoUrl?: string | null, street: string, houseNumber: string, place: string, zipcode: string };

export type CompanyFieldsFragment = { __typename: 'Company', id: string, logoUrl?: string | null };

export type ConversationFieldsFragment = { __typename: 'Conversation', id: string, hasUnreadMessages: boolean, lastMessageAt?: Date | string | null, createdAt: Date | string, otherProfile: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null }, lastMessage?: { __typename: 'Message', id: string, content?: string | null, sentAt: Date | string, deletedAt?: Date | string | null, locationLabel?: string | null, locationAddress?: string | null, locationLatitude?: number | null, locationLongitude?: number | null, senderProfile?: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } | null, media: Array<{ __typename: 'MessageMedia', id: string, mediaType: MediaType, key: string, url: string, thumbnailUrl?: string | null, durationSeconds?: number | null, position: number }>, sharedCommunityEvent?: { __typename: 'CommunityEvent', id: string, name: string } | null, sharedCommunityEventInstance?: { __typename: 'CommunityEventInstance', id: string, startAt: Date | string } | null } | null };

export type PaginatedConversationFieldsFragment = { __typename: 'PaginatedConversation', hasNextPage: boolean, totalCount: number, nodes: Array<{ __typename: 'Conversation', id: string, hasUnreadMessages: boolean, lastMessageAt?: Date | string | null, createdAt: Date | string, otherProfile: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null }, lastMessage?: { __typename: 'Message', id: string, content?: string | null, sentAt: Date | string, deletedAt?: Date | string | null, locationLabel?: string | null, locationAddress?: string | null, locationLatitude?: number | null, locationLongitude?: number | null, senderProfile?: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } | null, media: Array<{ __typename: 'MessageMedia', id: string, mediaType: MediaType, key: string, url: string, thumbnailUrl?: string | null, durationSeconds?: number | null, position: number }>, sharedCommunityEvent?: { __typename: 'CommunityEvent', id: string, name: string } | null, sharedCommunityEventInstance?: { __typename: 'CommunityEventInstance', id: string, startAt: Date | string } | null } | null }>, edges?: Array<{ __typename: 'ConversationEdge', cursor: { __typename: 'PaginatedConversationCursor', id?: string | null } }> | null };

export type CustomerPromotionCodeFieldsFragment = { __typename: 'CustomerPromotionCode', id: string, promoCode: string, usageCount: number, promotionCode: { __typename: 'PromotionCode', promotionCode: string, percentage: number } };

export type CustomerTopRankingFieldsFragment = { __typename: 'CustomerTopRanking', firstName: string, lastName: string, email: string, salesTotal: number, trainingsTotal: number };

export type CustomerFieldsFragment = { __typename: 'Customer', id: string, firstName: string, lastName: string, email: string, dateOfBirth: Date | string, zipcode: string, street: string, houseNumber: string, place: string, mobileNumber: string, verified: boolean, createdAt: Date | string };

export type PaginatedCustomerFieldsFragment = { __typename: 'PaginatedCustomers', hasNextPage: boolean, totalCount: number, nodes: Array<{ __typename: 'Customer', id: string, firstName: string, lastName: string, email: string, dateOfBirth: Date | string, zipcode: string, street: string, houseNumber: string, place: string, mobileNumber: string, verified: boolean, createdAt: Date | string }>, edges?: Array<{ __typename: 'CustomerEdge', cursor: { __typename: 'PaginatedCustomersCursor', id?: string | null } }> | null };

export type DashboardCustomerBillingsFragment = { __typename: 'CustomerBilling', id: number, paidPrice?: number | null, status: BillingStatus, isPaid: boolean, createdAt: Date | string };

export type DashboardCustomersFragment = { __typename: 'Customer', id: string, firstName: string, lastName: string, createdAt: Date | string, dateOfBirth: Date | string };

export type DashboardTrainingSessionsFragment = { __typename: 'TrainingSession', id: string, startTime: Date | string, endTime?: Date | string | null, createdAt: Date | string };

export type DashboardGymTrainingSessionsFragment = { __typename: 'Gym', name: string, trainingSessions?: Array<{ __typename: 'TrainingSession', id: string, customerBilling?: { __typename: 'CustomerBilling', paidPrice?: number | null } | null }> | null };

export type CompanyEmployeeFieldsFragment = { __typename: 'CompanyEmployee', id: string, firstName?: string | null, lastName?: string | null, email: string, userType: EmployeeUserType, status: EmployeeStatus, gyms?: Array<{ __typename: 'Gym', name: string }> | null, communityClubs?: Array<{ __typename: 'CommunityClub', name: string }> | null, profile?: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } | null };

export type EventBookingFieldsFragment = { __typename: 'EventBooking', id: string, createdAt: Date | string, status: EventBookingStatus, customer: { __typename: 'Customer', id: string, firstName: string, lastName: string, email: string }, event: { __typename: 'Event', id: string, name: string, duration: number, startAt: Date | string, price?: { __typename: 'Price', id: string, price: number, pricingModel: PricingModel } | null }, gym: { __typename: 'Gym', id: string, name: string } };

export type EventFieldsFragment = { __typename: 'Event', id: string, name: string, description?: string | null, startAt: Date | string, endAt: Date | string, maxParticipants: number, createdAt: Date | string, updatedAt: Date | string, price?: { __typename: 'Price', id: string, price: number, pricingModel: PricingModel } | null, gym: { __typename: 'Gym', id: string, name: string }, _count: { __typename: 'EventCount', bookings: number, sessions: number } };

export type PaginatedEventBookingsFieldsFragment = { __typename: 'PaginatedEventbookings', hasNextPage: boolean, totalCount: number, nodes: Array<{ __typename: 'EventBooking', id: string, createdAt: Date | string, status: EventBookingStatus, customer: { __typename: 'Customer', id: string, firstName: string, lastName: string, email: string }, event: { __typename: 'Event', id: string, name: string, duration: number, startAt: Date | string, price?: { __typename: 'Price', id: string, price: number, pricingModel: PricingModel } | null }, gym: { __typename: 'Gym', id: string, name: string } }>, edges?: Array<{ __typename: 'EventBookingEdge', cursor: { __typename: 'PaginatedEventbookingsCursor', id?: string | null } }> | null };

export type GymAdvantageFieldsFragment = { __typename: 'GymAdvantage', id: string, name: string };

export type GymCategoryFieldsFragment = { __typename: 'GymCategory', id: string, name: string, description?: string | null };

export type GymForHighlightFieldsFragment = { __typename: 'Gym', id: string, name: string };

export type GymHighlightOrderFieldsFragment = { __typename: 'GymHighlightOrder', id: string, status: GymHighlightOrderStatus, startDate: string, endDate: string, amountPerGymInCents: number, totalAmountInCents: number, createdAt: Date | string, gyms: Array<{ __typename: 'Gym', id: string, name: string }>, companyBilling?: { __typename: 'CompanyBilling', id: string, invoiceNumber?: string | null, pdfKey?: string | null } | null };

export type GymHighlightPriceConfigFieldsFragment = { __typename: 'GymHighlightPriceConfig', id: string, active: boolean, mondayCents: number, tuesdayCents: number, wednesdayCents: number, thursdayCents: number, fridayCents: number, saturdayCents: number, sundayCents: number };

export type GymImageFieldsFragment = { __typename: 'GymImage', id: string, s3Key: string, s3ImageUrl: string, createdAt: Date | string, updatedAt: Date | string, gymId: string };

export type GymRatingFieldsFragment = { __typename: 'GymRating', id: string, rating: number, comment?: string | null, createdAt: Date | string, updatedAt: Date | string, customer: { __typename: 'Customer', id: string, firstName: string, lastName: string, email: string, dateOfBirth: Date | string, zipcode: string, street: string, houseNumber: string, place: string, mobileNumber: string, verified: boolean, createdAt: Date | string } };

export type GymAccessDeviceFieldsFragment = { __typename: 'GymAccessDevice', id: string, name: string, canOpenEntry: boolean, canOpenExit: boolean };

export type GymPickerFieldsFragment = { __typename: 'Gym', id: string, name: string };

export type GymTopRatingFieldsFragment = { __typename: 'GymTopRating', id: string, name: string, overallTotalRating: number };

export type GymFieldsFragment = { __typename: 'Gym', id: string, name: string, type: GymType, zipcode: string, place: string, street: string, houseNumber: string, latitude: string, longitude: string, qrcode: string, weeklySessionLimit?: number | null, minTrainingDuration: number, description?: string | null, createdAt: Date | string, updatedAt: Date | string, averageRating: number, advantages?: Array<{ __typename: 'GymAdvantage', id: string, name: string }> | null, price?: { __typename: 'Price', id: string, price: number, pricingModel: PricingModel } | null, category?: { __typename: 'GymCategory', id: string, name: string, description?: string | null } | null, images?: Array<{ __typename: 'GymImage', id: string, s3Key: string, s3ImageUrl: string, createdAt: Date | string, updatedAt: Date | string, gymId: string }> | null, events?: Array<{ __typename: 'Event', id: string, name: string, description?: string | null, startAt: Date | string, endAt: Date | string, maxParticipants: number, createdAt: Date | string, updatedAt: Date | string, price?: { __typename: 'Price', id: string, price: number, pricingModel: PricingModel } | null, gym: { __typename: 'Gym', id: string, name: string }, _count: { __typename: 'EventCount', bookings: number, sessions: number } }> | null, _count: { __typename: 'GymCount', events: number } };

export type GymsForPromotionsFieldsFragment = { __typename: 'Gym', id: string, name: string, promotion?: { __typename: 'Promotion', id: string, name?: string | null } | null };

export type MessageFieldsFragment = { __typename: 'Message', id: string, content?: string | null, sentAt: Date | string, deletedAt?: Date | string | null, locationLabel?: string | null, locationAddress?: string | null, locationLatitude?: number | null, locationLongitude?: number | null, senderProfile?: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } | null, media: Array<{ __typename: 'MessageMedia', id: string, mediaType: MediaType, key: string, url: string, thumbnailUrl?: string | null, durationSeconds?: number | null, position: number }>, sharedCommunityEvent?: { __typename: 'CommunityEvent', id: string, name: string } | null, sharedCommunityEventInstance?: { __typename: 'CommunityEventInstance', id: string, startAt: Date | string } | null };

export type PaginatedMessageFieldsFragment = { __typename: 'PaginatedMessage', hasNextPage: boolean, totalCount: number, nodes: Array<{ __typename: 'Message', id: string, content?: string | null, sentAt: Date | string, deletedAt?: Date | string | null, locationLabel?: string | null, locationAddress?: string | null, locationLatitude?: number | null, locationLongitude?: number | null, senderProfile?: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } | null, media: Array<{ __typename: 'MessageMedia', id: string, mediaType: MediaType, key: string, url: string, thumbnailUrl?: string | null, durationSeconds?: number | null, position: number }>, sharedCommunityEvent?: { __typename: 'CommunityEvent', id: string, name: string } | null, sharedCommunityEventInstance?: { __typename: 'CommunityEventInstance', id: string, startAt: Date | string } | null }>, edges?: Array<{ __typename: 'MessageEdge', cursor: { __typename: 'PaginatedMessageCursor', id?: string | null } }> | null };

export type OpeningHourFieldsFragment = { __typename: 'OpeningHour', id: string, day: number, open: Date | string, close: Date | string };

export type PaginatedGymRatingFieldsFragment = { __typename: 'PaginatedGymRating', hasNextPage: boolean, totalCount: number, nodes: Array<{ __typename: 'GymRating', id: string, rating: number, comment?: string | null, createdAt: Date | string, updatedAt: Date | string, customer: { __typename: 'Customer', id: string, firstName: string, lastName: string, email: string, dateOfBirth: Date | string, zipcode: string, street: string, houseNumber: string, place: string, mobileNumber: string, verified: boolean, createdAt: Date | string } }>, edges?: Array<{ __typename: 'GymRatingEdge', cursor: { __typename: 'PaginatedGymRatingCursor', id?: string | null } }> | null };

export type PriceFieldsFragment = { __typename: 'Price', id: string, price: number, pricingModel: PricingModel };

export type ProfileFieldsFragment = { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null };

export type PromotionCodeFieldsFragment = { __typename: 'PromotionCode', id: string, promotionCode: string, description?: string | null, percentage: number, usageLimit?: number | null, startDate?: Date | string | null, endDate?: Date | string | null, createdAt: Date | string, updatedAt: Date | string, deletedAt?: Date | string | null, company?: { __typename: 'Company', id: string } | null, _count: { __typename: 'PromotionCodeCount', customerPromotionCode: number, trainings: number } };

export type PromotionFieldsFragment = { __typename: 'Promotion', id: string, active: boolean, name?: string | null, description?: string | null, imageUrl?: string | null, clickUrl?: string | null, gyms?: Array<{ __typename: 'Gym', id: string, name: string }> | null };

export type PushNotificationHistoryFieldsFragment = { __typename: 'PushNotificationHistory', id: string, affectedCustomers: number, sendAt: Date | string, pushNotification: { __typename: 'PushNotification', title: string, message: string, type: PushNotificationSendType } };

export type PushNotificationFieldsFragment = { __typename: 'PushNotification', id: string, title: string, message: string, type: PushNotificationSendType, status: PushNotificationStatus, cronExpression?: string | null, cronStartDate?: Date | string | null, cronInterval?: CronInterval | null, sendAt?: Date | string | null, createdAt: Date | string };

export type RatingQuestionFieldsFragment = { __typename: 'RatingQuestion', id: string, question: string, isActive: boolean, type: RatingQuestionType, createdAt: Date | string, updatedAt: Date | string, computedRating: { __typename: 'ComputedRating', value: number, type?: ComputedRatingType | null } };

export type ActiveTrainingSessionFragment = { __typename: 'TrainingSession', id: string, startTime: Date | string, endTime?: Date | string | null, event?: { __typename: 'Event', id: string, name: string, duration: number, price?: { __typename: 'Price', price: number } | null } | null, promotionCode?: { __typename: 'PromotionCode', id: string, percentage: number, promotionCode: string } | null, price: { __typename: 'Price', price: number, pricingModel: PricingModel }, gym: { __typename: 'Gym', id: string, name: string, minTrainingDuration: number }, customer: { __typename: 'Customer', id: string, firstName: string, lastName: string, email: string } };

export type CompleteTrainingSessionFragment = { __typename: 'TrainingSession', id: string, startTime: Date | string, endTime?: Date | string | null, gym: { __typename: 'Gym', id: string, name: string }, customer: { __typename: 'Customer', email: string, id: string, firstName: string, lastName: string }, promotionCode?: { __typename: 'PromotionCode', id: string, percentage: number, promotionCode: string } | null, price: { __typename: 'Price', pricingModel: PricingModel }, customerBilling?: { __typename: 'CustomerBilling', id: number, status: BillingStatus, isPaid: boolean, trainingPrice?: number | null, paidPrice?: number | null, errorMessage?: string | null } | null };

export type CustomerTrainingSessionInfoFragment = { __typename: 'TrainingSession', id: string, startTime: Date | string, endTime?: Date | string | null, gym: { __typename: 'Gym', id: string, name: string }, customerBilling?: { __typename: 'CustomerBilling', id: number, status: BillingStatus, isPaid: boolean, trainingPrice?: number | null, paidPrice?: number | null } | null, promotionCode?: { __typename: 'PromotionCode', id: string, percentage: number, promotionCode: string } | null, event?: { __typename: 'Event', id: string, name: string, duration: number, startAt: Date | string, price?: { __typename: 'Price', id: string, price: number, pricingModel: PricingModel } | null } | null };

export type PaginatedTrainingsFieldsFragment = { __typename: 'PaginatedTrainings', hasNextPage: boolean, totalCount: number, nodes: Array<{ __typename: 'TrainingSession', id: string, startTime: Date | string, endTime?: Date | string | null, gym: { __typename: 'Gym', id: string, name: string }, customer: { __typename: 'Customer', email: string, id: string, firstName: string, lastName: string }, promotionCode?: { __typename: 'PromotionCode', id: string, percentage: number, promotionCode: string } | null, price: { __typename: 'Price', pricingModel: PricingModel }, customerBilling?: { __typename: 'CustomerBilling', id: number, status: BillingStatus, isPaid: boolean, trainingPrice?: number | null, paidPrice?: number | null, errorMessage?: string | null } | null }>, edges?: Array<{ __typename: 'TrainingSessionEdge', cursor: { __typename: 'PaginatedTrainingsCursor', id?: string | null } }> | null };

export type TrendMetricFieldsFragment = { __typename: 'TrendMetric', periodCount: number, previousPeriodCount: number, trend: number, dateGroupedCount: Array<{ __typename: 'DateGroupedCount', date: Date | string, count: number }> };

export type CreateCircleMutationVariables = Exact<{
  data: CircleCreateInput;
}>;


export type CreateCircleMutation = { __typename: 'Mutation', createCircle: { __typename: 'Circle', id: string, mediaType: MediaType, key: string, url: string, thumbnailUrl?: string | null, durationSeconds?: number | null, text?: string | null, link?: string | null, expiresAt: Date | string, createdAt: Date | string, authorProfile: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null }, _count: { __typename: 'CircleCount', circleViews: number } } };

export type DeleteCircleMutationVariables = Exact<{
  where: CircleWhereUniqueInput;
}>;


export type DeleteCircleMutation = { __typename: 'Mutation', deleteCircle: { __typename: 'Circle', id: string } };

export type SubmitCommunityClubOnboardingMutationVariables = Exact<{
  data: CommunityClubOnboardingSubmitInput;
}>;


export type SubmitCommunityClubOnboardingMutation = { __typename: 'Mutation', submitCommunityClubOnboarding: { __typename: 'CommunityClubOnboarding', id: string, status: CommunityClubOnboardingStatus } };

export type ActivateCommunityEventBookingsFromWaitlistMutationVariables = Exact<{
  data: CommunityEventBookingActivateWaitlistInput;
}>;


export type ActivateCommunityEventBookingsFromWaitlistMutation = { __typename: 'Mutation', activateCommunityEventBookingsFromWaitlist: Array<{ __typename: 'CommunityEventBooking', id: string }> };

export type CancelCommunityEventBookingManagementMutationVariables = Exact<{
  where: CommunityEventBookingWhereUniqueInput;
}>;


export type CancelCommunityEventBookingManagementMutation = { __typename: 'Mutation', cancelCommunityEventBookingManagement: { __typename: 'CommunityEventBooking', id: string, status: CommunityEventBookingStatus, communityEventInstance: { __typename: 'CommunityEventInstance', id: string, startAt: Date | string, endAt?: Date | string | null }, customer: { __typename: 'Customer', id: string, firstName: string, lastName: string } } };

export type CreateCommunityEventImageMutationVariables = Exact<{
  data: CommunityEventImageCreateInput;
}>;


export type CreateCommunityEventImageMutation = { __typename: 'Mutation', createCommunityEventImage: { __typename: 'CommunityEventImage', id: string, s3ImageUrl: string, communityEvent: { __typename: 'CommunityEvent', id: string } } };

export type CreateCommunityEventImagesMutationVariables = Exact<{
  data: CommunityEventImagesCreateInput;
}>;


export type CreateCommunityEventImagesMutation = { __typename: 'Mutation', createCommunityEventImages: Array<{ __typename: 'CommunityEventImage', id: string, s3ImageUrl: string, communityEvent: { __typename: 'CommunityEvent', id: string } }> };

export type DeleteCommunityEventImageMutationVariables = Exact<{
  where: CommunityEventImageWhereUniqueInput;
}>;


export type DeleteCommunityEventImageMutation = { __typename: 'Mutation', deleteCommunityEventImage: { __typename: 'CommunityEventImage', id: string } };

export type CreateCommunityEventInstanceMutationVariables = Exact<{
  data: CommunityEventInstanceCreateInput;
}>;


export type CreateCommunityEventInstanceMutation = { __typename: 'Mutation', createCommunityEventInstance: { __typename: 'CommunityEventInstance', id: string, startAt: Date | string, endAt?: Date | string | null } };

export type DeleteCommunityEventInstanceMutationVariables = Exact<{
  where: CommunityEventInstanceWhereUniqueInput;
}>;


export type DeleteCommunityEventInstanceMutation = { __typename: 'Mutation', deleteCommunityEventInstance: { __typename: 'CommunityEventInstance', id: string, startAt: Date | string, endAt?: Date | string | null } };

export type UpdateCommunityEventInstanceMutationVariables = Exact<{
  data: CommunityEventInstanceUpdateInput;
  where: CommunityEventInstanceWhereUniqueInput;
}>;


export type UpdateCommunityEventInstanceMutation = { __typename: 'Mutation', updateCommunityEventInstance: { __typename: 'CommunityEventInstance', id: string, startAt: Date | string, endAt?: Date | string | null } };

export type CreateCommunityEventLocationMutationVariables = Exact<{
  createArgs: CommunityEventLocationCreateInput;
}>;


export type CreateCommunityEventLocationMutation = { __typename: 'Mutation', createOneCommunityEventLocation: { __typename: 'CommunityEventLocation', id: string, name: string, zipcode: string, place: string, street: string, houseNumber: string, latitude: string, longitude: string, communityClub: { __typename: 'CommunityClub', id: string } } };

export type DeleteCommunityEventLocationMutationVariables = Exact<{
  where: CommunityEventLocationWhereUniqueInput;
}>;


export type DeleteCommunityEventLocationMutation = { __typename: 'Mutation', deleteCommunityEventLocation: { __typename: 'CommunityEventLocation', id: string, name: string, zipcode: string, place: string, street: string, houseNumber: string, latitude: string, longitude: string, communityClub: { __typename: 'CommunityClub', id: string } } };

export type UpdateCommunityEventLocationMutationVariables = Exact<{
  data: CommunityEventLocationUpdateInput;
  where: CommunityEventLocationWhereUniqueInput;
}>;


export type UpdateCommunityEventLocationMutation = { __typename: 'Mutation', updateOneCommunityEventLocation: { __typename: 'CommunityEventLocation', id: string, name: string, zipcode: string, place: string, street: string, houseNumber: string, latitude: string, longitude: string, communityClub: { __typename: 'CommunityClub', id: string } } };

export type CreateCommunityEventPartnerMutationVariables = Exact<{
  createArgs: CommunityEventPartnerCreateInput;
}>;


export type CreateCommunityEventPartnerMutation = { __typename: 'Mutation', createOneCommunityEventPartner: { __typename: 'CommunityEventPartner', id: string, name: string, description?: string | null, s3LogoKey?: string | null, s3LogoUrl?: string | null, street: string, houseNumber: string, zipcode: string, place: string, latitude: string, longitude: string } };

export type DeleteCommunityEventPartnerMutationVariables = Exact<{
  where: CommunityEventPartnerWhereUniqueInput;
}>;


export type DeleteCommunityEventPartnerMutation = { __typename: 'Mutation', deleteCommunityEventPartner: { __typename: 'CommunityEventPartner', id: string, name: string, description?: string | null, s3LogoKey?: string | null, s3LogoUrl?: string | null, street: string, houseNumber: string, zipcode: string, place: string, latitude: string, longitude: string } };

export type UpdateCommunityEventPartnerMutationVariables = Exact<{
  data: CommunityEventPartnerUpdateInput;
  where: CommunityEventPartnerWhereUniqueInput;
}>;


export type UpdateCommunityEventPartnerMutation = { __typename: 'Mutation', updateOneCommunityEventPartner: { __typename: 'CommunityEventPartner', id: string, name: string, description?: string | null, s3LogoKey?: string | null, s3LogoUrl?: string | null, street: string, houseNumber: string, zipcode: string, place: string, latitude: string, longitude: string } };

export type CreateCommunityEventPriceTierMutationVariables = Exact<{
  data: CreateCommunityEventPriceTierInput;
}>;


export type CreateCommunityEventPriceTierMutation = { __typename: 'Mutation', createCommunityEventPriceTier: { __typename: 'CommunityEventPriceTier', id: string, name: string, priceInCents: number, sortOrder: number, quota: number, validUntil?: Date | string | null, closedAt?: Date | string | null } };

export type CreateCommunityEventTicketPurchaseGrantMutationVariables = Exact<{
  data: CreateCommunityEventTicketPurchaseGrantInput;
}>;


export type CreateCommunityEventTicketPurchaseGrantMutation = { __typename: 'Mutation', createCommunityEventTicketPurchaseGrant: { __typename: 'CommunityEventTicketPurchaseGrant', id: string, validUntil?: Date | string | null, usedAt?: Date | string | null, revokedAt?: Date | string | null, createdAt: Date | string, priceTier: { __typename: 'CommunityEventPriceTier', id: string, name: string, priceInCents: number }, customer?: { __typename: 'Customer', id: string, firstName: string, lastName: string } | null } };

export type CreateComplimentaryCommunityEventTicketMutationVariables = Exact<{
  data: CreateComplimentaryCommunityEventTicketInput;
}>;


export type CreateComplimentaryCommunityEventTicketMutation = { __typename: 'Mutation', createComplimentaryCommunityEventTicket: { __typename: 'CommunityEventTicket', id: string, status: CommunityEventTicketStatus, source: CommunityEventTicketSource, priceInCents: number, issuedAt: Date | string, usedAt?: Date | string | null, refundRequestedAt?: Date | string | null, refundedAt?: Date | string | null, priceTier?: { __typename: 'CommunityEventPriceTier', id: string, name: string } | null, customer?: { __typename: 'Customer', id: string, firstName: string, lastName: string } | null } };

export type DeleteCommunityEventPriceTierMutationVariables = Exact<{
  data: DeleteCommunityEventPriceTierInput;
}>;


export type DeleteCommunityEventPriceTierMutation = { __typename: 'Mutation', deleteCommunityEventPriceTier: { __typename: 'CommunityEventPriceTier', id: string } };

export type RefundCommunityEventTicketMutationVariables = Exact<{
  data: RefundCommunityEventTicketInput;
}>;


export type RefundCommunityEventTicketMutation = { __typename: 'Mutation', refundCommunityEventTicket: { __typename: 'CommunityEventTicket', id: string, status: CommunityEventTicketStatus, source: CommunityEventTicketSource, priceInCents: number, issuedAt: Date | string, usedAt?: Date | string | null, refundRequestedAt?: Date | string | null, refundedAt?: Date | string | null, priceTier?: { __typename: 'CommunityEventPriceTier', id: string, name: string } | null, customer?: { __typename: 'Customer', id: string, firstName: string, lastName: string } | null } };

export type RevokeCommunityEventTicketPurchaseGrantMutationVariables = Exact<{
  data: RevokeCommunityEventTicketPurchaseGrantInput;
}>;


export type RevokeCommunityEventTicketPurchaseGrantMutation = { __typename: 'Mutation', revokeCommunityEventTicketPurchaseGrant: { __typename: 'CommunityEventTicketPurchaseGrant', id: string, validUntil?: Date | string | null, usedAt?: Date | string | null, revokedAt?: Date | string | null, createdAt: Date | string, priceTier: { __typename: 'CommunityEventPriceTier', id: string, name: string, priceInCents: number }, customer?: { __typename: 'Customer', id: string, firstName: string, lastName: string } | null } };

export type ScanCommunityEventTicketMutationVariables = Exact<{
  data: ScanCommunityEventTicketInput;
}>;


export type ScanCommunityEventTicketMutation = { __typename: 'Mutation', scanCommunityEventTicket: { __typename: 'CommunityEventTicketScanResult', status: CommunityEventTicketScanStatus, holderName?: string | null, priceTierName?: string | null, eventName?: string | null, startAt?: Date | string | null, usedAt?: Date | string | null, scannedByName?: string | null } };

export type UpdateCommunityEventPriceTierMutationVariables = Exact<{
  data: UpdateCommunityEventPriceTierInput;
}>;


export type UpdateCommunityEventPriceTierMutation = { __typename: 'Mutation', updateCommunityEventPriceTier: { __typename: 'CommunityEventPriceTier', id: string, name: string, priceInCents: number, sortOrder: number, quota: number, validUntil?: Date | string | null, closedAt?: Date | string | null } };

export type UpdateCommunityEventTicketSaleMutationVariables = Exact<{
  data: UpdateCommunityEventTicketSaleInput;
}>;


export type UpdateCommunityEventTicketSaleMutation = { __typename: 'Mutation', updateCommunityEventTicketSale: { __typename: 'CommunityEventTicketSale', id: string, salesStartAt: Date | string, complimentaryQuota: number } };

export type CreateCommunityEventMutationVariables = Exact<{
  createArgs: CommunityEventCreateInput;
}>;


export type CreateCommunityEventMutation = { __typename: 'Mutation', createOneCommunityEvent: { __typename: 'CommunityEvent', id: string, name: string, communityEventInstances?: Array<{ __typename: 'CommunityEventInstance', id: string, startAt: Date | string, endAt?: Date | string | null }> | null } };

export type DeleteCommunityEventMutationVariables = Exact<{
  where: CommunityEventWhereUniqueInput;
}>;


export type DeleteCommunityEventMutation = { __typename: 'Mutation', deleteCommunityEvent: { __typename: 'CommunityEvent', id: string, name: string, description?: string | null, isActive: boolean, isLimited: boolean, isDraft: boolean, isPaid: boolean, durationMin?: number | null, s3HeaderImageKey?: string | null, s3HeaderImageUrl?: string | null, maxParticipants?: number | null, advanceGenerationDays: number, recurrenceFreq?: RecurrenceFrequency | null, recurrenceInterval?: number | null, recurrenceStartDate?: Date | string | null, recurrenceEndType?: RecurrenceEndType | null, recurrenceUntil?: Date | string | null, recurrenceCount?: number | null, recurrenceByweekday?: Array<number> | null, recurrenceMonthOption?: RecurrenceMonthOption | null, communityClub: { __typename: 'CommunityClub', id: string, name: string }, communityEventPartner?: { __typename: 'CommunityEventPartner', id: string, name: string } | null, communityEventLocation: { __typename: 'CommunityEventLocation', id: string, name: string }, communityEventCategory?: { __typename: 'CommunityEventCategory', id: string, name: string, iconName?: string | null } | null, host?: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } | null } };

export type UpdateCommunityEventMutationVariables = Exact<{
  data: CommunityEventUpdateInput;
  where: CommunityEventWhereUniqueInput;
}>;


export type UpdateCommunityEventMutation = { __typename: 'Mutation', updateOneCommunityEvent: { __typename: 'CommunityEvent', id: string, name: string, description?: string | null, isActive: boolean, isLimited: boolean, isDraft: boolean, isPaid: boolean, durationMin?: number | null, s3HeaderImageKey?: string | null, s3HeaderImageUrl?: string | null, maxParticipants?: number | null, advanceGenerationDays: number, recurrenceFreq?: RecurrenceFrequency | null, recurrenceInterval?: number | null, recurrenceStartDate?: Date | string | null, recurrenceEndType?: RecurrenceEndType | null, recurrenceUntil?: Date | string | null, recurrenceCount?: number | null, recurrenceByweekday?: Array<number> | null, recurrenceMonthOption?: RecurrenceMonthOption | null, communityClub: { __typename: 'CommunityClub', id: string, name: string }, communityEventPartner?: { __typename: 'CommunityEventPartner', id: string, name: string } | null, communityEventLocation: { __typename: 'CommunityEventLocation', id: string, name: string }, communityEventCategory?: { __typename: 'CommunityEventCategory', id: string, name: string, iconName?: string | null } | null, host?: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } | null } };

export type DeleteCommunityPostCommentMutationVariables = Exact<{
  where: CommunityPostCommentWhereUniqueInput;
}>;


export type DeleteCommunityPostCommentMutation = { __typename: 'Mutation', deleteCommunityPostComment: { __typename: 'CommunityPostComment', id: string, content: string, customer?: { __typename: 'Customer', firstName: string, lastName: string } | null, profile?: { __typename: 'Profile', fullName?: string | null } | null } };

export type CreateCommunityPostMutationVariables = Exact<{
  createArgs: CommunityPostCreateInput;
}>;


export type CreateCommunityPostMutation = { __typename: 'Mutation', createCommunityPost: { __typename: 'CommunityPost', id: string, title?: string | null, content: string, postedAt: Date | string, s3ImageUrl?: string | null, author?: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } | null, communityClub: { __typename: 'CommunityClub', id: string, name: string }, _count: { __typename: 'CommunityPostCount', communityPostLikes: number, communityPostComments: number } } };

export type DeleteCommunityPostMutationVariables = Exact<{
  where: CommunityPostWhereUniqueInput;
}>;


export type DeleteCommunityPostMutation = { __typename: 'Mutation', deleteCommunityPost: { __typename: 'CommunityPost', id: string, title?: string | null, content: string, postedAt: Date | string, s3ImageUrl?: string | null, author?: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } | null, communityClub: { __typename: 'CommunityClub', id: string, name: string }, _count: { __typename: 'CommunityPostCount', communityPostLikes: number, communityPostComments: number } } };

export type UpdateCommunityPostMutationVariables = Exact<{
  data: CommunityPostUpdateInput;
  where: CommunityPostWhereUniqueInput;
}>;


export type UpdateCommunityPostMutation = { __typename: 'Mutation', updateCommunityPost: { __typename: 'CommunityPost', id: string, title?: string | null, content: string, postedAt: Date | string, s3ImageUrl?: string | null, author?: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } | null, communityClub: { __typename: 'CommunityClub', id: string, name: string }, _count: { __typename: 'CommunityPostCount', communityPostLikes: number, communityPostComments: number } } };

export type CreateCommunityClubMutationVariables = Exact<{
  createArgs: CommunityClubCreateInput;
}>;


export type CreateCommunityClubMutation = { __typename: 'Mutation', createOneCommunityClub: { __typename: 'CommunityClub', id: string, name: string, description?: string | null, s3LogoKey?: string | null, s3LogoUrl?: string | null, s3CoverImageKey?: string | null, s3CoverImageUrl?: string | null, zipcode: string, place: string, street: string, houseNumber: string, latitude: string, longitude: string, createdAt: Date | string, updatedAt: Date | string, memberCount: number, plannedEventsCount: number, membersCanPost: boolean, ticketingEnabled: boolean, profile?: { __typename: 'Profile', id: string, handle: string } | null } };

export type DeleteCommunityClubMutationVariables = Exact<{
  where: CommunityClubWhereUniqueInput;
}>;


export type DeleteCommunityClubMutation = { __typename: 'Mutation', deleteCommunityClub: { __typename: 'CommunityClub', id: string, name: string, description?: string | null, s3LogoKey?: string | null, s3LogoUrl?: string | null, s3CoverImageKey?: string | null, s3CoverImageUrl?: string | null, zipcode: string, place: string, street: string, houseNumber: string, latitude: string, longitude: string, createdAt: Date | string, updatedAt: Date | string, memberCount: number, plannedEventsCount: number, membersCanPost: boolean, ticketingEnabled: boolean, profile?: { __typename: 'Profile', id: string, handle: string } | null } };

export type UpdateCommunityClubMutationVariables = Exact<{
  data: CommunityClubUpdateInput;
  where: CommunityClubWhereUniqueInput;
}>;


export type UpdateCommunityClubMutation = { __typename: 'Mutation', updateCommunityClub: { __typename: 'CommunityClub', id: string, name: string, description?: string | null, s3LogoKey?: string | null, s3LogoUrl?: string | null, s3CoverImageKey?: string | null, s3CoverImageUrl?: string | null, zipcode: string, place: string, street: string, houseNumber: string, latitude: string, longitude: string, createdAt: Date | string, updatedAt: Date | string, memberCount: number, plannedEventsCount: number, membersCanPost: boolean, ticketingEnabled: boolean, profile?: { __typename: 'Profile', id: string, handle: string } | null } };

export type DeleteCompanyEmployeeMutationVariables = Exact<{
  email: Scalars['EmailAddress']['input'];
}>;


export type DeleteCompanyEmployeeMutation = { __typename: 'Mutation', deleteCompanyEmployee: { __typename: 'CompanyEmployee', id: string } };

export type InviteCompanyEmployeeMutationVariables = Exact<{
  email: Scalars['EmailAddress']['input'];
  gyms?: InputMaybe<GymCreateNestedManyWithoutEmployeesInput>;
  communityClubs?: InputMaybe<CommunityClubCreateNestedManyWithoutEmployeesInput>;
}>;


export type InviteCompanyEmployeeMutation = { __typename: 'Mutation', inviteCompanyEmployee: { __typename: 'CompanyEmployee', id: string, firstName?: string | null, lastName?: string | null, email: string, userType: EmployeeUserType, status: EmployeeStatus, gyms?: Array<{ __typename: 'Gym', name: string }> | null, communityClubs?: Array<{ __typename: 'CommunityClub', name: string }> | null, profile?: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } | null } };

export type SendCompanyEmployeePasswordChangeEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type SendCompanyEmployeePasswordChangeEmailMutation = { __typename: 'Mutation', sendCompanyEmployeePasswordChangeEmail: { __typename: 'CompanyEmployee', id: string, firstName?: string | null, lastName?: string | null, email: string, userType: EmployeeUserType, status: EmployeeStatus, gyms?: Array<{ __typename: 'Gym', name: string }> | null, communityClubs?: Array<{ __typename: 'CommunityClub', name: string }> | null, profile?: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } | null } };

export type UpdateCompanyEmployeeMutationVariables = Exact<{
  data: CompanyEmployeeUpdateInput;
  where?: InputMaybe<CompanyEmployeeUniqueInput>;
}>;


export type UpdateCompanyEmployeeMutation = { __typename: 'Mutation', updateCompanyEmployee: { __typename: 'CompanyEmployee', id: string, firstName?: string | null, lastName?: string | null, email: string, userType: EmployeeUserType, status: EmployeeStatus, gyms?: Array<{ __typename: 'Gym', name: string }> | null, communityClubs?: Array<{ __typename: 'CommunityClub', name: string }> | null, profile?: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } | null } };

export type UpdateCompanyMutationVariables = Exact<{
  updateInput: CompanyUpdateInput;
}>;


export type UpdateCompanyMutation = { __typename: 'Mutation', updateCompany: { __typename: 'Company', name: string, email: string, comission: number, primaryColor?: string | null, secondaryColor?: string | null, id: string, logoUrl?: string | null, street: string, houseNumber: string, place: string, zipcode: string } };

export type GenerateContractMutationVariables = Exact<{
  customerId: Scalars['String']['input'];
  gymId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  data: GenerateContractInput;
}>;


export type GenerateContractMutation = { __typename: 'Mutation', generateContract: { __typename: 'GenerateContractResponse', id: number } };

export type DeleteConversationMutationVariables = Exact<{
  conversationId: Scalars['String']['input'];
}>;


export type DeleteConversationMutation = { __typename: 'Mutation', deleteConversation: boolean };

export type MarkConversationReadMutationVariables = Exact<{
  conversationId: Scalars['String']['input'];
}>;


export type MarkConversationReadMutation = { __typename: 'Mutation', markConversationRead: boolean };

export type CancelBookingCompanyMutationVariables = Exact<{
  where: EventBookingWhereUniqueInput;
}>;


export type CancelBookingCompanyMutation = { __typename: 'Mutation', cancelBookingCompany: { __typename: 'EventBooking', id: string } };

export type CancelEventMutationVariables = Exact<{
  where: EventWhereUniqueInput;
}>;


export type CancelEventMutation = { __typename: 'Mutation', cancelEvent: { __typename: 'Event', id: string } };

export type CreateEventMutationVariables = Exact<{
  data: EventCreateInput;
}>;


export type CreateEventMutation = { __typename: 'Mutation', createEvent: { __typename: 'Event', id: string, name: string, description?: string | null, startAt: Date | string, endAt: Date | string, maxParticipants: number, createdAt: Date | string, updatedAt: Date | string, price?: { __typename: 'Price', id: string, price: number, pricingModel: PricingModel } | null, gym: { __typename: 'Gym', id: string, name: string }, _count: { __typename: 'EventCount', bookings: number, sessions: number } } };

export type CreateEventsMutationVariables = Exact<{
  data: Array<EventCreateInput> | EventCreateInput;
}>;


export type CreateEventsMutation = { __typename: 'Mutation', createEvents: Array<{ __typename: 'Event', id: string, name: string, description?: string | null, startAt: Date | string, endAt: Date | string, maxParticipants: number, createdAt: Date | string, updatedAt: Date | string, price?: { __typename: 'Price', id: string, price: number, pricingModel: PricingModel } | null, gym: { __typename: 'Gym', id: string, name: string }, _count: { __typename: 'EventCount', bookings: number, sessions: number } }> };

export type UpdateEventMutationVariables = Exact<{
  data: EventUpdateInput;
  where: EventWhereUniqueInput;
}>;


export type UpdateEventMutation = { __typename: 'Mutation', updateEvent: { __typename: 'Event', id: string, name: string, description?: string | null, startAt: Date | string, endAt: Date | string, maxParticipants: number, createdAt: Date | string, updatedAt: Date | string, price?: { __typename: 'Price', id: string, price: number, pricingModel: PricingModel } | null, gym: { __typename: 'Gym', id: string, name: string }, _count: { __typename: 'EventCount', bookings: number, sessions: number } } };

export type CreateGymHighlightOrderCheckoutSessionMutationVariables = Exact<{
  data: CreateGymHighlightOrderCheckoutSessionInput;
}>;


export type CreateGymHighlightOrderCheckoutSessionMutation = { __typename: 'Mutation', createGymHighlightOrderCheckoutSession: string };

export type CreateGymHighlightOrderMutationVariables = Exact<{
  data: CreateGymHighlightOrderInput;
}>;


export type CreateGymHighlightOrderMutation = { __typename: 'Mutation', createGymHighlightOrder: { __typename: 'GymHighlightOrder', id: string, status: GymHighlightOrderStatus, startDate: string, endDate: string, amountPerGymInCents: number, totalAmountInCents: number, createdAt: Date | string, gyms: Array<{ __typename: 'Gym', id: string, name: string }>, companyBilling?: { __typename: 'CompanyBilling', id: string, invoiceNumber?: string | null, pdfKey?: string | null } | null } };

export type DeleteGymHighlightOrderMutationVariables = Exact<{
  where: GymHighlightOrderWhereUniqueInput;
}>;


export type DeleteGymHighlightOrderMutation = { __typename: 'Mutation', deleteGymHighlightOrder: { __typename: 'GymHighlightOrder', id: string, status: GymHighlightOrderStatus } };

export type CreateGymImageMutationVariables = Exact<{
  data: GymImageCreateInput;
}>;


export type CreateGymImageMutation = { __typename: 'Mutation', createGymImage: { __typename: 'GymImage', id: string, s3Key: string, s3ImageUrl: string, createdAt: Date | string, updatedAt: Date | string, gymId: string } };

export type DeleteGymImageMutationVariables = Exact<{
  where: GymImageWhereUniqueInput;
}>;


export type DeleteGymImageMutation = { __typename: 'Mutation', deleteGymImage: { __typename: 'GymImage', id: string } };

export type PublicCreateManyGymRatingsMutationVariables = Exact<{
  data: Array<GymRatingCreateManyInput> | GymRatingCreateManyInput;
  gymId: Scalars['String']['input'];
  customerId?: InputMaybe<Scalars['String']['input']>;
  trainingSessionId?: InputMaybe<Scalars['String']['input']>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PublicCreateManyGymRatingsMutation = { __typename: 'Mutation', createManyGymRatings: Array<{ __typename: 'GymRating', id: string }> };

export type CreateGymMutationVariables = Exact<{
  createArgs: GymCreateInput;
  eventWhere?: InputMaybe<EventWhereInput>;
}>;


export type CreateGymMutation = { __typename: 'Mutation', createOneGym: { __typename: 'Gym', id: string, name: string, type: GymType, zipcode: string, place: string, street: string, houseNumber: string, latitude: string, longitude: string, qrcode: string, weeklySessionLimit?: number | null, minTrainingDuration: number, description?: string | null, createdAt: Date | string, updatedAt: Date | string, averageRating: number, advantages?: Array<{ __typename: 'GymAdvantage', id: string, name: string }> | null, price?: { __typename: 'Price', id: string, price: number, pricingModel: PricingModel } | null, category?: { __typename: 'GymCategory', id: string, name: string, description?: string | null } | null, images?: Array<{ __typename: 'GymImage', id: string, s3Key: string, s3ImageUrl: string, createdAt: Date | string, updatedAt: Date | string, gymId: string }> | null, events?: Array<{ __typename: 'Event', id: string, name: string, description?: string | null, startAt: Date | string, endAt: Date | string, maxParticipants: number, createdAt: Date | string, updatedAt: Date | string, price?: { __typename: 'Price', id: string, price: number, pricingModel: PricingModel } | null, gym: { __typename: 'Gym', id: string, name: string }, _count: { __typename: 'EventCount', bookings: number, sessions: number } }> | null, _count: { __typename: 'GymCount', events: number } } };

export type DeleteGymMutationVariables = Exact<{
  where: GymWhereUniqueInput;
  eventWhere?: InputMaybe<EventWhereInput>;
}>;


export type DeleteGymMutation = { __typename: 'Mutation', deleteGym: { __typename: 'Gym', id: string, name: string, type: GymType, zipcode: string, place: string, street: string, houseNumber: string, latitude: string, longitude: string, qrcode: string, weeklySessionLimit?: number | null, minTrainingDuration: number, description?: string | null, createdAt: Date | string, updatedAt: Date | string, averageRating: number, advantages?: Array<{ __typename: 'GymAdvantage', id: string, name: string }> | null, price?: { __typename: 'Price', id: string, price: number, pricingModel: PricingModel } | null, category?: { __typename: 'GymCategory', id: string, name: string, description?: string | null } | null, images?: Array<{ __typename: 'GymImage', id: string, s3Key: string, s3ImageUrl: string, createdAt: Date | string, updatedAt: Date | string, gymId: string }> | null, events?: Array<{ __typename: 'Event', id: string, name: string, description?: string | null, startAt: Date | string, endAt: Date | string, maxParticipants: number, createdAt: Date | string, updatedAt: Date | string, price?: { __typename: 'Price', id: string, price: number, pricingModel: PricingModel } | null, gym: { __typename: 'Gym', id: string, name: string }, _count: { __typename: 'EventCount', bookings: number, sessions: number } }> | null, _count: { __typename: 'GymCount', events: number } } };

export type OpenAccessDeviceManuallyMutationVariables = Exact<{
  where: OpenAccessDeviceManuallyInput;
}>;


export type OpenAccessDeviceManuallyMutation = { __typename: 'Mutation', openAccessDeviceManually: { __typename: 'OpenAccessDeviceGymApp', requestId: string } };

export type UpdateGymMutationVariables = Exact<{
  data: GymUpdateInput;
  where: GymWhereUniqueInput;
  eventWhere?: InputMaybe<EventWhereInput>;
}>;


export type UpdateGymMutation = { __typename: 'Mutation', updateGym: { __typename: 'Gym', id: string, name: string, type: GymType, zipcode: string, place: string, street: string, houseNumber: string, latitude: string, longitude: string, qrcode: string, weeklySessionLimit?: number | null, minTrainingDuration: number, description?: string | null, createdAt: Date | string, updatedAt: Date | string, averageRating: number, advantages?: Array<{ __typename: 'GymAdvantage', id: string, name: string }> | null, price?: { __typename: 'Price', id: string, price: number, pricingModel: PricingModel } | null, category?: { __typename: 'GymCategory', id: string, name: string, description?: string | null } | null, images?: Array<{ __typename: 'GymImage', id: string, s3Key: string, s3ImageUrl: string, createdAt: Date | string, updatedAt: Date | string, gymId: string }> | null, events?: Array<{ __typename: 'Event', id: string, name: string, description?: string | null, startAt: Date | string, endAt: Date | string, maxParticipants: number, createdAt: Date | string, updatedAt: Date | string, price?: { __typename: 'Price', id: string, price: number, pricingModel: PricingModel } | null, gym: { __typename: 'Gym', id: string, name: string }, _count: { __typename: 'EventCount', bookings: number, sessions: number } }> | null, _count: { __typename: 'GymCount', events: number } } };

export type DeleteMessageMutationVariables = Exact<{
  messageId: Scalars['String']['input'];
}>;


export type DeleteMessageMutation = { __typename: 'Mutation', deleteMessage: { __typename: 'Message', id: string } };

export type SendMessageMutationVariables = Exact<{
  targetProfileId: Scalars['String']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<MessageMediaInput> | MessageMediaInput>;
  location?: InputMaybe<MessageLocationInput>;
  sharedCommunityEventId?: InputMaybe<Scalars['String']['input']>;
  sharedCommunityEventInstanceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendMessageMutation = { __typename: 'Mutation', sendMessage: { __typename: 'Message', id: string, content?: string | null, sentAt: Date | string, deletedAt?: Date | string | null, locationLabel?: string | null, locationAddress?: string | null, locationLatitude?: number | null, locationLongitude?: number | null, senderProfile?: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } | null, media: Array<{ __typename: 'MessageMedia', id: string, mediaType: MediaType, key: string, url: string, thumbnailUrl?: string | null, durationSeconds?: number | null, position: number }>, sharedCommunityEvent?: { __typename: 'CommunityEvent', id: string, name: string } | null, sharedCommunityEventInstance?: { __typename: 'CommunityEventInstance', id: string, startAt: Date | string } | null } };

export type CreateOpeningHourMutationVariables = Exact<{
  createArgs: OpeningHourCreateInput;
}>;


export type CreateOpeningHourMutation = { __typename: 'Mutation', createOneOpeningHour: { __typename: 'OpeningHour', id: string, day: number, open: Date | string, close: Date | string } };

export type DeleteOpeningHourMutationVariables = Exact<{
  where: OpeningHourWhereUniqueInput;
}>;


export type DeleteOpeningHourMutation = { __typename: 'Mutation', deleteOpeningHour: { __typename: 'OpeningHour', id: string, day: number, open: Date | string, close: Date | string } };

export type UpdateOpeningHourMutationVariables = Exact<{
  data: OpeningHourUpdateInput;
  where: OpeningHourWhereUniqueInput;
}>;


export type UpdateOpeningHourMutation = { __typename: 'Mutation', updateOpeningHour: { __typename: 'OpeningHour', id: string, day: number, open: Date | string, close: Date | string } };

export type CreateCompanyProfileMutationVariables = Exact<{
  data: CompanyProfileCreateInput;
}>;


export type CreateCompanyProfileMutation = { __typename: 'Mutation', createCompanyProfile: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } };

export type CreateMyProfileMutationVariables = Exact<{
  data: ProfileCreateInput;
}>;


export type CreateMyProfileMutation = { __typename: 'Mutation', createMyProfile: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } };

export type UpdateCompanyProfileMutationVariables = Exact<{
  data: CompanyProfileUpdateInput;
}>;


export type UpdateCompanyProfileMutation = { __typename: 'Mutation', updateCompanyProfile: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } };

export type UpdateMyProfileMutationVariables = Exact<{
  data: ProfileUpdateInput;
}>;


export type UpdateMyProfileMutation = { __typename: 'Mutation', updateMyProfile: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } };

export type CreatePromotionCodeMutationVariables = Exact<{
  data: PromotionCodeCreateInput;
}>;


export type CreatePromotionCodeMutation = { __typename: 'Mutation', createPromotionCode: { __typename: 'PromotionCode', id: string, promotionCode: string, description?: string | null, percentage: number, usageLimit?: number | null, startDate?: Date | string | null, endDate?: Date | string | null, createdAt: Date | string, updatedAt: Date | string, deletedAt?: Date | string | null, company?: { __typename: 'Company', id: string } | null, _count: { __typename: 'PromotionCodeCount', customerPromotionCode: number, trainings: number } } };

export type DeletePromotionCodeMutationVariables = Exact<{
  promotionCode: Scalars['String']['input'];
}>;


export type DeletePromotionCodeMutation = { __typename: 'Mutation', softDeletePromotionCode: { __typename: 'PromotionCode', id: string, promotionCode: string, description?: string | null, percentage: number, usageLimit?: number | null, startDate?: Date | string | null, endDate?: Date | string | null, createdAt: Date | string, updatedAt: Date | string, deletedAt?: Date | string | null, company?: { __typename: 'Company', id: string } | null, _count: { __typename: 'PromotionCodeCount', customerPromotionCode: number, trainings: number } } };

export type CreatePromotionMutationVariables = Exact<{
  data: PromotionCreateInput;
}>;


export type CreatePromotionMutation = { __typename: 'Mutation', createPromotion: { __typename: 'Promotion', id: string, active: boolean, name?: string | null, description?: string | null, imageUrl?: string | null, clickUrl?: string | null, gyms?: Array<{ __typename: 'Gym', id: string, name: string }> | null } };

export type DeletePromotionMutationVariables = Exact<{
  where: PromotionWhereUniqueInput;
}>;


export type DeletePromotionMutation = { __typename: 'Mutation', deletePromotion: { __typename: 'Promotion', id: string, active: boolean, name?: string | null, description?: string | null, imageUrl?: string | null, clickUrl?: string | null, gyms?: Array<{ __typename: 'Gym', id: string, name: string }> | null } };

export type UpdatePromotionMutationVariables = Exact<{
  where: PromotionWhereUniqueInput;
  data: PromotionUpdateInput;
}>;


export type UpdatePromotionMutation = { __typename: 'Mutation', updatePromotion: { __typename: 'Promotion', id: string, active: boolean, name?: string | null, description?: string | null, imageUrl?: string | null, clickUrl?: string | null, gyms?: Array<{ __typename: 'Gym', id: string, name: string }> | null } };

export type CreatePushNotificationCommunityMutationVariables = Exact<{
  createInput: PushNotificationCreateCommunityClubInput;
}>;


export type CreatePushNotificationCommunityMutation = { __typename: 'Mutation', createPushNotificationCommunityClub: { __typename: 'PushNotification', id: string, title: string, message: string, type: PushNotificationSendType, status: PushNotificationStatus, cronExpression?: string | null, cronStartDate?: Date | string | null, cronInterval?: CronInterval | null, sendAt?: Date | string | null, createdAt: Date | string } };

export type CreatePushNotificationMutationVariables = Exact<{
  createInput: PushNotificationCreateInput;
}>;


export type CreatePushNotificationMutation = { __typename: 'Mutation', createPushNotification: { __typename: 'PushNotification', id: string, title: string, message: string, type: PushNotificationSendType, status: PushNotificationStatus, cronExpression?: string | null, cronStartDate?: Date | string | null, cronInterval?: CronInterval | null, sendAt?: Date | string | null, createdAt: Date | string } };

export type DeletePushNotificationMutationVariables = Exact<{
  where: PushNotificationWhereUniqueInput;
}>;


export type DeletePushNotificationMutation = { __typename: 'Mutation', deletePushNotification: { __typename: 'PushNotification', id: string } };

export type DisablePushNotificationMutationVariables = Exact<{
  pushNotificationId: Scalars['String']['input'];
}>;


export type DisablePushNotificationMutation = { __typename: 'Mutation', disablePushNotification: { __typename: 'PushNotification', id: string } };

export type CreateRatingQuestionMutationVariables = Exact<{
  data: RatingQuestionCreateInput;
  gymId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type CreateRatingQuestionMutation = { __typename: 'Mutation', createRatingQuestion: { __typename: 'RatingQuestion', id: string, question: string, isActive: boolean, type: RatingQuestionType, createdAt: Date | string, updatedAt: Date | string, computedRating: { __typename: 'ComputedRating', value: number, type?: ComputedRatingType | null } } };

export type DeleteRatingQuestionMutationVariables = Exact<{
  where: RatingQuestionWhereUniqueInput;
  gymId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type DeleteRatingQuestionMutation = { __typename: 'Mutation', deleteRatingQuestion: { __typename: 'RatingQuestion', id: string, question: string, isActive: boolean, type: RatingQuestionType, createdAt: Date | string, updatedAt: Date | string, computedRating: { __typename: 'ComputedRating', value: number, type?: ComputedRatingType | null } } };

export type UpdateRatingQuestionActiveStatusMutationVariables = Exact<{
  where: RatingQuestionWhereUniqueInput;
  data: RatingQuestionActiveStatusUpdateInput;
  gymId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type UpdateRatingQuestionActiveStatusMutation = { __typename: 'Mutation', updateRatingQuestionActiveStatus: { __typename: 'RatingQuestion', id: string, question: string, isActive: boolean, type: RatingQuestionType, createdAt: Date | string, updatedAt: Date | string, computedRating: { __typename: 'ComputedRating', value: number, type?: ComputedRatingType | null } } };

export type DismissReportMutationVariables = Exact<{
  reportId: Scalars['String']['input'];
}>;


export type DismissReportMutation = { __typename: 'Mutation', dismissReport: boolean };

export type FinishTrainingSessionMutationVariables = Exact<{
  where: TrainingSessionWhereUniqueInput;
  data: FinishTrainingSessionInput;
}>;


export type FinishTrainingSessionMutation = { __typename: 'Mutation', finishTrainingSession: { __typename: 'TrainingSession', id: string } };

export type CreateUserPostMutationVariables = Exact<{
  data: UserPostCreateInput;
}>;


export type CreateUserPostMutation = { __typename: 'Mutation', createUserPost: { __typename: 'UserPost', id: string, scope: PostScope, postType: UserPostType, content?: string | null, postedAt: Date | string, authorProfile: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null }, communityClub?: { __typename: 'CommunityClub', id: string, name: string } | null, media?: Array<{ __typename: 'PostMedia', id: string, mediaType: MediaType, url: string, thumbnailUrl?: string | null, durationSeconds?: number | null, position: number }> | null, _count: { __typename: 'UserPostCount', communityPostLikes: number, communityPostComments: number } } };

export type DeleteUserPostMutationVariables = Exact<{
  where: UserPostWhereUniqueInput;
}>;


export type DeleteUserPostMutation = { __typename: 'Mutation', deleteUserPost: { __typename: 'UserPost', id: string } };

export type UpdateUserPostMutationVariables = Exact<{
  data: UserPostUpdateInput;
  where: UserPostWhereUniqueInput;
}>;


export type UpdateUserPostMutation = { __typename: 'Mutation', updateUserPost: { __typename: 'UserPost', id: string, scope: PostScope, postType: UserPostType, content?: string | null, postedAt: Date | string, authorProfile: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null }, communityClub?: { __typename: 'CommunityClub', id: string, name: string } | null, media?: Array<{ __typename: 'PostMedia', id: string, mediaType: MediaType, url: string, thumbnailUrl?: string | null, durationSeconds?: number | null, position: number }> | null, _count: { __typename: 'UserPostCount', communityPostLikes: number, communityPostComments: number } } };

export type MyCirclesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyCirclesQuery = { __typename: 'Query', myProfile?: { __typename: 'Profile', id: string, circles: Array<{ __typename: 'Circle', id: string, mediaType: MediaType, key: string, url: string, thumbnailUrl?: string | null, durationSeconds?: number | null, text?: string | null, link?: string | null, expiresAt: Date | string, createdAt: Date | string, authorProfile: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null }, _count: { __typename: 'CircleCount', circleViews: number } }> } | null };

export type MyCompanyCirclesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyCompanyCirclesQuery = { __typename: 'Query', companyProfile?: { __typename: 'Profile', id: string, circles: Array<{ __typename: 'Circle', id: string, mediaType: MediaType, key: string, url: string, thumbnailUrl?: string | null, durationSeconds?: number | null, text?: string | null, link?: string | null, expiresAt: Date | string, createdAt: Date | string, authorProfile: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null }, _count: { __typename: 'CircleCount', circleViews: number } }> } | null };

export type CommunityClubOnboardingEmailExistsQueryVariables = Exact<{
  accountEmail: Scalars['String']['input'];
}>;


export type CommunityClubOnboardingEmailExistsQuery = { __typename: 'Query', communityClubOnboardingEmailExists: boolean };

export type CommunityClubExistenceQueryVariables = Exact<{
  where?: InputMaybe<CommunityClubWhereInput>;
}>;


export type CommunityClubExistenceQuery = { __typename: 'Query', communityClubs: Array<{ __typename: 'CommunityClub', id: string, s3LogoUrl?: string | null }> };

export type CommunityClubHostsQueryVariables = Exact<{ [key: string]: never; }>;


export type CommunityClubHostsQuery = { __typename: 'Query', communityClubs: Array<{ __typename: 'CommunityClub', id: string, communityHost: Array<{ __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null }> }> };

export type CommunityClubsForPickerQueryVariables = Exact<{
  where?: InputMaybe<CommunityClubWhereInput>;
  orderBy?: InputMaybe<Array<CommunityClubOrderByWithRelationInput> | CommunityClubOrderByWithRelationInput>;
  cursor?: InputMaybe<CommunityClubWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<CommunityClubScalarFieldEnum> | CommunityClubScalarFieldEnum>;
}>;


export type CommunityClubsForPickerQuery = { __typename: 'Query', communityClubs: Array<{ __typename: 'CommunityClub', id: string, name: string }> };

export type CommunityClubTicketFeesQueryVariables = Exact<{
  where: CommunityClubWhereUniqueInput;
}>;


export type CommunityClubTicketFeesQuery = { __typename: 'Query', communityClub: { __typename: 'CommunityClub', id: string, ticketFees: { __typename: 'CommunityClubTicketFees', commissionPercent: number, flatFeeInCents: number } } };

export type CommunityClubsQueryVariables = Exact<{
  where?: InputMaybe<CommunityClubWhereInput>;
  orderBy?: InputMaybe<Array<CommunityClubOrderByWithRelationInput> | CommunityClubOrderByWithRelationInput>;
  cursor?: InputMaybe<CommunityClubWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<CommunityClubScalarFieldEnum> | CommunityClubScalarFieldEnum>;
}>;


export type CommunityClubsQuery = { __typename: 'Query', communityClubs: Array<{ __typename: 'CommunityClub', id: string, name: string, description?: string | null, s3LogoKey?: string | null, s3LogoUrl?: string | null, s3CoverImageKey?: string | null, s3CoverImageUrl?: string | null, zipcode: string, place: string, street: string, houseNumber: string, latitude: string, longitude: string, createdAt: Date | string, updatedAt: Date | string, memberCount: number, plannedEventsCount: number, membersCanPost: boolean, ticketingEnabled: boolean, profile?: { __typename: 'Profile', id: string, handle: string } | null }> };

export type CommunityEventBookingInfoQueryVariables = Exact<{
  where?: InputMaybe<CommunityEventBookingWhereInput>;
  orderBy?: InputMaybe<Array<CommunityEventBookingOrderByWithRelationInput> | CommunityEventBookingOrderByWithRelationInput>;
  cursor?: InputMaybe<CommunityEventBookingWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<CommunityEventBookingScalarFieldEnum> | CommunityEventBookingScalarFieldEnum>;
}>;


export type CommunityEventBookingInfoQuery = { __typename: 'Query', communityEventBookings: Array<{ __typename: 'CommunityEventBooking', id: string, status: CommunityEventBookingStatus, communityEventInstance: { __typename: 'CommunityEventInstance', id: string, startAt: Date | string, endAt?: Date | string | null, communityEvent: { __typename: 'CommunityEvent', id: string, name: string } } }> };

export type CommunityEventBookingParticipantsQueryVariables = Exact<{
  where?: InputMaybe<CommunityEventBookingWhereInput>;
  orderBy?: InputMaybe<Array<CommunityEventBookingOrderByWithRelationInput> | CommunityEventBookingOrderByWithRelationInput>;
  cursor?: InputMaybe<CommunityEventBookingWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<CommunityEventBookingScalarFieldEnum> | CommunityEventBookingScalarFieldEnum>;
}>;


export type CommunityEventBookingParticipantsQuery = { __typename: 'Query', communityEventBookings: Array<{ __typename: 'CommunityEventBooking', id: string, status: CommunityEventBookingStatus, customer: { __typename: 'Customer', id: string, firstName: string, lastName: string, email: string, profile?: { __typename: 'Profile', id: string, handle: string } | null } }> };

export type CommunityEventBookingsQueryVariables = Exact<{
  where?: InputMaybe<CommunityEventBookingWhereInput>;
  orderBy?: InputMaybe<Array<CommunityEventBookingOrderByWithRelationInput> | CommunityEventBookingOrderByWithRelationInput>;
  cursor?: InputMaybe<CommunityEventBookingWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<CommunityEventBookingScalarFieldEnum> | CommunityEventBookingScalarFieldEnum>;
}>;


export type CommunityEventBookingsQuery = { __typename: 'Query', communityEventBookings: Array<{ __typename: 'CommunityEventBooking', id: string, status: CommunityEventBookingStatus, communityEventInstance: { __typename: 'CommunityEventInstance', id: string, startAt: Date | string, endAt?: Date | string | null }, customer: { __typename: 'Customer', id: string, firstName: string, lastName: string } }> };

export type CommunityEventCategoriesQueryVariables = Exact<{
  where?: InputMaybe<CommunityEventCategoryWhereInput>;
  orderBy?: InputMaybe<Array<CommunityEventCategoryOrderByWithRelationInput> | CommunityEventCategoryOrderByWithRelationInput>;
  cursor?: InputMaybe<CommunityEventCategoryWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<CommunityEventCategoryScalarFieldEnum> | CommunityEventCategoryScalarFieldEnum>;
}>;


export type CommunityEventCategoriesQuery = { __typename: 'Query', communityEventCategories: Array<{ __typename: 'CommunityEventCategory', id: string, name: string, description?: string | null, iconName?: string | null }> };

export type CommunityEventImagesQueryVariables = Exact<{
  where?: InputMaybe<CommunityEventImageWhereInput>;
  orderBy?: InputMaybe<Array<CommunityEventImageOrderByWithRelationInput> | CommunityEventImageOrderByWithRelationInput>;
  cursor?: InputMaybe<CommunityEventImageWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<CommunityEventImageScalarFieldEnum> | CommunityEventImageScalarFieldEnum>;
}>;


export type CommunityEventImagesQuery = { __typename: 'Query', communityEventImages: Array<{ __typename: 'CommunityEventImage', id: string, s3ImageUrl: string, communityEvent: { __typename: 'CommunityEvent', id: string } }> };

export type CommunityEventInstancesQueryVariables = Exact<{
  where?: InputMaybe<CommunityEventInstanceWhereInput>;
  orderBy?: InputMaybe<Array<CommunityEventInstanceOrderByWithRelationInput> | CommunityEventInstanceOrderByWithRelationInput>;
  cursor?: InputMaybe<CommunityEventInstanceWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<CommunityEventInstanceScalarFieldEnum> | CommunityEventInstanceScalarFieldEnum>;
}>;


export type CommunityEventInstancesQuery = { __typename: 'Query', communityEventInstances: Array<{ __typename: 'CommunityEventInstance', id: string, startAt: Date | string, endAt?: Date | string | null }> };

export type CommunityEventInstancesAttendanceQueryVariables = Exact<{
  where?: InputMaybe<CommunityEventInstanceWhereInput>;
  orderBy?: InputMaybe<Array<CommunityEventInstanceOrderByWithRelationInput> | CommunityEventInstanceOrderByWithRelationInput>;
  cursor?: InputMaybe<CommunityEventInstanceWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<CommunityEventInstanceScalarFieldEnum> | CommunityEventInstanceScalarFieldEnum>;
}>;


export type CommunityEventInstancesAttendanceQuery = { __typename: 'Query', communityEventInstances: Array<{ __typename: 'CommunityEventInstance', id: string, startAt: Date | string, endAt?: Date | string | null, attendance: { __typename: 'CommunityEventInstanceAttendance', registeredCount: number, checkedInCount: number, noShowCount: number } }> };

export type CommunityEventLocationsQueryVariables = Exact<{
  where?: InputMaybe<CommunityEventLocationWhereInput>;
  orderBy?: InputMaybe<Array<CommunityEventLocationOrderByWithRelationInput> | CommunityEventLocationOrderByWithRelationInput>;
  cursor?: InputMaybe<CommunityEventLocationWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<CommunityEventLocationScalarFieldEnum> | CommunityEventLocationScalarFieldEnum>;
}>;


export type CommunityEventLocationsQuery = { __typename: 'Query', communityEventLocations: Array<{ __typename: 'CommunityEventLocation', id: string, name: string, zipcode: string, place: string, street: string, houseNumber: string, latitude: string, longitude: string, communityClub: { __typename: 'CommunityClub', id: string } }> };

export type CommunityEventPartnersQueryVariables = Exact<{
  where?: InputMaybe<CommunityEventPartnerWhereInput>;
  orderBy?: InputMaybe<Array<CommunityEventPartnerOrderByWithRelationInput> | CommunityEventPartnerOrderByWithRelationInput>;
  cursor?: InputMaybe<CommunityEventPartnerWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<CommunityEventPartnerScalarFieldEnum> | CommunityEventPartnerScalarFieldEnum>;
}>;


export type CommunityEventPartnersQuery = { __typename: 'Query', communityEventPartners: Array<{ __typename: 'CommunityEventPartner', id: string, name: string, description?: string | null, s3LogoKey?: string | null, s3LogoUrl?: string | null, street: string, houseNumber: string, zipcode: string, place: string, latitude: string, longitude: string }> };

export type CommunityEventInstancePurchaseGrantsQueryVariables = Exact<{
  where?: InputMaybe<CommunityEventInstanceWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CommunityEventInstancePurchaseGrantsQuery = { __typename: 'Query', communityEventInstances: Array<{ __typename: 'CommunityEventInstance', id: string, ticketSale?: { __typename: 'CommunityEventTicketSale', id: string, purchaseGrants?: Array<{ __typename: 'CommunityEventTicketPurchaseGrant', id: string, validUntil?: Date | string | null, usedAt?: Date | string | null, revokedAt?: Date | string | null, createdAt: Date | string, priceTier: { __typename: 'CommunityEventPriceTier', id: string, name: string, priceInCents: number }, customer?: { __typename: 'Customer', id: string, firstName: string, lastName: string } | null }> | null } | null }> };

export type CommunityEventInstanceTicketSaleQueryVariables = Exact<{
  where?: InputMaybe<CommunityEventInstanceWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CommunityEventInstanceTicketSaleQuery = { __typename: 'Query', communityEventInstances: Array<{ __typename: 'CommunityEventInstance', id: string, startAt: Date | string, endAt?: Date | string | null, communityEvent: { __typename: 'CommunityEvent', id: string, isDraft: boolean }, ticketSale?: { __typename: 'CommunityEventTicketSale', id: string, salesStartAt: Date | string, rescheduledAt?: Date | string | null, canceledAt?: Date | string | null, complimentaryQuota: number, availableTicketCount?: number | null, communityClub: { __typename: 'CommunityClub', id: string }, activePriceTier?: { __typename: 'CommunityEventPriceTier', id: string, name: string, priceInCents: number, sortOrder: number, quota: number, validUntil?: Date | string | null, closedAt?: Date | string | null } | null, priceTiers?: Array<{ __typename: 'CommunityEventPriceTier', id: string, name: string, priceInCents: number, sortOrder: number, quota: number, validUntil?: Date | string | null, closedAt?: Date | string | null }> | null, reservations?: Array<{ __typename: 'CommunityEventTicketReservation', id: string, status: CommunityEventTicketReservationStatus }> | null, queueEntries?: Array<{ __typename: 'CommunityEventTicketQueueEntry', id: string }> | null } | null }> };

export type CommunityEventInstanceTicketsQueryVariables = Exact<{
  where?: InputMaybe<CommunityEventInstanceWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CommunityEventInstanceTicketsQuery = { __typename: 'Query', communityEventInstances: Array<{ __typename: 'CommunityEventInstance', id: string, endAt?: Date | string | null, ticketSale?: { __typename: 'CommunityEventTicketSale', id: string, canceledAt?: Date | string | null, tickets?: Array<{ __typename: 'CommunityEventTicket', id: string, status: CommunityEventTicketStatus, source: CommunityEventTicketSource, priceInCents: number, issuedAt: Date | string, usedAt?: Date | string | null, refundRequestedAt?: Date | string | null, refundedAt?: Date | string | null, priceTier?: { __typename: 'CommunityEventPriceTier', id: string, name: string } | null, customer?: { __typename: 'Customer', id: string, firstName: string, lastName: string } | null }> | null } | null }> };

export type CommunityEventsQueryVariables = Exact<{
  where?: InputMaybe<CommunityEventWhereInput>;
  orderBy?: InputMaybe<Array<CommunityEventOrderByWithRelationInput> | CommunityEventOrderByWithRelationInput>;
  cursor?: InputMaybe<CommunityEventWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<CommunityEventScalarFieldEnum> | CommunityEventScalarFieldEnum>;
}>;


export type CommunityEventsQuery = { __typename: 'Query', communityEvents: Array<{ __typename: 'CommunityEvent', id: string, name: string, description?: string | null, isActive: boolean, isLimited: boolean, isDraft: boolean, isPaid: boolean, durationMin?: number | null, s3HeaderImageKey?: string | null, s3HeaderImageUrl?: string | null, maxParticipants?: number | null, advanceGenerationDays: number, recurrenceFreq?: RecurrenceFrequency | null, recurrenceInterval?: number | null, recurrenceStartDate?: Date | string | null, recurrenceEndType?: RecurrenceEndType | null, recurrenceUntil?: Date | string | null, recurrenceCount?: number | null, recurrenceByweekday?: Array<number> | null, recurrenceMonthOption?: RecurrenceMonthOption | null, communityClub: { __typename: 'CommunityClub', id: string, name: string }, communityEventPartner?: { __typename: 'CommunityEventPartner', id: string, name: string } | null, communityEventLocation: { __typename: 'CommunityEventLocation', id: string, name: string }, communityEventCategory?: { __typename: 'CommunityEventCategory', id: string, name: string, iconName?: string | null } | null, host?: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } | null }> };

export type CommunityPostCommentsQueryVariables = Exact<{
  where?: InputMaybe<CommunityPostCommentWhereInput>;
  orderBy?: InputMaybe<Array<CommunityPostCommentOrderByWithRelationInput> | CommunityPostCommentOrderByWithRelationInput>;
  cursor?: InputMaybe<CommunityPostCommentWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<CommunityPostCommentScalarFieldEnum> | CommunityPostCommentScalarFieldEnum>;
}>;


export type CommunityPostCommentsQuery = { __typename: 'Query', communityPostComments: Array<{ __typename: 'CommunityPostComment', id: string, content: string, customer?: { __typename: 'Customer', firstName: string, lastName: string } | null, profile?: { __typename: 'Profile', fullName?: string | null } | null }> };

export type CommunityPostsQueryVariables = Exact<{
  where?: InputMaybe<CommunityPostWhereInput>;
  orderBy?: InputMaybe<Array<CommunityPostOrderByWithRelationInput> | CommunityPostOrderByWithRelationInput>;
  cursor?: InputMaybe<CommunityPostWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<CommunityPostScalarFieldEnum> | CommunityPostScalarFieldEnum>;
}>;


export type CommunityPostsQuery = { __typename: 'Query', communityPosts: Array<{ __typename: 'CommunityPost', id: string, title?: string | null, content: string, postedAt: Date | string, s3ImageUrl?: string | null, author?: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } | null, communityClub: { __typename: 'CommunityClub', id: string, name: string }, _count: { __typename: 'CommunityPostCount', communityPostLikes: number, communityPostComments: number } }> };

export type CompanyInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyInformationQuery = { __typename: 'Query', company: { __typename: 'Company', name: string, email: string, comission: number, primaryColor?: string | null, secondaryColor?: string | null, id: string, logoUrl?: string | null, street: string, houseNumber: string, place: string, zipcode: string } };

export type CompanyNameQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyNameQuery = { __typename: 'Query', companyName: string };

export type PublicContractDetailsQueryVariables = Exact<{
  gymId: Scalars['String']['input'];
  contractId: Scalars['String']['input'];
}>;


export type PublicContractDetailsQuery = { __typename: 'Query', publicContractDetails: { __typename: 'ContractDetails', companyName?: string | null, gymName: string, tenant: string, crmStudioId: string, imprint: string, privacyPolicy: string, generalTerms: string, logoUrl?: string | null, primaryColor?: string | null, secondaryColor?: string | null, normalPrice?: number | null, savings?: number | null, totalOverTerm?: number | null, contract?: { __typename: 'ConnectApiRateBundle', name: string, description: string, terms: Array<{ __typename: 'ConnectApiRateBundleTerm', id: number, term: { __typename: 'TermDto', termUnit: TermUnit }, paymentFrequencyDto: { __typename: 'PaymentFrequencyDto', money: { __typename: 'MoneyDto', amount: number, currencyCode: string }, term?: { __typename: 'TermDto', termUnit: TermUnit } | null } }>, modules: Array<{ __typename: 'ConnectApiRateBundleModule', name: string }>, contractTextBlocks: Array<{ __typename: 'ConnectApiSignableTextBlock', title: string, text: string }> } | null } };

export type PaginatedConversationQueryVariables = Exact<{
  where?: InputMaybe<ConversationWhereInput>;
  orderBy?: InputMaybe<Array<ConversationOrderByWithRelationInput> | ConversationOrderByWithRelationInput>;
  cursor?: InputMaybe<ConversationWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<ConversationScalarFieldEnum> | ConversationScalarFieldEnum>;
}>;


export type PaginatedConversationQuery = { __typename: 'Query', paginatedConversation: { __typename: 'PaginatedConversation', hasNextPage: boolean, totalCount: number, nodes: Array<{ __typename: 'Conversation', id: string, hasUnreadMessages: boolean, lastMessageAt?: Date | string | null, createdAt: Date | string, otherProfile: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null }, lastMessage?: { __typename: 'Message', id: string, content?: string | null, sentAt: Date | string, deletedAt?: Date | string | null, locationLabel?: string | null, locationAddress?: string | null, locationLatitude?: number | null, locationLongitude?: number | null, senderProfile?: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } | null, media: Array<{ __typename: 'MessageMedia', id: string, mediaType: MediaType, key: string, url: string, thumbnailUrl?: string | null, durationSeconds?: number | null, position: number }>, sharedCommunityEvent?: { __typename: 'CommunityEvent', id: string, name: string } | null, sharedCommunityEventInstance?: { __typename: 'CommunityEventInstance', id: string, startAt: Date | string } | null } | null }>, edges?: Array<{ __typename: 'ConversationEdge', cursor: { __typename: 'PaginatedConversationCursor', id?: string | null } }> | null } };

export type CustomerAgeDistributionQueryVariables = Exact<{
  whereYoungerThan30: CustomerWhereInput;
  whereBetween30And50: CustomerWhereInput;
  whereOlderThan50: CustomerWhereInput;
}>;


export type CustomerAgeDistributionQuery = { __typename: 'Query', youngerThan30: number, between30And50: number, olderThan50: number };

export type CustomerBillingTrendQueryVariables = Exact<{
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  timezone: Scalars['TimeZone']['input'];
  gymId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type CustomerBillingTrendQuery = { __typename: 'Query', customerBillingTrend: { __typename: 'TrendMetric', periodCount: number, previousPeriodCount: number, trend: number, dateGroupedCount: Array<{ __typename: 'DateGroupedCount', date: Date | string, count: number }> } };

export type CustomerNewVsReturningQueryVariables = Exact<{
  whereNew: CustomerWhereInput;
  whereReturning: CustomerWhereInput;
}>;


export type CustomerNewVsReturningQuery = { __typename: 'Query', newCustomers: number, returningCustomers: number };

export type CustomerPromotionCodesQueryVariables = Exact<{
  where?: InputMaybe<CustomerPromotionCodeWhereInput>;
  orderBy?: InputMaybe<Array<CustomerPromotionCodeOrderByWithRelationInput> | CustomerPromotionCodeOrderByWithRelationInput>;
  cursor?: InputMaybe<CustomerPromotionCodeWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<CustomerPromotionCodeScalarFieldEnum> | CustomerPromotionCodeScalarFieldEnum>;
}>;


export type CustomerPromotionCodesQuery = { __typename: 'Query', customerPromotionCodes: Array<{ __typename: 'CustomerPromotionCode', id: string, promoCode: string, usageCount: number, promotionCode: { __typename: 'PromotionCode', promotionCode: string, percentage: number } }> };

export type CustomerTopRankingQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  gymId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type CustomerTopRankingQuery = { __typename: 'Query', customerTopRanking: Array<{ __typename: 'CustomerTopRanking', firstName: string, lastName: string, email: string, salesTotal: number, trainingsTotal: number }> };

export type CustomerTrendQueryVariables = Exact<{
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  timezone: Scalars['TimeZone']['input'];
  gymId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type CustomerTrendQuery = { __typename: 'Query', customerTrend: { __typename: 'TrendMetric', periodCount: number, previousPeriodCount: number, trend: number, dateGroupedCount: Array<{ __typename: 'DateGroupedCount', date: Date | string, count: number }> } };

export type CustomersQueryVariables = Exact<{
  where?: InputMaybe<CustomerWhereInput>;
  orderBy?: InputMaybe<Array<CustomerOrderByWithRelationInput> | CustomerOrderByWithRelationInput>;
  cursor?: InputMaybe<CustomerWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<CustomerScalarFieldEnum> | CustomerScalarFieldEnum>;
}>;


export type CustomersQuery = { __typename: 'Query', customers: Array<{ __typename: 'Customer', id: string, firstName: string, lastName: string, email: string, dateOfBirth: Date | string, zipcode: string, street: string, houseNumber: string, place: string, mobileNumber: string, verified: boolean, createdAt: Date | string }> };

export type PaginatedCustomersQueryVariables = Exact<{
  where?: InputMaybe<CustomerWhereInput>;
  orderBy?: InputMaybe<Array<CustomerOrderByWithRelationInput> | CustomerOrderByWithRelationInput>;
  cursor?: InputMaybe<CustomerWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<CustomerScalarFieldEnum> | CustomerScalarFieldEnum>;
}>;


export type PaginatedCustomersQuery = { __typename: 'Query', paginatedCustomers: { __typename: 'PaginatedCustomers', hasNextPage: boolean, totalCount: number, nodes: Array<{ __typename: 'Customer', id: string, firstName: string, lastName: string, email: string, dateOfBirth: Date | string, zipcode: string, street: string, houseNumber: string, place: string, mobileNumber: string, verified: boolean, createdAt: Date | string }>, edges?: Array<{ __typename: 'CustomerEdge', cursor: { __typename: 'PaginatedCustomersCursor', id?: string | null } }> | null } };

export type DashboardOverviewQueryVariables = Exact<{
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  timezone: Scalars['TimeZone']['input'];
  countCustomerWhere?: InputMaybe<CustomerWhereInput>;
  customerBillingsWhere?: InputMaybe<CustomerBillingWhereInput>;
  customerBillingsWhereOpen?: InputMaybe<CustomerBillingWhereInput>;
  countTrainingSessionsWhere?: InputMaybe<TrainingSessionWhereInput>;
  gymId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type DashboardOverviewQuery = { __typename: 'Query', countCustomer: number, countTrainingSessions: number, averageTrainingSessionTime: number, totalSales: { __typename: 'AggregateCustomerBilling', _sum?: { __typename: 'CustomerBillingSumAggregate', paidPrice?: number | null } | null, _avg?: { __typename: 'CustomerBillingAvgAggregate', paidPrice?: number | null } | null }, openSales: { __typename: 'AggregateCustomerBilling', _sum?: { __typename: 'CustomerBillingSumAggregate', paidPrice?: number | null } | null }, customerBillingPerDay: Array<{ __typename: 'DateGroupedCount', date: Date | string, count: number }> };

export type DashboardQueryVariables = Exact<{
  whereCustomers?: InputMaybe<CustomerWhereInput>;
  whereCustomerBillings?: InputMaybe<CustomerBillingWhereInput>;
  whereTrainingSessions?: InputMaybe<TrainingSessionWhereInput>;
}>;


export type DashboardQuery = { __typename: 'Query', customers: Array<{ __typename: 'Customer', id: string, firstName: string, lastName: string, createdAt: Date | string, dateOfBirth: Date | string }>, customerBillings: Array<{ __typename: 'CustomerBilling', id: number, paidPrice?: number | null, status: BillingStatus, isPaid: boolean, createdAt: Date | string }>, trainingSessions: Array<{ __typename: 'TrainingSession', id: string, startTime: Date | string, endTime?: Date | string | null, createdAt: Date | string }>, checkInUtilization: Array<{ __typename: 'CheckInUtilizationModel', name: string, data: Array<number> }> };

export type DashboardGymsQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardGymsQuery = { __typename: 'Query', gyms: Array<{ __typename: 'Gym', name: string, trainingSessions?: Array<{ __typename: 'TrainingSession', id: string, customerBilling?: { __typename: 'CustomerBilling', paidPrice?: number | null } | null }> | null }> };

export type CompanyEmployeesQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyEmployeesQuery = { __typename: 'Query', companyEmployees: Array<{ __typename: 'CompanyEmployee', id: string, firstName?: string | null, lastName?: string | null, email: string, userType: EmployeeUserType, status: EmployeeStatus, gyms?: Array<{ __typename: 'Gym', name: string }> | null, communityClubs?: Array<{ __typename: 'CommunityClub', name: string }> | null, profile?: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } | null }> };

export type EventBookingsQueryVariables = Exact<{
  where?: InputMaybe<EventBookingWhereInput>;
  orderBy?: InputMaybe<Array<EventBookingOrderByWithRelationInput> | EventBookingOrderByWithRelationInput>;
  cursor?: InputMaybe<EventBookingWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<EventBookingScalarFieldEnum> | EventBookingScalarFieldEnum>;
}>;


export type EventBookingsQuery = { __typename: 'Query', eventBookings: Array<{ __typename: 'EventBooking', id: string, createdAt: Date | string, status: EventBookingStatus, customer: { __typename: 'Customer', id: string, firstName: string, lastName: string, email: string }, event: { __typename: 'Event', id: string, name: string, duration: number, startAt: Date | string, price?: { __typename: 'Price', id: string, price: number, pricingModel: PricingModel } | null }, gym: { __typename: 'Gym', id: string, name: string } }> };

export type PaginatedEventBookingsQueryVariables = Exact<{
  where?: InputMaybe<EventBookingWhereInput>;
  orderBy?: InputMaybe<Array<EventBookingOrderByWithRelationInput> | EventBookingOrderByWithRelationInput>;
  cursor?: InputMaybe<EventBookingWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<EventBookingScalarFieldEnum> | EventBookingScalarFieldEnum>;
}>;


export type PaginatedEventBookingsQuery = { __typename: 'Query', paginatedEventBookings: { __typename: 'PaginatedEventbookings', hasNextPage: boolean, totalCount: number, nodes: Array<{ __typename: 'EventBooking', id: string, createdAt: Date | string, status: EventBookingStatus, customer: { __typename: 'Customer', id: string, firstName: string, lastName: string, email: string }, event: { __typename: 'Event', id: string, name: string, duration: number, startAt: Date | string, price?: { __typename: 'Price', id: string, price: number, pricingModel: PricingModel } | null }, gym: { __typename: 'Gym', id: string, name: string } }>, edges?: Array<{ __typename: 'EventBookingEdge', cursor: { __typename: 'PaginatedEventbookingsCursor', id?: string | null } }> | null } };

export type EventsQueryVariables = Exact<{
  where?: InputMaybe<EventWhereInput>;
  orderBy?: InputMaybe<Array<EventOrderByWithRelationInput> | EventOrderByWithRelationInput>;
  cursor?: InputMaybe<EventWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<EventScalarFieldEnum> | EventScalarFieldEnum>;
  bookingFilter?: InputMaybe<EventBookingWhereInput>;
}>;


export type EventsQuery = { __typename: 'Query', events: Array<{ __typename: 'Event', id: string, name: string, description?: string | null, startAt: Date | string, endAt: Date | string, maxParticipants: number, createdAt: Date | string, updatedAt: Date | string, bookings?: Array<{ __typename: 'EventBooking', id: string, createdAt: Date | string, status: EventBookingStatus, customer: { __typename: 'Customer', id: string, firstName: string, lastName: string, email: string }, event: { __typename: 'Event', id: string, name: string, duration: number, startAt: Date | string, price?: { __typename: 'Price', id: string, price: number, pricingModel: PricingModel } | null }, gym: { __typename: 'Gym', id: string, name: string } }> | null, price?: { __typename: 'Price', id: string, price: number, pricingModel: PricingModel } | null, gym: { __typename: 'Gym', id: string, name: string }, _count: { __typename: 'EventCount', bookings: number, sessions: number } }> };

export type GymAdvantagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GymAdvantagesQuery = { __typename: 'Query', gymAdvantages: Array<{ __typename: 'GymAdvantage', id: string, name: string }> };

export type GymCategoriesQueryVariables = Exact<{
  where?: InputMaybe<GymCategoryWhereInput>;
  orderBy?: InputMaybe<Array<GymCategoryOrderByWithRelationInput> | GymCategoryOrderByWithRelationInput>;
  cursor?: InputMaybe<GymCategoryWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<GymCategoryScalarFieldEnum> | GymCategoryScalarFieldEnum>;
}>;


export type GymCategoriesQuery = { __typename: 'Query', gymCategories: Array<{ __typename: 'GymCategory', id: string, name: string, description?: string | null }> };

export type GymHighlightOrdersQueryVariables = Exact<{
  where?: InputMaybe<GymHighlightOrderWhereInput>;
  orderBy?: InputMaybe<Array<GymHighlightOrderOrderByWithRelationInput> | GymHighlightOrderOrderByWithRelationInput>;
}>;


export type GymHighlightOrdersQuery = { __typename: 'Query', gymHighlightOrders: Array<{ __typename: 'GymHighlightOrder', id: string, status: GymHighlightOrderStatus, startDate: string, endDate: string, amountPerGymInCents: number, totalAmountInCents: number, createdAt: Date | string, gyms: Array<{ __typename: 'Gym', id: string, name: string }>, companyBilling?: { __typename: 'CompanyBilling', id: string, invoiceNumber?: string | null, pdfKey?: string | null } | null }> };

export type GymHighlightPriceConfigsQueryVariables = Exact<{
  where?: InputMaybe<GymHighlightPriceConfigWhereInput>;
}>;


export type GymHighlightPriceConfigsQuery = { __typename: 'Query', gymHighlightPriceConfigs: Array<{ __typename: 'GymHighlightPriceConfig', id: string, active: boolean, mondayCents: number, tuesdayCents: number, wednesdayCents: number, thursdayCents: number, fridayCents: number, saturdayCents: number, sundayCents: number }> };

export type GymsForStudioHighlightQueryVariables = Exact<{
  where?: InputMaybe<GymWhereInput>;
  orderBy?: InputMaybe<Array<GymOrderByWithRelationInput> | GymOrderByWithRelationInput>;
}>;


export type GymsForStudioHighlightQuery = { __typename: 'Query', gyms: Array<{ __typename: 'Gym', id: string, name: string }> };

export type GymRatingsQueryVariables = Exact<{
  where?: InputMaybe<GymRatingWhereInput>;
  oderBy?: InputMaybe<Array<GymRatingOrderByWithRelationInput> | GymRatingOrderByWithRelationInput>;
  cursor?: InputMaybe<GymRatingWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<GymRatingScalarFieldEnum> | GymRatingScalarFieldEnum>;
}>;


export type GymRatingsQuery = { __typename: 'Query', gymRatings: Array<{ __typename: 'GymRating', id: string, rating: number, comment?: string | null, createdAt: Date | string, updatedAt: Date | string, customer: { __typename: 'Customer', id: string, firstName: string, lastName: string, email: string, dateOfBirth: Date | string, zipcode: string, street: string, houseNumber: string, place: string, mobileNumber: string, verified: boolean, createdAt: Date | string } }> };

export type PaginatedGymRatingsQueryVariables = Exact<{
  where?: InputMaybe<GymRatingWhereInput>;
  orderBy?: InputMaybe<Array<GymRatingOrderByWithRelationInput> | GymRatingOrderByWithRelationInput>;
  cursor?: InputMaybe<GymRatingWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<GymRatingScalarFieldEnum> | GymRatingScalarFieldEnum>;
}>;


export type PaginatedGymRatingsQuery = { __typename: 'Query', paginatedGymRating: { __typename: 'PaginatedGymRating', hasNextPage: boolean, totalCount: number, nodes: Array<{ __typename: 'GymRating', id: string, rating: number, comment?: string | null, createdAt: Date | string, updatedAt: Date | string, customer: { __typename: 'Customer', id: string, firstName: string, lastName: string, email: string, dateOfBirth: Date | string, zipcode: string, street: string, houseNumber: string, place: string, mobileNumber: string, verified: boolean, createdAt: Date | string } }>, edges?: Array<{ __typename: 'GymRatingEdge', cursor: { __typename: 'PaginatedGymRatingCursor', id?: string | null } }> | null } };

export type GymAccessDevicesQueryVariables = Exact<{
  input: GymAccessDevicesInput;
}>;


export type GymAccessDevicesQuery = { __typename: 'Query', gymAccessDevices: Array<{ __typename: 'GymAccessDevice', id: string, name: string, canOpenEntry: boolean, canOpenExit: boolean }> };

export type GymExistenceQueryVariables = Exact<{
  where?: InputMaybe<GymWhereInput>;
}>;


export type GymExistenceQuery = { __typename: 'Query', gyms: Array<{ __typename: 'Gym', id: string }> };

export type GymsForPickerQueryVariables = Exact<{
  where?: InputMaybe<GymWhereInput>;
  orderBy?: InputMaybe<Array<GymOrderByWithRelationInput> | GymOrderByWithRelationInput>;
  cursor?: InputMaybe<GymWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<GymScalarFieldEnum> | GymScalarFieldEnum>;
}>;


export type GymsForPickerQuery = { __typename: 'Query', gyms: Array<{ __typename: 'Gym', id: string, name: string }> };

export type GymTopRatingQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GymTopRatingQuery = { __typename: 'Query', gymTopRating: Array<{ __typename: 'GymTopRating', id: string, name: string, overallTotalRating: number }> };

export type GymsForPromotionQueryVariables = Exact<{
  where?: InputMaybe<GymWhereInput>;
  orderBy?: InputMaybe<Array<GymOrderByWithRelationInput> | GymOrderByWithRelationInput>;
  cursor?: InputMaybe<GymWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<GymScalarFieldEnum> | GymScalarFieldEnum>;
}>;


export type GymsForPromotionQuery = { __typename: 'Query', gyms: Array<{ __typename: 'Gym', id: string, name: string, promotion?: { __typename: 'Promotion', id: string, name?: string | null } | null }> };

export type GymsQueryVariables = Exact<{
  where?: InputMaybe<GymWhereInput>;
  orderBy?: InputMaybe<Array<GymOrderByWithRelationInput> | GymOrderByWithRelationInput>;
  cursor?: InputMaybe<GymWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<GymScalarFieldEnum> | GymScalarFieldEnum>;
  eventWhere?: InputMaybe<EventWhereInput>;
}>;


export type GymsQuery = { __typename: 'Query', gyms: Array<{ __typename: 'Gym', id: string, name: string, type: GymType, zipcode: string, place: string, street: string, houseNumber: string, latitude: string, longitude: string, qrcode: string, weeklySessionLimit?: number | null, minTrainingDuration: number, description?: string | null, createdAt: Date | string, updatedAt: Date | string, averageRating: number, advantages?: Array<{ __typename: 'GymAdvantage', id: string, name: string }> | null, price?: { __typename: 'Price', id: string, price: number, pricingModel: PricingModel } | null, category?: { __typename: 'GymCategory', id: string, name: string, description?: string | null } | null, images?: Array<{ __typename: 'GymImage', id: string, s3Key: string, s3ImageUrl: string, createdAt: Date | string, updatedAt: Date | string, gymId: string }> | null, events?: Array<{ __typename: 'Event', id: string, name: string, description?: string | null, startAt: Date | string, endAt: Date | string, maxParticipants: number, createdAt: Date | string, updatedAt: Date | string, price?: { __typename: 'Price', id: string, price: number, pricingModel: PricingModel } | null, gym: { __typename: 'Gym', id: string, name: string }, _count: { __typename: 'EventCount', bookings: number, sessions: number } }> | null, _count: { __typename: 'GymCount', events: number } }> };

export type PaginatedMessageQueryVariables = Exact<{
  where?: InputMaybe<MessageWhereInput>;
  orderBy?: InputMaybe<Array<MessageOrderByWithRelationInput> | MessageOrderByWithRelationInput>;
  cursor?: InputMaybe<MessageWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<MessageScalarFieldEnum> | MessageScalarFieldEnum>;
}>;


export type PaginatedMessageQuery = { __typename: 'Query', paginatedMessage: { __typename: 'PaginatedMessage', hasNextPage: boolean, totalCount: number, nodes: Array<{ __typename: 'Message', id: string, content?: string | null, sentAt: Date | string, deletedAt?: Date | string | null, locationLabel?: string | null, locationAddress?: string | null, locationLatitude?: number | null, locationLongitude?: number | null, senderProfile?: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } | null, media: Array<{ __typename: 'MessageMedia', id: string, mediaType: MediaType, key: string, url: string, thumbnailUrl?: string | null, durationSeconds?: number | null, position: number }>, sharedCommunityEvent?: { __typename: 'CommunityEvent', id: string, name: string } | null, sharedCommunityEventInstance?: { __typename: 'CommunityEventInstance', id: string, startAt: Date | string } | null }>, edges?: Array<{ __typename: 'MessageEdge', cursor: { __typename: 'PaginatedMessageCursor', id?: string | null } }> | null } };

export type OpeningHoursQueryVariables = Exact<{
  where?: InputMaybe<OpeningHourWhereInput>;
  orderBy?: InputMaybe<Array<OpeningHourOrderByWithRelationInput> | OpeningHourOrderByWithRelationInput>;
  cursor?: InputMaybe<OpeningHourWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<OpeningHourScalarFieldEnum> | OpeningHourScalarFieldEnum>;
}>;


export type OpeningHoursQuery = { __typename: 'Query', openingHours: Array<{ __typename: 'OpeningHour', id: string, day: number, open: Date | string, close: Date | string }> };

export type CompanyProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyProfileQuery = { __typename: 'Query', companyProfile?: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } | null };

export type IsHandleAvailableQueryVariables = Exact<{
  handle: Scalars['String']['input'];
}>;


export type IsHandleAvailableQuery = { __typename: 'Query', isHandleAvailable: boolean };

export type MyProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type MyProfileQuery = { __typename: 'Query', myProfile?: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } | null };

export type ProfileQueryVariables = Exact<{
  where: ProfileWhereUniqueInput;
}>;


export type ProfileQuery = { __typename: 'Query', profile: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } };

export type SearchProfilesQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type SearchProfilesQuery = { __typename: 'Query', searchProfiles: Array<{ __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null }> };

export type PromotionCodesQueryVariables = Exact<{
  where?: InputMaybe<PromotionCodeWhereInput>;
  orderBy?: InputMaybe<Array<PromotionCodeOrderByWithRelationInput> | PromotionCodeOrderByWithRelationInput>;
  cursor?: InputMaybe<PromotionCodeWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<PromotionCodeScalarFieldEnum> | PromotionCodeScalarFieldEnum>;
}>;


export type PromotionCodesQuery = { __typename: 'Query', promotionCodes: Array<{ __typename: 'PromotionCode', id: string, promotionCode: string, description?: string | null, percentage: number, usageLimit?: number | null, startDate?: Date | string | null, endDate?: Date | string | null, createdAt: Date | string, updatedAt: Date | string, deletedAt?: Date | string | null, company?: { __typename: 'Company', id: string } | null, _count: { __typename: 'PromotionCodeCount', customerPromotionCode: number, trainings: number } }> };

export type AvailableStripeCouponsQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableStripeCouponsQuery = { __typename: 'Query', availableStripeCoupons: Array<{ __typename: 'StripeCoupon', percentage: number }> };

export type PromotionsQueryVariables = Exact<{
  where?: InputMaybe<PromotionWhereInput>;
  orderBy?: InputMaybe<Array<PromotionOrderByWithRelationInput> | PromotionOrderByWithRelationInput>;
  cursor?: InputMaybe<PromotionWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<PromotionScalarFieldEnum> | PromotionScalarFieldEnum>;
}>;


export type PromotionsQuery = { __typename: 'Query', promotions: Array<{ __typename: 'Promotion', id: string, active: boolean, name?: string | null, description?: string | null, imageUrl?: string | null, clickUrl?: string | null, gyms?: Array<{ __typename: 'Gym', id: string, name: string }> | null }> };

export type PushNotificationHistoriesQueryVariables = Exact<{
  where?: InputMaybe<PushNotificationHistoryWhereInput>;
  orderBy?: InputMaybe<Array<PushNotificationHistoryOrderByWithRelationInput> | PushNotificationHistoryOrderByWithRelationInput>;
  cursor?: InputMaybe<PushNotificationHistoryWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<PushNotificationHistoryScalarFieldEnum> | PushNotificationHistoryScalarFieldEnum>;
}>;


export type PushNotificationHistoriesQuery = { __typename: 'Query', pushNotificationHistories: Array<{ __typename: 'PushNotificationHistory', id: string, affectedCustomers: number, sendAt: Date | string, pushNotification: { __typename: 'PushNotification', title: string, message: string, type: PushNotificationSendType } }> };

export type PushNotificationsQueryVariables = Exact<{
  where?: InputMaybe<PushNotificationWhereInput>;
  orderBy?: InputMaybe<Array<PushNotificationOrderByWithRelationInput> | PushNotificationOrderByWithRelationInput>;
  cursor?: InputMaybe<PushNotificationWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<PushNotificationScalarFieldEnum> | PushNotificationScalarFieldEnum>;
}>;


export type PushNotificationsQuery = { __typename: 'Query', pushNotifications: Array<{ __typename: 'PushNotification', id: string, title: string, message: string, type: PushNotificationSendType, status: PushNotificationStatus, cronExpression?: string | null, cronStartDate?: Date | string | null, cronInterval?: CronInterval | null, sendAt?: Date | string | null, createdAt: Date | string }> };

export type RatingQuestionsQueryVariables = Exact<{
  where?: InputMaybe<RatingQuestionWhereInput>;
  orderBy?: InputMaybe<Array<RatingQuestionOrderByWithRelationInput> | RatingQuestionOrderByWithRelationInput>;
  cursor?: InputMaybe<RatingQuestionWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<RatingQuestionScalarFieldEnum> | RatingQuestionScalarFieldEnum>;
  gymId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type RatingQuestionsQuery = { __typename: 'Query', ratingQuestions: Array<{ __typename: 'RatingQuestion', id: string, question: string, isActive: boolean, type: RatingQuestionType, createdAt: Date | string, updatedAt: Date | string, computedRating: { __typename: 'ComputedRating', value: number, type?: ComputedRatingType | null } }> };

export type PublicRatingQuestionsQueryVariables = Exact<{
  where: PublicRatingQuestionWhereInput;
}>;


export type PublicRatingQuestionsQuery = { __typename: 'Query', publicRatingQuestions: Array<{ __typename: 'PublicRatingQuestion', id: string, question: string, type: RatingQuestionType }> };

export type ReportsQueryVariables = Exact<{
  where?: InputMaybe<ReportWhereInput>;
  orderBy?: InputMaybe<Array<ReportOrderByWithRelationInput> | ReportOrderByWithRelationInput>;
  cursor?: InputMaybe<ReportWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<ReportScalarFieldEnum> | ReportScalarFieldEnum>;
}>;


export type ReportsQuery = { __typename: 'Query', reports: Array<{ __typename: 'Report', id: string, reportedAt: Date | string, reporterProfile: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null }, communityClub?: { __typename: 'CommunityClub', id: string, name: string } | null, userPost?: { __typename: 'UserPost', id: string, content?: string | null, scope: PostScope, postedAt: Date | string, authorProfile: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null }, media?: Array<{ __typename: 'PostMedia', id: string, mediaType: MediaType, url: string, thumbnailUrl?: string | null, position: number }> | null } | null, communityPostComment?: { __typename: 'CommunityPostComment', id: string, content: string, userPost?: { __typename: 'UserPost', id: string } | null, profile?: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null } | null, customer?: { __typename: 'Customer', firstName: string, lastName: string } | null } | null }> };

export type SendMailToSupportQueryVariables = Exact<{
  fromMail: Scalars['String']['input'];
  mailType: MailTypes;
  subject?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendMailToSupportQuery = { __typename: 'Query', sendMailToSupport: { __typename: 'MailModel', successful: boolean } };

export type ActiveTrainingSessionsQueryVariables = Exact<{
  where?: InputMaybe<TrainingSessionWhereInput>;
  orderBy?: InputMaybe<Array<TrainingSessionOrderByWithRelationInput> | TrainingSessionOrderByWithRelationInput>;
  cursor?: InputMaybe<TrainingSessionWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<TrainingSessionScalarFieldEnum> | TrainingSessionScalarFieldEnum>;
}>;


export type ActiveTrainingSessionsQuery = { __typename: 'Query', trainingSessions: Array<{ __typename: 'TrainingSession', id: string, startTime: Date | string, endTime?: Date | string | null, event?: { __typename: 'Event', id: string, name: string, duration: number, price?: { __typename: 'Price', price: number } | null } | null, promotionCode?: { __typename: 'PromotionCode', id: string, percentage: number, promotionCode: string } | null, price: { __typename: 'Price', price: number, pricingModel: PricingModel }, gym: { __typename: 'Gym', id: string, name: string, minTrainingDuration: number }, customer: { __typename: 'Customer', id: string, firstName: string, lastName: string, email: string } }> };

export type CustomerTrainingSessionInfoQueryVariables = Exact<{
  where?: InputMaybe<TrainingSessionWhereInput>;
  orderBy?: InputMaybe<Array<TrainingSessionOrderByWithRelationInput> | TrainingSessionOrderByWithRelationInput>;
  cursor?: InputMaybe<TrainingSessionWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<TrainingSessionScalarFieldEnum> | TrainingSessionScalarFieldEnum>;
}>;


export type CustomerTrainingSessionInfoQuery = { __typename: 'Query', trainingSessions: Array<{ __typename: 'TrainingSession', id: string, startTime: Date | string, endTime?: Date | string | null, gym: { __typename: 'Gym', id: string, name: string }, customerBilling?: { __typename: 'CustomerBilling', id: number, status: BillingStatus, isPaid: boolean, trainingPrice?: number | null, paidPrice?: number | null } | null, promotionCode?: { __typename: 'PromotionCode', id: string, percentage: number, promotionCode: string } | null, event?: { __typename: 'Event', id: string, name: string, duration: number, startAt: Date | string, price?: { __typename: 'Price', id: string, price: number, pricingModel: PricingModel } | null } | null }> };

export type PaginatedTrainingsQueryVariables = Exact<{
  where?: InputMaybe<TrainingSessionWhereInput>;
  orderBy?: InputMaybe<Array<TrainingSessionOrderByWithRelationInput> | TrainingSessionOrderByWithRelationInput>;
  cursor?: InputMaybe<TrainingSessionWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<TrainingSessionScalarFieldEnum> | TrainingSessionScalarFieldEnum>;
}>;


export type PaginatedTrainingsQuery = { __typename: 'Query', paginatedTrainingSessions: { __typename: 'PaginatedTrainings', hasNextPage: boolean, totalCount: number, nodes: Array<{ __typename: 'TrainingSession', id: string, startTime: Date | string, endTime?: Date | string | null, gym: { __typename: 'Gym', id: string, name: string }, customer: { __typename: 'Customer', email: string, id: string, firstName: string, lastName: string }, promotionCode?: { __typename: 'PromotionCode', id: string, percentage: number, promotionCode: string } | null, price: { __typename: 'Price', pricingModel: PricingModel }, customerBilling?: { __typename: 'CustomerBilling', id: number, status: BillingStatus, isPaid: boolean, trainingPrice?: number | null, paidPrice?: number | null, errorMessage?: string | null } | null }>, edges?: Array<{ __typename: 'TrainingSessionEdge', cursor: { __typename: 'PaginatedTrainingsCursor', id?: string | null } }> | null } };

export type TrainingSessionTrendQueryVariables = Exact<{
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  timezone: Scalars['TimeZone']['input'];
  gymId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type TrainingSessionTrendQuery = { __typename: 'Query', trainingSessionTrend: { __typename: 'TrendMetric', periodCount: number, previousPeriodCount: number, trend: number, dateGroupedCount: Array<{ __typename: 'DateGroupedCount', date: Date | string, count: number }> } };

export type UserPostsQueryVariables = Exact<{
  where?: InputMaybe<UserPostWhereInput>;
  orderBy?: InputMaybe<Array<UserPostOrderByWithRelationInput> | UserPostOrderByWithRelationInput>;
  cursor?: InputMaybe<UserPostWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<UserPostScalarFieldEnum> | UserPostScalarFieldEnum>;
}>;


export type UserPostsQuery = { __typename: 'Query', userPosts: Array<{ __typename: 'UserPost', id: string, scope: PostScope, postType: UserPostType, content?: string | null, postedAt: Date | string, authorProfile: { __typename: 'Profile', id: string, ownerType: ProfileOwnerType, handle: string, avatarKey?: string | null, avatarUrl?: string | null, bio?: string | null, place?: string | null, fullName?: string | null, isFeaturedForDiscovery: boolean, createdAt: Date | string, updatedAt: Date | string, tags?: Array<{ __typename: 'ProfileTag', id: string, name: string }> | null }, communityClub?: { __typename: 'CommunityClub', id: string, name: string } | null, media?: Array<{ __typename: 'PostMedia', id: string, mediaType: MediaType, url: string, thumbnailUrl?: string | null, durationSeconds?: number | null, position: number }> | null, _count: { __typename: 'UserPostCount', communityPostLikes: number, communityPostComments: number } }> };

export const ProfileFieldsFragmentDoc = gql`
    fragment ProfileFields on Profile {
  id
  ownerType
  handle
  avatarKey
  avatarUrl
  bio
  place
  fullName
  isFeaturedForDiscovery
  tags {
    id
    name
  }
  createdAt
  updatedAt
}
    `;
export const CircleFieldsFragmentDoc = gql`
    fragment CircleFields on Circle {
  id
  mediaType
  key
  url
  thumbnailUrl
  durationSeconds
  text
  link
  expiresAt
  createdAt
  authorProfile {
    ...ProfileFields
  }
  _count {
    circleViews
  }
}
    ${ProfileFieldsFragmentDoc}`;
export const CommunityClubPickerFieldsFragmentDoc = gql`
    fragment CommunityClubPickerFields on CommunityClub {
  id
  name
}
    `;
export const CommunityClubFieldsFragmentDoc = gql`
    fragment CommunityClubFields on CommunityClub {
  id
  name
  description
  s3LogoKey
  s3LogoUrl
  s3CoverImageKey
  s3CoverImageUrl
  zipcode
  place
  street
  houseNumber
  latitude
  longitude
  createdAt
  updatedAt
  memberCount
  plannedEventsCount
  membersCanPost
  ticketingEnabled
  profile {
    id
    handle
  }
}
    `;
export const CommunityEventBookingInfoFragmentDoc = gql`
    fragment CommunityEventBookingInfo on CommunityEventBooking {
  id
  status
  communityEventInstance {
    id
    startAt
    endAt
    communityEvent {
      id
      name
    }
  }
}
    `;
export const CommunityEventBookingParticipantFieldsFragmentDoc = gql`
    fragment CommunityEventBookingParticipantFields on CommunityEventBooking {
  id
  status
  customer {
    id
    firstName
    lastName
    email
    profile {
      id
      handle
    }
  }
}
    `;
export const CommunityEventBookingFieldsFragmentDoc = gql`
    fragment CommunityEventBookingFields on CommunityEventBooking {
  id
  status
  communityEventInstance {
    id
    startAt
    endAt
  }
  customer {
    id
    firstName
    lastName
  }
}
    `;
export const CommunityEventCategoryFieldsFragmentDoc = gql`
    fragment CommunityEventCategoryFields on CommunityEventCategory {
  id
  name
  description
  iconName
}
    `;
export const CommunityEventImageFieldsFragmentDoc = gql`
    fragment CommunityEventImageFields on CommunityEventImage {
  id
  s3ImageUrl
  communityEvent {
    id
  }
}
    `;
export const CommunityEventInstanceAttendanceFieldsFragmentDoc = gql`
    fragment CommunityEventInstanceAttendanceFields on CommunityEventInstance {
  id
  startAt
  endAt
  attendance {
    registeredCount
    checkedInCount
    noShowCount
  }
}
    `;
export const CommunityEventInstanceFieldsFragmentDoc = gql`
    fragment CommunityEventInstanceFields on CommunityEventInstance {
  id
  startAt
  endAt
}
    `;
export const CommunityEventLocationFieldsFragmentDoc = gql`
    fragment CommunityEventLocationFields on CommunityEventLocation {
  id
  name
  zipcode
  place
  street
  houseNumber
  latitude
  longitude
  communityClub {
    id
  }
}
    `;
export const CommunityEventPartnerFieldsFragmentDoc = gql`
    fragment CommunityEventPartnerFields on CommunityEventPartner {
  id
  name
  description
  s3LogoKey
  s3LogoUrl
  street
  houseNumber
  zipcode
  place
  latitude
  longitude
}
    `;
export const CommunityEventTicketFieldsFragmentDoc = gql`
    fragment CommunityEventTicketFields on CommunityEventTicket {
  id
  status
  source
  priceInCents
  issuedAt
  usedAt
  refundRequestedAt
  refundedAt
  priceTier {
    id
    name
  }
  customer {
    id
    firstName
    lastName
  }
}
    `;
export const CommunityEventTicketPurchaseGrantFieldsFragmentDoc = gql`
    fragment CommunityEventTicketPurchaseGrantFields on CommunityEventTicketPurchaseGrant {
  id
  validUntil
  usedAt
  revokedAt
  createdAt
  priceTier {
    id
    name
    priceInCents
  }
  customer {
    id
    firstName
    lastName
  }
}
    `;
export const CommunityEventPriceTierFieldsFragmentDoc = gql`
    fragment CommunityEventPriceTierFields on CommunityEventPriceTier {
  id
  name
  priceInCents
  sortOrder
  quota
  validUntil
  closedAt
}
    `;
export const CommunityEventTicketSaleFieldsFragmentDoc = gql`
    fragment CommunityEventTicketSaleFields on CommunityEventTicketSale {
  id
  salesStartAt
  rescheduledAt
  canceledAt
  complimentaryQuota
  availableTicketCount
  communityClub {
    id
  }
  activePriceTier {
    ...CommunityEventPriceTierFields
  }
  priceTiers {
    ...CommunityEventPriceTierFields
  }
  reservations {
    id
    status
  }
  queueEntries {
    id
  }
}
    ${CommunityEventPriceTierFieldsFragmentDoc}`;
export const CommunityEventFieldsFragmentDoc = gql`
    fragment CommunityEventFields on CommunityEvent {
  id
  name
  description
  isActive
  isLimited
  isDraft
  isPaid
  durationMin
  s3HeaderImageKey
  s3HeaderImageUrl
  maxParticipants
  advanceGenerationDays
  recurrenceFreq
  recurrenceInterval
  recurrenceStartDate
  recurrenceEndType
  recurrenceUntil
  recurrenceCount
  recurrenceByweekday
  recurrenceMonthOption
  communityClub {
    id
    name
  }
  communityEventPartner {
    id
    name
  }
  communityEventLocation {
    id
    name
  }
  communityEventCategory {
    id
    name
    iconName
  }
  host {
    ...ProfileFields
  }
}
    ${ProfileFieldsFragmentDoc}`;
export const CommunityPostCommentFieldsFragmentDoc = gql`
    fragment CommunityPostCommentFields on CommunityPostComment {
  id
  content
  customer {
    firstName
    lastName
  }
  profile {
    fullName
  }
}
    `;
export const CommunityPostFieldsFragmentDoc = gql`
    fragment CommunityPostFields on CommunityPost {
  id
  title
  content
  postedAt
  s3ImageUrl
  author {
    ...ProfileFields
  }
  communityClub {
    id
    name
  }
  _count {
    communityPostLikes
    communityPostComments
  }
}
    ${ProfileFieldsFragmentDoc}`;
export const ReportFieldsFragmentDoc = gql`
    fragment ReportFields on Report {
  id
  reportedAt
  reporterProfile {
    ...ProfileFields
  }
  communityClub {
    id
    name
  }
  userPost {
    id
    content
    scope
    postedAt
    authorProfile {
      ...ProfileFields
    }
    media {
      id
      mediaType
      url
      thumbnailUrl
      position
    }
  }
  communityPostComment {
    id
    content
    userPost {
      id
    }
    profile {
      ...ProfileFields
    }
    customer {
      firstName
      lastName
    }
  }
}
    ${ProfileFieldsFragmentDoc}`;
export const UserPostFieldsFragmentDoc = gql`
    fragment UserPostFields on UserPost {
  id
  scope
  postType
  content
  postedAt
  authorProfile {
    ...ProfileFields
  }
  communityClub {
    id
    name
  }
  media {
    id
    mediaType
    url
    thumbnailUrl
    durationSeconds
    position
  }
  _count {
    communityPostLikes
    communityPostComments
  }
}
    ${ProfileFieldsFragmentDoc}`;
export const CompanyFieldsFragmentDoc = gql`
    fragment CompanyFields on Company {
  id
  logoUrl
}
    `;
export const CompanyAddressFieldsFragmentDoc = gql`
    fragment CompanyAddressFields on Company {
  street
  houseNumber
  place
  zipcode
}
    `;
export const CompanyInformationFieldsFragmentDoc = gql`
    fragment CompanyInformationFields on Company {
  ...CompanyFields
  ...CompanyAddressFields
  name
  email
  comission
  primaryColor
  secondaryColor
}
    ${CompanyFieldsFragmentDoc}
${CompanyAddressFieldsFragmentDoc}`;
export const MessageFieldsFragmentDoc = gql`
    fragment MessageFields on Message {
  id
  content
  sentAt
  deletedAt
  locationLabel
  locationAddress
  locationLatitude
  locationLongitude
  senderProfile {
    ...ProfileFields
  }
  media {
    id
    mediaType
    key
    url
    thumbnailUrl
    durationSeconds
    position
  }
  sharedCommunityEvent {
    id
    name
  }
  sharedCommunityEventInstance {
    id
    startAt
  }
}
    ${ProfileFieldsFragmentDoc}`;
export const ConversationFieldsFragmentDoc = gql`
    fragment ConversationFields on Conversation {
  id
  hasUnreadMessages
  lastMessageAt
  createdAt
  otherProfile {
    ...ProfileFields
  }
  lastMessage {
    ...MessageFields
  }
}
    ${ProfileFieldsFragmentDoc}
${MessageFieldsFragmentDoc}`;
export const PaginatedConversationFieldsFragmentDoc = gql`
    fragment PaginatedConversationFields on PaginatedConversation {
  nodes {
    ...ConversationFields
  }
  hasNextPage
  totalCount
  edges {
    cursor {
      id
    }
  }
}
    ${ConversationFieldsFragmentDoc}`;
export const CustomerPromotionCodeFieldsFragmentDoc = gql`
    fragment CustomerPromotionCodeFields on CustomerPromotionCode {
  id
  promoCode
  usageCount
  promotionCode {
    promotionCode
    percentage
  }
}
    `;
export const CustomerTopRankingFieldsFragmentDoc = gql`
    fragment CustomerTopRankingFields on CustomerTopRanking {
  firstName
  lastName
  email
  salesTotal
  trainingsTotal
}
    `;
export const CustomerFieldsFragmentDoc = gql`
    fragment CustomerFields on Customer {
  id
  firstName
  lastName
  email
  dateOfBirth
  zipcode
  street
  houseNumber
  place
  mobileNumber
  verified
  createdAt
}
    `;
export const PaginatedCustomerFieldsFragmentDoc = gql`
    fragment PaginatedCustomerFields on PaginatedCustomers {
  nodes {
    ...CustomerFields
  }
  hasNextPage
  totalCount
  edges {
    cursor {
      id
    }
  }
}
    ${CustomerFieldsFragmentDoc}`;
export const DashboardCustomerBillingsFragmentDoc = gql`
    fragment DashboardCustomerBillings on CustomerBilling {
  id
  paidPrice
  status
  isPaid
  createdAt
}
    `;
export const DashboardCustomersFragmentDoc = gql`
    fragment DashboardCustomers on Customer {
  id
  firstName
  lastName
  createdAt
  dateOfBirth
}
    `;
export const DashboardTrainingSessionsFragmentDoc = gql`
    fragment DashboardTrainingSessions on TrainingSession {
  id
  startTime
  endTime
  createdAt
}
    `;
export const DashboardGymTrainingSessionsFragmentDoc = gql`
    fragment DashboardGymTrainingSessions on Gym {
  name
  trainingSessions {
    id
    customerBilling {
      paidPrice
    }
  }
}
    `;
export const CompanyEmployeeFieldsFragmentDoc = gql`
    fragment CompanyEmployeeFields on CompanyEmployee {
  id
  firstName
  lastName
  email
  userType
  status
  gyms {
    name
  }
  communityClubs {
    name
  }
  profile {
    ...ProfileFields
  }
}
    ${ProfileFieldsFragmentDoc}`;
export const PriceFieldsFragmentDoc = gql`
    fragment PriceFields on Price {
  id
  price
  pricingModel
}
    `;
export const EventBookingFieldsFragmentDoc = gql`
    fragment EventBookingFields on EventBooking {
  id
  createdAt
  customer {
    id
    firstName
    lastName
    email
  }
  event {
    id
    name
    duration
    price {
      ...PriceFields
    }
    startAt
  }
  gym {
    id
    name
  }
  status
}
    ${PriceFieldsFragmentDoc}`;
export const PaginatedEventBookingsFieldsFragmentDoc = gql`
    fragment PaginatedEventBookingsFields on PaginatedEventbookings {
  nodes {
    ...EventBookingFields
  }
  hasNextPage
  totalCount
  edges {
    cursor {
      id
    }
  }
}
    ${EventBookingFieldsFragmentDoc}`;
export const GymForHighlightFieldsFragmentDoc = gql`
    fragment GymForHighlightFields on Gym {
  id
  name
}
    `;
export const GymHighlightOrderFieldsFragmentDoc = gql`
    fragment GymHighlightOrderFields on GymHighlightOrder {
  id
  status
  startDate
  endDate
  amountPerGymInCents
  totalAmountInCents
  createdAt
  gyms {
    id
    name
  }
  companyBilling {
    id
    invoiceNumber
    pdfKey
  }
}
    `;
export const GymHighlightPriceConfigFieldsFragmentDoc = gql`
    fragment GymHighlightPriceConfigFields on GymHighlightPriceConfig {
  id
  active
  mondayCents
  tuesdayCents
  wednesdayCents
  thursdayCents
  fridayCents
  saturdayCents
  sundayCents
}
    `;
export const GymAccessDeviceFieldsFragmentDoc = gql`
    fragment GymAccessDeviceFields on GymAccessDevice {
  id
  name
  canOpenEntry
  canOpenExit
}
    `;
export const GymPickerFieldsFragmentDoc = gql`
    fragment GymPickerFields on Gym {
  id
  name
}
    `;
export const GymTopRatingFieldsFragmentDoc = gql`
    fragment GymTopRatingFields on GymTopRating {
  id
  name
  overallTotalRating
}
    `;
export const GymAdvantageFieldsFragmentDoc = gql`
    fragment GymAdvantageFields on GymAdvantage {
  id
  name
}
    `;
export const GymCategoryFieldsFragmentDoc = gql`
    fragment GymCategoryFields on GymCategory {
  id
  name
  description
}
    `;
export const GymImageFieldsFragmentDoc = gql`
    fragment GymImageFields on GymImage {
  id
  s3Key
  s3ImageUrl
  createdAt
  updatedAt
  gymId
}
    `;
export const EventFieldsFragmentDoc = gql`
    fragment EventFields on Event {
  id
  name
  description
  startAt
  endAt
  price {
    ...PriceFields
  }
  maxParticipants
  gym {
    id
    name
  }
  createdAt
  updatedAt
  _count {
    bookings
    sessions
  }
}
    ${PriceFieldsFragmentDoc}`;
export const GymFieldsFragmentDoc = gql`
    fragment GymFields on Gym {
  id
  name
  type
  zipcode
  place
  street
  houseNumber
  latitude
  longitude
  qrcode
  weeklySessionLimit
  minTrainingDuration
  description
  createdAt
  updatedAt
  advantages {
    ...GymAdvantageFields
  }
  price {
    ...PriceFields
  }
  category {
    ...GymCategoryFields
  }
  averageRating
  images {
    ...GymImageFields
  }
  events(where: $eventWhere) {
    ...EventFields
  }
  _count {
    events
  }
}
    ${GymAdvantageFieldsFragmentDoc}
${PriceFieldsFragmentDoc}
${GymCategoryFieldsFragmentDoc}
${GymImageFieldsFragmentDoc}
${EventFieldsFragmentDoc}`;
export const GymsForPromotionsFieldsFragmentDoc = gql`
    fragment GymsForPromotionsFields on Gym {
  id
  name
  promotion {
    id
    name
  }
}
    `;
export const PaginatedMessageFieldsFragmentDoc = gql`
    fragment PaginatedMessageFields on PaginatedMessage {
  nodes {
    ...MessageFields
  }
  hasNextPage
  totalCount
  edges {
    cursor {
      id
    }
  }
}
    ${MessageFieldsFragmentDoc}`;
export const OpeningHourFieldsFragmentDoc = gql`
    fragment OpeningHourFields on OpeningHour {
  id
  day
  open
  close
}
    `;
export const GymRatingFieldsFragmentDoc = gql`
    fragment GymRatingFields on GymRating {
  id
  rating
  comment
  createdAt
  updatedAt
  customer {
    ...CustomerFields
  }
}
    ${CustomerFieldsFragmentDoc}`;
export const PaginatedGymRatingFieldsFragmentDoc = gql`
    fragment PaginatedGymRatingFields on PaginatedGymRating {
  nodes {
    ...GymRatingFields
  }
  hasNextPage
  totalCount
  edges {
    cursor {
      id
    }
  }
}
    ${GymRatingFieldsFragmentDoc}`;
export const PromotionCodeFieldsFragmentDoc = gql`
    fragment PromotionCodeFields on PromotionCode {
  id
  promotionCode
  company {
    id
  }
  description
  percentage
  usageLimit
  startDate
  endDate
  createdAt
  updatedAt
  deletedAt
  _count {
    customerPromotionCode
    trainings
  }
}
    `;
export const PromotionFieldsFragmentDoc = gql`
    fragment PromotionFields on Promotion {
  id
  active
  name
  description
  imageUrl
  clickUrl
  gyms {
    id
    name
  }
}
    `;
export const PushNotificationHistoryFieldsFragmentDoc = gql`
    fragment PushNotificationHistoryFields on PushNotificationHistory {
  id
  affectedCustomers
  pushNotification {
    title
    message
    type
  }
  sendAt
}
    `;
export const PushNotificationFieldsFragmentDoc = gql`
    fragment PushNotificationFields on PushNotification {
  id
  title
  message
  type
  status
  cronExpression
  cronStartDate
  cronInterval
  sendAt
  createdAt
}
    `;
export const RatingQuestionFieldsFragmentDoc = gql`
    fragment RatingQuestionFields on RatingQuestion {
  id
  question
  isActive
  type
  computedRating(gymId: $gymId) {
    value
    type
  }
  createdAt
  updatedAt
  __typename
}
    `;
export const ActiveTrainingSessionFragmentDoc = gql`
    fragment ActiveTrainingSession on TrainingSession {
  id
  startTime
  endTime
  event {
    id
    name
    duration
    price {
      price
    }
  }
  promotionCode {
    id
    percentage
    promotionCode
  }
  price {
    price
    pricingModel
  }
  gym {
    id
    name
    minTrainingDuration
  }
  customer {
    id
    firstName
    lastName
    email
  }
}
    `;
export const CustomerTrainingSessionInfoFragmentDoc = gql`
    fragment CustomerTrainingSessionInfo on TrainingSession {
  id
  startTime
  endTime
  gym {
    id
    name
  }
  customerBilling {
    id
    status
    isPaid
    trainingPrice
    paidPrice
  }
  promotionCode {
    id
    percentage
    promotionCode
  }
  event {
    id
    name
    duration
    price {
      ...PriceFields
    }
    startAt
  }
}
    ${PriceFieldsFragmentDoc}`;
export const CompleteTrainingSessionFragmentDoc = gql`
    fragment CompleteTrainingSession on TrainingSession {
  id
  startTime
  endTime
  gym {
    id
    name
  }
  customer {
    email
    id
    firstName
    lastName
  }
  promotionCode {
    id
    percentage
    promotionCode
  }
  price {
    pricingModel
  }
  customerBilling {
    id
    status
    isPaid
    trainingPrice
    paidPrice
    errorMessage
  }
}
    `;
export const PaginatedTrainingsFieldsFragmentDoc = gql`
    fragment PaginatedTrainingsFields on PaginatedTrainings {
  nodes {
    ...CompleteTrainingSession
  }
  hasNextPage
  totalCount
  edges {
    cursor {
      id
    }
  }
}
    ${CompleteTrainingSessionFragmentDoc}`;
export const TrendMetricFieldsFragmentDoc = gql`
    fragment TrendMetricFields on TrendMetric {
  periodCount
  previousPeriodCount
  dateGroupedCount {
    date
    count
  }
  trend
}
    `;
export const CreateCircleDocument = gql`
    mutation CreateCircle($data: CircleCreateInput!) {
  createCircle(data: $data) {
    ...CircleFields
  }
}
    ${CircleFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCircleGQL extends Apollo.Mutation<CreateCircleMutation, CreateCircleMutationVariables> {
    override document = CreateCircleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCircleDocument = gql`
    mutation DeleteCircle($where: CircleWhereUniqueInput!) {
  deleteCircle(where: $where) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCircleGQL extends Apollo.Mutation<DeleteCircleMutation, DeleteCircleMutationVariables> {
    override document = DeleteCircleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubmitCommunityClubOnboardingDocument = gql`
    mutation SubmitCommunityClubOnboarding($data: CommunityClubOnboardingSubmitInput!) {
  submitCommunityClubOnboarding(data: $data) {
    id
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SubmitCommunityClubOnboardingGQL extends Apollo.Mutation<SubmitCommunityClubOnboardingMutation, SubmitCommunityClubOnboardingMutationVariables> {
    override document = SubmitCommunityClubOnboardingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ActivateCommunityEventBookingsFromWaitlistDocument = gql`
    mutation ActivateCommunityEventBookingsFromWaitlist($data: CommunityEventBookingActivateWaitlistInput!) {
  activateCommunityEventBookingsFromWaitlist(data: $data) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ActivateCommunityEventBookingsFromWaitlistGQL extends Apollo.Mutation<ActivateCommunityEventBookingsFromWaitlistMutation, ActivateCommunityEventBookingsFromWaitlistMutationVariables> {
    override document = ActivateCommunityEventBookingsFromWaitlistDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancelCommunityEventBookingManagementDocument = gql`
    mutation CancelCommunityEventBookingManagement($where: CommunityEventBookingWhereUniqueInput!) {
  cancelCommunityEventBookingManagement(where: $where) {
    ...CommunityEventBookingFields
  }
}
    ${CommunityEventBookingFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CancelCommunityEventBookingManagementGQL extends Apollo.Mutation<CancelCommunityEventBookingManagementMutation, CancelCommunityEventBookingManagementMutationVariables> {
    override document = CancelCommunityEventBookingManagementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCommunityEventImageDocument = gql`
    mutation CreateCommunityEventImage($data: CommunityEventImageCreateInput!) {
  createCommunityEventImage(data: $data) {
    ...CommunityEventImageFields
  }
}
    ${CommunityEventImageFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCommunityEventImageGQL extends Apollo.Mutation<CreateCommunityEventImageMutation, CreateCommunityEventImageMutationVariables> {
    override document = CreateCommunityEventImageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCommunityEventImagesDocument = gql`
    mutation CreateCommunityEventImages($data: CommunityEventImagesCreateInput!) {
  createCommunityEventImages(data: $data) {
    ...CommunityEventImageFields
  }
}
    ${CommunityEventImageFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCommunityEventImagesGQL extends Apollo.Mutation<CreateCommunityEventImagesMutation, CreateCommunityEventImagesMutationVariables> {
    override document = CreateCommunityEventImagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCommunityEventImageDocument = gql`
    mutation DeleteCommunityEventImage($where: CommunityEventImageWhereUniqueInput!) {
  deleteCommunityEventImage(where: $where) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCommunityEventImageGQL extends Apollo.Mutation<DeleteCommunityEventImageMutation, DeleteCommunityEventImageMutationVariables> {
    override document = DeleteCommunityEventImageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCommunityEventInstanceDocument = gql`
    mutation CreateCommunityEventInstance($data: CommunityEventInstanceCreateInput!) {
  createCommunityEventInstance(data: $data) {
    ...CommunityEventInstanceFields
  }
}
    ${CommunityEventInstanceFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCommunityEventInstanceGQL extends Apollo.Mutation<CreateCommunityEventInstanceMutation, CreateCommunityEventInstanceMutationVariables> {
    override document = CreateCommunityEventInstanceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCommunityEventInstanceDocument = gql`
    mutation DeleteCommunityEventInstance($where: CommunityEventInstanceWhereUniqueInput!) {
  deleteCommunityEventInstance(where: $where) {
    ...CommunityEventInstanceFields
  }
}
    ${CommunityEventInstanceFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCommunityEventInstanceGQL extends Apollo.Mutation<DeleteCommunityEventInstanceMutation, DeleteCommunityEventInstanceMutationVariables> {
    override document = DeleteCommunityEventInstanceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCommunityEventInstanceDocument = gql`
    mutation UpdateCommunityEventInstance($data: CommunityEventInstanceUpdateInput!, $where: CommunityEventInstanceWhereUniqueInput!) {
  updateCommunityEventInstance(data: $data, where: $where) {
    ...CommunityEventInstanceFields
  }
}
    ${CommunityEventInstanceFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCommunityEventInstanceGQL extends Apollo.Mutation<UpdateCommunityEventInstanceMutation, UpdateCommunityEventInstanceMutationVariables> {
    override document = UpdateCommunityEventInstanceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCommunityEventLocationDocument = gql`
    mutation CreateCommunityEventLocation($createArgs: CommunityEventLocationCreateInput!) {
  createOneCommunityEventLocation(data: $createArgs) {
    ...CommunityEventLocationFields
  }
}
    ${CommunityEventLocationFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCommunityEventLocationGQL extends Apollo.Mutation<CreateCommunityEventLocationMutation, CreateCommunityEventLocationMutationVariables> {
    override document = CreateCommunityEventLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCommunityEventLocationDocument = gql`
    mutation DeleteCommunityEventLocation($where: CommunityEventLocationWhereUniqueInput!) {
  deleteCommunityEventLocation(where: $where) {
    ...CommunityEventLocationFields
  }
}
    ${CommunityEventLocationFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCommunityEventLocationGQL extends Apollo.Mutation<DeleteCommunityEventLocationMutation, DeleteCommunityEventLocationMutationVariables> {
    override document = DeleteCommunityEventLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCommunityEventLocationDocument = gql`
    mutation UpdateCommunityEventLocation($data: CommunityEventLocationUpdateInput!, $where: CommunityEventLocationWhereUniqueInput!) {
  updateOneCommunityEventLocation(data: $data, where: $where) {
    ...CommunityEventLocationFields
  }
}
    ${CommunityEventLocationFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCommunityEventLocationGQL extends Apollo.Mutation<UpdateCommunityEventLocationMutation, UpdateCommunityEventLocationMutationVariables> {
    override document = UpdateCommunityEventLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCommunityEventPartnerDocument = gql`
    mutation CreateCommunityEventPartner($createArgs: CommunityEventPartnerCreateInput!) {
  createOneCommunityEventPartner(data: $createArgs) {
    ...CommunityEventPartnerFields
  }
}
    ${CommunityEventPartnerFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCommunityEventPartnerGQL extends Apollo.Mutation<CreateCommunityEventPartnerMutation, CreateCommunityEventPartnerMutationVariables> {
    override document = CreateCommunityEventPartnerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCommunityEventPartnerDocument = gql`
    mutation DeleteCommunityEventPartner($where: CommunityEventPartnerWhereUniqueInput!) {
  deleteCommunityEventPartner(where: $where) {
    ...CommunityEventPartnerFields
  }
}
    ${CommunityEventPartnerFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCommunityEventPartnerGQL extends Apollo.Mutation<DeleteCommunityEventPartnerMutation, DeleteCommunityEventPartnerMutationVariables> {
    override document = DeleteCommunityEventPartnerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCommunityEventPartnerDocument = gql`
    mutation UpdateCommunityEventPartner($data: CommunityEventPartnerUpdateInput!, $where: CommunityEventPartnerWhereUniqueInput!) {
  updateOneCommunityEventPartner(data: $data, where: $where) {
    ...CommunityEventPartnerFields
  }
}
    ${CommunityEventPartnerFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCommunityEventPartnerGQL extends Apollo.Mutation<UpdateCommunityEventPartnerMutation, UpdateCommunityEventPartnerMutationVariables> {
    override document = UpdateCommunityEventPartnerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCommunityEventPriceTierDocument = gql`
    mutation CreateCommunityEventPriceTier($data: CreateCommunityEventPriceTierInput!) {
  createCommunityEventPriceTier(data: $data) {
    ...CommunityEventPriceTierFields
  }
}
    ${CommunityEventPriceTierFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCommunityEventPriceTierGQL extends Apollo.Mutation<CreateCommunityEventPriceTierMutation, CreateCommunityEventPriceTierMutationVariables> {
    override document = CreateCommunityEventPriceTierDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCommunityEventTicketPurchaseGrantDocument = gql`
    mutation CreateCommunityEventTicketPurchaseGrant($data: CreateCommunityEventTicketPurchaseGrantInput!) {
  createCommunityEventTicketPurchaseGrant(data: $data) {
    ...CommunityEventTicketPurchaseGrantFields
  }
}
    ${CommunityEventTicketPurchaseGrantFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCommunityEventTicketPurchaseGrantGQL extends Apollo.Mutation<CreateCommunityEventTicketPurchaseGrantMutation, CreateCommunityEventTicketPurchaseGrantMutationVariables> {
    override document = CreateCommunityEventTicketPurchaseGrantDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateComplimentaryCommunityEventTicketDocument = gql`
    mutation CreateComplimentaryCommunityEventTicket($data: CreateComplimentaryCommunityEventTicketInput!) {
  createComplimentaryCommunityEventTicket(data: $data) {
    ...CommunityEventTicketFields
  }
}
    ${CommunityEventTicketFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateComplimentaryCommunityEventTicketGQL extends Apollo.Mutation<CreateComplimentaryCommunityEventTicketMutation, CreateComplimentaryCommunityEventTicketMutationVariables> {
    override document = CreateComplimentaryCommunityEventTicketDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCommunityEventPriceTierDocument = gql`
    mutation DeleteCommunityEventPriceTier($data: DeleteCommunityEventPriceTierInput!) {
  deleteCommunityEventPriceTier(data: $data) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCommunityEventPriceTierGQL extends Apollo.Mutation<DeleteCommunityEventPriceTierMutation, DeleteCommunityEventPriceTierMutationVariables> {
    override document = DeleteCommunityEventPriceTierDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RefundCommunityEventTicketDocument = gql`
    mutation RefundCommunityEventTicket($data: RefundCommunityEventTicketInput!) {
  refundCommunityEventTicket(data: $data) {
    ...CommunityEventTicketFields
  }
}
    ${CommunityEventTicketFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RefundCommunityEventTicketGQL extends Apollo.Mutation<RefundCommunityEventTicketMutation, RefundCommunityEventTicketMutationVariables> {
    override document = RefundCommunityEventTicketDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevokeCommunityEventTicketPurchaseGrantDocument = gql`
    mutation RevokeCommunityEventTicketPurchaseGrant($data: RevokeCommunityEventTicketPurchaseGrantInput!) {
  revokeCommunityEventTicketPurchaseGrant(data: $data) {
    ...CommunityEventTicketPurchaseGrantFields
  }
}
    ${CommunityEventTicketPurchaseGrantFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RevokeCommunityEventTicketPurchaseGrantGQL extends Apollo.Mutation<RevokeCommunityEventTicketPurchaseGrantMutation, RevokeCommunityEventTicketPurchaseGrantMutationVariables> {
    override document = RevokeCommunityEventTicketPurchaseGrantDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ScanCommunityEventTicketDocument = gql`
    mutation ScanCommunityEventTicket($data: ScanCommunityEventTicketInput!) {
  scanCommunityEventTicket(data: $data) {
    status
    holderName
    priceTierName
    eventName
    startAt
    usedAt
    scannedByName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ScanCommunityEventTicketGQL extends Apollo.Mutation<ScanCommunityEventTicketMutation, ScanCommunityEventTicketMutationVariables> {
    override document = ScanCommunityEventTicketDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCommunityEventPriceTierDocument = gql`
    mutation UpdateCommunityEventPriceTier($data: UpdateCommunityEventPriceTierInput!) {
  updateCommunityEventPriceTier(data: $data) {
    ...CommunityEventPriceTierFields
  }
}
    ${CommunityEventPriceTierFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCommunityEventPriceTierGQL extends Apollo.Mutation<UpdateCommunityEventPriceTierMutation, UpdateCommunityEventPriceTierMutationVariables> {
    override document = UpdateCommunityEventPriceTierDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCommunityEventTicketSaleDocument = gql`
    mutation UpdateCommunityEventTicketSale($data: UpdateCommunityEventTicketSaleInput!) {
  updateCommunityEventTicketSale(data: $data) {
    id
    salesStartAt
    complimentaryQuota
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCommunityEventTicketSaleGQL extends Apollo.Mutation<UpdateCommunityEventTicketSaleMutation, UpdateCommunityEventTicketSaleMutationVariables> {
    override document = UpdateCommunityEventTicketSaleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCommunityEventDocument = gql`
    mutation CreateCommunityEvent($createArgs: CommunityEventCreateInput!) {
  createOneCommunityEvent(data: $createArgs) {
    id
    name
    communityEventInstances {
      id
      startAt
      endAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCommunityEventGQL extends Apollo.Mutation<CreateCommunityEventMutation, CreateCommunityEventMutationVariables> {
    override document = CreateCommunityEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCommunityEventDocument = gql`
    mutation DeleteCommunityEvent($where: CommunityEventWhereUniqueInput!) {
  deleteCommunityEvent(where: $where) {
    ...CommunityEventFields
  }
}
    ${CommunityEventFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCommunityEventGQL extends Apollo.Mutation<DeleteCommunityEventMutation, DeleteCommunityEventMutationVariables> {
    override document = DeleteCommunityEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCommunityEventDocument = gql`
    mutation UpdateCommunityEvent($data: CommunityEventUpdateInput!, $where: CommunityEventWhereUniqueInput!) {
  updateOneCommunityEvent(data: $data, where: $where) {
    ...CommunityEventFields
  }
}
    ${CommunityEventFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCommunityEventGQL extends Apollo.Mutation<UpdateCommunityEventMutation, UpdateCommunityEventMutationVariables> {
    override document = UpdateCommunityEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCommunityPostCommentDocument = gql`
    mutation DeleteCommunityPostComment($where: CommunityPostCommentWhereUniqueInput!) {
  deleteCommunityPostComment(where: $where) {
    ...CommunityPostCommentFields
  }
}
    ${CommunityPostCommentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCommunityPostCommentGQL extends Apollo.Mutation<DeleteCommunityPostCommentMutation, DeleteCommunityPostCommentMutationVariables> {
    override document = DeleteCommunityPostCommentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCommunityPostDocument = gql`
    mutation CreateCommunityPost($createArgs: CommunityPostCreateInput!) {
  createCommunityPost(data: $createArgs) {
    ...CommunityPostFields
  }
}
    ${CommunityPostFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCommunityPostGQL extends Apollo.Mutation<CreateCommunityPostMutation, CreateCommunityPostMutationVariables> {
    override document = CreateCommunityPostDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCommunityPostDocument = gql`
    mutation DeleteCommunityPost($where: CommunityPostWhereUniqueInput!) {
  deleteCommunityPost(where: $where) {
    ...CommunityPostFields
  }
}
    ${CommunityPostFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCommunityPostGQL extends Apollo.Mutation<DeleteCommunityPostMutation, DeleteCommunityPostMutationVariables> {
    override document = DeleteCommunityPostDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCommunityPostDocument = gql`
    mutation UpdateCommunityPost($data: CommunityPostUpdateInput!, $where: CommunityPostWhereUniqueInput!) {
  updateCommunityPost(data: $data, where: $where) {
    ...CommunityPostFields
  }
}
    ${CommunityPostFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCommunityPostGQL extends Apollo.Mutation<UpdateCommunityPostMutation, UpdateCommunityPostMutationVariables> {
    override document = UpdateCommunityPostDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCommunityClubDocument = gql`
    mutation CreateCommunityClub($createArgs: CommunityClubCreateInput!) {
  createOneCommunityClub(data: $createArgs) {
    ...CommunityClubFields
  }
}
    ${CommunityClubFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCommunityClubGQL extends Apollo.Mutation<CreateCommunityClubMutation, CreateCommunityClubMutationVariables> {
    override document = CreateCommunityClubDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCommunityClubDocument = gql`
    mutation DeleteCommunityClub($where: CommunityClubWhereUniqueInput!) {
  deleteCommunityClub(where: $where) {
    ...CommunityClubFields
  }
}
    ${CommunityClubFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCommunityClubGQL extends Apollo.Mutation<DeleteCommunityClubMutation, DeleteCommunityClubMutationVariables> {
    override document = DeleteCommunityClubDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCommunityClubDocument = gql`
    mutation UpdateCommunityClub($data: CommunityClubUpdateInput!, $where: CommunityClubWhereUniqueInput!) {
  updateCommunityClub(data: $data, where: $where) {
    ...CommunityClubFields
  }
}
    ${CommunityClubFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCommunityClubGQL extends Apollo.Mutation<UpdateCommunityClubMutation, UpdateCommunityClubMutationVariables> {
    override document = UpdateCommunityClubDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCompanyEmployeeDocument = gql`
    mutation DeleteCompanyEmployee($email: EmailAddress!) {
  deleteCompanyEmployee(email: $email) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCompanyEmployeeGQL extends Apollo.Mutation<DeleteCompanyEmployeeMutation, DeleteCompanyEmployeeMutationVariables> {
    override document = DeleteCompanyEmployeeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InviteCompanyEmployeeDocument = gql`
    mutation InviteCompanyEmployee($email: EmailAddress!, $gyms: GymCreateNestedManyWithoutEmployeesInput, $communityClubs: CommunityClubCreateNestedManyWithoutEmployeesInput) {
  inviteCompanyEmployee(
    email: $email
    gyms: $gyms
    communityClubs: $communityClubs
  ) {
    ...CompanyEmployeeFields
  }
}
    ${CompanyEmployeeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InviteCompanyEmployeeGQL extends Apollo.Mutation<InviteCompanyEmployeeMutation, InviteCompanyEmployeeMutationVariables> {
    override document = InviteCompanyEmployeeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendCompanyEmployeePasswordChangeEmailDocument = gql`
    mutation SendCompanyEmployeePasswordChangeEmail {
  sendCompanyEmployeePasswordChangeEmail {
    ...CompanyEmployeeFields
  }
}
    ${CompanyEmployeeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SendCompanyEmployeePasswordChangeEmailGQL extends Apollo.Mutation<SendCompanyEmployeePasswordChangeEmailMutation, SendCompanyEmployeePasswordChangeEmailMutationVariables> {
    override document = SendCompanyEmployeePasswordChangeEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCompanyEmployeeDocument = gql`
    mutation UpdateCompanyEmployee($data: CompanyEmployeeUpdateInput!, $where: CompanyEmployeeUniqueInput) {
  updateCompanyEmployee(data: $data, where: $where) {
    ...CompanyEmployeeFields
  }
}
    ${CompanyEmployeeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCompanyEmployeeGQL extends Apollo.Mutation<UpdateCompanyEmployeeMutation, UpdateCompanyEmployeeMutationVariables> {
    override document = UpdateCompanyEmployeeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCompanyDocument = gql`
    mutation UpdateCompany($updateInput: CompanyUpdateInput!) {
  updateCompany(updateInput: $updateInput) {
    ...CompanyInformationFields
  }
}
    ${CompanyInformationFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCompanyGQL extends Apollo.Mutation<UpdateCompanyMutation, UpdateCompanyMutationVariables> {
    override document = UpdateCompanyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateContractDocument = gql`
    mutation GenerateContract($customerId: String!, $gymId: String!, $tenant: String!, $data: GenerateContractInput!) {
  generateContract(
    gymId: $gymId
    customerId: $customerId
    tenant: $tenant
    data: $data
  ) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateContractGQL extends Apollo.Mutation<GenerateContractMutation, GenerateContractMutationVariables> {
    override document = GenerateContractDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteConversationDocument = gql`
    mutation DeleteConversation($conversationId: String!) {
  deleteConversation(conversationId: $conversationId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteConversationGQL extends Apollo.Mutation<DeleteConversationMutation, DeleteConversationMutationVariables> {
    override document = DeleteConversationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkConversationReadDocument = gql`
    mutation MarkConversationRead($conversationId: String!) {
  markConversationRead(conversationId: $conversationId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkConversationReadGQL extends Apollo.Mutation<MarkConversationReadMutation, MarkConversationReadMutationVariables> {
    override document = MarkConversationReadDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancelBookingCompanyDocument = gql`
    mutation CancelBookingCompany($where: EventBookingWhereUniqueInput!) {
  cancelBookingCompany(where: $where) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CancelBookingCompanyGQL extends Apollo.Mutation<CancelBookingCompanyMutation, CancelBookingCompanyMutationVariables> {
    override document = CancelBookingCompanyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancelEventDocument = gql`
    mutation CancelEvent($where: EventWhereUniqueInput!) {
  cancelEvent(where: $where) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CancelEventGQL extends Apollo.Mutation<CancelEventMutation, CancelEventMutationVariables> {
    override document = CancelEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateEventDocument = gql`
    mutation CreateEvent($data: EventCreateInput!) {
  createEvent(data: $data) {
    ...EventFields
  }
}
    ${EventFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateEventGQL extends Apollo.Mutation<CreateEventMutation, CreateEventMutationVariables> {
    override document = CreateEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateEventsDocument = gql`
    mutation CreateEvents($data: [EventCreateInput!]!) {
  createEvents(data: $data) {
    ...EventFields
  }
}
    ${EventFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateEventsGQL extends Apollo.Mutation<CreateEventsMutation, CreateEventsMutationVariables> {
    override document = CreateEventsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEventDocument = gql`
    mutation UpdateEvent($data: EventUpdateInput!, $where: EventWhereUniqueInput!) {
  updateEvent(data: $data, where: $where) {
    ...EventFields
  }
}
    ${EventFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEventGQL extends Apollo.Mutation<UpdateEventMutation, UpdateEventMutationVariables> {
    override document = UpdateEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateGymHighlightOrderCheckoutSessionDocument = gql`
    mutation CreateGymHighlightOrderCheckoutSession($data: CreateGymHighlightOrderCheckoutSessionInput!) {
  createGymHighlightOrderCheckoutSession(data: $data)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateGymHighlightOrderCheckoutSessionGQL extends Apollo.Mutation<CreateGymHighlightOrderCheckoutSessionMutation, CreateGymHighlightOrderCheckoutSessionMutationVariables> {
    override document = CreateGymHighlightOrderCheckoutSessionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateGymHighlightOrderDocument = gql`
    mutation CreateGymHighlightOrder($data: CreateGymHighlightOrderInput!) {
  createGymHighlightOrder(data: $data) {
    ...GymHighlightOrderFields
  }
}
    ${GymHighlightOrderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateGymHighlightOrderGQL extends Apollo.Mutation<CreateGymHighlightOrderMutation, CreateGymHighlightOrderMutationVariables> {
    override document = CreateGymHighlightOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteGymHighlightOrderDocument = gql`
    mutation DeleteGymHighlightOrder($where: GymHighlightOrderWhereUniqueInput!) {
  deleteGymHighlightOrder(where: $where) {
    id
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteGymHighlightOrderGQL extends Apollo.Mutation<DeleteGymHighlightOrderMutation, DeleteGymHighlightOrderMutationVariables> {
    override document = DeleteGymHighlightOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateGymImageDocument = gql`
    mutation CreateGymImage($data: GymImageCreateInput!) {
  createGymImage(data: $data) {
    ...GymImageFields
  }
}
    ${GymImageFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateGymImageGQL extends Apollo.Mutation<CreateGymImageMutation, CreateGymImageMutationVariables> {
    override document = CreateGymImageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteGymImageDocument = gql`
    mutation DeleteGymImage($where: GymImageWhereUniqueInput!) {
  deleteGymImage(where: $where) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteGymImageGQL extends Apollo.Mutation<DeleteGymImageMutation, DeleteGymImageMutationVariables> {
    override document = DeleteGymImageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PublicCreateManyGymRatingsDocument = gql`
    mutation PublicCreateManyGymRatings($data: [GymRatingCreateManyInput!]!, $gymId: String!, $customerId: String, $trainingSessionId: String, $skipDuplicates: Boolean) {
  createManyGymRatings(
    data: $data
    gymId: $gymId
    customerId: $customerId
    trainingSessionId: $trainingSessionId
    skipDuplicates: $skipDuplicates
  ) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PublicCreateManyGymRatingsGQL extends Apollo.Mutation<PublicCreateManyGymRatingsMutation, PublicCreateManyGymRatingsMutationVariables> {
    override document = PublicCreateManyGymRatingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateGymDocument = gql`
    mutation CreateGym($createArgs: GymCreateInput!, $eventWhere: EventWhereInput) {
  createOneGym(data: $createArgs) {
    ...GymFields
  }
}
    ${GymFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateGymGQL extends Apollo.Mutation<CreateGymMutation, CreateGymMutationVariables> {
    override document = CreateGymDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteGymDocument = gql`
    mutation DeleteGym($where: GymWhereUniqueInput!, $eventWhere: EventWhereInput) {
  deleteGym(where: $where) {
    ...GymFields
  }
}
    ${GymFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteGymGQL extends Apollo.Mutation<DeleteGymMutation, DeleteGymMutationVariables> {
    override document = DeleteGymDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OpenAccessDeviceManuallyDocument = gql`
    mutation OpenAccessDeviceManually($where: OpenAccessDeviceManuallyInput!) {
  openAccessDeviceManually(where: $where) {
    requestId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OpenAccessDeviceManuallyGQL extends Apollo.Mutation<OpenAccessDeviceManuallyMutation, OpenAccessDeviceManuallyMutationVariables> {
    override document = OpenAccessDeviceManuallyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateGymDocument = gql`
    mutation UpdateGym($data: GymUpdateInput!, $where: GymWhereUniqueInput!, $eventWhere: EventWhereInput) {
  updateGym(data: $data, where: $where) {
    ...GymFields
  }
}
    ${GymFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateGymGQL extends Apollo.Mutation<UpdateGymMutation, UpdateGymMutationVariables> {
    override document = UpdateGymDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteMessageDocument = gql`
    mutation DeleteMessage($messageId: String!) {
  deleteMessage(messageId: $messageId) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteMessageGQL extends Apollo.Mutation<DeleteMessageMutation, DeleteMessageMutationVariables> {
    override document = DeleteMessageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendMessageDocument = gql`
    mutation SendMessage($targetProfileId: String!, $content: String, $media: [MessageMediaInput!], $location: MessageLocationInput, $sharedCommunityEventId: String, $sharedCommunityEventInstanceId: String) {
  sendMessage(
    targetProfileId: $targetProfileId
    content: $content
    media: $media
    location: $location
    sharedCommunityEventId: $sharedCommunityEventId
    sharedCommunityEventInstanceId: $sharedCommunityEventInstanceId
  ) {
    ...MessageFields
  }
}
    ${MessageFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SendMessageGQL extends Apollo.Mutation<SendMessageMutation, SendMessageMutationVariables> {
    override document = SendMessageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOpeningHourDocument = gql`
    mutation CreateOpeningHour($createArgs: OpeningHourCreateInput!) {
  createOneOpeningHour(data: $createArgs) {
    ...OpeningHourFields
  }
}
    ${OpeningHourFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOpeningHourGQL extends Apollo.Mutation<CreateOpeningHourMutation, CreateOpeningHourMutationVariables> {
    override document = CreateOpeningHourDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteOpeningHourDocument = gql`
    mutation DeleteOpeningHour($where: OpeningHourWhereUniqueInput!) {
  deleteOpeningHour(where: $where) {
    ...OpeningHourFields
  }
}
    ${OpeningHourFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteOpeningHourGQL extends Apollo.Mutation<DeleteOpeningHourMutation, DeleteOpeningHourMutationVariables> {
    override document = DeleteOpeningHourDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOpeningHourDocument = gql`
    mutation UpdateOpeningHour($data: OpeningHourUpdateInput!, $where: OpeningHourWhereUniqueInput!) {
  updateOpeningHour(data: $data, where: $where) {
    ...OpeningHourFields
  }
}
    ${OpeningHourFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOpeningHourGQL extends Apollo.Mutation<UpdateOpeningHourMutation, UpdateOpeningHourMutationVariables> {
    override document = UpdateOpeningHourDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCompanyProfileDocument = gql`
    mutation CreateCompanyProfile($data: CompanyProfileCreateInput!) {
  createCompanyProfile(data: $data) {
    ...ProfileFields
  }
}
    ${ProfileFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCompanyProfileGQL extends Apollo.Mutation<CreateCompanyProfileMutation, CreateCompanyProfileMutationVariables> {
    override document = CreateCompanyProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateMyProfileDocument = gql`
    mutation CreateMyProfile($data: ProfileCreateInput!) {
  createMyProfile(data: $data) {
    ...ProfileFields
  }
}
    ${ProfileFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateMyProfileGQL extends Apollo.Mutation<CreateMyProfileMutation, CreateMyProfileMutationVariables> {
    override document = CreateMyProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCompanyProfileDocument = gql`
    mutation UpdateCompanyProfile($data: CompanyProfileUpdateInput!) {
  updateCompanyProfile(data: $data) {
    ...ProfileFields
  }
}
    ${ProfileFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCompanyProfileGQL extends Apollo.Mutation<UpdateCompanyProfileMutation, UpdateCompanyProfileMutationVariables> {
    override document = UpdateCompanyProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateMyProfileDocument = gql`
    mutation UpdateMyProfile($data: ProfileUpdateInput!) {
  updateMyProfile(data: $data) {
    ...ProfileFields
  }
}
    ${ProfileFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateMyProfileGQL extends Apollo.Mutation<UpdateMyProfileMutation, UpdateMyProfileMutationVariables> {
    override document = UpdateMyProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePromotionCodeDocument = gql`
    mutation CreatePromotionCode($data: PromotionCodeCreateInput!) {
  createPromotionCode(data: $data) {
    ...PromotionCodeFields
  }
}
    ${PromotionCodeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePromotionCodeGQL extends Apollo.Mutation<CreatePromotionCodeMutation, CreatePromotionCodeMutationVariables> {
    override document = CreatePromotionCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePromotionCodeDocument = gql`
    mutation DeletePromotionCode($promotionCode: String!) {
  softDeletePromotionCode(promotionCode: $promotionCode) {
    ...PromotionCodeFields
  }
}
    ${PromotionCodeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePromotionCodeGQL extends Apollo.Mutation<DeletePromotionCodeMutation, DeletePromotionCodeMutationVariables> {
    override document = DeletePromotionCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePromotionDocument = gql`
    mutation CreatePromotion($data: PromotionCreateInput!) {
  createPromotion(data: $data) {
    ...PromotionFields
  }
}
    ${PromotionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePromotionGQL extends Apollo.Mutation<CreatePromotionMutation, CreatePromotionMutationVariables> {
    override document = CreatePromotionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePromotionDocument = gql`
    mutation DeletePromotion($where: PromotionWhereUniqueInput!) {
  deletePromotion(where: $where) {
    ...PromotionFields
  }
}
    ${PromotionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePromotionGQL extends Apollo.Mutation<DeletePromotionMutation, DeletePromotionMutationVariables> {
    override document = DeletePromotionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePromotionDocument = gql`
    mutation UpdatePromotion($where: PromotionWhereUniqueInput!, $data: PromotionUpdateInput!) {
  updatePromotion(where: $where, data: $data) {
    ...PromotionFields
  }
}
    ${PromotionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePromotionGQL extends Apollo.Mutation<UpdatePromotionMutation, UpdatePromotionMutationVariables> {
    override document = UpdatePromotionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePushNotificationCommunityDocument = gql`
    mutation CreatePushNotificationCommunity($createInput: PushNotificationCreateCommunityClubInput!) {
  createPushNotificationCommunityClub(data: $createInput) {
    ...PushNotificationFields
  }
}
    ${PushNotificationFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePushNotificationCommunityGQL extends Apollo.Mutation<CreatePushNotificationCommunityMutation, CreatePushNotificationCommunityMutationVariables> {
    override document = CreatePushNotificationCommunityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePushNotificationDocument = gql`
    mutation CreatePushNotification($createInput: PushNotificationCreateInput!) {
  createPushNotification(data: $createInput) {
    ...PushNotificationFields
  }
}
    ${PushNotificationFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePushNotificationGQL extends Apollo.Mutation<CreatePushNotificationMutation, CreatePushNotificationMutationVariables> {
    override document = CreatePushNotificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePushNotificationDocument = gql`
    mutation DeletePushNotification($where: PushNotificationWhereUniqueInput!) {
  deletePushNotification(where: $where) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePushNotificationGQL extends Apollo.Mutation<DeletePushNotificationMutation, DeletePushNotificationMutationVariables> {
    override document = DeletePushNotificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisablePushNotificationDocument = gql`
    mutation DisablePushNotification($pushNotificationId: String!) {
  disablePushNotification(pushNotificationId: $pushNotificationId) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisablePushNotificationGQL extends Apollo.Mutation<DisablePushNotificationMutation, DisablePushNotificationMutationVariables> {
    override document = DisablePushNotificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateRatingQuestionDocument = gql`
    mutation CreateRatingQuestion($data: RatingQuestionCreateInput!, $gymId: UUID = null) {
  createRatingQuestion(data: $data) {
    ...RatingQuestionFields
  }
}
    ${RatingQuestionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateRatingQuestionGQL extends Apollo.Mutation<CreateRatingQuestionMutation, CreateRatingQuestionMutationVariables> {
    override document = CreateRatingQuestionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteRatingQuestionDocument = gql`
    mutation DeleteRatingQuestion($where: RatingQuestionWhereUniqueInput!, $gymId: UUID = null) {
  deleteRatingQuestion(where: $where) {
    ...RatingQuestionFields
  }
}
    ${RatingQuestionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteRatingQuestionGQL extends Apollo.Mutation<DeleteRatingQuestionMutation, DeleteRatingQuestionMutationVariables> {
    override document = DeleteRatingQuestionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateRatingQuestionActiveStatusDocument = gql`
    mutation UpdateRatingQuestionActiveStatus($where: RatingQuestionWhereUniqueInput!, $data: RatingQuestionActiveStatusUpdateInput!, $gymId: UUID = null) {
  updateRatingQuestionActiveStatus(where: $where, data: $data) {
    ...RatingQuestionFields
  }
}
    ${RatingQuestionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateRatingQuestionActiveStatusGQL extends Apollo.Mutation<UpdateRatingQuestionActiveStatusMutation, UpdateRatingQuestionActiveStatusMutationVariables> {
    override document = UpdateRatingQuestionActiveStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DismissReportDocument = gql`
    mutation DismissReport($reportId: String!) {
  dismissReport(reportId: $reportId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DismissReportGQL extends Apollo.Mutation<DismissReportMutation, DismissReportMutationVariables> {
    override document = DismissReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FinishTrainingSessionDocument = gql`
    mutation FinishTrainingSession($where: TrainingSessionWhereUniqueInput!, $data: FinishTrainingSessionInput!) {
  finishTrainingSession(where: $where, data: $data) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FinishTrainingSessionGQL extends Apollo.Mutation<FinishTrainingSessionMutation, FinishTrainingSessionMutationVariables> {
    override document = FinishTrainingSessionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUserPostDocument = gql`
    mutation CreateUserPost($data: UserPostCreateInput!) {
  createUserPost(data: $data) {
    ...UserPostFields
  }
}
    ${UserPostFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserPostGQL extends Apollo.Mutation<CreateUserPostMutation, CreateUserPostMutationVariables> {
    override document = CreateUserPostDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteUserPostDocument = gql`
    mutation DeleteUserPost($where: UserPostWhereUniqueInput!) {
  deleteUserPost(where: $where) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteUserPostGQL extends Apollo.Mutation<DeleteUserPostMutation, DeleteUserPostMutationVariables> {
    override document = DeleteUserPostDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserPostDocument = gql`
    mutation UpdateUserPost($data: UserPostUpdateInput!, $where: UserPostWhereUniqueInput!) {
  updateUserPost(data: $data, where: $where) {
    ...UserPostFields
  }
}
    ${UserPostFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserPostGQL extends Apollo.Mutation<UpdateUserPostMutation, UpdateUserPostMutationVariables> {
    override document = UpdateUserPostDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MyCirclesDocument = gql`
    query MyCircles {
  myProfile {
    id
    circles {
      ...CircleFields
    }
  }
}
    ${CircleFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MyCirclesGQL extends Apollo.Query<MyCirclesQuery, MyCirclesQueryVariables> {
    override document = MyCirclesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MyCompanyCirclesDocument = gql`
    query MyCompanyCircles {
  companyProfile {
    id
    circles {
      ...CircleFields
    }
  }
}
    ${CircleFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MyCompanyCirclesGQL extends Apollo.Query<MyCompanyCirclesQuery, MyCompanyCirclesQueryVariables> {
    override document = MyCompanyCirclesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommunityClubOnboardingEmailExistsDocument = gql`
    query CommunityClubOnboardingEmailExists($accountEmail: String!) {
  communityClubOnboardingEmailExists(accountEmail: $accountEmail)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CommunityClubOnboardingEmailExistsGQL extends Apollo.Query<CommunityClubOnboardingEmailExistsQuery, CommunityClubOnboardingEmailExistsQueryVariables> {
    override document = CommunityClubOnboardingEmailExistsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommunityClubExistenceDocument = gql`
    query CommunityClubExistence($where: CommunityClubWhereInput) {
  communityClubs(where: $where, take: 1) {
    id
    s3LogoUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CommunityClubExistenceGQL extends Apollo.Query<CommunityClubExistenceQuery, CommunityClubExistenceQueryVariables> {
    override document = CommunityClubExistenceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommunityClubHostsDocument = gql`
    query CommunityClubHosts {
  communityClubs(where: {deletedAt: null}) {
    id
    communityHost {
      ...ProfileFields
    }
  }
}
    ${ProfileFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CommunityClubHostsGQL extends Apollo.Query<CommunityClubHostsQuery, CommunityClubHostsQueryVariables> {
    override document = CommunityClubHostsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommunityClubsForPickerDocument = gql`
    query CommunityClubsForPicker($where: CommunityClubWhereInput, $orderBy: [CommunityClubOrderByWithRelationInput!], $cursor: CommunityClubWhereUniqueInput, $take: Int, $skip: Int, $distinct: [CommunityClubScalarFieldEnum!]) {
  communityClubs(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...CommunityClubPickerFields
  }
}
    ${CommunityClubPickerFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CommunityClubsForPickerGQL extends Apollo.Query<CommunityClubsForPickerQuery, CommunityClubsForPickerQueryVariables> {
    override document = CommunityClubsForPickerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommunityClubTicketFeesDocument = gql`
    query CommunityClubTicketFees($where: CommunityClubWhereUniqueInput!) {
  communityClub(where: $where) {
    id
    ticketFees {
      commissionPercent
      flatFeeInCents
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CommunityClubTicketFeesGQL extends Apollo.Query<CommunityClubTicketFeesQuery, CommunityClubTicketFeesQueryVariables> {
    override document = CommunityClubTicketFeesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommunityClubsDocument = gql`
    query CommunityClubs($where: CommunityClubWhereInput, $orderBy: [CommunityClubOrderByWithRelationInput!], $cursor: CommunityClubWhereUniqueInput, $take: Int, $skip: Int, $distinct: [CommunityClubScalarFieldEnum!]) {
  communityClubs(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...CommunityClubFields
  }
}
    ${CommunityClubFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CommunityClubsGQL extends Apollo.Query<CommunityClubsQuery, CommunityClubsQueryVariables> {
    override document = CommunityClubsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommunityEventBookingInfoDocument = gql`
    query CommunityEventBookingInfo($where: CommunityEventBookingWhereInput, $orderBy: [CommunityEventBookingOrderByWithRelationInput!], $cursor: CommunityEventBookingWhereUniqueInput, $take: Int, $skip: Int, $distinct: [CommunityEventBookingScalarFieldEnum!]) {
  communityEventBookings(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...CommunityEventBookingInfo
  }
}
    ${CommunityEventBookingInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CommunityEventBookingInfoGQL extends Apollo.Query<CommunityEventBookingInfoQuery, CommunityEventBookingInfoQueryVariables> {
    override document = CommunityEventBookingInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommunityEventBookingParticipantsDocument = gql`
    query CommunityEventBookingParticipants($where: CommunityEventBookingWhereInput, $orderBy: [CommunityEventBookingOrderByWithRelationInput!], $cursor: CommunityEventBookingWhereUniqueInput, $take: Int, $skip: Int, $distinct: [CommunityEventBookingScalarFieldEnum!]) {
  communityEventBookings(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...CommunityEventBookingParticipantFields
  }
}
    ${CommunityEventBookingParticipantFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CommunityEventBookingParticipantsGQL extends Apollo.Query<CommunityEventBookingParticipantsQuery, CommunityEventBookingParticipantsQueryVariables> {
    override document = CommunityEventBookingParticipantsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommunityEventBookingsDocument = gql`
    query CommunityEventBookings($where: CommunityEventBookingWhereInput, $orderBy: [CommunityEventBookingOrderByWithRelationInput!], $cursor: CommunityEventBookingWhereUniqueInput, $take: Int, $skip: Int, $distinct: [CommunityEventBookingScalarFieldEnum!]) {
  communityEventBookings(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...CommunityEventBookingFields
  }
}
    ${CommunityEventBookingFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CommunityEventBookingsGQL extends Apollo.Query<CommunityEventBookingsQuery, CommunityEventBookingsQueryVariables> {
    override document = CommunityEventBookingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommunityEventCategoriesDocument = gql`
    query CommunityEventCategories($where: CommunityEventCategoryWhereInput, $orderBy: [CommunityEventCategoryOrderByWithRelationInput!], $cursor: CommunityEventCategoryWhereUniqueInput, $take: Int, $skip: Int, $distinct: [CommunityEventCategoryScalarFieldEnum!]) {
  communityEventCategories(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...CommunityEventCategoryFields
  }
}
    ${CommunityEventCategoryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CommunityEventCategoriesGQL extends Apollo.Query<CommunityEventCategoriesQuery, CommunityEventCategoriesQueryVariables> {
    override document = CommunityEventCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommunityEventImagesDocument = gql`
    query CommunityEventImages($where: CommunityEventImageWhereInput, $orderBy: [CommunityEventImageOrderByWithRelationInput!], $cursor: CommunityEventImageWhereUniqueInput, $take: Int, $skip: Int, $distinct: [CommunityEventImageScalarFieldEnum!]) {
  communityEventImages(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...CommunityEventImageFields
  }
}
    ${CommunityEventImageFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CommunityEventImagesGQL extends Apollo.Query<CommunityEventImagesQuery, CommunityEventImagesQueryVariables> {
    override document = CommunityEventImagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommunityEventInstancesDocument = gql`
    query CommunityEventInstances($where: CommunityEventInstanceWhereInput, $orderBy: [CommunityEventInstanceOrderByWithRelationInput!], $cursor: CommunityEventInstanceWhereUniqueInput, $take: Int, $skip: Int, $distinct: [CommunityEventInstanceScalarFieldEnum!]) {
  communityEventInstances(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...CommunityEventInstanceFields
  }
}
    ${CommunityEventInstanceFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CommunityEventInstancesGQL extends Apollo.Query<CommunityEventInstancesQuery, CommunityEventInstancesQueryVariables> {
    override document = CommunityEventInstancesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommunityEventInstancesAttendanceDocument = gql`
    query CommunityEventInstancesAttendance($where: CommunityEventInstanceWhereInput, $orderBy: [CommunityEventInstanceOrderByWithRelationInput!], $cursor: CommunityEventInstanceWhereUniqueInput, $take: Int, $skip: Int, $distinct: [CommunityEventInstanceScalarFieldEnum!]) {
  communityEventInstances(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...CommunityEventInstanceAttendanceFields
  }
}
    ${CommunityEventInstanceAttendanceFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CommunityEventInstancesAttendanceGQL extends Apollo.Query<CommunityEventInstancesAttendanceQuery, CommunityEventInstancesAttendanceQueryVariables> {
    override document = CommunityEventInstancesAttendanceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommunityEventLocationsDocument = gql`
    query CommunityEventLocations($where: CommunityEventLocationWhereInput, $orderBy: [CommunityEventLocationOrderByWithRelationInput!], $cursor: CommunityEventLocationWhereUniqueInput, $take: Int, $skip: Int, $distinct: [CommunityEventLocationScalarFieldEnum!]) {
  communityEventLocations(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...CommunityEventLocationFields
  }
}
    ${CommunityEventLocationFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CommunityEventLocationsGQL extends Apollo.Query<CommunityEventLocationsQuery, CommunityEventLocationsQueryVariables> {
    override document = CommunityEventLocationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommunityEventPartnersDocument = gql`
    query CommunityEventPartners($where: CommunityEventPartnerWhereInput, $orderBy: [CommunityEventPartnerOrderByWithRelationInput!], $cursor: CommunityEventPartnerWhereUniqueInput, $take: Int, $skip: Int, $distinct: [CommunityEventPartnerScalarFieldEnum!]) {
  communityEventPartners(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...CommunityEventPartnerFields
  }
}
    ${CommunityEventPartnerFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CommunityEventPartnersGQL extends Apollo.Query<CommunityEventPartnersQuery, CommunityEventPartnersQueryVariables> {
    override document = CommunityEventPartnersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommunityEventInstancePurchaseGrantsDocument = gql`
    query CommunityEventInstancePurchaseGrants($where: CommunityEventInstanceWhereInput, $take: Int) {
  communityEventInstances(where: $where, take: $take) {
    id
    ticketSale {
      id
      purchaseGrants {
        ...CommunityEventTicketPurchaseGrantFields
      }
    }
  }
}
    ${CommunityEventTicketPurchaseGrantFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CommunityEventInstancePurchaseGrantsGQL extends Apollo.Query<CommunityEventInstancePurchaseGrantsQuery, CommunityEventInstancePurchaseGrantsQueryVariables> {
    override document = CommunityEventInstancePurchaseGrantsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommunityEventInstanceTicketSaleDocument = gql`
    query CommunityEventInstanceTicketSale($where: CommunityEventInstanceWhereInput, $take: Int) {
  communityEventInstances(where: $where, take: $take) {
    id
    startAt
    endAt
    communityEvent {
      id
      isDraft
    }
    ticketSale {
      ...CommunityEventTicketSaleFields
    }
  }
}
    ${CommunityEventTicketSaleFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CommunityEventInstanceTicketSaleGQL extends Apollo.Query<CommunityEventInstanceTicketSaleQuery, CommunityEventInstanceTicketSaleQueryVariables> {
    override document = CommunityEventInstanceTicketSaleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommunityEventInstanceTicketsDocument = gql`
    query CommunityEventInstanceTickets($where: CommunityEventInstanceWhereInput, $take: Int) {
  communityEventInstances(where: $where, take: $take) {
    id
    endAt
    ticketSale {
      id
      canceledAt
      tickets {
        ...CommunityEventTicketFields
      }
    }
  }
}
    ${CommunityEventTicketFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CommunityEventInstanceTicketsGQL extends Apollo.Query<CommunityEventInstanceTicketsQuery, CommunityEventInstanceTicketsQueryVariables> {
    override document = CommunityEventInstanceTicketsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommunityEventsDocument = gql`
    query CommunityEvents($where: CommunityEventWhereInput, $orderBy: [CommunityEventOrderByWithRelationInput!], $cursor: CommunityEventWhereUniqueInput, $take: Int, $skip: Int, $distinct: [CommunityEventScalarFieldEnum!]) {
  communityEvents(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...CommunityEventFields
  }
}
    ${CommunityEventFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CommunityEventsGQL extends Apollo.Query<CommunityEventsQuery, CommunityEventsQueryVariables> {
    override document = CommunityEventsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommunityPostCommentsDocument = gql`
    query CommunityPostComments($where: CommunityPostCommentWhereInput, $orderBy: [CommunityPostCommentOrderByWithRelationInput!], $cursor: CommunityPostCommentWhereUniqueInput, $take: Int, $skip: Int, $distinct: [CommunityPostCommentScalarFieldEnum!]) {
  communityPostComments(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...CommunityPostCommentFields
  }
}
    ${CommunityPostCommentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CommunityPostCommentsGQL extends Apollo.Query<CommunityPostCommentsQuery, CommunityPostCommentsQueryVariables> {
    override document = CommunityPostCommentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommunityPostsDocument = gql`
    query CommunityPosts($where: CommunityPostWhereInput, $orderBy: [CommunityPostOrderByWithRelationInput!], $cursor: CommunityPostWhereUniqueInput, $take: Int, $skip: Int, $distinct: [CommunityPostScalarFieldEnum!]) {
  communityPosts(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...CommunityPostFields
  }
}
    ${CommunityPostFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CommunityPostsGQL extends Apollo.Query<CommunityPostsQuery, CommunityPostsQueryVariables> {
    override document = CommunityPostsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompanyInformationDocument = gql`
    query CompanyInformation {
  company {
    ...CompanyInformationFields
  }
}
    ${CompanyInformationFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyInformationGQL extends Apollo.Query<CompanyInformationQuery, CompanyInformationQueryVariables> {
    override document = CompanyInformationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompanyNameDocument = gql`
    query CompanyName {
  companyName
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyNameGQL extends Apollo.Query<CompanyNameQuery, CompanyNameQueryVariables> {
    override document = CompanyNameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PublicContractDetailsDocument = gql`
    query PublicContractDetails($gymId: String!, $contractId: String!) {
  publicContractDetails(gymId: $gymId, contractId: $contractId) {
    companyName
    gymName
    tenant
    crmStudioId
    imprint
    privacyPolicy
    generalTerms
    logoUrl
    primaryColor
    secondaryColor
    normalPrice
    savings
    totalOverTerm
    contract {
      name
      description
      terms {
        id
        term {
          termUnit
        }
        paymentFrequencyDto {
          money {
            amount
            currencyCode
          }
          term {
            termUnit
          }
        }
      }
      modules {
        name
      }
      contractTextBlocks {
        title
        text
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PublicContractDetailsGQL extends Apollo.Query<PublicContractDetailsQuery, PublicContractDetailsQueryVariables> {
    override document = PublicContractDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginatedConversationDocument = gql`
    query PaginatedConversation($where: ConversationWhereInput, $orderBy: [ConversationOrderByWithRelationInput!], $cursor: ConversationWhereUniqueInput, $take: Int, $skip: Int, $distinct: [ConversationScalarFieldEnum!]) {
  paginatedConversation(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...PaginatedConversationFields
  }
}
    ${PaginatedConversationFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginatedConversationGQL extends Apollo.Query<PaginatedConversationQuery, PaginatedConversationQueryVariables> {
    override document = PaginatedConversationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CustomerAgeDistributionDocument = gql`
    query CustomerAgeDistribution($whereYoungerThan30: CustomerWhereInput!, $whereBetween30And50: CustomerWhereInput!, $whereOlderThan50: CustomerWhereInput!) {
  youngerThan30: countCustomer(where: $whereYoungerThan30)
  between30And50: countCustomer(where: $whereBetween30And50)
  olderThan50: countCustomer(where: $whereOlderThan50)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CustomerAgeDistributionGQL extends Apollo.Query<CustomerAgeDistributionQuery, CustomerAgeDistributionQueryVariables> {
    override document = CustomerAgeDistributionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CustomerBillingTrendDocument = gql`
    query CustomerBillingTrend($startDate: DateTime!, $endDate: DateTime!, $timezone: TimeZone!, $gymId: UUID) {
  customerBillingTrend(
    startDate: $startDate
    endDate: $endDate
    timezone: $timezone
    gymId: $gymId
  ) {
    ...TrendMetricFields
  }
}
    ${TrendMetricFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CustomerBillingTrendGQL extends Apollo.Query<CustomerBillingTrendQuery, CustomerBillingTrendQueryVariables> {
    override document = CustomerBillingTrendDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CustomerNewVsReturningDocument = gql`
    query CustomerNewVsReturning($whereNew: CustomerWhereInput!, $whereReturning: CustomerWhereInput!) {
  newCustomers: countCustomer(where: $whereNew)
  returningCustomers: countCustomer(where: $whereReturning)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CustomerNewVsReturningGQL extends Apollo.Query<CustomerNewVsReturningQuery, CustomerNewVsReturningQueryVariables> {
    override document = CustomerNewVsReturningDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CustomerPromotionCodesDocument = gql`
    query CustomerPromotionCodes($where: CustomerPromotionCodeWhereInput, $orderBy: [CustomerPromotionCodeOrderByWithRelationInput!], $cursor: CustomerPromotionCodeWhereUniqueInput, $take: Int, $skip: Int, $distinct: [CustomerPromotionCodeScalarFieldEnum!]) {
  customerPromotionCodes(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...CustomerPromotionCodeFields
  }
}
    ${CustomerPromotionCodeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CustomerPromotionCodesGQL extends Apollo.Query<CustomerPromotionCodesQuery, CustomerPromotionCodesQueryVariables> {
    override document = CustomerPromotionCodesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CustomerTopRankingDocument = gql`
    query CustomerTopRanking($startDate: DateTime, $endDate: DateTime, $gymId: UUID) {
  customerTopRanking(startDate: $startDate, endDate: $endDate, gymId: $gymId) {
    ...CustomerTopRankingFields
  }
}
    ${CustomerTopRankingFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CustomerTopRankingGQL extends Apollo.Query<CustomerTopRankingQuery, CustomerTopRankingQueryVariables> {
    override document = CustomerTopRankingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CustomerTrendDocument = gql`
    query CustomerTrend($startDate: DateTime!, $endDate: DateTime!, $timezone: TimeZone!, $gymId: UUID) {
  customerTrend(
    startDate: $startDate
    endDate: $endDate
    timezone: $timezone
    gymId: $gymId
  ) {
    ...TrendMetricFields
  }
}
    ${TrendMetricFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CustomerTrendGQL extends Apollo.Query<CustomerTrendQuery, CustomerTrendQueryVariables> {
    override document = CustomerTrendDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CustomersDocument = gql`
    query Customers($where: CustomerWhereInput, $orderBy: [CustomerOrderByWithRelationInput!], $cursor: CustomerWhereUniqueInput, $take: Int, $skip: Int, $distinct: [CustomerScalarFieldEnum!]) {
  customers(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...CustomerFields
  }
}
    ${CustomerFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CustomersGQL extends Apollo.Query<CustomersQuery, CustomersQueryVariables> {
    override document = CustomersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginatedCustomersDocument = gql`
    query PaginatedCustomers($where: CustomerWhereInput, $orderBy: [CustomerOrderByWithRelationInput!], $cursor: CustomerWhereUniqueInput, $take: Int, $skip: Int, $distinct: [CustomerScalarFieldEnum!]) {
  paginatedCustomers(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...PaginatedCustomerFields
  }
}
    ${PaginatedCustomerFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginatedCustomersGQL extends Apollo.Query<PaginatedCustomersQuery, PaginatedCustomersQueryVariables> {
    override document = PaginatedCustomersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DashboardOverviewDocument = gql`
    query DashboardOverview($startDate: DateTime!, $endDate: DateTime!, $timezone: TimeZone!, $countCustomerWhere: CustomerWhereInput, $customerBillingsWhere: CustomerBillingWhereInput, $customerBillingsWhereOpen: CustomerBillingWhereInput, $countTrainingSessionsWhere: TrainingSessionWhereInput, $gymId: UUID) {
  countCustomer(where: $countCustomerWhere)
  totalSales: aggregateCustomerBilling(
    where: $customerBillingsWhere
    _sum: {paidPrice: true}
    _avg: {paidPrice: true}
  ) {
    _sum {
      paidPrice
    }
    _avg {
      paidPrice
    }
  }
  openSales: aggregateCustomerBilling(
    where: $customerBillingsWhereOpen
    _sum: {paidPrice: true}
  ) {
    _sum {
      paidPrice
    }
  }
  countTrainingSessions(where: $countTrainingSessionsWhere)
  averageTrainingSessionTime(
    startDate: $startDate
    endDate: $endDate
    timezone: $timezone
    gymId: $gymId
  )
  customerBillingPerDay(
    startDate: $startDate
    endDate: $endDate
    timezone: $timezone
    gymId: $gymId
  ) {
    date
    count
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DashboardOverviewGQL extends Apollo.Query<DashboardOverviewQuery, DashboardOverviewQueryVariables> {
    override document = DashboardOverviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DashboardDocument = gql`
    query Dashboard($whereCustomers: CustomerWhereInput, $whereCustomerBillings: CustomerBillingWhereInput, $whereTrainingSessions: TrainingSessionWhereInput) {
  customers(where: $whereCustomers) {
    ...DashboardCustomers
  }
  customerBillings(where: $whereCustomerBillings) {
    ...DashboardCustomerBillings
  }
  trainingSessions(where: $whereTrainingSessions) {
    ...DashboardTrainingSessions
  }
  checkInUtilization {
    name
    data
  }
}
    ${DashboardCustomersFragmentDoc}
${DashboardCustomerBillingsFragmentDoc}
${DashboardTrainingSessionsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DashboardGQL extends Apollo.Query<DashboardQuery, DashboardQueryVariables> {
    override document = DashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DashboardGymsDocument = gql`
    query DashboardGyms {
  gyms {
    ...DashboardGymTrainingSessions
  }
}
    ${DashboardGymTrainingSessionsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DashboardGymsGQL extends Apollo.Query<DashboardGymsQuery, DashboardGymsQueryVariables> {
    override document = DashboardGymsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompanyEmployeesDocument = gql`
    query CompanyEmployees {
  companyEmployees {
    ...CompanyEmployeeFields
  }
}
    ${CompanyEmployeeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyEmployeesGQL extends Apollo.Query<CompanyEmployeesQuery, CompanyEmployeesQueryVariables> {
    override document = CompanyEmployeesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EventBookingsDocument = gql`
    query EventBookings($where: EventBookingWhereInput, $orderBy: [EventBookingOrderByWithRelationInput!], $cursor: EventBookingWhereUniqueInput, $take: Int, $skip: Int, $distinct: [EventBookingScalarFieldEnum!]) {
  eventBookings(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...EventBookingFields
  }
}
    ${EventBookingFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EventBookingsGQL extends Apollo.Query<EventBookingsQuery, EventBookingsQueryVariables> {
    override document = EventBookingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginatedEventBookingsDocument = gql`
    query PaginatedEventBookings($where: EventBookingWhereInput, $orderBy: [EventBookingOrderByWithRelationInput!], $cursor: EventBookingWhereUniqueInput, $take: Int, $skip: Int, $distinct: [EventBookingScalarFieldEnum!]) {
  paginatedEventBookings(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...PaginatedEventBookingsFields
  }
}
    ${PaginatedEventBookingsFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginatedEventBookingsGQL extends Apollo.Query<PaginatedEventBookingsQuery, PaginatedEventBookingsQueryVariables> {
    override document = PaginatedEventBookingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EventsDocument = gql`
    query Events($where: EventWhereInput, $orderBy: [EventOrderByWithRelationInput!], $cursor: EventWhereUniqueInput, $take: Int, $skip: Int, $distinct: [EventScalarFieldEnum!], $bookingFilter: EventBookingWhereInput) {
  events(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...EventFields
    bookings(where: $bookingFilter) {
      ...EventBookingFields
    }
  }
}
    ${EventFieldsFragmentDoc}
${EventBookingFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EventsGQL extends Apollo.Query<EventsQuery, EventsQueryVariables> {
    override document = EventsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GymAdvantagesDocument = gql`
    query GymAdvantages {
  gymAdvantages {
    ...GymAdvantageFields
  }
}
    ${GymAdvantageFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GymAdvantagesGQL extends Apollo.Query<GymAdvantagesQuery, GymAdvantagesQueryVariables> {
    override document = GymAdvantagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GymCategoriesDocument = gql`
    query GymCategories($where: GymCategoryWhereInput, $orderBy: [GymCategoryOrderByWithRelationInput!], $cursor: GymCategoryWhereUniqueInput, $take: Int, $skip: Int, $distinct: [GymCategoryScalarFieldEnum!]) {
  gymCategories(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...GymCategoryFields
  }
}
    ${GymCategoryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GymCategoriesGQL extends Apollo.Query<GymCategoriesQuery, GymCategoriesQueryVariables> {
    override document = GymCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GymHighlightOrdersDocument = gql`
    query GymHighlightOrders($where: GymHighlightOrderWhereInput, $orderBy: [GymHighlightOrderOrderByWithRelationInput!]) {
  gymHighlightOrders(where: $where, orderBy: $orderBy) {
    ...GymHighlightOrderFields
  }
}
    ${GymHighlightOrderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GymHighlightOrdersGQL extends Apollo.Query<GymHighlightOrdersQuery, GymHighlightOrdersQueryVariables> {
    override document = GymHighlightOrdersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GymHighlightPriceConfigsDocument = gql`
    query GymHighlightPriceConfigs($where: GymHighlightPriceConfigWhereInput) {
  gymHighlightPriceConfigs(where: $where) {
    ...GymHighlightPriceConfigFields
  }
}
    ${GymHighlightPriceConfigFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GymHighlightPriceConfigsGQL extends Apollo.Query<GymHighlightPriceConfigsQuery, GymHighlightPriceConfigsQueryVariables> {
    override document = GymHighlightPriceConfigsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GymsForStudioHighlightDocument = gql`
    query GymsForStudioHighlight($where: GymWhereInput, $orderBy: [GymOrderByWithRelationInput!]) {
  gyms(where: $where, orderBy: $orderBy) {
    ...GymForHighlightFields
  }
}
    ${GymForHighlightFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GymsForStudioHighlightGQL extends Apollo.Query<GymsForStudioHighlightQuery, GymsForStudioHighlightQueryVariables> {
    override document = GymsForStudioHighlightDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GymRatingsDocument = gql`
    query GymRatings($where: GymRatingWhereInput, $oderBy: [GymRatingOrderByWithRelationInput!], $cursor: GymRatingWhereUniqueInput, $take: Int, $skip: Int, $distinct: [GymRatingScalarFieldEnum!]) {
  gymRatings(
    where: $where
    orderBy: $oderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...GymRatingFields
  }
}
    ${GymRatingFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GymRatingsGQL extends Apollo.Query<GymRatingsQuery, GymRatingsQueryVariables> {
    override document = GymRatingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginatedGymRatingsDocument = gql`
    query PaginatedGymRatings($where: GymRatingWhereInput, $orderBy: [GymRatingOrderByWithRelationInput!], $cursor: GymRatingWhereUniqueInput, $take: Int, $skip: Int, $distinct: [GymRatingScalarFieldEnum!]) {
  paginatedGymRating(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...PaginatedGymRatingFields
  }
}
    ${PaginatedGymRatingFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginatedGymRatingsGQL extends Apollo.Query<PaginatedGymRatingsQuery, PaginatedGymRatingsQueryVariables> {
    override document = PaginatedGymRatingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GymAccessDevicesDocument = gql`
    query GymAccessDevices($input: GymAccessDevicesInput!) {
  gymAccessDevices(where: $input) {
    ...GymAccessDeviceFields
  }
}
    ${GymAccessDeviceFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GymAccessDevicesGQL extends Apollo.Query<GymAccessDevicesQuery, GymAccessDevicesQueryVariables> {
    override document = GymAccessDevicesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GymExistenceDocument = gql`
    query GymExistence($where: GymWhereInput) {
  gyms(where: $where, take: 1) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GymExistenceGQL extends Apollo.Query<GymExistenceQuery, GymExistenceQueryVariables> {
    override document = GymExistenceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GymsForPickerDocument = gql`
    query GymsForPicker($where: GymWhereInput, $orderBy: [GymOrderByWithRelationInput!], $cursor: GymWhereUniqueInput, $take: Int, $skip: Int, $distinct: [GymScalarFieldEnum!]) {
  gyms(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...GymPickerFields
  }
}
    ${GymPickerFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GymsForPickerGQL extends Apollo.Query<GymsForPickerQuery, GymsForPickerQueryVariables> {
    override document = GymsForPickerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GymTopRatingDocument = gql`
    query GymTopRating($startDate: DateTime, $endDate: DateTime) {
  gymTopRating(startDate: $startDate, endDate: $endDate) {
    ...GymTopRatingFields
  }
}
    ${GymTopRatingFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GymTopRatingGQL extends Apollo.Query<GymTopRatingQuery, GymTopRatingQueryVariables> {
    override document = GymTopRatingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GymsForPromotionDocument = gql`
    query GymsForPromotion($where: GymWhereInput, $orderBy: [GymOrderByWithRelationInput!], $cursor: GymWhereUniqueInput, $take: Int, $skip: Int, $distinct: [GymScalarFieldEnum!]) {
  gyms(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...GymsForPromotionsFields
  }
}
    ${GymsForPromotionsFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GymsForPromotionGQL extends Apollo.Query<GymsForPromotionQuery, GymsForPromotionQueryVariables> {
    override document = GymsForPromotionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GymsDocument = gql`
    query Gyms($where: GymWhereInput, $orderBy: [GymOrderByWithRelationInput!], $cursor: GymWhereUniqueInput, $take: Int, $skip: Int, $distinct: [GymScalarFieldEnum!], $eventWhere: EventWhereInput) {
  gyms(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...GymFields
  }
}
    ${GymFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GymsGQL extends Apollo.Query<GymsQuery, GymsQueryVariables> {
    override document = GymsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginatedMessageDocument = gql`
    query PaginatedMessage($where: MessageWhereInput, $orderBy: [MessageOrderByWithRelationInput!], $cursor: MessageWhereUniqueInput, $take: Int, $skip: Int, $distinct: [MessageScalarFieldEnum!]) {
  paginatedMessage(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...PaginatedMessageFields
  }
}
    ${PaginatedMessageFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginatedMessageGQL extends Apollo.Query<PaginatedMessageQuery, PaginatedMessageQueryVariables> {
    override document = PaginatedMessageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OpeningHoursDocument = gql`
    query OpeningHours($where: OpeningHourWhereInput, $orderBy: [OpeningHourOrderByWithRelationInput!], $cursor: OpeningHourWhereUniqueInput, $take: Int, $skip: Int, $distinct: [OpeningHourScalarFieldEnum!]) {
  openingHours(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...OpeningHourFields
  }
}
    ${OpeningHourFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OpeningHoursGQL extends Apollo.Query<OpeningHoursQuery, OpeningHoursQueryVariables> {
    override document = OpeningHoursDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompanyProfileDocument = gql`
    query CompanyProfile {
  companyProfile {
    ...ProfileFields
  }
}
    ${ProfileFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyProfileGQL extends Apollo.Query<CompanyProfileQuery, CompanyProfileQueryVariables> {
    override document = CompanyProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IsHandleAvailableDocument = gql`
    query IsHandleAvailable($handle: String!) {
  isHandleAvailable(handle: $handle)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IsHandleAvailableGQL extends Apollo.Query<IsHandleAvailableQuery, IsHandleAvailableQueryVariables> {
    override document = IsHandleAvailableDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MyProfileDocument = gql`
    query MyProfile {
  myProfile {
    ...ProfileFields
  }
}
    ${ProfileFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MyProfileGQL extends Apollo.Query<MyProfileQuery, MyProfileQueryVariables> {
    override document = MyProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProfileDocument = gql`
    query Profile($where: ProfileWhereUniqueInput!) {
  profile(where: $where) {
    ...ProfileFields
  }
}
    ${ProfileFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProfileGQL extends Apollo.Query<ProfileQuery, ProfileQueryVariables> {
    override document = ProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchProfilesDocument = gql`
    query SearchProfiles($query: String!) {
  searchProfiles(query: $query) {
    ...ProfileFields
  }
}
    ${ProfileFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchProfilesGQL extends Apollo.Query<SearchProfilesQuery, SearchProfilesQueryVariables> {
    override document = SearchProfilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PromotionCodesDocument = gql`
    query PromotionCodes($where: PromotionCodeWhereInput, $orderBy: [PromotionCodeOrderByWithRelationInput!], $cursor: PromotionCodeWhereUniqueInput, $take: Int, $skip: Int, $distinct: [PromotionCodeScalarFieldEnum!]) {
  promotionCodes(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...PromotionCodeFields
  }
}
    ${PromotionCodeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PromotionCodesGQL extends Apollo.Query<PromotionCodesQuery, PromotionCodesQueryVariables> {
    override document = PromotionCodesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AvailableStripeCouponsDocument = gql`
    query AvailableStripeCoupons {
  availableStripeCoupons {
    percentage
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AvailableStripeCouponsGQL extends Apollo.Query<AvailableStripeCouponsQuery, AvailableStripeCouponsQueryVariables> {
    override document = AvailableStripeCouponsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PromotionsDocument = gql`
    query Promotions($where: PromotionWhereInput, $orderBy: [PromotionOrderByWithRelationInput!], $cursor: PromotionWhereUniqueInput, $take: Int, $skip: Int, $distinct: [PromotionScalarFieldEnum!]) {
  promotions(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...PromotionFields
  }
}
    ${PromotionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PromotionsGQL extends Apollo.Query<PromotionsQuery, PromotionsQueryVariables> {
    override document = PromotionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PushNotificationHistoriesDocument = gql`
    query PushNotificationHistories($where: PushNotificationHistoryWhereInput, $orderBy: [PushNotificationHistoryOrderByWithRelationInput!], $cursor: PushNotificationHistoryWhereUniqueInput, $take: Int, $skip: Int, $distinct: [PushNotificationHistoryScalarFieldEnum!]) {
  pushNotificationHistories(
    where: $where
    cursor: $cursor
    distinct: $distinct
    orderBy: $orderBy
    skip: $skip
    take: $take
  ) {
    ...PushNotificationHistoryFields
  }
}
    ${PushNotificationHistoryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PushNotificationHistoriesGQL extends Apollo.Query<PushNotificationHistoriesQuery, PushNotificationHistoriesQueryVariables> {
    override document = PushNotificationHistoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PushNotificationsDocument = gql`
    query PushNotifications($where: PushNotificationWhereInput, $orderBy: [PushNotificationOrderByWithRelationInput!], $cursor: PushNotificationWhereUniqueInput, $take: Int, $skip: Int, $distinct: [PushNotificationScalarFieldEnum!]) {
  pushNotifications(
    where: $where
    cursor: $cursor
    distinct: $distinct
    orderBy: $orderBy
    skip: $skip
    take: $take
  ) {
    ...PushNotificationFields
  }
}
    ${PushNotificationFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PushNotificationsGQL extends Apollo.Query<PushNotificationsQuery, PushNotificationsQueryVariables> {
    override document = PushNotificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RatingQuestionsDocument = gql`
    query RatingQuestions($where: RatingQuestionWhereInput, $orderBy: [RatingQuestionOrderByWithRelationInput!], $cursor: RatingQuestionWhereUniqueInput, $take: Int, $skip: Int, $distinct: [RatingQuestionScalarFieldEnum!], $gymId: UUID = null) {
  ratingQuestions(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...RatingQuestionFields
  }
}
    ${RatingQuestionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RatingQuestionsGQL extends Apollo.Query<RatingQuestionsQuery, RatingQuestionsQueryVariables> {
    override document = RatingQuestionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PublicRatingQuestionsDocument = gql`
    query PublicRatingQuestions($where: PublicRatingQuestionWhereInput!) {
  publicRatingQuestions(where: $where) {
    id
    question
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PublicRatingQuestionsGQL extends Apollo.Query<PublicRatingQuestionsQuery, PublicRatingQuestionsQueryVariables> {
    override document = PublicRatingQuestionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReportsDocument = gql`
    query Reports($where: ReportWhereInput, $orderBy: [ReportOrderByWithRelationInput!], $cursor: ReportWhereUniqueInput, $take: Int, $skip: Int, $distinct: [ReportScalarFieldEnum!]) {
  reports(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...ReportFields
  }
}
    ${ReportFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ReportsGQL extends Apollo.Query<ReportsQuery, ReportsQueryVariables> {
    override document = ReportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendMailToSupportDocument = gql`
    query SendMailToSupport($fromMail: String!, $mailType: MailTypes!, $subject: String, $message: String) {
  sendMailToSupport(
    fromMail: $fromMail
    mailType: $mailType
    subject: $subject
    message: $message
  ) {
    successful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendMailToSupportGQL extends Apollo.Query<SendMailToSupportQuery, SendMailToSupportQueryVariables> {
    override document = SendMailToSupportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ActiveTrainingSessionsDocument = gql`
    query ActiveTrainingSessions($where: TrainingSessionWhereInput, $orderBy: [TrainingSessionOrderByWithRelationInput!], $cursor: TrainingSessionWhereUniqueInput, $take: Int, $skip: Int, $distinct: [TrainingSessionScalarFieldEnum!]) {
  trainingSessions(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...ActiveTrainingSession
  }
}
    ${ActiveTrainingSessionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ActiveTrainingSessionsGQL extends Apollo.Query<ActiveTrainingSessionsQuery, ActiveTrainingSessionsQueryVariables> {
    override document = ActiveTrainingSessionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CustomerTrainingSessionInfoDocument = gql`
    query CustomerTrainingSessionInfo($where: TrainingSessionWhereInput, $orderBy: [TrainingSessionOrderByWithRelationInput!], $cursor: TrainingSessionWhereUniqueInput, $take: Int, $skip: Int, $distinct: [TrainingSessionScalarFieldEnum!]) {
  trainingSessions(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...CustomerTrainingSessionInfo
  }
}
    ${CustomerTrainingSessionInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CustomerTrainingSessionInfoGQL extends Apollo.Query<CustomerTrainingSessionInfoQuery, CustomerTrainingSessionInfoQueryVariables> {
    override document = CustomerTrainingSessionInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginatedTrainingsDocument = gql`
    query PaginatedTrainings($where: TrainingSessionWhereInput, $orderBy: [TrainingSessionOrderByWithRelationInput!], $cursor: TrainingSessionWhereUniqueInput, $take: Int, $skip: Int, $distinct: [TrainingSessionScalarFieldEnum!]) {
  paginatedTrainingSessions(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...PaginatedTrainingsFields
  }
}
    ${PaginatedTrainingsFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginatedTrainingsGQL extends Apollo.Query<PaginatedTrainingsQuery, PaginatedTrainingsQueryVariables> {
    override document = PaginatedTrainingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TrainingSessionTrendDocument = gql`
    query TrainingSessionTrend($startDate: DateTime!, $endDate: DateTime!, $timezone: TimeZone!, $gymId: UUID) {
  trainingSessionTrend(
    startDate: $startDate
    endDate: $endDate
    timezone: $timezone
    gymId: $gymId
  ) {
    ...TrendMetricFields
  }
}
    ${TrendMetricFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TrainingSessionTrendGQL extends Apollo.Query<TrainingSessionTrendQuery, TrainingSessionTrendQueryVariables> {
    override document = TrainingSessionTrendDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserPostsDocument = gql`
    query UserPosts($where: UserPostWhereInput, $orderBy: [UserPostOrderByWithRelationInput!], $cursor: UserPostWhereUniqueInput, $take: Int, $skip: Int, $distinct: [UserPostScalarFieldEnum!]) {
  userPosts(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...UserPostFields
  }
}
    ${UserPostFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UserPostsGQL extends Apollo.Query<UserPostsQuery, UserPostsQueryVariables> {
    override document = UserPostsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }